import { VProgressCircular, VProgressLinear, VDialog, VBtn, VLayout, VAlert, VTooltip, VIcon, VSubheader, VListItem, VList, VBottomSheet, VListItemTitle, VMenu, VStepperStep, VStepper, VCheckbox, VTextField, VListItemGroup, VDivider, VSheet, VSwitch, VChip, VCol, VRow, VContainer, VTextarea, VSelect, VSnackbar, VCard, VStepperContent, VStepperItems, VBadge, VRadio, VRadioGroup, VBtnToggle, Intersect, VAutocomplete, VTab, VTabs, VTabItem, VTabsItems, VBreadcrumbs, VColorPicker, VExpansionPanelHeader, VExpansionPanelContent, VExpansionPanel, VExpansionPanels, VSkeletonLoader, VTimelineItem, VTimeline, VDataTable } from 'vuetify/lib';

var script$1$ = {
  name: 'VcLayout',
  render: function (createElement) {
    // `<v-layout><slot></slot></v-layout>`
    const props = {
      attrs: { ...this.$attrs
      },
      on: { ...this.$listeners
      },
      ref: this.$vnode.data.ref,
      style: this.$vnode.data.style
    };
    return createElement('v-layout', props, this.$slots.default);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$1$ = script$1$;
/* template */

/* style */

const __vue_inject_styles__$1$ = undefined;
/* scoped */

const __vue_scope_id__$1$ = "data-v-6e723926";
/* module identifier */

const __vue_module_identifier__$1$ = undefined;
/* functional template */

const __vue_is_functional_template__$1$ = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2W = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$1$, __vue_script__$1$, __vue_scope_id__$1$, __vue_is_functional_template__$1$, __vue_module_identifier__$1$, false, undefined, undefined, undefined);

var VcLayout = __vue_component__$2W;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1_ = {
  components: {
    VProgressCircular: VProgressCircular,
    VProgressLinear: VProgressLinear
  },

  name: 'VcLoader',

  props: {
    value: {
      type: Number,
      default: 40
    },
    mode: {
      type: String,
      default: 'circular',
      validator: function (value) {
        return ['circular', 'linear'].includes(value);
      }
    },
    color: {
      type: String,
      default: 'primary'
    },

    /**
     * Circumference of the loader in pixels
     */
    size: {
      type: Number,
      required: false
    },

    /**
     * Line width in pixels
     */
    width: {
      type: Number,
      required: false
    },
    dataQa: {
      type: String,
      default: 'VcLoader'
    }
  }
};

/* script */
const __vue_script__$1_ = script$1_;
/* template */

var __vue_render__$1T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.mode === 'circular' ? _c('v-progress-circular', {
    attrs: {
      "value": _vm.value,
      "color": _vm.color,
      "size": _vm.size,
      "width": _vm.width,
      "data-qa": _vm.dataQa,
      "indeterminate": ""
    }
  }) : _vm.mode === 'linear' ? _c('v-progress-linear', {
    attrs: {
      "active": "",
      "color": _vm.color,
      "data-qa": _vm.dataQa,
      "indeterminate": ""
    }
  }) : _vm._e();
};

var __vue_staticRenderFns__$1T = [];
/* style */

const __vue_inject_styles__$1_ = undefined;
/* scoped */

const __vue_scope_id__$1_ = undefined;
/* module identifier */

const __vue_module_identifier__$1_ = undefined;
/* functional template */

const __vue_is_functional_template__$1_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1T,
  staticRenderFns: __vue_staticRenderFns__$1T
}, __vue_inject_styles__$1_, __vue_script__$1_, __vue_scope_id__$1_, __vue_is_functional_template__$1_, __vue_module_identifier__$1_, false, undefined, undefined, undefined);

var VcLoader = __vue_component__$2V;

//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1Z = {
  components: {
    VDialog: VDialog
  },

  props: {
    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    },
    useOffset: {
      type: Boolean,
      default: true
    },
    contentClass: {
      type: String,
      default: ''
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    retainFocus: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    offsetClass: function () {
      return this.useOffset ? 'offset' : '';
    }
  }
};

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$1Z = script$1Z;
/* template */

var __vue_render__$1S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "fullscreen": _vm.fullscreen,
      "value": true,
      "retain-focus": _vm.retainFocus,
      "content-class": "VcModalWrapper " + _vm.contentClass + " " + _vm.offsetClass
    },
    on: {
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        _vm.closeOnEsc && _vm.$emit('onCloseButtonClicked');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.$emit('onEnterClicked');
      }],
      "click:outside": function ($event) {
        return _vm.$emit('onClickOutside');
      }
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$1S = [];
/* style */

const __vue_inject_styles__$1Z = function (inject) {
  if (!inject) return;
  inject("data-v-96959f86_0", {
    source: ".VcModalWrapper{position:relative;width:auto;background-color:var(--modal-bg-color);box-shadow:var(--modal-box-shadow)}@media screen and (min-width:960px){.VcModalWrapper{margin:0 24px}.VcModalWrapper.offset{left:var(--modal-desktop-offset)}#app[dir=rtl] .VcModalWrapper.offset{left:auto;right:var(--modal-desktop-offset)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1Z = undefined;
/* module identifier */

const __vue_module_identifier__$1Z = undefined;
/* functional template */

const __vue_is_functional_template__$1Z = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1S,
  staticRenderFns: __vue_staticRenderFns__$1S
}, __vue_inject_styles__$1Z, __vue_script__$1Z, __vue_scope_id__$1Z, __vue_is_functional_template__$1Z, __vue_module_identifier__$1Z, false, createInjector, undefined, undefined);

var VcModalWrapper = __vue_component__$2U;

var script$1Y = {
  name: 'VcIcon',
  props: {
    dataQa: {
      type: String,
      default: 'VcIcon'
    },
    color: {
      type: String,
      default: 'black'
    }
  },
  render: function (createElement) {
    const props = {
      attrs: { ...this.$attrs,
        'data-qa': this.dataQa
      },
      on: this.$listeners,
      style: {
        fill: this.$props.color,
        color: this.$props.color
      }
    };
    return createElement('v-icon', props, this.$slots.default);
  }
};

/* script */
const __vue_script__$1Y = script$1Y;
/* template */

/* style */

const __vue_inject_styles__$1Y = undefined;
/* scoped */

const __vue_scope_id__$1Y = undefined;
/* module identifier */

const __vue_module_identifier__$1Y = undefined;
/* functional template */

const __vue_is_functional_template__$1Y = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2T = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$1Y, __vue_script__$1Y, __vue_scope_id__$1Y, __vue_is_functional_template__$1Y, __vue_module_identifier__$1Y, false, undefined, undefined, undefined);

var VcIcon = __vue_component__$2T;

var script$1X = {
  name: 'VcButton',
  components: {
    VcIcon,
    VBtn: VBtn
  },
  props: {
    /**
     * Text for display on the button
     */
    label: {
      type: String,
      required: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    elevation: {
      type: Number,
      default: 0
    },

    /**
     * Shortcut for setting the button size
     */
    xSmall: {
      type: Boolean,
      default: false
    },

    /**
     * Shortcut for setting the button size
     */
    small: {
      type: Boolean,
      default: false
    },

    /**
     * Shortcut for setting the button size
     */
    large: {
      type: Boolean,
      default: false
    },

    /**
     * Shortcut for setting the button size
     */
    xLarge: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'secondary',
      validator: type => {
        return ['secondary', 'white', 'black', 'ai'].indexOf(type) > -1;
      }
    },
    flavor: {
      type: String,
      default: 'primary',
      validator: type => ['secondary', 'primary', 'ai'].includes(type)
    },

    /**
     * white color text and icon in case of dark background
     */
    white: {
      type: Boolean,
      default: false
    },
    ghost: {
      type: Boolean,
      default: false
    },

    /**
     * The button will contain an icon and no text
     */
    icon: {
      type: Boolean,
      default: false
    },
    fab: {
      type: Boolean,
      default: false
    },
    pill: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showDisabledBackground: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      required: false
    },
    ripple: {
      type: Boolean
    },
    href: {
      type: String,
      comment: 'This param will change the <button> to <a> with link'
    },
    prependDefaultIcon: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      default: 'plus'
    },
    iconSize: {
      type: Number,
      default: 16
    },
    dataQa: {
      type: String,
      default: 'vc-btn'
    }
  },
  computed: {
    buttonColor() {
      switch (this.flavor) {
        case 'primary':
          // When the flavor is primary, the theme color is the value in secondary color
          return this.color;

        case 'secondary':
          return this.outlined ? '--gray-darken-5' : '--neutral-lighten-2';

        default:
          console.error('ButtonColor could not be determined since the flavour is not expected, flavor is: ' + this.flavor);
          return '';
      }
    },

    getPrependIcon() {
      return `$${this.prependIcon}`;
    }

  }
};

/* script */
const __vue_script__$1X = script$1X;
/* template */

var __vue_render__$1R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-btn', {
    class: ["VcButton " + _vm.flavor + "__text", {
      'white-text': _vm.white
    }, {
      'hide-disabled-background': !_vm.showDisabledBackground
    }],
    attrs: {
      "color": _vm.flavor ? _vm.buttonColor : _vm.color,
      "icon": _vm.icon,
      "fab": _vm.fab,
      "outlined": _vm.outlined,
      "text": _vm.ghost,
      "rounded": _vm.pill,
      "plain": _vm.plain,
      "x-small": _vm.xSmall,
      "small": _vm.small,
      "large": _vm.large,
      "x-large": _vm.xLarge,
      "ripple": _vm.ripple,
      "elevation": _vm.elevation,
      "width": _vm.width,
      "min-width": "0",
      "loading": _vm.loading,
      "block": _vm.block,
      "disabled": _vm.disabled,
      "href": _vm.href,
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function (event) {
        return _vm.$emit('click', event);
      }
    }
  }, [_vm._t("prepend", function () {
    return [_vm.prependDefaultIcon ? _c('VcIcon', {
      class: {
        prependDefaultIcon: !_vm.icon
      },
      attrs: {
        "color": "currentColor",
        "size": _vm.iconSize
      }
    }, [_vm._v("\n      " + _vm._s(_vm.getPrependIcon) + "\n    ")]) : _vm._e()];
  }), _vm._v(" "), _vm._t("default", function () {
    return [_vm._v("\n    " + _vm._s(_vm.label || _vm.$slots.default && _vm.$slots.default[0].text || '') + "\n  ")];
  }), _vm._v(" "), _vm._t("append")], 2);
};

var __vue_staticRenderFns__$1R = [];
/* style */

const __vue_inject_styles__$1X = function (inject) {
  if (!inject) return;
  inject("data-v-27adbf17_0", {
    source: ".VcButton[data-v-27adbf17]{letter-spacing:var(--letter-spacing)}.VcButton[data-v-27adbf17]:disabled{background-color:var(--gray-lighten-2);color:var(--gray-darken-2)}.VcButton.hide-disabled-background[data-v-27adbf17]:disabled{color:var(--gray-lighten-2)!important;background-color:transparent}.VcButton .prependDefaultIcon[data-v-27adbf17]{margin-inline-end:var(--size-value3)}.VcButton.secondary__text[data-v-27adbf17]{color:var(--gray-darken-5)!important;border-color:var(--neutral-lighten-1)}.VcButton.ai__text[data-v-27adbf17]:not(.v-btn--disabled){color:var(--ai-main)!important}.VcButton.white-text[data-v-27adbf17]{color:var(--gray-lighten-4)!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1X = "data-v-27adbf17";
/* module identifier */

const __vue_module_identifier__$1X = undefined;
/* functional template */

const __vue_is_functional_template__$1X = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1R,
  staticRenderFns: __vue_staticRenderFns__$1R
}, __vue_inject_styles__$1X, __vue_script__$1X, __vue_scope_id__$1X, __vue_is_functional_template__$1X, __vue_module_identifier__$1X, false, createInjector, undefined, undefined);

var VcButton = __vue_component__$2S;

var script$1W = {
  name: 'VcCloseButton',
  components: {
    VcButton,
    VcIcon
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcButton-close-button'
    }
  }
};

/* script */
const __vue_script__$1W = script$1W;
/* template */

var __vue_render__$1Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcButton', {
    staticClass: "VcModalCloseButton",
    attrs: {
      "icon": "",
      "fab": "",
      "small": "",
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "size": "14",
            "color": "var(--gray-darken-2)"
          }
        }, [_vm._v(" $close_button ")])];
      },
      proxy: true
    }])
  });
};

var __vue_staticRenderFns__$1Q = [];
/* style */

const __vue_inject_styles__$1W = undefined;
/* scoped */

const __vue_scope_id__$1W = "data-v-fee64a46";
/* module identifier */

const __vue_module_identifier__$1W = undefined;
/* functional template */

const __vue_is_functional_template__$1W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Q,
  staticRenderFns: __vue_staticRenderFns__$1Q
}, __vue_inject_styles__$1W, __vue_script__$1W, __vue_scope_id__$1W, __vue_is_functional_template__$1W, __vue_module_identifier__$1W, false, undefined, undefined, undefined);

var VcCloseButton = __vue_component__$2R;

var script$1V = {
  name: 'VcModalContainer',
  components: {
    VcModalWrapper,
    VcCloseButton,
    VLayout: VLayout
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['auto', 'sm', 'md', 'lg', 'xl', 'responsive', 'fullscreen'].includes(prop)
    },
    showHeaderDivider: {
      type: Boolean,
      default: false
    },
    showFooterDivider: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },

    /**
     * In case your modal is displayed within an iframe, you may want to display it in a certain offset in order to center is.
     * The offset value is set in the css var --modal-desktop-offset, which should be 0 (zero) by default
     */
    useOffset: {
      type: Boolean,
      default: true
    },

    /**
     * Allows to apply specific design requirements
     */
    flavor: {
      type: String,
      required: false,
      validator: prop => ['', 'confirm', 'notice', 'input', 'prominent'].includes(prop)
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    dataQa: {
      type: String,
      default: 'VcModalContainer'
    },

    /**
     * Defines 100% height to the layout container to support multi-line header title
     */
    fullHeight: {
      type: Boolean,
      default: false
    },
    retainFocus: {
      type: Boolean,
      default: true
    }
  }
};

/* script */
const __vue_script__$1V = script$1V;
/* template */

var __vue_render__$1P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.showDialog ? _c('VcModalWrapper', {
    attrs: {
      "use-offset": _vm.useOffset,
      "content-class": _vm.size + " VcModalContainer " + (_vm.flavor ? _vm.flavor : 'unflavored'),
      "close-on-esc": _vm.closeOnEsc,
      "retain-focus": _vm.retainFocus
    },
    on: {
      "onClickOutside": function ($event) {
        return _vm.$emit('onClickOutside');
      },
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      },
      "enterPressed": function ($event) {
        return _vm.$emit('onEnterClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('v-layout', {
          staticClass: "VcModalContainerLayout",
          class: {
            'VcModalContainerLayout--full-height': _vm.fullHeight
          },
          attrs: {
            "column": "",
            "data-qa": _vm.dataQa
          }
        }, [_c('header', {
          staticClass: "d-flex justify-end",
          class: {
            showDivider: _vm.showHeaderDivider
          }
        }, [_vm._t("header"), _vm._v(" "), _vm.showCloseButton ? _c('VcCloseButton', {
          staticClass: "VcModalContainer--closeButton",
          attrs: {
            "data-qa": _vm.dataQa + "-close-button"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('onCloseButtonClicked');
            }
          }
        }) : _vm._e()], 2), _vm._v(" "), _c('div', {
          staticClass: "VcModalContainerContent"
        }, [_vm._t("content")], 2), _vm._v(" "), !!_vm.$slots.footer ? _c('footer', {
          class: {
            showDivider: _vm.showFooterDivider
          }
        }, [_vm._t("footer")], 2) : _vm._e()])];
      },
      proxy: true
    }], null, true)
  }) : _vm._e();
};

var __vue_staticRenderFns__$1P = [];
/* style */

const __vue_inject_styles__$1V = function (inject) {
  if (!inject) return;
  inject("data-v-48cc85d8_0", {
    source: ".VcModalContainer{overflow-y:hidden;height:auto;min-height:100px;min-width:300px;display:flex}.VcModalContainer .VcModalContainerLayout--full-height{height:100%}.VcModalContainer.fullscreen{position:absolute;top:0;bottom:0;right:0;left:0;margin:24px}.VcModalContainer.sm{width:var(--modal-width-small)}.VcModalContainer.md{width:var(--modal-width-medium)}.VcModalContainer.lg{width:var(--modal-width-large)}.VcModalContainer.xl{width:var(--modal-width-x-large)}.VcModalContainer.responsive{width:100%;margin:0 24px}.VcModalContainer--closeButton{margin-inline-end:var(--size-value2);top:var(--size-value2)}.VcModalContainer .VcModalContainerContent,.VcModalContainer footer,.VcModalContainer header{flex-shrink:0}.VcModalContainer header{display:flex;justify-content:space-between}.VcModalContainer header.showDivider{border-bottom:1px solid rgba(0,0,0,.12)}.VcModalContainer .VcModalContainerContent{overflow-y:auto;overflow-x:hidden;height:calc(100% - 138px);line-height:var(--size-value6);flex-grow:1;font-size:var(--font-size-small);padding:0 var(--size-value6) var(--size-value6)}.VcModalContainer footer{padding:var(--size-value3) var(--size-value4) var(--size-value3);text-align:end}.VcModalContainer footer.showDivider{border-top:1px solid rgba(0,0,0,.12)}@media screen and (min-width:960px){.VcModalContainer footer{padding:var(--size-value3) var(--size-value6) var(--size-value3)}}.VcModalContainer.notice header,.VcModalContainer.prominent header{font-weight:var(--font-weight-xl);font-size:var(--font-size-medium2);padding-bottom:0}.VcModalContainer.notice .VcModalContainerContent,.VcModalContainer.prominent .VcModalContainerContent{min-height:168px;height:calc(100% - 497px);padding:var(--size-value10) 0 0}@media screen and (min-width:960px){.VcModalContainer.notice .VcModalContainerContent,.VcModalContainer.prominent .VcModalContainerContent{margin-bottom:var(--size-value2)}}.VcModalContainer.notice footer,.VcModalContainer.prominent footer{padding-top:var(--size-value3);padding-bottom:0}.VcModalContainer.notice.responsive .VcModalContainerContent,.VcModalContainer.notice.sm .VcModalContainerContent,.VcModalContainer.prominent.responsive .VcModalContainerContent,.VcModalContainer.prominent.sm .VcModalContainerContent{margin-left:var(--size-value6);padding-right:var(--size-value6)}.VcModalContainer.notice.md .VcModalContainerContent,.VcModalContainer.prominent.md .VcModalContainerContent{margin-left:var(--size-value10);padding-right:var(--size-value10)}.VcModalContainer.notice.lg header,.VcModalContainer.prominent.lg header{height:initial}.VcModalContainer.notice.lg .VcModalContainerContent,.VcModalContainer.prominent.lg .VcModalContainerContent{min-height:0;margin-left:var(--size-value16);padding-right:var(--size-value16)}.VcModalContainer.prominent .VcModalContainerContent{margin-bottom:var(--size-value6)}.VcModalContainer.input.responsive{height:100%;margin:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.VcModalContainer.input .VcModalContainerContent{padding:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1V = undefined;
/* module identifier */

const __vue_module_identifier__$1V = undefined;
/* functional template */

const __vue_is_functional_template__$1V = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1P,
  staticRenderFns: __vue_staticRenderFns__$1P
}, __vue_inject_styles__$1V, __vue_script__$1V, __vue_scope_id__$1V, __vue_is_functional_template__$1V, __vue_module_identifier__$1V, false, createInjector, undefined, undefined);

var VcModalContainer = __vue_component__$2Q;

var script$1U = {
  name: 'VcModalFooter',
  components: {
    VcLayout,
    VcButton
  },
  props: {
    direction: {
      type: String,
      default: 'horizontal',
      validator: prop => ['horizontal', 'vertical'].includes(prop)
    },
    buttons: {
      type: Array,
      default: () => [{
        label: 'ok',
        event: 'onOkClicked',
        color: 'white'
      }, {
        label: 'cancel',
        event: 'onCancelClicked',
        color: 'secondary'
      }],
      validator: prop => prop.every(e => e.label && e.event)
    },
    dataQa: {
      type: String,
      default: 'vc-footer'
    }
  }
};

/* script */
const __vue_script__$1U = script$1U;
/* template */

var __vue_render__$1O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    class: "VcModalFooter " + _vm.direction,
    attrs: {
      "column": _vm.direction === 'vertical',
      "justify-end": _vm.$vuetify.breakpoint.mdAndUp && _vm.direction === 'horizontal',
      "align-center": !_vm.$vuetify.breakpoint.mdAndUp || _vm.direction === 'vertical',
      "data-qa": _vm.dataQa
    }
  }, _vm._l(_vm.buttons, function (button) {
    return _c('VcButton', {
      key: button.event,
      staticClass: "VcFooterButton",
      attrs: {
        "color": button.color,
        "label": button.label,
        "loading": button.loading || false,
        "disabled": button.disabled,
        "large": !_vm.$vuetify.breakpoint.mdAndUp,
        "data-qa": _vm.dataQa + "-" + button.label
      },
      on: {
        "click": function ($event) {
          return _vm.$emit(button.event);
        }
      }
    });
  }), 1);
};

var __vue_staticRenderFns__$1O = [];
/* style */

const __vue_inject_styles__$1U = function (inject) {
  if (!inject) return;
  inject("data-v-189b7a6a_0", {
    source: ".VcModalFooter.vertical .VcFooterButton[data-v-189b7a6a]{width:100%;margin-bottom:var(--size-value2)}.VcModalFooter.vertical .VcFooterButton[data-v-189b7a6a]:last-of-type{margin-bottom:0}@media screen and (min-width:960px){.VcModalFooter.vertical .VcFooterButton[data-v-189b7a6a]{width:auto}}.VcModalFooter.horizontal .VcFooterButton[data-v-189b7a6a]{flex-basis:0;flex-grow:1}.VcModalFooter.horizontal .VcFooterButton[data-v-189b7a6a]:first-of-type{margin-left:0}.VcModalFooter.horizontal .VcFooterButton[data-v-189b7a6a]:last-of-type{margin-right:0}@media screen and (min-width:960px){.VcModalFooter.horizontal .VcFooterButton[data-v-189b7a6a]{flex-basis:auto;flex-grow:0}}.VcModalFooter .VcFooterButton[data-v-189b7a6a]{margin-left:var(--size-value1);margin-right:var(--size-value1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1U = "data-v-189b7a6a";
/* module identifier */

const __vue_module_identifier__$1U = undefined;
/* functional template */

const __vue_is_functional_template__$1U = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1O,
  staticRenderFns: __vue_staticRenderFns__$1O
}, __vue_inject_styles__$1U, __vue_script__$1U, __vue_scope_id__$1U, __vue_is_functional_template__$1U, __vue_module_identifier__$1U, false, createInjector, undefined, undefined);

var VcModalFooter = __vue_component__$2P;

var script$1T = {
  name: 'VcModalHeader',
  components: {
    VcCloseButton,
    VcLayout,
    VcIcon,
    VcButton
  },
  props: {
    topTitle: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    subtitle: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    iconColor: {
      type: String,
      default: 'warning'
    },
    rightButtonIcon: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    flavor: {
      type: String,
      default: 'confirm',
      validator: prop => ['confirm', 'input'].includes(prop)
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    closeButtonIcon: {
      type: String,
      default: '$close_button'
    },

    /**
     * This only takes effect when flavor="input"
     */
    showBackButton: {
      type: Boolean,
      default: true
    },
    showBackButtonDesktop: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-header'
    },
    wrapTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isBackButtonDisplayed() {
      if (this.flavor === 'input') {
        if (this.$vuetify.breakpoint.mdAndUp) {
          return this.showBackButtonDesktop;
        }

        return this.showBackButton;
      }

      return false;
    },

    isRightButtonDisplayed() {
      return this.flavor === 'input' && !!this.rightButtonIcon && !this.$vuetify.breakpoint.mdAndUp;
    },

    isCloseButtonStyle() {
      return !this.closeButton && !this.isBackButtonDisplayed ? 'no-close-button' : '';
    }

  }
};

/* script */
const __vue_script__$1T = script$1T;
/* template */

var __vue_render__$1N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    class: "VcHeader " + _vm.flavor + " " + _vm.isCloseButtonStyle,
    attrs: {
      "align-center": "",
      "data-qa": _vm.dataQa
    }
  }, [_vm.isBackButtonDisplayed ? _c('VcButton', {
    staticClass: "VcHeaderButton",
    attrs: {
      "data-qa": _vm.dataQa + "-back-button",
      "icon": "",
      "fab": "",
      "small": "",
      "width": 24
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('svg', {
          attrs: {
            "width": "8",
            "height": "14",
            "viewBox": "0 0 8 14",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M7.45226 13.8605L7.67324 13.6396C7.81969 13.4931 7.81969 13.2557 7.67324 13.1092L1.56409 7.00006L7.67324 0.890882C7.81969 0.744459 7.81969 0.507003 7.67324 0.360549L7.45226 0.139602C7.30584 -0.0068206 7.06841 -0.0068206 6.92196 0.139602L0.326637 6.73489C0.180183 6.88135 0.180183 7.11877 0.326637 7.26526L6.92196 13.8605C7.06841 14.007 7.30584 14.007 7.45226 13.8605Z",
            "fill": "black",
            "fill-opacity": "0.4"
          }
        })])];
      },
      proxy: true
    }], null, false, 3344096172)
  }) : _vm._e(), _vm._v(" "), _vm._t("headerImage", function () {
    return [_vm.image ? _c('img', {
      staticClass: "VcHeaderImage",
      attrs: {
        "src": _vm.image
      }
    }) : _vm._e(), _vm._v(" "), _vm.icon ? _c('VcIcon', {
      staticClass: "VcHeaderIcon",
      attrs: {
        "color": _vm.iconColor
      }
    }, [_vm._v("\n      " + _vm._s(_vm.icon) + "\n    ")]) : _vm._e()];
  }), _vm._v(" "), _c('VcLayout', {
    attrs: {
      "column": ""
    }
  }, [_vm.topTitle ? _c('div', {
    staticClass: "VcHeaderTopTitle"
  }, [_vm._v("\n      " + _vm._s(_vm.topTitle) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('VcLayout', {
    attrs: {
      "justify-space-between": !_vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('VcLayout', {
    attrs: {
      "column": ""
    }
  }, [_c('div', {
    staticClass: "VcHeaderTitle",
    class: {
      'VcHeaderTitle--wrap': _vm.wrapTitle
    }
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), !!_vm.description ? _c('div', {
    staticClass: "VcHeaderDescription"
  }, [_vm._v("\n          " + _vm._s(_vm.description) + "\n        ")]) : _vm._e()]), _vm._v(" "), _vm.subtitle ? _c('div', {
    staticClass: "VcHeaderSubtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.subtitle) + "\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), !!_vm.isRightButtonDisplayed ? _c('VcButton', {
    staticClass: "VcRightButton",
    attrs: {
      "icon": "",
      "fab": "",
      "small": "",
      "width": 24
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onRightButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "size": "20",
            "color": "var(--gray-darken-2)",
            "data-qa": _vm.dataQa + "-right-button"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.rightButtonIcon) + "\n      ")])];
      },
      proxy: true
    }], null, false, 570043167)
  }) : _vm._e(), _vm._v(" "), _vm.closeButton ? _c('VcCloseButton', {
    attrs: {
      "data-qa": _vm.dataQa + "-close-button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    }
  }) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1N = [];
/* style */

const __vue_inject_styles__$1T = function (inject) {
  if (!inject) return;
  inject("data-v-1b3be0a8_0", {
    source: ".VcHeader[data-v-1b3be0a8]{padding:var(--size-value4);font-weight:var(--font-weight-large);font-size:var(--font-size-medium);line-height:var(--size-value7);letter-spacing:var(--letter-spacing)}@media screen and (min-width:960px){.VcHeader[data-v-1b3be0a8]{padding:var(--size-value4) var(--size-value4) var(--size-value4) var(--size-value6)}}.VcHeader.no-close-button[data-v-1b3be0a8]{font-weight:var(--font-weight-large2);font-size:var(--font-size-small2);padding:var(--size-value4) var(--size-value6) var(--size-value0)}.VcHeader.no-close-button.input[data-v-1b3be0a8]{padding-block-end:var(--size-value0)}.VcHeader .VcHeaderImage[data-v-1b3be0a8]{width:var(--size-value8);margin-right:var(--size-value3);padding:5px;border:1px solid var(--gray-lighten-1);box-sizing:border-box;border-radius:var(--border-radius)}.VcHeader .VcHeaderTopTitle[data-v-1b3be0a8]{font-size:11px;font-weight:var(--font-weight-medium);line-height:var(--size-value3);color:var(--gray-darken-3)}.VcHeader .VcHeaderTitle[data-v-1b3be0a8]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-inline-end:var(--size-value6)}.VcHeader .VcHeaderTitle--wrap[data-v-1b3be0a8]{white-space:normal}.VcHeader .VcHeaderDescription[data-v-1b3be0a8]{font-size:var(--font-size-xx-small);font-weight:var(--font-weight-medium);line-height:var(--size-value4);color:var(--gray-darken-4)}.VcHeader .VcHeaderSubtitle[data-v-1b3be0a8]{font-size:var(--font-size-small2);font-weight:var(--font-weight-medium);color:var(--gray-darken-5);padding-left:var(--size-value2)}.VcHeader.confirm[data-v-1b3be0a8]{font-weight:var(--font-weight-large);font-size:var(--font-size-medium);line-height:var(--size-value7);display:flex;align-items:flex-end;letter-spacing:var(--letter-spacing);color:var(--gray-darken-5);padding-inline:var(--size-value6) var(--size-value4)}@media screen and (min-width:960px){.VcHeader.confirm[data-v-1b3be0a8]{font-weight:var(--font-weight-large2);padding-bottom:var(--size-value1);padding-top:var(--size-value6)}}.VcHeader.confirm .VcHeaderButton[data-v-1b3be0a8],.VcHeader.input .VcHeaderButton[data-v-1b3be0a8]{max-height:24px;margin-right:var(--size-value3)}.VcHeader.confirm .VcRightButton[data-v-1b3be0a8],.VcHeader.input .VcRightButton[data-v-1b3be0a8]{max-height:24px}.VcHeader.confirm .VcHeaderIcon[data-v-1b3be0a8],.VcHeader.input .VcHeaderIcon[data-v-1b3be0a8]{padding-right:var(--size-value3);font-size:var(--font-size-medium)}.VcHeader.input[data-v-1b3be0a8]{padding:var(--size-value2);padding-inline-start:var(--size-value4)}@media screen and (min-width:960px){.VcHeader.input[data-v-1b3be0a8]{padding:var(--size-value2);padding-inline-start:var(--size-value6)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1T = "data-v-1b3be0a8";
/* module identifier */

const __vue_module_identifier__$1T = undefined;
/* functional template */

const __vue_is_functional_template__$1T = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1N,
  staticRenderFns: __vue_staticRenderFns__$1N
}, __vue_inject_styles__$1T, __vue_script__$1T, __vue_scope_id__$1T, __vue_is_functional_template__$1T, __vue_module_identifier__$1T, false, createInjector, undefined, undefined);

var VcModalHeader = __vue_component__$2O;

var script$1S = {
  name: 'VcConfirmModal',
  components: {
    VcModalHeader,
    VcModalFooter,
    VcModalContainer
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    topTitle: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    headerImage: {
      type: String,
      required: false
    },
    headerIcon: {
      type: String,
      required: false
    },
    contentText: {
      type: String,
      required: false
    },

    /**
     * In case the component is being displayed in an iframe, and so can become un centered, this allows to correct the position, when combined with the --modal-desktop-offset css variable.
     */
    useOffset: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['sm', 'md', 'lg'].includes(prop)
    },
    okButtonLabel: {
      type: String,
      required: false
    },
    cancelButtonLabel: {
      type: String,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcConfirmModal'
    },
    wrapTitle: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$1S = script$1S;
/* template */

var __vue_render__$1M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcModalContainer', {
    attrs: {
      "show-close-button": _vm.showCloseButton,
      "use-offset": _vm.useOffset,
      "show-dialog": _vm.showDialog,
      "size": _vm.$vuetify.breakpoint.mdAndUp ? _vm.size : 'responsive',
      "data-qa": _vm.dataQa,
      "full-height": _vm.wrapTitle
    },
    on: {
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._t("header", function () {
          return [_c('VcModalHeader', {
            attrs: {
              "top-title": _vm.topTitle,
              "title": _vm.title,
              "subtitle": _vm.subtitle,
              "icon": _vm.headerIcon,
              "image": _vm.headerImage,
              "flavor": "confirm",
              "wrap-title": _vm.wrapTitle
            },
            on: {
              "onCloseButtonClicked": function ($event) {
                return _vm.$emit('onCloseButtonClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_vm._t("content", function () {
          return [_vm._v("\n      " + _vm._s(_vm.contentText) + "\n    ")];
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm._t("footer", function () {
          return [_c('VcModalFooter', {
            attrs: {
              "buttons": [{
                label: _vm.cancelButtonLabel || _vm.$dst('ds.modal.cancel'),
                event: 'onCancelClicked',
                color: 'white',
                loading: _vm.loading
              }, {
                label: _vm.okButtonLabel || _vm.$dst('ds.modal.ok'),
                event: 'onOkClicked',
                color: 'secondary',
                loading: _vm.loading
              }]
            },
            on: {
              "onOkClicked": function ($event) {
                return _vm.$emit('onOkClicked');
              },
              "onCancelClicked": function ($event) {
                return _vm.$emit('onCancelClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$1M = [];
/* style */

const __vue_inject_styles__$1S = undefined;
/* scoped */

const __vue_scope_id__$1S = "data-v-3acc782e";
/* module identifier */

const __vue_module_identifier__$1S = undefined;
/* functional template */

const __vue_is_functional_template__$1S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1M,
  staticRenderFns: __vue_staticRenderFns__$1M
}, __vue_inject_styles__$1S, __vue_script__$1S, __vue_scope_id__$1S, __vue_is_functional_template__$1S, __vue_module_identifier__$1S, false, undefined, undefined, undefined);

var __vue_component__$2N = __vue_component__$2M;

var script$1R = {
  name: 'VcForm',
  emits: ['input', 'submit'],
  methods: {
    validate() {
      this.form.componentInstance.validate();
    }

  },
  render: function (createElement) {
    // `<v-form><slot></slot></v-form>`
    const props = {
      attrs: this.$attrs,
      on: this.$listeners
    };
    this.form = createElement('v-form', props, this.$slots.default);
    return this.form;
  }
};

/* script */
const __vue_script__$1R = script$1R;
/* template */

/* style */

const __vue_inject_styles__$1R = undefined;
/* scoped */

const __vue_scope_id__$1R = "data-v-70852cb8";
/* module identifier */

const __vue_module_identifier__$1R = undefined;
/* functional template */

const __vue_is_functional_template__$1R = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2L = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$1R, __vue_script__$1R, __vue_scope_id__$1R, __vue_is_functional_template__$1R, __vue_module_identifier__$1R, false, undefined, undefined, undefined);

var VcForm = __vue_component__$2L;

var script$1Q = {
  name: 'VcInputModal',
  components: {
    VcForm,
    VcLayout,
    VcModalFooter,
    VcModalContainer,
    VcModalHeader
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    topTitle: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    headerIcon: {
      type: String,
      required: false
    },
    headerImage: {
      type: String,
      required: false
    },
    useOffset: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['md', 'lg'].includes(prop)
    },
    okButtonLabel: {
      type: String,
      required: false
    },
    cancelButtonLabel: {
      type: String,
      required: false
    },
    cancelButtonProps: {
      type: Object,
      required: false
    },
    okButtonProps: {
      type: Object,
      required: false
    },

    /**
     * Can be used for mobile or desktop, or not at all
     */
    closeButton: {
      type: Boolean,
      default: false
    },

    /**
     * Only relevant for mobile
     */
    showBackButton: {
      type: Boolean,
      default: true
    },
    showBackButtonDesktop: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },

    /**
     * Controls whether to show dividers for header and footer
     */
    showDividers: {
      type: Boolean,
      default: true
    },
    dataQa: {
      type: String,
      default: 'vc-input-modal'
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    retainFocus: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    mainValid: true,
    additionalValid: true
  }),
  methods: {
    onOkClicked() {
      this.validate();
      this.$emit('onOkClicked', {
        valid: this.mainValid && this.additionalValid
      });
    },

    validate() {
      this.$refs.mainForm.validate();
      this.$refs.additionalForm && this.$refs.additionalForm.validate();
    },

    onMainFormValueChanged(value) {
      this.mainValid = value;
      this.$emit('onValidationChanged', {
        valid: this.mainValid && this.additionalValid
      });
    },

    onAdditionalFormValueChanged(value) {
      this.additionalValid = value;
      this.$emit('onValidationChanged', {
        valid: this.mainValid && this.additionalValid
      });
    }

  }
};

/* script */
const __vue_script__$1Q = script$1Q;
/* template */

var __vue_render__$1L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcModalContainer', {
    attrs: {
      "show-header-divider": _vm.showDividers,
      "show-footer-divider": _vm.showDividers,
      "flavor": "input",
      "show-close-button": false,
      "use-offset": _vm.useOffset,
      "show-dialog": _vm.showDialog,
      "size": _vm.$vuetify.breakpoint.mdAndUp ? _vm.size : 'responsive',
      "close-on-esc": _vm.closeOnEsc,
      "retain-focus": _vm.retainFocus,
      "data-qa": _vm.dataQa
    },
    on: {
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._t("header", function () {
          return [_c('VcModalHeader', {
            attrs: {
              "top-title": _vm.topTitle,
              "title": _vm.title,
              "subtitle": _vm.subtitle,
              "close-button": _vm.closeButton,
              "icon": _vm.headerIcon,
              "image": _vm.headerImage,
              "flavor": "input",
              "show-back-button": _vm.showBackButton,
              "show-back-button-desktop": _vm.showBackButtonDesktop,
              "data-qa": _vm.dataQa + "-header"
            },
            on: {
              "onCloseButtonClicked": function ($event) {
                return _vm.$emit('onCloseButtonClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_c('VcLayout', {
          staticClass: "VcInputForm-layout"
        }, [_c('VcForm', {
          ref: "mainForm",
          staticClass: "VcInputForm-main",
          attrs: {
            "value": _vm.mainValid,
            "lazy-validation": ""
          },
          on: {
            "input": _vm.onMainFormValueChanged
          }
        }, [_vm._t("content")], 2), _vm._v(" "), _vm.$slots.additional && _vm.size === 'lg' && _vm.$vuetify.breakpoint.mdAndUp ? _c('VcForm', {
          ref: "additionalForm",
          staticClass: "VcInputForm-additional",
          attrs: {
            "value": _vm.additionalValid,
            "lazy-validation": ""
          },
          on: {
            "input": _vm.onAdditionalFormValueChanged
          }
        }, [_vm._t("additional")], 2) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm.showFooter ? _vm._t("footer", function () {
          return [_c('VcModalFooter', {
            attrs: {
              "buttons": [Object.assign({}, {
                label: _vm.cancelButtonLabel || _vm.$dst('ds.modal.cancel'),
                event: 'onCancelClicked',
                color: 'white'
              }, _vm.cancelButtonProps), Object.assign({}, {
                label: _vm.okButtonLabel || _vm.$dst('ds.modal.ok'),
                event: 'onOkClicked',
                color: 'secondary'
              }, _vm.okButtonProps)]
            },
            on: {
              "onOkClicked": _vm.onOkClicked,
              "onCancelClicked": function ($event) {
                return _vm.$emit('onCancelClicked');
              }
            }
          })];
        }) : _vm._e()];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$1L = [];
/* style */

const __vue_inject_styles__$1Q = function (inject) {
  if (!inject) return;
  inject("data-v-5a6057c8_0", {
    source: ".VcInputForm-layout .VcInputForm-main[data-v-5a6057c8]{width:100%;max-width:100%;padding:var(--size-value6)}.VcInputForm-layout .VcInputForm-additional[data-v-5a6057c8]{min-width:324px;padding:var(--size-value6);background:#f8f9fb;border-left:1px solid rgba(0,0,0,.12)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1Q = "data-v-5a6057c8";
/* module identifier */

const __vue_module_identifier__$1Q = undefined;
/* functional template */

const __vue_is_functional_template__$1Q = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1L,
  staticRenderFns: __vue_staticRenderFns__$1L
}, __vue_inject_styles__$1Q, __vue_script__$1Q, __vue_scope_id__$1Q, __vue_is_functional_template__$1Q, __vue_module_identifier__$1Q, false, createInjector, undefined, undefined);

var __vue_component__$2K = __vue_component__$2J;

var script$1P = {
  name: 'VcImage',
  components: {
    VcLayout
  },
  props: {
    image: {
      type: [String, Object],
      required: true
    },
    dataQa: {
      type: String,
      default: 'VcImage'
    }
  }
};

/* script */
const __vue_script__$1P = script$1P;
/* template */

var __vue_render__$1K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcImage",
    attrs: {
      "justify-content-center": "",
      "data-qa": _vm.dataQa
    }
  }, [_vm.image && typeof _vm.image === 'string' ? _c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.image
    }
  }) : _c(_vm.image, {
    tag: "component",
    staticClass: "image"
  })], 1);
};

var __vue_staticRenderFns__$1K = [];
/* style */

const __vue_inject_styles__$1P = function (inject) {
  if (!inject) return;
  inject("data-v-a8e0ecf8_0", {
    source: ".VcImage[data-v-a8e0ecf8]{height:100%;justify-content:center}.VcImage[data-v-a8e0ecf8]  img{height:100%}.VcImage[data-v-a8e0ecf8]  svg{max-width:100%;height:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1P = "data-v-a8e0ecf8";
/* module identifier */

const __vue_module_identifier__$1P = undefined;
/* functional template */

const __vue_is_functional_template__$1P = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1K,
  staticRenderFns: __vue_staticRenderFns__$1K
}, __vue_inject_styles__$1P, __vue_script__$1P, __vue_scope_id__$1P, __vue_is_functional_template__$1P, __vue_module_identifier__$1P, false, createInjector, undefined, undefined);

var VcImage = __vue_component__$2I;

var script$1O = {
  name: 'VcNoticeModal',
  components: {
    VcImage,
    VcLayout,
    VcModalFooter,
    VcModalContainer
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    image: {
      type: [String, Object]
    },
    icon: {
      type: [String, Object],
      comment: 'deprecated'
    },
    titleText: {
      type: String,
      required: true
    },
    subtitleText: {
      type: String,
      required: true
    },
    contentText: {
      type: String,
      required: false
    },
    useOffset: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['md', 'lg', 'sm'].includes(prop)
    },
    flavor: {
      type: String,
      default: 'notice',
      validator: prop => ['notice', 'prominent'].includes(prop)
    },
    okButtonLabel: {
      type: String,
      required: false
    },
    cancelButtonLabel: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      default: 'VcNoticeModal'
    }
  },
  computed: {
    currentImage() {
      // for backward compatibility
      return this.image || this.icon;
    }

  }
};

/* script */
const __vue_script__$1O = script$1O;
/* template */

var __vue_render__$1J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcModalContainer', {
    attrs: {
      "show-footer-divider": _vm.flavor === 'prominent',
      "flavor": _vm.flavor,
      "use-offset": _vm.useOffset,
      "show-dialog": _vm.showDialog,
      "size": _vm.$vuetify.breakpoint.mdAndUp ? _vm.size : 'responsive',
      "data-qa": _vm.dataQa,
      "show-close-button": ""
    },
    on: {
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('VcLayout', {
          class: "VcNoticeHeader " + _vm.flavor,
          attrs: {
            "column": "",
            "align-content-center": ""
          }
        }, [_c('VcImage', {
          staticClass: "VcNoticeImage",
          class: "" + _vm.size,
          attrs: {
            "image": _vm.currentImage
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "VcNoticeHeaderText"
        }, [_vm._v("\n        " + _vm._s(_vm.titleText) + "\n      ")])], 1), _vm._v(" "), _c('VcLayout', {
          class: "VcNoticeSubtitle " + _vm.flavor,
          attrs: {
            "column": ""
          }
        }, [_vm._v("\n      " + _vm._s(_vm.subtitleText) + "\n    ")]), _vm._v(" "), _vm._t("content", function () {
          return [_vm.contentText ? _c('VcLayout', {
            class: "VcNoticeContent " + _vm.size,
            attrs: {
              "column": ""
            }
          }, [_vm._v("\n        " + _vm._s(_vm.contentText) + "\n      ")]) : _vm._e()];
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm._t("footer", function () {
          return [_c('VcModalFooter', {
            staticClass: "VcNoticeFooter",
            attrs: {
              "direction": "vertical",
              "buttons": [{
                label: _vm.okButtonLabel || _vm.$dst('ds.modal.ok'),
                event: 'onOkClicked',
                color: 'secondary'
              }, {
                label: _vm.cancelButtonLabel || _vm.$dst('ds.modal.cancel'),
                event: 'onCancelClicked',
                color: 'white'
              }]
            },
            on: {
              "onOkClicked": function ($event) {
                return _vm.$emit('onOkClicked');
              },
              "onCancelClicked": function ($event) {
                return _vm.$emit('onCancelClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$1J = [];
/* style */

const __vue_inject_styles__$1O = function (inject) {
  if (!inject) return;
  inject("data-v-19d788a4_0", {
    source: ".VcNoticeImage[data-v-19d788a4]{margin-bottom:var(--size-value4)}.VcNoticeImage.md[data-v-19d788a4],.VcNoticeImage.responsive[data-v-19d788a4],.VcNoticeImage.sm[data-v-19d788a4]{height:160px}.VcNoticeImage.lg[data-v-19d788a4]{height:208px}.VcNoticeContent[data-v-19d788a4],.VcNoticeHeader[data-v-19d788a4],.VcNoticeSubtitle[data-v-19d788a4]{text-align:center;line-height:24px}.VcNoticeHeader[data-v-19d788a4]{text-align:center;align-items:center;font-size:18px;font-weight:600;line-height:28px}@media screen and (min-width:960px){.VcNoticeHeader[data-v-19d788a4]{font-size:24px;font-weight:800;line-height:var(--size-value10)}}.VcNoticeHeader .VcNoticeHeaderText[data-v-19d788a4]{padding-bottom:var(--size-value2)}.VcNoticeHeader.prominent .VcNoticeHeaderText[data-v-19d788a4]{font-size:18px;font-weight:600}.VcNoticeSubtitle[data-v-19d788a4]{font-size:15px;font-weight:var(--font-weight-medium);line-height:var(--size-value6)}@media screen and (min-width:960px){.VcNoticeSubtitle[data-v-19d788a4]{font-size:var(--font-size-small)}}.VcNoticeSubtitle.prominent[data-v-19d788a4]{font-size:15px}.VcNoticeContent[data-v-19d788a4]{background:#eafcf2;border:1px solid #cff8e1;box-sizing:border-box;border-radius:8px;padding:var(--size-value3) var(--size-value4);margin-top:var(--size-value4);line-height:20px;font-size:13px}@media screen and (min-width:960px){.VcNoticeContent[data-v-19d788a4]{line-height:21px;font-size:14px}}.VcNoticeFooter[data-v-19d788a4]{padding-bottom:var(--size-value10)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1O = "data-v-19d788a4";
/* module identifier */

const __vue_module_identifier__$1O = undefined;
/* functional template */

const __vue_is_functional_template__$1O = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1J,
  staticRenderFns: __vue_staticRenderFns__$1J
}, __vue_inject_styles__$1O, __vue_script__$1O, __vue_scope_id__$1O, __vue_is_functional_template__$1O, __vue_module_identifier__$1O, false, createInjector, undefined, undefined);

var __vue_component__$2H = __vue_component__$2G;

var script$1N = {
  name: 'VcAlert',
  components: {
    VcIcon,
    VcButton,
    VcLayout,
    VAlert: VAlert
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: prop => ['attention', 'warning', 'info', 'success', 'app', 'recommendation'].includes(prop)
    },
    headerText: {
      type: String
    },
    bodyText: {
      type: String
    },
    buttonText: {
      type: String
    },

    /**
     * Array of buttons to display in the alert, each param represents the params that will be passed to a VcButton component.
     * Each button will emit an event based on its index in this array.
     * The first button will emit 'action0', the next will be 'action1', etc.
     * The event data will include the item data from the array.
     */
    buttonsData: {
      type: Array,
      default: () => []
    },
    inlineActionText: {
      type: String
    },
    isStripe: {
      type: Boolean,
      default: false
    },
    isInline: {
      type: Boolean,
      default: false
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    isInlineHeader: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number]
    },
    dataQa: {
      type: String,
      default: 'vc-alert'
    }
  },
  computed: {
    getStripe() {
      return this.isStripe ? ' stripe' : '';
    },

    getInline() {
      return this.isInline ? ' inline' : '';
    },

    getClass() {
      return `vcita-alert-${this.type}${this.getStripe}${this.getInline}`;
    },

    getIcon() {
      if (this.isInline) {
        switch (this.type) {
          case 'warning':
            return '$warning_fill';

          case 'info':
            return '$info_fill';

          case 'success':
            return '$check_fill';

          case 'app':
            return '$app';

          case 'recommendation':
            return '$ai_sparkles';

          default:
            return '$attention_fill';
        }
      }

      switch (this.type) {
        case 'warning':
          return '$warning';

        case 'info':
          return '$info';

        case 'success':
          return '$check_circle';

        case 'app':
          return '$app';

        case 'recommendation':
          return '$ai_sparkles';

        default:
          return '$error';
      }
    },

    getBodyText() {
      if (this.isInlineHeader && this.headerText) {
        return `<span class="alert-header">${this.headerText}</span> ${this.bodyText}`;
      }

      return this.bodyText;
    },

    decoratedButtonsData() {
      return this.buttonsData.map(button => {
        return {
          pill: true,
          flavor: 'ai',
          dataQa: button.dataQa || 'VcAlert-action-btn',
          ...button
        };
      });
    }

  }
};

/* script */
const __vue_script__$1N = script$1N;
/* template */

var __vue_render__$1I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VAlert', {
    staticClass: "dialog-alert",
    class: _vm.getClass,
    attrs: {
      "data-qa": _vm.dataQa,
      "width": _vm.width,
      "icon": _vm.getIcon
    }
  }, [_c('VcLayout', {
    staticClass: "alert-content",
    class: {
      'dialog-alert__close-btn': _vm.closeButton
    },
    attrs: {
      "align-start": "",
      "column": ""
    }
  }, [_vm.headerText && !_vm.isInlineHeader ? _c('span', {
    staticClass: "alert-header"
  }, [_vm._v("\n      " + _vm._s(_vm.headerText) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "alert-body",
    class: {
      'alert-body--with-inline-action': _vm.inlineActionText
    }
  }, [_vm._t("body", function () {
    return [_vm.bodyText ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getBodyText)
      }
    }) : _vm._e()];
  }, {
    "bodyText": _vm.bodyText
  })], 2), _vm._v(" "), _vm.inlineActionText ? _c('span', {
    staticClass: "inline-action",
    on: {
      "click": function ($event) {
        return _vm.$emit('onInlineAction');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.inlineActionText) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _vm.buttonText ? _c('VcButton', {
    staticClass: "action-button",
    attrs: {
      "plain": "",
      "data-qa": "alert-action-btn"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onAction');
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('VcIcon', [_vm._v("$arrow_right")])];
      },
      proxy: true
    }], null, false, 3701565208)
  }, [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.decoratedButtonsData, function (button, index) {
    return _c('VcButton', _vm._b({
      key: index,
      staticClass: "multi-action-button",
      on: {
        "click": function ($event) {
          return _vm.$emit('action' + index, button);
        }
      }
    }, 'VcButton', button, false));
  }), _vm._v(" "), _vm.closeButton ? _c('VcButton', {
    staticClass: "close-button",
    attrs: {
      "data-qa": "alert-close-btn",
      "fab": "",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('closeAlert');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', [_vm._v("$close_button")])];
      },
      proxy: true
    }], null, false, 521807287)
  }) : _vm._e()], 2);
};

var __vue_staticRenderFns__$1I = [];
/* style */

const __vue_inject_styles__$1N = function (inject) {
  if (!inject) return;
  inject("data-v-03d3e760_0", {
    source: ".dialog-alert{padding:var(--size-value3);margin:var(--size-value0)}.dialog-alert__close-btn{margin-inline-end:var(--size-value7)}.dialog-alert .alert-content{padding-inline-end:var(--size-value9)}.dialog-alert .v-alert__icon{margin-inline-end:var(--size-value2);font-size:var(--size-value5);height:var(--size-value5);min-width:var(--size-value5)}.dialog-alert .close-button{position:absolute;width:var(--size-value6);height:var(--size-value6);top:var(--size-value3);right:var(--size-value3)}#app[dir=rtl] .dialog-alert .close-button{right:auto;left:var(--size-value3)}.dialog-alert .close-button .v-btn__content{opacity:unset}.dialog-alert .close-button:hover{background-color:rgba(0,0,0,.07)}.dialog-alert .close-button .v-icon{margin-right:var(--size-value0)}.dialog-alert .close-button .v-icon svg{fill:var(--gray-darken-2);width:var(--size-value4);height:var(--size-value4)}.dialog-alert.stripe.v-alert{border-radius:var(--size-value0);border-top:none;border-left:none;border-right:none}.dialog-alert.inline.v-alert{border-radius:var(--size-value0);border:none;padding:var(--size-value0);background-color:transparent}.dialog-alert.vcita-alert-attention{border:1px solid var(--red-lighten-2);background-color:var(--red-lighten-3)}.dialog-alert.vcita-alert-attention .v-icon svg.vc-attention-fill,.dialog-alert.vcita-alert-attention .v-icon svg.vc-notif{fill:var(--red)}.dialog-alert.vcita-alert-warning{border:1px solid var(--yellow-lighten-2);background-color:var(--yellow-lighten-3)}.dialog-alert.vcita-alert-warning .v-alert__wrapper .v-icon svg.vc-notif,.dialog-alert.vcita-alert-warning .v-alert__wrapper .v-icon svg.vc-warning-fill{fill:var(--yellow)}.dialog-alert.vcita-alert-info{border:1px solid var(--blue-lighten-2);background-color:var(--blue-lighten-3)}.dialog-alert.vcita-alert-info .v-alert__wrapper .v-icon svg.vc-info-fill,.dialog-alert.vcita-alert-info .v-alert__wrapper .v-icon svg.vc-notif{fill:var(--blue)}.dialog-alert.vcita-alert-success{border:1px solid var(--green-lighten-2);background-color:var(--green-lighten-3)}.dialog-alert.vcita-alert-success .v-icon svg.vc-check-fill,.dialog-alert.vcita-alert-success .v-icon svg.vc-notif{fill:var(--green)}.dialog-alert.vcita-alert-app{border:1px solid var(--purple-lighten-2);background-color:var(--purple-lighten-3)}.dialog-alert.vcita-alert-app .v-icon svg.vc-check-fill,.dialog-alert.vcita-alert-app .v-icon svg.vc-notif{fill:var(--purple)}.dialog-alert.vcita-alert-app .v-alert__wrapper{justify-content:center}.dialog-alert.vcita-alert-app .v-alert__wrapper .v-alert__content{flex:revert}.dialog-alert.vcita-alert-app .inline-action{color:var(--purple)}.dialog-alert.vcita-alert-recommendation{background-image:var(--ai-background)}.dialog-alert.vcita-alert-recommendation .v-icon svg.vc-notif{fill:var(--ai-main)}.dialog-alert.vcita-alert-recommendation .v-alert__wrapper .v-alert__content{flex:revert}.dialog-alert.vcita-alert-recommendation .inline-action{color:var(--purple)}.dialog-alert .v-alert__wrapper .v-icon__component{height:var(--size-value4);width:var(--size-value4)}.dialog-alert .v-alert__wrapper .v-icon__component svg.vc-notif{font-size:var(--size-value4);height:var(--size-value4);min-width:var(--size-value4)}.dialog-alert .v-alert__wrapper .v-icon__component svg.arrow-right{fill:var(--blue)}.dialog-alert .alert-header{font-weight:700;font-size:var(--font-size-x-small);line-height:var(--size-value5);letter-spacing:var(--letter-spacing);margin-bottom:var(--size-value1);color:var(--gray-darken-5)}.dialog-alert .alert-header:after{content:\" \";padding-right:var(--size-value1)}.dialog-alert .alert-body{font-size:var(--font-size-x-small);line-height:var(--size-value5);letter-spacing:-.01em;color:var(--gray-darken-5)}.dialog-alert .alert-body a{color:var(--link-color)}.dialog-alert .alert-body--with-inline-action{margin-inline-end:var(--size-value1)}.dialog-alert .inline-action{font-size:var(--font-size-x-small);line-height:var(--size-value5);font-weight:var(--font-weight-large2);cursor:pointer}.dialog-alert .VcButton .v-icon{margin-right:initial;align-items:initial}.dialog-alert .VcButton.action-button{height:var(--size-value6);color:var(--blue)!important;font-weight:var(--font-weight-large);font-size:var(--font-size-x-small);line-height:var(--size-value6);margin-top:var(--size-value1);padding:var(--size-value0)}.dialog-alert .VcButton.action-button span.v-btn__content{opacity:unset!important}.dialog-alert .VcButton.action-button span.v-btn__content .v-icon:before{content:\" \";padding-right:var(--size-value1)}.dialog-alert .VcButton.multi-action-button{margin-top:var(--size-value3);margin-inline-end:var(--size-value2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1N = undefined;
/* module identifier */

const __vue_module_identifier__$1N = undefined;
/* functional template */

const __vue_is_functional_template__$1N = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1I,
  staticRenderFns: __vue_staticRenderFns__$1I
}, __vue_inject_styles__$1N, __vue_script__$1N, __vue_scope_id__$1N, __vue_is_functional_template__$1N, __vue_module_identifier__$1N, false, createInjector, undefined, undefined);

var VcAlert = __vue_component__$2F;

var script$1M = {
  name: 'VcTooltip',
  components: {
    VcIcon,
    VTooltip: VTooltip
  },
  props: {
    flavor: {
      type: String,
      default: 'information',
      validator: type => {
        return ['information', 'alert'].indexOf(type) > -1;
      }
    },
    header: {
      type: String,
      default: ''
    },
    content: {
      type: String
    },
    top: {
      type: Boolean,
      default: true
    },
    bottom: {
      type: Boolean,
      default: false
    },
    nudgeLeft: {
      type: Number
    },
    nudgeRight: {
      type: Number
    },
    dark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-tooltip'
    },
    closeDelay: {
      type: Number,
      default: 0
    },
    maxWidth: {
      type: String,
      default: ''
    },
    openDelay: {
      type: Number,
      default: 0
    }
  },
  computed: {
    enableHeader() {
      return this.header.length > 0;
    }

  }
};

/* script */
const __vue_script__$1M = script$1M;
/* template */

var __vue_render__$1H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', [_c('v-tooltip', {
    attrs: {
      "content-class": "vc-tooltip",
      "left": !_vm.$vuetify.rtl,
      "right": _vm.$vuetify.rtl,
      "top": _vm.top,
      "bottom": _vm.bottom,
      "nudge-left": _vm.nudgeLeft,
      "nudge-right": _vm.nudgeRight,
      "disabled": _vm.disabled,
      "data-qa": _vm.dataQa,
      "close-delay": _vm.closeDelay,
      "max-width": _vm.maxWidth,
      "open-delay": _vm.openDelay
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        var attrs = ref.attrs;
        return [_c('span', _vm._g(_vm._b({
          staticClass: "vc-tooltip__activator",
          attrs: {
            "data-qa": _vm.dataQa + "__activator"
          }
        }, 'span', attrs, false), on), [_vm._t("default", function () {
          return [_c('VcIcon', {
            staticClass: "default-activator-icon"
          }, [_vm._v("$info")])];
        }, null, attrs)], 2)];
      }
    }], null, true)
  }, [_vm._v(" "), _vm.dark ? _c('div', {
    staticClass: "dark-tooltip",
    attrs: {
      "data-qa": _vm.dataQa + "-dark-content"
    }
  }, [_vm._t("tooltipContent", function () {
    return [_vm.header || _vm.content ? _c('span', {
      staticClass: "inner-content",
      domProps: {
        "innerHTML": _vm._s(_vm.header + " " + _vm.content)
      }
    }) : _vm._e()];
  })], 2) : _c('div', {
    staticClass: "tooltip-wrapper",
    attrs: {
      "data-qa": _vm.dataQa + "-content"
    }
  }, [_vm.enableHeader ? _c('div', {
    staticClass: "tooltip-header",
    class: _vm.flavor
  }, [_vm._v("\n        " + _vm._s(_vm.header) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tooltip-content"
  }, [_c('div', {
    staticClass: "content-text"
  }, [_vm._t("tooltipContent", function () {
    return [_vm.content ? _c('span', {
      staticClass: "inner-content",
      domProps: {
        "innerHTML": _vm._s(_vm.content)
      }
    }) : _vm._e()];
  })], 2)])])])], 1);
};

var __vue_staticRenderFns__$1H = [];
/* style */

const __vue_inject_styles__$1M = function (inject) {
  if (!inject) return;
  inject("data-v-293eb92e_0", {
    source: ":root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0{--color-dark:#fed62f;--color-light:#fff1b6}.color-1{--color-dark:#fec22e;--color-light:#ffeab6}.color-2{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4{--color-dark:#fd7024;--color-light:#fecdb3}.color-5{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6{--color-dark:#f2483f;--color-light:#fabfbc}.color-7{--color-dark:#dc331b;--color-light:#f3b8af}.color-8{--color-dark:#d41419;--color-light:#f0adaf}.color-9{--color-dark:#e72866;--color-light:#f7b4ca}.color-10{--color-dark:#c41c63;--color-light:#eab0c9}.color-11{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12{--color-dark:#673bb5;--color-light:#cabbe5}.color-13{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15{--color-dark:#311b92;--color-light:#c0b2ff}.color-16{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20{--color-dark:#14abbf;--color-light:#ade2e9}.color-21{--color-dark:#0f9587;--color-light:#abdad5}.color-22{--color-dark:#16bea5;--color-light:#aee8e0}.color-23{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25{--color-dark:#8cc250;--color-light:#d7eac2}.color-26{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27{--color-dark:#880e4f;--color-light:#ab8198}.color-28{--color-dark:#1565c0;--color-light:#83a4ca}.color-29{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999{--color-dark:#4675d9;--color-light:#becff2}.color-101{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104{--color-dark:#8564c4;--color-light:#cbbce6}.color-105{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109{--color-dark:#328179;--color-light:#a9dad6}.color-110{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111{--color-dark:#5b8131;--color-light:#d7eac1}.color-112{--color-dark:#757b23;--color-light:#eef2bb}.color-113{--color-dark:#8a731e;--color-light:#fff8bc}.color-114{--color-dark:#c88704;--color-light:#ffe9aa}.color-115{--color-dark:#b85f00;--color-light:#ffdba9}.color-116{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120{--color-dark:#63757e;--color-light:#c8d2d7}.vc-tooltip{opacity:1!important;padding:0;border-radius:var(--border-radius)}.vc-tooltip .dark-tooltip{background-color:rgba(0,0,0,.97);font-size:var(--size-value3);font-weight:400;border-radius:var(--size-value1);padding:var(--size-value2)}.vc-tooltip .tooltip-wrapper{background:var(--modal-bg-color);box-shadow:0 5px 5px -3px rgba(0,0,0,.1),0 8px 10px 1px rgba(0,0,0,.06),0 3px 14px 2px rgba(0,0,0,.06);border-radius:var(--border-radius)}.vc-tooltip .tooltip-wrapper .tooltip-header{color:var(--gray-darken-5);font-size:var(--font-size-small2);border-radius:var(--border-radius) var(--border-radius) 0 0;font-weight:var(--font-weight-large);padding:var(--size-value3) var(--size-value4)}.vc-tooltip .tooltip-wrapper .tooltip-header.alert{background-color:var(--red-lighten-3)}.vc-tooltip .tooltip-wrapper .tooltip-header.information{background-color:var(--blue-lighten-3)}.vc-tooltip .tooltip-wrapper .tooltip-content{display:block;font-size:var(--font-size-x-small);padding:var(--size-value3) var(--size-value4) var(--size-value4)}.vc-tooltip .tooltip-wrapper .tooltip-content .content-text{color:var(--gray-darken-5);max-width:fit-content;min-width:250px;word-wrap:break-word}.vc-tooltip .inner-content{display:contents}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1M = undefined;
/* module identifier */

const __vue_module_identifier__$1M = undefined;
/* functional template */

const __vue_is_functional_template__$1M = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1H,
  staticRenderFns: __vue_staticRenderFns__$1H
}, __vue_inject_styles__$1M, __vue_script__$1M, __vue_scope_id__$1M, __vue_is_functional_template__$1M, __vue_module_identifier__$1M, false, createInjector, undefined, undefined);

var VcTooltip = __vue_component__$2E;

var script$1L = {
  name: 'VcIconWithTooltip',
  components: {
    VcTooltip,
    VIcon: VIcon
  },
  props: {
    icon: {
      type: String,
      default: 'information',
      validator: prop => ['information', 'question', 'attention', 'default'].includes(prop)
    },
    size: {
      type: Number,
      default: 12
    },
    dataQa: {
      type: String,
      default: 'vc-tooltip'
    }
  },

  data() {
    return {
      iconInUse: this.icon
    };
  },

  computed: {
    getIcon() {
      if (this.iconInUse === 'default' || this.iconInUse === 'default_hovering') {
        return '$information';
      }

      return `$${this.iconInUse}`;
    }

  },
  methods: {
    inHover() {
      switch (this.icon) {
        case 'information':
          this.iconInUse = 'info_fill';
          break;

        case 'question':
          this.iconInUse = 'question_fill';
          break;

        case 'attention':
          this.iconInUse = 'attention_fill';
          break;

        case 'default':
          this.iconInUse = 'default_hovering';
          break;
      }
    }

  }
};

/* script */
const __vue_script__$1L = script$1L;
/* template */

var __vue_render__$1G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcTooltip', _vm._b({
    attrs: {
      "data-qa": _vm.dataQa
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('v-icon', {
          staticClass: "tooltip-icon",
          class: {
            'vc-default': _vm.iconInUse === 'default',
            'vc-default_hovering': _vm.iconInUse === 'default_hovering'
          },
          attrs: {
            "size": _vm.size,
            "data-qa": _vm.dataQa + "-icon"
          },
          on: {
            "mouseover": _vm.inHover,
            "mouseleave": function ($event) {
              _vm.iconInUse = _vm.icon;
            }
          }
        }, [_vm._v("\n      " + _vm._s(_vm.getIcon) + "\n    ")])];
      },
      proxy: true
    }])
  }, 'VcTooltip', _vm.$attrs, false));
};

var __vue_staticRenderFns__$1G = [];
/* style */

const __vue_inject_styles__$1L = function (inject) {
  if (!inject) return;
  inject("data-v-2602c977_0", {
    source: ":root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0{--color-dark:#fed62f;--color-light:#fff1b6}.color-1{--color-dark:#fec22e;--color-light:#ffeab6}.color-2{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4{--color-dark:#fd7024;--color-light:#fecdb3}.color-5{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6{--color-dark:#f2483f;--color-light:#fabfbc}.color-7{--color-dark:#dc331b;--color-light:#f3b8af}.color-8{--color-dark:#d41419;--color-light:#f0adaf}.color-9{--color-dark:#e72866;--color-light:#f7b4ca}.color-10{--color-dark:#c41c63;--color-light:#eab0c9}.color-11{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12{--color-dark:#673bb5;--color-light:#cabbe5}.color-13{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15{--color-dark:#311b92;--color-light:#c0b2ff}.color-16{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20{--color-dark:#14abbf;--color-light:#ade2e9}.color-21{--color-dark:#0f9587;--color-light:#abdad5}.color-22{--color-dark:#16bea5;--color-light:#aee8e0}.color-23{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25{--color-dark:#8cc250;--color-light:#d7eac2}.color-26{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27{--color-dark:#880e4f;--color-light:#ab8198}.color-28{--color-dark:#1565c0;--color-light:#83a4ca}.color-29{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999{--color-dark:#4675d9;--color-light:#becff2}.color-101{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104{--color-dark:#8564c4;--color-light:#cbbce6}.color-105{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109{--color-dark:#328179;--color-light:#a9dad6}.color-110{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111{--color-dark:#5b8131;--color-light:#d7eac1}.color-112{--color-dark:#757b23;--color-light:#eef2bb}.color-113{--color-dark:#8a731e;--color-light:#fff8bc}.color-114{--color-dark:#c88704;--color-light:#ffe9aa}.color-115{--color-dark:#b85f00;--color-light:#ffdba9}.color-116{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120{--color-dark:#63757e;--color-light:#c8d2d7}.tooltip-icon{cursor:pointer}.tooltip-icon .vc-question{fill:rgba(0,0,0,.4)}.tooltip-icon .vc-question-fill{fill:var(--gray-darken-4)}.tooltip-icon .vc-info-fill,.tooltip-icon .vc-information{fill:var(--v-info-base)}.tooltip-icon .vc-attention,.tooltip-icon .vc-attention-fill{fill:var(--red)}.tooltip-icon.vc-default .vc-info-fill,.tooltip-icon.vc-default .vc-information{fill:rgba(0,0,0,.4)}.tooltip-icon.vc-default_hovering .vc-info-fill,.tooltip-icon.vc-default_hovering .vc-information{fill:var(--gray-darken-4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1L = undefined;
/* module identifier */

const __vue_module_identifier__$1L = undefined;
/* functional template */

const __vue_is_functional_template__$1L = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1G,
  staticRenderFns: __vue_staticRenderFns__$1G
}, __vue_inject_styles__$1L, __vue_script__$1L, __vue_scope_id__$1L, __vue_is_functional_template__$1L, __vue_module_identifier__$1L, false, createInjector, undefined, undefined);

var VcIconWithTooltip = __vue_component__$2D;

var script$1K = {
  name: 'VcTruncatedText',
  components: {
    VcTooltip
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    dataQa: {
      type: String,
      default: 'vc-truncated-text'
    }
  },

  data() {
    return {
      isTruncated: false,
      resizeObserver: null
    };
  },

  mounted() {
    this.checkTruncation();
    this.setupResizeObserver();
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },

  methods: {
    checkTruncation() {
      const element = this.$refs.textContainer;

      if (element) {
        this.isTruncated = element.scrollWidth > element.clientWidth;
      }
    },

    setupResizeObserver() {
      this.resizeObserver = new ResizeObserver(this.checkTruncation);
      const element = this.$refs.textContainer;

      if (element) {
        this.resizeObserver.observe(element);
      }
    }

  }
};

/* script */
const __vue_script__$1K = script$1K;
/* template */

var __vue_render__$1F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcTooltip', _vm._b({
    attrs: {
      "content": _vm.content,
      "disabled": !_vm.isTruncated,
      "data-qa": _vm.dataQa
    }
  }, 'VcTooltip', _vm.$attrs, false), [_c('div', {
    ref: "textContainer",
    staticClass: "vc-truncated-text",
    class: {
      'vc-truncated-text--truncated': _vm.isTruncated
    }
  }, [_vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.content))];
  })], 2)]);
};

var __vue_staticRenderFns__$1F = [];
/* style */

const __vue_inject_styles__$1K = function (inject) {
  if (!inject) return;
  inject("data-v-7ca27212_0", {
    source: ".vc-truncated-text[data-v-7ca27212]{display:inline-block;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1K = "data-v-7ca27212";
/* module identifier */

const __vue_module_identifier__$1K = undefined;
/* functional template */

const __vue_is_functional_template__$1K = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1F,
  staticRenderFns: __vue_staticRenderFns__$1F
}, __vue_inject_styles__$1K, __vue_script__$1K, __vue_scope_id__$1K, __vue_is_functional_template__$1K, __vue_module_identifier__$1K, false, createInjector, undefined, undefined);

var __vue_component__$2C = __vue_component__$2B;

var script$1J = {
  name: 'VcAvatar',
  components: {
    VcImage,
    VIcon: VIcon,
    VTooltip: VTooltip
  },
  props: {
    imagePath: {
      type: [String, Object],
      default: ''
    },
    name: {
      type: String
    },
    text: {
      type: String
    },
    colorId: {
      type: Number
    },
    size: {
      type: String,
      default: 'md',
      validator: prop => ['x-sm', 'sm', 'md', 'lg'].includes(prop)
    },
    badgeIcon: {
      type: String,
      default: ''
    },
    badgePosition: {
      type: String,
      default: 'right'
    },
    lightMode: {
      type: Boolean,
      default: false
    },
    lightModeTooltip: {
      type: String,
      default: ''
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcAvatar'
    }
  },

  data() {
    return {
      icons: {
        flag: {
          backgroundColor: '#478FFF',
          size: '10',
          icon: '$flag'
        },
        customer: {
          backgroundColor: '#54D28C',
          size: '10',
          icon: '$customer'
        },
        inactive: {
          backgroundColor: '#586E8C',
          size: '10',
          icon: '$inactive'
        },
        vip: {
          backgroundColor: '#FF9718',
          size: '10',
          icon: '$vip'
        },
        confirmed: {
          backgroundColor: '#54D28C',
          size: '8',
          icon: '$success'
        }
      }
    };
  },

  computed: {
    setLightModeClass() {
      return this.lightMode && !this.imagePath ? 'light-mode' : '';
    },

    setShowBorder() {
      return this.showBorder ? 'show-border' : '';
    },

    setdisabled() {
      return this.disabled ? 'vc-disabled' : '';
    },

    computedClasses() {
      return `${this.colorClass} ${this.size} ${this.setLightModeClass} ${this.setShowBorder} ${this.setdisabled}`;
    },

    computedBadgeClass() {
      return this.badgeIcon + ' ' + this.size + ' ' + this.badgePosition;
    },

    colorClass() {
      return !this.imagePath && this.colorId >= 0 ? `color-${this.colorId}` : '';
    },

    initials() {
      return this.getInitials(this.name);
    }

  },
  methods: {
    getInitials(name) {
      let split = name.trim().split(' ').filter(Boolean);
      let initials = '';

      if (split.length) {
        initials += split[0][0];

        if (split[1]) {
          initials += split[1][0];
        } else if (split[0][1]) {
          initials += split[0][1];
        }
      }

      return initials.toUpperCase();
    }

  }
};

/* script */
const __vue_script__$1J = script$1J;
/* template */

var __vue_render__$1E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "avatar-wrapper",
    class: _vm.computedClasses,
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        ref.attrs;
        return [_c('VcImage', _vm._g({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.imagePath,
            expression: "imagePath"
          }],
          staticClass: "avatar-image",
          attrs: {
            "data-qa": "avatarImage",
            "image": _vm.imagePath
          }
        }, _vm.lightMode && _vm.lightModeTooltip && on)), _vm._v(" "), _c('div', _vm._g({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.imagePath,
            expression: "!imagePath"
          }],
          staticClass: "avatar-initials",
          attrs: {
            "data-qa": "avatar-initials"
          }
        }, _vm.lightMode && _vm.lightModeTooltip && on), [_vm.text || _vm.name ? _c('span', [_vm._v(_vm._s(_vm.text || _vm.initials))]) : _vm._e()]), _vm._v(" "), _vm.badgeIcon && _vm.icons[_vm.badgeIcon] ? _c('div', {
          staticClass: "badge d-flex justify-center align-center",
          class: _vm.computedBadgeClass,
          style: {
            backgroundColor: _vm.icons[_vm.badgeIcon].backgroundColor
          }
        }, [_c('v-icon', {
          attrs: {
            "data-qa": "avatarBadgeIcon",
            "size": _vm.icons[_vm.badgeIcon].size
          }
        }, [_vm._v("\n          " + _vm._s(_vm.icons[_vm.badgeIcon].icon) + "\n        ")])], 1) : _vm._e()];
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lightModeTooltip))])])], 1);
};

var __vue_staticRenderFns__$1E = [];
/* style */

const __vue_inject_styles__$1J = function (inject) {
  if (!inject) return;
  inject("data-v-0ea4772d_0", {
    source: "[data-v-0ea4772d]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-0ea4772d]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-0ea4772d]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-0ea4772d]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-0ea4772d]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-0ea4772d]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-0ea4772d]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-0ea4772d]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-0ea4772d]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-0ea4772d]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-0ea4772d]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-0ea4772d]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-0ea4772d]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-0ea4772d]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-0ea4772d]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-0ea4772d]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-0ea4772d]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-0ea4772d]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-0ea4772d]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-0ea4772d]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-0ea4772d]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-0ea4772d]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-0ea4772d]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-0ea4772d]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-0ea4772d]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-0ea4772d]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-0ea4772d]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-0ea4772d]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-0ea4772d]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-0ea4772d]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-0ea4772d]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-0ea4772d]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-0ea4772d]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-0ea4772d]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-0ea4772d]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-0ea4772d]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-0ea4772d]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-0ea4772d]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-0ea4772d]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-0ea4772d]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-0ea4772d]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-0ea4772d]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-0ea4772d]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-0ea4772d]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-0ea4772d]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-0ea4772d]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-0ea4772d]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-0ea4772d]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-0ea4772d]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-0ea4772d]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-0ea4772d]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-0ea4772d]{--color-dark:#63757e;--color-light:#c8d2d7}.avatar-wrapper[data-v-0ea4772d]{position:relative;border-radius:50%;background-color:var(--color-dark);text-align:center;color:var(--modal-bg-color)}.avatar-wrapper.show-border[data-v-0ea4772d]{border:1px solid var(--modal-bg-color)}.avatar-wrapper.vc-disabled[data-v-0ea4772d]{filter:grayscale(100%)}.avatar-wrapper.light-mode[data-v-0ea4772d]{border:1px solid rgba(0,0,0,.3);color:rgba(0,0,0,.3);background-color:var(--modal-bg-color)}.avatar-wrapper.x-sm[data-v-0ea4772d]{height:var(--avatar-x-sm);width:var(--avatar-x-sm);font-size:var(--font-size-xxx-small)}.avatar-wrapper.sm[data-v-0ea4772d]{height:var(--avatar-sm);width:var(--avatar-sm);font-size:var(--font-size-xx-small)}.avatar-wrapper.md[data-v-0ea4772d]{height:var(--avatar-md);width:var(--avatar-md);font-size:var(--font-size-small)}.avatar-wrapper.lg[data-v-0ea4772d]{height:var(--avatar-lg);width:var(--avatar-lg);font-size:var(--font-size-small3)}.avatar-wrapper .avatar-image[data-v-0ea4772d]{height:100%;width:100%;border-radius:50%;overflow:hidden}.avatar-wrapper .avatar-image[data-v-0ea4772d]  svg{height:100%}.avatar-wrapper .avatar-image[data-v-0ea4772d]  img{height:100%}.avatar-wrapper .avatar-initials[data-v-0ea4772d]{position:relative;top:50%;font-weight:var(--font-weight-medium2);transform:translateY(-50%)}.avatar-wrapper .badge[data-v-0ea4772d]{fill:#fff;position:absolute;--gap:0;height:var(--size-value4);width:var(--size-value4);border-radius:50%;bottom:calc(var(--gap) * -1);left:calc(var(--gap) * -1)}.avatar-wrapper .badge.x-sm[data-v-0ea4772d]{--gap:var(--size-value1)}.avatar-wrapper .badge.sm[data-v-0ea4772d]{--gap:var(--size-value1)}.avatar-wrapper .badge.md[data-v-0ea4772d]{--gap:2px}.avatar-wrapper .badge.lg[data-v-0ea4772d]{--gap:var(--size-value0)}.avatar-wrapper .badge.right[data-v-0ea4772d]{left:unset;right:calc(var(--gap) * -1)}.avatar-wrapper .badge.confirmed[data-v-0ea4772d]{border:2px var(--modal-bg-color) solid}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1J = "data-v-0ea4772d";
/* module identifier */

const __vue_module_identifier__$1J = undefined;
/* functional template */

const __vue_is_functional_template__$1J = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1E,
  staticRenderFns: __vue_staticRenderFns__$1E
}, __vue_inject_styles__$1J, __vue_script__$1J, __vue_scope_id__$1J, __vue_is_functional_template__$1J, __vue_module_identifier__$1J, false, createInjector, undefined, undefined);

var VcAvatar = __vue_component__$2A;

var script$1I = {
  name: 'VcBottomActions',
  components: {
    VcLayout,
    VcButton,
    VcIcon,
    VcAvatar,
    VSubheader: VSubheader,
    VListItem: VListItem,
    VList: VList,
    VBottomSheet: VBottomSheet
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true,
      validator: prop => prop.every(e => e.title && e.event)
    },
    header: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: undefined
    },
    avatarData: {
      type: Object,
      default: undefined
    },

    /**
     * Deprecated, please use avatarData
     */
    client: {
      type: Object,
      default: undefined
    },
    dataQa: {
      type: String,
      default: 'vc-bottom-sheet'
    }
  },
  computed: {
    isNotAllItemsWithIcons() {
      return this.items.some(item => !item.icon);
    }

  }
};

/* script */
const __vue_script__$1I = script$1I;
/* template */

var __vue_render__$1D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-bottom-sheet', {
    attrs: {
      "persistent": _vm.header,
      "value": _vm.value,
      "content-class": "vc-bottom-sheet"
    },
    on: {
      "click:outside": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_vm._t("default", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true)
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm.header ? _c('v-subheader', {
    staticClass: "subheader"
  }, [_vm.avatarData || _vm.client ? _c('vc-avatar', _vm._b({
    staticClass: "avatar",
    attrs: {
      "size": "x-sm"
    }
  }, 'vc-avatar', Object.assign({}, _vm.avatarData, _vm.client), false)) : _vm._e(), _vm._v(" "), _vm.title ? _c('span', {
    staticClass: "vc-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('vc-layout', {
    staticClass: "button-close-wrapper"
  }, [_c('vc-button', {
    staticClass: "close-button",
    attrs: {
      "ripple": false,
      "data-qa": "close-sheet-button",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('vc-icon', [_vm._v("$close_button")])];
      },
      proxy: true
    }], null, false, 3316324652)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('vc-layout', {
    staticClass: "items-wrapper",
    attrs: {
      "column": ""
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('v-list-item', {
      key: item.title,
      staticClass: "sheet-item",
      on: {
        "click": function ($event) {
          return _vm.$emit('action', item.event);
        }
      }
    }, [_c('vc-layout', {
      staticClass: "option-title",
      attrs: {
        "align-center": ""
      }
    }, [item.icon && !_vm.isNotAllItemsWithIcons ? _c('vc-icon', {
      staticClass: "icon-item"
    }, [_vm._v("\n            " + _vm._s("$" + item.icon) + "\n          ")]) : _vm._e(), _vm._v("\n          " + _vm._s(item.title) + "\n        ")], 1)], 1);
  }), 1)], 1)], 1);
};

var __vue_staticRenderFns__$1D = [];
/* style */

const __vue_inject_styles__$1I = function (inject) {
  if (!inject) return;
  inject("data-v-6c3d3276_0", {
    source: ":root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0{--color-dark:#fed62f;--color-light:#fff1b6}.color-1{--color-dark:#fec22e;--color-light:#ffeab6}.color-2{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4{--color-dark:#fd7024;--color-light:#fecdb3}.color-5{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6{--color-dark:#f2483f;--color-light:#fabfbc}.color-7{--color-dark:#dc331b;--color-light:#f3b8af}.color-8{--color-dark:#d41419;--color-light:#f0adaf}.color-9{--color-dark:#e72866;--color-light:#f7b4ca}.color-10{--color-dark:#c41c63;--color-light:#eab0c9}.color-11{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12{--color-dark:#673bb5;--color-light:#cabbe5}.color-13{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15{--color-dark:#311b92;--color-light:#c0b2ff}.color-16{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20{--color-dark:#14abbf;--color-light:#ade2e9}.color-21{--color-dark:#0f9587;--color-light:#abdad5}.color-22{--color-dark:#16bea5;--color-light:#aee8e0}.color-23{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25{--color-dark:#8cc250;--color-light:#d7eac2}.color-26{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27{--color-dark:#880e4f;--color-light:#ab8198}.color-28{--color-dark:#1565c0;--color-light:#83a4ca}.color-29{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999{--color-dark:#4675d9;--color-light:#becff2}.color-101{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104{--color-dark:#8564c4;--color-light:#cbbce6}.color-105{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109{--color-dark:#328179;--color-light:#a9dad6}.color-110{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111{--color-dark:#5b8131;--color-light:#d7eac1}.color-112{--color-dark:#757b23;--color-light:#eef2bb}.color-113{--color-dark:#8a731e;--color-light:#fff8bc}.color-114{--color-dark:#c88704;--color-light:#ffe9aa}.color-115{--color-dark:#b85f00;--color-light:#ffdba9}.color-116{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120{--color-dark:#63757e;--color-light:#c8d2d7}.vc-bottom-sheet{box-shadow:0 1px 10px rgba(0,0,0,.12),0 4px 5px rgba(0,0,0,.14),0 2px 4px -1px rgba(0,0,0,.2);margin:var(--size-value3) var(--size-value3) var(--size-value5)!important;border-radius:var(--modal-border-radius)!important}.vc-bottom-sheet .v-sheet.v-list{border-radius:var(--modal-border-radius);padding-top:var(--size-value0)}.vc-bottom-sheet .v-sheet.v-list .subheader{border-bottom:1px solid rgba(0,0,0,.12);padding:var(--size-value3) var(--size-value4);color:var(--gray-darken-5)}.vc-bottom-sheet .v-sheet.v-list .subheader .avatar{margin-inline-end:var(--size-value3)}.vc-bottom-sheet .v-sheet.v-list .subheader .vc-title{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small)}.vc-bottom-sheet .v-sheet.v-list .subheader .button-close-wrapper{flex-grow:1;justify-content:flex-end}.vc-bottom-sheet .v-sheet.v-list .subheader .button-close-wrapper .close-button{justify-content:flex-end;padding:var(--size-value0)}.vc-bottom-sheet .v-sheet.v-list .subheader .button-close-wrapper .close-button .v-btn__content{opacity:unset}.vc-bottom-sheet .v-sheet.v-list .subheader .button-close-wrapper .close-button .v-icon svg{fill:rgba(0,0,0,.4);width:var(--size-value4);height:var(--size-value4)}.vc-bottom-sheet .v-sheet.v-list .items-wrapper{padding:var(--size-value1) var(--size-value0)}.vc-bottom-sheet .v-sheet.v-list .items-wrapper .sheet-item{min-height:var(--size-value10)}.vc-bottom-sheet .v-sheet.v-list .items-wrapper .sheet-item .option-title{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2);letter-spacing:-.2px}.vc-bottom-sheet .v-sheet.v-list .items-wrapper .sheet-item .option-title .icon-item{vertical-align:sub;margin-inline-end:var(--size-value3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1I = undefined;
/* module identifier */

const __vue_module_identifier__$1I = undefined;
/* functional template */

const __vue_is_functional_template__$1I = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1D,
  staticRenderFns: __vue_staticRenderFns__$1D
}, __vue_inject_styles__$1I, __vue_script__$1I, __vue_scope_id__$1I, __vue_is_functional_template__$1I, __vue_module_identifier__$1I, false, createInjector, undefined, undefined);

var VcBottomActions = __vue_component__$2z;

var script$1H = {
  name: 'VcActionList',
  components: {
    VcLayout,
    VcIcon,
    VSubheader: VSubheader,
    VListItemTitle: VListItemTitle,
    VListItem: VListItem,
    VList: VList,
    VMenu: VMenu
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: prop => prop.every(e => e.title && e.event || e.header)
    },
    dataQa: {
      type: String,
      default: 'vc-action-list'
    },
    offsetX: {
      type: Boolean,
      default: true
    },
    offsetY: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$1H = script$1H;
/* template */

var __vue_render__$1C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-menu', {
    attrs: {
      "content-class": "vc-action-list",
      "offset-x": _vm.offsetX,
      "offset-y": _vm.offsetY
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_vm._t("default", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true)
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('vc-layout', {
    staticClass: "items-wrapper",
    attrs: {
      "column": ""
    }
  }, [_vm._l(_vm.items, function (item, index) {
    return [item.header ? _c('v-subheader', {
      key: item.header + "-" + index,
      class: {
        'hide-header': item.HideHeader
      }
    }, [_vm._v("\n          " + _vm._s(item.header) + "\n        ")]) : _c('v-list-item', {
      key: item.dataQa + "-" + index,
      staticClass: "sheet-item",
      attrs: {
        "data-qa": item.dataQa ? item.dataQa : _vm.dataQa + "-option-" + index
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('action', item.event);
        }
      }
    }, [_c('v-list-item-title', {
      staticClass: "option-title"
    }, [_vm._t("item-title-" + index, function () {
      return [item.icon ? _c('vc-icon', {
        staticClass: "icon-item",
        attrs: {
          "size": "20"
        }
      }, [_vm._v("\n                " + _vm._s(item.icon) + "\n              ")]) : _vm._e(), _vm._v("\n              " + _vm._s(item.title) + "\n            ")];
    }, {
      "item": item
    })], 2)], 1)];
  }), _vm._v(" "), _vm._t("append")], 2)], 1)], 1);
};

var __vue_staticRenderFns__$1C = [];
/* style */

const __vue_inject_styles__$1H = function (inject) {
  if (!inject) return;
  inject("data-v-01a3ba25_0", {
    source: ":root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0{--color-dark:#fed62f;--color-light:#fff1b6}.color-1{--color-dark:#fec22e;--color-light:#ffeab6}.color-2{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4{--color-dark:#fd7024;--color-light:#fecdb3}.color-5{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6{--color-dark:#f2483f;--color-light:#fabfbc}.color-7{--color-dark:#dc331b;--color-light:#f3b8af}.color-8{--color-dark:#d41419;--color-light:#f0adaf}.color-9{--color-dark:#e72866;--color-light:#f7b4ca}.color-10{--color-dark:#c41c63;--color-light:#eab0c9}.color-11{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12{--color-dark:#673bb5;--color-light:#cabbe5}.color-13{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15{--color-dark:#311b92;--color-light:#c0b2ff}.color-16{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20{--color-dark:#14abbf;--color-light:#ade2e9}.color-21{--color-dark:#0f9587;--color-light:#abdad5}.color-22{--color-dark:#16bea5;--color-light:#aee8e0}.color-23{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25{--color-dark:#8cc250;--color-light:#d7eac2}.color-26{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27{--color-dark:#880e4f;--color-light:#ab8198}.color-28{--color-dark:#1565c0;--color-light:#83a4ca}.color-29{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999{--color-dark:#4675d9;--color-light:#becff2}.color-101{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104{--color-dark:#8564c4;--color-light:#cbbce6}.color-105{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109{--color-dark:#328179;--color-light:#a9dad6}.color-110{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111{--color-dark:#5b8131;--color-light:#d7eac1}.color-112{--color-dark:#757b23;--color-light:#eef2bb}.color-113{--color-dark:#8a731e;--color-light:#fff8bc}.color-114{--color-dark:#c88704;--color-light:#ffe9aa}.color-115{--color-dark:#b85f00;--color-light:#ffdba9}.color-116{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120{--color-dark:#63757e;--color-light:#c8d2d7}.vc-action-list{box-shadow:0 1px 10px rgba(0,0,0,.12),0 4px 5px rgba(0,0,0,.14),0 2px 4px -1px rgba(0,0,0,.2);border-radius:var(--modal-border-radius)}.vc-action-list .v-list{border-radius:var(--modal-border-radius);padding:var(--size-value1) 0}.vc-action-list .v-list .items-wrapper .v-subheader{font-weight:600;font-size:10px;line-height:16px;color:var(--gray-darken-3);height:36px}.vc-action-list .v-list .items-wrapper .v-subheader:not(:first-child){border-top:var(--border-frame)}.vc-action-list .v-list .items-wrapper .v-subheader.hide-header{border-top:none}.vc-action-list .v-list .items-wrapper .sheet-item{min-height:var(--size-value10)}.vc-action-list .v-list .items-wrapper .sheet-item .option-title{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2);letter-spacing:-.2px}.vc-action-list .v-list .items-wrapper .sheet-item .option-title .icon-item{width:25px;vertical-align:sub;margin-inline-end:var(--size-value3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1H = undefined;
/* module identifier */

const __vue_module_identifier__$1H = undefined;
/* functional template */

const __vue_is_functional_template__$1H = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1C,
  staticRenderFns: __vue_staticRenderFns__$1C
}, __vue_inject_styles__$1H, __vue_script__$1H, __vue_scope_id__$1H, __vue_is_functional_template__$1H, __vue_module_identifier__$1H, false, createInjector, undefined, undefined);

var VcActionList = __vue_component__$2y;

var script$1G = {
  name: 'VcActions',
  components: {
    VcIcon,
    VcActionList,
    VcBottomActions
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: prop => prop.every(e => e.title && e.event)
    },
    header: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: undefined
    },
    avatarData: {
      type: Object,
      default: undefined
    },

    /**
     * Deprecated, please use avatarData
     */
    client: {
      type: Object,
      default: undefined
    },
    dataQa: {
      type: String,
      default: 'vc-actions'
    }
  },

  data() {
    return {
      showSheet: false
    };
  },

  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    }

  },
  methods: {
    handleSheet(action) {
      this.showSheet = false;
      this.$emit('action', action);
    },

    handleCloseSheet() {
      this.showSheet = false;
      this.$emit('close');
    }

  }
};

/* script */
const __vue_script__$1G = script$1G;
/* template */

var __vue_render__$1B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c(_vm.isMobile ? 'VcBottomActions' : 'VcActionList', _vm._b({
    tag: "component",
    on: {
      "action": function ($event) {
        return _vm.handleSheet($event);
      },
      "close": function ($event) {
        return _vm.handleCloseSheet();
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_c('VcIcon', _vm._g(_vm._b({
          attrs: {
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.showSheet = !_vm.showSheet;
            }
          }
        }, 'VcIcon', attrs, false), on), [_vm._v(" $three_dots ")])];
      }
    }]),
    model: {
      value: _vm.showSheet,
      callback: function ($$v) {
        _vm.showSheet = $$v;
      },
      expression: "showSheet"
    }
  }, 'component', _vm.$props, false));
};

var __vue_staticRenderFns__$1B = [];
/* style */

const __vue_inject_styles__$1G = undefined;
/* scoped */

const __vue_scope_id__$1G = undefined;
/* module identifier */

const __vue_module_identifier__$1G = undefined;
/* functional template */

const __vue_is_functional_template__$1G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1B,
  staticRenderFns: __vue_staticRenderFns__$1B
}, __vue_inject_styles__$1G, __vue_script__$1G, __vue_scope_id__$1G, __vue_is_functional_template__$1G, __vue_module_identifier__$1G, false, undefined, undefined, undefined);

var VcActions = __vue_component__$2x;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1F = {
  components: {
    VStepperStep: VStepperStep,
    VStepper: VStepper
  },

  name: 'VcStepsBar',

  model: {
    prop: 'currentStep'
  },

  props: {
    currentStep: {
      type: Number,
      default: 1
    },
    steps: {
      type: Array,
      validator: steps => steps.every(step => step.name),
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    dataQa: {
      type: String,
      default: 'vc-steps-bar'
    }
  },

  data() {
    return {
      lastCompleted: 0,
      FIRST_STEP: 1
    };
  },

  watch: {
    currentStep: {
      handler(newVal, oldVal) {
        if (newVal > oldVal) {
          this.nextStep();
        }

        if (newVal < this.FIRST_STEP) {
          this.shareStep(this.FIRST_STEP);
        }
      }

    }
  },

  methods: {
    goToStep(step) {
      if (this.lastCompleted > step) {
        this.$emit('goToStep', step);
      }
    },

    nextStep() {
      if (this.lastCompleted < this.currentStep) {
        this.lastCompleted = this.currentStep;
      }

      if (this.currentStep > this.steps.length) {
        this.shareStep(this.steps.length);
      }
    },

    shareStep(step) {
      this.$emit('input', step);
    }

  }
};

/* script */
const __vue_script__$1F = script$1F;
/* template */

var __vue_render__$1A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vc-stepper-container",
    attrs: {
      "data-qa": "vc-steps-bar"
    }
  }, [_c('v-stepper', {
    staticClass: "vc-stepper",
    attrs: {
      "vertical": "",
      "data-qa": _vm.dataQa
    },
    model: {
      value: _vm.currentStep,
      callback: function ($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, [_vm.title ? _c('div', {
    staticClass: "stepper-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._l(_vm.steps, function (step, index) {
    return [_c('v-stepper-step', {
      key: "step-" + (index + 1),
      staticClass: "test_class",
      attrs: {
        "id": "step-" + (index + 1),
        "complete": _vm.lastCompleted > index + 1,
        "step": index + 1
      },
      on: {
        "click": function ($event) {
          return _vm.goToStep(index + 1);
        }
      }
    }, [_vm._v("\n        " + _vm._s(step.title ? step.title : step.name) + "\n      ")])];
  })], 2)], 1);
};

var __vue_staticRenderFns__$1A = [];
/* style */

const __vue_inject_styles__$1F = function (inject) {
  if (!inject) return;
  inject("data-v-164f5e0e_0", {
    source: "[data-v-164f5e0e]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-164f5e0e]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-164f5e0e]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-164f5e0e]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-164f5e0e]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-164f5e0e]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-164f5e0e]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-164f5e0e]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-164f5e0e]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-164f5e0e]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-164f5e0e]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-164f5e0e]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-164f5e0e]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-164f5e0e]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-164f5e0e]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-164f5e0e]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-164f5e0e]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-164f5e0e]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-164f5e0e]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-164f5e0e]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-164f5e0e]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-164f5e0e]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-164f5e0e]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-164f5e0e]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-164f5e0e]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-164f5e0e]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-164f5e0e]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-164f5e0e]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-164f5e0e]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-164f5e0e]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-164f5e0e]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-164f5e0e]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-164f5e0e]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-164f5e0e]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-164f5e0e]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-164f5e0e]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-164f5e0e]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-164f5e0e]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-164f5e0e]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-164f5e0e]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-164f5e0e]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-164f5e0e]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-164f5e0e]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-164f5e0e]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-164f5e0e]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-164f5e0e]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-164f5e0e]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-164f5e0e]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-164f5e0e]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-164f5e0e]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-164f5e0e]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-164f5e0e]{--color-dark:#63757e;--color-light:#c8d2d7}.vc-stepper-container[data-v-164f5e0e]{height:100%;padding-block-start:var(--size-value4);padding-inline-start:var(--size-value10)}.vc-stepper.v-stepper[data-v-164f5e0e]{box-shadow:none}.vc-stepper.v-stepper .stepper-title[data-v-164f5e0e]{margin-block-end:var(--size-value6);font-weight:var(--font-weight-large2);font-size:var(--font-size-medium);letter-spacing:.03em;color:var(--gray-darken-5)}.vc-stepper.v-stepper .v-stepper__step[data-v-164f5e0e]{padding:var(--size-value0);width:fit-content;align-items:flex-start;margin-block-end:var(--size-value1)}.vc-stepper.v-stepper .v-stepper__step[data-v-164f5e0e]  .v-stepper__label{padding-inline-end:var(--size-value6);text-shadow:none;font-size:var(--font-size-small2);letter-spacing:.01em;line-height:var(--size-value6);padding-bottom:var(--size-value7)}.vc-stepper.v-stepper .v-stepper__step[data-v-164f5e0e]  span.v-stepper__step__step{height:var(--size-value5);min-width:var(--size-value5);width:var(--size-value5);margin-inline-end:var(--size-value3);margin-inline-start:var(--size-value0);margin-block:2px;font-size:var(--font-size-xx-small);font-weight:var(--font-weight-medium2)}.vc-stepper.v-stepper .v-stepper__step[data-v-164f5e0e]:not(.v-stepper__step--active):not(.v-stepper__step--complete)  span.v-stepper__step__step{background-color:var(--gray-lighten-2);color:var(--gray-darken-2)}.vc-stepper.v-stepper .v-stepper__step[data-v-164f5e0e]:not(.v-stepper__step--active):not(.v-stepper__step--complete)  .v-stepper__label{color:var(--gray-darken-4)}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--active[data-v-164f5e0e]:not(.v-stepper__step--complete)  span.v-stepper__step__step{background-color:var(--v-secondary-base)!important}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--active[data-v-164f5e0e]:not(.v-stepper__step--complete)  .v-stepper__label{color:var(--gray-darken-5);font-weight:var(--font-weight-large)}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--complete[data-v-164f5e0e]  span.v-stepper__step__step{background-color:var(--green)!important}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--complete[data-v-164f5e0e]  span.v-stepper__step__step i{font-size:var(--size-value3)}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--complete[data-v-164f5e0e]  .v-stepper__label{color:var(--gray-darken-5)}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--complete.v-stepper__step--active[data-v-164f5e0e]  .v-stepper__label{font-weight:var(--font-weight-large)}.vc-stepper.v-stepper .v-stepper__step[data-v-164f5e0e]:not(:last-child)::after{content:\"\";border-inline-start:2px solid var(--gray-lighten-1);position:absolute;top:0;margin-inline-start:9px;height:-webkit-fill-available;margin-top:var(--size-value7)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1F = "data-v-164f5e0e";
/* module identifier */

const __vue_module_identifier__$1F = undefined;
/* functional template */

const __vue_is_functional_template__$1F = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1A,
  staticRenderFns: __vue_staticRenderFns__$1A
}, __vue_inject_styles__$1F, __vue_script__$1F, __vue_scope_id__$1F, __vue_is_functional_template__$1F, __vue_module_identifier__$1F, false, createInjector, undefined, undefined);

var VcStepsBar = __vue_component__$2w;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1E = {
  components: {
    VProgressCircular: VProgressCircular
  },

  name: 'VcProgressCircular',

  model: {
    prop: 'currentStep'
  },

  props: {
    currentStep: {
      type: Number,
      default: 1
    },
    steps: {
      type: Number,
      required: true
    },
    showStages: {
      type: Boolean,
      default: true
    },

    /**
     * By default, the text color will be black.
     * In specific cases, we want to have font color according to the theme.
     */
    fontColorByTheme: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-progress-circular'
    },
    size: {
      type: String,
      default: 'md'
    }
  },

  data() {
    return {
      FIRST_STEP: 1,
      FILLING_COLOR: 'var(--green)'
    };
  },

  computed: {
    fillPercentages() {
      return this.currentStep * 100 / this.steps;
    }

  },

  watch: {
    currentStep: {
      handler(newVal) {
        if (newVal > this.steps) {
          this.shareStep(this.steps);
        }

        if (newVal < this.FIRST_STEP) {
          this.shareStep(this.FIRST_STEP);
        }
      }

    }
  },

  methods: {
    shareStep(step) {
      this.$emit('input', step);
    }

  }
};

/* script */
const __vue_script__$1E = script$1E;
/* template */

var __vue_render__$1z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-progress-circular', {
    staticClass: "vc-progress-circular",
    attrs: {
      "rotate": -90,
      "size": _vm.size === 'sm' ? 36 : 48,
      "value": _vm.fillPercentages,
      "color": _vm.FILLING_COLOR,
      "data-qa": _vm.dataQa
    }
  }, [_vm.showStages ? _c('div', {
    staticClass: "vc-progress-counter",
    class: {
      fontColorByTheme: _vm.fontColorByTheme,
      sm: _vm.size === 'sm'
    }
  }, [_vm._v("\n    " + _vm._s(_vm.currentStep) + " / " + _vm._s(_vm.steps) + "\n  ")]) : _vm._e()]);
};

var __vue_staticRenderFns__$1z = [];
/* style */

const __vue_inject_styles__$1E = function (inject) {
  if (!inject) return;
  inject("data-v-1e34e81c_0", {
    source: "[data-v-1e34e81c]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-1e34e81c]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-1e34e81c]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-1e34e81c]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-1e34e81c]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-1e34e81c]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-1e34e81c]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-1e34e81c]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-1e34e81c]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-1e34e81c]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-1e34e81c]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-1e34e81c]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-1e34e81c]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-1e34e81c]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-1e34e81c]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-1e34e81c]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-1e34e81c]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-1e34e81c]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-1e34e81c]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-1e34e81c]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-1e34e81c]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-1e34e81c]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-1e34e81c]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-1e34e81c]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-1e34e81c]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-1e34e81c]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-1e34e81c]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-1e34e81c]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-1e34e81c]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-1e34e81c]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-1e34e81c]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-1e34e81c]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-1e34e81c]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-1e34e81c]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-1e34e81c]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-1e34e81c]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-1e34e81c]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-1e34e81c]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-1e34e81c]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-1e34e81c]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-1e34e81c]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-1e34e81c]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-1e34e81c]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-1e34e81c]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-1e34e81c]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-1e34e81c]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-1e34e81c]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-1e34e81c]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-1e34e81c]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-1e34e81c]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-1e34e81c]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-1e34e81c]{--color-dark:#63757e;--color-light:#c8d2d7}.vc-progress-circular .vc-progress-counter[data-v-1e34e81c]{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2);color:var(--gray-darken-5)}.vc-progress-circular .vc-progress-counter.fontColorByTheme[data-v-1e34e81c]{color:var(--v-text-base)}.vc-progress-circular .vc-progress-counter.sm[data-v-1e34e81c]{font-size:var(--font-size-xs-small)}.vc-progress-circular[data-v-1e34e81c]  .v-progress-circular__underlay{stroke:var(--neutral-lighten-1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1E = "data-v-1e34e81c";
/* module identifier */

const __vue_module_identifier__$1E = undefined;
/* functional template */

const __vue_is_functional_template__$1E = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1z,
  staticRenderFns: __vue_staticRenderFns__$1z
}, __vue_inject_styles__$1E, __vue_script__$1E, __vue_scope_id__$1E, __vue_is_functional_template__$1E, __vue_module_identifier__$1E, false, createInjector, undefined, undefined);

var VcProgressCircular = __vue_component__$2v;

var script$1D = {
  name: 'VcMobileWizardProgress',
  components: {
    VcLayout,
    VcProgressCircular
  },
  model: {
    prop: 'currentStep'
  },
  props: {
    currentStep: {
      type: Number,
      default: 1
    },
    steps: {
      type: [Array],
      validator: steps => steps.every(step => step.name),
      required: true
    },
    dataQa: {
      type: String,
      default: 'vc-mobile-wizard-stepper'
    }
  },
  computed: {
    _currentStep: {
      get() {
        return this.currentStep;
      },

      set(step) {
        this.$emit('input', step);
      }

    },

    currentStepName() {
      var _this$steps;

      return (_this$steps = this.steps[this.currentStep - 1]) === null || _this$steps === void 0 ? void 0 : _this$steps.name;
    },

    nextStepName() {
      var _this$steps$this$curr;

      if (this.currentStep >= this.numOfSteps) {
        return;
      }

      return `${this.$dst('ds.progress_circular.next')} ${(_this$steps$this$curr = this.steps[this.currentStep]) === null || _this$steps$this$curr === void 0 ? void 0 : _this$steps$this$curr.name}`;
    },

    numOfSteps() {
      return this.steps.length;
    }

  }
};

/* script */
const __vue_script__$1D = script$1D;
/* template */

var __vue_render__$1y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('vc-layout', {
    staticClass: "vc-mobile-wizard-progress",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('VcProgressCircular', {
    attrs: {
      "steps": _vm.numOfSteps,
      "data-qa": _vm.dataQa + "-progress"
    },
    model: {
      value: _vm._currentStep,
      callback: function ($$v) {
        _vm._currentStep = $$v;
      },
      expression: "_currentStep"
    }
  }), _vm._v(" "), _c('vc-layout', {
    staticClass: "titles-container",
    attrs: {
      "column": ""
    }
  }, [_vm.currentStepName ? _c('div', {
    staticClass: "current-step"
  }, [_vm._v("\n      " + _vm._s(_vm.currentStepName) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.nextStepName ? _c('div', {
    staticClass: "next-step"
  }, [_vm._v("\n      " + _vm._s(_vm.nextStepName) + "\n    ")]) : _vm._e()])], 1);
};

var __vue_staticRenderFns__$1y = [];
/* style */

const __vue_inject_styles__$1D = function (inject) {
  if (!inject) return;
  inject("data-v-0bc314d4_0", {
    source: "[data-v-0bc314d4]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-0bc314d4]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-0bc314d4]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-0bc314d4]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-0bc314d4]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-0bc314d4]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-0bc314d4]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-0bc314d4]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-0bc314d4]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-0bc314d4]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-0bc314d4]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-0bc314d4]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-0bc314d4]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-0bc314d4]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-0bc314d4]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-0bc314d4]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-0bc314d4]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-0bc314d4]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-0bc314d4]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-0bc314d4]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-0bc314d4]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-0bc314d4]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-0bc314d4]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-0bc314d4]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-0bc314d4]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-0bc314d4]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-0bc314d4]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-0bc314d4]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-0bc314d4]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-0bc314d4]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-0bc314d4]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-0bc314d4]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-0bc314d4]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-0bc314d4]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-0bc314d4]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-0bc314d4]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-0bc314d4]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-0bc314d4]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-0bc314d4]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-0bc314d4]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-0bc314d4]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-0bc314d4]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-0bc314d4]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-0bc314d4]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-0bc314d4]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-0bc314d4]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-0bc314d4]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-0bc314d4]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-0bc314d4]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-0bc314d4]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-0bc314d4]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-0bc314d4]{--color-dark:#63757e;--color-light:#c8d2d7}.vc-mobile-wizard-progress[data-v-0bc314d4]{padding:var(--size-value4);background-color:var(--neutral-lighten-3);width:100%;max-height:84px}.vc-mobile-wizard-progress .titles-container[data-v-0bc314d4]{margin:var(--size-value0) var(--size-value4)}.vc-mobile-wizard-progress .titles-container .current-step[data-v-0bc314d4]{font-weight:var(--font-weight-large2);font-size:var(--font-size-small2)}.vc-mobile-wizard-progress .titles-container .next-step[data-v-0bc314d4]{font-size:var(--font-size-x-small);color:var(--gray-darken-4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1D = "data-v-0bc314d4";
/* module identifier */

const __vue_module_identifier__$1D = undefined;
/* functional template */

const __vue_is_functional_template__$1D = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1y,
  staticRenderFns: __vue_staticRenderFns__$1y
}, __vue_inject_styles__$1D, __vue_script__$1D, __vue_scope_id__$1D, __vue_is_functional_template__$1D, __vue_module_identifier__$1D, false, createInjector, undefined, undefined);

var VcMobileWizardProgress = __vue_component__$2u;

var script$1C = {
  name: 'VcCheckbox',
  components: {
    VcIcon,
    VcAvatar,
    VcTooltip,
    VCheckbox: VCheckbox
  },
  props: {
    label: {
      type: String,
      required: false
    },
    tooltip: {
      type: String,
      required: false
    },
    avatar: {
      type: Object,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    checked: {
      type: [Boolean, Array],
      default: false
    },
    value: {
      type: [String, Boolean, Number],
      default: false
    },
    showAvatarBorder: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    isSingleLine: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcCheckbox'
    }
  },

  data() {
    return {
      labelEl: null,
      labelElScrollWidth: 0,
      labelElClientWidth: 0,
      resizeObserver: null
    };
  },

  computed: {
    selected: {
      get() {
        return this.checked;
      },

      set(val) {
        this.$emit('change', val);
      }

    },

    showTruncateTooltip() {
      return this.isSingleLine && this.labelElScrollWidth > this.labelElClientWidth;
    }

  },

  async mounted() {
    if (this.isSingleLine) {
      await this.$nextTick();
      this.labelEl = this.$refs.labelEl;
      this.resizeObserver = new ResizeObserver(this.measureSize);
      this.resizeObserver.observe(this.labelEl);
    }
  },

  destroyed() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },

  methods: {
    measureSize() {
      if (this.labelEl) {
        var _this$labelEl, _this$labelEl2;

        this.labelElScrollWidth = (_this$labelEl = this.labelEl) === null || _this$labelEl === void 0 ? void 0 : _this$labelEl.scrollWidth;
        this.labelElClientWidth = (_this$labelEl2 = this.labelEl) === null || _this$labelEl2 === void 0 ? void 0 : _this$labelEl2.clientWidth;
      }
    }

  }
};

/* script */
const __vue_script__$1C = script$1C;
/* template */

var __vue_render__$1x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-checkbox', {
    staticClass: "vc-checkbox d-flex align-center",
    attrs: {
      "hide-details": "true",
      "disabled": _vm.disabled,
      "ripple": false,
      "on-icon": _vm.indeterminate ? '$indeterminate' : 'check',
      "off-icon": "",
      "indeterminate-icon": "$indeterminate",
      "indeterminate": _vm.indeterminate,
      "color": "white",
      "label": _vm.label,
      "value": _vm.value,
      "error": _vm.error,
      "rules": _vm.rules,
      "data-qa": _vm.dataQa
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex align-center ms-2",
          class: {
            'single-line': _vm.isSingleLine
          }
        }, [_vm.avatar && _vm.label ? _c('VcAvatar', {
          staticClass: "ms-1 me-3",
          class: {
            'single-line__avatar': _vm.isSingleLine
          },
          attrs: {
            "image-path": _vm.avatar.path,
            "name": _vm.avatar.name,
            "color-id": _vm.avatar.colorId,
            "disabled": _vm.disabled,
            "show-border": _vm.showAvatarBorder,
            "size": "x-sm"
          }
        }) : _vm._e(), _vm._v(" "), _vm._t("label", function () {
          return [_vm.label ? _c('VcTooltip', {
            attrs: {
              "data-qa": "label-tooltip",
              "content": _vm.label,
              "dark": "",
              "disabled": !_vm.showTruncateTooltip
            }
          }, [_c('span', {
            ref: "labelEl",
            staticClass: "checkbox-label",
            class: {
              'single-line__label': _vm.isSingleLine
            }
          }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e()];
        }), _vm._v(" "), _vm._t("tooltip", function () {
          return [_vm.label && _vm.tooltip ? _c('VcTooltip', {
            attrs: {
              "dark": "",
              "content": _vm.tooltip,
              "bottom": ""
            }
          }, [_c('VcIcon', {
            staticClass: "tooltip-icon ms-2",
            attrs: {
              "size": "16"
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
              }
            }
          }, [_vm._v(" $info ")])], 1) : _vm._e()];
        })], 2)];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  });
};

var __vue_staticRenderFns__$1x = [];
/* style */

const __vue_inject_styles__$1C = function (inject) {
  if (!inject) return;
  inject("data-v-6776354a_0", {
    source: ".vc-checkbox[data-v-6776354a]{font-family:var(--primary-font-family);text-align:unset}.vc-checkbox[data-v-6776354a] .v-input__slot .v-input--selection-controls__input{width:var(--size-value4);height:var(--size-value4);margin-inline-end:0}.vc-checkbox[data-v-6776354a] .v-input__slot .v-input--selection-controls__input .v-icon{color:transparent;border:1px solid rgba(0,0,0,.2);box-sizing:border-box;border-radius:2px;font-size:var(--font-size-small);font-weight:700;z-index:1;background-color:#fff}.vc-checkbox[data-v-6776354a] .v-input__slot .v-label{overflow-x:hidden}.vc-checkbox[data-v-6776354a] .v-input__slot .v-label .single-line{overflow-x:hidden}.vc-checkbox[data-v-6776354a] .v-input__slot .v-label .single-line__avatar{flex:none}.vc-checkbox[data-v-6776354a] .v-input__slot .v-label .single-line span{overflow-x:hidden}.vc-checkbox[data-v-6776354a] .v-input__slot .v-label .single-line span .vc-tooltip__activator{display:flex}.vc-checkbox[data-v-6776354a] .v-input__slot .v-label .single-line span .vc-tooltip__activator .single-line__label{text-wrap:nowrap;text-overflow:ellipsis}.vc-checkbox[data-v-6776354a] .checkbox-label{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small)}.vc-checkbox[data-v-6776354a] .checkbox-label.inline-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.vc-checkbox[data-v-6776354a]:not(.v-input--is-disabled) .checkbox-label{color:var(--gray-darken-5)}.vc-checkbox[data-v-6776354a] .tooltip-icon{color:var(--gray-darken-3)}.vc-checkbox[data-v-6776354a] .avatar-wrapper .avatar-initials{font-size:var(--font-size-xxx-small);font-weight:var(--font-weight-medium2)}.vc-checkbox[data-v-6776354a].v-input--indeterminate:not(.v-input--is-disabled,.error--text) .v-input--selection-controls__input .v-icon{background-color:var(--green);color:#fff}.vc-checkbox[data-v-6776354a].v-input--is-label-active:not(.v-input--is-disabled,.error--text) .v-input--selection-controls__input .v-icon{background-color:var(--green);color:#fff;border:none}.vc-checkbox[data-v-6776354a]:not(.v-input--is-disabled):hover:not(:active) .v-input--selection-controls__input .v-icon{background-color:var(--gray-lighten-3)}.vc-checkbox[data-v-6776354a].v-input--indeterminate:not(.v-input--is-disabled,.error--text):hover .v-input--selection-controls__input .v-icon,.vc-checkbox[data-v-6776354a].v-input--is-label-active:not(.v-input--is-disabled,.error--text):hover .v-input--selection-controls__input .v-icon{background-color:rgba(84,210,140,.76)}.vc-checkbox[data-v-6776354a].v-input--indeterminate:not(.v-input--is-disabled,.error--text):active .v-input--selection-controls__input .v-icon,.vc-checkbox[data-v-6776354a].v-input--is-label-active:not(.v-input--is-disabled,.error--text):active .v-input--selection-controls__input .v-icon{background-color:rgba(84,210,140,.5)}.vc-checkbox[data-v-6776354a]:not(.v-input--is-label-active):not(.v-input--indeterminate):not(.v-input--is-disabled):active .v-input--selection-controls__input .v-icon{background:var(--gray-lighten-1)}.vc-checkbox[data-v-6776354a]:not(.v-input--is-disabled):focus .v-input--selection-controls__input .v-icon{box-shadow:0 0 0 3px var(--v-secondary-lighten1)}.vc-checkbox[data-v-6776354a].v-input--is-disabled .v-input--selection-controls__input .v-icon{background:var(--gray-lighten-2)}.vc-checkbox[data-v-6776354a].v-input--is-disabled.v-input--is-label-active .v-input--selection-controls__input .v-icon{border:none}.vc-checkbox[data-v-6776354a].v-input--is-disabled.v-input--is-label-active .v-input--selection-controls__input .v-icon:is(.error--text){color:var(--gray-darken-2)!important}.vc-checkbox[data-v-6776354a].error--text:not(.v-input--is-disabled) .v-input--selection-controls__input .v-icon{border-color:currentColor}.vc-checkbox[data-v-6776354a].v-input--has-state.error--text .v-label{animation:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1C = "data-v-6776354a";
/* module identifier */

const __vue_module_identifier__$1C = undefined;
/* functional template */

const __vue_is_functional_template__$1C = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1x,
  staticRenderFns: __vue_staticRenderFns__$1x
}, __vue_inject_styles__$1C, __vue_script__$1C, __vue_scope_id__$1C, __vue_is_functional_template__$1C, __vue_module_identifier__$1C, false, createInjector, undefined, undefined);

var VcCheckbox = __vue_component__$2t;

var script$1B = {
  name: 'VcChecklistItem',
  components: {
    VcLayout,
    VcCheckbox,
    VcTooltip
  },
  model: {
    prop: 'checked'
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    avatar: {
      type: Object,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipContent: {
      type: String,
      default: ''
    },
    dataQa: {
      type: String,
      default: 'VcChecklistItem'
    }
  },
  computed: {
    getAvatar() {
      if (this.avatar && Object.keys(this.avatar).length) {
        return {
          name: this.label,
          ...this.avatar
        };
      }

      return undefined;
    }

  },
  methods: {
    onChange(val) {
      this.$emit('change', {
        checked: val
      });
    }

  }
};

/* script */
const __vue_script__$1B = script$1B;
/* template */

var __vue_render__$1w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcTooltip', {
    staticClass: "VcChecklistItem-wrapper",
    attrs: {
      "content": _vm.tooltipContent,
      "disabled": !_vm.tooltipContent || !_vm.disabled,
      "dark": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('VcLayout', {
          staticClass: "VcChecklistItem",
          class: {
            disabled: _vm.disabled
          },
          attrs: {
            "data-qa": _vm.dataQa
          }
        }, [_c('VcCheckbox', {
          attrs: {
            "avatar": _vm.getAvatar,
            "checked": _vm.checked,
            "data-qa": _vm.dataQa + "-checkbox",
            "disabled": _vm.disabled,
            "label": _vm.label,
            "show-avatar-border": false
          },
          on: {
            "change": _vm.onChange
          }
        })], 1)];
      },
      proxy: true
    }])
  });
};

var __vue_staticRenderFns__$1w = [];
/* style */

const __vue_inject_styles__$1B = function (inject) {
  if (!inject) return;
  inject("data-v-7bbed29e_0", {
    source: ".VcChecklistItem-wrapper[data-v-7bbed29e]{width:100%}.VcChecklistItem-wrapper[hide=true][data-v-7bbed29e]{display:none}.VcChecklistItem-wrapper .VcChecklistItem.disabled[data-v-7bbed29e]{background-color:var(--gray-lighten-3)}.VcChecklistItem-wrapper .VcChecklistItem .vc-checkbox[data-v-7bbed29e]{flex:1 1 auto;padding:var(--size-value0);margin:var(--size-value0)}.VcChecklistItem-wrapper .VcChecklistItem .vc-checkbox[data-v-7bbed29e]  .v-input__control .v-input__slot{padding:var(--size-value2) var(--size-value4)}.VcChecklistItem-wrapper .VcChecklistItem[data-v-7bbed29e]:hover{background-color:var(--gray-lighten-3)}.VcChecklistItem-wrapper .VcChecklistItem[data-v-7bbed29e]:focus{box-shadow:0 0 0 2px var(--v-secondary-lighten1)}.VcChecklistItem-wrapper .VcChecklistItem[data-v-7bbed29e]:active{background-color:var(--v-secondary-lighten3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1B = "data-v-7bbed29e";
/* module identifier */

const __vue_module_identifier__$1B = undefined;
/* functional template */

const __vue_is_functional_template__$1B = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1w,
  staticRenderFns: __vue_staticRenderFns__$1w
}, __vue_inject_styles__$1B, __vue_script__$1B, __vue_scope_id__$1B, __vue_is_functional_template__$1B, __vue_module_identifier__$1B, false, createInjector, undefined, undefined);

var VcChecklistItem = __vue_component__$2s;

var script$1A = {
  name: 'VcTextField',
  components: {
    VcIconWithTooltip,
    VTextField: VTextField
  },
  props: {
    type: {
      type: String,
      default: 'text',
      validator: prop => ['text', 'number', 'search'].includes(prop)
    },
    dataQa: {
      type: String,
      default: 'vc-text-field'
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: ''
    },
    counter: {
      type: [Number, Boolean],
      default: false
    },
    maxlength: {
      type: Number,
      default: 100,
      validator: prop => prop > 0
    },
    rules: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
    // works only when hint prop is passed
    customHint: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    tooltipHeader: {
      type: String,
      default: ''
    },
    tooltipContent: {
      type: String,
      default: ''
    },
    tooltipNudgeLeft: {
      type: Number,
      default: 0
    },
    tooltipNudgeRight: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: ''
    },
    compactPrefix: {
      type: Boolean,
      default: false
    },
    disabledTextPrefix: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: String,
      default: ''
    },
    hideDetails: {
      type: [Boolean, String],
      default: 'auto'
    },
    persistentHint: {
      type: Boolean,
      default: true
    },
    singleLine: {
      type: Boolean,
      default: false
    },
    googleAddressAutoComplete: {
      type: Boolean,
      default: false
    },
    googleAddressCountryOptions: {
      type: Array,
      default: () => []
    },
    appendIcon: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      required: false
    },
    max: {
      type: Number,
      required: false
    },
    size: {
      type: String,
      default: 'large',
      validator: value => ['large', 'medium'].includes(value)
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    if (this.googleAddressAutoComplete) {
      var _window$google;

      const googleAddressScriptId = 'googleAddressScript';
      const existingScript = document.getElementById(googleAddressScriptId);
      const autoCompleteClass = (_window$google = window.google) === null || _window$google === void 0 ? void 0 : _window$google.maps.places.Autocomplete; // Script loading completed

      if (existingScript && autoCompleteClass) {
        this.initAutoComplete();
      } else {
        let googleAutocompleteScript = existingScript;

        if (!googleAutocompleteScript) {
          googleAutocompleteScript = document.createElement('script');
          googleAutocompleteScript.setAttribute('id', googleAddressScriptId);
          googleAutocompleteScript.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${this.$ds.googleAppKey}&channel=1&libraries=places`);
        }

        googleAutocompleteScript.addEventListener('load', this.initAutoComplete);
        document.body.appendChild(googleAutocompleteScript);
      }
    }
  },

  methods: {
    initAutoComplete() {
      let options = {
        fields: ['name', 'address_component'],
        types: ['address']
      };

      if (this.googleAddressCountryOptions.length > 0) {
        options['componentRestrictions'] = {
          country: this.googleAddressCountryOptions
        };
      }

      const input = this.$children[0].$el.getElementsByClassName('v-text-field__slot')[0].getElementsByTagName('input')[0]; // this deny google default placeholder to be added, and doesn't overrides placeholder prop.

      input.placeholder = '';
      this.autocomplete = new window.google.maps.places.Autocomplete(input, options);
      this.autocomplete.addListener('place_changed', this.emitGoogleSelectedPlace);
    },

    emitGoogleSelectedPlace() {
      let googlePlace = this.autocomplete.getPlace();
      let selectedPlace = {};
      selectedPlace['address'] = googlePlace.name;

      for (const component of googlePlace.address_components) {
        const componentType = component.types[0];

        switch (componentType) {
          case 'postal_code':
            {
              selectedPlace['postcode'] = component.long_name;
              break;
            }

          case 'administrative_area_level_1':
            {
              selectedPlace['state'] = component.long_name;
              selectedPlace['stateCode'] = component.short_name;
              break;
            }

          case 'country':
            selectedPlace['country'] = component.long_name;
            selectedPlace['countryCode'] = component.short_name;
            break;

          case 'locality':
            selectedPlace['city'] = component.long_name;
            break;

          case 'sublocality_level_1':
            if (!selectedPlace['city']) {
              selectedPlace['city'] = component.long_name;
            }

            break;
        }
      }

      this.$emit('onPlaceSelected', { ...selectedPlace,
        googlePlace
      });
    },

    onKeydownEnter(event) {
      event.preventDefault();
      this.$emit('onKeydownEnter');
    },

    onBlur(event) {
      this.$emit('onValidation', {
        value: this.value,
        isValid: this.$refs.textField.validationState !== 'error'
      });
      this.$emit('blur', event);
    }

  }
};

/* script */
const __vue_script__$1A = script$1A;
/* template */

var __vue_render__$1v = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-text-field', {
    ref: "textField",
    staticClass: "VcTextInput",
    class: (_obj = {
      'no-label': !_vm.label
    }, _obj[_vm.size] = true, _obj['compact-prefix'] = _vm.compactPrefix, _obj['disabled-text-prefix'] = _vm.disabledTextPrefix, _obj),
    attrs: {
      "dense": "",
      "clearable": _vm.clearable,
      "clear-icon": "$close_button",
      "data-qa": _vm.dataQa,
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "rules": _vm.rules,
      "disabled": _vm.disabled,
      "type": _vm.type,
      "error": _vm.counter && !!_vm.maxlength && _vm.value.length > _vm.maxlength,
      "error-messages": _vm.errorMessages,
      "value": _vm.value,
      "hint": _vm.hint,
      "append-icon": _vm.appendIcon,
      "counter": _vm.counter,
      "maxlength": _vm.maxlength,
      "prefix": _vm.prefix,
      "persistent-hint": _vm.persistentHint,
      "single-line": _vm.singleLine,
      "hide-details": _vm.hideDetails,
      "readonly": _vm.readonly,
      "autofocus": _vm.autofocus,
      "min": _vm.min,
      "max": _vm.max
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      },
      "focus": function ($event) {
        return _vm.$emit('focus');
      },
      "blur": _vm.onBlur,
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.onKeydownEnter.apply(null, arguments);
      }, function ($event) {
        return _vm.$emit('keydown', $event);
      }],
      "input": function (data) {
        return _vm.$emit('input', data);
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_vm._t("prepend-inner")];
      },
      proxy: true
    }, {
      key: "append",
      fn: function () {
        return [_vm._t("append", function () {
          return [_vm.tooltipContent ? _c('VcIconWithTooltip', {
            attrs: {
              "header": _vm.tooltipHeader,
              "content": _vm.tooltipContent,
              "nudge-left": _vm.tooltipNudgeLeft,
              "nudge-right": _vm.tooltipNudgeRight,
              "size": 15,
              "icon": 'question'
            }
          }) : _vm._e()];
        })];
      },
      proxy: true
    }, {
      key: "message",
      fn: function () {
        return [_vm.customHint ? _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.customHint)
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$1v = [];
/* style */

const __vue_inject_styles__$1A = function (inject) {
  if (!inject) return;
  inject("data-v-497a519a_0", {
    source: ".VcTextInput.v-text-field[data-v-497a519a].large .v-input__slot label{font-size:var(--font-size-small2)}.VcTextInput.v-text-field[data-v-497a519a].large .v-input__slot input{font-size:var(--font-size-small2)}.VcTextInput.v-text-field[data-v-497a519a].large .v-input__slot .v-text-field__prefix{font-size:var(--font-size-small2)}.VcTextInput.v-text-field[data-v-497a519a].large.error--text .v-input__slot{font-size:var(--font-size-xx-small)}.VcTextInput.v-text-field[data-v-497a519a].large.v-input--is-focused label,.VcTextInput.v-text-field[data-v-497a519a].large.v-input--is-label-active label{font-size:var(--font-size-small)}.VcTextInput.v-text-field[data-v-497a519a].medium .v-input__slot label{font-size:var(--font-size-x-small)}.VcTextInput.v-text-field[data-v-497a519a].medium .v-input__slot input{font-size:var(--font-size-x-small)}.VcTextInput.v-text-field[data-v-497a519a].medium.error--text .v-input__slot{font-size:var(--font-size-xx-small)}.VcTextInput.v-text-field[data-v-497a519a].medium.v-input--is-focused label,.VcTextInput.v-text-field[data-v-497a519a].medium.v-input--is-label-active label{font-size:var(--font-size-small)}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot{padding:0 var(--size-value3);height:var(--size-value13);background:#fff;border:1px solid var(--gray-lighten-1);box-sizing:border-box;border-radius:6px}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot label{line-height:var(--size-value5);color:var(--gray-darken-3);font-weight:var(--font-weight-medium)}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot .v-text-field__prefix{color:var(--gray-darken-5)}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot input{font-weight:var(--font-weight-medium2);line-height:var(--size-value5);color:var(--gray-darken-5);caret-color:var(--gray-darken-3)}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot input::placeholder{font-weight:var(--font-weight-medium)}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot:after,.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot:before{display:none}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot:hover{border-color:var(--gray-darken-3)}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot:active,.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot:focus,.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot:focus-within{border:1px solid var(--v-secondary-base);box-shadow:0 0 0 3px var(--v-secondary-lighten1)}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot:active input,.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot:focus input,.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot:focus-within input{color:var(--gray-darken-3)}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot .v-input__prepend-inner{padding-inline-end:var(--size-value3);align-self:center}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot .v-input__icon .v-icon{margin:var(--size-value0)!important}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot .v-input__icon .v-icon__component{height:var(--size-value3);width:var(--size-value3);line-height:0}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot .v-input__icon .v-icon__component .vc-chevron-right{fill:var(--gray-darken-2)}.VcTextInput.v-text-field[data-v-497a519a] .v-input__slot .v-input__icon--clear .v-icon{width:var(--size-value2);padding-top:var(--size-value1)}.VcTextInput.v-text-field[data-v-497a519a].error--text .v-input__slot{border-color:var(--red);color:unset;box-shadow:unset;line-height:var(--size-value4)}.VcTextInput.v-text-field[data-v-497a519a].v-input--is-focused label,.VcTextInput.v-text-field[data-v-497a519a].v-input--is-label-active label{line-height:14px;height:var(--size-value4);letter-spacing:-.3px;color:var(--gray-darken-4)!important;transform:translateY(-100%) scale(.85);top:var(--size-value2)}.VcTextInput.v-text-field[data-v-497a519a].v-input--is-focused .v-text-field__slot,.VcTextInput.v-text-field[data-v-497a519a].v-input--is-label-active .v-text-field__slot{margin-bottom:-14px}.VcTextInput.v-text-field[data-v-497a519a].v-input--is-focused.no-label .v-text-field__slot,.VcTextInput.v-text-field[data-v-497a519a].v-input--is-label-active.no-label .v-text-field__slot{margin-bottom:unset}.VcTextInput.v-text-field[data-v-497a519a].v-input--is-disabled .v-input__slot{background:var(--gray-lighten-3);border:1px solid var(--gray-lighten-1)}.VcTextInput.v-text-field[data-v-497a519a].v-input--is-disabled .v-input__slot input,.VcTextInput.v-text-field[data-v-497a519a].v-input--is-disabled .v-input__slot label{color:var(--gray-darken-2)}.VcTextInput.v-text-field[data-v-497a519a]:not(.v-input--is-label-active):not(.v-input--is-focused) input{padding:var(--size-value2) 0}.VcTextInput.v-text-field[data-v-497a519a] .v-messages__message{line-height:var(--size-value4)}.VcTextInput.v-text-field[data-v-497a519a] .v-input__append-inner{align-self:center;fill:var(--gray-darken-3)}.VcTextInput.v-text-field[data-v-497a519a] .v-input__append-inner .v-input__icon--append{min-width:var(--size-value5);width:var(--size-value5)}.VcTextInput.v-text-field[data-v-497a519a].v-input--dense:not(.v-text-field--outlined) input{padding-block:var(--size-value2)}.VcTextInput.v-text-field[data-v-497a519a].v-input--is-readonly{cursor:pointer}.VcTextInput.v-text-field[data-v-497a519a].compact-prefix .v-input__slot .v-text-field__prefix{padding:0}.VcTextInput.v-text-field[data-v-497a519a].disabled-text-prefix .v-input__slot .v-text-field__prefix{font-weight:var(--font-weight-medium2);color:var(--gray-darken-2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1A = "data-v-497a519a";
/* module identifier */

const __vue_module_identifier__$1A = undefined;
/* functional template */

const __vue_is_functional_template__$1A = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1v,
  staticRenderFns: __vue_staticRenderFns__$1v
}, __vue_inject_styles__$1A, __vue_script__$1A, __vue_scope_id__$1A, __vue_is_functional_template__$1A, __vue_module_identifier__$1A, false, createInjector, undefined, undefined);

var VcTextField = __vue_component__$2r;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

function commonjsRequire (target) {
	throw new Error('Could not dynamically require "' + target + '". Please configure the dynamicRequireTargets option of @rollup/plugin-commonjs appropriately for this require call to behave properly.');
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$1(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_throttle = throttle$1;

var script$1z = {
  name: 'VcSearchBar',
  components: {
    VcTextField,
    VcIcon
  },
  props: {
    size: {
      type: String,
      default: 'large',
      validator: size => ['small', 'medium', 'large'].includes(size)
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    value: {
      type: String,
      default: ''
    },
    caseSensitive: {
      type: Boolean,
      default: false
    },

    /**
     * By default, the user input is throttled so that the search event is emitted after the user hasn't typed anything for a certain time.
     * To cancel this behavior, pass 0 (zero) in this prop.
     */
    throttleTime: {
      type: Number,
      default: 500,
      validator: throttleTime => throttleTime > 0
    },
    borderTopRadius: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-search-bar'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      searchThrottled: lodash_throttle(search => {
        this.$emit('search', this.caseSensitive || !search ? search : search.toLowerCase());
      }, this.throttleTime, {
        leading: false
      })
    };
  },

  computed: {
    getLabel() {
      return this.label || this.$dst('ds.search_bar.label');
    },

    getPlaceholder() {
      return this.placeholder || this.$dst('ds.search_bar.label');
    },

    getClasses() {
      return `${this.size}${this.borderTopRadius ? ' border-top-radius' : ''}`;
    }

  }
};

/* script */
const __vue_script__$1z = script$1z;
/* template */

var __vue_render__$1u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcTextField', {
    class: "vc-search-bar " + _vm.getClasses,
    attrs: {
      "data-qa": _vm.dataQa,
      "label": _vm.getLabel,
      "clearable": _vm.clearable,
      "persistent-hint": false,
      "placeholder": _vm.getPlaceholder,
      "value": _vm.value,
      "hide-details": "",
      "single-line": "",
      "type": "search",
      "size": _vm.size === 'small' ? 'medium' : _vm.size,
      "autofocus": _vm.autofocus
    },
    on: {
      "input": _vm.searchThrottled
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c('VcIcon', {
          staticClass: "vc-search-bar__magnify",
          attrs: {
            "small": ['medium', 'large'].includes(_vm.size),
            "x-small": _vm.size === 'small'
          }
        }, [_vm._v("\n      $magnify_glass\n    ")])];
      },
      proxy: true
    }])
  });
};

var __vue_staticRenderFns__$1u = [];
/* style */

const __vue_inject_styles__$1z = function (inject) {
  if (!inject) return;
  inject("data-v-2399110e_0", {
    source: ".vc-search-bar.VcTextInput[data-v-2399110e]{padding:var(--size-value0);margin:var(--size-value0)}.vc-search-bar.VcTextInput.border-top-radius[data-v-2399110e]  .v-input__control .v-input__slot{border-radius:var(--border-radius) var(--border-radius) var(--size-value0) var(--size-value0)}.vc-search-bar.VcTextInput.v-input--has-state[data-v-2399110e]  .v-input__slot .v-text-field__slot,.vc-search-bar.VcTextInput.v-input--is-focused[data-v-2399110e]  .v-input__slot .v-text-field__slot,.vc-search-bar.VcTextInput.v-input--is-label-active[data-v-2399110e]  .v-input__slot .v-text-field__slot{margin:0}.vc-search-bar.VcTextInput__magnify[data-v-2399110e]{fill:var(--gray-darken-2)}.vc-search-bar.VcTextInput[data-v-2399110e]:hover{border-color:var(--gray-darken-2)}.vc-search-bar.VcTextInput[data-v-2399110e]:hover  .v-input__slot label{color:var(--gray-darken-2)}.vc-search-bar.VcTextInput.medium[data-v-2399110e]  .v-input__control .v-input__slot{height:var(--size-value10)}.vc-search-bar.VcTextInput.medium[data-v-2399110e]  .v-input__control .v-input__slot .v-input__prepend-inner{padding:var(--size-value3)}.vc-search-bar.VcTextInput.small[data-v-2399110e]  .v-input__control .v-input__slot{height:var(--size-value8)}.vc-search-bar.VcTextInput.small[data-v-2399110e]  .v-input__control .v-input__slot .v-input__prepend-inner{padding:var(--size-value3)}.vc-search-bar.VcTextInput[data-v-2399110e]  .v-input__control .v-input__slot{padding:var(--size-value0)}.vc-search-bar.VcTextInput[data-v-2399110e]  .v-input__control .v-input__slot .v-input__prepend-inner{padding:18px var(--size-value3);margin:var(--size-value0)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1z = "data-v-2399110e";
/* module identifier */

const __vue_module_identifier__$1z = undefined;
/* functional template */

const __vue_is_functional_template__$1z = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1u,
  staticRenderFns: __vue_staticRenderFns__$1u
}, __vue_inject_styles__$1z, __vue_script__$1z, __vue_scope_id__$1z, __vue_is_functional_template__$1z, __vue_module_identifier__$1z, false, createInjector, undefined, undefined);

var VcSearchBar = __vue_component__$2q;

var script$1y = {
  name: 'VcListbox',
  components: {
    VcLayout,
    VcSearchBar,
    VcChecklistItem,
    VcIcon,
    VcTooltip,
    VListItem: VListItem,
    VListItemGroup: VListItemGroup,
    VDivider: VDivider,
    VList: VList
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: items => items.every(item => item.label && item.identifier || item.identifier === 0)
    },
    addAnother: {
      type: Boolean,
      default: false
    },
    addSearch: {
      type: Boolean,
      default: false
    },
    searchLabel: {
      type: String
    },
    addAnotherLabel: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    emptyListMsg: {
      type: String
    },
    dataQa: {
      type: String,
      default: 'VcListbox'
    }
  },
  data: () => ({
    search: ''
  }),
  computed: {
    getAddAnotherLabel() {
      return this.addAnotherLabel || this.$dst('ds.listbox.add');
    },

    confirmedArray() {
      return this.filteredItems.filter(item => item.checked);
    },

    filteredItems() {
      return this.items.map(item => ({ ...item,
        hide: !item.label.toLowerCase().includes(this.search)
      }));
    },

    listExist() {
      return this.filteredItems.some(item => !item.hide);
    },

    noItemsMsg() {
      return this.emptyListMsg || this.$dst('ds.listbox.empty_list');
    }

  },
  methods: {
    onSelection(selections) {
      const newSelections = selections.map(selected => ({ ...selected,
        checked: true
      }));
      this.$emit('change', newSelections);
    },

    onSearch(search) {
      this.search = search;
    },

    setDataQa(label) {
      return label.replace(/ /g, '-');
    }

  }
};

/* script */
const __vue_script__$1y = script$1y;
/* template */

var __vue_render__$1t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.title ? _c('div', {
    staticClass: "vc-list-title",
    attrs: {
      "data-qa": _vm.dataQa + "-title"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "VcListbox",
    class: {
      'with-search': _vm.addSearch,
      'with-add-another': _vm.addAnother
    },
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm.addSearch ? _c('VcSearchBar', {
    attrs: {
      "label": _vm.searchLabel,
      "data-qa": _vm.dataQa + "-search",
      "border-top-radius": ""
    },
    on: {
      "search": _vm.onSearch
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vc-overflow"
  }, [_vm.listExist ? _c('v-list-item-group', {
    attrs: {
      "value": _vm.confirmedArray,
      "multiple": ""
    },
    on: {
      "change": _vm.onSelection
    }
  }, _vm._l(_vm.filteredItems, function (item) {
    return _c('VcTooltip', {
      key: item.identifier,
      attrs: {
        "content": item.tooltipContent,
        "data-qa": _vm.dataQa + "-" + _vm.setDataQa(item.label) + "-tooltip",
        "disabled": !item.tooltipContent || !item.disabled,
        "dark": ""
      }
    }, [_c('v-list-item', {
      staticClass: "vc-list-item",
      attrs: {
        "disabled": item.disabled,
        "tabindex": item.label + "-" + item.identifier,
        "value": item
      }
    }, [_c('VcChecklistItem', _vm._b({
      attrs: {
        "data-qa": _vm.dataQa + "-" + _vm.setDataQa(item.label)
      }
    }, 'VcChecklistItem', item, false))], 1)], 1);
  }), 1) : _c('VcLayout', {
    staticClass: "VcListbox__empty",
    attrs: {
      "data-qa": _vm.dataQa + "-empty",
      "align-center": "",
      "justify-center": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.noItemsMsg) + "\n      ")])], 1), _vm._v(" "), _vm.addAnother ? _c('div', {
    attrs: {
      "data-qa": _vm.dataQa + "-increase"
    }
  }, [_c('v-divider', {
    staticClass: "divider"
  }), _vm._v(" "), _c('v-list-item', {
    staticClass: "last-item",
    attrs: {
      "align-baseline": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('addNew');
      }
    }
  }, [_c('VcIcon', {
    staticClass: "add-another-icon",
    attrs: {
      "dense": ""
    }
  }, [_vm._v(" $plus ")]), _vm._v(" "), _c('span', {
    staticClass: "add-another-label"
  }, [_vm._v(_vm._s(_vm.getAddAnotherLabel))])], 1)], 1) : _vm._e()], 1)], 1);
};

var __vue_staticRenderFns__$1t = [];
/* style */

const __vue_inject_styles__$1y = function (inject) {
  if (!inject) return;
  inject("data-v-02337bf6_0", {
    source: ".vc-list-title[data-v-02337bf6]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-small2);line-height:var(--size-value5);margin-block-end:var(--size-value3)}.VcListbox[data-v-02337bf6]{padding-block:var(--size-value1);margin-block:var(--size-value1);border:1px solid var(--gray-lighten-1);box-sizing:border-box;border-radius:var(--border-radius);box-shadow:none!important}.VcListbox.with-search[data-v-02337bf6]{border:none}.VcListbox.with-search .vc-overflow[data-v-02337bf6]{border-inline:var(--border-frame);border-block-end:var(--border-frame);border-radius:0 0 var(--border-radius) var(--border-radius)}.VcListbox.with-search.with-add-another .vc-overflow[data-v-02337bf6]{border-inline:var(--border-frame);border-block-end:unset;border-radius:unset}.VcListbox.with-search.with-add-another .last-item[data-v-02337bf6]{border-inline:var(--border-frame);border-block-end:var(--border-frame);border-radius:0 0 var(--border-radius) var(--border-radius)}.VcListbox .vc-overflow[data-v-02337bf6]{overflow:auto;height:160px}.VcListbox .vc-overflow .vc-list-item[data-v-02337bf6]{padding:var(--size-value0);min-height:unset}.VcListbox .vc-overflow .vc-list-item[data-v-02337bf6]:before{opacity:0}.VcListbox .divider[data-v-02337bf6]{border-color:var(--gray-lighten-1)}.VcListbox .last-item[data-v-02337bf6]{cursor:pointer;min-height:var(--size-value10);padding-block:var(--size-value1) var(--size-value2)}.VcListbox .last-item[data-v-02337bf6]:hover{background-color:var(--gray-lighten-3)}.VcListbox .last-item .add-another-label[data-v-02337bf6]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small);line-height:var(--size-value5);color:var(--gray-darken-5)}.VcListbox .last-item .add-another-icon[data-v-02337bf6]{margin-inline-end:var(--size-value3);cursor:pointer}.VcListbox .last-item .add-another-icon[data-v-02337bf6]  .v-icon__component{height:unset;width:unset}.VcListbox .last-item .add-another-icon[data-v-02337bf6]  .v-icon__component svg{width:var(--size-value3)}.VcListbox__empty[data-v-02337bf6]{height:100%;font-weight:var(--font-weight-medium2);font-size:var(--font-size-xx-small);color:var(--gray-darken-4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1y = "data-v-02337bf6";
/* module identifier */

const __vue_module_identifier__$1y = undefined;
/* functional template */

const __vue_is_functional_template__$1y = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1t,
  staticRenderFns: __vue_staticRenderFns__$1t
}, __vue_inject_styles__$1y, __vue_script__$1y, __vue_scope_id__$1y, __vue_is_functional_template__$1y, __vue_module_identifier__$1y, false, createInjector, undefined, undefined);

var __vue_component__$2p = __vue_component__$2o;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1x = {
  components: {
    VSheet: VSheet,
    VBottomSheet: VBottomSheet
  },

  name: 'VcBottomSheet',

  props: {
    /**
     * Opens and closes the bottom sheet display
     */
    value: {
      type: Boolean,
      default: false
    },

    /**
     * If true, the Bottom sheet won't close on "click outside"
     */
    persistent: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-bottom-sheet'
    }
  }
};

/* script */
const __vue_script__$1x = script$1x;
/* template */

var __vue_render__$1s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-bottom-sheet', {
    attrs: {
      "value": _vm.value,
      "persistent": _vm.persistent,
      "data-qa": _vm.dataQa,
      "content-class": "VcBottomSheet"
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (activatorObj) {
        return [_vm._t("activator", null, null, activatorObj)];
      }
    }], null, true)
  }, [_vm._v(" "), _c('v-sheet', {
    staticClass: "vc-sheet",
    attrs: {
      "data-qa": _vm.dataQa + "-sheet"
    }
  }, [_vm._t("default")], 2)], 1);
};

var __vue_staticRenderFns__$1s = [];
/* style */

const __vue_inject_styles__$1x = function (inject) {
  if (!inject) return;
  inject("data-v-1f861caa_0", {
    source: "[data-v-1f861caa]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-1f861caa]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-1f861caa]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-1f861caa]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-1f861caa]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-1f861caa]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-1f861caa]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-1f861caa]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-1f861caa]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-1f861caa]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-1f861caa]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-1f861caa]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-1f861caa]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-1f861caa]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-1f861caa]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-1f861caa]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-1f861caa]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-1f861caa]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-1f861caa]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-1f861caa]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-1f861caa]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-1f861caa]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-1f861caa]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-1f861caa]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-1f861caa]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-1f861caa]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-1f861caa]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-1f861caa]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-1f861caa]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-1f861caa]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-1f861caa]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-1f861caa]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-1f861caa]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-1f861caa]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-1f861caa]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-1f861caa]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-1f861caa]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-1f861caa]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-1f861caa]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-1f861caa]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-1f861caa]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-1f861caa]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-1f861caa]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-1f861caa]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-1f861caa]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-1f861caa]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-1f861caa]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-1f861caa]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-1f861caa]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-1f861caa]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-1f861caa]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-1f861caa]{--color-dark:#63757e;--color-light:#c8d2d7}.VcBottomSheet .vc-sheet[data-v-1f861caa]{max-height:92vh;border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;display:flex;box-shadow:var(--modal-box-shadow);overflow:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1x = "data-v-1f861caa";
/* module identifier */

const __vue_module_identifier__$1x = undefined;
/* functional template */

const __vue_is_functional_template__$1x = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1s,
  staticRenderFns: __vue_staticRenderFns__$1s
}, __vue_inject_styles__$1x, __vue_script__$1x, __vue_scope_id__$1x, __vue_is_functional_template__$1x, __vue_module_identifier__$1x, false, createInjector, undefined, undefined);

var VcBottomSheet = __vue_component__$2n;

var script$1w = {
  name: 'VcSwitch',
  components: {
    VcIcon,
    VSwitch: VSwitch
  },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      required: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    ripple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    labelPosition: {
      type: String,
      default: 'after',
      validator: prop => ['before', 'after'].includes(prop)
    }
  },
  methods: {
    onChange: function (value) {
      this.$emit('input', value);
    }
  }
};

/* script */
const __vue_script__$1w = script$1w;
/* template */

var __vue_render__$1r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "switchContainer",
    class: {
      'with-icon': _vm.icon
    }
  }, [_c('v-switch', {
    staticClass: "VcSwitch",
    class: {
      'is-active': _vm.value,
      'with-icon': _vm.icon,
      'pre-label': _vm.labelPosition === 'before'
    },
    attrs: {
      "inset": "",
      "hide-details": "",
      "label": _vm.label,
      "ripple": _vm.ripple,
      "input-value": _vm.value,
      "color": _vm.color,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.onChange
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._t("label")];
      },
      proxy: true
    }], null, true)
  }), _vm._v(" "), _vm.icon && _vm.value ? _c('VcIcon', {
    staticClass: "VcSwitchIcon VcSwitchIconV",
    attrs: {
      "color": _vm.color,
      "size": "10"
    }
  }, [_vm._v("\n    $check_button\n  ")]) : _vm._e(), _vm._v(" "), _vm.icon && !_vm.value ? _c('VcIcon', {
    staticClass: "VcSwitchIcon VcSwitchIconX",
    attrs: {
      "color": _vm.color,
      "size": "10"
    }
  }, [_vm._v("\n    $close_button\n  ")]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$1r = [];
/* style */

const __vue_inject_styles__$1w = function (inject) {
  if (!inject) return;
  inject("data-v-4f3914ec_0", {
    source: ".switchContainer .VcSwitch[data-v-4f3914ec]{padding:0;margin:0}.switchContainer .VcSwitch[data-v-4f3914ec]  label{font-size:var(--font-size-small);font-weight:var(--font-weight-medium);line-height:var(--size-value6);color:var(--neutral-lighten-1)}.switchContainer .VcSwitch[data-v-4f3914ec]  input{height:var(--size-value5)}.switchContainer .VcSwitch[data-v-4f3914ec]  .v-input--selection-controls__input{margin-left:0;margin-right:var(--size-value3);height:var(--size-value5);width:var(--size-value8)}#app[dir=rtl] .switchContainer .VcSwitch[data-v-4f3914ec]  .v-input--selection-controls__input{margin-left:var(--size-value3)}#app[dir=rtl] .switchContainer .VcSwitch[data-v-4f3914ec]  .v-input--selection-controls__input{margin-right:0}.switchContainer .VcSwitch[data-v-4f3914ec]  .v-input--switch__track{top:0;left:0}#app[dir=rtl] .switchContainer .VcSwitch[data-v-4f3914ec]  .v-input--switch__track{left:auto;right:0}.switchContainer .VcSwitch[data-v-4f3914ec]  .v-input--selection-controls__ripple{left:-10px;height:25px;width:25px}#app[dir=rtl] .switchContainer .VcSwitch[data-v-4f3914ec]  .v-input--selection-controls__ripple{left:auto;right:-10px}.switchContainer .VcSwitch[data-v-4f3914ec]  .v-input--switch__thumb{height:14px;width:14px;background-color:#fff;top:calc(50% - 7px);transform:translateX(3px)!important;box-shadow:var(--shadow-5)}#app[dir=rtl] .switchContainer .VcSwitch[data-v-4f3914ec]  .v-input--switch__thumb{transform:translateX(-3px)!important}.switchContainer .VcSwitch.v-input--is-disabled[data-v-4f3914ec] {opacity:1}.switchContainer .VcSwitch.v-input--is-disabled[data-v-4f3914ec]  .v-input--switch__track{color:var(--gray-lighten-2)!important}.switchContainer .VcSwitch.v-input--is-disabled[data-v-4f3914ec]  .v-input--switch__thumb{background-color:var(--gray)!important;box-shadow:none}.switchContainer .VcSwitch.is-active[data-v-4f3914ec]  .v-input--switch__track{opacity:1;background-color:currentColor}.switchContainer .VcSwitch.is-active[data-v-4f3914ec]  .v-input--selection-controls__ripple{transform:translateX(14px)!important}#app[dir=rtl] .switchContainer .VcSwitch.is-active[data-v-4f3914ec]  .v-input--selection-controls__ripple{transform:translateX(-14px)!important}.switchContainer .VcSwitch.is-active[data-v-4f3914ec]  .v-input--switch__thumb{transform:translateX(17px)!important}#app[dir=rtl] .switchContainer .VcSwitch.is-active[data-v-4f3914ec]  .v-input--switch__thumb{transform:translateX(-17px)!important}.switchContainer .VcSwitch.pre-label[data-v-4f3914ec]  label{order:-1;flex:unset;margin-inline-end:var(--size-value2)}.switchContainer .VcSwitch.pre-label[data-v-4f3914ec]  .v-input--selection-controls__input{margin:unset!important}.switchContainer .VcSwitch.with-icon[data-v-4f3914ec]  input{height:var(--size-value6)}.switchContainer .VcSwitch.with-icon[data-v-4f3914ec]  .v-input--selection-controls__input{margin-left:0;margin-right:var(--size-value3);height:var(--size-value6);width:var(--size-value12)}#app[dir=rtl] .switchContainer .VcSwitch.with-icon[data-v-4f3914ec]  .v-input--selection-controls__input{margin-left:var(--size-value3)}#app[dir=rtl] .switchContainer .VcSwitch.with-icon[data-v-4f3914ec]  .v-input--selection-controls__input{margin-right:0}.switchContainer .VcSwitch.with-icon[data-v-4f3914ec]  .v-input--switch__track{top:0;left:0;height:var(--size-value6);width:var(--size-value12)}#app[dir=rtl] .switchContainer .VcSwitch.with-icon[data-v-4f3914ec]  .v-input--switch__track{left:auto;right:0}.switchContainer .VcSwitch.with-icon[data-v-4f3914ec]  .v-input--selection-controls__ripple{left:-9px;height:29px;width:29px;top:calc(50% - 21.5px)}#app[dir=rtl] .switchContainer .VcSwitch.with-icon[data-v-4f3914ec]  .v-input--selection-controls__ripple{left:auto;right:-9px}.switchContainer .VcSwitch.with-icon[data-v-4f3914ec]  .v-input--switch__thumb{height:18px;width:18px;top:calc(50% - 9px);transform:translateX(3.5px)!important}#app[dir=rtl] .switchContainer .VcSwitch.with-icon[data-v-4f3914ec]  .v-input--switch__thumb{transform:translateX(-3.5px)!important}.switchContainer .VcSwitch.with-icon.v-input--is-disabled[data-v-4f3914ec] {opacity:1}.switchContainer .VcSwitch.with-icon.v-input--is-disabled[data-v-4f3914ec]  .v-input--switch__track{color:var(--gray-lighten-2)!important}.switchContainer .VcSwitch.with-icon.v-input--is-disabled[data-v-4f3914ec]  .v-input--switch__thumb{background-color:var(--gray)!important;box-shadow:none}.switchContainer .VcSwitch.with-icon.v-input--is-disabled+.VcSwitchIcon[data-v-4f3914ec]{fill:var(--gray-lighten-2)!important}.switchContainer .VcSwitch.with-icon.is-active[data-v-4f3914ec]  .v-input--switch__track{opacity:1;background-color:currentColor}.switchContainer .VcSwitch.with-icon.is-active[data-v-4f3914ec]  .v-input--selection-controls__ripple{transform:translateX(23.5px)!important}#app[dir=rtl] .switchContainer .VcSwitch.with-icon.is-active[data-v-4f3914ec]  .v-input--selection-controls__ripple{transform:translateX(-23.5px)!important}.switchContainer .VcSwitch.with-icon.is-active[data-v-4f3914ec]  .v-input--switch__thumb{transform:translateX(26px)!important}#app[dir=rtl] .switchContainer .VcSwitch.with-icon.is-active[data-v-4f3914ec]  .v-input--switch__thumb{transform:translateX(-26px)!important}.switchContainer .VcSwitchIcon[data-v-4f3914ec]{cursor:pointer;pointer-events:none;margin:17px;left:-10px}.switchContainer .VcSwitchIconV[data-v-4f3914ec]{top:-33px;transform:translateX(23px);fill:var(--v-secondary-base)}.switchContainer .VcSwitchIconX[data-v-4f3914ec]{top:-34px;transform:translate(0,0);fill:var(--neutral-lighten-1)}.switchContainer.with-icon[data-v-4f3914ec]{height:var(--size-value6)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1w = "data-v-4f3914ec";
/* module identifier */

const __vue_module_identifier__$1w = undefined;
/* functional template */

const __vue_is_functional_template__$1w = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1r,
  staticRenderFns: __vue_staticRenderFns__$1r
}, __vue_inject_styles__$1w, __vue_script__$1w, __vue_scope_id__$1w, __vue_is_functional_template__$1w, __vue_module_identifier__$1w, false, createInjector, undefined, undefined);

var VcSwitch = __vue_component__$2m;

var script$1v = {
  name: 'VcInputBottomSheet',
  components: {
    VcBottomSheet,
    VcModalHeader,
    VcLayout,
    VcModalFooter,
    VcForm,
    VcSwitch
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    titleDescription: {
      type: String
    },
    okButtonLabel: {
      type: String
    },
    cancelButtonLabel: {
      type: String
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    footer: {
      type: Boolean,
      default: true
    },
    showHeaderDivider: {
      type: Boolean,
      default: true
    },
    showFooterDivider: {
      type: Boolean,
      default: true
    },
    persistent: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-bottom-sheet-input'
    },
    showHeaderToggle: {
      type: Boolean,
      default: false
    },
    toggleInitialValue: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      toggleValue: this.toggleInitialValue,
      validForm: true
    };
  },

  methods: {
    onOkClicked() {
      this.validate();
      this.$emit('onOkClicked', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    },

    validate() {
      this.$refs.mainForm.validate();
    },

    onMainFormValueChanged(value) {
      this.validForm = value;
      this.$emit('onValidationChanged', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    },

    onHeaderToggleChanged() {
      this.$emit('onDisabledChanged', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    }

  }
};

/* script */
const __vue_script__$1v = script$1v;
/* template */

var __vue_render__$1q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcBottomSheet', {
    attrs: {
      "value": _vm.value,
      "data-qa": _vm.dataQa,
      "persistent": _vm.persistent
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }, {
      key: "default",
      fn: function () {
        return [_c('VcLayout', {
          staticClass: "VcInputBottomSheet",
          attrs: {
            "column": ""
          }
        }, [!!_vm.title ? _c('VcModalHeader', {
          staticClass: "vc-bottom-sheet__header",
          class: {
            showDivider: _vm.showHeaderDivider
          },
          attrs: {
            "close-button": _vm.closeButton,
            "data-qa": _vm.dataQa + "-header",
            "show-back-button": false,
            "title": _vm.title,
            "description": _vm.titleDescription,
            "flavor": "input"
          },
          on: {
            "onCloseButtonClicked": function ($event) {
              return _vm.$emit('input', false);
            }
          },
          scopedSlots: _vm._u([{
            key: "headerImage",
            fn: function () {
              return [_vm.showHeaderToggle ? _c('VcSwitch', {
                attrs: {
                  "color": "secondary",
                  "data-qa": _vm.dataQa + "-switch"
                },
                on: {
                  "input": _vm.onHeaderToggleChanged
                },
                model: {
                  value: _vm.toggleValue,
                  callback: function ($$v) {
                    _vm.toggleValue = $$v;
                  },
                  expression: "toggleValue"
                }
              }) : _vm._e()];
            },
            proxy: true
          }], null, false, 4191315885)
        }) : _vm._e(), _vm._v(" "), _c('VcLayout', {
          staticClass: "vc-bottom-sheet__content",
          attrs: {
            "column": ""
          }
        }, [_c('VcForm', {
          ref: "mainForm",
          staticClass: "VcContent",
          attrs: {
            "value": _vm.validForm,
            "lazy-validation": ""
          },
          on: {
            "input": _vm.onMainFormValueChanged,
            "submit": function (data) {
              return _vm.$emit('submit', data);
            }
          }
        }, [_vm._t("default", null, {
          "disabled": !_vm.toggleValue
        })], 2)], 1), _vm._v(" "), _vm.footer ? _c('VcModalFooter', {
          staticClass: "vc-bottom-sheet__footer",
          class: {
            showDivider: _vm.showHeaderDivider
          },
          attrs: {
            "buttons": [{
              label: _vm.cancelButtonLabel || _vm.$dst('ds.modal.cancel'),
              event: 'onCancelClicked',
              color: 'white'
            }, {
              label: _vm.okButtonLabel || _vm.$dst('ds.modal.ok'),
              event: 'onOkClicked',
              color: 'secondary'
            }],
            "data-qa": _vm.dataQa + "-footer"
          },
          on: {
            "onCancelClicked": function ($event) {
              return _vm.$emit('onCancelClicked');
            },
            "onOkClicked": _vm.onOkClicked
          }
        }) : _vm._e()], 1)];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$1q = [];
/* style */

const __vue_inject_styles__$1v = function (inject) {
  if (!inject) return;
  inject("data-v-54df0682_0", {
    source: "[data-v-54df0682]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-54df0682]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-54df0682]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-54df0682]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-54df0682]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-54df0682]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-54df0682]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-54df0682]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-54df0682]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-54df0682]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-54df0682]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-54df0682]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-54df0682]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-54df0682]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-54df0682]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-54df0682]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-54df0682]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-54df0682]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-54df0682]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-54df0682]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-54df0682]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-54df0682]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-54df0682]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-54df0682]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-54df0682]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-54df0682]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-54df0682]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-54df0682]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-54df0682]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-54df0682]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-54df0682]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-54df0682]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-54df0682]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-54df0682]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-54df0682]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-54df0682]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-54df0682]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-54df0682]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-54df0682]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-54df0682]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-54df0682]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-54df0682]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-54df0682]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-54df0682]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-54df0682]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-54df0682]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-54df0682]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-54df0682]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-54df0682]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-54df0682]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-54df0682]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-54df0682]{--color-dark:#63757e;--color-light:#c8d2d7}.VcInputBottomSheet .vc-bottom-sheet__header.showDivider[data-v-54df0682]{border-bottom:1px solid var(--gray-lighten-1)}.VcInputBottomSheet .vc-bottom-sheet__footer[data-v-54df0682]{padding:var(--size-value3) var(--size-value4)}.VcInputBottomSheet .vc-bottom-sheet__footer.showDivider[data-v-54df0682]{border-top:1px solid var(--gray-lighten-1);display:flex}.VcInputBottomSheet .vc-bottom-sheet__content[data-v-54df0682]{padding:var(--size-value6) var(--size-value4);overflow-y:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1v = "data-v-54df0682";
/* module identifier */

const __vue_module_identifier__$1v = undefined;
/* functional template */

const __vue_is_functional_template__$1v = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1q,
  staticRenderFns: __vue_staticRenderFns__$1q
}, __vue_inject_styles__$1v, __vue_script__$1v, __vue_scope_id__$1v, __vue_is_functional_template__$1v, __vue_module_identifier__$1v, false, createInjector, undefined, undefined);

var __vue_component__$2l = __vue_component__$2k;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1u = {
  components: {
    VMenu: VMenu
  },

  name: 'VcPopover',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    closeOnClick: {
      type: Boolean,
      default: true
    },
    top: {
      type: Number
    },
    right: {
      type: Number
    },
    bottom: {
      type: Number
    },
    left: {
      type: Number
    },
    dataQa: {
      type: String,
      default: 'vc-popover'
    }
  }
};

/* script */
const __vue_script__$1u = script$1u;
/* template */

var __vue_render__$1p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-menu', {
    attrs: {
      "close-on-click": _vm.closeOnClick,
      "close-on-content-click": false,
      "data-qa": _vm.dataQa,
      "value": _vm.value,
      "content-class": "vc-popover",
      "nudge-top": _vm.top,
      "nudge-right": _vm.right,
      "nudge-bottom": _vm.bottom,
      "nudge-left": _vm.left
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true)
  }, [_vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$1p = [];
/* style */

const __vue_inject_styles__$1u = function (inject) {
  if (!inject) return;
  inject("data-v-411611cb_0", {
    source: "[data-v-411611cb]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-411611cb]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-411611cb]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-411611cb]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-411611cb]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-411611cb]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-411611cb]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-411611cb]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-411611cb]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-411611cb]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-411611cb]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-411611cb]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-411611cb]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-411611cb]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-411611cb]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-411611cb]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-411611cb]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-411611cb]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-411611cb]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-411611cb]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-411611cb]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-411611cb]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-411611cb]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-411611cb]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-411611cb]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-411611cb]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-411611cb]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-411611cb]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-411611cb]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-411611cb]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-411611cb]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-411611cb]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-411611cb]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-411611cb]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-411611cb]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-411611cb]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-411611cb]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-411611cb]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-411611cb]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-411611cb]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-411611cb]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-411611cb]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-411611cb]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-411611cb]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-411611cb]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-411611cb]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-411611cb]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-411611cb]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-411611cb]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-411611cb]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-411611cb]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-411611cb]{--color-dark:#63757e;--color-light:#c8d2d7}.vc-popover[data-v-411611cb]{background-color:var(--modal-bg-color);width:var(--popover-width);max-height:var(--popover-max-height);display:flex;box-shadow:var(--modal-box-shadow);border-radius:var(--popover-border-radius)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1u = "data-v-411611cb";
/* module identifier */

const __vue_module_identifier__$1u = undefined;
/* functional template */

const __vue_is_functional_template__$1u = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1p,
  staticRenderFns: __vue_staticRenderFns__$1p
}, __vue_inject_styles__$1u, __vue_script__$1u, __vue_scope_id__$1u, __vue_is_functional_template__$1u, __vue_module_identifier__$1u, false, createInjector, undefined, undefined);

var VcPopover = __vue_component__$2j;

var script$1t = {
  name: 'VcInputPopover',
  components: {
    VcModalHeader,
    VcLayout,
    VcModalFooter,
    VcForm,
    VcPopover,
    VcSwitch
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    titleDescription: {
      type: String
    },
    okButtonLabel: {
      type: String
    },
    cancelButtonLabel: {
      type: String
    },
    footer: {
      type: Boolean,
      default: true
    },
    top: {
      type: Number
    },
    right: {
      type: Number
    },
    bottom: {
      type: Number
    },
    left: {
      type: Number
    },
    dataQa: {
      type: String,
      default: 'vc-input-popover'
    },
    showHeaderToggle: {
      type: Boolean,
      default: false
    },
    toggleInitialValue: {
      type: Boolean,
      default: true
    },
    closeOnClick: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      validForm: true,
      toggleValue: this.toggleInitialValue
    };
  },

  methods: {
    onOkClicked() {
      this.validate();
      this.$emit('onOkClicked', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    },

    validate() {
      this.$refs.mainForm.validate();
    },

    onMainFormValueChanged(value) {
      this.validForm = value;
      this.$emit('onValidationChanged', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    },

    onHeaderToggleChanged() {
      this.$emit('onDisabledChanged', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    }

  }
};

/* script */
const __vue_script__$1t = script$1t;
/* template */

var __vue_render__$1o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcPopover', {
    attrs: {
      "close-on-click": _vm.validForm && _vm.closeOnClick,
      "value": _vm.value,
      "top": _vm.top,
      "right": _vm.right,
      "bottom": _vm.bottom,
      "left": _vm.left,
      "data-qa": _vm.dataQa + "-bottom-sheet"
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }, {
      key: "default",
      fn: function () {
        return [_c('VcLayout', {
          attrs: {
            "data-qa": _vm.dataQa + "-layout",
            "column": ""
          }
        }, [!!_vm.title ? _c('VcModalHeader', {
          staticClass: "vc-popover-header",
          attrs: {
            "data-qa": _vm.dataQa + "-header",
            "show-back-button": false,
            "title": _vm.title,
            "description": _vm.titleDescription,
            "flavor": "input"
          },
          scopedSlots: _vm._u([{
            key: "headerImage",
            fn: function () {
              return [_vm.showHeaderToggle ? _c('VcSwitch', {
                attrs: {
                  "color": "secondary",
                  "data-qa": _vm.dataQa + "-switch"
                },
                on: {
                  "input": _vm.onHeaderToggleChanged
                },
                model: {
                  value: _vm.toggleValue,
                  callback: function ($$v) {
                    _vm.toggleValue = $$v;
                  },
                  expression: "toggleValue"
                }
              }) : _vm._e()];
            },
            proxy: true
          }], null, false, 4191315885)
        }) : _vm._e(), _vm._v(" "), _c('VcLayout', {
          staticClass: "vc-popover-content",
          attrs: {
            "column": ""
          }
        }, [_c('VcForm', {
          ref: "mainForm",
          staticClass: "VcContent",
          attrs: {
            "value": _vm.validForm,
            "lazy-validation": ""
          },
          on: {
            "input": _vm.onMainFormValueChanged,
            "submit": function (data) {
              return _vm.$emit('submit', data);
            }
          }
        }, [_vm._t("default", null, {
          "disabled": !_vm.toggleValue
        })], 2)], 1), _vm._v(" "), _vm.footer ? _c('VcModalFooter', {
          staticClass: "vc-popover-footer",
          attrs: {
            "buttons": [{
              label: _vm.cancelButtonLabel || _vm.$dst('ds.modal.cancel'),
              event: 'onCancelClicked',
              color: 'white'
            }, {
              label: _vm.okButtonLabel || _vm.$dst('ds.modal.done'),
              event: 'onOkClicked',
              color: 'secondary'
            }]
          },
          on: {
            "onCancelClicked": function ($event) {
              return _vm.$emit('onCancelClicked');
            },
            "onOkClicked": _vm.onOkClicked
          }
        }) : _vm._e()], 1)];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$1o = [];
/* style */

const __vue_inject_styles__$1t = function (inject) {
  if (!inject) return;
  inject("data-v-46ee69fa_0", {
    source: "[data-v-46ee69fa]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-46ee69fa]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-46ee69fa]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-46ee69fa]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-46ee69fa]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-46ee69fa]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-46ee69fa]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-46ee69fa]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-46ee69fa]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-46ee69fa]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-46ee69fa]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-46ee69fa]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-46ee69fa]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-46ee69fa]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-46ee69fa]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-46ee69fa]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-46ee69fa]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-46ee69fa]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-46ee69fa]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-46ee69fa]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-46ee69fa]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-46ee69fa]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-46ee69fa]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-46ee69fa]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-46ee69fa]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-46ee69fa]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-46ee69fa]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-46ee69fa]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-46ee69fa]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-46ee69fa]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-46ee69fa]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-46ee69fa]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-46ee69fa]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-46ee69fa]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-46ee69fa]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-46ee69fa]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-46ee69fa]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-46ee69fa]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-46ee69fa]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-46ee69fa]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-46ee69fa]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-46ee69fa]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-46ee69fa]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-46ee69fa]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-46ee69fa]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-46ee69fa]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-46ee69fa]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-46ee69fa]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-46ee69fa]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-46ee69fa]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-46ee69fa]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-46ee69fa]{--color-dark:#63757e;--color-light:#c8d2d7}.vc-popover[data-v-46ee69fa]{width:var(--popover-width);max-height:var(--popover-max-height);display:flex;box-shadow:var(--modal-box-shadow)}.vc-popover .vc-popover-content[data-v-46ee69fa]{padding:var(--size-value4) var(--size-value6);overflow-y:auto}.vc-popover .vc-popover-footer[data-v-46ee69fa]{padding:var(--size-value3) var(--size-value6)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1t = "data-v-46ee69fa";
/* module identifier */

const __vue_module_identifier__$1t = undefined;
/* functional template */

const __vue_is_functional_template__$1t = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1o,
  staticRenderFns: __vue_staticRenderFns__$1o
}, __vue_inject_styles__$1t, __vue_script__$1t, __vue_scope_id__$1t, __vue_is_functional_template__$1t, __vue_module_identifier__$1t, false, createInjector, undefined, undefined);

var __vue_component__$2i = __vue_component__$2h;

var script$1s = {
  name: 'VcChip',
  components: {
    VcTooltip,
    VcIcon,
    VcAvatar,
    VChip: VChip
  },
  props: {
    label: {
      type: String,
      required: true
    },
    subLabel: {
      type: String,
      default: ''
    },
    avatar: {
      type: Object,
      validator: avatar => avatar.imagePath || avatar.colorId || avatar.colorId === 0
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-chip'
    },
    isRipple: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    // relevant only for small chip
    narrow: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number
    },
    minWidth: {
      type: Number
    }
  },

  data() {
    return {
      showTooltip: false,
      resizeObserver: null
    };
  },

  computed: {
    getMaxWidth() {
      return this.maxWidth ? `${this.maxWidth}px` : 'fit-content';
    },

    getMinWidth() {
      return this.minWidth ? `${this.minWidth}px` : 'fit-content';
    }

  },

  async mounted() {
    await this.$nextTick();
    this.shouldShowTooltip();
    this.setResizeObservable();
  },

  destroyed() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },

  methods: {
    shouldShowTooltip() {
      var _this$$refs$labelWrap;

      this.labelWrapEl = (_this$$refs$labelWrap = this.$refs.labelWrapEl) === null || _this$$refs$labelWrap === void 0 ? void 0 : _this$$refs$labelWrap.$el;
      if (!this.labelWrapEl) return;
      this.showTooltip = this.labelWrapEl.scrollWidth > this.labelWrapEl.clientWidth;
    },

    setResizeObservable() {
      this.resizeObserver = new ResizeObserver(this.shouldShowTooltip);
      this.labelWrapEl && this.resizeObserver.observe(this.labelWrapEl);
    }

  }
};

/* script */
const __vue_script__$1s = script$1s;
/* template */

var __vue_render__$1n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-chip', {
    staticClass: "VcChip",
    class: {
      'vc-invalid': _vm.invalid,
      'vc-avatar': !!_vm.avatar,
      'vc-selected': _vm.selected,
      'VcChip--small': _vm.small,
      'VcChip--narrow': _vm.narrow
    },
    style: {
      maxWidth: _vm.getMaxWidth,
      minWidth: _vm.getMinWidth
    },
    attrs: {
      "close": _vm.closeButton,
      "ripple": _vm.isRipple,
      "close-icon": "$close",
      "disabled": _vm.disabled,
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onChipClick');
      },
      "click:close": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_vm._t("chip-avatar", function () {
    return [_vm.invalid ? _c('VcIcon', {
      staticClass: "v-chip__content__invalid-icon",
      attrs: {
        "data-qa": _vm.dataQa + "-invalid-icon"
      }
    }, [_vm._v("\n      $attention_fill\n    ")]) : !!_vm.avatar ? _c('VcAvatar', _vm._b({
      staticClass: "v-chip__content__avatar",
      attrs: {
        "name": _vm.label,
        "show-border": false,
        "size": "x-sm"
      }
    }, 'VcAvatar', _vm.avatar, false)) : _vm.selected ? _c('VcIcon', {
      staticClass: "v-chip__content__selected",
      attrs: {
        "data-qa": _vm.dataQa + "-check-icon",
        "size": "12",
        "color": "currentColor"
      }
    }, [_vm._v("\n      $check_button\n    ")]) : _vm._e()];
  }), _vm._v(" "), _vm._t("default", function () {
    return [_c('VcTooltip', {
      ref: "labelWrapEl",
      staticClass: "label-wrap",
      attrs: {
        "disabled": !_vm.showTooltip,
        "content": _vm.label,
        "dark": "",
        "bottom": ""
      }
    }, [_c('span', [_vm.subLabel ? _c('span', {
      staticClass: "VcChip__subLabel"
    }, [_vm._v(_vm._s(_vm.subLabel))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])])])];
  })], 2);
};

var __vue_staticRenderFns__$1n = [];
/* style */

const __vue_inject_styles__$1s = function (inject) {
  if (!inject) return;
  inject("data-v-7f3681a3_0", {
    source: "[data-v-7f3681a3]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-7f3681a3]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-7f3681a3]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-7f3681a3]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-7f3681a3]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-7f3681a3]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-7f3681a3]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-7f3681a3]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-7f3681a3]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-7f3681a3]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-7f3681a3]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-7f3681a3]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-7f3681a3]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-7f3681a3]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-7f3681a3]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-7f3681a3]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-7f3681a3]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-7f3681a3]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-7f3681a3]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-7f3681a3]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-7f3681a3]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-7f3681a3]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-7f3681a3]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-7f3681a3]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-7f3681a3]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-7f3681a3]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-7f3681a3]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-7f3681a3]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-7f3681a3]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-7f3681a3]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-7f3681a3]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-7f3681a3]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-7f3681a3]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-7f3681a3]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-7f3681a3]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-7f3681a3]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-7f3681a3]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-7f3681a3]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-7f3681a3]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-7f3681a3]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-7f3681a3]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-7f3681a3]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-7f3681a3]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-7f3681a3]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-7f3681a3]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-7f3681a3]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-7f3681a3]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-7f3681a3]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-7f3681a3]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-7f3681a3]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-7f3681a3]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-7f3681a3]{--color-dark:#63757e;--color-light:#c8d2d7}.VcChip[data-v-7f3681a3]{border:1px solid var(--neutral-lighten-1)}.VcChip .label-wrap[data-v-7f3681a3]{padding-inline:var(--size-value2);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.VcChip .v-chip__content__avatar[data-v-7f3681a3]{margin-inline-end:var(--size-value1)}.VcChip.v-chip[data-v-7f3681a3]{background-color:var(--modal-bg-color)}.VcChip.v-chip[data-v-7f3681a3]:active{background-color:var(--neutral-lighten-1);box-shadow:none}.VcChip.v-chip .VcChip__subLabel[data-v-7f3681a3]{color:var(--gray-darken-4)}.VcChip.v-chip .VcChip__subLabel[data-v-7f3681a3]:after{content:\"|\";color:var(--gray-lighten-1);padding-inline:var(--size-value2);font-size:var(--size-value4)}.VcChip.v-chip[data-v-7f3681a3]  .v-chip__content{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small);line-height:var(--size-value5);color:var(--gray-darken-5)}.VcChip.v-chip[data-v-7f3681a3]  .v-chip__content .vc-attention-fill{fill:var(--yellow)}.VcChip.v-chip[data-v-7f3681a3]  .v-chip__content .v-chip__close{direction:inherit;color:var(--gray)}.VcChip.v-chip[data-v-7f3681a3]  .v-chip__content .v-chip__close:hover{opacity:unset}.VcChip.v-chip.vc-avatar[data-v-7f3681a3]:not(.VcChip--small),.VcChip.v-chip.vc-invalid[data-v-7f3681a3]:not(.VcChip--small){padding-inline:var(--size-value1) var(--size-value3)}.VcChip.v-chip.VcChip--small[data-v-7f3681a3]{padding-inline:0;height:var(--size-value6);padding-inline-end:var(--size-value2)}.VcChip.v-chip.VcChip--small[data-v-7f3681a3]:not(.vc-avatar,.vc-invalid){padding-inline-start:var(--size-value3)}.VcChip.v-chip.VcChip--small:not(.vc-avatar,.vc-invalid).VcChip--narrow[data-v-7f3681a3]{padding-inline:2px}.VcChip .v-chip__content__selected[data-v-7f3681a3]{margin-inline-end:var(--size-value2)}.VcChip.v-chip--disabled[data-v-7f3681a3]{background-color:var(--gray-lighten-2);border:1px solid var(--gray-lighten-2)}.VcChip.v-chip--disabled[data-v-7f3681a3]  .v-chip__content{color:var(--gray-darken-1)}.VcChip.vc-invalid[data-v-7f3681a3]{background-color:var(--yellow-lighten-3);border:1px solid var(--yellow)}.VcChip.vc-invalid[data-v-7f3681a3]:hover{background-color:var(--yellow-lighten-2)}.VcChip.vc-selected[data-v-7f3681a3]{background-color:var(--v-secondary-lighten3);border:1px solid var(--v-secondary-base)}.VcChip.vc-selected[data-v-7f3681a3]:hover{background-color:var(--v-secondary-lighten3)}.VcChip.vc-selected[data-v-7f3681a3]  .v-chip__content{font-weight:var(--font-weight-large);color:var(--v-secondary-base)}.VcChip[data-v-7f3681a3]:hover{background-color:var(--gray-lighten-3)}.VcChip[data-v-7f3681a3]:hover:before{opacity:0}.VcChip[data-v-7f3681a3]:focus{box-shadow:0 0 0 3px var(--v-secondary-lighten1)}.VcChip[data-v-7f3681a3]:focus:before{opacity:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1s = "data-v-7f3681a3";
/* module identifier */

const __vue_module_identifier__$1s = undefined;
/* functional template */

const __vue_is_functional_template__$1s = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1n,
  staticRenderFns: __vue_staticRenderFns__$1n
}, __vue_inject_styles__$1s, __vue_script__$1s, __vue_scope_id__$1s, __vue_is_functional_template__$1s, __vue_module_identifier__$1s, false, createInjector, undefined, undefined);

var VcChip = __vue_component__$2g;

var justDebounce = debounce;

function debounce(fn, delay, atStart, guarantee) {
  var timeout;
  var args;
  var self;

  return function debounced() {
    self = this;
    args = Array.prototype.slice.call(arguments);

    if (timeout && (atStart || guarantee)) {
      return;
    } else if (!atStart) {
      clear();

      timeout = setTimeout(run, delay);
      return timeout;
    }

    timeout = setTimeout(clear, delay);
    fn.apply(self, args);

    function run() {
      clear();
      fn.apply(self, args);
    }

    function clear() {
      clearTimeout(timeout);
      timeout = null;
    }
  };
}

var script$1r = {
  name: 'VcChipList',
  components: {
    VcChip,
    VTooltip: VTooltip
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: prop => prop.every(chip => !chip.avatar || typeof chip.avatar === 'object')
    },
    moreText: {
      type: String,
      required: true
    },
    dataQa: {
      type: String,
      default: 'VcChipList'
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    lines: {
      type: Number,
      default: 2,
      validator: prop => Number.isInteger(prop) && prop > 0
    },
    hiddenItemDisplay: {
      type: String,
      default: 'text',
      validator: value => ['text', 'chip'].includes(value)
    },
    maxChipWidth: {
      type: Number
    },
    minChipWidth: {
      type: Number
    }
  },

  data() {
    return {
      visibleChips: [],
      hiddenChips: [],
      processingDone: false,
      itemHeight: null
    };
  },

  computed: {
    hiddenLabelsString() {
      return this.hiddenChips.map(chip => chip && chip.label).join(', ');
    },

    listStyle() {
      return {
        height: this.lines * (this.itemHeight || 40) + 'px'
      };
    },

    isSmall() {
      return this.items.some(chip => chip.small);
    },

    hiddenExistingChips() {
      return this.hiddenChips.filter(chip => chip === null || chip === void 0 ? void 0 : chip.label);
    }

  },
  watch: {
    items() {
      this.processChips();
    },

    lines() {
      this.processChips();
    }

  },

  created() {
    window.addEventListener('resize', justDebounce(this.processChips, 300));
  },

  mounted() {
    this.processChips();
  },

  destroyed() {
    window.removeEventListener('resize', justDebounce(this.processChips, 300));
  },

  methods: {
    async processChips() {
      this.processingDone = false;
      await this.$nextTick(); // wait for chip list height to render

      this.visibleChips = [];
      this.hiddenChips = [];
      const chipListEl = this.$refs['chip-list'];
      if (!chipListEl) return;
      const chipListTopHeight = chipListEl.offsetTop + chipListEl.offsetHeight;
      const moreIndicatorEl = this.$refs['more-indicator'].$el ? this.$refs['more-indicator'].$el : this.$refs['more-indicator'];
      let overflowReached = false;

      for (let i in this.items) {
        var _this$$refs$i$;

        if (overflowReached) {
          this.hiddenChips.push(this.items[i]);
          continue;
        }

        this.visibleChips.push(this.items[i]);
        await this.$nextTick(); // wait for chip to render

        const chipEl = this.$refs[i] && ((_this$$refs$i$ = this.$refs[i][0]) === null || _this$$refs$i$ === void 0 ? void 0 : _this$$refs$i$.$el);

        if (!this.itemHeight && chipEl) {
          this.itemHeight = this.getItemHeight(chipEl);
        }

        if (!chipEl || chipEl.offsetTop >= chipListTopHeight) {
          this.hiddenChips.push(this.visibleChips.pop());
          overflowReached = true;
        }
      }

      if (this.hiddenChips.length) {
        await this.$nextTick(); // wait for more indicator to render
        // if the 'more' indicator is overflowed, hide the last visible chip and show it in the tooltip

        if (moreIndicatorEl.offsetTop + moreIndicatorEl.offsetHeight >= chipListTopHeight) {
          this.hiddenChips.unshift(this.visibleChips.pop());
          await this.$nextTick();
        }
      }

      this.$emit('onHiddenChipsChange', this.hiddenChips.length);
      this.processingDone = true;
    },

    getItemHeight(elem) {
      const offsetHeight = elem.offsetHeight;
      const marginBottom = parseFloat(getComputedStyle(elem).marginBottom);
      return offsetHeight + marginBottom;
    }

  }
};

/* script */
const __vue_script__$1r = script$1r;
/* template */

var __vue_render__$1m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "chip-list",
    staticClass: "VcChipList",
    class: {
      'VcChipList--loaded': _vm.processingDone
    },
    style: _vm.listStyle,
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm._l(_vm.visibleChips, function (item, i) {
    return _c('VcChip', _vm._b({
      key: item.label,
      ref: i,
      refInFor: true,
      class: {
        'multi-line': _vm.lines > 1
      },
      attrs: {
        "label": item.label || '',
        "sub-label": item.subLabel || '',
        "avatar": item.avatar,
        "close-button": _vm.showCloseButton,
        "max-width": _vm.maxChipWidth,
        "min-width": _vm.minChipWidth,
        "is-ripple": false,
        "data-qa": "vc-chip-item-" + i
      },
      on: {
        "input": function (data) {
          return _vm.$emit('onRemove', data, item);
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function () {
          return [_vm._t("chipLabel", null, {
            "item": item
          })];
        },
        proxy: true
      }], null, true)
    }, 'VcChip', item, false));
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": "",
      "content-class": "more-tooltip"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        var attrs = ref.attrs;
        return [_vm.hiddenItemDisplay === 'chip' ? _c('span', _vm._g(_vm._b({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.hiddenChips.length,
            expression: "hiddenChips.length"
          }],
          ref: "more-indicator",
          staticClass: "more-chip"
        }, 'span', attrs, false), on), [_c('VcChip', {
          attrs: {
            "label": _vm.moreText,
            "is-ripple": false,
            "close-button": _vm.showCloseButton,
            "small": _vm.isSmall,
            "max-width": _vm.maxChipWidth,
            "min-width": _vm.minChipWidth,
            "narrow": "",
            "data-qa": "vc-chip-item-more"
          }
        })], 1) : _c('span', _vm._g(_vm._b({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.hiddenChips.length,
            expression: "hiddenChips.length"
          }],
          ref: "more-indicator",
          staticClass: "more-indicator",
          class: {
            'multi-line': _vm.lines > 1
          }
        }, 'span', attrs, false), on), [_vm._v("\n        " + _vm._s(_vm.moreText) + "\n      ")])];
      }
    }])
  }, [_vm._v(" "), _vm._t("tooltipSlot", function () {
    return [_vm.hiddenItemDisplay === 'chip' ? _c('ul', {
      staticClass: "hidden-chips-list"
    }, _vm._l(_vm.hiddenExistingChips, function (chip) {
      return _c('li', {
        key: chip.label
      }, [_c('span', [_vm._v(_vm._s(chip.label))])]);
    }), 0) : _c('span', [_vm._v(_vm._s(_vm.hiddenLabelsString))])];
  }, {
    "items": _vm.hiddenChips
  })], 2)], 2);
};

var __vue_staticRenderFns__$1m = [];
/* style */

const __vue_inject_styles__$1r = function (inject) {
  if (!inject) return;
  inject("data-v-a541b0d0_0", {
    source: ".VcChipList[data-v-a541b0d0]{overflow:hidden;--chip-bottom-margin:var(--size-value2);display:flex;flex-wrap:wrap;align-items:center}.VcChipList--loaded[data-v-a541b0d0]{height:auto}.VcChipList .VcChip.multi-line[data-v-a541b0d0]{margin-bottom:var(--chip-bottom-margin)}.VcChipList .VcChip[data-v-a541b0d0]:not(:last-child){margin-inline-end:var(--size-value1)}.VcChipList .VcChip[data-v-a541b0d0]:hover{background-color:unset}.VcChipList .more-indicator[data-v-a541b0d0]{position:relative;margin-left:var(--size-value1);font-size:var(--font-size-small);font-weight:var(--font-weight-medium2);color:var(--gray-darken-4);text-decoration:underline}.VcChipList .more-indicator.multi-line[data-v-a541b0d0]{margin-bottom:var(--chip-bottom-margin)}.more-tooltip[data-v-a541b0d0]{padding:var(--size-value1) var(--size-value2);background-color:var(--gray-darken-5);font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2)}.hidden-chips-list[data-v-a541b0d0]{padding-inline-end:var(--size-value3)}.hidden-chips-list li[data-v-a541b0d0]{font-size:var(--font-size-xxx-small);line-height:var(--size-value4)}.hidden-chips-list li span[data-v-a541b0d0]{font-size:var(--font-size-x-small)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1r = "data-v-a541b0d0";
/* module identifier */

const __vue_module_identifier__$1r = undefined;
/* functional template */

const __vue_is_functional_template__$1r = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1m,
  staticRenderFns: __vue_staticRenderFns__$1m
}, __vue_inject_styles__$1r, __vue_script__$1r, __vue_scope_id__$1r, __vue_is_functional_template__$1r, __vue_module_identifier__$1r, false, createInjector, undefined, undefined);

var VcChipList = __vue_component__$2f;

//
//
//
//
//
//
//
//
//
var script$1q = {
  name: 'VcBaseListItem',
  model: {
    prop: 'selected'
  },
  props: {
    /**
     * The effect of this class can be seen when the items is in selected mode
     */
    selectedClass: {
      type: String,
      default: 'multiple',
      validator: selectedClass => ['multiple', 'single'].includes(selectedClass)
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-base-list-item'
    }
  },
  computed: {
    getListItemClasses() {
      return {
        [this.selectedClass]: true,
        disabled: this.disabled,
        active: this.selected
      };
    }

  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('click');
      }
    }

  }
};

/* script */
const __vue_script__$1q = script$1q;
/* template */

var __vue_render__$1l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vc-base-list-item",
    class: _vm.getListItemClasses,
    attrs: {
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.onClick();
      }
    }
  }, [[_vm._t("default")]], 2);
};

var __vue_staticRenderFns__$1l = [];
/* style */

const __vue_inject_styles__$1q = function (inject) {
  if (!inject) return;
  inject("data-v-3bec37ee_0", {
    source: ".vc-base-list-item[data-v-3bec37ee]{padding:var(--size-value4);cursor:pointer;transition:background .8s}.vc-base-list-item.disabled[data-v-3bec37ee]{cursor:unset;background-color:var(--gray-lighten-3);color:var(--gray-darken-2)}.vc-base-list-item[data-v-3bec37ee]:not(.disabled):hover{background-color:var(--gray-lighten-3)}.vc-base-list-item[data-v-3bec37ee]:not(.disabled):focus{box-shadow:0 0 0 2px var(--v-secondary-lighten1)}.vc-base-list-item[data-v-3bec37ee]:not(.disabled):focus:before{background-color:var(--modal-bg-color)}.vc-base-list-item:not(.disabled).active[data-v-3bec37ee]::before{background-color:unset}.vc-base-list-item:not(.disabled).active:not(.disabled).multiple[data-v-3bec37ee]{background-color:unset}.vc-base-list-item:not(.disabled).active:not(.disabled).single[data-v-3bec37ee]{background-color:var(--v-secondary-lighten3)}.vc-base-list-item[data-v-3bec37ee]:not(.disabled):active{background-color:var(--gray)!important;transition:background 0s}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1q = "data-v-3bec37ee";
/* module identifier */

const __vue_module_identifier__$1q = undefined;
/* functional template */

const __vue_is_functional_template__$1q = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1l,
  staticRenderFns: __vue_staticRenderFns__$1l
}, __vue_inject_styles__$1q, __vue_script__$1q, __vue_scope_id__$1q, __vue_is_functional_template__$1q, __vue_module_identifier__$1q, false, createInjector, undefined, undefined);

var VcBaseListItem = __vue_component__$2e;

var script$1p = {
  name: 'VcLink',
  components: {
    VcIcon
  },
  props: {
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      required: false
    },
    appendIcon: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      default: 'VcLink'
    },
    target: {
      type: String,
      default: '_blank',
      validator: target => ['_blank', '_self', '_parent', '_top', '_system'].includes(target)
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$1p = script$1p;
/* template */

var __vue_render__$1k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a', {
    staticClass: "VcLink",
    class: {
      'link-secondary': _vm.secondary,
      disabled: _vm.disabled
    },
    attrs: {
      "href": _vm.url,
      "target": _vm.target,
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function (event) {
        return _vm.$emit('click', event);
      }
    }
  }, [!!_vm.prependIcon ? _c('VcIcon', {
    staticClass: "VcLink-icon prepend-icon",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.prependIcon))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), !!_vm.appendIcon ? _c('VcIcon', {
    staticClass: "VcLink-icon append-icon",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.appendIcon))]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$1k = [];
/* style */

const __vue_inject_styles__$1p = function (inject) {
  if (!inject) return;
  inject("data-v-5b4d68d8_0", {
    source: ".VcLink[data-v-5b4d68d8]{display:flex;align-items:center;font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2);padding-top:var(--size-value1);text-decoration:none;color:var(--link-color)}.VcLink.link-secondary[data-v-5b4d68d8]{color:var(--gray-darken-4)}.VcLink.link-secondary.VcLink[data-v-5b4d68d8]  svg path{fill:var(--gray-darken-4)}.VcLink:hover label[data-v-5b4d68d8]{text-decoration:underline;cursor:pointer}.VcLink .VcLink-icon[data-v-5b4d68d8]  svg path{fill:var(--link-color)}.VcLink .prepend-icon[data-v-5b4d68d8]{padding-inline-end:var(--size-value1)}.VcLink .append-icon[data-v-5b4d68d8]{padding-inline-start:var(--size-value1)}.VcLink.disabled[data-v-5b4d68d8]{pointer-events:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1p = "data-v-5b4d68d8";
/* module identifier */

const __vue_module_identifier__$1p = undefined;
/* functional template */

const __vue_is_functional_template__$1p = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1k,
  staticRenderFns: __vue_staticRenderFns__$1k
}, __vue_inject_styles__$1p, __vue_script__$1p, __vue_scope_id__$1p, __vue_is_functional_template__$1p, __vue_module_identifier__$1p, false, createInjector, undefined, undefined);

var VcLink = __vue_component__$2d;

var script$1o = {
  name: 'VcEmptyState',
  components: {
    VcImage,
    VcButton,
    VcLayout,
    VcLink
  },
  props: {
    size: {
      type: String,
      default: 'md',
      validator: prop => ['sm', 'md', 'lg'].includes(prop)
    },
    image: {
      type: [String, Object],
      comment: 'This is the standard way to pass the image, the icon and svg props are for backward compatibility'
    },
    icon: {
      type: [String, Object],
      comment: 'url to some image, deprecated'
    },
    svg: {
      type: [String, Object],
      comment: 'using the svgImage design system object, deprecated'
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    button: {
      type: String,
      required: false
    },
    outlinedButton: {
      type: Boolean,
      required: false
    },
    linkLabel: {
      type: String,
      required: false
    },
    linkUrl: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      default: 'VcEmptyState'
    }
  },
  computed: {
    currentImage() {
      // for backward compatibility
      return this.image || this.icon || this.svg;
    },

    buttonFlavor() {
      return this.outlinedButton ? 'secondary' : 'primary';
    }

  }
};

/* script */
const __vue_script__$1o = script$1o;
/* template */

var __vue_render__$1j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    class: "VcEmptyState " + _vm.size,
    attrs: {
      "column": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    attrs: {
      "column": ""
    }
  }, [_vm.currentImage ? _c('VcImage', {
    staticClass: "VcEmptyStateImage",
    attrs: {
      "image": _vm.currentImage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "VcEmptyStateTitle"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])], 1), _vm._v(" "), _c('VcLayout', {
    staticClass: "VcEmptyStateSubtitle",
    attrs: {
      "column": ""
    }
  }, [_vm._v("\n    " + _vm._s(_vm.subtitle) + "\n  ")]), _vm._v(" "), _vm._t("buttonArea", function () {
    return [_vm.button || _vm.linkLabel && _vm.linkUrl ? _c('VcLayout', {
      attrs: {
        "column": "",
        "align-center": ""
      }
    }, [_vm.button ? _c('VcButton', {
      staticClass: "VcEmptyStateButton",
      attrs: {
        "small": "",
        "block": false,
        "outlined": _vm.outlinedButton,
        "flavor": _vm.buttonFlavor
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('click');
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.button) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.linkLabel && _vm.linkUrl ? _c('VcLink', {
      attrs: {
        "url": _vm.linkUrl,
        "label": _vm.linkLabel
      }
    }) : _vm._e()], 1) : _vm._e()];
  })], 2);
};

var __vue_staticRenderFns__$1j = [];
/* style */

const __vue_inject_styles__$1o = function (inject) {
  if (!inject) return;
  inject("data-v-1490a720_0", {
    source: ".VcEmptyState[data-v-1490a720],.VcEmptyStateSubtitle[data-v-1490a720]{text-align:center;line-height:var(--size-value6)}.VcEmptyState[data-v-1490a720]{text-align:center}.VcEmptyState .VcEmptyStateImage[data-v-1490a720]{margin-bottom:var(--size-value4);height:160px}.VcEmptyState .VcEmptyStateTitle[data-v-1490a720]{font-weight:var(--font-weight-xl);line-height:22px;padding-bottom:var(--size-value1);font-size:var(--font-size-small2)}.VcEmptyState .VcEmptyStateSubtitle[data-v-1490a720]{font-size:var(--font-size-x-small)}.VcEmptyState .VcEmptyStateButton[data-v-1490a720]{margin-top:var(--size-value4)}.sm .VcEmptyStateImage[data-v-1490a720]{height:48px;margin-bottom:var(--size-value8)}.sm .VcEmptyStateImage[data-v-1490a720]  svg{width:48px}.lg .VcEmptyStateImage[data-v-1490a720]{height:280px;margin-bottom:var(--size-value8)}.lg .VcEmptyStateImage[data-v-1490a720]  svg{width:280px}.lg .VcEmptyStateTitle[data-v-1490a720]{font-weight:var(--font-weight-large);line-height:22px;padding-bottom:var(--size-value2);font-size:var(--font-size-medium1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1o = "data-v-1490a720";
/* module identifier */

const __vue_module_identifier__$1o = undefined;
/* functional template */

const __vue_is_functional_template__$1o = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1j,
  staticRenderFns: __vue_staticRenderFns__$1j
}, __vue_inject_styles__$1o, __vue_script__$1o, __vue_scope_id__$1o, __vue_is_functional_template__$1o, __vue_module_identifier__$1o, false, createInjector, undefined, undefined);

var VcEmptyState = __vue_component__$2c;

var script$1n = {
  name: 'VcList',
  components: {
    VcEmptyState,
    VcBaseListItem
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: items => items.every(item => !isNaN(item.identifier))
    },
    multiple: {
      type: Boolean,
      default: false
    },
    emptyListMsg: {
      type: String
    },
    emptyListTitle: {
      type: String
    },
    imagePath: {
      type: String
    },
    dataQa: {
      type: String,
      default: 'vc-list'
    }
  },
  computed: {
    getSelectedClass() {
      return this.multiple ? 'multiple' : 'single';
    },

    isEmptyList() {
      return !this.items.length;
    },

    noItemsTitle() {
      return this.emptyListMsg || this.$dst('ds.listbox.empty_list');
    },

    noItemsMsg() {
      return this.emptyListTitle || this.$dst('ds.list.empty_list_description');
    }

  }
};

/* script */
const __vue_script__$1n = script$1n;
/* template */

var __vue_render__$1i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vc-list-container",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [!_vm.isEmptyList ? _c('ul', {
    staticClass: "vc-list"
  }, _vm._l(_vm.items, function (item) {
    return _c('VcBaseListItem', _vm._b({
      key: item.identifier,
      attrs: {
        "selected-class": _vm.getSelectedClass,
        "data-qa": _vm.dataQa + "-" + item.identifier
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('select', item.identifier, !item.selected);
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function () {
          return [_vm._t("default", function () {
            return [_vm._v("\n          " + _vm._s(item.label) + "\n        ")];
          }, null, item)];
        },
        proxy: true
      }], null, true)
    }, 'VcBaseListItem', item, false));
  }), 1) : [_vm._t("emptyList", function () {
    return [_c('VcEmptyState', {
      staticClass: "VcListEmptyState",
      attrs: {
        "title": _vm.noItemsTitle,
        "subtitle": _vm.noItemsMsg,
        "size": "sm",
        "data-qa": _vm.dataQa + "-empty",
        "image": _vm.imagePath
      }
    })];
  })]], 2);
};

var __vue_staticRenderFns__$1i = [];
/* style */

const __vue_inject_styles__$1n = function (inject) {
  if (!inject) return;
  inject("data-v-7c09e060_0", {
    source: ".vc-list-container[data-v-7c09e060]{width:100%}.vc-list[data-v-7c09e060]{width:100%;margin:var(--size-value0);padding:var(--size-value0)}.VcListEmptyState[data-v-7c09e060]{margin:var(--size-value4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1n = "data-v-7c09e060";
/* module identifier */

const __vue_module_identifier__$1n = undefined;
/* functional template */

const __vue_is_functional_template__$1n = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1i,
  staticRenderFns: __vue_staticRenderFns__$1i
}, __vue_inject_styles__$1n, __vue_script__$1n, __vue_scope_id__$1n, __vue_is_functional_template__$1n, __vue_module_identifier__$1n, false, createInjector, undefined, undefined);

var VcList = __vue_component__$2b;

var script$1m = {
  name: 'VcAiButton',
  components: {
    VcButton,
    VcIcon
  },
  inheritAttrs: false,
  props: {
    /**
     * Text for display on the button
     */
    label: {
      type: String,
      required: false
    },

    /**
     * Use the default AI icon (ai_sparkles) as prepend icon
     */
    useAiIcon: {
      type: Boolean,
      default: false
    },

    /**
     * Use primary style (solid purple background)
     */
    primary: {
      type: Boolean,
      default: true
    },
    prependIcon: {
      type: String,
      required: false
    },
    appendIcon: {
      type: String,
      required: false
    },
    small: {
      type: Boolean,
      required: false
    },
    dataQa: {
      type: String,
      default: 'vc-ai-btn'
    }
  },
  computed: {
    aiIcon() {
      return 'ai_sparkles';
    },

    parsedVcButtonAttrs() {
      return { ...this.$attrs,
        white: false,
        small: this.small,
        xSmall: false,
        large: false,
        xLarge: false
      };
    },

    appendIconColor() {
      if (this.$attrs.secondary) return 'var(--ai-main)';
      if (this.$attrs.ghost) return 'black';
      return 'white';
    },

    classes() {
      return {
        'vc-ai-button--primary': this.primary,
        'vc-ai-button--secondary-white': this.$attrs.secondary && this.$attrs.white,
        'vc-ai-button--ghost': this.$attrs.ghost
      };
    }

  }
};

/* script */
const __vue_script__$1m = script$1m;
/* template */

var __vue_render__$1h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcButton', _vm._b({
    staticClass: "vc-ai-button",
    class: _vm.classes,
    attrs: {
      "pill": "",
      "color": "ai",
      "icon-size": "16",
      "prepend-default-icon": !!_vm.prependIcon || _vm.useAiIcon,
      "prepend-icon": _vm.prependIcon || _vm.aiIcon,
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click', $event);
      }
    },
    scopedSlots: _vm._u([_vm.$slots.prepend ? {
      key: "prepend",
      fn: function () {
        return [_vm._t("prepend")];
      },
      proxy: true
    } : null, _vm.appendIcon ? {
      key: "append",
      fn: function () {
        return [_c('span', {
          staticClass: "append-icon",
          attrs: {
            "data-testid": "vc-ai-btn-append-icon"
          }
        }, [_c('VcIcon', {
          attrs: {
            "color": _vm.appendIconColor,
            "size": "16"
          }
        }, [_vm._v(_vm._s(_vm.appendIcon))])], 1)];
      },
      proxy: true
    } : null], null, true)
  }, 'VcButton', _vm.parsedVcButtonAttrs, false), [_vm._v(" "), _vm._t("default", function () {
    return [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")];
  })], 2);
};

var __vue_staticRenderFns__$1h = [];
/* style */

const __vue_inject_styles__$1m = function (inject) {
  if (!inject) return;
  inject("data-v-4bde42b9_0", {
    source: ".vc-ai-button[data-v-4bde42b9]{background-image:var(--ai-background);color:var(--ai-main);transition:all .2s ease-in-out;outline:0}.vc-ai-button[data-v-4bde42b9]:hover{opacity:.9;background-image:var(--ai-background);box-shadow:var(--shadow-1)}.vc-ai-button[data-v-4bde42b9]:active{opacity:.85;background-image:var(--ai-background);box-shadow:var(--shadow-1);outline:0}.vc-ai-button[data-v-4bde42b9]:disabled{opacity:.6;border-color:var(--gray-lighten-2);box-shadow:none}.vc-ai-button[data-v-4bde42b9]:focus{outline:0;box-shadow:0 0 0 2px rgba(96,57,252,.15)}.vc-ai-button--primary[data-v-4bde42b9]{background-image:none;background-color:var(--ai-main);color:var(--white)!important;border:none}.vc-ai-button--primary.theme--light.v-btn.v-btn--has-bg[data-v-4bde42b9]{background-color:var(--ai-main)}.vc-ai-button--primary[data-v-4bde42b9]:hover{background-image:none;background-color:var(--ai-main);opacity:.9}.vc-ai-button--primary[data-v-4bde42b9]:active{background-color:var(--ai-main);opacity:.85;outline:0}.vc-ai-button--primary[data-v-4bde42b9]:disabled{background-color:var(--gray-lighten-2);color:var(--gray-darken-2)}.vc-ai-button--primary[data-v-4bde42b9]:focus{outline:0;box-shadow:0 0 0 2px rgba(96,57,252,.15)}.vc-ai-button--secondary-white.v-btn--has-bg[data-v-4bde42b9]{background-image:var(--white);background-color:var(--white);color:var(--ai-main)}.vc-ai-button--ghost[data-v-4bde42b9]{background-image:none;color:#000}.vc-ai-button--ghost[data-v-4bde42b9]:focus{background-image:none;background-color:rgba(255,255,255,.4)}.vc-ai-button--ghost[data-v-4bde42b9]:disabled{background-image:none;background-color:initial}.vc-ai-button--block[data-v-4bde42b9]{width:100%;height:unset;min-height:36px;max-height:none;align-self:flex-start;position:relative;box-sizing:border-box}.vc-ai-button--block[data-v-4bde42b9]  .v-btn__content{height:auto;display:flex;align-items:center;justify-content:center;padding:8px 16px;box-sizing:border-box}.vc-ai-button[data-v-4bde42b9]  .v-btn__content{outline:0}.vc-ai-button[data-v-4bde42b9]  .prependDefaultIcon,.vc-ai-button[data-v-4bde42b9]  .v-icon{color:inherit}.vc-ai-button .append-icon[data-v-4bde42b9]{margin-inline-start:12px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1m = "data-v-4bde42b9";
/* module identifier */

const __vue_module_identifier__$1m = undefined;
/* functional template */

const __vue_is_functional_template__$1m = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$29 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1h,
  staticRenderFns: __vue_staticRenderFns__$1h
}, __vue_inject_styles__$1m, __vue_script__$1m, __vue_scope_id__$1m, __vue_is_functional_template__$1m, __vue_module_identifier__$1m, false, createInjector, undefined, undefined);

var __vue_component__$2a = __vue_component__$29;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1l = {
  components: {
    VCol: VCol,
    VRow: VRow,
    VContainer: VContainer
  },

  name: 'VcButtonGroup',

  model: {
    prop: 'selected',
    event: 'change'
  },

  props: {
    buttons: {
      type: Array,
      required: true,
      validator: function (buttons) {
        return buttons.length >= 4 && buttons.length <= 9 && buttons.every(button => !!button.id && !!button.label);
      }
    },
    selected: String,
    direction: {
      type: String,
      default: 'vertical',
      validator: prop => ['horizontal', 'vertical'].includes(prop)
    },
    dataQa: {
      type: String,
      default: 'VcButtonGroup'
    }
  },

  data() {
    return {
      buttonSelected: false
    };
  },

  computed: {
    rows() {
      let rows = [];
      let numOfRows = Math.ceil(this.buttons.length / this.cols);

      for (let row = 0; row < numOfRows; row++) {
        const sliceStart = row * this.cols;
        const sliceEnd = row * this.cols + this.cols;
        const buttonsRow = this.buttons.slice(sliceStart, sliceEnd);
        rows.push(buttonsRow);
      }

      return rows;
    },

    cols() {
      switch (this.buttons.length) {
        case 5:
        case 6:
          return this.direction === 'horizontal' ? 3 : 2;

        case 7:
        case 8:
          return this.direction === 'horizontal' ? 4 : 2;

        case 9:
          return 3;
      }

      return 2;
    }

  },

  created() {
    this.buttonSelected = this.selected;
  },

  methods: {
    onSelected: function (id) {
      this.$emit('change', id);
    }
  }
};

/* script */
const __vue_script__$1l = script$1l;
/* template */

var __vue_render__$1g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-container', {
    staticClass: "VcButtonGroup",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, _vm._l(_vm.rows, function (row, rowIdx) {
    return _c('v-row', {
      key: "row-" + rowIdx,
      staticClass: "button-group-row",
      attrs: {
        "data-qa": "row"
      }
    }, _vm._l(row, function (button, itemIdx) {
      return _c('v-col', {
        key: button.id,
        staticClass: "button-item d-flex align-center justify-center",
        class: {
          selected: button.id === _vm.selected,
          top: rowIdx === 0,
          left: itemIdx === 0,
          bottom: rowIdx === _vm.rows.length - 1,
          right: itemIdx === row.length - 1,
          disabled: button.disabled
        },
        attrs: {
          "cols": Math.floor(12 / _vm.cols),
          "data-qa": "item-" + _vm.buttons.indexOf(button)
        },
        on: {
          "click": function ($event) {
            return _vm.onSelected(button.id);
          }
        }
      }, [_c('div', {
        staticClass: "button-label"
      }, [_vm._v("\n        " + _vm._s(button.label) + "\n      ")])]);
    }), 1);
  }), 1);
};

var __vue_staticRenderFns__$1g = [];
/* style */

const __vue_inject_styles__$1l = function (inject) {
  if (!inject) return;
  inject("data-v-6d489dc8_0", {
    source: ".VcButtonGroup[data-v-6d489dc8]{font-weight:var(--font-weight-medium2);font-size:13px}.VcButtonGroup .button-group-row[data-v-6d489dc8]{margin:0}.VcButtonGroup .button-item[data-v-6d489dc8]{cursor:pointer;transition:.3s background-color,color ease-out;min-height:40px;border-color:#d6dbe6;border-style:solid;border-width:0;color:rgba(0,0,0,.62);border-right-width:1px;border-bottom-width:1px;padding:0 12px}.VcButtonGroup .button-item .button-label[data-v-6d489dc8]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.VcButtonGroup .button-item.left[data-v-6d489dc8]{border-left-width:1px}.VcButtonGroup .button-item.top[data-v-6d489dc8]{border-top-width:1px}.VcButtonGroup .button-item.bottom[data-v-6d489dc8]:not(.top):not(.selected){border-top-width:0}.VcButtonGroup .button-item.top.left[data-v-6d489dc8]{border-top-left-radius:6px}.VcButtonGroup .button-item.top.right[data-v-6d489dc8]{border-top-right-radius:6px}.VcButtonGroup .button-item.bottom.left[data-v-6d489dc8]{border-bottom-left-radius:6px}.VcButtonGroup .button-item.bottom.right[data-v-6d489dc8]{border-bottom-right-radius:6px}.VcButtonGroup .button-item[data-v-6d489dc8]:hover{background-color:rgba(0,0,0,.03)}.VcButtonGroup .button-item[data-v-6d489dc8]:focus{box-shadow:0 0 0 3px var(--v-secondary-lighten1)}.VcButtonGroup .button-item.selected[data-v-6d489dc8]{border:2px solid var(--v-secondary-base);font-weight:600}.VcButtonGroup .button-item.selected[data-v-6d489dc8]:hover{background:rgba(0,0,0,.03)}.VcButtonGroup .button-item[data-v-6d489dc8]:active{background:rgba(0,0,0,.12)}.VcButtonGroup .button-item.disabled[data-v-6d489dc8]{background:rgba(0,0,0,.07);color:rgba(0,0,0,.4);pointer-events:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1l = "data-v-6d489dc8";
/* module identifier */

const __vue_module_identifier__$1l = undefined;
/* functional template */

const __vue_is_functional_template__$1l = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$27 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1g,
  staticRenderFns: __vue_staticRenderFns__$1g
}, __vue_inject_styles__$1l, __vue_script__$1l, __vue_scope_id__$1l, __vue_is_functional_template__$1l, __vue_module_identifier__$1l, false, createInjector, undefined, undefined);

var __vue_component__$28 = __vue_component__$27;

var script$1k = {
  name: 'VcListEntity',
  components: {
    VcSwitch,
    VContainer: VContainer
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      default: 'VcListEntity'
    }
  }
};

/* script */
const __vue_script__$1k = script$1k;
/* template */

var __vue_render__$1f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "listEntity",
    attrs: {
      "id": "container",
      "data-qa": _vm.dataQa
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "d-flex justify-space-between align-center sl-row",
    class: {
      'margin-start': _vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('div', {
    staticClass: "justify-start d-flex align-center"
  }, [_vm._t("icon"), _vm._v(" "), _c('div', {
    staticClass: "sl-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('VcSwitch', {
    attrs: {
      "disabled": _vm.disabled,
      "ripple": false,
      "value": _vm.value,
      "color": "secondary"
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', Boolean(val));
      }
    }
  })], 1)])])], 1);
};

var __vue_staticRenderFns__$1f = [];
/* style */

const __vue_inject_styles__$1k = function (inject) {
  if (!inject) return;
  inject("data-v-68906724_0", {
    source: ".listEntity .sl-title{font-size:var(--font-size-x-small);line-height:var(--size-value4);font-weight:var(--font-weight-medium2);margin:0 8px}.listEntity .sl-row{min-width:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1k = undefined;
/* module identifier */

const __vue_module_identifier__$1k = undefined;
/* functional template */

const __vue_is_functional_template__$1k = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$25 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1f,
  staticRenderFns: __vue_staticRenderFns__$1f
}, __vue_inject_styles__$1k, __vue_script__$1k, __vue_scope_id__$1k, __vue_is_functional_template__$1k, __vue_module_identifier__$1k, false, createInjector, undefined, undefined);

var __vue_component__$26 = __vue_component__$25;

var script$1j = {
  name: 'VcExpansionCard',
  components: {
    VcImage,
    VcIcon,
    VcSwitch,
    VContainer: VContainer
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    toLogo: {
      type: String,
      required: false,
      default: ''
    },
    fromLogo: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      default: 'VcExpansionCard'
    }
  }
};

/* script */
const __vue_script__$1j = script$1j;
/* template */

var __vue_render__$1e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "expansionCard",
    class: {
      'is-active': _vm.value
    },
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('v-container', {
    staticClass: "expansion-card-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "expansionCardTitle d-flex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "logo-area justify-start d-flex align-center"
  }, [_c('VcImage', {
    staticClass: "VcLogoImage",
    attrs: {
      "image": _vm.fromLogo
    }
  }), _vm._v(" "), _c('VcIcon', {
    attrs: {
      "size": "12"
    }
  }, [_vm._v(" $chevron_right ")]), _vm._v(" "), _c('VcImage', {
    staticClass: "VcLogoImage",
    attrs: {
      "image": _vm.toLogo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-end",
    class: {
      'order-2': _vm.$vuetify.breakpoint.mdAndUp
    },
    staticStyle: {
      "width": "initial"
    }
  }, [_c('VcSwitch', {
    attrs: {
      "disabled": _vm.disabled,
      "ripple": false,
      "icon": "",
      "value": _vm.value,
      "color": "secondary"
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', Boolean(val));
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex ec-text",
    class: {
      'order-1 justify-start': _vm.$vuetify.breakpoint.mdAndUp,
      'full-width': !_vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('div', {
    staticClass: "ec-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })])]), _vm._v(" "), _vm.value ? _c('div', {
    staticClass: "default-slot-content"
  }, [_vm._t("default")], 2) : _vm._e()])], 1);
};

var __vue_staticRenderFns__$1e = [];
/* style */

const __vue_inject_styles__$1j = function (inject) {
  if (!inject) return;
  inject("data-v-215b5c94_0", {
    source: ".expansionCard[data-v-215b5c94]{border-radius:var(--border-radius);border:1px solid;border-color:var(--gray-lighten-1)!important;margin:var(--size-value5) 0}.expansionCard.is-active[data-v-215b5c94]{border-color:var(--v-secondary-base)!important}.expansionCard .ec-title[data-v-215b5c94]{font-size:var(--font-size-small2);line-height:var(--size-value6);margin:var(--size-value3) 0}@media screen and (min-width:960px){.expansionCard .ec-title[data-v-215b5c94]{padding-inline-start:35px}}.expansionCard .VcLogoImage[data-v-215b5c94]{width:var(--size-value7);height:var(--size-value7);margin:0 6px;box-sizing:border-box;border-radius:6px}.expansionCard .ec-text.full-width[data-v-215b5c94]{width:100%}.expansionCard .ec-text.order-1[data-v-215b5c94]{flex-grow:1}.expansionCard .expansion-card-container[data-v-215b5c94]{padding:var(--size-value4)}@media screen and (min-width:960px){.expansionCard .expansion-card-container[data-v-215b5c94]{padding:var(--size-value4) var(--size-value6)}}.expansionCard .default-slot-content[data-v-215b5c94]{max-height:10000px;transition:max-height;transition-duration:.3s;overflow:hidden}.expansionCard .default-slot-content.hidden[data-v-215b5c94]{max-height:0}@media screen and (min-width:960px){.expansionCard .default-slot-content[data-v-215b5c94]{padding-inline-start:108px}}.expansionCardTitle[data-v-215b5c94]{min-width:100%}.logo-area[data-v-215b5c94]{min-width:92px}",
    map: undefined,
    media: undefined
  }), inject("data-v-215b5c94_1", {
    source: ".expansionCard .vc-chevron-right{fill:var(--gray-darken-1)!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1j = "data-v-215b5c94";
/* module identifier */

const __vue_module_identifier__$1j = undefined;
/* functional template */

const __vue_is_functional_template__$1j = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$23 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1e,
  staticRenderFns: __vue_staticRenderFns__$1e
}, __vue_inject_styles__$1j, __vue_script__$1j, __vue_scope_id__$1j, __vue_is_functional_template__$1j, __vue_module_identifier__$1j, false, createInjector, undefined, undefined);

var __vue_component__$24 = __vue_component__$23;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1i = {
  components: {
    VTextarea: VTextarea
  },

  name: 'VcTextArea',

  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    rules: {
      type: Array
    },
    dataQa: {
      type: String,
      default: 'vc-text-area'
    },

    /**
     * pass false to remove the counter, or pass a string/number value to set the counter value
     */
    counter: {
      type: [Boolean, Number, String],
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    messages: {
      type: [String, Boolean],
      default: ''
    },
    autoGrow: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    noResize: {
      type: Boolean,
      default: false
    },
    height: {
      type: [Number, String],
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    persistentHint: {
      type: Boolean,
      default: true
    }
  }
};

/* script */
const __vue_script__$1i = script$1i;
/* template */

var __vue_render__$1d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-textarea', {
    staticClass: "VcTextArea",
    class: {
      'no-label': !_vm.label
    },
    attrs: {
      "dense": "",
      "primary": "",
      "messages": _vm.messages,
      "rows": _vm.rows,
      "label": _vm.label,
      "rules": _vm.rules,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "hide-details": "auto",
      "disabled": _vm.disabled,
      "counter": _vm.counter,
      "data-qa": _vm.dataQa,
      "auto-grow": _vm.autoGrow,
      "no-resize": _vm.noResize,
      "height": _vm.height,
      "hint": _vm.hint,
      "persistent-hint": _vm.persistentHint
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return function (event) {
          return _vm.$emit('keydown-enter', event);
        }.apply(null, arguments);
      },
      "input": function (data) {
        return _vm.$emit('input', data);
      },
      "focus": function ($event) {
        return _vm.$emit('focus');
      },
      "blur": function ($event) {
        return _vm.$emit('blur', $event);
      }
    }
  });
};

var __vue_staticRenderFns__$1d = [];
/* style */

const __vue_inject_styles__$1i = function (inject) {
  if (!inject) return;
  inject("data-v-39bb95d4_0", {
    source: "[data-v-39bb95d4].VcTextArea.v-text-field .v-text-field__slot:first-child{margin-inline-start:var(--size-value3);margin-inline-end:var(--size-value4);margin-top:3px;margin-bottom:var(--size-value3);height:100%}[data-v-39bb95d4].VcTextArea.v-text-field.v-input--is-focused label,[data-v-39bb95d4].VcTextArea.v-text-field.v-input--is-label-active label{font-size:12px;color:rgba(0,0,0,.62)!important;transform:translateY(-18px) scale(.85)}[data-v-39bb95d4].VcTextArea.v-text-field.v-input--is-focused .v-input__slot{border-color:var(--v-secondary-base);box-shadow:0 0 0 3px var(--v-secondary-lighten1);transition:box-shadow .1s!important}[data-v-39bb95d4].VcTextArea.v-text-field:not(.v-text-field--outlined) .v-text-field__slot{transition:margin-bottom .1s}[data-v-39bb95d4].VcTextArea.v-text-field:not(.v-text-field--outlined).v-input--is-focused label,[data-v-39bb95d4].VcTextArea.v-text-field:not(.v-text-field--outlined).v-input--is-label-active label{font-size:12px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.17;letter-spacing:-.3px;color:rgba(0,0,0,.62)!important;transform:translateY(-100%) scale(.85);top:24px}[data-v-39bb95d4].VcTextArea.v-text-field .v-input__slot{border-radius:6px;background-color:#fff!important;position:relative!important;border:solid 1px rgba(0,0,0,.12);transition:border-color .1s!important;caret-color:var(--gray-darken-3)}[data-v-39bb95d4].VcTextArea.v-text-field .v-input__slot:hover:not(.v-input--is-focused.v-input__slot):not(.error--text.v-input__slot){border-color:#757575}[data-v-39bb95d4].VcTextArea.v-text-field .v-input__slot:after,[data-v-39bb95d4].VcTextArea.v-text-field .v-input__slot:before{display:none}[data-v-39bb95d4].VcTextArea.v-text-field textarea{font-size:15px!important;font-weight:500;line-height:1.5;margin-top:20px}[data-v-39bb95d4].VcTextArea.v-text-field.no-label textarea{margin-top:var(--size-value2)}[data-v-39bb95d4].VcTextArea.v-text-field .v-text-field__prefix{color:rgba(0,0,0,.54)!important}[data-v-39bb95d4].VcTextArea.v-text-field.error--text .v-input__slot{border:1px solid var(--v-danger-base);box-shadow:none}[data-v-39bb95d4].VcTextArea.v-text-field.v-input--is-disabled .v-input__slot{background-color:rgba(0,0,0,.03)!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1i = "data-v-39bb95d4";
/* module identifier */

const __vue_module_identifier__$1i = undefined;
/* functional template */

const __vue_is_functional_template__$1i = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$21 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1d,
  staticRenderFns: __vue_staticRenderFns__$1d
}, __vue_inject_styles__$1i, __vue_script__$1i, __vue_scope_id__$1i, __vue_is_functional_template__$1i, __vue_module_identifier__$1i, false, createInjector, undefined, undefined);

var __vue_component__$22 = __vue_component__$21;

var script$1h = {
  name: 'VcSelectField',
  components: {
    VcIconWithTooltip,
    VcIcon,
    VSelect: VSelect
  },
  props: {
    dataQa: {
      type: String,
      default: 'vc-select-field'
    },
    preSelection: {
      type: Object,
      required: false
    },
    rules: {
      type: Array
    },
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    tooltipHeader: {
      type: String,
      default: ''
    },
    tooltipContent: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    messages: {
      type: [String, Array],
      default: ''
    },
    errorMessages: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipNudgeLeft: {
      type: Number,
      default: 0
    },
    tooltipNudgeRight: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'large',
      validator: value => ['medium', 'large'].includes(value)
    },
    top: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    menuProps() {
      let contentClass = 'vc-select-field-menu';
      if (this.top) contentClass += ' top';
      return {
        'offset-y': true,
        contentClass,
        closeOnClick: true,
        top: this.top
      };
    }

  },
  methods: {
    selectionChanged(selection) {
      this.$emit('selection-changed', selection);
    }

  }
};

/* script */
const __vue_script__$1h = script$1h;
/* template */

var __vue_render__$1c = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-select', {
    staticClass: "VcSelectField",
    class: (_obj = {
      'with-tooltip': _vm.tooltipContent
    }, _obj[_vm.size] = true, _obj.top = _vm.top, _obj),
    attrs: {
      "dense": "",
      "outlined": "",
      "return-object": "",
      "hide-details": "auto",
      "item-color": "var(--gray-darken-5)",
      "readonly": _vm.readonly,
      "label": _vm.label,
      "items": _vm.items,
      "rules": _vm.rules,
      "data-qa": _vm.dataQa,
      "messages": _vm.messages,
      "error-messages": _vm.errorMessages,
      "disabled": _vm.disabled,
      "value": _vm.preSelection,
      "menu-props": _vm.menuProps,
      "placeholder": _vm.placeholder
    },
    on: {
      "change": _vm.selectionChanged
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_vm._t("prepend"), _vm._v(" "), _c('div', {
          staticClass: "dropdown-arrow d-flex align-center justify-center"
        }, [_c('VcIcon', {
          staticClass: "icon",
          attrs: {
            "size": "9",
            "color": "var(--gray-darken-2)"
          }
        }, [_vm._v(" $caret_down ")])], 1), _vm._v(" "), _vm.tooltipContent ? _c('div', {
          staticClass: "tooltip d-flex align-center"
        }, [_c('VcIconWithTooltip', {
          attrs: {
            "header": _vm.tooltipHeader,
            "content": _vm.tooltipContent,
            "nudge-left": _vm.tooltipNudgeLeft,
            "nudge-right": _vm.tooltipNudgeRight,
            "size": 15,
            "icon": 'question'
          }
        })], 1) : _vm._e()];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (data) {
        return [data.item.icon ? _c('VcIcon', {
          staticClass: "prepend-item-icon",
          attrs: {
            "size": "20"
          }
        }, [_vm._v("\n      " + _vm._s(data.item.icon) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "option-text"
        }, [_vm._v(_vm._s(data.item.text))])];
      }
    }, {
      key: "selection",
      fn: function (data) {
        return [data.item.icon ? _c('VcIcon', {
          staticClass: "prepend-item-icon",
          attrs: {
            "size": "20"
          }
        }, [_vm._v("\n      " + _vm._s(data.item.icon) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "selection-text",
          class: {
            'selection-text--disabled': _vm.disabled
          }
        }, [_vm._v(_vm._s(data.item.text))])];
      }
    }], null, true)
  });
};

var __vue_staticRenderFns__$1c = [];
/* style */

const __vue_inject_styles__$1h = function (inject) {
  if (!inject) return;
  inject("data-v-9d6b2e42_0", {
    source: "[data-v-9d6b2e42]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-9d6b2e42]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-9d6b2e42]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-9d6b2e42]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-9d6b2e42]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-9d6b2e42]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-9d6b2e42]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-9d6b2e42]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-9d6b2e42]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-9d6b2e42]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-9d6b2e42]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-9d6b2e42]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-9d6b2e42]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-9d6b2e42]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-9d6b2e42]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-9d6b2e42]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-9d6b2e42]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-9d6b2e42]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-9d6b2e42]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-9d6b2e42]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-9d6b2e42]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-9d6b2e42]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-9d6b2e42]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-9d6b2e42]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-9d6b2e42]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-9d6b2e42]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-9d6b2e42]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-9d6b2e42]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-9d6b2e42]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-9d6b2e42]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-9d6b2e42]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-9d6b2e42]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-9d6b2e42]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-9d6b2e42]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-9d6b2e42]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-9d6b2e42]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-9d6b2e42]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-9d6b2e42]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-9d6b2e42]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-9d6b2e42]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-9d6b2e42]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-9d6b2e42]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-9d6b2e42]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-9d6b2e42]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-9d6b2e42]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-9d6b2e42]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-9d6b2e42]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-9d6b2e42]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-9d6b2e42]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-9d6b2e42]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-9d6b2e42]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-9d6b2e42]{--color-dark:#63757e;--color-light:#c8d2d7}.VcSelectField.large .selection-text[data-v-9d6b2e42]{font-size:var(--font-size-small2)}.VcSelectField.large[data-v-9d6b2e42]  fieldset{height:var(--select-field-height)}.VcSelectField.medium .selection-text[data-v-9d6b2e42]{font-size:13px}.VcSelectField.medium[data-v-9d6b2e42]  fieldset{top:0;height:var(--select-field-height-md)}.VcSelectField.medium[data-v-9d6b2e42]  .v-select__slot{max-height:32px}.VcSelectField.medium[data-v-9d6b2e42]  .v-select__slot .v-select__selections{max-height:32px}.VcSelectField[data-v-9d6b2e42]{border-radius:var(--border-radius)}.VcSelectField[data-v-9d6b2e42] .icon{fill:var(--gray-darken-2)}.VcSelectField[data-v-9d6b2e42] fieldset{background:var(--modal-bg-color);border-color:var(--gray-lighten-1);transition:border-color .1s}.VcSelectField[data-v-9d6b2e42] .v-label--active{transform:translateY(-8px) scale(.75)!important}.VcSelectField[data-v-9d6b2e42] .v-label{color:var(--gray-darken-3)!important}.VcSelectField[data-v-9d6b2e42] .v-select__slot label+div{position:absolute;top:10px}.VcSelectField[data-v-9d6b2e42]:hover fieldset{border-color:var(--gray-darken-3)}.VcSelectField[data-v-9d6b2e42].v-input--is-disabled fieldset{background-color:var(--gray-lighten-3)}.VcSelectField[data-v-9d6b2e42].v-input--is-focused fieldset{border:1px solid var(--v-secondary-base)!important;transition:outline .1s,border-color .1s;outline:var(--v-secondary-lighten1) solid 3px}.VcSelectField[data-v-9d6b2e42].v-input--is-focused fieldset input{color:var(--gray-darken-3)}.VcSelectField[data-v-9d6b2e42].error--text fieldset{border:1px solid var(--red);transition:border-color .1s}.VcSelectField[data-v-9d6b2e42] .v-text-field__details{padding-inline-start:0}.VcSelectField[data-v-9d6b2e42] .v-text-field__details .v-messages__message{margin-top:10px}.VcSelectField[data-v-9d6b2e42] legend{display:none}.VcSelectField[data-v-9d6b2e42] .v-select__selection--comma{font-size:15px;font-weight:500}.VcSelectField[data-v-9d6b2e42].with-tooltip .v-select__selection{max-width:75%}.VcSelectField[data-v-9d6b2e42] .v-input__append-inner{pointer-events:none;align-content:center;align-items:center;margin-top:5px!important;height:75%}.VcSelectField[data-v-9d6b2e42] .dropdown-arrow{width:var(--size-value5);height:var(--size-value5)}.VcSelectField[data-v-9d6b2e42] .tooltip{padding-inline-start:var(--size-value3);margin-inline-start:var(--size-value3);border-inline-start:1px solid var(--gray-lighten-1);height:100%}.prepend-item-icon[data-v-9d6b2e42]{margin-inline-end:var(--size-value2)}.option-text[data-v-9d6b2e42],.selection-text[data-v-9d6b2e42]{font-weight:var(--font-weight-medium2)}.option-text[data-v-9d6b2e42]{font-size:var(--font-size-x-small)}.selection-text[data-v-9d6b2e42]{color:var(--gray-darken-5)}.selection-text--disabled[data-v-9d6b2e42]{color:var(--gray-darken-3)}.v-select--is-menu-active .dropdown-arrow span[data-v-9d6b2e42]{transform:rotate(180deg)}",
    map: undefined,
    media: undefined
  }), inject("data-v-9d6b2e42_1", {
    source: ".vc-select-field-menu:not(.top){margin-top:14px}.v-list-item:active{background-color:var(--v-secondary-lighten3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1h = "data-v-9d6b2e42";
/* module identifier */

const __vue_module_identifier__$1h = undefined;
/* functional template */

const __vue_is_functional_template__$1h = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$20 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1c,
  staticRenderFns: __vue_staticRenderFns__$1c
}, __vue_inject_styles__$1h, __vue_script__$1h, __vue_scope_id__$1h, __vue_is_functional_template__$1h, __vue_module_identifier__$1h, false, createInjector, undefined, undefined);

var VcSelectField = __vue_component__$20;

var script$1g = {
  name: 'VcToast',
  components: {
    VcAlert,
    VSnackbar: VSnackbar
  },
  props: {
    /**
        Controls whether or not the toast is currently displayed, part of the v-model two way binding mechanism
       */
    value: {
      type: Boolean,
      default: false
    },

    /**
     * Set this prop to change the timeout of a specific toast instance.
     * The default value is 3000.
     * To change the timeout across the project, use the toastTimeout configuration when initializing the project.
     */
    timeout: {
      type: Number,
      required: false
    }
  },
  computed: {
    computedTimeout() {
      return this.timeout || this.$ds.toastTimeout || 3000;
    }

  }
};

/* script */
const __vue_script__$1g = script$1g;
/* template */

var __vue_render__$1b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-snackbar', {
    attrs: {
      "value": _vm.value || false,
      "timeout": _vm.computedTimeout,
      "bottom": "",
      "left": !_vm.$vuetify.rtl,
      "right": _vm.$vuetify.rtl,
      "transition": "scroll-y-reverse-transition"
    },
    on: {
      "input": function (newValue) {
        return _vm.$emit('input', newValue);
      }
    }
  }, [_c('VcAlert', _vm._b({
    attrs: {
      "width": 288,
      "is-stripe": false
    }
  }, 'VcAlert', _vm.$attrs, false))], 1);
};

var __vue_staticRenderFns__$1b = [];
/* style */

const __vue_inject_styles__$1g = function (inject) {
  if (!inject) return;
  inject("data-v-e80b33f6_0", {
    source: ".v-snack--right[data-v-e80b33f6]{direction:ltr}.v-snack--right[data-v-e80b33f6]  .v-snack__wrapper{direction:rtl}[data-v-e80b33f6] .v-snack__action{display:none}[data-v-e80b33f6] .v-snack__wrapper.theme--dark{background-color:transparent;min-height:unset;min-width:unset;margin:16px}@media screen and (min-width:960px){[data-v-e80b33f6] .v-snack__wrapper.theme--dark{margin:24px}}[data-v-e80b33f6] .v-alert{margin-bottom:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1g = "data-v-e80b33f6";
/* module identifier */

const __vue_module_identifier__$1g = undefined;
/* functional template */

const __vue_is_functional_template__$1g = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1b,
  staticRenderFns: __vue_staticRenderFns__$1b
}, __vue_inject_styles__$1g, __vue_script__$1g, __vue_scope_id__$1g, __vue_is_functional_template__$1g, __vue_module_identifier__$1g, false, createInjector, undefined, undefined);

var __vue_component__$1$ = __vue_component__$1_;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1f = {
  components: {
    VCard: VCard
  },

  name: 'VcCard',

  props: {
    dataQa: {
      type: String,
      default: 'VcCard'
    },
    elevation: {
      type: Boolean,
      default: true
    },
    dashColor: {
      type: String,
      default: ''
    },
    clickable: {
      type: Boolean,
      default: true
    }
  }
};

/* script */
const __vue_script__$1f = script$1f;
/* template */

var __vue_render__$1a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-card', {
    staticClass: "VcCard rounded",
    class: {
      elevation: _vm.elevation,
      dash: _vm.dashColor,
      clickable: _vm.clickable
    },
    attrs: {
      "tile": "",
      "outlined": !_vm.elevation,
      "ripple": false,
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        _vm.clickable && _vm.$emit('onClick');
      }
    }
  }, [_vm.dashColor ? _c('hr', {
    staticClass: "VcCard__dash",
    style: {
      'background-color': _vm.dashColor
    },
    attrs: {
      "data-qa": "dash"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$1a = [];
/* style */

const __vue_inject_styles__$1f = function (inject) {
  if (!inject) return;
  inject("data-v-01f7cee2_0", {
    source: ".VcCard[data-v-01f7cee2]{position:relative;padding:var(--size-value4) var(--size-value6);border:1px solid var(--gray-lighten-1);box-sizing:border-box;box-shadow:none;overflow:hidden;transition:box-shadow .4s}.VcCard[data-v-01f7cee2]:not(.clickable){cursor:default}.VcCard[data-v-01f7cee2]:not(.clickable)::before{opacity:0}.VcCard.elevation[data-v-01f7cee2]{border:0;box-shadow:var(--shadow-2)}.VcCard.elevation[data-v-01f7cee2]:hover{box-shadow:var(--shadow-5)}.VcCard.dash[data-v-01f7cee2]{border-top:0}.VcCard__dash[data-v-01f7cee2]{position:absolute;top:0;left:-5px;width:110%;border:0;height:5px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1f = "data-v-01f7cee2";
/* module identifier */

const __vue_module_identifier__$1f = undefined;
/* functional template */

const __vue_is_functional_template__$1f = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1a,
  staticRenderFns: __vue_staticRenderFns__$1a
}, __vue_inject_styles__$1f, __vue_script__$1f, __vue_scope_id__$1f, __vue_is_functional_template__$1f, __vue_module_identifier__$1f, false, createInjector, undefined, undefined);

var __vue_component__$1Z = __vue_component__$1Y;

var script$1e = {
  name: 'VcFilterPanel',
  components: {
    VcLayout,
    VcIcon,
    VcButton,
    VcLoader
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    flavor: {
      type: String,
      default: 'primary',
      validator: prop => ['primary', 'secondary'].includes(prop)
    },
    shouldDisplayHeader: {
      type: Boolean,
      default: true
    },
    dataQa: {
      type: String,
      default: 'VcFilterPanel'
    }
  }
};

/* script */
const __vue_script__$1e = script$1e;
/* template */

var __vue_render__$19 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcFilterPanel",
    class: "vc-" + _vm.flavor,
    attrs: {
      "column": "",
      "align-content-space-between": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    staticClass: "VcFilterPanel-container",
    attrs: {
      "column": ""
    }
  }, [_vm.shouldDisplayHeader ? _c('VcLayout', {
    staticClass: "VcFilterPanel-header"
  }, [_c('div', {
    staticClass: "filter"
  }, [_vm._t("header", function () {
    return [_c('span', {
      staticClass: "filter-label",
      class: {
        'with-close-button': _vm.showCloseButton
      }
    }, [_vm._v(_vm._s(_vm.title))])];
  })], 2)]) : _vm._e(), _vm._v(" "), _vm.showCloseButton ? _c('VcButton', {
    staticClass: "VcFilterPanel-close-button",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v(" $close_button ")])];
      },
      proxy: true
    }], null, false, 2274872497)
  }) : _vm._e(), _vm._v(" "), _c('VcLayout', {
    staticClass: "VcFilterPanel-content-wrapper",
    attrs: {
      "column": ""
    }
  }, [_vm.isLoading ? _c('VcLoader', {
    staticClass: "filter-loader"
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('VcLayout', {
    staticClass: "VcFilterPanel-footer",
    attrs: {
      "align-end": ""
    }
  }, [_vm._t("footer")], 2)], 1)], 1);
};

var __vue_staticRenderFns__$19 = [];
/* style */

const __vue_inject_styles__$1e = function (inject) {
  if (!inject) return;
  inject("data-v-1f5e208b_0", {
    source: ".VcFilterPanel[data-v-1f5e208b]{width:100%;background-color:#fff;min-height:150px;height:100vh}@media screen and (min-width:960px){.VcFilterPanel[data-v-1f5e208b]{height:100%;border-inline-end:1px solid var(--gray-lighten-1)}}.VcFilterPanel .filter-loader[data-v-1f5e208b]{margin:var(--size-value8) auto auto auto}.VcFilterPanel .VcFilterPanel-container[data-v-1f5e208b]{max-height:100%;overflow:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none}.VcFilterPanel .VcFilterPanel-container[data-v-1f5e208b]::-webkit-scrollbar{width:0;height:0}.VcFilterPanel .VcFilterPanel-container.column[data-v-1f5e208b]{position:relative}.VcFilterPanel .VcFilterPanel-container .VcFilterPanel-header[data-v-1f5e208b]{flex:0 0 56px}.VcFilterPanel .filter[data-v-1f5e208b]{min-width:100%;border-bottom:1px solid var(--gray);line-height:var(--size-value14);background-color:var(--neutral-lighten-3)}.VcFilterPanel .filter .filter-label[data-v-1f5e208b]{padding-inline-start:var(--size-value6);font-size:var(--font-size-small2);font-weight:var(--font-weight-large);color:var(--gray-darken-5)}.VcFilterPanel .filter .filter-label.with-close-button[data-v-1f5e208b]{padding-inline-end:var(--size-value12)}.VcFilterPanel.vc-secondary .filter[data-v-1f5e208b]{border-bottom:none;background-color:var(--modal-bg-color)}.VcFilterPanel.vc-secondary .filter .filter-label[data-v-1f5e208b]{font-weight:700;font-size:18px}.VcFilterPanel .VcFilterPanel-content-wrapper[data-v-1f5e208b]{overflow-y:auto;overflow-x:hidden}.VcFilterPanel .VcFilterPanel-footer[data-v-1f5e208b]{width:100%}.VcFilterPanel .VcFilterPanel-close-button[data-v-1f5e208b]{position:absolute;width:var(--size-value6);height:var(--size-value6);top:var(--size-value4);right:var(--size-value4)}#app[dir=rtl] .VcFilterPanel .VcFilterPanel-close-button[data-v-1f5e208b]{right:auto;left:var(--size-value4)}.VcFilterPanel .VcFilterPanel-close-button .v-btn__content[data-v-1f5e208b]{opacity:unset}.VcFilterPanel .VcFilterPanel-close-button[data-v-1f5e208b]:hover{background-color:rgba(0,0,0,.07)}.VcFilterPanel .VcFilterPanel-close-button .v-icon[data-v-1f5e208b]{margin-right:var(--size-value0)}.VcFilterPanel .VcFilterPanel-close-button .v-icon svg[data-v-1f5e208b]{fill:var(--gray-darken-2);width:var(--size-value4);height:var(--size-value4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1e = "data-v-1f5e208b";
/* module identifier */

const __vue_module_identifier__$1e = undefined;
/* functional template */

const __vue_is_functional_template__$1e = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$19,
  staticRenderFns: __vue_staticRenderFns__$19
}, __vue_inject_styles__$1e, __vue_script__$1e, __vue_scope_id__$1e, __vue_is_functional_template__$1e, __vue_module_identifier__$1e, false, createInjector, undefined, undefined);

var __vue_component__$1X = __vue_component__$1W;

//
//
//
//
//
//
var script$1d = {
  components: {
    VLayout: VLayout
  },

  name: 'VcFocusArea',

  props: {
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md'].includes(value)
    },
    dataQa: {
      type: String,
      default: 'VcFocusArea'
    }
  }
};

/* script */
const __vue_script__$1d = script$1d;
/* template */

var __vue_render__$18 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-layout', {
    class: "VcFocusArea " + _vm.size,
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$18 = [];
/* style */

const __vue_inject_styles__$1d = function (inject) {
  if (!inject) return;
  inject("data-v-8d9844be_0", {
    source: ".VcFocusArea[data-v-8d9844be]{padding:var(--size-value4);background-color:var(--gray-lighten-3);border-radius:6px}.VcFocusArea.sm[data-v-8d9844be]{padding:var(--size-value3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1d = "data-v-8d9844be";
/* module identifier */

const __vue_module_identifier__$1d = undefined;
/* functional template */

const __vue_is_functional_template__$1d = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$18,
  staticRenderFns: __vue_staticRenderFns__$18
}, __vue_inject_styles__$1d, __vue_script__$1d, __vue_scope_id__$1d, __vue_is_functional_template__$1d, __vue_module_identifier__$1d, false, createInjector, undefined, undefined);

var VcFocusArea = __vue_component__$1V;

var script$1c = {
  name: 'VcListItem',
  components: {
    VcLayout,
    VcCheckbox,
    VcActions
  },
  props: {
    showSelect: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => [],
      validator: prop => prop.every(e => e.title && e.event)
    },
    value: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcListItem'
    }
  }
};

/* script */
const __vue_script__$1c = script$1c;
/* template */

var __vue_render__$17 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcListItem",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm.showSelect ? _c('VcCheckbox', {
    staticClass: "selected-checkbox shrink mr-0 mt-0 pt-0",
    attrs: {
      "value": _vm.value
    },
    on: {
      "change": function (newVal) {
        return _vm.$emit('onSelectClicked', newVal);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('VcLayout', {
    attrs: {
      "data-qa": "VcListItem-content"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('VcLayout', {
    staticClass: "right-area"
  }, [_vm._t("further-actions"), _vm._v(" "), _vm.actions.length > 0 ? _c('VcActions', {
    attrs: {
      "items": _vm.actions
    },
    on: {
      "action": function (item) {
        return _vm.$emit(item);
      }
    }
  }) : _c('div', {
    staticClass: "placeholder"
  })], 2)], 1);
};

var __vue_staticRenderFns__$17 = [];
/* style */

const __vue_inject_styles__$1c = function (inject) {
  if (!inject) return;
  inject("data-v-3974bc76_0", {
    source: ".VcListItem[data-v-3974bc76]{flex-grow:0;padding:var(--size-value6) 0;padding-inline-end:var(--size-value2)}@media screen and (min-width:960px){.VcListItem[data-v-3974bc76]{padding:var(--size-value6) var(--size-value5)}}.VcListItem .selected-checkbox[data-v-3974bc76]{padding-right:var(--size-value1)}.VcListItem .right-area[data-v-3974bc76]{justify-content:flex-end;transition:opacity .3s;flex-grow:0;align-items:center}@media screen and (min-width:960px){.VcListItem .right-area[data-v-3974bc76]{opacity:0}}@media screen and (min-width:960px){.VcListItem .right-area .placeholder[data-v-3974bc76]{min-width:14px}}.VcListItem:hover .right-area[data-v-3974bc76]{opacity:1}.VcListItem .v-btn:not(.v-btn--round).v-size--default[data-v-3974bc76]{padding:0;min-width:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1c = "data-v-3974bc76";
/* module identifier */

const __vue_module_identifier__$1c = undefined;
/* functional template */

const __vue_is_functional_template__$1c = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$17,
  staticRenderFns: __vue_staticRenderFns__$17
}, __vue_inject_styles__$1c, __vue_script__$1c, __vue_scope_id__$1c, __vue_is_functional_template__$1c, __vue_module_identifier__$1c, false, createInjector, undefined, undefined);

var VcListItem = __vue_component__$1U;

var script$1b = {
  name: 'VcGroupHeader',
  components: {
    VcLayout
  },
  props: {
    title: {
      type: String,
      required: true
    },
    summaryText: {
      type: String,
      default: ''
    },
    dataQa: {
      type: String,
      default: 'VcGroupHeader'
    }
  }
};

/* script */
const __vue_script__$1b = script$1b;
/* template */

var __vue_render__$16 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcGroupHeader",
    attrs: {
      "justify-space-between": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.summaryText))])]);
};

var __vue_staticRenderFns__$16 = [];
/* style */

const __vue_inject_styles__$1b = function (inject) {
  if (!inject) return;
  inject("data-v-6e8615ec_0", {
    source: ".VcGroupHeader[data-v-6e8615ec]{width:100%;height:var(--size-value10);flex-grow:0;color:var(--gray-darken-4);background-color:var(--neutral-lighten-3);font-size:var(--font-size-xx-small);font-weight:var(--font-weight-medium2);line-height:var(--size-value10);padding:0 var(--size-value6);border-bottom:1px solid var(--gray-lighten-1)}@media screen and (min-width:960px){.VcGroupHeader[data-v-6e8615ec]{font-size:var(--font-size-xx-small)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1b = "data-v-6e8615ec";
/* module identifier */

const __vue_module_identifier__$1b = undefined;
/* functional template */

const __vue_is_functional_template__$1b = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$16,
  staticRenderFns: __vue_staticRenderFns__$16
}, __vue_inject_styles__$1b, __vue_script__$1b, __vue_scope_id__$1b, __vue_is_functional_template__$1b, __vue_module_identifier__$1b, false, createInjector, undefined, undefined);

var VcGroupHeader = __vue_component__$1T;

//
//
//
//
//
var script$1a = {
  name: 'VcSvg',
  // eslint-disable-next-line vue/require-prop-types
  props: ['svg']
};

/* script */
const __vue_script__$1a = script$1a;
/* template */

var __vue_render__$15 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  });
};

var __vue_staticRenderFns__$15 = [];
/* style */

const __vue_inject_styles__$1a = undefined;
/* scoped */

const __vue_scope_id__$1a = undefined;
/* module identifier */

const __vue_module_identifier__$1a = undefined;
/* functional template */

const __vue_is_functional_template__$1a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$15,
  staticRenderFns: __vue_staticRenderFns__$15
}, __vue_inject_styles__$1a, __vue_script__$1a, __vue_scope_id__$1a, __vue_is_functional_template__$1a, __vue_module_identifier__$1a, false, undefined, undefined, undefined);

var VcSvg = __vue_component__$1S;

var script$19 = {
  name: 'VcBanner',
  components: {
    VcImage,
    VcButton,
    VcIcon,
    VcLink,
    VcSvg
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcBanner'
    },
    image: {
      type: [String, Object],
      required: false
    },
    backgroundColor: {
      type: String,
      default: '#F8F9FB'
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    note: {
      type: String
    },
    linkUrl: {
      type: String,
      default: ''
    },
    linkLabel: {
      type: String,
      default: ''
    },
    buttonLabel: {
      type: String
    },
    closeButton: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$19 = script$19;
/* template */

var __vue_render__$14 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "banner",
    staticClass: "VcBanner d-flex justify-space-between flex-column flex-sm-row",
    style: {
      backgroundColor: _vm.backgroundColor
    },
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('div', {
    staticClass: "text-container px-6 pt-10 pt-sm-6"
  }, [_c('div', {
    staticClass: "banner-title pb-2 pb-sm-4 pb-md-2"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _vm.subtitle ? _c('div', {
    staticClass: "banner-subtitle"
  }, [_vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.buttonLabel || _vm.linkLabel ? _c('div', {
    staticClass: "cta-container py-6 py-sm-7 d-flex flex justify-start flex-wrap"
  }, [_vm.buttonLabel ? _c('VcButton', {
    staticClass: "primary-cta",
    attrs: {
      "pill": "",
      "large": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onAction');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttonLabel) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.linkLabel && _vm.linkUrl ? _c('VcLink', {
    staticClass: "secondary-cta pt-6 pt-sm-0",
    attrs: {
      "url": _vm.linkUrl,
      "label": _vm.linkLabel,
      "data-qa": _vm.dataQa + "-link"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('linkClick', $event);
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.note || _vm.$slots.note ? _c('div', {
    staticClass: "banner-note py-4 pt-sm-9"
  }, [_vm._t("note", function () {
    return [_vm._v("\n        " + _vm._s(_vm.note) + "\n      ")];
  })], 2) : _vm._e()]), _vm._v(" "), _vm.image ? _c('div', {
    staticClass: "images-container d-flex align-self-end"
  }, [_c('VcSvg', {
    staticClass: "background-stain",
    attrs: {
      "svg": _vm.$svgImages.background_stain
    }
  }), _vm._v(" "), _c('VcImage', {
    staticClass: "banner-image pb-0",
    attrs: {
      "image": _vm.image
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.closeButton ? _c('VcButton', {
    staticClass: "close-button mt-6 me-1",
    attrs: {
      "icon": "",
      "data-qa": _vm.dataQa + "-close-btn",
      "fab": "",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('closeBanner');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v(" $close_button ")])];
      },
      proxy: true
    }], null, false, 2274872497)
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$14 = [];
/* style */

const __vue_inject_styles__$19 = function (inject) {
  if (!inject) return;
  inject("data-v-5613040c_0", {
    source: ".VcBanner[data-v-5613040c]{min-height:188px;box-sizing:border-box;overflow:hidden;border-radius:var(--size-value2);border:1px solid var(--neutral-lighten-2);position:relative}.VcBanner .images-container[data-v-5613040c]{position:relative;height:100%}.VcBanner .images-container .background-stain[data-v-5613040c]{position:absolute;opacity:15%;margin:0 auto;overflow:hidden;top:-80px;height:calc(100% + 110px);transform:scale(.7);left:-335px}#app[dir=rtl] .VcBanner .images-container .background-stain[data-v-5613040c]{left:auto;right:-335px}@media screen and (min-width:600px){.VcBanner .images-container .background-stain[data-v-5613040c]{transform:scale(1);top:-206px;height:calc(100% + 206px);left:-64px}#app[dir=rtl] .VcBanner .images-container .background-stain[data-v-5613040c]{left:auto;right:-64px}}@media screen and (min-width:960px){.VcBanner .images-container .background-stain[data-v-5613040c]{top:-176px;height:calc(100% + 176px);left:-50px}#app[dir=rtl] .VcBanner .images-container .background-stain[data-v-5613040c]{left:auto;right:-50px}}#app[dir=rtl] .VcBanner .images-container .background-stain[data-v-5613040c]{transform:scale(-.7,.7)}@media screen and (min-width:600px){#app[dir=rtl] .VcBanner .images-container .background-stain[data-v-5613040c]{transform:scaleX(-1)}}.VcBanner .images-container .background-stain[data-v-5613040c]  #background_stain{fill:var(--v-secondary-base)}.VcBanner .images-container .banner-image[data-v-5613040c]{margin:auto 0 0;position:relative;width:200px;height:95px}@media screen and (min-width:600px){.VcBanner .images-container .banner-image[data-v-5613040c]{width:300px;height:142.5px}}@media screen and (min-width:960px){.VcBanner .images-container .banner-image[data-v-5613040c]{width:400px;height:190px}}.VcBanner .text-container[data-v-5613040c]{flex:0 0 60%;color:var(--gray-darken-5);z-index:1}.VcBanner .text-container .banner-title[data-v-5613040c]{font-weight:var(--font-weight-large2);font-size:var(--font-size-medium2);line-height:var(--size-value8)}@media screen and (min-width:960px){.VcBanner .text-container .banner-title[data-v-5613040c]{flex:0 0 100%}}.VcBanner .text-container .banner-subtitle[data-v-5613040c]{font-size:var(--font-size-small2);line-height:var(--size-value5);font-weight:var(--font-weight-medium2)}.VcBanner .text-container .banner-note[data-v-5613040c]{font-size:var(--font-size-small2);font-weight:var(--font-weight-medium)}.VcBanner .cta-container .primary-cta[data-v-5613040c]{line-height:var(--size-value12);font-weight:var(--font-weight-large2);margin-inline-end:var(--size-value6)}.VcBanner .cta-container .secondary-cta[data-v-5613040c]{font-size:var(--font-size-small2);font-weight:var(--font-weight-large);flex:0 0 100%}@media screen and (min-width:600px){.VcBanner .cta-container .secondary-cta[data-v-5613040c]{flex:none}}.VcBanner .close-button[data-v-5613040c]{position:absolute;width:var(--size-value3);height:var(--size-value3);right:var(--size-value4)}#app[dir=rtl] .VcBanner .close-button[data-v-5613040c]{right:auto;left:var(--size-value4)}.VcBanner .close-button[data-v-5613040c]  .v-btn__content{opacity:unset}.VcBanner .close-button[data-v-5613040c]  .v-icon{margin-right:var(--size-value0)}.VcBanner .close-button[data-v-5613040c]  .v-icon svg{fill:var(--gray-darken-2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$19 = "data-v-5613040c";
/* module identifier */

const __vue_module_identifier__$19 = undefined;
/* functional template */

const __vue_is_functional_template__$19 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$14,
  staticRenderFns: __vue_staticRenderFns__$14
}, __vue_inject_styles__$19, __vue_script__$19, __vue_scope_id__$19, __vue_is_functional_template__$19, __vue_module_identifier__$19, false, createInjector, undefined, undefined);

var __vue_component__$1R = __vue_component__$1Q;

var script$18 = {
  name: 'VcWizardCtaContainer',
  components: {
    VcButton,
    VcLayout
  },
  props: {
    isBackDisplayed: {
      type: Boolean,
      required: true
    },
    isNextButtonDisabled: {
      type: Boolean,
      required: true
    },
    backButtonLabel: {
      type: String,
      required: true
    },
    nextButtonLabel: {
      type: String,
      required: true
    },
    dataQa: {
      type: String,
      default: 'VcWizardCtaContainer'
    }
  }
};

/* script */
const __vue_script__$18 = script$18;
/* template */

var __vue_render__$13 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "wizard-cta-container",
    attrs: {
      "align-center": "",
      "justify-end": ""
    }
  }, [_vm.isBackDisplayed ? _c('vc-button', {
    staticClass: "wizard-cta-button back-button",
    attrs: {
      "color": "white",
      "data-qa": _vm.dataQa + "-wizard-back-button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onBackPressed');
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.backButtonLabel) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('vc-button', {
    staticClass: "wizard-cta-button next-button",
    attrs: {
      "data-qa": _vm.dataQa + "-wizard-next-button",
      "disabled": _vm.isNextButtonDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('moveForward');
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.nextButtonLabel) + "\n  ")])], 1);
};

var __vue_staticRenderFns__$13 = [];
/* style */

const __vue_inject_styles__$18 = function (inject) {
  if (!inject) return;
  inject("data-v-85b59970_0", {
    source: "[data-v-85b59970]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-85b59970]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-85b59970]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-85b59970]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-85b59970]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-85b59970]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-85b59970]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-85b59970]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-85b59970]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-85b59970]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-85b59970]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-85b59970]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-85b59970]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-85b59970]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-85b59970]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-85b59970]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-85b59970]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-85b59970]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-85b59970]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-85b59970]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-85b59970]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-85b59970]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-85b59970]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-85b59970]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-85b59970]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-85b59970]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-85b59970]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-85b59970]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-85b59970]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-85b59970]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-85b59970]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-85b59970]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-85b59970]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-85b59970]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-85b59970]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-85b59970]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-85b59970]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-85b59970]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-85b59970]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-85b59970]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-85b59970]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-85b59970]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-85b59970]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-85b59970]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-85b59970]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-85b59970]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-85b59970]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-85b59970]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-85b59970]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-85b59970]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-85b59970]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-85b59970]{--color-dark:#63757e;--color-light:#c8d2d7}.wizard-cta-container[data-v-85b59970]{background-color:#fff;position:sticky;bottom:0;left:0;width:100%;height:var(--size-value18);max-height:var(--size-value18);padding:var(--size-value3) var(--size-value0);border-top:1px solid var(--gray-lighten-1)}@media screen and (min-width:960px){.wizard-cta-container[data-v-85b59970]{border-top:revert;position:static;width:100%;transform:revert;height:var(--size-value20);max-height:var(--size-value20);padding-bottom:var(--size-value6)}}.wizard-cta-button[data-v-85b59970]{flex:1;min-height:var(--size-value12)}@media screen and (min-width:960px){.wizard-cta-button[data-v-85b59970]{flex:revert;min-height:var(--size-value10)}}.wizard-cta-button+.wizard-cta-button[data-v-85b59970]{margin-inline-start:var(--size-value3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$18 = "data-v-85b59970";
/* module identifier */

const __vue_module_identifier__$18 = undefined;
/* functional template */

const __vue_is_functional_template__$18 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$13,
  staticRenderFns: __vue_staticRenderFns__$13
}, __vue_inject_styles__$18, __vue_script__$18, __vue_scope_id__$18, __vue_is_functional_template__$18, __vue_module_identifier__$18, false, createInjector, undefined, undefined);

var VcWizardCtaContainer = __vue_component__$1P;

var script$17 = {
  name: 'VcStepperContent',
  components: {
    VcLayout,
    VcLoader,
    VStepperContent: VStepperContent,
    VStepperItems: VStepperItems,
    VStepper: VStepper
  },
  model: {
    prop: 'currentStep'
  },
  props: {
    wizardData: {
      type: Object,
      required: true
    },
    currentStep: {
      type: Number,
      default: 1
    },
    steps: {
      type: Array,
      validator: steps => steps.every(step => step.component && step.name),
      required: true
    },
    dataQa: {
      type: String,
      default: 'vc-content-wizard'
    }
  },

  data() {
    return {
      lastCompleted: 0,
      isLoading: true,
      LOADER_SIZE: 48,
      LOADER_COLOR: 'secondary',
      FIRST_STEP: 1
    };
  },

  computed: {
    currentStepObj() {
      return this.steps[this.currentStep - 1];
    },

    getStepName() {
      var _this$currentStepObj;

      const currentStepName = (_this$currentStepObj = this.currentStepObj) === null || _this$currentStepObj === void 0 ? void 0 : _this$currentStepObj.name;

      if (typeof currentStepName === 'function') {
        return currentStepName(this.wizardData);
      }

      return currentStepName;
    },

    getStepDescription() {
      var _this$currentStepObj2;

      const currentStepDescription = (_this$currentStepObj2 = this.currentStepObj) === null || _this$currentStepObj2 === void 0 ? void 0 : _this$currentStepObj2.description;

      if (typeof currentStepDescription === 'function') {
        return currentStepDescription(this.wizardData);
      }

      return currentStepDescription;
    }

  },
  watch: {
    currentStep: {
      handler(newVal, oldVal) {
        this.isLoading = true;

        if (newVal > oldVal) {
          this.nextStep();
        }

        if (newVal < this.FIRST_STEP) {
          this.shareStep(this.FIRST_STEP);
        }
      }

    }
  },

  mounted() {
    this.$nextTick(() => this.isLoading = false);
  },

  updated() {
    this.isLoading = false;
  },

  methods: {
    nextStep() {
      if (this.lastCompleted < this.currentStep) {
        this.lastCompleted = this.currentStep;
      }

      if (this.currentStep > this.steps.length) {
        this.shareStep(this.steps.length);
      }
    },

    getStepQa(idx) {
      return `${this.dataQa}-step-${idx}`;
    },

    shareStep(step) {
      this.$emit('input', step);
    }

  }
};

/* script */
const __vue_script__$17 = script$17;
/* template */

var __vue_render__$12 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('vc-layout', {
    staticClass: "stepper-content-wrapper",
    attrs: {
      "column": "",
      "justify-start": ""
    }
  }, [!_vm.isLoading ? _c('VcLayout', {
    staticClass: "stepper-header",
    attrs: {
      "column": ""
    }
  }, [_c('div', {
    staticClass: "content-stepper-title",
    attrs: {
      "data-qa": _vm.dataQa + "-step-title"
    }
  }, [_vm._v(_vm._s(_vm.getStepName))]), _vm._v(" "), _c('div', {
    staticClass: "content-stepper-description",
    attrs: {
      "data-qa": _vm.dataQa + "-step-description"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.getStepDescription)
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-stepper', {
    staticClass: "vc-stepper-content",
    attrs: {
      "data-qa": _vm.dataQa
    },
    model: {
      value: _vm.currentStep,
      callback: function ($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, [_c('v-stepper-items', _vm._l(_vm.steps, function (step, index) {
    return _c('v-stepper-content', {
      key: "step-" + index,
      attrs: {
        "step": index + 1
      }
    }, [_vm.currentStep === index + 1 ? _c('VcLayout', {
      staticClass: "layout-content",
      attrs: {
        "column": "",
        "justify-center": _vm.isLoading
      }
    }, [_c('VcLoader', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isLoading,
        expression: "isLoading"
      }],
      attrs: {
        "size": _vm.LOADER_SIZE,
        "color": _vm.LOADER_COLOR
      }
    }), _vm._v(" "), _vm._t("alert-" + (index + 1)), _vm._v(" "), _c(step.component, _vm._g(_vm._b({
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isLoading,
        expression: "!isLoading"
      }],
      tag: "component",
      attrs: {
        "data-qa": _vm.getStepQa(index)
      },
      on: {
        "submit": function (data) {
          return _vm.$emit('submit', data);
        },
        "error": function (data) {
          return _vm.$emit('error', data);
        },
        "moveForward": function ($event) {
          return _vm.$emit('moveForward');
        }
      }
    }, 'component', Object.assign({}, _vm.wizardData, step.props), false), step.event))], 2) : _vm._e()], 1);
  }), 1)], 1)], 1);
};

var __vue_staticRenderFns__$12 = [];
/* style */

const __vue_inject_styles__$17 = function (inject) {
  if (!inject) return;
  inject("data-v-78f49002_0", {
    source: "[data-v-78f49002]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-78f49002]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-78f49002]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-78f49002]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-78f49002]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-78f49002]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-78f49002]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-78f49002]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-78f49002]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-78f49002]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-78f49002]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-78f49002]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-78f49002]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-78f49002]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-78f49002]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-78f49002]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-78f49002]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-78f49002]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-78f49002]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-78f49002]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-78f49002]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-78f49002]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-78f49002]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-78f49002]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-78f49002]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-78f49002]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-78f49002]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-78f49002]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-78f49002]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-78f49002]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-78f49002]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-78f49002]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-78f49002]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-78f49002]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-78f49002]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-78f49002]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-78f49002]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-78f49002]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-78f49002]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-78f49002]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-78f49002]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-78f49002]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-78f49002]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-78f49002]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-78f49002]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-78f49002]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-78f49002]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-78f49002]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-78f49002]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-78f49002]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-78f49002]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-78f49002]{--color-dark:#63757e;--color-light:#c8d2d7}.stepper-content-wrapper[data-v-78f49002]{height:100%;width:100%;padding-bottom:var(--size-value6)}@media screen and (min-width:960px){.stepper-content-wrapper[data-v-78f49002]{padding-bottom:var(--size-value0)}}.layout-content[data-v-78f49002]{padding:var(--size-value0) var(--size-value4)}@media screen and (min-width:960px){.layout-content[data-v-78f49002]{padding:revert;padding-block-start:var(--size-value3)}}.stepper-header[data-v-78f49002]{flex:0;margin-block-end:var(--size-value4);padding:var(--size-value0)}@media screen and (min-width:960px){.stepper-header[data-v-78f49002]{padding:revert;flex:revert;padding-block-start:var(--size-value3)}}.stepper-header .content-stepper-title[data-v-78f49002]{letter-spacing:.01em;font-size:var(--font-size-medium);font-weight:var(--font-weight-large);line-height:var(--size-value8);color:var(--gray-darken-5)}@media screen and (min-width:960px){.stepper-header .content-stepper-title[data-v-78f49002]{font-size:var(--font-size-medium2)}}.stepper-header .content-stepper-description[data-v-78f49002]{font-size:var(--font-size-x-small);line-height:var(--size-value5);color:var(--gray-darken-4)}.stepper-header .content-stepper-description[data-v-78f49002]  a{color:var(--blue)}.vc-stepper-content.v-stepper[data-v-78f49002]{width:100%;box-shadow:none;height:100%;overflow:auto}.vc-stepper-content.v-stepper[data-v-78f49002]  .v-stepper__items .v-stepper__content{padding:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$17 = "data-v-78f49002";
/* module identifier */

const __vue_module_identifier__$17 = undefined;
/* functional template */

const __vue_is_functional_template__$17 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$12,
  staticRenderFns: __vue_staticRenderFns__$12
}, __vue_inject_styles__$17, __vue_script__$17, __vue_scope_id__$17, __vue_is_functional_template__$17, __vue_module_identifier__$17, false, createInjector, undefined, undefined);

var VcStepperContent = __vue_component__$1O;

var script$16 = {
  name: 'VcWizard',
  components: {
    VcStepsBar,
    VcStepperContent,
    VcMobileWizardProgress,
    VcWizardCtaContainer,
    VLayout: VLayout
  },
  model: {
    prop: 'currentStep',
    event: 'indexChanged'
  },
  props: {
    size: {
      type: String,
      default: 'md',
      validator: size => ['md', 'lg'].indexOf(size) !== -1
    },
    initialWizardData: {
      type: Object,
      default: () => ({})
    },
    steps: {
      type: [Array],
      validator: steps => steps.every(step => step.name),
      required: true
    },
    dataQa: {
      type: String,
      default: 'wizard'
    },
    title: {
      type: String,
      default: ''
    },
    currentStep: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      hasError: false,
      wizardSteps: [],
      wizardStepsData: {}
    };
  },

  computed: {
    wizardData() {
      return Object.keys(this.wizardStepsData).sort().reduce((acc, currentValue) => {
        Object.assign(acc, this.wizardStepsData[currentValue]);
        return acc;
      }, { ...this.initialWizardData
      });
    },

    currentStepObj() {
      return this.wizardSteps[this.currentStepComputed - 1];
    },

    isBackDisplayed() {
      return this.currentStepObj.isBackDisplayed !== undefined ? this.currentStepObj.isBackDisplayed : this.currentStepComputed > 1;
    },

    isNextButtonDisabled() {
      if (this.hasError) {
        return true;
      }

      if (this.currentStepObj.nextStepEnabledRules) {
        return this.currentStepObj.nextStepEnabledRules.every(rule => !rule(this.wizardData));
      } else {
        return this.currentStepObj.isNextButtonDisabled !== undefined ? this.currentStepObj.isNextButtonDisabled : false;
      }
    },

    currentStepComputed() {
      return Math.min(this.currentStep, this.steps.length);
    }

  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.wizardSteps = this.steps.slice();
    },

    goBackOneStep() {
      this.hasError = false;
      this.wizardStepsData[this.currentStepComputed] = undefined;
      this.$set(this.wizardStepsData, this.currentStepComputed, undefined);
      this.$emit('indexChanged', this.currentStepComputed - 1, 'back', this.wizardData);
    },

    goToStep(step) {
      this.$emit('indexChanged', step, '', this.wizardData);
    },

    handleSubmit(data) {
      const stepData = data.stepData || {};
      const wizardData = data.wizardData || {};
      const newStepData = { ...this.currentStepObj,
        ...stepData
      };
      const newWizardStepData = { ...this.wizardStepsData[this.currentStepComputed],
        ...wizardData
      };
      this.$set(this.wizardStepsData, this.currentStepComputed, newWizardStepData);
      this.wizardSteps.splice(this.currentStepComputed - 1, 1, newStepData);
    },

    goForwardOneStep() {
      if (this.currentStepComputed < this.wizardSteps.length) {
        this.$emit('indexChanged', this.currentStepComputed + 1, 'next', this.wizardData);
      } else {
        this.$emit('submit', this.wizardData);
      }
    },

    handleError(errorData) {
      this.hasError = true;
      this.$emit('error', errorData);
    }

  }
};

/* script */
const __vue_script__$16 = script$16;
/* template */

var __vue_render__$11 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-layout', {
    staticClass: "vc-wizard",
    class: ["wizard-size-" + _vm.size],
    attrs: {
      "column": "",
      "align-start": "",
      "justify-start": ""
    }
  }, [!_vm.$vuetify.breakpoint.mdAndUp ? _c('VcMobileWizardProgress', {
    attrs: {
      "data-qa": _vm.dataQa,
      "current-step": _vm.currentStepComputed,
      "steps": _vm.wizardSteps
    }
  }) : _c('VcStepsBar', {
    attrs: {
      "current-step": _vm.currentStepComputed,
      "steps": _vm.wizardSteps,
      "title": _vm.title,
      "data-qa": _vm.dataQa
    },
    on: {
      "goToStep": _vm.goToStep
    }
  }), _vm._v(" "), _c('VcStepperContent', {
    attrs: {
      "wizard-data": _vm.wizardData,
      "current-step": _vm.currentStepComputed,
      "steps": _vm.wizardSteps,
      "data-qa": _vm.dataQa
    },
    on: {
      "submit": _vm.handleSubmit,
      "error": _vm.handleError,
      "moveForward": _vm.goForwardOneStep
    }
  }), _vm._v(" "), _c('VcWizardCtaContainer', {
    attrs: {
      "is-back-displayed": _vm.isBackDisplayed,
      "is-next-button-disabled": _vm.isNextButtonDisabled,
      "back-button-label": _vm.currentStepObj.backButtonLabel || _vm.$dst('ds.wizard.back'),
      "next-button-label": _vm.currentStepObj.nextButtonLabel || _vm.$dst('ds.wizard.next'),
      "data-qa": _vm.dataQa
    },
    on: {
      "onBackPressed": _vm.goBackOneStep,
      "moveForward": _vm.goForwardOneStep
    }
  })], 1);
};

var __vue_staticRenderFns__$11 = [];
/* style */

const __vue_inject_styles__$16 = function (inject) {
  if (!inject) return;
  inject("data-v-3158471d_0", {
    source: "[data-v-3158471d]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-3158471d]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-3158471d]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-3158471d]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-3158471d]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-3158471d]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-3158471d]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-3158471d]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-3158471d]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-3158471d]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-3158471d]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-3158471d]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-3158471d]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-3158471d]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-3158471d]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-3158471d]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-3158471d]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-3158471d]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-3158471d]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-3158471d]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-3158471d]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-3158471d]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-3158471d]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-3158471d]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-3158471d]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-3158471d]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-3158471d]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-3158471d]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-3158471d]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-3158471d]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-3158471d]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-3158471d]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-3158471d]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-3158471d]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-3158471d]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-3158471d]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-3158471d]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-3158471d]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-3158471d]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-3158471d]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-3158471d]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-3158471d]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-3158471d]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-3158471d]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-3158471d]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-3158471d]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-3158471d]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-3158471d]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-3158471d]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-3158471d]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-3158471d]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-3158471d]{--color-dark:#63757e;--color-light:#c8d2d7}.vc-wizard[data-v-3158471d]{height:100%}@media screen and (min-width:960px){.vc-wizard[data-v-3158471d]{display:grid;grid-template-columns:minmax(250px,1fr) 3fr;grid-template-rows:1fr 80px;grid-row-gap:0}.vc-wizard.wizard-size-md[data-v-3158471d]{grid-column-gap:var(--size-value10);padding-inline-end:var(--size-value10)}.vc-wizard.wizard-size-lg[data-v-3158471d]{grid-column-gap:var(--size-value20);padding-inline-end:var(--size-value20)}}.vc-stepper-container[data-v-3158471d]{grid-area:1/1/3/2;border-inline-end:1px solid #e0e0e0;max-height:calc(100% - 24px)}.wizard-cta-container[data-v-3158471d]{grid-area:2/2/3/3}.stepper-content-wrapper[data-v-3158471d]{overflow:auto;grid-area:1/2/2/3}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$16 = "data-v-3158471d";
/* module identifier */

const __vue_module_identifier__$16 = undefined;
/* functional template */

const __vue_is_functional_template__$16 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$11,
  staticRenderFns: __vue_staticRenderFns__$11
}, __vue_inject_styles__$16, __vue_script__$16, __vue_scope_id__$16, __vue_is_functional_template__$16, __vue_module_identifier__$16, false, createInjector, undefined, undefined);

var __vue_component__$1N = __vue_component__$1M;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$15 = {
  name: 'VcBadge',
  components: {
    VBadge: VBadge
  },
  props: {
    left: {
      type: Boolean,
      required: false
    },
    badgeText: {
      type: [String, Number],
      required: false
    },
    badgeIcon: {
      type: String,
      required: false
    },
    offsetX: {
      type: [Number, String],
      default: 18
    },
    offsetY: {
      type: [Number, String]
    },
    dataQa: {
      type: String,
      default: 'VcBadge'
    },
    inline: {
      type: Boolean,
      required: false
    },
    flavor: {
      type: String,
      default: 'red',
      validator: type => ['neutral', 'orange', 'red', 'blue', 'green'].includes(type)
    },
    size: {
      type: String,
      default: 'md',
      validator: prop => ['sm', 'md'].includes(prop)
    }
  }
};

/* script */
const __vue_script__$15 = script$15;
/* template */

var __vue_render__$10 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "VcBadge",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('v-badge', {
    class: "" + _vm.size,
    attrs: {
      "color": "var(--" + _vm.flavor + ")",
      "overlap": "",
      "offset-x": _vm.offsetX,
      "offset-y": _vm.offsetY || _vm.offsetX,
      "icon": _vm.badgeIcon,
      "value": !!_vm.badgeIcon || !!_vm.badgeText,
      "left": _vm.left,
      "inline": _vm.inline,
      "content": _vm.badgeText
    }
  }, [_vm._t("default")], 2)], 1);
};

var __vue_staticRenderFns__$10 = [];
/* style */

const __vue_inject_styles__$15 = function (inject) {
  if (!inject) return;
  inject("data-v-76037891_0", {
    source: "[data-v-76037891] .v-icon__component{height:12px;width:12px}.sm[data-v-76037891]  .v-badge__badge{font-size:11px;height:16px;min-width:16px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$15 = "data-v-76037891";
/* module identifier */

const __vue_module_identifier__$15 = undefined;
/* functional template */

const __vue_is_functional_template__$15 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$10,
  staticRenderFns: __vue_staticRenderFns__$10
}, __vue_inject_styles__$15, __vue_script__$15, __vue_scope_id__$15, __vue_is_functional_template__$15, __vue_module_identifier__$15, false, createInjector, undefined, undefined);

var VcBadge = __vue_component__$1L;

var script$14 = {
  name: 'VcUpsellBlock',
  components: {
    VcImage,
    VcLink,
    VcButton,
    VcLayout,
    VcIcon
  },
  props: {
    titleText: {
      type: String,
      default: ''
    },
    subtitleText: {
      type: String,
      default: ''
    },
    bulletsText: {
      type: Array,
      default: () => []
    },
    buttonText: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: [String, Object],
      default: ''
    },
    linkUrl: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'page',
      validator: prop => ['page', 'dialog'].includes(prop)
    },
    dataQa: {
      type: String,
      default: 'VcUpsellBlock'
    },
    icon: {
      type: String,
      default: ''
    },
    linkTarget: {
      type: String,
      default: '_blank'
    }
  },
  computed: {
    isDialog() {
      return this.mode === 'dialog';
    }

  }
};

/* script */
const __vue_script__$14 = script$14;
/* template */

var __vue_render__$$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcUpsellBlock justify-space-between align-md-center",
    class: {
      dialog: _vm.isDialog
    },
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('div', {
    staticClass: "text-container flex-column pa-6 pb-0"
  }, [_c('div', {
    staticClass: "title-text mb-4"
  }, [_vm._v("\n      " + _vm._s(_vm.titleText) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-text mb-6"
  }, [_vm._v("\n      " + _vm._s(_vm.subtitleText) + "\n    ")]), _vm._v(" "), _vm.bulletsText.length > 0 ? _vm._l(_vm.bulletsText, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "bullets-text d-flex mb-3"
    }, [_vm.icon ? _c('div', {
      staticClass: "align-self-start bullets-icon"
    }, [_c('VcIcon', {
      attrs: {
        "size": "16"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.icon) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "bullets-span"
    }, [_vm._v(_vm._s(item))])]);
  }) : _vm._e(), _vm._v(" "), _vm.linkText || _vm.buttonText ? _c('div', {
    staticClass: "cta-container d-flex mt-md-6",
    class: _vm.isDialog ? 'cta-container-dialog' : ''
  }, [_vm.buttonText ? _c('VcButton', {
    staticClass: "primary-cta",
    attrs: {
      "pill": true
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('buttonClick');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.linkText ? _c('VcLink', {
    staticClass: "secondary-cta justify-center",
    attrs: {
      "target": _vm.linkTarget,
      "url": _vm.linkUrl,
      "label": _vm.linkText
    }
  }) : _vm._e()], 1) : _vm._e()], 2), _vm._v(" "), _c('VcLayout', {
    staticClass: "images-container"
  }, [_c('VcImage', {
    staticClass: "upsell-image",
    attrs: {
      "image": _vm.imageUrl
    }
  })], 1)], 1);
};

var __vue_staticRenderFns__$$ = [];
/* style */

const __vue_inject_styles__$14 = function (inject) {
  if (!inject) return;
  inject("data-v-6dee53cc_0", {
    source: ".VcUpsellBlock[data-v-6dee53cc]{flex-flow:row wrap;width:100%;height:100vh;max-width:960px;margin:auto;overflow-x:hidden;font-style:normal}@media screen and (min-width:960px){.VcUpsellBlock[data-v-6dee53cc]{overflow-x:visible}.VcUpsellBlock.dialog[data-v-6dee53cc]{overflow:hidden}}.VcUpsellBlock[data-v-6dee53cc]:before{pointer-events:none;content:\"\";position:absolute;-webkit-mask-image:url(\"data:image/svg+xml,%3Csvg width='1387' height='1787' viewBox='0 0 1387 1787' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath id='background_stain' d='M965.208 1786.79L1240.04 1427.2C1388.67 1251.5 1443.75 1042.72 1314.06 863.507L768.194 165.405C638.503 -13.8061 388.739 -53.6307 210.377 76.6778L164.621 109.767C-13.7407 240.369 -53.3766 491.322 76.3144 670.533L649.578 1404.65L965.208 1786.79Z' fill='%230093B8'/%3E%3C/svg%3E\");background-color:var(--v-secondary-base);opacity:15%;inset:70% 0 0 0}@media screen and (min-width:960px){.VcUpsellBlock[data-v-6dee53cc]:before{inset:0;inset-inline-start:50%}}#app[dir=rtl] .VcUpsellBlock[data-v-6dee53cc]:before{transform:scaleX(-1)}.VcUpsellBlock.dialog[data-v-6dee53cc]{height:100%;padding-top:8px}@media screen and (min-width:960px){.VcUpsellBlock.dialog[data-v-6dee53cc]{padding-top:70px;padding-bottom:46px}}@media screen and (min-width:960px){.VcUpsellBlock.dialog[data-v-6dee53cc]:before{top:-10%}}.VcUpsellBlock .text-container[data-v-6dee53cc]{flex:0 0 100%;margin:0 auto}@media screen and (min-width:960px){.VcUpsellBlock .text-container[data-v-6dee53cc]{flex:0 0 55%;max-width:444px}}.VcUpsellBlock .text-container .title-text[data-v-6dee53cc]{font-weight:var(--font-weight-large2);font-size:var(--font-size-medium2);line-height:32px;letter-spacing:.01em}@media screen and (min-width:960px){.VcUpsellBlock .text-container .title-text[data-v-6dee53cc]{font-size:var(--font-size-large);line-height:40px}}.VcUpsellBlock .text-container .sub-text[data-v-6dee53cc]{font-weight:var(--font-weight-large);font-size:var(--font-size-medium);line-height:28px;letter-spacing:var(--letter-spacing)}.VcUpsellBlock .text-container .bullets-text[data-v-6dee53cc]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-small2);line-height:20px}.VcUpsellBlock .text-container .bullets-text .bullets-icon[data-v-6dee53cc]{margin-inline-end:12px}.VcUpsellBlock .text-container .bullets-text .bullets-span[data-v-6dee53cc]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-small2);line-height:20px;color:#000}.VcUpsellBlock .text-container .cta-container[data-v-6dee53cc]{flex:1 1 auto;flex-flow:row wrap;align-items:center;margin:32px auto 0}.VcUpsellBlock .text-container .cta-container .primary-cta[data-v-6dee53cc]{z-index:2;width:auto;margin:0 auto;min-width:214px;line-height:48px;min-height:48px;font-weight:var(--font-weight-large);font-size:var(--font-size-small2)}@media screen and (min-width:960px){.VcUpsellBlock .text-container .cta-container .primary-cta[data-v-6dee53cc]{margin:0;height:48px}}.VcUpsellBlock .text-container .cta-container .primary-cta .v-btn__content[data-v-6dee53cc]{flex-flow:row wrap;width:100%;white-space:break-spaces}.VcUpsellBlock .text-container .cta-container .secondary-cta[data-v-6dee53cc]{flex:0 0 100%;text-align:center;font-weight:var(--font-weight-large);font-size:var(--font-size-small2);line-height:48px;height:48px;color:var(--gray-darken-5);margin:0;text-decoration:none}@media screen and (min-width:960px){.VcUpsellBlock .text-container .cta-container .secondary-cta[data-v-6dee53cc]{flex:0 0 45%;color:var(--blue);font-weight:var(--font-weight-large2)}}.VcUpsellBlock .text-container .cta-container-dialog[data-v-6dee53cc]{width:100%;z-index:1;position:absolute;justify-content:space-between;background:#fff;bottom:0;left:0;right:0;margin:0;height:72px;padding:0 24px}@media screen and (min-width:960px){.VcUpsellBlock .text-container .cta-container-dialog[data-v-6dee53cc]{position:static;justify-content:flex-start;padding:0}}.VcUpsellBlock .text-container .cta-container-dialog .primary-cta[data-v-6dee53cc]{margin:0;order:2}@media screen and (min-width:960px){.VcUpsellBlock .text-container .cta-container-dialog .primary-cta[data-v-6dee53cc]{order:0}}.VcUpsellBlock .text-container .cta-container-dialog .secondary-cta[data-v-6dee53cc]{flex:1 0 35%;padding-top:0}@media screen and (min-width:960px){.VcUpsellBlock .text-container .cta-container-dialog .secondary-cta[data-v-6dee53cc]{flex:0 0 45%}}.VcUpsellBlock .images-container[data-v-6dee53cc]{position:relative;flex:1 0 100%;margin:0 auto;min-height:40%;height:auto;overflow:hidden}@media screen and (min-width:960px){.VcUpsellBlock .images-container[data-v-6dee53cc]{flex:0 0 45%;overflow:visible}}.VcUpsellBlock .images-container .upsell-image[data-v-6dee53cc]{position:absolute;width:320px;height:380px;right:0;left:0;margin:0 auto}@media screen and (min-width:960px){.VcUpsellBlock .images-container .upsell-image[data-v-6dee53cc]{height:580px;width:466px;top:0;bottom:0;margin:auto}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$14 = "data-v-6dee53cc";
/* module identifier */

const __vue_module_identifier__$14 = undefined;
/* functional template */

const __vue_is_functional_template__$14 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$$,
  staticRenderFns: __vue_staticRenderFns__$$
}, __vue_inject_styles__$14, __vue_script__$14, __vue_scope_id__$14, __vue_is_functional_template__$14, __vue_module_identifier__$14, false, createInjector, undefined, undefined);

var __vue_component__$1K = __vue_component__$1J;

var script$13 = {
  name: 'VcDropzone',
  components: {
    VcLayout
  },
  props: {
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    supportedFileTypes: {
      type: Array,
      default: () => []
    },
    supportedFileSizeMb: {
      type: Number,
      default: 0
    },
    validatorFn: {
      type: Function,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-dropzone'
    }
  },

  data() {
    return {
      isHovered: false,
      isActive: false
    };
  },

  methods: {
    hover(hovered) {
      this.isHovered = hovered;
    },

    activate(active) {
      this.isActive = active;
    },

    _typeValidate(fileType) {
      return this.supportedFileTypes.includes(fileType.toLowerCase());
    },

    _sizeValidate(fileSize) {
      return this._mbToBytes(this.supportedFileSizeMb) >= fileSize;
    },

    _mbToBytes(mb) {
      return mb * 1048576;
    },

    addFiles(name, filelist) {
      const validatedFiles = [...filelist].map(file => {
        const validatedFile = {
          file
        };

        if (this.validatorFn) {
          validatedFile.externalValidated = this.validatorFn(file);
        }

        if (this.supportedFileSizeMb) {
          validatedFile.sizeValidated = this._sizeValidate(file.size);
        }

        if (this.supportedFileTypes.length) {
          validatedFile.typeValidated = this._typeValidate(file.name.toLowerCase().split('.').pop());
        }

        return validatedFile;
      });
      this.$refs.dropzone.value = null;
      return validatedFiles;
    }

  }
};

/* script */
const __vue_script__$13 = script$13;
/* template */

var __vue_render__$_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "dropzone__wrap",
    class: {
      'dropzone__wrap--hovered': _vm.isHovered,
      'dropzone__wrap--active': _vm.isActive,
      'dropzone__wrap--disabled': _vm.disabled
    },
    attrs: {
      "align-center": "",
      "justify-center": "",
      "data-qa": _vm.dataQa + "--wrap"
    }
  }, [_c('label', {
    staticClass: "dropzone__label",
    attrs: {
      "data-qa": _vm.dataQa + "--label"
    }
  }, [_c('input', {
    ref: "dropzone",
    staticClass: "dropzone__input",
    attrs: {
      "type": "file",
      "accept": "*/*",
      "multiple": "",
      "data-qa": _vm.dataQa + "--input",
      "disabled": _vm.disabled
    },
    on: {
      "change": function ($event) {
        _vm.$emit('onFilesValidated', {
          validatedFiles: _vm.addFiles('vc-dropzone', $event.target.files)
        });
      },
      "dragleave": function ($event) {
        return _vm.activate(false);
      },
      "dragenter": function ($event) {
        return _vm.activate(true);
      },
      "mouseenter": function ($event) {
        return _vm.hover(true);
      },
      "mouseleave": function ($event) {
        return _vm.hover(false);
      }
    }
  }), _vm._v(" "), _vm._t("default", function () {
    return [_vm.title ? _c('span', {
      staticClass: "dropzone__title",
      attrs: {
        "data-qa": _vm.dataQa + "--label-title"
      }
    }, [_vm._v(_vm._s(_vm.title || _vm.$dst('ds.dropzone.default_title')))]) : _vm._e(), _vm._v(" "), _vm.subtitle ? _c('span', {
      staticClass: "dropzone__subtitle",
      attrs: {
        "data-qa": _vm.dataQa + "--label-subtitle"
      }
    }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()];
  })], 2)]);
};

var __vue_staticRenderFns__$_ = [];
/* style */

const __vue_inject_styles__$13 = function (inject) {
  if (!inject) return;
  inject("data-v-be3ad9c6_0", {
    source: "[data-v-be3ad9c6]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-be3ad9c6]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-be3ad9c6]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-be3ad9c6]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-be3ad9c6]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-be3ad9c6]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-be3ad9c6]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-be3ad9c6]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-be3ad9c6]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-be3ad9c6]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-be3ad9c6]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-be3ad9c6]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-be3ad9c6]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-be3ad9c6]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-be3ad9c6]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-be3ad9c6]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-be3ad9c6]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-be3ad9c6]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-be3ad9c6]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-be3ad9c6]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-be3ad9c6]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-be3ad9c6]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-be3ad9c6]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-be3ad9c6]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-be3ad9c6]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-be3ad9c6]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-be3ad9c6]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-be3ad9c6]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-be3ad9c6]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-be3ad9c6]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-be3ad9c6]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-be3ad9c6]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-be3ad9c6]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-be3ad9c6]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-be3ad9c6]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-be3ad9c6]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-be3ad9c6]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-be3ad9c6]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-be3ad9c6]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-be3ad9c6]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-be3ad9c6]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-be3ad9c6]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-be3ad9c6]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-be3ad9c6]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-be3ad9c6]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-be3ad9c6]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-be3ad9c6]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-be3ad9c6]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-be3ad9c6]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-be3ad9c6]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-be3ad9c6]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-be3ad9c6]{--color-dark:#63757e;--color-light:#c8d2d7}.dropzone__wrap[data-v-be3ad9c6]{position:relative;border:1px dashed var(--gray-darken-1);padding:var(--size-value3);min-height:var(--size-value18);width:100%;border-radius:var(--border-radius);background-color:var(--gray-lighten-4);transition:background-color .1s ease-out,border-color .1s ease-out}.dropzone__wrap--hovered[data-v-be3ad9c6]{background-color:var(--gray-lighten-3);border-color:var(--gray-darken-1)}.dropzone__wrap--active[data-v-be3ad9c6]{background-color:var(--modal-bg-color);border-color:var(--dropzone-active-border-color);filter:drop-shadow(0 0 2px var(--dropzone-active-second-border-color))}.dropzone__wrap--disabled[data-v-be3ad9c6]{background-color:var(--gray-lighten-4);border-color:var(--gray)}.dropzone__input[data-v-be3ad9c6]{width:100%;height:100%;position:absolute;opacity:0;left:0;top:0;cursor:pointer}.dropzone__wrap--disabled .dropzone__input[data-v-be3ad9c6]{cursor:default}.dropzone__label[data-v-be3ad9c6]{display:flex;flex-direction:column;text-align:center}.dropzone__wrap--hovered .dropzone__label[data-v-be3ad9c6]{color:var(--gray-darken-5)}.dropzone__subtitle[data-v-be3ad9c6],.dropzone__title[data-v-be3ad9c6]{font-size:var(--font-size-x-small)}.dropzone__wrap--disabled .dropzone__subtitle[data-v-be3ad9c6],.dropzone__wrap--disabled .dropzone__title[data-v-be3ad9c6]{color:var(--gray-darken-2)}.dropzone__title[data-v-be3ad9c6]{color:var(--blue);font-weight:var(--font-weight-medium2)}.dropzone__subtitle[data-v-be3ad9c6]{color:var(--gray-darken-3);font-weight:var(--font-weight-light)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$13 = "data-v-be3ad9c6";
/* module identifier */

const __vue_module_identifier__$13 = undefined;
/* functional template */

const __vue_is_functional_template__$13 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$_,
  staticRenderFns: __vue_staticRenderFns__$_
}, __vue_inject_styles__$13, __vue_script__$13, __vue_scope_id__$13, __vue_is_functional_template__$13, __vue_module_identifier__$13, false, createInjector, undefined, undefined);

var __vue_component__$1I = __vue_component__$1H;

var script$12 = {
  name: 'VcRadio',
  components: {
    VcTooltip,
    VcIcon,
    VRadio: VRadio
  },
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    tooltipProps: {
      type: Object
    },
    dataQa: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$12 = script$12;
/* template */

var __vue_render__$Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-radio', {
    staticClass: "vc-radio",
    attrs: {
      "color": 'var(--green)',
      "value": _vm.value,
      "disabled": _vm.disabled
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('input', _vm.value);
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', {
          staticClass: "label-container",
          attrs: {
            "data-qa": _vm.dataQa || "radio-" + _vm.value
          }
        }, [_vm.icon ? _c('vc-icon', {
          staticClass: "radio-icon"
        }, [_vm._v("\n        " + _vm._s(_vm.icon) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm._t("label", function () {
          return [_vm.label ? _c('span', {
            staticClass: "radio-label"
          }, [_vm._v("\n          " + _vm._s(_vm.label) + "\n        ")]) : _vm._e()];
        }), _vm._v(" "), _vm.tooltipProps ? _c('vc-tooltip', _vm._b({
          staticClass: "radio-tooltip",
          scopedSlots: _vm._u([{
            key: "tooltipContent",
            fn: function () {
              return [_vm._t("tooltip-content")];
            },
            proxy: true
          }], null, true)
        }, 'vc-tooltip', _vm.tooltipProps, false)) : _vm._e()], 2)];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$Z = [];
/* style */

const __vue_inject_styles__$12 = function (inject) {
  if (!inject) return;
  inject("data-v-6e43dd3f_0", {
    source: ".label-container[data-v-6e43dd3f]{margin-inline-start:var(--size-value2)}.radio-label[data-v-6e43dd3f]{color:var(--gray-darken-5);font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small)}.radio-icon[data-v-6e43dd3f]{margin-inline-start:var(--size-value2);font-size:var(--size-value4)}.radio-icon[data-v-6e43dd3f]  .v-icon__component{height:var(--size-value4);width:var(--size-value4)}.radio-tooltip[data-v-6e43dd3f]{height:var(--size-value5);margin-inline-start:var(--size-value2)}.radio-tooltip[data-v-6e43dd3f]  .v-icon__component{width:var(--size-value4)}.vc-radio[data-v-6e43dd3f]{margin:0;margin-bottom:auto}.vc-radio.v-input--radio-group--column[data-v-6e43dd3f]  .v-radio:not(:last-child):not(:only-child){margin-bottom:var(--size-value4)}.vc-radio[data-v-6e43dd3f]  .v-input--selection-controls__ripple{inset-inline-start:-9px;top:calc(50% - 17px);width:var(--size-value5);height:var(--size-value5)}.vc-radio[data-v-6e43dd3f]  .v-input--selection-controls__input{margin:0;padding:0;margin-bottom:auto;height:var(--size-value5);width:var(--size-value4)}.vc-radio[data-v-6e43dd3f]  .v-input--selection-controls__input .v-icon{font-size:var(--font-size-medium)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$12 = "data-v-6e43dd3f";
/* module identifier */

const __vue_module_identifier__$12 = undefined;
/* functional template */

const __vue_is_functional_template__$12 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Z,
  staticRenderFns: __vue_staticRenderFns__$Z
}, __vue_inject_styles__$12, __vue_script__$12, __vue_scope_id__$12, __vue_is_functional_template__$12, __vue_module_identifier__$12, false, createInjector, undefined, undefined);

var VcRadio = __vue_component__$1G;

var script$11 = {
  name: 'VcRadioGroup',
  components: {
    VcRadio,
    VRadioGroup: VRadioGroup
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    items: {
      type: Array,
      required: true,

      validator(val) {
        return val.every(item => item.value) && val.length > 1;
      }

    },
    value: {
      type: String,
      required: true
    },
    dataQa: {
      type: String,
      default: 'vc-radio-group'
    },
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isHorizontal: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$11 = script$11;
/* template */

var __vue_render__$Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm.title ? _c('div', {
    staticClass: "vc-title"
  }, [_vm._t("title", function () {
    return [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")];
  })], 2) : _vm._e(), _vm._v(" "), _c('v-radio-group', {
    staticClass: "vc-radio-buttons",
    attrs: {
      "value": _vm.value,
      "hide-details": "auto",
      "row": _vm.isHorizontal
    },
    on: {
      "change": function (val) {
        return _vm.$emit('change', val);
      }
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('VcRadio', _vm._b({
      key: item.value,
      attrs: {
        "disabled": _vm.disabled
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function () {
          return [_vm._t("label-" + item.value)];
        },
        proxy: true
      }, {
        key: "tooltip-content",
        fn: function () {
          return [_vm._t("tooltip-content-" + item.value)];
        },
        proxy: true
      }], null, true)
    }, 'VcRadio', item, false));
  }), 1)], 1);
};

var __vue_staticRenderFns__$Y = [];
/* style */

const __vue_inject_styles__$11 = function (inject) {
  if (!inject) return;
  inject("data-v-68b6349a_0", {
    source: ".vc-radio-buttons[data-v-68b6349a]{margin:0;padding:0;text-align:unset}.vc-radio-buttons.v-input--radio-group--column[data-v-68b6349a]  .v-radio:not(:last-child):not(:only-child){margin-bottom:var(--size-value4)}.vc-title[data-v-68b6349a]{color:var(--gray-darken-5);margin-bottom:var(--size-value2);font-weight:var(--font-weight-large);font-size:var(--size-value3);line-height:var(--size-value4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$11 = "data-v-68b6349a";
/* module identifier */

const __vue_module_identifier__$11 = undefined;
/* functional template */

const __vue_is_functional_template__$11 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Y,
  staticRenderFns: __vue_staticRenderFns__$Y
}, __vue_inject_styles__$11, __vue_script__$11, __vue_scope_id__$11, __vue_is_functional_template__$11, __vue_module_identifier__$11, false, createInjector, undefined, undefined);

var __vue_component__$1F = __vue_component__$1E;

var script$10 = {
  name: 'VcSegmentedControl',
  components: {
    VcIcon,
    VBtn: VBtn,
    VBtnToggle: VBtnToggle
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: prop => prop.every(e => e.label)
    },
    value: {
      type: Number,
      required: true
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcSegmentedControl'
    }
  },
  methods: {
    getDataQaForItem(item) {
      const index = this.items.indexOf(item);
      return `${this.dataQa}-item-${item.id || index}`;
    }

  }
};

/* script */
const __vue_script__$10 = script$10;
/* template */

var __vue_render__$X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-btn-toggle', {
    staticClass: "button-group",
    class: {
      'rounded-toggle': _vm.rounded
    },
    attrs: {
      "value": _vm.value,
      "mandatory": _vm.mandatory,
      "data-qa": _vm.dataQa
    },
    on: {
      "change": function (value) {
        return _vm.$emit('change', value);
      }
    }
  }, _vm._l(_vm.rounded ? _vm.items.slice(0, 2) : _vm.items, function (item) {
    return _c('v-btn', {
      key: item.id,
      class: {
        'rounded-button': _vm.rounded
      },
      attrs: {
        "id": item.id,
        "disabled": !!item.disabled,
        "data-qa": _vm.getDataQaForItem(item)
      }
    }, [item.icon ? _c('vc-icon', {
      staticClass: "item-icon",
      attrs: {
        "size": "16"
      }
    }, [_vm._v("\n      " + _vm._s(item.icon) + "\n    ")]) : _vm._e(), _vm._v("\n    " + _vm._s(item.label) + "\n  ")], 1);
  }), 1);
};

var __vue_staticRenderFns__$X = [];
/* style */

const __vue_inject_styles__$10 = function (inject) {
  if (!inject) return;
  inject("data-v-c30779dc_0", {
    source: "[data-v-c30779dc]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-c30779dc]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-c30779dc]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-c30779dc]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-c30779dc]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-c30779dc]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-c30779dc]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-c30779dc]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-c30779dc]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-c30779dc]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-c30779dc]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-c30779dc]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-c30779dc]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-c30779dc]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-c30779dc]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-c30779dc]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-c30779dc]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-c30779dc]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-c30779dc]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-c30779dc]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-c30779dc]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-c30779dc]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-c30779dc]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-c30779dc]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-c30779dc]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-c30779dc]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-c30779dc]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-c30779dc]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-c30779dc]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-c30779dc]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-c30779dc]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-c30779dc]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-c30779dc]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-c30779dc]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-c30779dc]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-c30779dc]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-c30779dc]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-c30779dc]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-c30779dc]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-c30779dc]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-c30779dc]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-c30779dc]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-c30779dc]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-c30779dc]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-c30779dc]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-c30779dc]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-c30779dc]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-c30779dc]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-c30779dc]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-c30779dc]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-c30779dc]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-c30779dc]{--color-dark:#63757e;--color-light:#c8d2d7}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]{border-radius:var(--border-radius);width:100%;max-width:100%;font-family:var(--primary-font-family)}div.button-group.v-item-group.v-btn-toggle.rounded-toggle[data-v-c30779dc]{border-radius:50px;padding:2px;background:var(--neutral-lighten-3);overflow:hidden}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc] >button.v-btn:first-child{border-bottom-left-radius:inherit;border-top-left-radius:inherit}#app[dir=rtl] div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc] >button.v-btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0;border-bottom-right-radius:inherit;border-top-right-radius:inherit}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc] >button.v-btn:last-child{border-bottom-right-radius:inherit;border-top-right-radius:inherit}#app[dir=rtl] div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc] >button.v-btn:last-child{border-bottom-right-radius:0;border-top-right-radius:0;border-bottom-left-radius:inherit;border-top-left-radius:inherit}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc] >button.v-btn:not(:first-child){border-left-width:0}#app[dir=rtl] div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc] >button.v-btn:not(:first-child){border-left-width:1px;border-right-width:0}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn{flex:1;height:auto;padding-top:var(--size-value3);padding-bottom:var(--size-value3);font-family:var(--primary-font-family);font-size:var(--font-size-x-small);line-height:var(--size-value4);text-transform:none;letter-spacing:normal}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn.rounded-button{padding:var(--size-value2) var(--size-value3);font-size:var(--font-size-xx-small);font-weight:var(--font-weight-medium2);border-style:none}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn.rounded-button span{white-space:nowrap}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn:before{background-color:inherit}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn:not(.v-item--active){background:var(--gray-lighten-3);color:var(--gray-darken-4)}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn:not(.v-item--active).rounded-button{color:var(--gray-darken-2)}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn.v-item--active{box-shadow:var(--shadow-4);background:var(--modal-bg-color);color:var(--gray-darken-5)}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn.v-item--active.rounded-button{box-shadow:0 0 1px 0 rgba(0,0,0,.3) inset,0 2px 5px 0 rgba(0,0,0,.16);border-radius:inherit;font-weight:var(--font-weight-large);z-index:1}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn:hover{background:var(--gray-lighten-4)}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn.v-btn--disabled{background:var(--gray-lighten-2);color:var(--gray-darken-2)}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn span{max-width:100%;white-space:initial}div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn .item-icon{padding-left:var(--size-value0);padding-right:var(--size-value1)}#app[dir=rtl] div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn .item-icon{padding-left:var(--size-value1)}#app[dir=rtl] div.button-group.v-item-group.v-btn-toggle[data-v-c30779dc]  button.v-btn .item-icon{padding-right:var(--size-value0)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$10 = "data-v-c30779dc";
/* module identifier */

const __vue_module_identifier__$10 = undefined;
/* functional template */

const __vue_is_functional_template__$10 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$X,
  staticRenderFns: __vue_staticRenderFns__$X
}, __vue_inject_styles__$10, __vue_script__$10, __vue_scope_id__$10, __vue_is_functional_template__$10, __vue_module_identifier__$10, false, createInjector, undefined, undefined);

var __vue_component__$1D = __vue_component__$1C;

const FORMATS = {
  DOCUMENT: ['doc', 'docx'],
  IMAGE: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'],
  PDF: ['pdf'],
  SPREADSHEET: ['csv', 'xls', 'xlsx'],
  SLIDESHOW: ['ppt', 'pptx'],
  ARCHIVE: ['zip', 'rar'],
  AUDIO: ['mp3', 'wav'],
  VIDEO: ['avi', 'mp4', 'mkv', 'mov']
};
var script$$ = {
  name: 'VcDocItem',
  components: {
    VcButton,
    VcIcon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    uid: {
      type: String,
      required: true
    },
    isSignable: {
      type: Boolean,
      default: false
    },
    trimSignable: {
      type: Boolean,
      default: false
    },
    allowActions: {
      type: Boolean,
      default: true
    },
    dataQa: {
      type: String,
      default: 'vc-doc-item'
    },
    actions: {
      type: Array,
      validator: prop => prop.every(a => a.type && a.icon),
      default: () => [{
        type: 'onRemove',
        icon: 'trash'
      }]
    },
    uploaded: {
      type: Boolean,
      default: false
    },
    corrupted: {
      type: Boolean,
      default: false
    },
    corruptedLabel: {
      type: String,
      required: false
    },
    fileSize: {
      type: String,
      required: false
    }
  },
  computed: {
    extension() {
      return this.title.indexOf('.') !== -1 ? this.title.split('.').pop() : 'general';
    },

    docIcon() {
      const {
        DOCUMENT,
        IMAGE,
        PDF,
        SPREADSHEET,
        SLIDESHOW,
        ARCHIVE,
        AUDIO,
        VIDEO
      } = FORMATS;
      if (DOCUMENT.includes(this.extension)) return 'document';
      if (IMAGE.includes(this.extension)) return 'image';
      if (PDF.includes(this.extension)) return 'pdf';
      if (SPREADSHEET.includes(this.extension)) return 'sheet';
      if (SLIDESHOW.includes(this.extension)) return 'slideshow';
      if (ARCHIVE.includes(this.extension)) return 'archive';
      if (AUDIO.includes(this.extension)) return 'audio';
      if (VIDEO.includes(this.extension)) return 'video';
      return 'general';
    },

    flag() {
      if (this.corrupted) return '$corrupted_flag';else if (this.uploaded) return '$uploaded_flag';else return '';
    },

    corruptedLabelText() {
      return this.corruptedLabel || this.$dst('ds.document.corrupted');
    }

  }
};

/* script */
const __vue_script__$$ = script$$;
/* template */

var __vue_render__$W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vc-doc-item",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "details__doc-icon",
    attrs: {
      "data-qa": _vm.dataQa + "-doc-icon"
    }
  }, [_c('VcIcon', {
    attrs: {
      "size": "24"
    }
  }, [_vm._v(" $doc_" + _vm._s(_vm.docIcon) + " ")]), _vm._v(" "), _vm.uploaded || _vm.corrupted ? _c('VcIcon', {
    staticClass: "v-icon--flag",
    attrs: {
      "size": "16",
      "data-qa": _vm.dataQa + "-corrupted-label"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.flag) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "title",
    class: {
      'title--corrupted': _vm.corrupted
    },
    attrs: {
      "data-qa": _vm.dataQa + "-title"
    }
  }, [_c('span', {
    staticClass: "title__header"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _vm.fileSize && _vm.fileSize.length ? _c('span', {
    staticClass: "title__file-size",
    attrs: {
      "data-qa": _vm.dataQa + "-size"
    }
  }, [_vm._v("\n        (" + _vm._s(_vm.fileSize) + ")\n      ")]) : _vm._e(), _vm._v(" "), _vm.corrupted ? _c('span', {
    staticClass: "title__corrupted"
  }, [_vm._v("\n        " + _vm._s(_vm.corruptedLabelText) + "\n      ")]) : _vm._e()]), _vm._v(" "), _vm.isSignable ? _c('div', {
    staticClass: "signature",
    class: {
      'signature--trimmed': _vm.trimSignable
    },
    attrs: {
      "data-qa": _vm.dataQa + "-signature"
    }
  }, [_c('VcIcon', {
    staticClass: "signature__icon",
    attrs: {
      "size": "14"
    }
  }, [_vm._v(" $union ")]), _vm._v(" "), !_vm.trimSignable ? _c('span', {
    staticClass: "signature__text"
  }, [_vm._v("\n        " + _vm._s(_vm.$dst('ds.document.signature')) + "\n      ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _vm.allowActions ? _c('div', {
    staticClass: "actions",
    attrs: {
      "data-qa": _vm.dataQa + "-actions"
    }
  }, _vm._l(_vm.actions, function (action, index) {
    return _c('VcButton', {
      key: index,
      attrs: {
        "icon": "",
        "data-qa": _vm.dataQa + "-action"
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_c('VcIcon', {
            attrs: {
              "size": "16"
            },
            on: {
              "click": function (e) {
                return _vm.$emit(action.type, _vm.uid, e);
              }
            }
          }, [_vm._v(" $" + _vm._s(action.icon) + " ")])];
        },
        proxy: true
      }], null, true)
    });
  }), 1) : _vm._e()]);
};

var __vue_staticRenderFns__$W = [];
/* style */

const __vue_inject_styles__$$ = function (inject) {
  if (!inject) return;
  inject("data-v-37e01f8f_0", {
    source: "[data-v-37e01f8f]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-37e01f8f]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-37e01f8f]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-37e01f8f]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-37e01f8f]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-37e01f8f]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-37e01f8f]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-37e01f8f]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-37e01f8f]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-37e01f8f]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-37e01f8f]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-37e01f8f]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-37e01f8f]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-37e01f8f]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-37e01f8f]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-37e01f8f]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-37e01f8f]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-37e01f8f]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-37e01f8f]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-37e01f8f]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-37e01f8f]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-37e01f8f]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-37e01f8f]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-37e01f8f]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-37e01f8f]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-37e01f8f]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-37e01f8f]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-37e01f8f]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-37e01f8f]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-37e01f8f]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-37e01f8f]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-37e01f8f]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-37e01f8f]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-37e01f8f]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-37e01f8f]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-37e01f8f]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-37e01f8f]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-37e01f8f]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-37e01f8f]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-37e01f8f]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-37e01f8f]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-37e01f8f]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-37e01f8f]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-37e01f8f]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-37e01f8f]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-37e01f8f]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-37e01f8f]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-37e01f8f]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-37e01f8f]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-37e01f8f]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-37e01f8f]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-37e01f8f]{--color-dark:#63757e;--color-light:#c8d2d7}.vc-doc-item[data-v-37e01f8f]{display:flex;align-items:center;padding:0 var(--size-value4);height:48px;max-width:100%}.vc-doc-item .actions[data-v-37e01f8f]{display:flex;margin-inline-start:var(--size-value2)}.vc-doc-item .actions button[data-v-37e01f8f]{opacity:.4}.vc-doc-item .actions button[data-v-37e01f8f]:hover{opacity:1}.details[data-v-37e01f8f]{font-family:var(--primary-font-family);display:flex;flex-direction:row;align-items:center;width:100%;min-width:0}.details__doc-icon[data-v-37e01f8f]{position:relative}.details__doc-icon .v-icon[data-v-37e01f8f]{margin-inline-end:var(--size-value4)}.details__doc-icon .v-icon--flag[data-v-37e01f8f]{position:absolute;bottom:calc(-1 * var(--size-value1));inset-inline-end:calc(-1 * var(--size-value1))}.title[data-v-37e01f8f]{padding-inline-end:var(--size-value3);line-height:18px;display:flex;overflow:hidden}.title--corrupted[data-v-37e01f8f]{flex-direction:column}.title__corrupted[data-v-37e01f8f],.title__header[data-v-37e01f8f]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small);color:var(--gray-darken-5);white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.title__corrupted[data-v-37e01f8f]{color:var(--red)}.title__file-size[data-v-37e01f8f]{margin-inline-start:10px;color:var(--gray-darken-3);font-size:var(--font-size-xx-small);font-weight:var(--font-weight-medium);white-space:nowrap}.signature[data-v-37e01f8f]{display:flex;flex-direction:row;align-items:center;margin-inline-start:auto}.signature--trimmed[data-v-37e01f8f]{margin-inline-start:0}.signature__icon[data-v-37e01f8f]{color:var(--gray-darken-5);margin-inline-end:var(--size-value2)}.signature__text[data-v-37e01f8f]{font-weight:var(--font-weight-medium);font-size:var(--font-size-xx-small);color:var(--gray-darken-5);white-space:nowrap}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$$ = "data-v-37e01f8f";
/* module identifier */

const __vue_module_identifier__$$ = undefined;
/* functional template */

const __vue_is_functional_template__$$ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$W,
  staticRenderFns: __vue_staticRenderFns__$W
}, __vue_inject_styles__$$, __vue_script__$$, __vue_scope_id__$$, __vue_is_functional_template__$$, __vue_module_identifier__$$, false, createInjector, undefined, undefined);

var __vue_component__$1B = __vue_component__$1A;

//
//
//
//
//
//
var script$_ = {
  name: 'VcTimeSince',
  props: {
    timestamp: {
      required: true,
      type: Number,
      validator: prop => Date.now() > prop
    },
    dataQa: {
      type: String,
      default: 'vc-time-since'
    }
  },
  computed: {
    timeSince() {
      const years = 31536000;
      const months = 2592000;
      const days = 86400;
      const hours = 3600;
      const minutes = 60;
      const seconds = Math.floor((new Date() - this.timestamp) / 1000);
      let interval = seconds / years;

      if (interval > 1) {
        return `${this.$dst('ds.time_since.years', {
          years: Math.floor(interval)
        })}`;
      }

      interval = seconds / months;

      if (interval > 1) {
        return `${this.$dst('ds.time_since.months', {
          months: Math.floor(interval)
        })}`;
      }

      interval = seconds / days;

      if (Math.floor(interval) === 1) {
        return `${this.$dst('ds.time_since.yesterday')}`;
      }

      if (interval > 1) {
        return `${this.$dst('ds.time_since.days', {
          days: Math.floor(interval)
        })}`;
      }

      interval = seconds / hours;

      if (interval > 1) {
        return `${this.$dst('ds.time_since.hours', {
          hours: Math.floor(interval)
        })}`;
      }

      interval = seconds / minutes;

      if (interval > 1) {
        return `${this.$dst('ds.time_since.minutes', {
          minutes: Math.floor(interval)
        })}`;
      }

      return `${this.$dst('ds.time_since.now')}`;
    }

  }
};

/* script */
const __vue_script__$_ = script$_;
/* template */

var __vue_render__$V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm._v("\n  " + _vm._s(_vm.timeSince) + "\n")]);
};

var __vue_staticRenderFns__$V = [];
/* style */

const __vue_inject_styles__$_ = undefined;
/* scoped */

const __vue_scope_id__$_ = undefined;
/* module identifier */

const __vue_module_identifier__$_ = undefined;
/* functional template */

const __vue_is_functional_template__$_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$_, __vue_script__$_, __vue_scope_id__$_, __vue_is_functional_template__$_, __vue_module_identifier__$_, false, undefined, undefined, undefined);

var __vue_component__$1z = __vue_component__$1y;

var script$Z = {
  directives: {
    Intersect: Intersect
  },

  name: 'VcSearchPicker',

  components: {
    VcIcon,
    VcCheckbox,
    VcLoader,
    VAutocomplete: VAutocomplete
  },

  model: {
    prop: 'selectedItems',
    event: 'onSelectionChange'
  },

  props: {
    items: {
      type: Array,
      default: () => [],
      validator: prop => prop.every(item => item.text && item.value)
    },
    selectedItems: {
      type: Array,
      default: () => [],
      validator: prop => prop.every(item => typeof item === 'string')
    },
    noDataText: {
      type: String,
      required: false
    },
    errorLabelText: {
      type: String,
      required: false
    },
    placeholderBlurText: {
      type: String,
      required: false
    },
    placeholderFocus: {
      type: String,
      default: ''
    },
    showInnerIcon: {
      type: Boolean,
      default: true
    },
    iconType: {
      type: String,
      default: 'magnify_glass'
    },
    dataQa: {
      type: String,
      default: 'vc-search-picker'
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    menuContentClass: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      focused: false,
      searchInput: ''
    };
  },

  computed: {
    placeholder() {
      return this.focused ? this.placeholderFocus : this.placeholderBlur;
    },

    menuProps() {
      return {
        value: this.focused,
        contentClass: `vc-select-field-menu ${this.menuContentClass}`
      };
    },

    noData() {
      return this.noDataText || this.$dst('ds.multi_select.no_data');
    },

    errorLabel() {
      return this.errorLabelText || this.$dst('ds.multi_select.error_label');
    },

    placeholderBlur() {
      return this.placeholderBlurText || this.$dst('ds.multi_select.placeholder');
    }

  },

  methods: {
    toggleMenu(e) {
      if (this.focused && e.target.type === 'text') return;
      this.$emit('onMenuToggled', {
        isOpen: !this.focused
      });
      this.focused = !this.focused;
    },

    itemsIntersection(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.$emit('onScrollEnd');
      }
    }

  }
};

/* script */
const __vue_script__$Z = script$Z;
/* template */

var __vue_render__$U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vc-search-picker",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('v-autocomplete', {
    staticClass: "autocomplete",
    class: {
      'autocomplete--open': _vm.focused,
      'autocomplete--error': _vm.error,
      'autocomplete--has-items': _vm.selectedItems.length,
      'autocomplete--search-content': _vm.searchInput && _vm.searchInput.length
    },
    attrs: {
      "value": _vm.selectedItems,
      "items": _vm.items,
      "placeholder": _vm.placeholder,
      "no-data-text": _vm.noData,
      "menu-content-class": _vm.menuContentClass,
      "menu-props": _vm.menuProps,
      "search-input": _vm.searchInput,
      "multiple": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.searchInput = $event;
      },
      "update:search-input": [function ($event) {
        _vm.searchInput = $event;
      }, function (text) {
        return text && text.length && _vm.$emit('onSearchInput', text);
      }],
      "change": function (newVal) {
        return _vm.$emit('onSelectionChange', newVal);
      },
      "blur": function ($event) {
        _vm.focused = false;

        _vm.$emit('onMenuToggled', {
          isOpen: false
        });
      }
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.toggleMenu.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_vm.showInnerIcon ? _c('VcIcon', {
          attrs: {
            "size": "16"
          }
        }, [_vm._v(" $" + _vm._s(_vm.iconType) + " ")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (data) {
        return [_c('VcCheckbox', {
          attrs: {
            "checked": _vm.selectedItems.includes(data.item.value)
          }
        }), _vm._v(" "), _vm._t("customItem", function () {
          return [_c('div', [_vm._v(_vm._s(data.item.text))])];
        }, {
          "item": data.item
        })];
      }
    }, {
      key: "selection",
      fn: function () {
        return [_c('span', {
          staticClass: "placeholder-text"
        }, [_vm._v(_vm._s(_vm.placeholder))])];
      },
      proxy: true
    }, {
      key: "append-item",
      fn: function () {
        return [_vm.loading ? _c('VcLoader', {
          staticClass: "spinner",
          attrs: {
            "size": 20,
            "width": 2,
            "data-qa": "spinner"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          directives: [{
            name: "intersect",
            rawName: "v-intersect",
            value: _vm.itemsIntersection,
            expression: "itemsIntersection"
          }]
        })];
      },
      proxy: true
    }], null, true)
  }), _vm._v(" "), _vm.error ? _c('span', {
    staticClass: "vc-search-picker__error-label",
    attrs: {
      "data-qa": "error-label"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.errorLabel) + "\n  ")]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$U = [];
/* style */

const __vue_inject_styles__$Z = function (inject) {
  if (!inject) return;
  inject("data-v-1ec657a4_0", {
    source: "[data-v-1ec657a4]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-1ec657a4]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-1ec657a4]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-1ec657a4]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-1ec657a4]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-1ec657a4]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-1ec657a4]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-1ec657a4]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-1ec657a4]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-1ec657a4]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-1ec657a4]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-1ec657a4]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-1ec657a4]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-1ec657a4]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-1ec657a4]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-1ec657a4]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-1ec657a4]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-1ec657a4]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-1ec657a4]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-1ec657a4]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-1ec657a4]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-1ec657a4]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-1ec657a4]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-1ec657a4]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-1ec657a4]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-1ec657a4]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-1ec657a4]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-1ec657a4]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-1ec657a4]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-1ec657a4]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-1ec657a4]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-1ec657a4]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-1ec657a4]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-1ec657a4]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-1ec657a4]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-1ec657a4]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-1ec657a4]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-1ec657a4]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-1ec657a4]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-1ec657a4]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-1ec657a4]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-1ec657a4]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-1ec657a4]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-1ec657a4]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-1ec657a4]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-1ec657a4]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-1ec657a4]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-1ec657a4]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-1ec657a4]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-1ec657a4]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-1ec657a4]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-1ec657a4]{--color-dark:#63757e;--color-light:#c8d2d7}.vc-search-picker[data-v-1ec657a4]{position:relative}.vc-search-picker__error-label[data-v-1ec657a4]{font-weight:var(--font-weight-medium);font-size:var(--font-size-xx-small);color:var(--red)}.vc-search-picker[data-v-1ec657a4]  .v-input__slot{border:1px solid var(--gray-lighten-1);border-radius:var(--border-radius);height:var(--size-value13);padding:0 var(--size-value5);background-color:var(--modal-bg-color)}.vc-search-picker[data-v-1ec657a4]  .v-input__slot:hover{border-color:var(--gray-darken-2)}.vc-search-picker[data-v-1ec657a4]  .v-input__icon--append .v-icon{transform:rotate(0);color:var(--gray-darken-3)!important}.vc-search-picker[data-v-1ec657a4]  .autocomplete--open .v-input__icon--append .v-icon{transform:rotate(180deg)}.vc-search-picker[data-v-1ec657a4]  .autocomplete--open .v-input__slot{border-color:var(--v-secondary-base);outline:2px solid var(--v-secondary-lighten1)}.vc-search-picker[data-v-1ec657a4]  .autocomplete{height:var(--size-value13);padding-top:0;margin-top:0}.vc-search-picker[data-v-1ec657a4]  .autocomplete--error .v-input__slot{border-color:var(--red)}.vc-search-picker[data-v-1ec657a4]  .autocomplete--has-items .placeholder-text:not(:first-of-type){display:none}.vc-search-picker[data-v-1ec657a4]  .autocomplete--has-items.autocomplete--search-content .placeholder-text{display:none}.vc-search-picker[data-v-1ec657a4]  .placeholder-text{font-size:var(--font-size-small2);font-weight:var(--font-weight-medium);color:var(--gray-darken-5);margin-inline-end:var(--size-value2);text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.vc-search-picker[data-v-1ec657a4]  .v-text-field>.v-input__control>.v-input__slot:after,.vc-search-picker[data-v-1ec657a4]  .v-text-field>.v-input__control>.v-input__slot:before{content:initial}.vc-search-picker[data-v-1ec657a4]  .v-input__prepend-inner{margin-right:auto;padding-inline-end:var(--size-value3);height:100%;display:flex;align-items:center;margin-top:0}.vc-search-picker[data-v-1ec657a4]  .v-select__selections{flex-wrap:nowrap}.vc-search-picker[data-v-1ec657a4]  .v-select__selections input[type=text]{display:inline-block;font-size:var(--font-size-small2);color:var(--gray-darken-5);caret-color:currentColor}.vc-search-picker[data-v-1ec657a4]  .v-list-item--active::before{content:none}.v-menu__content.vc-select-field-menu[data-v-1ec657a4]{top:var(--size-value4)}.v-menu__content.vc-select-field-menu .v-input.vc-checkbox[data-v-1ec657a4]{margin:0;padding:0}.v-menu__content.vc-select-field-menu .spinner[data-v-1ec657a4]{margin:0 auto;display:block}[data-v-1ec657a4] .v-list-item--link{font-size:var(--font-size-x-small)}[data-v-1ec657a4] .v-list-item--link:before{content:initial}[data-v-1ec657a4] .v-input__append-inner{pointer-events:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$Z = "data-v-1ec657a4";
/* module identifier */

const __vue_module_identifier__$Z = undefined;
/* functional template */

const __vue_is_functional_template__$Z = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$Z, __vue_script__$Z, __vue_scope_id__$Z, __vue_is_functional_template__$Z, __vue_module_identifier__$Z, false, createInjector, undefined, undefined);

var __vue_component__$1x = __vue_component__$1w;

/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var version = "1.10.2";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !!
    /*@__PURE__*/
    navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, ["evt"]);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    if (lastChild(sortable)) return;
    var rect = getRect(sortable),
        threshold = sortable[expando].options.emptyInsertThreshold,
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // assign target only if condition is true


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      _ref5.sortable;
          var cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

var sortable_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': Sortable,
  MultiDrag: MultiDragPlugin,
  Sortable: Sortable,
  Swap: SwapPlugin
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(sortable_esm);

var vuedraggable_umd = createCommonjsModule(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory(require$$0);
})((typeof self !== 'undefined' ? self : commonjsGlobal), function(__WEBPACK_EXTERNAL_MODULE_a352__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __webpack_require__) {
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("5ca1");
var context = __webpack_require__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("5ca1");
var $includes = __webpack_require__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("9c6c")('includes');


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
var toObject = __webpack_require__("4bf8");
var IObject = __webpack_require__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a352":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c649":
/***/ (function(module, __webpack_exports__, __webpack_require__) {
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return insertNodeAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return console; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeNode; });
/* harmony import */ __webpack_require__("a481");


function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }

  return global.console;
}

var console = getConsole();

function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var regex = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(regex, function (_, c) {
    return c ? c.toUpperCase() : "";
  });
});

function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")));

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f559":
/***/ (function(module, exports, __webpack_require__) {
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  {
    __webpack_require__("f6fd");
  }

  var setPublicPath_i;
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1]; // eslint-disable-line
  }
}

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
__webpack_require__("f751");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
__webpack_require__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
__webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
__webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
__webpack_require__("456d");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
__webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
__webpack_require__("2fdb");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

// EXTERNAL MODULE: ./src/util/helper.js
var helper = __webpack_require__("c649");

// CONCATENATED MODULE: ./src/vuedraggable.js












function buildAttribute(object, propName, value) {
  if (value === undefined) {
    return object;
  }

  object = object || {};
  object[propName] = value;
  return object;
}

function computeVmIndex(vnodes, element) {
  return vnodes.map(function (elt) {
    return elt.elm;
  }).indexOf(element);
}

function _computeIndexes(slots, children, isTransition, footerOffset) {
  if (!slots) {
    return [];
  }

  var elmFromNodes = slots.map(function (elt) {
    return elt.elm;
  });
  var footerIndex = children.length - footerOffset;

  var rawIndexes = _toConsumableArray(children).map(function (elt, idx) {
    return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
  });

  return isTransition ? rawIndexes.filter(function (ind) {
    return ind !== -1;
  }) : rawIndexes;
}

function emit(evtName, evtData) {
  var _this = this;

  this.$nextTick(function () {
    return _this.$emit(evtName.toLowerCase(), evtData);
  });
}

function delegateAndEmit(evtName) {
  var _this2 = this;

  return function (evtData) {
    if (_this2.realList !== null) {
      _this2["onDrag" + evtName](evtData);
    }

    emit.call(_this2, evtName, evtData);
  };
}

function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}

function vuedraggable_isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }

  var _slots = _slicedToArray(slots, 1),
      componentOptions = _slots[0].componentOptions;

  if (!componentOptions) {
    return false;
  }

  return isTransitionName(componentOptions.tag);
}

function getSlot(slot, scopedSlot, key) {
  return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : undefined);
}

function computeChildrenAndOffsets(children, slot, scopedSlot) {
  var headerOffset = 0;
  var footerOffset = 0;
  var header = getSlot(slot, scopedSlot, "header");

  if (header) {
    headerOffset = header.length;
    children = children ? [].concat(_toConsumableArray(header), _toConsumableArray(children)) : _toConsumableArray(header);
  }

  var footer = getSlot(slot, scopedSlot, "footer");

  if (footer) {
    footerOffset = footer.length;
    children = children ? [].concat(_toConsumableArray(children), _toConsumableArray(footer)) : _toConsumableArray(footer);
  }

  return {
    children: children,
    headerOffset: headerOffset,
    footerOffset: footerOffset
  };
}

function getComponentAttributes($attrs, componentData) {
  var attributes = null;

  var update = function update(name, value) {
    attributes = buildAttribute(attributes, name, value);
  };

  var attrs = Object.keys($attrs).filter(function (key) {
    return key === "id" || key.startsWith("data-");
  }).reduce(function (res, key) {
    res[key] = $attrs[key];
    return res;
  }, {});
  update("attrs", attrs);

  if (!componentData) {
    return attributes;
  }

  var on = componentData.on,
      props = componentData.props,
      componentDataAttrs = componentData.attrs;
  update("on", on);
  update("props", props);
  Object.assign(attributes.attrs, componentDataAttrs);
  return attributes;
}

var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function (evt) {
  return "on" + evt;
});
var draggingElement = null;
var props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  value: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: function _default(original) {
      return original;
    }
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
var draggableComponent = {
  name: "draggable",
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false
    };
  },
  render: function render(h) {
    var slots = this.$slots.default;
    this.transitionMode = vuedraggable_isTransition(slots);

    var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots),
        children = _computeChildrenAndOf.children,
        headerOffset = _computeChildrenAndOf.headerOffset,
        footerOffset = _computeChildrenAndOf.footerOffset;

    this.headerOffset = headerOffset;
    this.footerOffset = footerOffset;
    var attributes = getComponentAttributes(this.$attrs, this.componentData);
    return h(this.getTag(), attributes, children);
  },
  created: function created() {
    if (this.list !== null && this.value !== null) {
      helper["b" /* console */].error("Value and list props are mutually exclusive! Please set one or another.");
    }

    if (this.element !== "div") {
      helper["b" /* console */].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
    }

    if (this.options !== undefined) {
      helper["b" /* console */].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();

    if (this.noneFunctionalComponentMode && this.transitionMode) {
      throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
    }

    var optionsAdded = {};
    eventsListened.forEach(function (elt) {
      optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
    });
    eventsToEmit.forEach(function (elt) {
      optionsAdded["on" + elt] = emit.bind(_this3, elt);
    });
    var attributes = Object.keys(this.$attrs).reduce(function (res, key) {
      res[Object(helper["a" /* camelize */])(key)] = _this3.$attrs[key];
      return res;
    }, {});
    var options = Object.assign({}, this.options, attributes, optionsAdded, {
      onMove: function onMove(evt, originalEvent) {
        return _this3.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
    this.computeIndexes();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._sortable !== undefined) this._sortable.destroy();
  },
  computed: {
    rootContainer: function rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList: function realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    $attrs: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList: function realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional: function getIsFunctional() {
      var fnOptions = this._vnode.fnOptions;
      return fnOptions && fnOptions.functional;
    },
    getTag: function getTag() {
      return this.tag || this.element;
    },
    updateOptions: function updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        var value = Object(helper["a" /* camelize */])(property);

        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes: function getChildrenNodes() {
      if (this.noneFunctionalComponentMode) {
        return this.$children[0].$slots.default;
      }

      var rawNodes = this.$slots.default;
      return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
    },
    computeIndexes: function computeIndexes() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
      });
    },
    getUnderlyingVm: function getUnderlyingVm(htmlElt) {
      var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);

      if (index === -1) {
        //Edge case during move callback: related element might be
        //an element different from collection
        return null;
      }

      var element = this.realList[index];
      return {
        index: index,
        element: element
      };
    },
    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
      var vue = _ref.__vue__;

      if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
        if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0]) return vue.$children[0];
        return vue;
      }

      return vue.$parent;
    },
    emitChanges: function emitChanges(evt) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$emit("change", evt);
      });
    },
    alterList: function alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }

      var newList = _toConsumableArray(this.value);

      onList(newList);
      this.$emit("input", newList);
    },
    spliceList: function spliceList() {
      var _arguments = arguments;

      var spliceList = function spliceList(list) {
        return list.splice.apply(list, _toConsumableArray(_arguments));
      };

      this.alterList(spliceList);
    },
    updatePosition: function updatePosition(oldIndex, newIndex) {
      var updatePosition = function updatePosition(list) {
        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
      };

      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
      var to = _ref2.to,
          related = _ref2.related;
      var component = this.getUnderlyingPotencialDraggableComponent(to);

      if (!component) {
        return {
          component: component
        };
      }

      var list = component.realList;
      var context = {
        list: list,
        component: component
      };

      if (to !== related && list && component.getUnderlyingVm) {
        var destination = component.getUnderlyingVm(related);

        if (destination) {
          return Object.assign(destination, context);
        }
      }

      return context;
    },
    getVmIndex: function getVmIndex(domIndex) {
      var indexes = this.visibleIndexes;
      var numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent: function getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData: function resetTransitionData(index) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }

      var nodes = this.getChildrenNodes();
      nodes[index].data = null;
      var transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = undefined;
    },
    onDragStart: function onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd: function onDragAdd(evt) {
      var element = evt.item._underlying_vm_;

      if (element === undefined) {
        return;
      }

      Object(helper["d" /* removeNode */])(evt.item);
      var newIndex = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex, 0, element);
      this.computeIndexes();
      var added = {
        element: element,
        newIndex: newIndex
      };
      this.emitChanges({
        added: added
      });
    },
    onDragRemove: function onDragRemove(evt) {
      Object(helper["c" /* insertNodeAt */])(this.rootContainer, evt.item, evt.oldIndex);

      if (evt.pullMode === "clone") {
        Object(helper["d" /* removeNode */])(evt.clone);
        return;
      }

      var oldIndex = this.context.index;
      this.spliceList(oldIndex, 1);
      var removed = {
        element: this.context.element,
        oldIndex: oldIndex
      };
      this.resetTransitionData(oldIndex);
      this.emitChanges({
        removed: removed
      });
    },
    onDragUpdate: function onDragUpdate(evt) {
      Object(helper["d" /* removeNode */])(evt.item);
      Object(helper["c" /* insertNodeAt */])(evt.from, evt.item, evt.oldIndex);
      var oldIndex = this.context.index;
      var newIndex = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex, newIndex);
      var moved = {
        element: this.context.element,
        oldIndex: oldIndex,
        newIndex: newIndex
      };
      this.emitChanges({
        moved: moved
      });
    },
    updateProperty: function updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }

      var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
        return el.style["display"] !== "none";
      });

      var currentDOMIndex = domChildren.indexOf(evt.related);
      var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove: function onDragMove(evt, originalEvent) {
      var onMove = this.move;

      if (!onMove || !this.realList) {
        return true;
      }

      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
      var draggedContext = this.context;
      var futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, {
        futureIndex: futureIndex
      });
      var sendEvt = Object.assign({}, evt, {
        relatedContext: relatedContext,
        draggedContext: draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd: function onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    }
  }
};

if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("draggable", draggableComponent);
}

/* harmony default export */ var vuedraggable = (draggableComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ __webpack_exports__["default"] = (vuedraggable);



/***/ })

/******/ })["default"];
});

});

var draggable = /*@__PURE__*/getDefaultExportFromCjs(vuedraggable_umd);

var script$Y = {
  name: 'VcDraggableList',
  components: {
    VcIcon,
    draggable
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    dataQa: {
      type: String,
      default: 'vc-draggable-list'
    }
  },

  data() {
    return {
      dragging: false,
      hoveringIndex: -1
    };
  },

  methods: {
    hover(index) {
      this.hoveringIndex = index;
    },

    drag(dragging, e) {
      this.dragging = dragging;

      if (!dragging) {
        this.$emit('onDragging', {
          from: e.oldIndex,
          to: e.newIndex,
          items: this.items
        });
      }
    }

  }
};

/* script */
const __vue_script__$Y = script$Y;
/* template */

var __vue_render__$T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('draggable', {
    staticClass: "list-group",
    class: {
      onDragging: _vm.dragging
    },
    attrs: {
      "list": _vm.items,
      "ghost-class": "ghost",
      "drag-class": "drag",
      "handle": ".handle",
      "data-qa": _vm.dataQa
    },
    on: {
      "start": function ($event) {
        return _vm.drag(true);
      },
      "end": function ($event) {
        return _vm.drag(false, $event);
      }
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-group-item",
      attrs: {
        "data-qa": _vm.dataQa + "--item"
      }
    }, [_c('div', {
      staticClass: "d-flex",
      class: {
        onHover: _vm.hoveringIndex === index && !_vm.dragging
      },
      attrs: {
        "data-qa": _vm.dataQa + "--in-item"
      },
      on: {
        "mouseenter": function ($event) {
          return _vm.hover(index);
        },
        "mouseleave": function ($event) {
          return _vm.hover(-1);
        }
      }
    }, [_c('VcIcon', {
      staticClass: "align-self-center handle",
      attrs: {
        "size": "16",
        "color": "var(--gray-darken-3)"
      }
    }, [_vm._v("\n        $draggable\n      ")]), _vm._v(" "), _vm._t("default", function () {
      return [_vm._v("\n        " + _vm._s(item.text) + "\n      ")];
    }, null, {
      item: item
    })], 2)]);
  }), 0);
};

var __vue_staticRenderFns__$T = [];
/* style */

const __vue_inject_styles__$Y = function (inject) {
  if (!inject) return;
  inject("data-v-563a90f4_0", {
    source: ".list-group.onDragging[data-v-563a90f4]{cursor:grabbing!important}.list-group .v-icon[data-v-563a90f4]{margin:0 var(--size-value1)}@media screen and (min-width:960px){.list-group .v-icon[data-v-563a90f4]{visibility:hidden}}@media screen and (min-width:960px){.list-group .onHover[data-v-563a90f4]{background:var(--gray-lighten-3);border-radius:var(--border-radius)}.list-group .onHover .v-icon[data-v-563a90f4]{cursor:grab;visibility:visible}}.list-group .ghost[data-v-563a90f4]{background:var(--gray-lighten-2);border:1px solid var(--v-secondary-lighten1);border-radius:var(--border-radius);box-shadow:unset;opacity:.4}.list-group .ghost .v-icon[data-v-563a90f4]{visibility:visible}.list-group .drag[data-v-563a90f4]{background:#fff;opacity:1!important;border-left:3px solid var(--v-secondary-base);box-shadow:var(--shadow-6);border-radius:var(--size-value1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$Y = "data-v-563a90f4";
/* module identifier */

const __vue_module_identifier__$Y = undefined;
/* functional template */

const __vue_is_functional_template__$Y = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$Y, __vue_script__$Y, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, createInjector, undefined, undefined);

var __vue_component__$1v = __vue_component__$1u;

var script$X = {
  name: 'VcMenu',
  props: {
    dataQa: {
      type: String,
      default: 'VcMenu'
    }
  },
  render: function (createElement) {
    const props = { ...this.$props,
      ...this.$attrs
    };
    return createElement(this.$vuetify.breakpoint.mdAndUp ? 'v-menu' : VcBottomSheet, {
      props,
      on: this.$listeners,
      scopedSlots: this.$scopedSlots
    });
  }
};

/* script */
const __vue_script__$X = script$X;
/* template */

/* style */

const __vue_inject_styles__$X = undefined;
/* scoped */

const __vue_scope_id__$X = "data-v-3f6985ce";
/* module identifier */

const __vue_module_identifier__$X = undefined;
/* functional template */

const __vue_is_functional_template__$X = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1t = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$X, __vue_script__$X, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, undefined, undefined, undefined);

var VcMenu = __vue_component__$1t;

var script$W = {
  name: 'VcDropdown',
  components: {
    VcBaseListItem,
    VcLayout,
    VcMenu,
    VcIcon,
    VDivider: VDivider
  },
  props: {
    /**
     * If set to true and no content has been placed inside the footer slot, it will contain a separator and an "add another" item, as an easy shortcut.
     */
    showAddAnother: {
      type: Boolean,
      default: false
    },

    /**
     * If you use the built in "add another" footer element, this will allow you to customize the label
     */
    addAnotherLabel: {
      type: String,
      default: ''
    },

    /**
     * Max height in pixels. additional content will be scrolled.
     */
    maxHeight: {
      type: String,
      default: '297px'
    },
    dataQa: {
      type: String,
      default: 'VcDropdown'
    },
    closeOnContentClick: {
      type: Boolean,
      default: false
    },
    contentAreaStyle: {
      type: String,
      default: 'minWidth: 220px'
    }
  },
  computed: {
    getAddAnotherLabel() {
      return this.addAnotherLabel || this.$dst('ds.menu.add');
    }

  }
};

/* script */
const __vue_script__$W = script$W;
/* template */

var __vue_render__$S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcMenu', _vm._g(_vm._b({
    attrs: {
      "offset-y": true,
      "close-on-content-click": _vm.closeOnContentClick,
      "data-qa": _vm.dataQa + "-VcMenu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (activatorObj) {
        return [_vm._t("activator", null, null, activatorObj)];
      }
    }], null, true)
  }, 'VcMenu', _vm.$attrs, false), _vm.$listeners), [_vm._v(" "), _c('VcLayout', {
    staticClass: "VcDropdown-wrapper",
    style: {
      maxHeight: _vm.maxHeight
    },
    attrs: {
      "column": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    staticClass: "header-area",
    attrs: {
      "data-qa": _vm.dataQa + "-header"
    }
  }, [_vm._t("header")], 2), _vm._v(" "), _c('VcLayout', {
    staticClass: "content-area",
    style: _vm.contentAreaStyle,
    attrs: {
      "data-qa": _vm.dataQa + "-content"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('VcLayout', {
    staticClass: "footer-area",
    attrs: {
      "data-qa": _vm.dataQa + "-footer"
    }
  }, [_vm._t("footer", function () {
    return [_vm.showAddAnother ? _c('VcLayout', {
      attrs: {
        "column": ""
      }
    }, [_c('v-divider'), _vm._v(" "), _c('VcBaseListItem', {
      attrs: {
        "data-qa": _vm.dataQa + "-add"
      },
      on: {
        "click": function (data) {
          return _vm.$emit('onAddItem', data);
        }
      }
    }, [_c('VcIcon', {
      staticClass: "add-another-icon",
      attrs: {
        "size": "12",
        "dense": ""
      }
    }, [_vm._v(" $plus ")]), _vm._v(" "), _c('span', {
      staticClass: "add-another-label"
    }, [_vm._v(_vm._s(_vm.getAddAnotherLabel))])], 1)], 1) : _vm._e()];
  })], 2)], 1)], 1);
};

var __vue_staticRenderFns__$S = [];
/* style */

const __vue_inject_styles__$W = function (inject) {
  if (!inject) return;
  inject("data-v-4069a9c2_0", {
    source: ".VcDropdown-wrapper[data-v-4069a9c2]{background-color:#fff}.content-area[data-v-4069a9c2]{overflow-y:auto;overflow-x:hidden}.add-another-label[data-v-4069a9c2]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small);line-height:var(--size-value5);color:var(--gray-darken-5)}.add-another-icon[data-v-4069a9c2]{margin-inline-end:var(--size-value3);cursor:pointer}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$W = "data-v-4069a9c2";
/* module identifier */

const __vue_module_identifier__$W = undefined;
/* functional template */

const __vue_is_functional_template__$W = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$W, __vue_script__$W, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, createInjector, undefined, undefined);

var VcDropdown = __vue_component__$1s;

var script$V = {
  name: 'VcTabs',
  components: {
    VcBaseListItem,
    VcLayout,
    VcDropdown,
    VcIcon,
    VcButton,
    VcTooltip,
    draggable,
    VTab: VTab,
    VTabs: VTabs,
    VTabItem: VTabItem,
    VTabsItems: VTabsItems
  },
  model: {
    prop: 'currentIndex',
    event: 'change'
  },
  props: {
    tabs: {
      type: Array,
      required: true,
      validator: value => value.every(tab => tab.label)
    },
    tabSize: {
      type: String,
      default: 'M',
      validator: value => ['M', 'L'].includes(value)
    },
    currentIndex: {
      type: Number,
      default: 0,
      validator: prop => prop >= 0
    },
    distribution: {
      type: String,
      default: 'start',
      validator: prop => ['start', 'equal', 'grow'].includes(prop)
    },
    separatorStyle: {
      type: String,
      default: 'default',
      validator: prop => ['default', 'shadow', 'divider'].includes(prop)
    },
    dataQa: {
      type: String,
      default: 'VcTabs'
    },
    fullHeightTabs: {
      type: Boolean,
      default: false
    },
    contentTransition: {
      type: Boolean,
      default: true
    },
    sliderTransition: {
      type: Boolean,
      default: true
    },
    tabDragScroll: {
      type: Boolean,
      default: false
    },
    tabsBottomBorder: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default',
      validator: prop => ['default', 'folder'].includes(prop)
    },

    /**
     * The following props are relevant only for 'folder' type
     */
    isDraggable: {
      type: Boolean,
      default: false
    },
    disableCloseButton: {
      type: Boolean,
      default: false
    },
    closeButtonTooltip: {
      type: String,
      default: 'Remove'
    },
    menuButtonTooltip: {
      type: String,
      default: 'More'
    },
    dragTooltip: {
      type: String
    },
    disableDrag: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isDragging: false
    };
  },

  computed: {
    safeCurrentIndex() {
      return Math.max(0, Math.min(this.currentIndex, this.tabs.length - 1));
    },

    tabHeight() {
      let height = this.tabSize === 'M' ? 48 : 60;

      if (this.type === 'folder' && this.tabSize === 'L') {
        height = 62;
      }

      return height;
    },

    customClasses() {
      return {
        separatorShadow: this.separatorStyle === 'shadow',
        separatorDivider: this.separatorStyle === 'divider',
        'no-tabs-transition': !this.sliderTransition,
        'no-drag-scroll': !this.tabDragScroll,
        'tabs-bottom-border': this.tabsBottomBorder,
        [this.type]: true
      };
    },

    dragIconClasses() {
      return {
        'folder-label__drag': true,
        'folder-label__drag--dragging': this.isDragging,
        'folder-label__drag--disabled': !this.isDraggable
      };
    },

    folderLabelClasses() {
      return {
        'label-text': true,
        'folder-small': this.type === 'folder' && this.tabSize === 'M'
      };
    }

  },

  mounted() {
    this.scrollTabIntoView(this.currentIndex);
  },

  methods: {
    drag(isDragging, event) {
      this.isDragging = isDragging;

      if (!isDragging) {
        this.$emit('tabDragged', {
          oldIndex: event.oldIndex,
          newIndex: event.newIndex,
          tabs: this.tabs
        });
      }
    },

    onActionClick(item, actionIndex) {
      item.isMenuOpen = false;
      this.$emit('actionItemClick', {
        item,
        actionIndex
      });
    },

    onTabChange(newIndex) {
      !this.tabDragScroll && this.scrollTabIntoView(newIndex, 'smooth');
      this.$emit('change', newIndex);
    },

    scrollTabIntoView(index, behavior = 'instant') {
      const tab = this.$refs[`tab-${index}`];
      if (isNaN(index) || index < 0 || !tab) return;
      tab[0].$el.scrollIntoView && tab[0].$el.scrollIntoView({
        behavior,
        block: 'center'
      });
    }

  }
};

/* script */
const __vue_script__$V = script$V;
/* template */

var __vue_render__$R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "VcTabs--wrapper",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('v-tabs', {
    ref: "tabsArea",
    staticClass: "VcTabs--content",
    class: _vm.customClasses,
    attrs: {
      "value": _vm.safeCurrentIndex,
      "background-color": "transparent",
      "slider-color": "secondary",
      "slider-size": "4",
      "height": _vm.tabHeight,
      "grow": _vm.distribution === 'grow',
      "fixed-tabs": _vm.distribution === 'equal',
      "data-qa": _vm.dataQa + "-tabs-container"
    },
    on: {
      "change": _vm.onTabChange
    }
  }, [_c('draggable', {
    staticClass: "draggable-tabs",
    attrs: {
      "list": _vm.tabs,
      "handle": _vm.disableDrag ? '.folder-label__no-drag' : '.folder-label__drag'
    },
    on: {
      "start": function ($event) {
        return _vm.drag(true);
      },
      "end": function ($event) {
        return _vm.drag(false, $event);
      }
    }
  }, [_vm._l(_vm.tabs, function (item, index) {
    return _c('v-tab', {
      key: "tab-" + index,
      ref: "tab-" + index,
      refInFor: true,
      class: {
        VcTab: true,
        VcTabDisabled: item.disabled,
        VcTabFolder: _vm.type === 'folder'
      },
      attrs: {
        "active-class": "VcTabActive",
        "disabled": item.disabled,
        "data-qa": _vm.dataQa + "-tab-" + (item.dataQaIdentifier || index)
      }
    }, [_vm._t("tab-" + index, function () {
      return [_vm.type === 'folder' ? _c('div', {
        key: index,
        staticClass: "folder-label"
      }, [_c('VcTooltip', {
        attrs: {
          "content": _vm.dragTooltip,
          "disabled": !_vm.dragTooltip,
          "dark": "",
          "bottom": ""
        }
      }, [_c('VcIcon', {
        class: _vm.dragIconClasses,
        attrs: {
          "size": "16",
          "data-qa": _vm.dataQa + "-drag-" + (item.dataQaIdentifier || index),
          "color": _vm.dragTooltip ? 'var(--gray)' : 'var(--gray-darken-4)'
        }
      }, [_vm._v("\n                $draggable\n              ")])], 1), _vm._v(" "), _c('div', {
        staticClass: "folder-label__info"
      }, [_vm._t("folder-label-info-" + index, function () {
        return [_c('span', {
          class: _vm.folderLabelClasses
        }, [_vm._v(_vm._s(item.label))])];
      }, {
        "item": item
      })], 2), _vm._v(" "), _c('VcTooltip', {
        attrs: {
          "content": _vm.closeButtonTooltip,
          "dark": "",
          "bottom": ""
        }
      }, [_c('VcButton', {
        staticClass: "folder-label__close",
        attrs: {
          "icon": "",
          "x-small": "",
          "disabled": _vm.disableCloseButton,
          "data-qa": _vm.dataQa + "-close-" + (item.dataQaIdentifier || index)
        },
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return _vm.$emit('closeButtonClicked', index);
          }
        },
        scopedSlots: _vm._u([{
          key: "prepend",
          fn: function () {
            return [_c('VcIcon', {
              attrs: {
                "size": "12",
                "color": _vm.disableCloseButton ? 'var(--gray-darken-1)' : 'var(--gray-darken-4)'
              }
            }, [_vm._v("\n                    $close_button\n                  ")])];
          },
          proxy: true
        }], null, true)
      })], 1), _vm._v(" "), _c('VcTooltip', {
        attrs: {
          "content": _vm.menuButtonTooltip,
          "dark": "",
          "bottom": ""
        }
      }, [_c('VcDropdown', {
        attrs: {
          "data-qa": _vm.dataQa + "-VcDropdown-more-tab-" + (item.dataQaIdentifier || index)
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function (ref) {
            var on = ref.on;
            var attrs = ref.attrs;
            return [_c('VcButton', _vm._g(_vm._b({
              staticClass: "folder-label__menu",
              attrs: {
                "icon": "",
                "x-small": "",
                "data-qa": _vm.dataQa + "-VcDropdown-more-tab-" + (item.dataQaIdentifier || index) + "-three-dots"
              },
              scopedSlots: _vm._u([{
                key: "prepend",
                fn: function () {
                  return [_c('VcIcon', {
                    attrs: {
                      "size": "14",
                      "color": "var(--gray-darken-4)"
                    }
                  }, [_vm._v("$three_dots")])];
                },
                proxy: true
              }], null, true)
            }, 'VcButton', attrs, false), on))];
          }
        }, {
          key: "header",
          fn: function () {
            return [_vm._t("folder-more--top-content-" + index)];
          },
          proxy: true
        }, {
          key: "default",
          fn: function () {
            return [_c('VcLayout', {
              attrs: {
                "column": ""
              }
            }, _vm._l(item.actions, function (action, actionIndex) {
              return _c('VcBaseListItem', {
                key: "action-" + actionIndex,
                attrs: {
                  "data-qa": _vm.dataQa + "-tab-" + (item.dataQaIdentifier || index) + "-actionItem-" + actionIndex
                },
                on: {
                  "click": function ($event) {
                    return _vm.onActionClick(item, actionIndex);
                  }
                }
              }, [_c('VcIcon', {
                staticClass: "folder-more--action-item-icon",
                attrs: {
                  "size": "16",
                  "dense": ""
                }
              }, [_vm._v(_vm._s(action.icon))]), _vm._v(" "), _c('span', {
                staticClass: "folder-more--action-item-label"
              }, [_vm._v(_vm._s(action.label))])], 1);
            }), 1)];
          },
          proxy: true
        }, {
          key: "footer",
          fn: function (ref) {
            ref.on;
            ref.attrs;
            return [_vm._t("folder-more--bottom-content-" + index)];
          }
        }], null, true),
        model: {
          value: item.isMenuOpen,
          callback: function ($$v) {
            _vm.$set(item, "isMenuOpen", $$v);
          },
          expression: "item.isMenuOpen"
        }
      })], 1)], 1) : _c('span', {
        staticClass: "VcTab-label"
      }, [_vm._v(_vm._s(item.label))])];
    }, {
      "item": item
    })], 2);
  }), _vm._v(" "), _vm._t("append")], 2)], 1), _vm._v(" "), _c('v-tabs-items', {
    staticClass: "VcTabsContent",
    class: {
      'full-height-tabs': _vm.fullHeightTabs
    },
    attrs: {
      "value": _vm.safeCurrentIndex
    },
    on: {
      "change": function (newIndex) {
        return _vm.$emit('change', newIndex);
      }
    }
  }, _vm._l(_vm.tabs, function (item, index) {
    return _c('v-tab-item', {
      key: "tab-content-" + index,
      attrs: {
        "transition": _vm.type === 'folder' || !_vm.contentTransition ? false : undefined,
        "data-qa": _vm.dataQa + "-tab-content-" + (item.dataQaIdentifier || index)
      }
    }, [_vm._t("tab-content-" + index, function () {
      return [_c('div', [_vm._v(_vm._s(item.label))])];
    }, {
      "item": item
    })], 2);
  }), 1)], 1);
};

var __vue_staticRenderFns__$R = [];
/* style */

const __vue_inject_styles__$V = function (inject) {
  if (!inject) return;
  inject("data-v-11efaa04_0", {
    source: ".VcTabs--wrapper[data-v-11efaa04]{display:flex;flex-direction:column;height:100%}.VcTabs--wrapper .separatorShadow[data-v-11efaa04]{border-bottom:1px solid var(--gray-lighten-1);box-shadow:var(--shadow-1)}.VcTabs--wrapper .separatorDivider[data-v-11efaa04]{border-bottom:1px solid var(--gray-lighten-1)}.VcTabs--wrapper .folder[data-v-11efaa04]  .v-tabs-slider-wrapper{transition:none;bottom:auto}.VcTabs--wrapper .folder[data-v-11efaa04]  .v-ripple__container{display:none!important}.VcTabs--wrapper .folder[data-v-11efaa04]  .VcTab{padding:0;min-width:auto}.VcTabs--wrapper .folder[data-v-11efaa04]  .VcTabActive:hover::before{opacity:0}.VcTabs--wrapper .full-height-tabs[data-v-11efaa04]{height:calc(100% - 1px)}.VcTabs--wrapper .full-height-tabs .v-window-item[data-v-11efaa04]{height:100%}.VcTabs--wrapper .no-tabs-transition[data-v-11efaa04]  .v-tabs-slider-wrapper{transition:none}.VcTabs--wrapper .no-drag-scroll[data-v-11efaa04]  .v-slide-group__wrapper{overflow-x:auto;overflow-y:hidden}.VcTabs--wrapper .no-drag-scroll[data-v-11efaa04]  .v-slide-group__content{transform:none!important}.VcTabs--wrapper .tabs-bottom-border[data-v-11efaa04]  .v-slide-group__wrapper{border-bottom:1px solid var(--gray-lighten-1)}.VcTabs--wrapper .draggable-tabs[data-v-11efaa04]{display:flex;width:100%}.VcTabs--content[data-v-11efaa04]{flex:unset}.VcTab[data-v-11efaa04]:focus{color:rgba(255,255,255,0)!important;box-shadow:inset 0 0 0 3px var(--v-secondary-lighten1);border-radius:2px}.VcTab:focus .VcTab-label[data-v-11efaa04]{color:var(--gray-darken-4)}.VcTab:focus.VcTabDisabled[data-v-11efaa04]{background:rgba(0,0,0,.04);color:var(--gray-darken-2)}.VcTabActive[data-v-11efaa04]{color:var(--gray-darken-5)}.VcTab-label[data-v-11efaa04]{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2);line-height:var(--size-value4);letter-spacing:0;text-transform:initial}.VcTabFolder[data-v-11efaa04]{width:100%;max-width:216px}.VcTabFolder .folder-label[data-v-11efaa04]{display:flex;flex-direction:row;height:100%;width:100%;font-size:var(--font-size-xx-small);border-inline-end:1px solid var(--gray-lighten-2);text-transform:none;letter-spacing:normal;padding:var(--size-value3) var(--size-value1);gap:var(--size-value1);text-align:start}.VcTabFolder .folder-label__info[data-v-11efaa04]{width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.VcTabFolder .folder-label__info .label-text[data-v-11efaa04]{line-height:var(--size-value5)}.VcTabFolder .folder-label__info .folder-small[data-v-11efaa04]{font-size:var(--font-size-x-small);font-weight:var(--font-weight-large)}.VcTabFolder .folder-label__close[data-v-11efaa04],.VcTabFolder .folder-label__menu[data-v-11efaa04]{top:-3px;display:none}.VcTabFolder .folder-label__close[data-v-11efaa04]{margin-inline-end:-4px}.VcTabFolder .folder-label__drag[data-v-11efaa04]{cursor:grab}.VcTabFolder .folder-label__drag--dragging[data-v-11efaa04]{cursor:grabbing}.VcTabFolder .folder-label__drag--hidden[data-v-11efaa04]{visibility:hidden}.VcTabFolder .folder-label:hover .folder-label__close[data-v-11efaa04],.VcTabFolder .folder-label:hover .folder-label__menu[data-v-11efaa04]{display:flex;animation:fadeIn-data-v-11efaa04 250ms}.VcTabFolder .folder-label:hover .folder-label__drag[data-v-11efaa04]:not(.folder-label__drag--hidden){visibility:visible}.VcTabFolder:not(.VcTabActive) .folder-label[data-v-11efaa04]{background-color:var(--gray-lighten-4);border-bottom:1px solid var(--gray-lighten-2)}.VcTabFolder:not(.VcTabActive) .folder-label .folder-small[data-v-11efaa04]{font-weight:var(--font-weight-medium2)}.VcTabFolder:not(.VcTabActive) .folder-label__drag[data-v-11efaa04]{visibility:hidden}.VcTabFolder:not(.VcTabActive) .folder-label:hover .folder-label__drag[data-v-11efaa04]{visibility:visible;animation:fadeIn-data-v-11efaa04 250ms}.VcTabFolder[data-v-11efaa04]:focus{color:unset!important;box-shadow:none}.VcTabsContent[data-v-11efaa04]{background-color:transparent;overflow-y:auto}[data-v-11efaa04] .v-slide-group__next,[data-v-11efaa04] .v-slide-group__prev{display:none!important}.folder-more--action-item-icon[data-v-11efaa04]{margin-inline-end:var(--size-value3)}.folder-more--action-item-label[data-v-11efaa04]{line-height:var(--size-value5);font-weight:var(--font-weight-medium);font-size:var(--font-size-x-small)}@keyframes fadeIn-data-v-11efaa04{from{opacity:0}to{opacity:1}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$V = "data-v-11efaa04";
/* module identifier */

const __vue_module_identifier__$V = undefined;
/* functional template */

const __vue_is_functional_template__$V = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$V, __vue_script__$V, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, createInjector, undefined, undefined);

var __vue_component__$1r = __vue_component__$1q;

var script$U = {
  name: 'VcGroupedItems',
  components: {
    VcLayout,
    VcIcon,
    VDivider: VDivider
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcGroupedItems'
    },
    selected: {
      type: String,
      required: false
    },
    itemGroups: {
      type: Array,
      validator: prop => prop.every(group => group.label && group.id),
      required: true
    },
    flavor: {
      type: String,
      default: 'flat',
      validator: value => ['flat', 'elevated'].includes(value)
    },
    showDividers: {
      type: Boolean,
      default: false
    },
    groupClass: {
      type: String
    },
    itemClass: {
      type: String
    },
    direction: {
      type: String,
      default: 'vertical',
      validator: value => ['vertical', 'horizontal'].includes(value)
    },
    noFocusBorder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    }

  }
};

/* script */
const __vue_script__$U = script$U;
/* template */

var __vue_render__$Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "grouped-items",
    attrs: {
      "column": _vm.direction === 'vertical',
      "data-qa": _vm.dataQa
    }
  }, _vm._l(_vm.itemGroups, function (group, groupIndex) {
    var _obj;

    return _c('div', {
      key: group.id,
      staticClass: "grouped-items__group",
      class: (_obj = {}, _obj[_vm.groupClass] = _vm.groupClass, _obj),
      attrs: {
        "data-qa": "group-" + group.id
      }
    }, [_vm._t("group-" + group.id + "-header", function () {
      return [_vm._t("header", function () {
        return [_c('div', {
          class: "grouped-items__group__header " + _vm.flavor + " mb-2"
        }, [_vm._v("\n          " + _vm._s(group.label) + "\n        ")])];
      }, {
        "group": group
      })];
    }, {
      "group": group
    }), _vm._v(" "), group.items ? _c('VcLayout', {
      class: "grouped-items__group__container " + _vm.flavor,
      attrs: {
        "column": ""
      }
    }, _vm._l(group.items, function (item) {
      var _obj;

      return _c('VcLayout', {
        key: item.id,
        staticClass: "grouped-items__group__container__menu-item d-flex align-center flex-grow-1",
        class: (_obj = {
          selected: _vm.selected && item.id === _vm.selected,
          disabled: item.disabled,
          mobile: _vm.isMobile,
          rtl: _vm.$vuetify.rtl
        }, _obj[_vm.itemClass] = _vm.itemClass, _obj['no-focus-border'] = _vm.noFocusBorder, _obj),
        attrs: {
          "tabindex": 0,
          "data-qa": "item-" + item.id
        },
        on: {
          "click": function ($event) {
            return _vm.$emit('change', item.id);
          },
          "keyup": function ($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }

            return _vm.$emit('change', item.id);
          }
        }
      }, [_vm._t("item-" + item.id, function () {
        return [_vm._t("item", function () {
          return [_c('VcLayout', {
            staticClass: "px-4 flex-grow-1",
            attrs: {
              "justify-space-between": "",
              "align-center": ""
            }
          }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _vm.isMobile ? _c('VcIcon', {
            attrs: {
              "size": "12",
              "disabled": item.disabled
            }
          }, [_vm._v("\n                $chevron_right\n              ")]) : _vm._e()], 1)];
        }, {
          "item": item
        })];
      }, {
        "item": item
      })], 2);
    }), 1) : _vm._e(), _vm._v(" "), _vm.showDividers && groupIndex < _vm.itemGroups.length - 1 ? _c('v-divider') : _vm._e()], 2);
  }), 0);
};

var __vue_staticRenderFns__$Q = [];
/* style */

const __vue_inject_styles__$U = function (inject) {
  if (!inject) return;
  inject("data-v-4eaddcca_0", {
    source: ".grouped-items[data-v-4eaddcca]{column-gap:var(--size-value5)}.grouped-items__group__header[data-v-4eaddcca]{font-size:var(--font-size-xx-small);font-weight:var(--font-weight-large);line-height:var(--size-value5);color:var(--gray-darken-2)}.grouped-items__group__header.flat[data-v-4eaddcca]{padding-left:var(--size-value4);font-size:var(--font-size-xxx-small)}.grouped-items__group__container[data-v-4eaddcca]{border-radius:var(--border-radius);background-color:var(--modal-bg-color)}.grouped-items__group__container.elevated[data-v-4eaddcca]{box-shadow:var(--shadow-1)}.grouped-items__group__container .no-focus-border[data-v-4eaddcca]:focus,.grouped-items__group__container .no-focus-border[data-v-4eaddcca]:focus-visible{border:0}.grouped-items__group__container__menu-item[data-v-4eaddcca]{cursor:pointer;box-sizing:border-box;height:var(--size-value11);font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small);border-inline-start:3px solid var(--modal-bg-color);transition:.3s;transition-property:border-color,background-color}.grouped-items__group__container__menu-item[data-v-4eaddcca]:first-of-type{margin-top:var(--size-value1)}.grouped-items__group__container__menu-item[data-v-4eaddcca]:last-of-type{margin-bottom:var(--size-value1)}.grouped-items__group__container__menu-item[data-v-4eaddcca]:hover{border-color:var(--gray-lighten-3);background-color:var(--gray-lighten-3)}.grouped-items__group__container__menu-item.no-focus-border[data-v-4eaddcca]{border-inline-start:0}.grouped-items__group__container__menu-item[data-v-4eaddcca]:focus,.grouped-items__group__container__menu-item[data-v-4eaddcca]:focus-visible{border:3px solid var(--v-secondary-lighten1)}.grouped-items__group__container__menu-item[data-v-4eaddcca]:active:not(.mobile){border-color:var(--gray-lighten-1);background-color:var(--gray-lighten-1)}.grouped-items__group__container__menu-item.selected[data-v-4eaddcca]{font-weight:var(--font-weight-large)}.grouped-items__group__container__menu-item.selected[data-v-4eaddcca]:not(.mobile){border-inline-start:3px solid var(--v-secondary-base)}.grouped-items__group__container__menu-item.mobile[data-v-4eaddcca]{color:var(--gray-darken-5);height:var(--size-value13)}.grouped-items__group__container__menu-item.mobile[data-v-4eaddcca]  svg.vc-chevron-right{fill:var(--gray-darken-2)}.grouped-items__group__container__menu-item.mobile.rtl[data-v-4eaddcca]  svg.vc-chevron-right{transform:scaleX(-1)}.grouped-items__group__container__menu-item.disabled[data-v-4eaddcca]{cursor:unset;pointer-events:none;color:var(--gray-darken-2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$U = "data-v-4eaddcca";
/* module identifier */

const __vue_module_identifier__$U = undefined;
/* functional template */

const __vue_is_functional_template__$U = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$U, __vue_script__$U, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, createInjector, undefined, undefined);

var VcGroupedItems = __vue_component__$1p;

var script$T = {
  name: 'VcSideNav',
  components: {
    VcGroupedItems
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcSideNav'
    },
    selected: {
      type: String,
      required: true
    },
    navGroups: {
      type: Array,
      validator: prop => prop.every(group => group.label && group.id)
    }
  },
  computed: {
    allItems() {
      return this.navGroups.reduce((acc, group) => acc.concat(group.items), []);
    }

  },
  methods: {
    getGroupSlotName(groupId) {
      return `group-${groupId}-header`;
    },

    getItemSlotName(itemId) {
      return `item-${itemId}`;
    }

  }
};

/* script */
const __vue_script__$T = script$T;
/* template */

var __vue_render__$P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcGroupedItems', {
    attrs: {
      "item-groups": _vm.navGroups,
      "selected": _vm.selected,
      "flavor": "elevated",
      "data-qa": _vm.dataQa
    },
    on: {
      "change": function (data) {
        return _vm.$emit('change', data);
      }
    },
    scopedSlots: _vm._u([_vm._l(_vm.navGroups, function (group) {
      return {
        key: _vm.getGroupSlotName(group.id),
        fn: function () {
          return [_vm._t("group-" + group.id + "-header")];
        },
        proxy: true
      };
    }), _vm._l(_vm.allItems, function (item) {
      return {
        key: _vm.getItemSlotName(item.id),
        fn: function () {
          return [_vm._t("item-" + item.id, null, {
            "item": item
          })];
        },
        proxy: true
      };
    })], null, true)
  });
};

var __vue_staticRenderFns__$P = [];
/* style */

const __vue_inject_styles__$T = undefined;
/* scoped */

const __vue_scope_id__$T = "data-v-46dfec22";
/* module identifier */

const __vue_module_identifier__$T = undefined;
/* functional template */

const __vue_is_functional_template__$T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$T, __vue_script__$T, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, undefined, undefined, undefined);

var __vue_component__$1o = __vue_component__$1n;

var script$S = {
  name: 'VcBanner',
  components: {
    VcButton
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcMiniBanner'
    },
    thumbImage: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    ctaLabel: {
      type: String,
      required: true
    },
    gradientHue: {
      type: String
    }
  }
};

/* script */
const __vue_script__$S = script$S;
/* template */

var __vue_render__$O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vc-mini-banner d-flex flex-column flex-sm-row justify-space-between justify-sm-start align-start align-sm-center",
    style: {
      background: _vm.gradientHue ? "linear-gradient(" + (_vm.$vuetify.breakpoint.smAndUp ? 90 : 180) + "deg, " + _vm.gradientHue + " 0%, #fff 42%, #fff 100%)" : 'transparent'
    },
    attrs: {
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onAction');
      }
    }
  }, [_c('div', {
    staticClass: "vc-mini-banner__thumbnail"
  }, [_c('div', {
    staticClass: "vc-mini-banner__image-wrap"
  }, [_c('div', {
    staticClass: "vc-mini-banner__image",
    style: {
      backgroundImage: "url(" + _vm.thumbImage + ")"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "vc-mini-banner__text-content"
  }, [_c('h3', {
    staticClass: "vc-mini-banner__title",
    attrs: {
      "data-qa": _vm.dataQa + "-title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _vm.subtitle ? _c('h4', {
    staticClass: "vc-mini-banner__subtitle",
    attrs: {
      "data-qa": _vm.dataQa + "-subtitle"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vc-mini-banner__cta"
  }, [_c('VcButton', {
    staticClass: "primary-cta",
    attrs: {
      "pill": "",
      "small": "",
      "data-qa": _vm.dataQa + "-button"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.ctaLabel) + "\n    ")])], 1)]);
};

var __vue_staticRenderFns__$O = [];
/* style */

const __vue_inject_styles__$S = function (inject) {
  if (!inject) return;
  inject("data-v-b38ff6be_0", {
    source: ".vc-mini-banner[data-v-b38ff6be]{min-height:66px;overflow:hidden;border-radius:var(--size-value2);border:1px solid var(--neutral-lighten-2);padding:var(--size-value4);padding-inline-start:var(--size-value5);padding-inline-end:var(--size-value8);grid-gap:var(--size-value5);cursor:pointer;background-color:var(--modal-bg-color)}.vc-mini-banner__thumbnail[data-v-b38ff6be]{background:var(--modal-bg-color);height:var(--size-value12);width:var(--size-value12);box-shadow:var(--shadow-5);border-radius:var(--border-radius)}.vc-mini-banner__image-wrap[data-v-b38ff6be]{height:inherit;width:inherit;padding:var(--size-value2)}.vc-mini-banner__image[data-v-b38ff6be]{height:100%;background-repeat:no-repeat;background-size:contain}.vc-mini-banner__text-content[data-v-b38ff6be]{color:var(--gray-darken-5)}.vc-mini-banner__title[data-v-b38ff6be]{font-weight:var(--font-weight-large2);font-size:var(--font-size-small3)}@media screen and (min-width:600px){.vc-mini-banner__title[data-v-b38ff6be]{font-weight:var(--font-weight-large);font-size:var(--font-size-small2)}}.vc-mini-banner__subtitle[data-v-b38ff6be]{margin-top:var(--size-value1);font-weight:var(--font-weight-medium);font-size:var(--font-size-small2)}@media screen and (min-width:600px){.vc-mini-banner__subtitle[data-v-b38ff6be]{font-weight:var(--font-weight-medium);font-size:var(--font-size-xx-small)}}.vc-mini-banner__subtitle[data-v-b38ff6be],.vc-mini-banner__title[data-v-b38ff6be]{user-select:none}@media screen and (min-width:600px){.vc-mini-banner__cta[data-v-b38ff6be]{margin-inline-start:auto}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$S = "data-v-b38ff6be";
/* module identifier */

const __vue_module_identifier__$S = undefined;
/* functional template */

const __vue_is_functional_template__$S = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$S, __vue_script__$S, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, createInjector, undefined, undefined);

var __vue_component__$1m = __vue_component__$1l;

var script$R = {
  name: 'VcGalleryItem',
  components: {
    VcIcon,
    VcButton,
    VcLayout
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcGalleryItem'
    },
    flavor: {
      type: String,
      default: 'basic',
      validator: prop => ['basic', 'pro', 'create'].includes(prop)
    },
    isMobile: {
      type: Boolean,
      required: true
    },
    uid: {
      type: String,
      required: true
    },
    campaignUrl: {
      type: String,
      required: false
    },
    color: {
      type: String,
      default: 'var(--v-secondary-base)'
    },
    src: {
      type: String
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    outerTitle: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      required: false
    },
    ctaLabel: {
      type: String,
      default: 'click Here'
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      isImageError: false
    };
  },

  computed: {
    isPro() {
      return this.flavor === 'pro';
    },

    isCreate() {
      return this.flavor === 'create';
    },

    isBasic() {
      return this.flavor === 'basic';
    },

    bottomLabel() {
      return !this.isCreate ? this.outerTitle : this.$dst('ds.gallery_item.create');
    },

    itemDataQa() {
      return `${this.dataQa}-${this.flavor}`;
    },

    previewItem() {
      const {
        uid,
        campaignUrl,
        title,
        description
      } = this;
      return {
        uid,
        campaignUrl,
        title,
        description
      };
    }

  }
};

/* script */
const __vue_script__$R = script$R;
/* template */

var __vue_render__$N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vc-gallery-item",
    class: {
      'vc-gallery-item--is-create': _vm.isCreate,
      'vc-gallery-item--is-pro': _vm.isPro,
      'vc-gallery-item--is-basic': _vm.isBasic,
      'vc-gallery-item--mobile': _vm.isMobile,
      'vc-gallery-item--selected': _vm.selected,
      'vc-gallery-item--disabled': _vm.disabled
    },
    attrs: {
      "data-qa": _vm.itemDataQa
    }
  }, [_c('div', {
    staticClass: "vc-gallery-item__thumbnail d-flex flex-column",
    attrs: {
      "data-qa": _vm.dataQa + "-thumbnail"
    },
    on: {
      "click": function ($event) {
        _vm.isCreate ? _vm.$emit('onCreate') : _vm.isMobile && _vm.$emit('onPreview', _vm.previewItem);
      }
    }
  }, [_vm.isBasic ? _c('section', {
    staticClass: "vc-gallery-item__top d-flex flex-column"
  }, [_c('div', {
    staticClass: "vc-gallery-item__top-wrap d-flex flex-column"
  }, [_c('div', {
    staticClass: "vc-gallery-item__label-wrap d-flex flex-column justify-center"
  }, [_c('h3', {
    staticClass: "vc-gallery-item__label",
    style: {
      color: _vm.color
    },
    attrs: {
      "data-qa": _vm.dataQa + "-label"
    }
  }, [_vm._t("label", function () {
    return [_vm._v("\n              " + _vm._s(!_vm.isCreate ? _vm.title : _vm.$dst('ds.gallery_item.create')) + "\n            ")];
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "vc-gallery-item__skeleton",
    attrs: {
      "data-qa": _vm.dataQa + "-skeleton"
    }
  }, [_c('VcIcon', [_vm._v("$skeleton")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vc-gallery-item__cta d-flex justify-center align-center",
    attrs: {
      "data-qa": _vm.dataQa + "-cta"
    }
  }, [_c('button', {
    staticClass: "cta-button",
    style: {
      backgroundColor: _vm.color
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ctaLabel) + "\n          ")])])])]) : _vm._e(), _vm._v(" "), _vm.isPro || _vm.isBasic ? _c('div', {
    staticClass: "vc-gallery-item__bottom",
    class: {
      'vc-gallery-item__bottom--full-height': _vm.isPro,
      'vc-gallery-item__bottom--fallback': _vm.isImageError
    }
  }, [!_vm.isImageError ? _c('img', {
    staticClass: "vc-gallery-item__image",
    attrs: {
      "src": _vm.src,
      "alt": _vm.alt
    },
    on: {
      "error": function ($event) {
        _vm.isImageError = true;
      }
    }
  }) : _c('VcIcon', {
    attrs: {
      "size": "60"
    }
  }, [_vm._v(" $gallery_fallback ")]), _vm._v(" "), _vm.selected ? _c('VcLayout', {
    staticClass: "selected-indicator",
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('VcIcon', {
    attrs: {
      "color": "white",
      "size": "16",
      "data-qa": _vm.dataQa + "-selected-icon"
    }
  }, [_vm._v(" $success ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), !_vm.isMobile || _vm.isCreate ? _c('div', {
    staticClass: "buttons flex-column align-center justify-center"
  }, [_vm._t("actions", function () {
    return [_c('div', {
      staticClass: "align-buttons d-inline-flex flex-column"
    }, [!_vm.isCreate ? _c('VcButton', {
      staticClass: "buttons__select",
      attrs: {
        "pill": "",
        "label": _vm.$dst('ds.gallery_item.select'),
        "data-qa": _vm.dataQa + "-select-btn",
        "disabled": _vm.disabled
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('onSelect', _vm.uid);
        }
      }
    }) : _vm._e(), _vm._v(" "), !_vm.isCreate ? _c('VcButton', {
      staticClass: "buttons__preview",
      attrs: {
        "flavor": "secondary",
        "pill": "",
        "label": _vm.$dst('ds.gallery_item.preview'),
        "data-qa": _vm.dataQa + "-preview-btn"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('onPreview', _vm.previewItem);
        }
      }
    }) : _c('div', {
      staticClass: "create__wrap"
    }, [_c('VcButton', {
      staticClass: "create__button",
      attrs: {
        "icon": "",
        "plain": "",
        "data-qa": _vm.dataQa + "-create-button"
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_c('VcIcon', {
            attrs: {
              "size": "32",
              "color": "var(--v-secondary-base)"
            }
          }, [_vm._v(" $plus ")])];
        },
        proxy: true
      }], null, false, 1891255564)
    })], 1)], 1)];
  })], 2) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "vc-gallery-item__bottom_label",
    attrs: {
      "data-qa": _vm.dataQa + "-label"
    }
  }, [_vm._t("label", function () {
    return [_vm._v("\n      " + _vm._s(_vm.bottomLabel) + "\n    ")];
  })], 2)]);
};

var __vue_staticRenderFns__$N = [];
/* style */

const __vue_inject_styles__$R = function (inject) {
  if (!inject) return;
  inject("data-v-1f8cae11_0", {
    source: "[data-v-1f8cae11]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-1f8cae11]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-1f8cae11]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-1f8cae11]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-1f8cae11]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-1f8cae11]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-1f8cae11]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-1f8cae11]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-1f8cae11]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-1f8cae11]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-1f8cae11]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-1f8cae11]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-1f8cae11]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-1f8cae11]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-1f8cae11]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-1f8cae11]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-1f8cae11]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-1f8cae11]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-1f8cae11]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-1f8cae11]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-1f8cae11]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-1f8cae11]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-1f8cae11]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-1f8cae11]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-1f8cae11]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-1f8cae11]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-1f8cae11]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-1f8cae11]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-1f8cae11]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-1f8cae11]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-1f8cae11]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-1f8cae11]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-1f8cae11]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-1f8cae11]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-1f8cae11]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-1f8cae11]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-1f8cae11]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-1f8cae11]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-1f8cae11]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-1f8cae11]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-1f8cae11]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-1f8cae11]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-1f8cae11]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-1f8cae11]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-1f8cae11]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-1f8cae11]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-1f8cae11]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-1f8cae11]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-1f8cae11]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-1f8cae11]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-1f8cae11]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-1f8cae11]{--color-dark:#63757e;--color-light:#c8d2d7}.vc-gallery-item[data-v-1f8cae11]{max-width:252px}.vc-gallery-item__thumbnail[data-v-1f8cae11]{position:relative;height:0;padding-bottom:133%;border-radius:var(--border-radius);box-shadow:var(--shadow-4);overflow:hidden;background-color:var(--modal-bg-color);transition:background-color .1s ease-out}.vc-gallery-item--disabled .vc-gallery-item__thumbnail[data-v-1f8cae11]{filter:grayscale(100%)}.vc-gallery-item--selected .vc-gallery-item__thumbnail[data-v-1f8cae11]{outline:2px solid var(--v-secondary-base)}.vc-gallery-item--selected.vc-gallery-item--disabled .vc-gallery-item__thumbnail[data-v-1f8cae11]{outline:2px solid var(--gray-darken-1)}.vc-gallery-item--is-create .vc-gallery-item__thumbnail[data-v-1f8cae11]:hover{background-color:var(--v-secondary-lighten3)}.vc-gallery-item--is-create .vc-gallery-item__thumbnail[data-v-1f8cae11]{background-color:transparent;border:1px dashed var(--v-secondary-base);box-shadow:none}.vc-gallery-item--is-mobile .vc-gallery-item__thumbnail .vc-gallery-item__thumbnail[data-v-1f8cae11]{filter:none}.vc-gallery-item__top[data-v-1f8cae11]{height:0;padding-bottom:80%;position:relative}.vc-gallery-item__bottom[data-v-1f8cae11]{height:0;padding-bottom:54%;background-size:cover;background-repeat:no-repeat;background-position:top center}.vc-gallery-item__bottom--full-height[data-v-1f8cae11]{padding-bottom:inherit}.vc-gallery-item__bottom--fallback[data-v-1f8cae11]{display:flex;justify-content:center;position:relative;background-color:var(--neutral-lighten-3)}.vc-gallery-item__bottom--fallback[data-v-1f8cae11]  .v-icon{top:50%;position:absolute;transform:translateY(-50%)}@media screen and (min-width:960px){.vc-gallery-item__thumbnail:hover .vc-gallery-item__bottom[data-v-1f8cae11]{filter:blur(5px);transition:filter .3s ease-out}}.vc-gallery-item__image[data-v-1f8cae11]{width:100%}.vc-gallery-item .cta-button[data-v-1f8cae11]{font-size:7px;color:#fff;padding:var(--size-value1) var(--size-value8);border-radius:var(--border-radius);font-weight:var(--font-weight-large);margin-top:0}.vc-gallery-item .VcButton.secondary__text[data-v-1f8cae11]{background-color:var(--v-secondary-lighten2);color:var(--v-secondary-base)!important}.vc-gallery-item .align-buttons[data-v-1f8cae11]{min-width:50%;text-align:center}.vc-gallery-item__top-wrap[data-v-1f8cae11]{height:100%;width:100%;position:absolute;overflow:hidden;padding:0 var(--size-value5)}.vc-gallery-item__label-wrap[data-v-1f8cae11]{flex:0 1 140px;padding-top:var(--size-value4)}.vc-gallery-item__label[data-v-1f8cae11]{font-weight:var(--font-weight-large2);font-size:var(--font-size-x-small);line-height:1.5;text-align:center;color:var(--gray-darken-5);overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;line-clamp:3}.vc-gallery-item--is-create .vc-gallery-item__label[data-v-1f8cae11]{color:var(--v-secondary-base)}.vc-gallery-item--mobile .vc-gallery-item__label[data-v-1f8cae11]{line-height:1.2;-webkit-line-clamp:2;line-clamp:2;font-size:var(--font-size-xx-small)}.vc-gallery-item__skeleton[data-v-1f8cae11]{width:90%;margin:0 auto;background-position:center;flex:1 1 auto}.vc-gallery-item--mobile .vc-gallery-item__skeleton[data-v-1f8cae11]{width:75%;margin:6px auto 0}.vc-gallery-item__skeleton[data-v-1f8cae11]  .v-icon__component{height:100%;width:100%}.vc-gallery-item__skeleton[data-v-1f8cae11]  .v-icon.v-icon{width:100%}.vc-gallery-item__cta[data-v-1f8cae11]{flex:0 1 100px}.vc-gallery-item__bottom_label[data-v-1f8cae11]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-small);line-height:1.5;text-align:center;color:var(--gray-darken-5);margin-top:var(--size-value3)}.vc-gallery-item--is-create .vc-gallery-item__bottom_label[data-v-1f8cae11]{color:var(--v-secondary-base)}.buttons[data-v-1f8cae11]{position:absolute;width:100%;height:100%;left:0;top:0;background-color:rgba(0,0,0,.7);display:none}.vc-gallery-item--is-create .buttons[data-v-1f8cae11]{display:flex;background-color:transparent;cursor:pointer}.vc-gallery-item__thumbnail:hover .buttons[data-v-1f8cae11]{display:flex}.buttons__select[data-v-1f8cae11]{margin-bottom:var(--size-value4)}.selected-indicator[data-v-1f8cae11]{position:absolute;top:0;inset-inline-end:0;background:var(--v-secondary-base);border-radius:0 0 0 var(--border-radius);width:var(--size-value6);height:var(--size-value6)}.vc-gallery-item--disabled .selected-indicator[data-v-1f8cae11]{background:var(--gray-darken-1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$R = "data-v-1f8cae11";
/* module identifier */

const __vue_module_identifier__$R = undefined;
/* functional template */

const __vue_is_functional_template__$R = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$R, __vue_script__$R, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, createInjector, undefined, undefined);

var VcGalleryItem = __vue_component__$1k;

var script$Q = {
  name: 'VcGalleryList',
  components: {
    VcGalleryItem,
    VcButton
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcGalleryList'
    },
    isMobile: {
      type: Boolean,
      required: true
    },
    categoryUid: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true,
      validator: prop => prop.every(item => item.uid && item.campaignUrl)
    },
    title: {
      type: String,
      required: false
    },
    showCreate: {
      type: Boolean,
      default: false
    },
    showLoadMore: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    flavor: {
      type: String,
      default: 'basic',
      validator: prop => ['basic', 'pro'].includes(prop)
    }
  },
  computed: {
    showMoreLabel() {
      return `${this.$dst('ds.gallery_item.show_more')} '${this.title}'`;
    }

  }
};

/* script */
const __vue_script__$Q = script$Q;
/* template */

var __vue_render__$M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vc-gallery-list",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm.title ? _c('h2', {
    staticClass: "vc-gallery-list__title",
    attrs: {
      "data-qa": _vm.dataQa + "-title"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vc-gallery-list__items",
    class: {
      'vc-gallery-list__items--mobile': _vm.isMobile
    }
  }, [_vm.showCreate ? _c('VcGalleryItem', {
    attrs: {
      "flavor": "create",
      "is-mobile": false,
      "uid": "xxx",
      "src": "xxx",
      "campaign-url": "xxx"
    },
    on: {
      "onCreate": function ($event) {
        return _vm.$emit('onCreate');
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.items, function (item, index) {
    return _c('VcGalleryItem', _vm._b({
      key: index,
      attrs: {
        "is-mobile": _vm.isMobile,
        "flavor": _vm.flavor
      },
      on: {
        "onSelect": function (uid) {
          return _vm.$emit('onSelect', uid);
        },
        "onExpend": function (uid) {
          return _vm.$emit('onExpend', uid);
        },
        "onPreview": function (previewItem) {
          return _vm.$emit('onPreview', previewItem);
        }
      }
    }, 'VcGalleryItem', item, false));
  })], 2), _vm._v(" "), _vm.showLoadMore ? _c('div', {
    staticClass: "show-more"
  }, [_c('VcButton', {
    staticClass: "show-more__button",
    attrs: {
      "flavor": "secondary",
      "loading": _vm.loading,
      "outlined": !_vm.loading,
      "data-qa": _vm.dataQa + "-show-more-button",
      "label": _vm.showMoreLabel,
      "ghost": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onShowMore', _vm.categoryUid);
      }
    }
  })], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$M = [];
/* style */

const __vue_inject_styles__$Q = function (inject) {
  if (!inject) return;
  inject("data-v-792520b5_0", {
    source: "[data-v-792520b5]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-792520b5]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-792520b5]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-792520b5]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-792520b5]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-792520b5]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-792520b5]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-792520b5]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-792520b5]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-792520b5]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-792520b5]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-792520b5]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-792520b5]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-792520b5]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-792520b5]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-792520b5]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-792520b5]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-792520b5]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-792520b5]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-792520b5]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-792520b5]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-792520b5]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-792520b5]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-792520b5]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-792520b5]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-792520b5]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-792520b5]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-792520b5]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-792520b5]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-792520b5]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-792520b5]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-792520b5]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-792520b5]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-792520b5]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-792520b5]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-792520b5]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-792520b5]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-792520b5]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-792520b5]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-792520b5]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-792520b5]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-792520b5]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-792520b5]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-792520b5]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-792520b5]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-792520b5]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-792520b5]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-792520b5]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-792520b5]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-792520b5]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-792520b5]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-792520b5]{--color-dark:#63757e;--color-light:#c8d2d7}.vc-gallery-list .vc-gallery-list__title[data-v-792520b5]{font-size:var(--font-size-small2);font-weight:var(--font-weight-large);margin-bottom:var(--size-value4)}@media screen and (min-width:960px){.vc-gallery-list .vc-gallery-list__title[data-v-792520b5]{margin-bottom:var(--size-value6)}}.vc-gallery-list .vc-gallery-list__items[data-v-792520b5]{display:grid;grid-gap:var(--size-value9);margin-bottom:var(--size-value12);grid-template-columns:repeat(auto-fill,minmax(200px,1fr))}.vc-gallery-list .vc-gallery-list__items--mobile[data-v-792520b5]{grid-gap:var(--size-value5);grid-template-columns:repeat(2,1fr)}.vc-gallery-list .show-more[data-v-792520b5]{margin:var(--size-value5) auto var(--size-value10);text-align:center}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$Q = "data-v-792520b5";
/* module identifier */

const __vue_module_identifier__$Q = undefined;
/* functional template */

const __vue_is_functional_template__$Q = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$Q, __vue_script__$Q, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, createInjector, undefined, undefined);

var __vue_component__$1j = __vue_component__$1i;

var script$P = {
  name: 'VcBreadcrumbs',
  components: {
    VcLink,
    VcIcon,
    VBreadcrumbs: VBreadcrumbs
  },
  props: {
    /**
     * The options for each item:
     *     disabled: boolean,
     *     exact: boolean,
     *     href: string,
     *     link: boolean,
     *     text: string | number,
     *     to: string | object
     */
    items: {
      type: Array,
      required: true,
      validator: items => items.every(item => item.text)
    },
    dataQa: {
      type: String,
      default: 'VcBreadcrumbs'
    }
  }
};

/* script */
const __vue_script__$P = script$P;
/* template */

var __vue_render__$L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-breadcrumbs', {
    staticClass: "VcBreadcrumbs",
    attrs: {
      "items": _vm.items,
      "data-qa": _vm.dataQa
    },
    scopedSlots: _vm._u([{
      key: "divider",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "size": "8"
          }
        }, [_vm._v(" $chevron_right ")])];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        return [_c('VcLink', {
          staticClass: "pt-0",
          attrs: {
            "secondary": "",
            "label": item.text,
            "url": item.href,
            "disabled": item.disabled,
            "data-qa": _vm.dataQa + "-" + item.text
          }
        })];
      }
    }])
  });
};

var __vue_staticRenderFns__$L = [];
/* style */

const __vue_inject_styles__$P = function (inject) {
  if (!inject) return;
  inject("data-v-1fc1a4a4_0", {
    source: ".VcBreadcrumbs[data-v-1fc1a4a4]{padding:0}.VcBreadcrumbs[data-v-1fc1a4a4]  a{font-size:var(--font-size-xx-small);color:var(--gray-darken-3)}.VcBreadcrumbs[data-v-1fc1a4a4]  a:last-child label{color:var(--gray-darken-5)}.VcBreadcrumbs[data-v-1fc1a4a4]  li.v-breadcrumbs__divider{font-size:var(--font-size-xx-small)}.VcBreadcrumbs[data-v-1fc1a4a4]  li.v-breadcrumbs__divider span.v-icon{font-size:var(--font-size-xx-small);line-height:var(--size-value2)}.VcBreadcrumbs[data-v-1fc1a4a4]  .v-icon svg,.VcBreadcrumbs[data-v-1fc1a4a4]  .v-icon__component{height:var(--size-value2);width:var(--size-value2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$P = "data-v-1fc1a4a4";
/* module identifier */

const __vue_module_identifier__$P = undefined;
/* functional template */

const __vue_is_functional_template__$P = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$P, __vue_script__$P, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, createInjector, undefined, undefined);

var VcBreadcrumbs = __vue_component__$1h;

var script$O = {
  name: 'VcPageHeader',
  components: {
    VcButton,
    VcIcon,
    VcLayout,
    VcBreadcrumbs,
    VcLink
  },
  props: {
    breadcrumbs: {
      type: Array,
      validator: items => items.every(item => item.text && item.href)
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    showBackButton: {
      type: Boolean,
      default: true
    },

    /**
     * This is used to control the display of the right side buttons.
     * All items are optional and have default values.
     * Note: if nothing is passed, the button will not appear.
     * If you want to display the save button, and still use all the default values, pass an empty object in the save field..
     * the structure is:
     * {
     *   save: {
     *     label (optional), default value is 'save'
     *     icon (optional), default value is 'check_button'
     *     flavor (optional), default value is 'primary',
     *     disabled (optional), default value is false,
     *   }
     * }
     */
    buttonData: {
      type: Object
    },
    chipLabel: {
      type: String,
      default: ''
    },
    chipFlavor: {
      type: String,
      default: 'beta',
      validator: type => ['beta'].includes(type)
    },
    buttonLabel: {
      type: String,
      default: ''
    },
    buttonPrependIcon: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcPageHeader'
    },
    subtitleAction: {
      type: String,
      required: false
    }
  },
  computed: {
    saveButtonLabel() {
      var _this$buttonData$save;

      return ((_this$buttonData$save = this.buttonData.save) === null || _this$buttonData$save === void 0 ? void 0 : _this$buttonData$save.label) || this.$dst('ds.page.saveButton.label');
    },

    saveButtonIcon() {
      var _this$buttonData$save2;

      return ((_this$buttonData$save2 = this.buttonData.save) === null || _this$buttonData$save2 === void 0 ? void 0 : _this$buttonData$save2.icon) || 'check_button';
    }

  },
  methods: {
    updateTitle(e) {
      if (this.editing) {
        this.$emit('onSaveEditedTitle', e.target.value);
      }
    },

    startEdit() {
      if (this.editable) {
        this.$emit('onToggleEditing', true);
        this.$nextTick(() => this.$refs.textField && this.$refs.textField.focus());
      }
    }

  }
};

/* script */
const __vue_script__$O = script$O;
/* template */

var __vue_render__$K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcPageHeader",
    attrs: {
      "align-center": ""
    }
  }, [_c('VcLayout', {
    attrs: {
      "column": "",
      "data-qa": _vm.dataQa
    }
  }, [_vm.breadcrumbs && _vm.breadcrumbs.length > 0 ? _c('VcBreadcrumbs', {
    attrs: {
      "items": _vm.breadcrumbs
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "VcHeader--title"
  }, [_vm.showBackButton ? _c('VcButton', {
    attrs: {
      "icon": "",
      "small": "",
      "data-qa": _vm.dataQa + "-backButton"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onBackClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "color": "black",
            "size": "var(--font-size-small)"
          }
        }, [_vm._v(" $chevron_left ")])];
      },
      proxy: true
    }], null, false, 2072917807)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-inline-block",
    class: {
      'editable-area': _vm.editable,
      editing: _vm.editing
    },
    attrs: {
      "data-qa": _vm.dataQa + "-title-wrap"
    },
    on: {
      "click": _vm.startEdit
    }
  }, [_vm._t("title-prepend"), _vm._v(" "), !_vm.editing ? _c('span', {
    attrs: {
      "data-qa": _vm.dataQa + "-title"
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _c('input', {
    ref: "textField",
    staticClass: "text-field d-inline-block",
    attrs: {
      "type": "text",
      "data-qa": _vm.dataQa + "-text-field"
    },
    domProps: {
      "value": _vm.title
    },
    on: {
      "blur": _vm.updateTitle,
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.updateTitle.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        return _vm.$emit('onToggleEditing', false);
      }]
    }
  }), _vm._v(" "), _vm.editable && !_vm.editing ? _c('VcIcon', {
    staticClass: "edit-icon",
    attrs: {
      "size": "var(--font-size-small2)",
      "data-qa": _vm.dataQa + "-edit-icon"
    }
  }, [_vm._v("\n          $pencil\n        ")]) : _vm._e()], 2), _vm._v(" "), _vm.chipLabel ? _c('span', {
    staticClass: "title-chip",
    class: "title-chip--" + _vm.chipFlavor,
    attrs: {
      "data-qa": _vm.dataQa + "-titleChip"
    }
  }, [_vm._v(_vm._s(_vm.chipLabel))]) : _vm._e(), _vm._v(" "), _vm.buttonLabel || _vm.buttonPrependIcon ? _c('VcButton', {
    staticClass: "title-button",
    attrs: {
      "flavor": "secondary",
      "ghost": "",
      "data-qa": _vm.dataQa + "-titleButton"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onTitleButtonClick');
      }
    },
    scopedSlots: _vm._u([_vm.buttonPrependIcon ? {
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          staticClass: "me-2",
          attrs: {
            "color": "black",
            "size": "var(--font-size-small)"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.buttonPrependIcon) + "\n          ")])];
      },
      proxy: true
    } : null], null, true)
  }, [_vm._v("\n        " + _vm._s(_vm.buttonLabel) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm.subtitle ? _c('span', {
    staticClass: "VcHeader--subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  }) : _vm._e(), _vm._v(" "), _vm.subtitleAction ? _c('VcLink', {
    attrs: {
      "label": _vm.subtitleAction
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('subtitle-action-click');
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm.buttonData || _vm.$slots.buttons ? _c('VcLayout', {
    attrs: {
      "justify-end": ""
    }
  }, [_vm._t("buttons", function () {
    return [_vm.buttonData.save ? _c('VcButton', {
      attrs: {
        "icon-size": 12,
        "flavor": _vm.buttonData.save.flavor || 'primary',
        "disabled": _vm.buttonData.save && _vm.buttonData.save.disabled,
        "prepend-default-icon": "",
        "prepend-icon": _vm.saveButtonIcon,
        "data-qa": _vm.dataQa + "-saveButton"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('onSaveClicked');
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.saveButtonLabel) + "\n      ")]) : _vm._e()];
  })], 2) : _vm._e()], 1);
};

var __vue_staticRenderFns__$K = [];
/* style */

const __vue_inject_styles__$O = function (inject) {
  if (!inject) return;
  inject("data-v-1da1a01a_0", {
    source: ".VcPageHeader[data-v-1da1a01a]{margin-bottom:var(--size-value10)}.VcHeader--title[data-v-1da1a01a]{font-size:var(--font-size-medium0);font-weight:var(--font-weight-large2);line-height:var(--size-value8);color:var(--gray-darken-5);margin-top:var(--size-value1)}.VcHeader--title .title-chip[data-v-1da1a01a]{padding:var(--size-value1) var(--size-value2);margin-inline-start:var(--size-value3);border-radius:var(--size-value6);font-weight:var(--font-weight-large2);font-size:var(--font-size-xx-small);height:var(--size-value5)}.VcHeader--title .title-chip--beta[data-v-1da1a01a]{background-color:var(--orange);color:#fff}.VcHeader--title .title-button[data-v-1da1a01a]{margin-inline-start:var(--size-value3)}.VcHeader--subtitle[data-v-1da1a01a]{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium);line-height:var(--size-value5)}.VcHeader--subtitle[data-v-1da1a01a]  a{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2);padding-top:var(--size-value1);text-decoration:none;color:var(--blue)}.VcLink[data-v-1da1a01a]{display:inline-block}.editable-area[data-v-1da1a01a]:not(.editing):hover{background:var(--gray-lighten-2)}.editing[data-v-1da1a01a]{outline:1px solid var(--v-secondary-base);border-radius:2px}.text-field[data-v-1da1a01a]{outline:0;font-size:inherit;font-weight:inherit;color:inherit}.edit-icon[data-v-1da1a01a]{margin-inline-start:var(--size-value3);cursor:pointer;opacity:.52}.edit-icon[data-v-1da1a01a]:hover{opacity:1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$O = "data-v-1da1a01a";
/* module identifier */

const __vue_module_identifier__$O = undefined;
/* functional template */

const __vue_is_functional_template__$O = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$O, __vue_script__$O, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, createInjector, undefined, undefined);

var __vue_component__$1g = __vue_component__$1f;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
const regexHex = /^#[0-9A-F]{6}$/i;
const regexHexa = /^#[0-9A-F]{8}$/i;
const swatchesConst = [['#EF4444', '#F97316'], ['#FACC15', '#4ADE80'], ['#2DD4BF', '#3B82F6'], ['#6467F2', '#EC4899'], ['#F43F5E', '#D946EF'], ['#8B5CF6', '#0EA5E9'], ['#10B981', '#84CC16']];
var script$N = {
  name: 'VcColorPicker',
  components: {
    VcTextField,
    VcSelectField,
    VColorPicker: VColorPicker,
    VBottomSheet: VBottomSheet
  },
  model: {
    prop: 'color',
    event: 'change'
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcColorPicker'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '',
      validator: prop => !prop || regexHex.test(prop) || regexHexa.test(prop)
    },

    /**
     * Similar to Vuetify rules prop - array of functions that return true or the message error as a string
     * See an example in the storybook
     */
    rules: {
      type: Array,
      validator: prop => prop.every(rule => typeof rule === 'function')
    },
    hexMode: {
      type: Boolean,
      default: false
    },
    openUp: {
      type: Boolean,
      default: false
    }
  },

  data(vm) {
    var _vm$color;

    return {
      showPicker: false,
      inputColor: this.getHexMode((_vm$color = vm.color) === null || _vm$color === void 0 ? void 0 : _vm$color.toUpperCase()),
      swatches: swatchesConst
    };
  },

  computed: {
    getPickerWidth() {
      var _this$$refs, _this$$refs$pickerInp;

      if (this.isMobile) return window.innerWidth;else return (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$pickerInp = _this$$refs.pickerInput) === null || _this$$refs$pickerInp === void 0 ? void 0 : _this$$refs$pickerInp.offsetWidth;
    },

    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },

    getError() {
      if (!this.rules) return false;
      let errorMessages = this.rules.map(rule => {
        const resolve = rule.call(this, this.inputColor);
        if (typeof resolve === 'string') return resolve;
      }).filter(item => !!item);
      return errorMessages[0];
    }

  },
  watch: {
    color(value) {
      this.inputColor = this.getHexMode(value);
      this.$emit('change', this.inputColor);
    }

  },
  methods: {
    isValidHexColor(val) {
      return regexHex.test(val) || regexHexa.test(val);
    },

    closePicker() {
      if (this.isMobile) return; // Don't close the picker after it's clicked

      this.showPicker = false;
    },

    onPickerUpdate(color) {
      this.inputColor = color.hexa.toUpperCase();
      this.$emit('change', this.inputColor);
    },

    validateInput() {
      this.inputColor = (this.isValidHexColor(this.inputColor) ? this.inputColor : this.color).toUpperCase();
    },

    onInputUpdate(color) {
      if (this.isValidHexColor(color)) this.$emit('change', color.toUpperCase());
    },

    getHexMode(color) {
      if (this.hexMode && color !== null && color !== void 0 && color.toString().match(/#[a-zA-Z0-9]{8}/)) {
        return color.substr(0, 7).toUpperCase();
      }

      return color;
    }

  }
};

/* script */
const __vue_script__$N = script$N;
/* template */

var __vue_render__$J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "ds-click-outside",
      rawName: "v-ds-click-outside",
      value: _vm.closePicker,
      expression: "closePicker"
    }],
    ref: "pickerInput",
    staticClass: "VcColorPicker d-flex flex-column",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('div', {
    staticClass: "VcColorPicker__input d-flex align-center"
  }, [_c('VcSelectField', {
    staticClass: "VcColorPicker__input__dropdown",
    class: {
      'error--text': _vm.getError
    },
    attrs: {
      "data-qa": _vm.dataQa + "_select",
      "disabled": _vm.disabled,
      "readonly": !_vm.disabled
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.showPicker = true;
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('div', {
          staticClass: "color-preview",
          style: {
            backgroundColor: _vm.color
          }
        })];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('VcTextField', {
    class: {
      'error--text': _vm.getError
    },
    attrs: {
      "data-qa": _vm.dataQa + "_input",
      "label": _vm.$dst('ds.color_picker.label'),
      "disabled": _vm.disabled
    },
    on: {
      "blur": _vm.validateInput,
      "input": _vm.onInputUpdate
    },
    model: {
      value: _vm.inputColor,
      callback: function ($$v) {
        _vm.inputColor = $$v;
      },
      expression: "inputColor"
    }
  })], 1), _vm._v(" "), !_vm.showPicker ? _c('div', {
    staticClass: "VcColorPicker__messages mt-1",
    class: {
      'error-message': _vm.getError
    }
  }, [_vm.hint && !_vm.getError ? _c('span', {
    attrs: {
      "data-qa": _vm.dataQa + "-hint"
    }
  }, [_vm._v(_vm._s(_vm.hint))]) : _vm._e(), _vm._v(" "), _vm.getError ? _c('span', {
    attrs: {
      "data-qa": _vm.dataQa + "-error"
    }
  }, [_vm._v(_vm._s(_vm.getError))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.showPicker && !_vm.isMobile ? _c('div', {
    staticClass: "VcColorPicker__picker mt-2 pa-2",
    class: {
      'order-first mb-2': _vm.openUp
    }
  }, [_c('v-color-picker', {
    attrs: {
      "hide-mode-switch": _vm.hexMode,
      "mode": "hexa",
      "value": _vm.color,
      "show-swatches": "",
      "flat": "",
      "width": _vm.getPickerWidth,
      "data-qa": _vm.dataQa + "_picker",
      "swatches": _vm.swatches
    },
    on: {
      "update:color": _vm.onPickerUpdate
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.isMobile ? _c('v-bottom-sheet', {
    model: {
      value: _vm.showPicker,
      callback: function ($$v) {
        _vm.showPicker = $$v;
      },
      expression: "showPicker"
    }
  }, [_vm.showPicker ? _c('v-color-picker', {
    staticClass: "VcColorPicker__picker",
    attrs: {
      "data-qa": _vm.dataQa + "_picker",
      "hide-mode-switch": _vm.hexMode,
      "mode": "hexa",
      "value": _vm.color,
      "show-swatches": "",
      "flat": "",
      "width": _vm.getPickerWidth,
      "swatches": _vm.swatches
    },
    on: {
      "update:color": _vm.onPickerUpdate
    }
  }) : _vm._e()], 1) : _vm._e()], 1);
};

var __vue_staticRenderFns__$J = [];
/* style */

const __vue_inject_styles__$N = function (inject) {
  if (!inject) return;
  inject("data-v-0b62df40_0", {
    source: ".v-dialog:has(.v-color-picker__color) .v-color-picker__color:has(span.v-icon){border:2px solid #fff;box-shadow:0 0 0 2px rgba(0,0,0,.25)}.v-dialog:has(.v-color-picker__color) .v-color-picker__color:has(span.v-icon) span.v-icon{display:none}",
    map: undefined,
    media: undefined
  }), inject("data-v-0b62df40_1", {
    source: ".VcColorPicker[data-v-0b62df40]{direction:ltr!important}.VcColorPicker__input__dropdown[data-v-0b62df40]{width:var(--size-value18);max-width:var(--size-value18)}.VcColorPicker__input__dropdown[data-v-0b62df40]  .v-input__append-inner{padding-top:var(--size-value1)}.VcColorPicker__input__dropdown .color-preview[data-v-0b62df40]{width:var(--size-value6);height:var(--size-value6);border-radius:var(--border-radius-circle)}.VcColorPicker__picker[data-v-0b62df40]{box-shadow:var(--shadow-6);background-color:var(--modal-bg-color);border-radius:var(--border-radius)}.VcColorPicker__messages[data-v-0b62df40]{font-weight:var(--font-weight-medium);font-size:var(--font-size-xx-small);line-height:var(--size-value4);color:var(--gray-darken-3)}.VcColorPicker__messages.error-message[data-v-0b62df40]{color:var(--red)}.VcColorPicker[data-v-0b62df40]  .VcSelectField{border-radius:var(--border-radius) 0 0 var(--border-radius)}.VcColorPicker[data-v-0b62df40]  .VcSelectField fieldset{margin-top:1px}.VcColorPicker[data-v-0b62df40]  .VcTextInput.v-text-field .v-input__slot{border-radius:0 var(--border-radius) var(--border-radius) 0}.VcColorPicker[data-v-0b62df40]  .v-color-picker__canvas{border-radius:var(--border-radius)}.VcColorPicker[data-v-0b62df40]  .v-dialog__content{background-color:red}.VcColorPicker[data-v-0b62df40]  .v-color-picker__color:has(span.v-icon){border:2px solid #fff;box-shadow:0 0 0 2px rgba(0,0,0,.25)}.VcColorPicker[data-v-0b62df40]  .v-color-picker__color:has(span.v-icon) span.v-icon{display:none}.VcColorPicker[data-v-0b62df40]  .v-color-picker__input{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2)}.VcColorPicker[data-v-0b62df40]  .v-color-picker__swatches>div{padding:unset;justify-content:space-between}.VcColorPicker[data-v-0b62df40]  .v-color-picker__controls{padding:var(--size-value4) var(--size-value2) var(--size-value6)}.VcColorPicker[data-v-0b62df40]  .v-color-picker__edit{padding-bottom:var(--size-value4);border-bottom:var(--border-frame)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$N = "data-v-0b62df40";
/* module identifier */

const __vue_module_identifier__$N = undefined;
/* functional template */

const __vue_is_functional_template__$N = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$N, __vue_script__$N, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, createInjector, undefined, undefined);

var __vue_component__$1e = __vue_component__$1d;

const flavors = {
  default: 'default',
  recommendation: 'recommendation'
};
var script$M = {
  name: 'VcAccordion',
  components: {
    VcLayout,
    VcIcon,
    VcButton,
    VExpansionPanelHeader: VExpansionPanelHeader,
    VExpansionPanelContent: VExpansionPanelContent,
    VExpansionPanel: VExpansionPanel,
    VExpansionPanels: VExpansionPanels
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: items => items.every(item => item.name)
    },
    dataQa: {
      type: String,
      default: 'VcAccordion'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    focusArea: {
      type: Boolean,
      default: false
    },
    gap: {
      type: String,
      validator: size => ['none', 's', 'm', 'l'].includes(size),
      default: 'none'
    },

    /**
     * if multiple true pass here array of the panels index to open.
     * if multiple false pass here the panels index to open
     * */
    openPanels: {
      type: [Array, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    headerSize: {
      type: String,
      default: 'md',
      validator: size => ['sm', 'md'].includes(size)
    },

    /**
     * If true, the size margins will be removed
     */
    slim: {
      type: Boolean,
      default: false
    },
    flavor: {
      type: String,
      default: flavors.default,
      validator: flavor => Object.values(flavors).includes(flavor)
    }
  },
  computed: {
    iconColor() {
      return this.disabled ? 'var(--gray-darken-1)' : 'var(--gray-darken-5)';
    },

    focusAreaClass() {
      if (!this.focusArea) return '';

      switch (this.flavor) {
        case flavors.recommendation:
          return 'VcAccordion__panel--flat_recommendation';

        default:
          return 'VcAccordion__panel--flat';
      }
    },

    appendIcon() {
      switch (this.flavor) {
        case flavors.recommendation:
          return '$ai_sparkles';

        default:
          return '$plus';
      }
    },

    appendIconColor() {
      switch (this.flavor) {
        case flavors.recommendation:
          return 'var(--ai-main)';

        default:
          return 'var(--gray-darken-2)';
      }
    }

  }
};

/* script */
const __vue_script__$M = script$M;
/* template */

var __vue_render__$I = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-expansion-panels', {
    staticClass: "VcAccordion",
    class: (_obj = {}, _obj["VcAccordion--gap-" + _vm.gap] = _vm.gap !== 'none', _obj["VcAccordion--size-" + _vm.headerSize] = true, _obj['VcAccordion--slim'] = _vm.slim, _obj),
    attrs: {
      "accordion": "",
      "value": _vm.openPanels,
      "flat": "",
      "data-qa": _vm.dataQa,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple
    },
    on: {
      "change": function (data) {
        return _vm.$emit('change', data);
      }
    }
  }, _vm._l(_vm.items, function (item, i) {
    return _c('v-expansion-panel', {
      key: i,
      staticClass: "VcAccordion__panel",
      class: _vm.focusAreaClass,
      attrs: {
        "readonly": item.readonly,
        "data-readonly": item.readonly,
        "data-qa": _vm.dataQa + "_panel_" + i
      }
    }, [_c('v-expansion-panel-header', {
      staticClass: "VcAccordion__panel__header pa-3",
      class: {
        disabled: _vm.disabled
      },
      attrs: {
        "data-qa": _vm.dataQa + "_header_" + i,
        "hide-actions": "",
        "disable-icon-rotate": ""
      }
    }, [_vm._t("header-" + i, function () {
      return [_c('VcLayout', {
        attrs: {
          "align-center": ""
        }
      }, [_c('div', {
        staticClass: "flex-grow-1"
      }, [_c('VcLayout', {
        attrs: {
          "align-center": ""
        }
      }, [!item.hideExpandIcon ? _c('VcIcon', {
        staticClass: "expend-icon flex-grow-0 ms-1 me-2",
        attrs: {
          "size": "8",
          "color": _vm.iconColor
        }
      }, [_vm._v("\n                $caret_down\n              ")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "VcAccordion__panel__title"
      }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), item.subtitle ? _c('div', {
        staticClass: "mt-2 font-weight-medium expand-subtitle",
        class: {
          'ml-5': !item.hideExpandIcon
        }
      }, [_vm._v("\n              " + _vm._s(item.subtitle) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _vm._t("header-" + i + "-append", function () {
        return [item.button ? _c('VcButton', {
          staticClass: "me-1",
          attrs: {
            "icon": "",
            "x-small": ""
          },
          scopedSlots: _vm._u([{
            key: "prepend",
            fn: function () {
              return [_c('VcIcon', {
                attrs: {
                  "data-qa": _vm.dataQa + "_expendIcon_" + i,
                  "size": "12",
                  "color": _vm.appendIconColor,
                  "data-icon": _vm.appendIcon
                }
              }, [_vm._v("\n                  " + _vm._s(_vm.appendIcon) + "\n                ")])];
            },
            proxy: true
          }], null, true)
        }) : _vm._e()];
      })], 2)];
    })], 2), _vm._v(" "), _c('v-expansion-panel-content', {
      staticClass: "VcAccordion__panel__content"
    }, [_vm._t("content-" + i, null, {
      "item": item
    })], 2)], 1);
  }), 1);
};

var __vue_staticRenderFns__$I = [];
/* style */

const __vue_inject_styles__$M = function (inject) {
  if (!inject) return;
  inject("data-v-d9a0ac34_0", {
    source: ".VcAccordion--gap-s[data-v-d9a0ac34]{gap:var(--size-value1)}.VcAccordion--gap-m[data-v-d9a0ac34]{gap:var(--size-value2)}.VcAccordion--gap-l[data-v-d9a0ac34]{gap:var(--size-value4)}.VcAccordion--size-sm .VcAccordion__panel__title[data-v-d9a0ac34]{font-size:var(--font-size-x-small)}.VcAccordion--slim .VcAccordion__panel__header[data-v-d9a0ac34]{padding:var(--size-value2) 0!important}.VcAccordion__panel.v-expansion-panel[data-v-d9a0ac34]{background-color:transparent}.VcAccordion__panel__header[data-v-d9a0ac34]{font-weight:var(--font-weight-large);padding:var(--size-value2) var(--size-value4)!important;min-height:unset}.VcAccordion__panel__header .v-icon.expend-icon[data-v-d9a0ac34]{transform:rotate(-90deg)}#app[dir=rtl] .VcAccordion__panel__header .v-icon.expend-icon[data-v-d9a0ac34]{transform:rotate(90deg)}.VcAccordion__panel__header .v-icon[data-v-d9a0ac34]:not(.expend-icon){transition:unset}.VcAccordion__panel__header .expand-subtitle[data-v-d9a0ac34]{font-size:var(--font-size-x-small);line-height:initial}.VcAccordion__panel__header.v-expansion-panel-header--active .v-icon[data-v-d9a0ac34]{transform:unset}#app[dir=rtl] .VcAccordion__panel__header.v-expansion-panel-header--active .v-icon[data-v-d9a0ac34]{transform:rotate(0)}.VcAccordion__panel__header[data-v-d9a0ac34]:not(.disabled){color:var(--gray-darken-5)}.VcAccordion__panel__header.disabled[data-v-d9a0ac34]{color:var(--gray-darken-2)}.VcAccordion__panel__header[data-v-d9a0ac34]:hover{transition:color .3s}.VcAccordion__panel__header[data-v-d9a0ac34]:focus{z-index:2;background-color:unset;transition:box-shadow .3s;box-shadow:var(--shadow-focused-frame);border-radius:var(--border-radius)}.VcAccordion__panel__header[data-v-d9a0ac34]:focus:before{opacity:0}.VcAccordion__panel__content[data-v-d9a0ac34]  .v-expansion-panel-content__wrap{padding:var(--size-value0) var(--size-value4) var(--size-value2)}.VcAccordion__panel--flat[data-v-d9a0ac34]{background-color:var(--gray-lighten-3)!important}.VcAccordion__panel--flat_recommendation[data-v-d9a0ac34]{background-image:var(--ai-background)!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$M = "data-v-d9a0ac34";
/* module identifier */

const __vue_module_identifier__$M = undefined;
/* functional template */

const __vue_is_functional_template__$M = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$M, __vue_script__$M, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, createInjector, undefined, undefined);

var __vue_component__$1c = __vue_component__$1b;

var script$L = {
  name: 'ActionBar',
  components: {
    VcDropdown,
    VcLayout,
    VcButton,
    VcIcon,
    VcCheckbox,
    VcBaseListItem
  },
  props: {
    showSelectAll: {
      type: Boolean,
      default: false
    },
    isSelectAll: {
      type: Boolean,
      default: false
    },
    isIndeterminate: {
      type: Boolean,
      default: false
    },
    entityActions: {
      type: Array,
      default: () => [],
      validator: prop => prop.every(e => e.icon && e.title && e.event)
    },
    summaryText: {
      type: String,
      default: ''
    },
    selectedText: {
      type: String,
      default: ''
    },
    pageActions: {
      type: Array,
      default: () => [],
      validator: prop => prop.every(e => e.icon && e.event)
    },
    entityActionsDisabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcActionBar'
    }
  }
};

/* script */
const __vue_script__$L = script$L;
/* template */

var __vue_render__$H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "action-bar action-bar-desktop",
    attrs: {
      "align-center": "",
      "data-qa": _vm.dataQa
    }
  }, [_vm.showSelectAll ? _c('VcCheckbox', {
    staticClass: "select-all-checkbox shrink mr-0 mt-0",
    class: {
      separator: _vm.entityActions.length > 0
    },
    attrs: {
      "value": _vm.isSelectAll,
      "indeterminate": _vm.isIndeterminate,
      "data-qa": _vm.dataQa + "-select-all-checkbox"
    },
    on: {
      "change": function (newVal) {
        return _vm.$emit('selectAllClicked', newVal);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.entityActions, function (action) {
    return [!action.actions || action.actions.length === 0 ? _c('VcButton', {
      staticClass: "action-button",
      attrs: {
        "small": "",
        "ghost": "",
        "flavor": "secondary",
        "disabled": _vm.entityActionsDisabled,
        "data-qa": _vm.dataQa + "-" + action.event + "-action"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit(action.event, action);
        }
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_c('VcIcon', {
            staticClass: "action-icon me-2",
            attrs: {
              "size": "16"
            }
          }, [_vm._v("\n          " + _vm._s(action.icon) + "\n        ")])];
        },
        proxy: true
      }], null, true)
    }, [_vm._v("\n      " + _vm._s(action.title) + "\n    ")]) : _c('VcDropdown', {
      attrs: {
        "items": action.actions,
        "disabled": _vm.entityActionsDisabled,
        "data-qa": _vm.dataQa + "-" + action.event + "-actions"
      },
      on: {
        "item-clicked": function (data) {
          return _vm.$emit(data.event, data);
        }
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (ref) {
          var on = ref.on;
          var attrs = ref.attrs;
          return [_c('VcButton', _vm._g(_vm._b({
            staticClass: "action-button",
            attrs: {
              "small": "",
              "ghost": "",
              "flavor": "secondary",
              "prepend-icon": action.icon,
              "disabled": _vm.entityActionsDisabled,
              "data-qa": _vm.dataQa + "-" + action.event + "-action"
            },
            scopedSlots: _vm._u([{
              key: "prepend",
              fn: function () {
                return [_c('VcIcon', {
                  staticClass: "action-icon me-2",
                  attrs: {
                    "icon": "",
                    "size": "14"
                  }
                }, [_vm._v("\n              " + _vm._s(action.icon) + "\n            ")])];
              },
              proxy: true
            }], null, true)
          }, 'VcButton', attrs, false), on), [_vm._v("\n          " + _vm._s(action.title) + "\n        ")])];
        }
      }], null, true)
    }, [_vm._v(" "), _c('VcLayout', {
      attrs: {
        "column": ""
      }
    }, _vm._l(action.actions, function (item, index) {
      return _c('VcBaseListItem', {
        key: index,
        on: {
          "click": function ($event) {
            return _vm.$emit(item.event, item);
          }
        }
      }, [_c('div', {
        staticClass: "VcActionVar-list-item"
      }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")])]);
    }), 1)], 1)];
  }), _vm._v(" "), !_vm.showSelectAll && _vm.entityActions.length === 0 ? _c('VcLayout', [_c('span', {
    staticClass: "summary-text"
  }, [_vm._v(_vm._s(_vm.summaryText))])]) : _vm._e(), _vm._v(" "), _c('VcLayout', {
    staticClass: "right-area align-center"
  }, [_vm.showSelectAll || _vm.entityActions.length > 0 ? _c('span', {
    staticClass: "summary-text"
  }, [_vm._v(_vm._s(_vm.summaryText))]) : _vm._e(), _vm._v(" "), _vm.selectedText.length > 0 ? _c('span', {
    staticClass: "selected-text",
    class: {
      'with-page-action': _vm.pageActions.length > 0
    }
  }, [_vm._v("\n      " + _vm._s(_vm.selectedText) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.pageActions, function (action) {
    return [!action.actions || action.actions.length === 0 ? _c('VcButton', {
      staticClass: "action-button page-action pe-2",
      attrs: {
        "ghost": "",
        "flavor": "secondary",
        "data-qa": _vm.dataQa + "-" + action.event + "-action"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit(action.event, action);
        }
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_c('VcIcon', {
            staticClass: "action-icon",
            attrs: {
              "size": "14"
            }
          }, [_vm._v("\n            " + _vm._s(action.icon) + "\n          ")])];
        },
        proxy: true
      }], null, true)
    }) : _vm._e()];
  })], 2)], 2);
};

var __vue_staticRenderFns__$H = [];
/* style */

const __vue_inject_styles__$L = function (inject) {
  if (!inject) return;
  inject("data-v-69e6d77e_0", {
    source: ".action-bar[data-v-69e6d77e]{width:100%;height:53px;border-bottom:1px solid var(--gray-lighten-3);padding:var(--size-value3) 0;flex-grow:0}.action-bar .right-area[data-v-69e6d77e]{justify-content:flex-end}.action-bar .select-all-checkbox[data-v-69e6d77e]{margin:0;padding-inline-start:var(--size-value4)}.action-bar .select-all-checkbox.separator[data-v-69e6d77e]{border-inline-end:1px solid var(--gray-lighten-3)}.action-bar .action-button[data-v-69e6d77e]{font-size:var(--font-size-x-small);margin:0 var(--size-value1);padding:var(--size-value2) var(--size-value4) var(--size-value2) var(--size-value3)}.action-bar .action-icon[data-v-69e6d77e]{width:var(--size-value4);margin-inline:0,var(--size-value1)}.action-bar .summary-text[data-v-69e6d77e]{padding-right:var(--size-value3);font-size:var(--size-value3);font-weight:var(--font-weight-medium2);line-height:2.5;text-align:right}.action-bar .selected-text[data-v-69e6d77e]{padding-inline:var(--size-value3),0;border-left:1px solid var(--gray-lighten-3);font-size:var(--size-value3);font-weight:var(--font-weight-medium2);line-height:2.5;text-align:right}.action-bar .selected-text.with-page-action[data-v-69e6d77e]{padding-inline:var(--size-value3),var(--size-value3);border-right:1px solid var(--gray-lighten-3)}.action-bar .page-action[data-v-69e6d77e]{min-width:0;max-width:var(--size-value8);margin-left:0;padding:0 0 0 var(--size-value3)}",
    map: undefined,
    media: undefined
  }), inject("data-v-69e6d77e_1", {
    source: ".VcActionVar-list-item{font-size:var(--font-size-x-small)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$L = "data-v-69e6d77e";
/* module identifier */

const __vue_module_identifier__$L = undefined;
/* functional template */

const __vue_is_functional_template__$L = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$19 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$L, __vue_script__$L, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, createInjector, undefined, undefined);

var __vue_component__$1a = __vue_component__$19;

/*!
 * vue-infinite-loading v2.4.5
 * (c) 2016-2020 PeachScript
 * MIT License
 */

var vueInfiniteLoading = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var a=e[i]={i:i,l:!1,exports:{}};return t[i].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i});},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var a in t)n.d(i,a,function(e){return t[e]}.bind(null,a));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=9)}([function(t,e,n){var i=n(6);"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);(0, n(3).default)("6223ff68",i,!0,{});},function(t,e,n){var i=n(8);"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);(0, n(3).default)("27f0e51f",i,!0,{});},function(t,e){t.exports=function(t){var e=[];return e.toString=function(){return this.map((function(e){var n=function(t,e){var n=t[1]||"",i=t[3];if(!i)return n;if(e&&"function"==typeof btoa){var a=(o=i,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */"),r=i.sources.map((function(t){return "/*# sourceURL="+i.sourceRoot+t+" */"}));return [n].concat(r).concat([a]).join("\n")}var o;return [n].join("\n")}(e,t);return e[2]?"@media "+e[2]+"{"+n+"}":n})).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var i={},a=0;a<this.length;a++){var r=this[a][0];"number"==typeof r&&(i[r]=!0);}for(a=0;a<t.length;a++){var o=t[a];"number"==typeof o[0]&&i[o[0]]||(n&&!o[2]?o[2]=n:n&&(o[2]="("+o[2]+") and ("+n+")"),e.push(o));}},e};},function(t,e,n){function i(t,e){for(var n=[],i={},a=0;a<e.length;a++){var r=e[a],o=r[0],s={id:t+":"+a,css:r[1],media:r[2],sourceMap:r[3]};i[o]?i[o].parts.push(s):n.push(i[o]={id:o,parts:[s]});}return n}n.r(e),n.d(e,"default",(function(){return f}));var a="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!a)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var r={},o=a&&(document.head||document.getElementsByTagName("head")[0]),s=null,l=0,d=!1,c=function(){},u=null,p="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function f(t,e,n,a){d=n,u=a||{};var o=i(t,e);return b(o),function(e){for(var n=[],a=0;a<o.length;a++){var s=o[a];(l=r[s.id]).refs--,n.push(l);}e?b(o=i(t,e)):o=[];for(a=0;a<n.length;a++){var l;if(0===(l=n[a]).refs){for(var d=0;d<l.parts.length;d++)l.parts[d]();delete r[l.id];}}}}function b(t){for(var e=0;e<t.length;e++){var n=t[e],i=r[n.id];if(i){i.refs++;for(var a=0;a<i.parts.length;a++)i.parts[a](n.parts[a]);for(;a<n.parts.length;a++)i.parts.push(m(n.parts[a]));i.parts.length>n.parts.length&&(i.parts.length=n.parts.length);}else {var o=[];for(a=0;a<n.parts.length;a++)o.push(m(n.parts[a]));r[n.id]={id:n.id,refs:1,parts:o};}}}function h(){var t=document.createElement("style");return t.type="text/css",o.appendChild(t),t}function m(t){var e,n,i=document.querySelector('style[data-vue-ssr-id~="'+t.id+'"]');if(i){if(d)return c;i.parentNode.removeChild(i);}if(p){var a=l++;i=s||(s=h()),e=w.bind(null,i,a,!1),n=w.bind(null,i,a,!0);}else i=h(),e=y.bind(null,i),n=function(){i.parentNode.removeChild(i);};return e(t),function(i){if(i){if(i.css===t.css&&i.media===t.media&&i.sourceMap===t.sourceMap)return;e(t=i);}else n();}}var g,v=(g=[],function(t,e){return g[t]=e,g.filter(Boolean).join("\n")});function w(t,e,n,i){var a=n?"":i.css;if(t.styleSheet)t.styleSheet.cssText=v(e,a);else {var r=document.createTextNode(a),o=t.childNodes;o[e]&&t.removeChild(o[e]),o.length?t.insertBefore(r,o[e]):t.appendChild(r);}}function y(t,e){var n=e.css,i=e.media,a=e.sourceMap;if(i&&t.setAttribute("media",i),u.ssrId&&t.setAttribute("data-vue-ssr-id",e.id),a&&(n+="\n/*# sourceURL="+a.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),t.styleSheet)t.styleSheet.cssText=n;else {for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n));}}},function(t,e){function n(e){return "function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?t.exports=n=function(t){return typeof t}:t.exports=n=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n(e)}t.exports=n;},function(t,e,n){n.r(e);var i=n(0),a=n.n(i);for(var r in i)"default"!==r&&function(t){n.d(e,t,(function(){return i[t]}));}(r);e.default=a.a;},function(t,e,n){(t.exports=n(2)(!1)).push([t.i,'.loading-wave-dots[data-v-46b20d22]{position:relative}.loading-wave-dots[data-v-46b20d22] .wave-item{position:absolute;top:50%;left:50%;display:inline-block;margin-top:-4px;width:8px;height:8px;border-radius:50%;-webkit-animation:loading-wave-dots-data-v-46b20d22 linear 2.8s infinite;animation:loading-wave-dots-data-v-46b20d22 linear 2.8s infinite}.loading-wave-dots[data-v-46b20d22] .wave-item:first-child{margin-left:-36px}.loading-wave-dots[data-v-46b20d22] .wave-item:nth-child(2){margin-left:-20px;-webkit-animation-delay:.14s;animation-delay:.14s}.loading-wave-dots[data-v-46b20d22] .wave-item:nth-child(3){margin-left:-4px;-webkit-animation-delay:.28s;animation-delay:.28s}.loading-wave-dots[data-v-46b20d22] .wave-item:nth-child(4){margin-left:12px;-webkit-animation-delay:.42s;animation-delay:.42s}.loading-wave-dots[data-v-46b20d22] .wave-item:last-child{margin-left:28px;-webkit-animation-delay:.56s;animation-delay:.56s}@-webkit-keyframes loading-wave-dots-data-v-46b20d22{0%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}10%{-webkit-transform:translateY(-6px);transform:translateY(-6px);background:#999}20%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}to{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}}@keyframes loading-wave-dots-data-v-46b20d22{0%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}10%{-webkit-transform:translateY(-6px);transform:translateY(-6px);background:#999}20%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}to{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}}.loading-circles[data-v-46b20d22] .circle-item{width:5px;height:5px;-webkit-animation:loading-circles-data-v-46b20d22 linear .75s infinite;animation:loading-circles-data-v-46b20d22 linear .75s infinite}.loading-circles[data-v-46b20d22] .circle-item:first-child{margin-top:-14.5px;margin-left:-2.5px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(2){margin-top:-11.26px;margin-left:6.26px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(3){margin-top:-2.5px;margin-left:9.5px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(4){margin-top:6.26px;margin-left:6.26px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(5){margin-top:9.5px;margin-left:-2.5px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(6){margin-top:6.26px;margin-left:-11.26px}.loading-circles[data-v-46b20d22] .circle-item:nth-child(7){margin-top:-2.5px;margin-left:-14.5px}.loading-circles[data-v-46b20d22] .circle-item:last-child{margin-top:-11.26px;margin-left:-11.26px}@-webkit-keyframes loading-circles-data-v-46b20d22{0%{background:#dfdfdf}90%{background:#505050}to{background:#dfdfdf}}@keyframes loading-circles-data-v-46b20d22{0%{background:#dfdfdf}90%{background:#505050}to{background:#dfdfdf}}.loading-bubbles[data-v-46b20d22] .bubble-item{background:#666;-webkit-animation:loading-bubbles-data-v-46b20d22 linear .75s infinite;animation:loading-bubbles-data-v-46b20d22 linear .75s infinite}.loading-bubbles[data-v-46b20d22] .bubble-item:first-child{margin-top:-12.5px;margin-left:-.5px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(2){margin-top:-9.26px;margin-left:8.26px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(3){margin-top:-.5px;margin-left:11.5px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(4){margin-top:8.26px;margin-left:8.26px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(5){margin-top:11.5px;margin-left:-.5px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(6){margin-top:8.26px;margin-left:-9.26px}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(7){margin-top:-.5px;margin-left:-12.5px}.loading-bubbles[data-v-46b20d22] .bubble-item:last-child{margin-top:-9.26px;margin-left:-9.26px}@-webkit-keyframes loading-bubbles-data-v-46b20d22{0%{width:1px;height:1px;box-shadow:0 0 0 3px #666}90%{width:1px;height:1px;box-shadow:0 0 0 0 #666}to{width:1px;height:1px;box-shadow:0 0 0 3px #666}}@keyframes loading-bubbles-data-v-46b20d22{0%{width:1px;height:1px;box-shadow:0 0 0 3px #666}90%{width:1px;height:1px;box-shadow:0 0 0 0 #666}to{width:1px;height:1px;box-shadow:0 0 0 3px #666}}.loading-default[data-v-46b20d22]{position:relative;border:1px solid #999;-webkit-animation:loading-rotating-data-v-46b20d22 ease 1.5s infinite;animation:loading-rotating-data-v-46b20d22 ease 1.5s infinite}.loading-default[data-v-46b20d22]:before{content:"";position:absolute;display:block;top:0;left:50%;margin-top:-3px;margin-left:-3px;width:6px;height:6px;background-color:#999;border-radius:50%}.loading-spiral[data-v-46b20d22]{border:2px solid #777;border-right-color:transparent;-webkit-animation:loading-rotating-data-v-46b20d22 linear .85s infinite;animation:loading-rotating-data-v-46b20d22 linear .85s infinite}@-webkit-keyframes loading-rotating-data-v-46b20d22{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loading-rotating-data-v-46b20d22{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.loading-bubbles[data-v-46b20d22],.loading-circles[data-v-46b20d22]{position:relative}.loading-bubbles[data-v-46b20d22] .bubble-item,.loading-circles[data-v-46b20d22] .circle-item{position:absolute;top:50%;left:50%;display:inline-block;border-radius:50%}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(2),.loading-circles[data-v-46b20d22] .circle-item:nth-child(2){-webkit-animation-delay:93ms;animation-delay:93ms}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(3),.loading-circles[data-v-46b20d22] .circle-item:nth-child(3){-webkit-animation-delay:.186s;animation-delay:.186s}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(4),.loading-circles[data-v-46b20d22] .circle-item:nth-child(4){-webkit-animation-delay:.279s;animation-delay:.279s}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(5),.loading-circles[data-v-46b20d22] .circle-item:nth-child(5){-webkit-animation-delay:.372s;animation-delay:.372s}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(6),.loading-circles[data-v-46b20d22] .circle-item:nth-child(6){-webkit-animation-delay:.465s;animation-delay:.465s}.loading-bubbles[data-v-46b20d22] .bubble-item:nth-child(7),.loading-circles[data-v-46b20d22] .circle-item:nth-child(7){-webkit-animation-delay:.558s;animation-delay:.558s}.loading-bubbles[data-v-46b20d22] .bubble-item:last-child,.loading-circles[data-v-46b20d22] .circle-item:last-child{-webkit-animation-delay:.651s;animation-delay:.651s}',""]);},function(t,e,n){n.r(e);var i=n(1),a=n.n(i);for(var r in i)"default"!==r&&function(t){n.d(e,t,(function(){return i[t]}));}(r);e.default=a.a;},function(t,e,n){(t.exports=n(2)(!1)).push([t.i,".infinite-loading-container[data-v-644ea9c9]{clear:both;text-align:center}.infinite-loading-container[data-v-644ea9c9] [class^=loading-]{display:inline-block;margin:5px 0;width:28px;height:28px;font-size:28px;line-height:28px;border-radius:50%}.btn-try-infinite[data-v-644ea9c9]{margin-top:5px;padding:5px 10px;color:#999;font-size:14px;line-height:1;background:transparent;border:1px solid #ccc;border-radius:3px;outline:none;cursor:pointer}.btn-try-infinite[data-v-644ea9c9]:not(:active):hover{opacity:.8}",""]);},function(t,e,n){n.r(e);var i={throttleLimit:50,loopCheckTimeout:1e3,loopCheckMaxCalls:10},a=function(){var t=!1;try{var e=Object.defineProperty({},"passive",{get:function(){return t={passive:!0},!0}});window.addEventListener("testpassive",e,e),window.remove("testpassive",e,e);}catch(t){}return t}(),r={STATE_CHANGER:["emit `loaded` and `complete` event through component instance of `$refs` may cause error, so it will be deprecated soon, please use the `$state` argument instead (`$state` just the special `$event` variable):","\ntemplate:",'<infinite-loading @infinite="infiniteHandler"></infinite-loading>',"\nscript:\n...\ninfiniteHandler($state) {\n  ajax('https://www.example.com/api/news')\n    .then((res) => {\n      if (res.data.length) {\n        $state.loaded();\n      } else {\n        $state.complete();\n      }\n    });\n}\n...","","more details: https://github.com/PeachScript/vue-infinite-loading/issues/57#issuecomment-324370549"].join("\n"),INFINITE_EVENT:"`:on-infinite` property will be deprecated soon, please use `@infinite` event instead.",IDENTIFIER:"the `reset` event will be deprecated soon, please reset this component by change the `identifier` property."},o={INFINITE_LOOP:["executed the callback function more than ".concat(i.loopCheckMaxCalls," times for a short time, it looks like searched a wrong scroll wrapper that doest not has fixed height or maximum height, please check it. If you want to force to set a element as scroll wrapper ranther than automatic searching, you can do this:"),'\n\x3c!-- add a special attribute for the real scroll wrapper --\x3e\n<div infinite-wrapper>\n  ...\n  \x3c!-- set force-use-infinite-wrapper --\x3e\n  <infinite-loading force-use-infinite-wrapper></infinite-loading>\n</div>\nor\n<div class="infinite-wrapper">\n  ...\n  \x3c!-- set force-use-infinite-wrapper as css selector of the real scroll wrapper --\x3e\n  <infinite-loading force-use-infinite-wrapper=".infinite-wrapper"></infinite-loading>\n</div>\n    ',"more details: https://github.com/PeachScript/vue-infinite-loading/issues/55#issuecomment-316934169"].join("\n")},s={READY:0,LOADING:1,COMPLETE:2,ERROR:3},l={color:"#666",fontSize:"14px",padding:"10px 0"},d={mode:"development",props:{spinner:"default",distance:100,forceUseInfiniteWrapper:!1},system:i,slots:{noResults:"No results :(",noMore:"No more data :)",error:"Opps, something went wrong :(",errorBtnText:"Retry",spinner:""},WARNINGS:r,ERRORS:o,STATUS:s},c=n(4),u=n.n(c),p={BUBBLES:{render:function(t){return t("span",{attrs:{class:"loading-bubbles"}},Array.apply(Array,Array(8)).map((function(){return t("span",{attrs:{class:"bubble-item"}})})))}},CIRCLES:{render:function(t){return t("span",{attrs:{class:"loading-circles"}},Array.apply(Array,Array(8)).map((function(){return t("span",{attrs:{class:"circle-item"}})})))}},DEFAULT:{render:function(t){return t("i",{attrs:{class:"loading-default"}})}},SPIRAL:{render:function(t){return t("i",{attrs:{class:"loading-spiral"}})}},WAVEDOTS:{render:function(t){return t("span",{attrs:{class:"loading-wave-dots"}},Array.apply(Array,Array(5)).map((function(){return t("span",{attrs:{class:"wave-item"}})})))}}};function f(t,e,n,i,a,r,o,s){var l,d="function"==typeof t?t.options:t;if(e&&(d.render=e,d.staticRenderFns=n,d._compiled=!0),i&&(d.functional=!0),r&&(d._scopeId="data-v-"+r),o?(l=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),a&&a.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o);},d._ssrRegister=l):a&&(l=s?function(){a.call(this,this.$root.$options.shadowRoot);}:a),l)if(d.functional){d._injectStyles=l;var c=d.render;d.render=function(t,e){return l.call(e),c(t,e)};}else {var u=d.beforeCreate;d.beforeCreate=u?[].concat(u,l):[l];}return {exports:t,options:d}}var b=f({name:"Spinner",computed:{spinnerView:function(){return p[(this.$attrs.spinner||"").toUpperCase()]||this.spinnerInConfig},spinnerInConfig:function(){return d.slots.spinner&&"string"==typeof d.slots.spinner?{render:function(){return this._v(d.slots.spinner)}}:"object"===u()(d.slots.spinner)?d.slots.spinner:p[d.props.spinner.toUpperCase()]||p.DEFAULT}}},(function(){var t=this.$createElement;return (this._self._c||t)(this.spinnerView,{tag:"component"})}),[],!1,(function(t){var e=n(5);e.__inject__&&e.__inject__(t);}),"46b20d22",null).exports;function h(t){"production"!==d.mode&&console.warn("[Vue-infinite-loading warn]: ".concat(t));}function m(t){console.error("[Vue-infinite-loading error]: ".concat(t));}var g={timers:[],caches:[],throttle:function(t){var e=this;-1===this.caches.indexOf(t)&&(this.caches.push(t),this.timers.push(setTimeout((function(){t(),e.caches.splice(e.caches.indexOf(t),1),e.timers.shift();}),d.system.throttleLimit)));},reset:function(){this.timers.forEach((function(t){clearTimeout(t);})),this.timers.length=0,this.caches=[];}},v={isChecked:!1,timer:null,times:0,track:function(){var t=this;this.times+=1,clearTimeout(this.timer),this.timer=setTimeout((function(){t.isChecked=!0;}),d.system.loopCheckTimeout),this.times>d.system.loopCheckMaxCalls&&(m(o.INFINITE_LOOP),this.isChecked=!0);}},w={key:"_infiniteScrollHeight",getScrollElm:function(t){return t===window?document.documentElement:t},save:function(t){var e=this.getScrollElm(t);e[this.key]=e.scrollHeight;},restore:function(t){var e=this.getScrollElm(t);"number"==typeof e[this.key]&&(e.scrollTop=e.scrollHeight-e[this.key]+e.scrollTop),this.remove(e);},remove:function(t){void 0!==t[this.key]&&delete t[this.key];}};function y(t){return t.replace(/[A-Z]/g,(function(t){return "-".concat(t.toLowerCase())}))}function x(t){return t.offsetWidth+t.offsetHeight>0}var k=f({name:"InfiniteLoading",data:function(){return {scrollParent:null,scrollHandler:null,isFirstLoad:!0,status:s.READY,slots:d.slots}},components:{Spinner:b},computed:{isShowSpinner:function(){return this.status===s.LOADING},isShowError:function(){return this.status===s.ERROR},isShowNoResults:function(){return this.status===s.COMPLETE&&this.isFirstLoad},isShowNoMore:function(){return this.status===s.COMPLETE&&!this.isFirstLoad},slotStyles:function(){var t=this,e={};return Object.keys(d.slots).forEach((function(n){var i=y(n);(!t.$slots[i]&&!d.slots[n].render||t.$slots[i]&&!t.$slots[i][0].tag)&&(e[n]=l);})),e}},props:{distance:{type:Number,default:d.props.distance},spinner:String,direction:{type:String,default:"bottom"},forceUseInfiniteWrapper:{type:[Boolean,String],default:d.props.forceUseInfiniteWrapper},identifier:{default:+new Date},onInfinite:Function},watch:{identifier:function(){this.stateChanger.reset();}},mounted:function(){var t=this;this.$watch("forceUseInfiniteWrapper",(function(){t.scrollParent=t.getScrollParent();}),{immediate:!0}),this.scrollHandler=function(e){t.status===s.READY&&(e&&e.constructor===Event&&x(t.$el)?g.throttle(t.attemptLoad):t.attemptLoad());},setTimeout((function(){t.scrollHandler(),t.scrollParent.addEventListener("scroll",t.scrollHandler,a);}),1),this.$on("$InfiniteLoading:loaded",(function(e){t.isFirstLoad=!1,"top"===t.direction&&t.$nextTick((function(){w.restore(t.scrollParent);})),t.status===s.LOADING&&t.$nextTick(t.attemptLoad.bind(null,!0)),e&&e.target===t||h(r.STATE_CHANGER);})),this.$on("$InfiniteLoading:complete",(function(e){t.status=s.COMPLETE,t.$nextTick((function(){t.$forceUpdate();})),t.scrollParent.removeEventListener("scroll",t.scrollHandler,a),e&&e.target===t||h(r.STATE_CHANGER);})),this.$on("$InfiniteLoading:reset",(function(e){t.status=s.READY,t.isFirstLoad=!0,w.remove(t.scrollParent),t.scrollParent.addEventListener("scroll",t.scrollHandler,a),setTimeout((function(){g.reset(),t.scrollHandler();}),1),e&&e.target===t||h(r.IDENTIFIER);})),this.stateChanger={loaded:function(){t.$emit("$InfiniteLoading:loaded",{target:t});},complete:function(){t.$emit("$InfiniteLoading:complete",{target:t});},reset:function(){t.$emit("$InfiniteLoading:reset",{target:t});},error:function(){t.status=s.ERROR,g.reset();}},this.onInfinite&&h(r.INFINITE_EVENT);},deactivated:function(){this.status===s.LOADING&&(this.status=s.READY),this.scrollParent.removeEventListener("scroll",this.scrollHandler,a);},activated:function(){this.scrollParent.addEventListener("scroll",this.scrollHandler,a);},methods:{attemptLoad:function(t){var e=this;this.status!==s.COMPLETE&&x(this.$el)&&this.getCurrentDistance()<=this.distance?(this.status=s.LOADING,"top"===this.direction&&this.$nextTick((function(){w.save(e.scrollParent);})),"function"==typeof this.onInfinite?this.onInfinite.call(null,this.stateChanger):this.$emit("infinite",this.stateChanger),!t||this.forceUseInfiniteWrapper||v.isChecked||v.track()):this.status===s.LOADING&&(this.status=s.READY);},getCurrentDistance:function(){var t;"top"===this.direction?t="number"==typeof this.scrollParent.scrollTop?this.scrollParent.scrollTop:this.scrollParent.pageYOffset:t=this.$el.getBoundingClientRect().top-(this.scrollParent===window?window.innerHeight:this.scrollParent.getBoundingClientRect().bottom);return t},getScrollParent:function(){var t,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.$el;return "string"==typeof this.forceUseInfiniteWrapper&&(t=document.querySelector(this.forceUseInfiniteWrapper)),t||("BODY"===e.tagName?t=window:!this.forceUseInfiniteWrapper&&["scroll","auto"].indexOf(getComputedStyle(e).overflowY)>-1?t=e:(e.hasAttribute("infinite-wrapper")||e.hasAttribute("data-infinite-wrapper"))&&(t=e)),t||this.getScrollParent(e.parentNode)}},destroyed:function(){!this.status!==s.COMPLETE&&(g.reset(),w.remove(this.scrollParent),this.scrollParent.removeEventListener("scroll",this.scrollHandler,a));}},(function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"infinite-loading-container"},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isShowSpinner,expression:"isShowSpinner"}],staticClass:"infinite-status-prompt",style:t.slotStyles.spinner},[t._t("spinner",[n("spinner",{attrs:{spinner:t.spinner}})])],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:t.isShowNoResults,expression:"isShowNoResults"}],staticClass:"infinite-status-prompt",style:t.slotStyles.noResults},[t._t("no-results",[t.slots.noResults.render?n(t.slots.noResults,{tag:"component"}):[t._v(t._s(t.slots.noResults))]])],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:t.isShowNoMore,expression:"isShowNoMore"}],staticClass:"infinite-status-prompt",style:t.slotStyles.noMore},[t._t("no-more",[t.slots.noMore.render?n(t.slots.noMore,{tag:"component"}):[t._v(t._s(t.slots.noMore))]])],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:t.isShowError,expression:"isShowError"}],staticClass:"infinite-status-prompt",style:t.slotStyles.error},[t._t("error",[t.slots.error.render?n(t.slots.error,{tag:"component",attrs:{trigger:t.attemptLoad}}):[t._v("\n        "+t._s(t.slots.error)+"\n        "),n("br"),t._v(" "),n("button",{staticClass:"btn-try-infinite",domProps:{textContent:t._s(t.slots.errorBtnText)},on:{click:t.attemptLoad}})]],{trigger:t.attemptLoad})],2)])}),[],!1,(function(t){var e=n(7);e.__inject__&&e.__inject__(t);}),"644ea9c9",null).exports;function E(t){d.mode=t.config.productionTip?"development":"production";}Object.defineProperty(k,"install",{configurable:!1,enumerable:!1,value:function(t,e){Object.assign(d.props,e&&e.props),Object.assign(d.slots,e&&e.slots),Object.assign(d.system,e&&e.system),t.component("infinite-loading",k),E(t);}}),"undefined"!=typeof window&&window.Vue&&(window.Vue.component("infinite-loading",k),E(window.Vue));e.default=k;}])}));
});

var InfiniteLoading = /*@__PURE__*/getDefaultExportFromCjs(vueInfiniteLoading);

var script$K = {
  name: 'VcInfiniteScroll',
  components: {
    VcEmptyState,
    InfiniteLoading,
    VcLoader
  },
  props: {
    direction: {
      type: String,
      default: 'bottom'
    },
    noResultIcon: {
      type: String,
      default: 'icon-folder'
    },
    noResultText: {
      type: String,
      required: true
    },
    isEmpty: {
      type: Boolean,
      required: true
    },
    identifier: {
      type: Number,
      required: false
    },
    dataQa: {
      type: String,
      default: 'VcInfiniteScroll'
    }
  }
};

/* script */
const __vue_script__$K = script$K;
/* template */

var __vue_render__$G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', {
    staticClass: "infinite-scroll",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('infinite-loading', {
    attrs: {
      "direction": _vm.direction,
      "identifier": _vm.identifier
    },
    on: {
      "infinite": function ($event) {
        return _vm.$emit('onScroll', $event);
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('VcLoader', {
    attrs: {
      "color": "secondary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  })]), _vm._v(" "), _vm.isEmpty ? _c('div', {
    staticClass: "no-results-wrapper"
  }, [_vm._t("default", function () {
    return [_c('VcEmptyState', {
      attrs: {
        "icon": _vm.noResultIcon,
        "title": _vm.noResultText,
        "subtitle": "",
        "content": ""
      }
    })];
  })], 2) : _vm._e()], 1);
};

var __vue_staticRenderFns__$G = [];
/* style */

const __vue_inject_styles__$K = function (inject) {
  if (!inject) return;
  inject("data-v-4fdc6e4f_0", {
    source: ".infinite-scroll .no-results-wrapper[data-v-4fdc6e4f]{height:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$K = "data-v-4fdc6e4f";
/* module identifier */

const __vue_module_identifier__$K = undefined;
/* functional template */

const __vue_is_functional_template__$K = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$18 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$K, __vue_script__$K, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, createInjector, undefined, undefined);

var VcInfiniteScroll = __vue_component__$18;

var VcInfiniteScroll$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': VcInfiniteScroll
});

var script$J = {
  name: 'VcEntityList',
  components: {
    VcInfiniteScroll,
    VcGroupHeader,
    VcListItem,
    VcLayout,
    VcEmptyState,
    VcLoader
  },
  props: {
    groups: {
      type: Array,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    },
    separatorType: {
      type: String,
      default: 'group',
      validator: prop => ['group'].includes(prop)
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    showSelect: {
      type: Boolean,
      default: true
    },
    emptyStateImage: {
      type: String,
      default: ''
    },
    emptyStateTitle: {
      type: String,
      default: ''
    },
    emptyStateSubtitle: {
      type: String,
      default: ''
    },
    showEmptyStateButton: {
      type: Boolean,
      default: false
    },
    emptyStateButton: {
      type: String,
      default: ''
    },
    dataQa: {
      type: String,
      default: 'VcEntityList'
    }
  },
  computed: {
    totalLoadedItems() {
      const flatList = this.groups.reduce((acc, group) => {
        acc.splice(...group.items);
        return acc;
      }, []);
      return flatList.length;
    }

  }
};

/* script */
const __vue_script__$J = script$J;
/* template */

var __vue_render__$F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.isEmpty ? _c('VcEmptyState', {
    attrs: {
      "icon": _vm.emptyStateImage,
      "title": _vm.emptyStateTitle,
      "subtitle": _vm.emptyStateSubtitle,
      "show-button": _vm.showEmptyStateButton,
      "button": _vm.emptyStateButton
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onEmptyStateButtonClicked');
      }
    }
  }) : _vm.isLoading ? _c('VcLoader', {
    staticClass: "VcEntityList--loader"
  }) : _c('div', {
    staticClass: "VcEntityList--list",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm._l(_vm.groups, function (group) {
    return [_c('VcGroupHeader', _vm._b({}, 'VcGroupHeader', group, false)), _vm._v(" "), _vm._l(group.items, function (item) {
      return [_c('VcListItem', _vm._b({
        key: item.id,
        staticClass: "VcEntityList--list-item",
        attrs: {
          "show-select": _vm.showSelect,
          "align-items-center": ""
        },
        on: {
          "click": function ($event) {
            return _vm.$emit('onItemClicked', item);
          },
          "onSelectClicked": function (value) {
            return _vm.$emit('onSelectClicked', {
              item: item,
              value: value
            });
          }
        }
      }, 'VcListItem', item, false), [_c('VcLayout', [_vm._t("default", function () {
        return [_c('div', {
          staticClass: "VcEntityList--list-item-column"
        }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.data))])];
      })], 2)], 1)];
    })];
  }), _vm._v(" "), _vm.totalLoadedItems < _vm.totalItems ? _c('VcInfiniteScroll', {
    attrs: {
      "is-empty": false,
      "no-result-text": "No more items to load"
    },
    on: {
      "onScroll": function ($event) {
        return _vm.$emit('onLoadNextPage');
      }
    }
  }) : _vm._e()], 2);
};

var __vue_staticRenderFns__$F = [];
/* style */

const __vue_inject_styles__$J = function (inject) {
  if (!inject) return;
  inject("data-v-0db229b2_0", {
    source: ".VcEntityList--loader[data-v-0db229b2]{margin:auto}.VcEntityList--list[data-v-0db229b2]{display:inline-grid;overflow-y:auto}.VcEntityList--list-item[data-v-0db229b2]{padding-left:var(--size-value4);font-size:var(--font-size-xx-small)}.VcEntityList--list-item-column[data-v-0db229b2]{padding-inline-end:var(--size-value9)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$J = "data-v-0db229b2";
/* module identifier */

const __vue_module_identifier__$J = undefined;
/* functional template */

const __vue_is_functional_template__$J = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$16 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$J, __vue_script__$J, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, createInjector, undefined, undefined);

var __vue_component__$17 = __vue_component__$16;

var script$I = {
  name: 'VcMenuItem',
  components: {
    VcIcon,
    VcLayout,
    VSkeletonLoader: VSkeletonLoader,
    VExpansionPanelHeader: VExpansionPanelHeader,
    VExpansionPanelContent: VExpansionPanelContent,
    VExpansionPanel: VExpansionPanel,
    VExpansionPanels: VExpansionPanels
  },
  model: {
    prop: 'isExpanded',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    badgeText: {
      type: String
    },
    badgeColor: {
      type: String,
      default: 'orange',
      validator: value => ['orange'].includes(value)
    },
    submenuItems: {
      type: Array,
      default: () => []
    },
    isExpanded: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    selectedSubitem: {
      type: Number
    },
    size: {
      type: String,
      default: 'md',
      validator: prop => ['sm', 'md'].includes(prop)
    },
    flavor: {
      type: String,
      default: 'mobile',
      validator: value => ['mobile', 'desktop'].includes(value)
    },
    dense: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcMenuItem'
    }
  },
  computed: {
    textColor() {
      return this.flavor === 'desktop' ? 'var(--v-text-base)' : 'black';
    }

  }
};

/* script */
const __vue_script__$I = script$I;
/* template */

var __vue_render__$E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.isLoading ? _c('VcLayout', {
    class: "VcMenuItem MenuItemSkeletonContainer " + _vm.size + " " + _vm.flavor,
    attrs: {
      "align-center": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VSkeletonLoader', {
    staticClass: "VcMenuItem-skeleton",
    attrs: {
      "type": "image",
      "width": "20",
      "height": "20"
    }
  }), _vm._v(" "), _c('VSkeletonLoader', {
    attrs: {
      "type": "list-item",
      "width": "100%"
    }
  })], 1) : _vm.submenuItems.length === 0 ? _c('VcLayout', {
    class: "VcMenuItem VcMenuItem-simple " + _vm.size + " " + _vm.flavor + " " + (_vm.isSelected ? 'selected' : '') + " " + (_vm.dense ? 'dense' : ''),
    attrs: {
      "align-center": "",
      "tabindex": 0,
      "data-qa": _vm.dataQa
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.$emit('click');
      },
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm.icon ? _c('VcIcon', {
    class: "VcMenuItem-icon " + _vm.flavor,
    attrs: {
      "size": _vm.size === 'md' ? 20 : 16,
      "color": _vm.textColor
    }
  }, [_vm._v("\n    " + _vm._s(_vm.icon) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._t("default", function () {
    return [_c('VcLayout', {
      attrs: {
        "align-baseline": ""
      }
    }, [_c('div', {
      class: "VcMenuItem-text " + _vm.flavor + " VcMenuItem-userSelectNone"
    }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")]), _vm._v(" "), _vm.badgeText ? _c('div', {
      class: "VcMenuItem-badge badge-color-" + _vm.badgeColor + " ps-5"
    }, [_vm._v("\n        " + _vm._s(_vm.badgeText) + "\n      ")]) : _vm._e()])];
  }), _vm._v(" "), _c('VcLayout', {
    staticClass: "VcMenuItem-right-area justify-center align-center"
  }, [_vm._t("actions")], 2)], 2) : _c('v-expansion-panels', {
    class: "" + _vm.flavor,
    attrs: {
      "flat": "",
      "hover": "",
      "value": _vm.isExpanded ? 0 : undefined,
      "data-qa": _vm.dataQa
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('change', !_vm.isExpanded);
      }
    }
  }, [_c('v-expansion-panel', {
    staticClass: "VcMenuItem--expansionPanel"
  }, [_c('v-expansion-panel-header', {
    class: "VcMenuItem VcMenuItem-complex " + _vm.flavor,
    attrs: {
      "align-center": ""
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "size": _vm.flavor === 'desktop' ? 16 : 24,
            "color": _vm.textColor
          }
        }, [_vm._v(" $chevron_down ")])];
      },
      proxy: true
    }])
  }, [_c('VcLayout', {
    attrs: {
      "align-center": ""
    }
  }, [_vm.icon ? _c('VcIcon', {
    class: "VcMenuItem-icon " + _vm.flavor,
    attrs: {
      "size": _vm.size === 'md' ? 20 : 16,
      "color": _vm.textColor
    }
  }, [_vm._v("\n          " + _vm._s(_vm.icon) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._t("default", function () {
    return [_c('VcLayout', {
      class: "VcMenuItem " + _vm.size + "  " + _vm.flavor,
      attrs: {
        "align-center": ""
      }
    }, [_c('div', {
      class: "VcMenuItem-text " + _vm.flavor
    }, [_vm._v("\n              " + _vm._s(_vm.label) + "\n            ")]), _vm._v(" "), _vm.badgeText ? _c('div', {
      class: "VcMenuItem-badge badge-color-" + _vm.badgeColor + " ps-5"
    }, [_vm._v("\n              " + _vm._s(_vm.badgeText) + "\n            ")]) : _vm._e()])];
  })], 2)], 1), _vm._v(" "), _vm._l(_vm.submenuItems, function (item, index) {
    return _c('v-expansion-panel-content', {
      key: item.label,
      class: (_vm.isSelected && _vm.selectedSubitem === index ? 'selected' : '') + " " + _vm.flavor,
      attrs: {
        "eager": ""
      }
    }, [_c('VcLayout', {
      class: "VcMenuItem-subitem VcMenuItem-userSelectNone ps-6 " + _vm.size + " " + _vm.flavor,
      attrs: {
        "data-qa": _vm.dataQa + "-subitem-" + item.name,
        "align-center": ""
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('onSubmenuClicked', item, index);
        }
      }
    }, [_c('div', {
      class: "VcMenuItem-text " + _vm.flavor
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")]), _vm._v(" "), item.badgeText ? _c('div', {
      class: "VcMenuItem-badge badge-color-orange ps-5"
    }, [_vm._v("\n          " + _vm._s(item.badgeText) + "\n        ")]) : _vm._e()])], 1);
  })], 2)], 1);
};

var __vue_staticRenderFns__$E = [];
/* style */

const __vue_inject_styles__$I = function (inject) {
  if (!inject) return;
  inject("data-v-4edbbda4_0", {
    source: ".VcMenuItem[data-v-4edbbda4]{height:var(--size-value13);min-height:unset;font-weight:var(--font-weight-medium2)}.VcMenuItem.desktop[data-v-4edbbda4]{display:flex;color:var(--v-text-base);height:var(--size-value10)}.VcMenuItem.desktop :hover .VcMenuItem-icon[data-v-4edbbda4],.VcMenuItem.desktop :hover .VcMenuItem-text[data-v-4edbbda4]{opacity:unset}.MenuItemSkeletonContainer[data-v-4edbbda4]{padding:0 var(--size-value5)}.VcMenuItem-skeleton[data-v-4edbbda4]{margin-inline-end:var(--size-value5)}[data-v-4edbbda4] .v-skeleton-loader__list-item{background-color:transparent!important}.VcMenuItem-simple[data-v-4edbbda4]{border-inline-start:3px solid transparent;transition:border-inline-start 250ms,background-color 250ms}.VcMenuItem-simple[data-v-4edbbda4]:not(.dense){padding:0 var(--size-value5)}.VcMenuItem-simple[data-v-4edbbda4]:hover{background:rgba(0,0,0,.04)}.VcMenuItem-simple:hover .VcMenuItem-icon[data-v-4edbbda4],.VcMenuItem-simple:hover .VcMenuItem-text[data-v-4edbbda4]{opacity:unset}.VcMenuItem-simple.desktop[data-v-4edbbda4]:not(.dense){padding-inline:var(--size-value5) var(--size-value2)}.VcMenuItem-simple.desktop[data-v-4edbbda4]:hover{background:var(--gray-light-opacity-1);background:var(--v-secondary-base-opacity-14);cursor:pointer}.VcMenuItem-simple[data-v-4edbbda4]:active{background:rgba(0,0,0,.12);background:var(--v-secondary-base-opacity-20);transition:.3s background-color}.VcMenuItem--expansionPanel[data-v-4edbbda4]{background-color:transparent!important}.VcMenuItem-complex[data-v-4edbbda4]{padding:var(--size-value4) var(--size-value5)}.VcMenuItem-complex[data-v-4edbbda4]  .v-expansion-panel-header__icon{flex:0 0 var(--size-value9);justify-content:center;align-items:center}.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--active[data-v-4edbbda4]{border-radius:0}.v-expansion-panels[data-v-4edbbda4]{border-radius:0}.desktop[data-v-4edbbda4]  .v-expansion-panel-header{padding:unset;padding-inline:var(--size-value5) var(--size-value2);border-inline-start:3px solid transparent}.desktop[data-v-4edbbda4]  .v-expansion-panel-header::before{background-color:transparent}.desktop[data-v-4edbbda4]  .v-expansion-panel-header--active{background:var(--v-secondary-base-opacity-20)}.desktop[data-v-4edbbda4]  .v-expansion-panel-header:hover{background:var(--gray-light-opacity-1);background:var(--v-secondary-base-opacity-14);cursor:pointer}.VcMenuItem-icon[data-v-4edbbda4]{margin-inline-end:var(--size-value4)}.VcMenuItem-icon.desktop[data-v-4edbbda4]{flex:0 0 var(--size-value8);margin-inline-end:var(--size-value3);opacity:72%}.VcMenuItem-text[data-v-4edbbda4]{font-size:15px}.VcMenuItem-text.desktop[data-v-4edbbda4]{opacity:87%}.desktop .VcMenuItem-text[data-v-4edbbda4]{font-size:13px}.VcMenuItem-userSelectNone[data-v-4edbbda4]{user-select:none}.VcMenuItem-badge[data-v-4edbbda4]{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2)}.VcMenuItem-badge.badge-color-orange[data-v-4edbbda4]{color:var(--orange)}.VcMenuItem-right-area[data-v-4edbbda4]{flex:0 0 var(--size-value9)}.v-expansion-panel-content[data-v-4edbbda4]{border-inline-start:3px solid transparent;background-color:transparent;transition:border-inline-start 250ms,background-color 250ms}.v-expansion-panel-content[data-v-4edbbda4]:hover{background:rgba(0,0,0,.04);background:var(--v-secondary-base-opacity-14)}.v-expansion-panel-content[data-v-4edbbda4]  .v-expansion-panel-content__wrap{padding:var(--size-value2) var(--size-value6)}.desktop .v-expansion-panel-content[data-v-4edbbda4]:not(.selected){background:var(--gray-light-opacity-3);background:var(--v-secondary-base-opacity-4)}.desktop .v-expansion-panel-content[data-v-4edbbda4]:hover{background:var(--gray-light-opacity-2);background:var(--v-secondary-base-opacity-14)}.desktop .v-expansion-panel-content[data-v-4edbbda4]  .v-expansion-panel-content__wrap{padding:var(--size-value2) var(--size-value10)}.VcMenuItem-subitem[data-v-4edbbda4]{height:var(--size-value8);padding:0;font-size:var(--font-size-small2)}.VcMenuItem-subitem.desktop[data-v-4edbbda4]{height:var(--size-value6);color:var(--v-text-base);margin:-8px 0;padding:var(--size-value5) var(--size-value0)}.VcMenuItem-subitem.desktop[data-v-4edbbda4]:hover{cursor:pointer}.VcMenuItem-subitem.desktop:hover .VcMenuItem-text[data-v-4edbbda4]{opacity:unset}.sm.VcMenuItem[data-v-4edbbda4]{height:var(--size-value10)}.sm .VcMenuItem-text[data-v-4edbbda4]{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2)}.selected[data-v-4edbbda4]{border-inline-start:3px solid var(--v-secondary-base);background-color:var(--gray-light-opacity-1)}.selected.desktop[data-v-4edbbda4]{background-color:var(--v-secondary-base-opacity-20)}.selected.desktop .VcMenuItem-icon[data-v-4edbbda4],.selected.desktop .VcMenuItem-text[data-v-4edbbda4]{opacity:unset}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$I = "data-v-4edbbda4";
/* module identifier */

const __vue_module_identifier__$I = undefined;
/* functional template */

const __vue_is_functional_template__$I = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$15 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$I, __vue_script__$I, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, createInjector, undefined, undefined);

var VcMenuItem = __vue_component__$15;

var script$H = {
  name: 'VcBottomNav',
  components: {
    VcLayout,
    VcIcon,
    VSkeletonLoader: VSkeletonLoader,
    VTab: VTab,
    VTabs: VTabs
  },
  model: {
    prop: 'currentIndex',
    event: 'change'
  },
  props: {
    tabs: {
      type: Array,
      required: true,
      validator: value => value.length > 0 && value.every(item => item.label && item.icon)
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    currentIndex: {
      type: Number,
      default: undefined
    },
    dataQa: {
      type: String,
      default: 'VcBottomNav'
    }
  },
  computed: {
    safeCurrentIndex() {
      return Math.max(0, Math.min(this.currentIndex, this.tabs.length - 1));
    }

  }
};

/* script */
const __vue_script__$H = script$H;
/* template */

var __vue_render__$D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-tabs', {
    staticClass: "VcBottomNav",
    attrs: {
      "value": _vm.safeCurrentIndex,
      "centered": "",
      "background-color": "transparent",
      "slider-color": "secondary",
      "slider-size": "4",
      "active-class": "VcBottomNav--active",
      "height": "52",
      "optional": "",
      "data-qa": _vm.dataQa
    },
    on: {
      "change": function (newIndex) {
        return _vm.$emit('change', newIndex);
      }
    }
  }, _vm._l(_vm.tabs, function (item, index) {
    return _c('v-tab', {
      key: "tab-" + index,
      staticClass: "VcBottomNav--tab",
      attrs: {
        "active-class": "VcBottomNav--tab--active",
        "data-qa": _vm.dataQa + "-tab-" + index
      }
    }, [_vm.isLoading ? _c('VcLayout', {
      staticClass: "VcBottomNav--item",
      attrs: {
        "column": !_vm.$vuetify.breakpoint.mdAndUp,
        "align-center": "",
        "data-qa": _vm.dataQa + "-loading"
      }
    }, [_c('VSkeletonLoader', {
      attrs: {
        "type": "image",
        "min-width": "20",
        "width": "20",
        "height": "20"
      }
    }), _vm._v(" "), _c('VSkeletonLoader', {
      staticClass: "VcBottomNav--skeleton",
      attrs: {
        "type": "list-item",
        "width": "100%"
      }
    })], 1) : _c('VcLayout', {
      staticClass: "VcBottomNav--item",
      attrs: {
        "column": !_vm.$vuetify.breakpoint.mdAndUp,
        "align-center": "",
        "justify-center": ""
      }
    }, [_vm._t("tab-" + index, function () {
      return [_c('VcIcon', {
        attrs: {
          "color": index === _vm.safeCurrentIndex ? 'var(--v-secondary-base)' : 'var(--gray-darken-4)',
          "size": "20"
        }
      }, [_vm._v("\n          " + _vm._s(item.icon) + "\n        ")])];
    }, {
      "item": item
    }), _vm._v(" "), _c('span', {
      staticClass: "VcBottomNav--label mt-1"
    }, [_vm._v(_vm._s(item.label))])], 2)], 1);
  }), 1);
};

var __vue_staticRenderFns__$D = [];
/* style */

const __vue_inject_styles__$H = function (inject) {
  if (!inject) return;
  inject("data-v-5437037e_0", {
    source: ".VcBottomNav[data-v-5437037e]{box-shadow:var(--bottom-nav-shadow)}.VcBottomNav--tab[data-v-5437037e]{text-transform:initial;padding:0;min-width:0;flex-grow:1;flex-basis:20%}@media screen and (min-width:960px){.VcBottomNav--tab[data-v-5437037e]{max-width:96px}}.VcBottomNav--item[data-v-5437037e]{margin:0 var(--size-value2);margin-top:1px}.VcBottomNav--skeleton[data-v-5437037e]{margin-top:var(--size-value1)}@media screen and (min-width:960px){.VcBottomNav--skeleton[data-v-5437037e]{margin-inline-start:var(--size-value2)}}.VcBottomNav--active[data-v-5437037e]{color:var(--v-secondary-base)}.VcBottomNav--label[data-v-5437037e]{font-size:var(--font-size-xs-small);font-weight:var(--font-weight-medium2);line-height:var(--size-value3);letter-spacing:.33px}@media screen and (min-width:960px){.VcBottomNav--label[data-v-5437037e]{margin-inline-start:var(--size-value2)}}[data-v-5437037e] .v-skeleton-loader__list-item{height:unset}[data-v-5437037e] .v-tabs-slider-wrapper{bottom:unset}[data-v-5437037e] .v-slide-group__next,[data-v-5437037e] .v-slide-group__prev{display:none!important}[data-v-5437037e] .v-tab:focus::before{opacity:0!important}[data-v-5437037e] .VcBottomNav--tab--active{pointer-events:none;color:var(--v-secondary-base)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$H = "data-v-5437037e";
/* module identifier */

const __vue_module_identifier__$H = undefined;
/* functional template */

const __vue_is_functional_template__$H = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$13 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$H, __vue_script__$H, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, createInjector, undefined, undefined);

var __vue_component__$14 = __vue_component__$13;

var script$G = {
  name: 'VcTopMenuBar',
  components: {
    VcButton,
    VcIcon,
    VcLayout,
    VcAvatar,
    VcDropdown,
    VcList,
    VcBadge,
    VcImage
  },
  props: {
    showBackButton: {
      type: Boolean,
      default: true
    },

    /**
     * This is an avatar object. The structure is:
     * {
     *       imagePath: string;
     *       name: string;
     *       colorId: string;
     *       badgeIcon: string;
     * }
     */
    avatar: {
      type: Object,
      required: false
    },
    dataQa: {
      type: String,
      default: 'VcTopMenuBar'
    },
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },

    /**
     * Logo image
     */
    logo: {
      type: [String, Object],
      required: false
    },

    /**
     * This is a first button object. The structure is:
     * {
     *   identifier: int;
     *   icon: string;
     *   actionEvent: string; //event to dispatch
     *   actionType?: string; // frontage
     *   badgeValue?: string;
     *   label: string;
     *   data: any;
     * }
     *
     * Confluence link:
     * https://myvcita.atlassian.net/wiki/spaces/PREZ/pages/2622488730/Mobile+Tob+Bar
     */
    firstButton: {
      type: Object,
      required: false
    },

    /**
     * This is a second button object.
     */
    secondButton: {
      type: Object,
      required: false
    },

    /**
     * This is an array of bottom sheet actions.
     * The structure is identical to the first and second buttons.
     */
    bottomSheetActions: {
      type: Array,
      default: () => [],
      validator: prop => prop.every(e => e.identifier)
    },

    /**
     * This is a text actionable object displayed near text.
     */
    textActionableButton: {
      type: Object,
      required: false
    },
    textColor: {
      type: String,
      default: 'white'
    }
  },
  data: () => ({
    isMenuOpen: false
  }),
  computed: {
    isLogo() {
      return this.logo;
    },

    isActionableText() {
      return !this.logo && this.textActionableButton;
    },

    isTitleAvatar() {
      return !this.logo && !this.textActionableButton;
    }

  },
  methods: {
    onBottomSheetAction(event) {
      this.isMenuOpen = !this.isMenuOpen;
      let bottomSheetAction = this.bottomSheetActions.find(action => action.identifier == event);
      this.$emit('onBottomSheetButtonClicked', bottomSheetAction);
    }

  }
};

/* script */
const __vue_script__$G = script$G;
/* template */

var __vue_render__$C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "topmenu-container",
    attrs: {
      "align-center": "",
      "data-qa": _vm.dataQa
    }
  }, [_c("style", {
    tag: "component"
  }, [_vm._v(" .title-wrapper{--topbar-color: " + _vm._s(_vm.textColor) + "} ")]), _vm._v(" "), _c('VcLayout', {
    staticClass: "shrinked-wrapper",
    attrs: {
      "column": ""
    }
  }, [_vm.showBackButton ? _c('VcButton', {
    attrs: {
      "icon": "",
      "small": "",
      "data-qa": _vm.dataQa + "-backButton"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onBackClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "size": "var(--font-size-small)",
            "color": _vm.textColor
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.rtl ? '$chevron_right' : '$chevron_left') + "\n        ")])];
      },
      proxy: true
    }], null, false, 3510042612)
  }) : _vm._e()], 1), _vm._v(" "), _vm.isTitleAvatar && _vm.avatar ? _c('VcLayout', {
    staticClass: "shrinked-wrapper avatar-wrapper",
    attrs: {
      "column": ""
    }
  }, [_c('VcButton', {
    attrs: {
      "icon": "",
      "small": "",
      "data-qa": _vm.dataQa + "-avatarButton"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onAvatarClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcAvatar', {
          attrs: {
            "image-path": _vm.avatar.imagePath,
            "name": _vm.avatar.name,
            "color-id": _vm.avatar.colorId,
            "badge-icon": _vm.avatar.badgeIcon,
            "show-border": false,
            "size": "sm"
          }
        })];
      },
      proxy: true
    }], null, false, 1306851143)
  })], 1) : _vm._e(), _vm._v(" "), _vm.isTitleAvatar ? _c('VcLayout', {
    staticClass: "title-wrapper",
    attrs: {
      "column": ""
    }
  }, [_vm.subtitle ? _c('div', {
    staticClass: "topmenu-subtitle",
    attrs: {
      "data-qa": _vm.dataQa + "-topMenuSubtitle"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.title ? _c('div', {
    staticClass: "topmenu-title",
    class: {
      'title-with-subtitle': _vm.title && _vm.subtitle,
      'title-only': _vm.title && !_vm.subtitle
    },
    attrs: {
      "data-qa": _vm.dataQa + "-topMenuTitle"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.isLogo ? _c('VcLayout', {
    attrs: {
      "column": "",
      "align-start": ""
    }
  }, [_c('VcImage', {
    staticClass: "top-bar-image-logo",
    attrs: {
      "image": _vm.logo,
      "data-qa": _vm.dataQa + "-logo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.isActionableText ? _c('VcLayout', {
    staticClass: "title-wrapper",
    attrs: {
      "column": ""
    }
  }, [_c('div', {
    staticClass: "topmenu-title title-only",
    attrs: {
      "data-qa": _vm.dataQa + "-topMenuTitle"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onTextActionableButtonClicked');
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n\n      "), _c('VcButton', {
    attrs: {
      "icon": "",
      "small": "",
      "data-qa": _vm.dataQa + "-textActionableButton"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "size": "var(--font-size-small)",
            "color": _vm.textColor
          }
        }, [_vm._v("\n            " + _vm._s(_vm.textActionableButton.icon) + "\n          ")])];
      },
      proxy: true
    }], null, false, 2936208436)
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.secondButton ? _c('VcLayout', {
    staticClass: "button-wrapper",
    attrs: {
      "column": ""
    }
  }, [_c('VcButton', {
    attrs: {
      "icon": "",
      "small": "",
      "data-qa": _vm.dataQa + "-secondButton"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onSecondButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [!!_vm.secondButton.badgeValue ? _c('VcBadge', {
          attrs: {
            "badge-text": _vm.secondButton.badgeValue,
            "offset-y": 10,
            "offset-x": 15
          }
        }, [_c('VcIcon', {
          attrs: {
            "size": "var(--font-size-medium0)",
            "color": _vm.textColor
          }
        }, [_vm._v("\n            " + _vm._s(_vm.secondButton.icon) + "\n          ")])], 1) : _c('VcIcon', {
          attrs: {
            "size": "var(--font-size-medium0)",
            "color": _vm.textColor
          }
        }, [_vm._v("\n          " + _vm._s(_vm.secondButton.icon) + "\n        ")])];
      },
      proxy: true
    }], null, false, 2312296270)
  })], 1) : _vm._e(), _vm._v(" "), _vm.firstButton ? _c('VcLayout', {
    staticClass: "button-wrapper",
    attrs: {
      "column": ""
    }
  }, [_c('VcButton', {
    attrs: {
      "icon": "",
      "small": "",
      "data-qa": _vm.dataQa + "-firstButton"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onFirstButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [!!_vm.firstButton.badgeValue ? _c('VcBadge', {
          attrs: {
            "badge-text": _vm.firstButton.badgeValue,
            "offset-y": 10,
            "offset-x": 15
          }
        }, [_c('VcIcon', {
          attrs: {
            "size": "var(--font-size-medium0)",
            "color": _vm.textColor
          }
        }, [_vm._v("\n            " + _vm._s(_vm.firstButton.icon) + "\n          ")])], 1) : _c('VcIcon', {
          attrs: {
            "size": "var(--font-size-medium0)",
            "color": _vm.textColor
          }
        }, [_vm._v("\n          " + _vm._s(_vm.firstButton.icon) + "\n        ")])];
      },
      proxy: true
    }], null, false, 3451316750)
  })], 1) : _vm._e(), _vm._v(" "), _vm.bottomSheetActions.length ? _c('VcLayout', {
    staticClass: "button-wrapper",
    attrs: {
      "column": ""
    }
  }, [_c('VcDropdown', {
    attrs: {
      "data-qa": _vm.dataQa + "-additionalActions"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        var attrs = ref.attrs;
        return [_c('VcButton', _vm._g({
          attrs: {
            "icon": "",
            "small": ""
          },
          scopedSlots: _vm._u([{
            key: "prepend",
            fn: function () {
              return [_c('VcIcon', _vm._g(_vm._b({
                ref: "threeDotsActivator",
                attrs: {
                  "size": "var(--font-size-medium0)",
                  "color": _vm.textColor,
                  "data-qa": _vm.dataQa + "-threeDots"
                }
              }, 'VcIcon', attrs, false), on), [_vm._v("\n              $three_dots\n            ")])];
            },
            proxy: true
          }], null, true)
        }, on))];
      }
    }], null, false, 1569354368),
    model: {
      value: _vm.isMenuOpen,
      callback: function ($$v) {
        _vm.isMenuOpen = $$v;
      },
      expression: "isMenuOpen"
    }
  }, [_vm._v(" "), _c('VcList', {
    staticClass: "menu-list py-2",
    attrs: {
      "items": _vm.bottomSheetActions
    },
    on: {
      "select": _vm.onBottomSheetAction
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (item) {
        return [_c('VcIcon', {
          attrs: {
            "size": "var(--font-size-medium)",
            "data-qa": _vm.dataQa + "-bottomSheetAction" + item.identifier
          }
        }, [_vm._v("\n            " + _vm._s(item.icon) + "\n          ")]), _vm._v(" "), _c('span', {
          staticClass: "menu-item-text"
        }, [_vm._v(_vm._s(item.label))])];
      }
    }], null, false, 3614754235)
  })], 1)], 1) : _vm._e()], 1);
};

var __vue_staticRenderFns__$C = [];
/* style */

const __vue_inject_styles__$G = function (inject) {
  if (!inject) return;
  inject("data-v-0ef42a26_0", {
    source: ".topmenu-container[data-v-0ef42a26]{padding:var(--size-value2) var(--size-value3);background-color:var(--v-primary-base);height:var(--vc-top-bar-height)}.avatar-wrapper[data-v-0ef42a26]{padding:var(--size-value1)}.title-wrapper[data-v-0ef42a26]{padding-left:var(--size-value2);text-align:start;color:var(--topbar-color,#fff)}.shrinked-wrapper[data-v-0ef42a26]{flex-grow:0;flex-shrink:0}.button-wrapper[data-v-0ef42a26]{padding-left:var(--size-value2);flex-grow:0;flex-shrink:0;text-align:start}.topmenu-subtitle[data-v-0ef42a26]{font-size:var(--font-size-xx-small);font-weight:var(--font-weight-medium2);line-height:var(--size-value3);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.topmenu-title[data-v-0ef42a26]{font-weight:var(--font-weight-xl);line-height:var(--size-value7);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.title-with-subtitle[data-v-0ef42a26]{font-size:var(--font-size-medium0)}.title-only[data-v-0ef42a26]{font-size:var(--font-size-medium1)}[data-v-0ef42a26] .top-bar-image-logo.VcImage{height:var(--size-value8)}.menu-item-text[data-v-0ef42a26]{vertical-align:bottom;padding-left:var(--size-value1);font-size:var(--font-size-x-small);font-weight:var(--font-weight-large)}.menu-list[data-v-0ef42a26]{text-align:start}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$G = "data-v-0ef42a26";
/* module identifier */

const __vue_module_identifier__$G = undefined;
/* functional template */

const __vue_is_functional_template__$G = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$11 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$G, __vue_script__$G, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, createInjector, undefined, undefined);

var __vue_component__$12 = __vue_component__$11;

var script$F = {
  name: 'VcMenuItemsGroup',
  components: {
    VcButton,
    VcLayout,
    VcMenuItem,
    VcIcon
  },
  props: {
    /** This is an array of groups. Each group is an array of menu items which should comply with VcMenuItem component and its props */
    groupedMenuItems: {
      type: Array,
      default: () => []
    },
    isMenuLoading: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcMenuItemsGroup'
    }
  },
  computed: {
    groups() {
      return this.isMenuLoading ? [Array.from({
        length: 10
      }, () => ({
        label: 'label'
      }))] : this.groupedMenuItems;
    }

  },
  methods: {
    onRightAreaClick(e, menuItem) {
      e.stopPropagation();
      this.$emit('rightAreaClick', menuItem);
    }

  }
};

/* script */
const __vue_script__$F = script$F;
/* template */

var __vue_render__$B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    attrs: {
      "column": "",
      "data-qa": _vm.dataQa
    }
  }, _vm._l(_vm.groups, function (group, index) {
    return _c('div', {
      key: index,
      staticClass: "VcMenuItemsGroup my-3 py-1"
    }, _vm._l(group, function (menuItem, groupIndex) {
      return _c('VcMenuItem', _vm._b({
        key: groupIndex,
        staticClass: "vc-menu-item",
        class: {
          'vc-menu-item-blocked': menuItem.blocked,
          'vc-menu-item-loading': _vm.isMenuLoading
        },
        attrs: {
          "is-loading": _vm.isMenuLoading,
          "data-qa": _vm.dataQa + "-" + menuItem.label
        },
        on: {
          "change": function (value) {
            return _vm.$emit('menuItemChange', value, menuItem);
          },
          "click": function ($event) {
            return _vm.$emit('menuItemClick', menuItem);
          },
          "onSubmenuClicked": function (item) {
            return _vm.$emit('subMenuItemClick', item);
          }
        },
        scopedSlots: _vm._u([menuItem.blocked && menuItem.submenuItems.length === 0 ? {
          key: "actions",
          fn: function () {
            return [_c('VcIcon', {
              attrs: {
                "color": "var(--gray-darken-3)",
                "size": "24"
              }
            }, [_vm._v(" keyboard_arrow_down ")])];
          },
          proxy: true
        } : {
          key: "actions",
          fn: function () {
            return [_vm._t("right-area-" + menuItem.name, function () {
              return [menuItem.rightIcon ? _c('div', {
                on: {
                  "click": function (e) {
                    return _vm.onRightAreaClick(e, menuItem);
                  }
                }
              }, [_c('VcButton', {
                attrs: {
                  "small": "",
                  "icon": ""
                },
                scopedSlots: _vm._u([menuItem.rightIcon ? {
                  key: "prepend",
                  fn: function () {
                    return [_c('VcIcon', {
                      staticClass: "right-area-icon",
                      attrs: {
                        "color": "var(--gray-darken-3)",
                        "size": "16",
                        "data-qa": "right-area-vc-icon-" + menuItem.name
                      }
                    }, [_vm._v("\n                  " + _vm._s(menuItem.rightIcon) + "\n                ")])];
                  },
                  proxy: true
                } : null], null, true)
              })], 1) : _vm._e()];
            })];
          },
          proxy: true
        }], null, true)
      }, 'VcMenuItem', menuItem, false));
    }), 1);
  }), 0);
};

var __vue_staticRenderFns__$B = [];
/* style */

const __vue_inject_styles__$F = function (inject) {
  if (!inject) return;
  inject("data-v-5c0d879a_0", {
    source: ".VcMenuItemsGroup[data-v-5c0d879a]{border-radius:10px;box-shadow:var(--shadow-1);overflow:hidden}.VcMenuItemsGroup .vc-menu-item[data-v-5c0d879a]{border-bottom:1px solid var(--gray-lighten-2)}.VcMenuItemsGroup .vc-menu-item[data-v-5c0d879a]:last-child{border-bottom:none}.VcMenuItemsGroup .vc-menu-item[data-v-5c0d879a] .v-expansion-panel-content:active{background:rgba(0,0,0,.12);transition:.3s background-color}.VcMenuItemsGroup .vc-menu-item-loading[data-v-5c0d879a]{padding:0 var(--size-value5)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$F = "data-v-5c0d879a";
/* module identifier */

const __vue_module_identifier__$F = undefined;
/* functional template */

const __vue_is_functional_template__$F = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$F, __vue_script__$F, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, createInjector, undefined, undefined);

var __vue_component__$10 = __vue_component__$$;

var script$E = {
  name: 'VcProfileIndication',
  components: {
    VcAvatar,
    VcLayout,
    VcIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    avatar: {
      type: Object,
      default: () => ({})
    },
    dataQa: {
      type: String,
      default: 'VcProfileIndication'
    },
    showArrow: {
      type: Boolean,
      default: true
    }
  }
};

/* script */
const __vue_script__$E = script$E;
/* template */

var __vue_render__$A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "vc-profile-indication",
    attrs: {
      "align-center": "",
      "justify-space-between": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcAvatar', _vm._b({
    attrs: {
      "size": "lg"
    }
  }, 'VcAvatar', _vm.avatar, false)), _vm._v(" "), _c('VcLayout', {
    staticClass: "ms-4 align-start",
    attrs: {
      "column": ""
    }
  }, [_c('span', {
    staticClass: "title mb-1"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.subTitle))])]), _vm._v(" "), _vm.showArrow ? _c('VcIcon', {
    staticClass: "vc-profile-indication-icon",
    attrs: {
      "size": "20"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('profileClick');
      }
    }
  }, [_vm._v("\n    $chevron_right\n  ")]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$A = [];
/* style */

const __vue_inject_styles__$E = function (inject) {
  if (!inject) return;
  inject("data-v-164e2d3a_0", {
    source: ".vc-profile-indication[data-v-164e2d3a]{max-height:var(--size-value12)}.vc-profile-indication .title[data-v-164e2d3a]{font-style:normal;font-weight:var(--font-weight-large);font-size:var(--font-size-small3);line-height:var(--size-value5);color:var(--gray-darken-5)}.vc-profile-indication .sub-title[data-v-164e2d3a]{font-style:normal;font-weight:var(--font-weight-medium);font-size:var(--font-size-x-small);line-height:var(--size-value4);color:var(--gray-darken-3)}.vc-profile-indication .vc-profile-indication-icon[data-v-164e2d3a]{fill:var(--gray)!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$E = "data-v-164e2d3a";
/* module identifier */

const __vue_module_identifier__$E = undefined;
/* functional template */

const __vue_is_functional_template__$E = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, createInjector, undefined, undefined);

var __vue_component__$_ = __vue_component__$Z;

var script$D = {
  name: 'VcPoweredBy',
  components: {
    VcImage,
    VcLayout
  },
  props: {
    reverse: {
      type: Boolean,
      default: false
    },
    poweredByText: {
      type: String
    },
    textColor: {
      type: String,
      default: '#000000'
    },
    image: {
      type: [String, Object],
      required: true
    },
    size: {
      type: String,
      default: 'sm',
      validator: value => ['sm', 'md'].includes(value)
    },
    dataQa: {
      type: String,
      default: 'VcPoweredBy'
    }
  },
  computed: {
    computedClasses() {
      return `${this.size}-text`;
    },

    computedStyle() {
      return {
        '--text-color': this.textColor
      };
    }

  }
};

/* script */
const __vue_script__$D = script$D;
/* template */

var __vue_render__$z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    class: _vm.reverse ? 'alignment-direction-reverse' : 'alignment-direction-row',
    attrs: {
      "justify-center": "",
      "align-center": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    staticClass: "vcita-logo-image-container",
    class: "" + _vm.size
  }, [_c('VcImage', {
    attrs: {
      "data-qa": _vm.dataQa + "-image",
      "image": _vm.image
    }
  })], 1), _vm._v(" "), _vm.poweredByText ? _c('span', {
    staticClass: "vc-powered-by-text mx-2",
    class: _vm.computedClasses,
    style: _vm.computedStyle
  }, [_vm._v(_vm._s(_vm.poweredByText))]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$z = [];
/* style */

const __vue_inject_styles__$D = function (inject) {
  if (!inject) return;
  inject("data-v-ae810868_0", {
    source: ".vc-powered-by-text[data-v-ae810868]{font-weight:var(--font-weight-medium);color:var(--text-color)}.alignment-direction-reverse[data-v-ae810868]{flex-direction:row-reverse}.alignment-direction-row[data-v-ae810868]{flex-direction:row}.vcita-logo-image-container[data-v-ae810868]{flex:0 auto}.sm[data-v-ae810868]{height:18px}.sm-text[data-v-ae810868]{font-size:var(--font-size-xs-small)}.md[data-v-ae810868]{height:22px}.md-text[data-v-ae810868]{font-size:var(--font-size-x-small)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$D = "data-v-ae810868";
/* module identifier */

const __vue_module_identifier__$D = undefined;
/* functional template */

const __vue_is_functional_template__$D = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, createInjector, undefined, undefined);

var __vue_component__$Y = __vue_component__$X;

var script$C = {
  name: 'VcClientItem',
  components: {
    VcTooltip,
    VcIcon,
    VcButton,
    VcAvatar,
    VcLayout
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcClientItem'
    },
    clientAvatar: {
      type: Object,
      required: true,
      validator: avatar => avatar.imagePath || avatar.colorId || avatar.colorId === 0
    },
    contactName: {
      type: String,
      required: true
    },
    matterName: {
      type: String,
      required: false
    },
    subtitle: {
      type: String
    },
    clientAddress: {
      type: String,
      required: false
    },
    clientPhone: {
      type: String,
      required: false
    },
    showActionsOnHover: {
      type: Boolean,
      default: false
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    truncateText: {
      type: Boolean,
      default: false
    },
    disableTooltip: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    avatarSize() {
      return this.clientAvatar.size || 'lg';
    },

    title() {
      return this.matterName || this.subtitle || this.contactName;
    },

    subtitleText() {
      if (this.matterName) {
        return this.subtitle || this.contactName;
      }

      return null;
    }

  },
  methods: {
    openMaps() {
      this.$emit('onOpenMapsClicked');
    },

    callClient() {
      this.$emit('onCallClientClicked');
    },

    sendMessage() {
      this.$emit('onSendMessageClicked');
    }

  }
};

/* script */
const __vue_script__$C = script$C;
/* template */

var __vue_render__$y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcClientItem",
    class: {
      'show-actions-on-hover': _vm.showActionsOnHover
    },
    attrs: {
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('VcLayout', {
    staticClass: "client-data-wrapper",
    attrs: {
      "align-center": ""
    }
  }, [_c('VcAvatar', _vm._b({
    staticClass: "flex-grow-0 flex-shrink-0",
    attrs: {
      "name": _vm.contactName,
      "size": _vm.avatarSize,
      "data-qa": _vm.dataQa + "_avatar"
    }
  }, 'VcAvatar', _vm.clientAvatar, false)), _vm._v(" "), _c('VcLayout', {
    staticClass: "client-name-wrapper",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('span', {
    staticClass: "matter-name",
    class: {
      truncated: _vm.truncateText
    },
    attrs: {
      "data-qa": _vm.dataQa + "_mainClientName"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _vm.subtitleText ? _c('span', {
    staticClass: "contact-name",
    class: {
      truncated: _vm.truncateText
    },
    attrs: {
      "data-qa": _vm.dataQa + "_subClientName"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.subtitleText) + "\n      ")]) : _vm._e()])], 1), _vm._v(" "), !_vm.hideActions ? _c('VcLayout', {
    staticClass: "flex-grow-0 flex-shrink-0",
    attrs: {
      "align-center": ""
    }
  }, [_vm._t("actions", function () {
    return [_vm.clientAddress ? _c('VcTooltip', {
      attrs: {
        "dark": "",
        "top": "",
        "content": _vm.clientAddress,
        "disabled": _vm.disableTooltip,
        "data-qa": _vm.dataQa + "_openMapsTooltip"
      }
    }, [_c('VcButton', {
      staticClass: "px-2 client-item-action",
      attrs: {
        "ghost": "",
        "small": "",
        "flavor": "secondary",
        "data-qa": _vm.dataQa + "_openMapsBtn"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.openMaps.apply(null, arguments);
        }
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_c('VcIcon', {
            attrs: {
              "size": 16
            }
          }, [_vm._v(" $location ")])];
        },
        proxy: true
      }], null, false, 2715300475)
    })], 1) : _vm._e(), _vm._v(" "), _vm.clientPhone ? _c('VcTooltip', {
      attrs: {
        "dark": "",
        "top": "",
        "content": _vm.clientPhone,
        "disabled": _vm.disableTooltip,
        "data-qa": _vm.dataQa + "_callClientTooltip"
      }
    }, [_c('VcButton', {
      staticClass: "px-2 client-item-action",
      attrs: {
        "ghost": "",
        "small": "",
        "flavor": "secondary",
        "data-qa": _vm.dataQa + "_callClientBtn"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.callClient.apply(null, arguments);
        }
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_c('VcIcon', {
            attrs: {
              "size": 16
            }
          }, [_vm._v(" $call ")])];
        },
        proxy: true
      }], null, false, 4000699556)
    })], 1) : _vm._e(), _vm._v(" "), _c('VcTooltip', {
      attrs: {
        "dark": "",
        "top": "",
        "content": _vm.$dst('ds.client_item.send_message'),
        "disabled": _vm.disableTooltip,
        "data-qa": _vm.dataQa + "_sendMessageTooltip"
      }
    }, [_c('VcButton', {
      staticClass: "px-2 client-item-action",
      attrs: {
        "ghost": "",
        "small": "",
        "flavor": "secondary",
        "data-qa": _vm.dataQa + "_sendMessageBtn"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.sendMessage.apply(null, arguments);
        }
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_c('VcIcon', {
            attrs: {
              "size": 16
            }
          }, [_vm._v(" $message ")])];
        },
        proxy: true
      }], null, false, 3089390509)
    })], 1)];
  })], 2) : _vm._e()], 1);
};

var __vue_staticRenderFns__$y = [];
/* style */

const __vue_inject_styles__$C = function (inject) {
  if (!inject) return;
  inject("data-v-dfb51d22_0", {
    source: "[data-v-dfb51d22]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-dfb51d22]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-dfb51d22]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-dfb51d22]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-dfb51d22]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-dfb51d22]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-dfb51d22]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-dfb51d22]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-dfb51d22]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-dfb51d22]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-dfb51d22]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-dfb51d22]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-dfb51d22]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-dfb51d22]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-dfb51d22]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-dfb51d22]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-dfb51d22]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-dfb51d22]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-dfb51d22]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-dfb51d22]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-dfb51d22]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-dfb51d22]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-dfb51d22]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-dfb51d22]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-dfb51d22]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-dfb51d22]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-dfb51d22]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-dfb51d22]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-dfb51d22]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-dfb51d22]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-dfb51d22]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-dfb51d22]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-dfb51d22]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-dfb51d22]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-dfb51d22]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-dfb51d22]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-dfb51d22]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-dfb51d22]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-dfb51d22]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-dfb51d22]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-dfb51d22]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-dfb51d22]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-dfb51d22]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-dfb51d22]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-dfb51d22]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-dfb51d22]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-dfb51d22]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-dfb51d22]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-dfb51d22]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-dfb51d22]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-dfb51d22]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-dfb51d22]{--color-dark:#63757e;--color-light:#c8d2d7}.VcClientItem[data-v-dfb51d22]{border-radius:var(--border-radius);padding-block:var(--size-value2);padding-inline-start:var(--size-value2)}.VcClientItem[data-v-dfb51d22]:hover{background-color:var(--gray-lighten-3)}.VcClientItem .client-data-wrapper[data-v-dfb51d22]{gap:var(--size-value4)}.VcClientItem .client-data-wrapper .client-name-wrapper[data-v-dfb51d22]{gap:2px;padding-top:2px}.VcClientItem .client-data-wrapper .client-name-wrapper .matter-name[data-v-dfb51d22]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-small2);line-height:var(--size-value5)}.VcClientItem .client-data-wrapper .client-name-wrapper .contact-name[data-v-dfb51d22]{font-weight:var(--font-weight-medium);font-size:var(--font-size-x-small);line-height:var(--size-value6)}.VcClientItem .client-data-wrapper .client-name-wrapper .truncated[data-v-dfb51d22]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.show-actions-on-hover .client-item-action[data-v-dfb51d22]{opacity:0}.show-actions-on-hover:hover .client-item-action[data-v-dfb51d22]{opacity:1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$C = "data-v-dfb51d22";
/* module identifier */

const __vue_module_identifier__$C = undefined;
/* functional template */

const __vue_is_functional_template__$C = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, createInjector, undefined, undefined);

var __vue_component__$W = __vue_component__$V;

var script$B = {
  name: 'VcDetailItem',
  components: {
    VcIcon,
    VcLayout
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcDetailItem'
    },
    icon: {
      type: String,
      required: true
    },
    iconSize: {
      type: Number,
      default: 20
    },
    header: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: false
    }
  }
};

/* script */
const __vue_script__$B = script$B;
/* template */

var __vue_render__$x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcDetailItem",
    attrs: {
      "align-start": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcIcon', {
    attrs: {
      "color": "var(--gray-darken-3)",
      "size": _vm.iconSize
    }
  }, [_vm._v("\n    " + _vm._s(_vm.icon) + "\n  ")]), _vm._v(" "), _c('VcLayout', {
    staticClass: "details-wrapper",
    attrs: {
      "column": ""
    }
  }, [_c('span', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('span', {
    staticClass: "detail-content"
  }, [_vm._v(_vm._s(_vm.content))])])], 1);
};

var __vue_staticRenderFns__$x = [];
/* style */

const __vue_inject_styles__$B = function (inject) {
  if (!inject) return;
  inject("data-v-154031a7_0", {
    source: "[data-v-154031a7]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-154031a7]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-154031a7]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-154031a7]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-154031a7]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-154031a7]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-154031a7]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-154031a7]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-154031a7]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-154031a7]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-154031a7]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-154031a7]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-154031a7]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-154031a7]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-154031a7]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-154031a7]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-154031a7]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-154031a7]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-154031a7]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-154031a7]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-154031a7]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-154031a7]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-154031a7]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-154031a7]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-154031a7]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-154031a7]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-154031a7]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-154031a7]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-154031a7]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-154031a7]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-154031a7]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-154031a7]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-154031a7]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-154031a7]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-154031a7]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-154031a7]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-154031a7]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-154031a7]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-154031a7]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-154031a7]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-154031a7]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-154031a7]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-154031a7]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-154031a7]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-154031a7]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-154031a7]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-154031a7]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-154031a7]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-154031a7]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-154031a7]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-154031a7]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-154031a7]{--color-dark:#63757e;--color-light:#c8d2d7}.VcDetailItem[data-v-154031a7]{border-radius:var(--border-radius);padding-block:var(--size-value2);padding-inline-start:var(--size-value2);gap:var(--size-value3)}.VcDetailItem .details-wrapper[data-v-154031a7]{gap:2px}.VcDetailItem .details-wrapper .detail-header[data-v-154031a7]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small);line-height:var(--size-value5);color:var(--gray-darken-3)}.VcDetailItem .details-wrapper .detail-content[data-v-154031a7]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small);line-height:var(--size-value6)}.VcDetailItem[data-v-154031a7]  .v-icon{height:var(--size-value5)!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$B = "data-v-154031a7";
/* module identifier */

const __vue_module_identifier__$B = undefined;
/* functional template */

const __vue_is_functional_template__$B = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, createInjector, undefined, undefined);

var __vue_component__$U = __vue_component__$T;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$A = {
  name: 'VcTimeline',
  components: {
    VTimelineItem: VTimelineItem,
    VTimeline: VTimeline
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcTimeline'
    },
    items: {
      type: Array,
      required: true,
      validator: value => value.every(item => !item.state || ['success', 'error', 'primary', 'default'].includes(item.state))
    }
  },
  methods: {
    getIconColorByState(state) {
      switch (state) {
        case 'success':
          return 'var(--green)';

        case 'error':
          return 'var(--red)';

        case 'primary':
          return 'var(--v-secondary-base)';

        default:
          return 'var(--gray-darken-1)';
      }
    }

  }
};

/* script */
const __vue_script__$A = script$A;
/* template */

var __vue_render__$w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-timeline', {
    staticClass: "VcTimeline",
    attrs: {
      "align-top": "",
      "dense": "",
      "data-qa": _vm.dataQa
    }
  }, _vm._l(_vm.items, function (timelineItem, index) {
    return _c('v-timeline-item', {
      key: index,
      attrs: {
        "color": "transparent",
        "small": ""
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function () {
          return [_c('div', {
            staticClass: "timeline-icon",
            style: {
              backgroundColor: _vm.getIconColorByState(timelineItem.state)
            }
          }, [_vm._v("\n         \n      ")])];
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._t("timeline-item-" + index, function () {
      return [[_c('span', [_vm._v(_vm._s(timelineItem.label))])]];
    }, {
      "item": timelineItem
    })], 2);
  }), 1);
};

var __vue_staticRenderFns__$w = [];
/* style */

const __vue_inject_styles__$A = function (inject) {
  if (!inject) return;
  inject("data-v-4a6ec1ac_0", {
    source: "[data-v-4a6ec1ac]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-4a6ec1ac]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-4a6ec1ac]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-4a6ec1ac]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-4a6ec1ac]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-4a6ec1ac]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-4a6ec1ac]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-4a6ec1ac]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-4a6ec1ac]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-4a6ec1ac]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-4a6ec1ac]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-4a6ec1ac]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-4a6ec1ac]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-4a6ec1ac]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-4a6ec1ac]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-4a6ec1ac]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-4a6ec1ac]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-4a6ec1ac]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-4a6ec1ac]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-4a6ec1ac]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-4a6ec1ac]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-4a6ec1ac]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-4a6ec1ac]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-4a6ec1ac]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-4a6ec1ac]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-4a6ec1ac]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-4a6ec1ac]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-4a6ec1ac]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-4a6ec1ac]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-4a6ec1ac]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-4a6ec1ac]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-4a6ec1ac]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-4a6ec1ac]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-4a6ec1ac]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-4a6ec1ac]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-4a6ec1ac]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-4a6ec1ac]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-4a6ec1ac]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-4a6ec1ac]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-4a6ec1ac]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-4a6ec1ac]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-4a6ec1ac]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-4a6ec1ac]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-4a6ec1ac]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-4a6ec1ac]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-4a6ec1ac]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-4a6ec1ac]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-4a6ec1ac]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-4a6ec1ac]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-4a6ec1ac]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-4a6ec1ac]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-4a6ec1ac]{--color-dark:#63757e;--color-light:#c8d2d7}.VcTimeline[data-v-4a6ec1ac]{padding-inline-end:var(--size-value4);padding-top:0}.VcTimeline[data-v-4a6ec1ac]  .v-timeline-item__dot{box-shadow:none;background:0 0}.VcTimeline[data-v-4a6ec1ac]  .timeline-icon{border-radius:var(--border-radius-circle);width:var(--size-value2);height:var(--size-value2)}.VcTimeline[data-v-4a6ec1ac]  .v-timeline-item:last-child{padding-bottom:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$A = "data-v-4a6ec1ac";
/* module identifier */

const __vue_module_identifier__$A = undefined;
/* functional template */

const __vue_is_functional_template__$A = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, createInjector, undefined, undefined);

var __vue_component__$S = __vue_component__$R;

var script$z = {
  name: 'VcTimelineRecord',
  components: {
    VcIcon,
    VcLayout
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcTimelineRecord'
    },
    header: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: false
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (this.clickable) {
        this.$emit('click');
      }
    }

  }
};

/* script */
const __vue_script__$z = script$z;
/* template */

var __vue_render__$v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcTimelineRecord",
    class: {
      clickable: _vm.clickable
    },
    attrs: {
      "align-center": "",
      "data-qa": _vm.dataQa
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('VcLayout', {
    attrs: {
      "column": ""
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      " + _vm._s(_vm.header) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("default", function () {
    return [_vm._v("\n        " + _vm._s(_vm.content) + "\n      ")];
  })], 2)]), _vm._v(" "), _vm.clickable ? _c('VcIcon', {
    attrs: {
      "size": "14",
      "color": "var(--gray)"
    }
  }, [_vm._v(" $chevron_right ")]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$v = [];
/* style */

const __vue_inject_styles__$z = function (inject) {
  if (!inject) return;
  inject("data-v-2a2a7bdc_0", {
    source: "[data-v-2a2a7bdc]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-2a2a7bdc]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-2a2a7bdc]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-2a2a7bdc]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-2a2a7bdc]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-2a2a7bdc]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-2a2a7bdc]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-2a2a7bdc]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-2a2a7bdc]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-2a2a7bdc]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-2a2a7bdc]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-2a2a7bdc]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-2a2a7bdc]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-2a2a7bdc]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-2a2a7bdc]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-2a2a7bdc]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-2a2a7bdc]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-2a2a7bdc]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-2a2a7bdc]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-2a2a7bdc]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-2a2a7bdc]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-2a2a7bdc]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-2a2a7bdc]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-2a2a7bdc]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-2a2a7bdc]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-2a2a7bdc]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-2a2a7bdc]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-2a2a7bdc]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-2a2a7bdc]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-2a2a7bdc]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-2a2a7bdc]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-2a2a7bdc]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-2a2a7bdc]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-2a2a7bdc]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-2a2a7bdc]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-2a2a7bdc]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-2a2a7bdc]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-2a2a7bdc]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-2a2a7bdc]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-2a2a7bdc]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-2a2a7bdc]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-2a2a7bdc]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-2a2a7bdc]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-2a2a7bdc]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-2a2a7bdc]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-2a2a7bdc]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-2a2a7bdc]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-2a2a7bdc]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-2a2a7bdc]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-2a2a7bdc]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-2a2a7bdc]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-2a2a7bdc]{--color-dark:#63757e;--color-light:#c8d2d7}.VcTimelineRecord[data-v-2a2a7bdc]{gap:var(--size-value1)}.VcTimelineRecord.clickable[data-v-2a2a7bdc]{cursor:pointer}.VcTimelineRecord .header[data-v-2a2a7bdc]{font-weight:500;font-size:var(--font-size-x-small);line-height:var(--size-value4)}.VcTimelineRecord .content[data-v-2a2a7bdc]{font-weight:400;font-size:var(--font-size-xx-small);line-height:var(--size-value4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$z = "data-v-2a2a7bdc";
/* module identifier */

const __vue_module_identifier__$z = undefined;
/* functional template */

const __vue_is_functional_template__$z = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, createInjector, undefined, undefined);

var __vue_component__$Q = __vue_component__$P;

var script$y = {
  name: 'VcEntityStatus',
  components: {
    VcIcon,
    VcLayout
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcEntityStatus'
    },
    mode: {
      type: String,
      required: true,
      validator: value => {
        return ['info', 'alert', 'warning', 'error', 'success', 'default'].includes(value);
      }
    },
    icon: {
      type: String,
      required: true
    },
    header: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    additionalContent: {
      type: String,
      required: false
    }
  }
};

/* script */
const __vue_script__$y = script$y;
/* template */

var __vue_render__$u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcEntityStatus pa-3",
    class: [_vm.mode + "-status"],
    attrs: {
      "column": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    staticClass: "header-wrapper"
  }, [_c('VcIcon', {
    attrs: {
      "size": 20,
      "color": "var(--header-color)"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.icon) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.header))])], 1), _vm._v(" "), _c('VcLayout', {
    staticClass: "content-wrapper"
  }, [_c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('span', {
    staticClass: "additional-content"
  }, [_vm._v(_vm._s(_vm.additionalContent))])])], 1);
};

var __vue_staticRenderFns__$u = [];
/* style */

const __vue_inject_styles__$y = function (inject) {
  if (!inject) return;
  inject("data-v-16ac0f4b_0", {
    source: "[data-v-16ac0f4b]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-16ac0f4b]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-16ac0f4b]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-16ac0f4b]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-16ac0f4b]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-16ac0f4b]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-16ac0f4b]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-16ac0f4b]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-16ac0f4b]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-16ac0f4b]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-16ac0f4b]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-16ac0f4b]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-16ac0f4b]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-16ac0f4b]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-16ac0f4b]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-16ac0f4b]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-16ac0f4b]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-16ac0f4b]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-16ac0f4b]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-16ac0f4b]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-16ac0f4b]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-16ac0f4b]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-16ac0f4b]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-16ac0f4b]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-16ac0f4b]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-16ac0f4b]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-16ac0f4b]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-16ac0f4b]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-16ac0f4b]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-16ac0f4b]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-16ac0f4b]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-16ac0f4b]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-16ac0f4b]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-16ac0f4b]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-16ac0f4b]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-16ac0f4b]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-16ac0f4b]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-16ac0f4b]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-16ac0f4b]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-16ac0f4b]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-16ac0f4b]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-16ac0f4b]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-16ac0f4b]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-16ac0f4b]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-16ac0f4b]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-16ac0f4b]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-16ac0f4b]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-16ac0f4b]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-16ac0f4b]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-16ac0f4b]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-16ac0f4b]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-16ac0f4b]{--color-dark:#63757e;--color-light:#c8d2d7}.VcEntityStatus[data-v-16ac0f4b]{gap:var(--size-value1)}.VcEntityStatus.info-status[data-v-16ac0f4b]{background-color:var(--entity-status-info-background-color);--header-color:var(--entity-status-info-header-color)}.VcEntityStatus.alert-status[data-v-16ac0f4b]{background-color:var(--entity-status-alert-background-color);--header-color:var(--entity-status-alert-header-color)}.VcEntityStatus.warning-status[data-v-16ac0f4b]{background-color:var(--entity-status-warning-background-color);--header-color:var(--entity-status-warning-header-color)}.VcEntityStatus.error-status[data-v-16ac0f4b]{background-color:var(--entity-status-error-background-color);--header-color:var(--entity-status-error-header-color)}.VcEntityStatus.success-status[data-v-16ac0f4b]{background-color:var(--entity-status-success-background-color);--header-color:var(--entity-status-success-header-color)}.VcEntityStatus.default-status[data-v-16ac0f4b]{background-color:var(--entity-status-default-background-color);--header-color:var(--entity-status-default-header-color)}.VcEntityStatus .header-wrapper[data-v-16ac0f4b]{gap:var(--size-value3);align-items:center;color:var(--header-color)}.VcEntityStatus .header-wrapper .header[data-v-16ac0f4b]{font-weight:var(--font-weight-large);font-size:var(--font-size-x-small);line-height:var(--size-value5)}.VcEntityStatus .content-wrapper[data-v-16ac0f4b]{gap:var(--size-value2);padding-inline-start:var(--size-value8);align-items:baseline}.VcEntityStatus .content-wrapper .content[data-v-16ac0f4b]{font-weight:var(--font-weight-large);font-size:var(--font-size-medium1);line-height:var(--size-value6)}.VcEntityStatus .content-wrapper .additional-content[data-v-16ac0f4b]{font-weight:var(--font-weight-large);font-size:var(--font-size-xx-small);line-height:var(--size-value6)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$y = "data-v-16ac0f4b";
/* module identifier */

const __vue_module_identifier__$y = undefined;
/* functional template */

const __vue_is_functional_template__$y = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, createInjector, undefined, undefined);

var __vue_component__$O = __vue_component__$N;

var script$x = {
  name: 'VcServiceItem',
  components: {
    VcImage,
    VcLayout
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcServiceItem'
    },
    image: {
      type: [String, Object],
      required: true
    },
    serviceName: {
      type: String,
      required: true
    },
    amount: {
      type: String,
      required: true
    }
  }
};

/* script */
const __vue_script__$x = script$x;
/* template */

var __vue_render__$t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcServiceItem",
    attrs: {
      "align-start": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    staticClass: "flex-grow-0"
  }, [_c('VcImage', {
    staticClass: "service-image",
    attrs: {
      "image": _vm.image
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "service-name flex-grow-1"
  }, [_vm._v(_vm._s(_vm.serviceName))]), _vm._v(" "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.amount))])], 1);
};

var __vue_staticRenderFns__$t = [];
/* style */

const __vue_inject_styles__$x = function (inject) {
  if (!inject) return;
  inject("data-v-297c12a8_0", {
    source: "[data-v-297c12a8]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-297c12a8]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-297c12a8]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-297c12a8]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-297c12a8]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-297c12a8]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-297c12a8]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-297c12a8]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-297c12a8]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-297c12a8]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-297c12a8]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-297c12a8]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-297c12a8]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-297c12a8]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-297c12a8]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-297c12a8]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-297c12a8]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-297c12a8]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-297c12a8]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-297c12a8]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-297c12a8]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-297c12a8]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-297c12a8]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-297c12a8]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-297c12a8]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-297c12a8]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-297c12a8]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-297c12a8]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-297c12a8]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-297c12a8]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-297c12a8]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-297c12a8]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-297c12a8]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-297c12a8]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-297c12a8]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-297c12a8]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-297c12a8]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-297c12a8]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-297c12a8]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-297c12a8]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-297c12a8]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-297c12a8]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-297c12a8]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-297c12a8]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-297c12a8]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-297c12a8]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-297c12a8]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-297c12a8]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-297c12a8]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-297c12a8]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-297c12a8]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-297c12a8]{--color-dark:#63757e;--color-light:#c8d2d7}.VcServiceItem[data-v-297c12a8]{padding-block:var(--size-value1);gap:var(--size-value4)}.VcServiceItem .service-image[data-v-297c12a8]{width:var(--size-value8);height:var(--size-value8);border-radius:var(--size-value1)}.VcServiceItem .service-name[data-v-297c12a8]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small);line-height:var(--size-value5)}.VcServiceItem .amount[data-v-297c12a8]{font-weight:var(--font-weight-large);font-size:var(--font-size-x-small);line-height:var(--size-value4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$x = "data-v-297c12a8";
/* module identifier */

const __vue_module_identifier__$x = undefined;
/* functional template */

const __vue_is_functional_template__$x = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, createInjector, undefined, undefined);

var __vue_component__$M = __vue_component__$L;

var script$w = {
  name: 'VcSidepaneHeader',
  components: {
    VcAvatar,
    VcButton,
    VcLayout,
    VcIcon,
    VDivider: VDivider
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcSidepaneHeader'
    },
    title: {
      type: String,
      required: false
    },
    contactName: {
      type: String,
      required: false
    },
    matterName: {
      type: String,
      required: false
    },
    clientAvatarUrl: {
      type: String,
      required: false
    },
    clientAvatarColor: {
      type: Number,
      required: false
    },
    clientAvatarIcon: {
      type: String,
      required: false
    },
    showBackBtn: {
      type: Boolean,
      default: false
    },
    showLinkBtn: {
      type: Boolean,
      default: false
    },
    showCloseBtn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    backClickHandler() {
      this.$emit('onBackClicked');
    },

    linkClickHandler() {
      this.$emit('onLinkClicked');
    },

    closeClickHandler() {
      this.$emit('onCloseClicked');
    }

  }
};

/* script */
const __vue_script__$w = script$w;
/* template */

var __vue_render__$s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    attrs: {
      "column": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    staticClass: "VcSidepaneHeader",
    attrs: {
      "align-center": "",
      "py-3": "",
      "pe-3": "",
      "ps-6": ""
    }
  }, [_c('VcLayout', {
    staticClass: "main-wrapper flex-grow-1"
  }, [_vm.showBackBtn ? _c('VcButton', {
    attrs: {
      "flavor": "secondary",
      "small": "",
      "ghost": "",
      "data-qa": _vm.dataQa + "_backBtn"
    },
    on: {
      "click": _vm.backClickHandler
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "size": 16
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.rtl ? '$chevron_right' : '$chevron_left') + "\n          ")])];
      },
      proxy: true
    }], null, false, 4050700405)
  }) : _vm._e(), _vm._v(" "), _vm.title ? _c('span', {
    staticClass: "header-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _c('VcLayout', {
    staticClass: "client-details-wrapper"
  }, [_c('VcAvatar', {
    attrs: {
      "name": _vm.contactName,
      "image-path": _vm.clientAvatarUrl,
      "color-id": _vm.clientAvatarColor,
      "badge-icon": _vm.clientAvatarIcon,
      "size": "sm",
      "data-qa": _vm.dataQa + "_clientAvatar"
    }
  }), _vm._v(" "), _c('VcLayout', {
    attrs: {
      "column": ""
    }
  }, [_c('span', {
    staticClass: "contact-name"
  }, [_vm._v(_vm._s(_vm.contactName))]), _vm._v(" "), _c('span', {
    staticClass: "matter-name"
  }, [_vm._v(_vm._s(_vm.matterName))])])], 1)], 1), _vm._v(" "), _c('VcLayout', {
    staticClass: "buttons-wrapper flex-grow-0"
  }, [_vm.showLinkBtn ? _c('VcButton', {
    staticClass: "px-2",
    attrs: {
      "ghost": "",
      "flavor": "secondary",
      "small": "",
      "data-qa": _vm.dataQa + "_linkBtn"
    },
    on: {
      "click": _vm.linkClickHandler
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "size": 16
          }
        }, [_vm._v(" $external_link ")])];
      },
      proxy: true
    }], null, false, 3268345668)
  }) : _vm._e(), _vm._v(" "), _vm.showCloseBtn ? _c('VcButton', {
    staticClass: "px-2",
    attrs: {
      "ghost": "",
      "flavor": "secondary",
      "small": "",
      "data-qa": _vm.dataQa + "_closeBtn"
    },
    on: {
      "click": _vm.closeClickHandler
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "color": "var(--gray-darken-2)",
            "size": 16
          }
        }, [_vm._v(" $close_button ")])];
      },
      proxy: true
    }], null, false, 3137988670)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider')], 1);
};

var __vue_staticRenderFns__$s = [];
/* style */

const __vue_inject_styles__$w = function (inject) {
  if (!inject) return;
  inject("data-v-599c1345_0", {
    source: "[data-v-599c1345]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-599c1345]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-599c1345]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-599c1345]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-599c1345]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-599c1345]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-599c1345]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-599c1345]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-599c1345]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-599c1345]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-599c1345]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-599c1345]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-599c1345]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-599c1345]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-599c1345]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-599c1345]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-599c1345]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-599c1345]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-599c1345]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-599c1345]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-599c1345]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-599c1345]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-599c1345]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-599c1345]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-599c1345]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-599c1345]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-599c1345]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-599c1345]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-599c1345]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-599c1345]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-599c1345]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-599c1345]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-599c1345]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-599c1345]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-599c1345]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-599c1345]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-599c1345]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-599c1345]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-599c1345]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-599c1345]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-599c1345]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-599c1345]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-599c1345]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-599c1345]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-599c1345]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-599c1345]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-599c1345]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-599c1345]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-599c1345]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-599c1345]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-599c1345]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-599c1345]{--color-dark:#63757e;--color-light:#c8d2d7}.VcSidepaneHeader .main-wrapper[data-v-599c1345]{gap:var(--size-value2)}.VcSidepaneHeader .main-wrapper .header-title[data-v-599c1345]{font-weight:var(--font-weight-large2);font-size:var(--font-size-small2);line-height:var(--size-value8);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.VcSidepaneHeader .main-wrapper .VcButton[data-v-599c1345]{max-width:var(--size-value8)}.VcSidepaneHeader .main-wrapper .client-details-wrapper[data-v-599c1345]{gap:var(--size-value3)}.VcSidepaneHeader .main-wrapper .client-details-wrapper .contact-name[data-v-599c1345]{font-weight:var(--font-weight-large2);font-size:var(--font-size-x-small);line-height:17px}.VcSidepaneHeader .main-wrapper .client-details-wrapper .matter-name[data-v-599c1345]{font-weight:var(--font-weight-normal);font-size:var(--font-size-small2);line-height:17px}.VcSidepaneHeader .buttons-wrapper[data-v-599c1345]{gap:var(--size-value1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$w = "data-v-599c1345";
/* module identifier */

const __vue_module_identifier__$w = undefined;
/* functional template */

const __vue_is_functional_template__$w = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, createInjector, undefined, undefined);

var __vue_component__$K = __vue_component__$J;

//
//
//
//
//
//
//
//
//
//
//
var script$v = {
  name: 'VcSummary',
  props: {
    headerText: {
      type: String,
      required: true
    },
    contentText: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      default: 'VcSummary'
    }
  }
};

/* script */
const __vue_script__$v = script$v;
/* template */

var __vue_render__$r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "VcSummary",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('div', {
    staticClass: "VcSummary__line VcSummary__header"
  }, [_vm._v("\n    " + _vm._s(_vm.headerText) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "VcSummary__line VcSummary__content"
  }, [_vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.contentText))];
  })], 2)]);
};

var __vue_staticRenderFns__$r = [];
/* style */

const __vue_inject_styles__$v = function (inject) {
  if (!inject) return;
  inject("data-v-70e0e786_0", {
    source: ".VcSummary[data-v-70e0e786]{border:1px solid var(--v-secondary-lighten2);border-radius:var(--border-radius);font-size:var(--font-size-x-small)}.VcSummary__line[data-v-70e0e786]{padding:var(--size-value2) var(--size-value4)}.VcSummary__header[data-v-70e0e786]{font-weight:var(--font-weight-large2);background-color:var(--v-secondary-lighten3);border-radius:var(--border-radius) var(--border-radius) 0 0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$v = "data-v-70e0e786";
/* module identifier */

const __vue_module_identifier__$v = undefined;
/* functional template */

const __vue_is_functional_template__$v = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, createInjector, undefined, undefined);

var __vue_component__$I = __vue_component__$H;

var script$u = {
  name: 'VcSystemAlert',
  components: {
    VcLayout,
    VcButton
  },
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'info',
      validator: value => ['warning', 'info', 'error'].includes(value)
    },
    buttonLabel: {
      type: String
    },
    dataQa: {
      type: String,
      default: 'VcSystemAlert'
    }
  }
};

/* script */
const __vue_script__$u = script$u;
/* template */

var __vue_render__$q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    class: "VcSystemAlert align-center justify-center VcSystemAlert--" + _vm.type,
    attrs: {
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.message) + "\n  "), _vm.buttonLabel ? _c('VcButton', {
    staticClass: "VcSystemAlert--button",
    attrs: {
      "small": "",
      "pill": "",
      "color": "white",
      "data-qa": _vm.dataQa + "-button"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.buttonLabel) + "\n  ")]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$q = [];
/* style */

const __vue_inject_styles__$u = function (inject) {
  if (!inject) return;
  inject("data-v-58132a93_0", {
    source: ".VcSystemAlert[data-v-58132a93]{width:100%;height:var(--size-value12);color:#fff;font-size:var(--font-size-x-small);font-weight:var(--font-weight-large2)}.VcSystemAlert .VcSystemAlert--button[data-v-58132a93]{margin-inline-start:var(--size-value4)}.VcSystemAlert.VcSystemAlert--warning[data-v-58132a93]{background-color:var(--orange)}.VcSystemAlert.VcSystemAlert--warning .VcSystemAlert--button[data-v-58132a93]{color:var(--orange)}.VcSystemAlert.VcSystemAlert--info[data-v-58132a93]{background-color:var(--blue)}.VcSystemAlert.VcSystemAlert--info .VcSystemAlert--button[data-v-58132a93]{color:var(--blue)}.VcSystemAlert.VcSystemAlert--error[data-v-58132a93]{background-color:var(--red)}.VcSystemAlert.VcSystemAlert--error .VcSystemAlert--button[data-v-58132a93]{color:var(--red)}.VcSystemAlert .VcSystemAlert--button[data-v-58132a93]{margin-inline-start:var(--size-value4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$u = "data-v-58132a93";
/* module identifier */

const __vue_module_identifier__$u = undefined;
/* functional template */

const __vue_is_functional_template__$u = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, createInjector, undefined, undefined);

var __vue_component__$G = __vue_component__$F;

var script$t = {
  name: 'VcSkeleton',
  props: {
    dataQa: {
      type: String
    }
  },
  render: function (createElement) {
    const classes = `${this.$attrs.height && this.$attrs.height.length > 0 ? 'VcSkeletonHeight' : ''}
    ${this.$attrs.width && this.$attrs.width.length > 0 ? 'VcSkeletonWidth' : ''}`;
    const props = {
      attrs: { ...this.$attrs,
        'data-qa': this.$props.dataQa || 'VcSkeleton'
      },
      on: { ...this.$listeners
      },
      ref: this.$vnode.data.ref,
      style: this.$vnode.data.style,
      class: classes
    };
    return createElement('v-skeleton-loader', props, this.$slots.default);
  }
};

/* script */
const __vue_script__$t = script$t;
/* template */

/* style */

const __vue_inject_styles__$t = function (inject) {
  if (!inject) return;
  inject("data-v-cde376cc_0", {
    source: ".VcSkeletonHeight[data-v-cde376cc]  .v-skeleton-loader__bone{height:inherit}.VcSkeletonWidth[data-v-cde376cc]  .v-skeleton-loader__bone{width:inherit}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$t = "data-v-cde376cc";
/* module identifier */

const __vue_module_identifier__$t = undefined;
/* functional template */

const __vue_is_functional_template__$t = undefined;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$E = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, createInjector, undefined, undefined);

var VcSkeleton = __vue_component__$E;

var script$s = {
  name: 'VcLargeQuickAction',
  components: {
    VcSkeleton,
    VcFocusArea,
    VcImage,
    VcLayout
  },
  props: {
    image: {
      type: [String, Object],
      required: true
    },
    title: {
      type: String,
      required: true
    },
    dataQa: {
      type: String,
      default: 'VcLargeQuickAction'
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$s = script$s;
/* template */

var __vue_render__$p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcLargeQuickAction",
    attrs: {
      "column": "",
      "align-center": "",
      "data-qa": _vm.dataQa
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.$emit('click');
      },
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm.isLoading ? _c('VcLayout', {
    attrs: {
      "align-center": "",
      "column": ""
    }
  }, [_c('VcSkeleton', {
    staticClass: "image-skeleton",
    attrs: {
      "type": "button",
      "width": "40",
      "height": "40"
    }
  }), _vm._v(" "), _c('VcSkeleton', {
    attrs: {
      "type": "list-item",
      "width": "100"
    }
  }), _vm._v(" "), _c('VcSkeleton', {
    attrs: {
      "type": "list-item",
      "width": "100"
    }
  })], 1) : _c('VcFocusArea', {
    staticClass: "imageBg",
    attrs: {
      "size": "sm"
    }
  }, [_c('VcImage', {
    staticClass: "image",
    attrs: {
      "image": _vm.image
    }
  })], 1), _vm._v("\n  " + _vm._s(_vm.title) + "\n")], 1);
};

var __vue_staticRenderFns__$p = [];
/* style */

const __vue_inject_styles__$s = function (inject) {
  if (!inject) return;
  inject("data-v-76ab0070_0", {
    source: ".VcLargeQuickAction[data-v-76ab0070]{font-size:12px;font-weight:var(--font-weight-medium);width:115px;max-width:115px;height:94px;padding:0 var(--size-value2) var(--size-value3) var(--size-value2);text-align:center;line-height:var(--size-value4);border-radius:var(--border-radius);cursor:pointer}.VcLargeQuickAction .imageBg[data-v-76ab0070]{flex-grow:0;margin:var(--size-value1) 2px}.VcLargeQuickAction .imageBg .image[data-v-76ab0070]{width:var(--size-value5);height:var(--size-value5)}.VcLargeQuickAction[data-v-76ab0070]:hover{background-color:rgba(0,0,0,.04)}.VcLargeQuickAction .image-skeleton[data-v-76ab0070]{margin-bottom:var(--size-value2);margin-top:var(--size-value1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$s = "data-v-76ab0070";
/* module identifier */

const __vue_module_identifier__$s = undefined;
/* functional template */

const __vue_is_functional_template__$s = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, createInjector, undefined, undefined);

var VcLargeQuickAction = __vue_component__$D;

var script$r = {
  name: 'VcSmallQuickAction',
  components: {
    VcSkeleton,
    VcTooltip,
    VcImage,
    VcLayout
  },
  props: {
    image: {
      type: [String, Object],
      required: true
    },
    title: {
      type: String,
      required: true
    },
    dataQa: {
      type: String,
      default: 'VcSmallQuickAction'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    tooltipProps: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    resizeObserver: undefined,
    showTooltip: false
  }),

  mounted() {
    this.resizeObserver = new ResizeObserver(this.measureSize);
    this.resizeObserver.observe(this.$refs.actionText);
  },

  destroyed() {
    var _this$resizeObserver;

    (_this$resizeObserver = this.resizeObserver) === null || _this$resizeObserver === void 0 ? void 0 : _this$resizeObserver.disconnect();
  },

  methods: {
    measureSize() {
      var _this$$refs$actionTex, _this$$refs$actionTex2;

      this.showTooltip = ((_this$$refs$actionTex = this.$refs.actionText) === null || _this$$refs$actionTex === void 0 ? void 0 : _this$$refs$actionTex.offsetWidth) < ((_this$$refs$actionTex2 = this.$refs.actionText) === null || _this$$refs$actionTex2 === void 0 ? void 0 : _this$$refs$actionTex2.scrollWidth);
    }

  }
};

/* script */
const __vue_script__$r = script$r;
/* template */

var __vue_render__$o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcSmallQuickAction",
    attrs: {
      "align-center": "",
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    staticClass: "VcSmallQuickAction--image"
  }, [_vm.isLoading ? _c('VcSkeleton', {
    attrs: {
      "type": "image",
      "width": "16",
      "height": "16"
    }
  }) : _c('VcImage', {
    attrs: {
      "image": _vm.image
    }
  })], 1), _vm._v(" "), _vm.isLoading ? _c('VcSkeleton', {
    attrs: {
      "type": "list-item",
      "width": "96",
      "height": "16"
    }
  }) : _vm._e(), _vm._v(" "), _c('VcTooltip', _vm._b({
    staticClass: "VcSmallQuickAction--tooltip"
  }, 'VcTooltip', Object.assign({}, _vm.tooltipProps, {
    content: _vm.title,
    disabled: !_vm.showTooltip
  }), false), [_c('div', {
    ref: "actionText",
    staticClass: "VcSmallQuickAction--title",
    class: {
      ellipsis: _vm.showTooltip
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])])], 1);
};

var __vue_staticRenderFns__$o = [];
/* style */

const __vue_inject_styles__$r = function (inject) {
  if (!inject) return;
  inject("data-v-3f480798_0", {
    source: ".VcSmallQuickAction[data-v-3f480798]{gap:var(--size-value2);width:162px}.VcSmallQuickAction--image[data-v-3f480798]{width:var(--size-value4);height:var(--size-value4)}.VcSmallQuickAction--tooltip[data-v-3f480798]{max-width:calc(100% - var(--size-value7))}.VcSmallQuickAction--title[data-v-3f480798]{font-size:13px;font-weight:var(--font-weight-medium);white-space:nowrap;overflow:hidden}.VcSmallQuickAction .ellipsis[data-v-3f480798]{text-overflow:ellipsis}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$r = "data-v-3f480798";
/* module identifier */

const __vue_module_identifier__$r = undefined;
/* functional template */

const __vue_is_functional_template__$r = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, createInjector, undefined, undefined);

var VcSmallQuickAction = __vue_component__$C;

var script$q = {
  name: 'VcQuickActions',
  components: {
    VcSkeleton,
    VcDropdown,
    VcSmallQuickAction,
    VcGroupedItems,
    VcButton,
    VcLargeQuickAction,
    VcLayout,
    VDivider: VDivider
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    buttonTitle: {
      type: String
    },
    largeActions: {
      type: Array,
      default: () => []
    },
    smallActions: {
      type: Array,
      default: () => []
    },
    nudgeRight: {
      type: [Number, String],
      default: 0
    },
    nudgeLeft: {
      type: [Number, String],
      default: 0
    },
    dataQa: {
      type: String,
      default: 'VcQuickActions'
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    skeletonLargeActions: Array(6).fill({
      isLoading: true,
      name: 'skeleton'
    }),
    skeletonSmallActions: [{
      items: Array(4).fill({
        isLoading: true,
        name: 'skeleton'
      })
    }, {
      items: Array(6).fill({
        isLoading: true,
        name: 'skeleton'
      })
    }, {
      items: Array(7).fill({
        isLoading: true,
        name: 'skeleton'
      })
    }, {
      items: Array(2).fill({
        isLoading: true,
        name: 'skeleton'
      })
    }]
  }),
  computed: {
    allSmallActions() {
      return this.smallActions.reduce((acc, group) => [...acc, ...group.items], []);
    }

  }
};

/* script */
const __vue_script__$q = script$q;
/* template */

var __vue_render__$n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcDropdown', {
    attrs: {
      "value": _vm.value,
      "data-qa": _vm.dataQa,
      "close-on-click": true,
      "max-height": "1000px",
      "offset-x": "",
      "top": "",
      "nudge-right": _vm.nudgeRight,
      "nudge-left": _vm.nudgeLeft
    },
    on: {
      "input": function (newValue) {
        return _vm.$emit('input', newValue);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (activatorObj) {
        return [_vm._t("activator", null, null, activatorObj)];
      }
    }], null, true)
  }, [_vm._v(" "), _c('VcLayout', {
    staticClass: "VcQuickActions",
    attrs: {
      "column": ""
    }
  }, [_c('VcLayout', {
    staticClass: "VcQuickActions--header",
    attrs: {
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_vm.isLoading ? _c('VcSkeleton', {
    staticClass: "VcQuickActions--skeleton-header",
    attrs: {
      "type": "button",
      "height": "16",
      "width": "109"
    }
  }) : _c('div', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _vm.buttonTitle ? _c('VcButton', {
    staticClass: "VcQuickActions--header--button",
    attrs: {
      "ghost": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onEditActionsClicked');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttonTitle) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('VcLayout', {
    staticClass: "VcQuickActions--large"
  }, _vm._l(_vm.isLoading ? _vm.skeletonLargeActions : _vm.largeActions, function (item) {
    return _c('VcLargeQuickAction', {
      key: item.title,
      attrs: {
        "tabindex": 0,
        "title": item.title,
        "image": item.image,
        "data-qa": "VcLargeQuickAction-" + item.name,
        "is-loading": item.isLoading
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('onLargeActionClicked', item);
        }
      }
    });
  }), 1), _vm._v(" "), _vm.largeActions && _vm.largeActions.length > 0 && _vm.smallActions && _vm.smallActions.length > 0 ? _c('v-divider', {
    staticClass: "VcQuickActions--divider"
  }) : _vm._e(), _vm._v(" "), _vm.smallActions && _vm.smallActions.length > 0 ? _c('VcGroupedItems', {
    staticClass: "VcQuickActions--small",
    attrs: {
      "item-groups": _vm.isLoading ? _vm.skeletonSmallActions : _vm.smallActions,
      "direction": "horizontal"
    },
    on: {
      "change": function (id) {
        return _vm.$emit('onSmallActionClicked', _vm.allSmallActions.find(function (item) {
          return item.id === id;
        }));
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (ref) {
        var group = ref.group;
        return [_c('span', {
          staticClass: "VcQuickActions--groupHeader"
        }, [_vm.isLoading ? _c('VcSkeleton', {
          staticClass: "VcQuickActions--skeleton-header-small-actions",
          attrs: {
            "type": "list-item",
            "width": "68"
          }
        }) : _c('span', [_vm._v(_vm._s(group.label))])], 1)];
      }
    }, {
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        return [_c('VcSmallQuickAction', _vm._b({
          attrs: {
            "is-loading": _vm.isLoading,
            "data-qa": "VcSmallQuickAction-" + item.name
          }
        }, 'VcSmallQuickAction', item, false))];
      }
    }], null, false, 3116046269)
  }) : _vm._e()], 1)], 1);
};

var __vue_staticRenderFns__$n = [];
/* style */

const __vue_inject_styles__$q = function (inject) {
  if (!inject) return;
  inject("data-v-41aa8fef_0", {
    source: ".VcQuickActions[data-v-41aa8fef]{padding:var(--size-value1) var(--size-value5);overflow:hidden}.VcQuickActions--header[data-v-41aa8fef]{height:var(--size-value12);font-size:15px;font-weight:var(--font-weight-large2);gap:var(--size-value2)}.VcQuickActions--header--button[data-v-41aa8fef]{padding:0!important}.VcQuickActions--large[data-v-41aa8fef]{padding:var(--size-value4) 0}.VcQuickActions--divider[data-v-41aa8fef]{transform:translateX(-24px);min-width:calc(100% + var(--size-value12))}.VcQuickActions--small[data-v-41aa8fef]{padding-top:var(--size-value3)}.VcQuickActions--small[data-v-41aa8fef]  .grouped-items__group__container__menu-item{border-radius:var(--border-radius)}.VcQuickActions--groupHeader[data-v-41aa8fef]{font-size:11px;font-weight:var(--font-weight-large);color:var(--gray-darken-3)}.VcQuickActions[data-v-41aa8fef]  .grouped-items__group__container__menu-item{height:var(--size-value10)}.VcQuickActions--skeleton-header[data-v-41aa8fef]{margin-top:var(--size-value1)}.VcQuickActions--skeleton-header-small-actions[data-v-41aa8fef]{margin-top:var(--size-value2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$q = "data-v-41aa8fef";
/* module identifier */

const __vue_module_identifier__$q = undefined;
/* functional template */

const __vue_is_functional_template__$q = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, createInjector, undefined, undefined);

var __vue_component__$B = __vue_component__$A;

var script$p = {
  name: 'VcDivider',
  render: function (createElement) {
    // `<v-divider></v-divider>`
    const props = {
      attrs: { ...this.$attrs
      },
      on: this.$listeners,
      ref: this.$vnode.data.ref
    };
    return createElement('v-divider', props, this.$slots.default);
  }
};

/* script */
const __vue_script__$p = script$p;
/* template */

/* style */

const __vue_inject_styles__$p = undefined;
/* scoped */

const __vue_scope_id__$p = "data-v-5bb74061";
/* module identifier */

const __vue_module_identifier__$p = undefined;
/* functional template */

const __vue_is_functional_template__$p = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);

var VcDivider = __vue_component__$z;

var script$o = {
  name: 'VcAccountMenu',
  components: {
    VcLayout,
    VcAvatar,
    VcDropdown,
    VcDivider,
    VcMenuItem
  },
  props: {
    name: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    colorId: {
      type: Number,
      required: true
    },
    imagePath: {
      type: [String, Object]
    },
    value: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    logoutLabel: {
      type: String
    },
    logoutIcon: {
      type: String
    },
    showLogout: {
      type: Boolean,
      default: true
    },
    dataQa: {
      type: String,
      default: 'VcAccountMenu'
    }
  },
  computed: {
    computedLogoutLabel() {
      return this.logoutLabel || this.$dst('ds.account.logout');
    },

    maxHeight() {
      return this.$vuetify.breakpoint.mdAndUp ? '500px' : '368px';
    }

  }
};

/* script */
const __vue_script__$o = script$o;
/* template */

var __vue_render__$m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcDropdown', {
    attrs: {
      "data-qa": _vm.dataQa,
      "value": _vm.value,
      "max-height": _vm.maxHeight
    },
    on: {
      "input": function (data) {
        return _vm.$emit('input', data);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (activatorObj) {
        return [_vm._t("activator", null, null, activatorObj)];
      }
    }], null, true)
  }, [_vm._v(" "), _c('VcLayout', {
    attrs: {
      "column": ""
    }
  }, [_c('VcLayout', {
    staticClass: "account-container",
    attrs: {
      "column": "",
      "align-center": "",
      "data-qa": _vm.dataQa + "-container"
    }
  }, [_c('VcAvatar', {
    attrs: {
      "name": _vm.name,
      "color-id": _vm.colorId,
      "image-path": _vm.imagePath,
      "size": "lg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "account-name"
  }, [_vm._v("\n        " + _vm._s(_vm.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "account-email"
  }, [_vm._v("\n        " + _vm._s(_vm.email) + "\n      ")])], 1), _vm._v(" "), _vm.items.length ? _c('VcDivider') : _vm._e(), _vm._v(" "), _vm.items.length ? _c('VcLayout', {
    staticClass: "account-items",
    attrs: {
      "column": "",
      "align-start": ""
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('VcMenuItem', _vm._b({
      key: item.event,
      staticClass: "account-item",
      attrs: {
        "size": "sm",
        "data-qa": _vm.dataQa + "-" + item.event
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('click', item.event);
        }
      }
    }, 'VcMenuItem', item, false));
  }), 1) : _vm._e(), _vm._v(" "), _vm.showLogout ? _c('VcLayout', {
    attrs: {
      "column": ""
    }
  }, [_c('VcDivider'), _vm._v(" "), _c('VcMenuItem', {
    staticClass: "account-item logout-item",
    attrs: {
      "label": _vm.computedLogoutLabel,
      "icon": _vm.logoutIcon,
      "size": "sm",
      "data-qa": _vm.dataQa + "-logout"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click', 'logout');
      }
    }
  })], 1) : _vm._e()], 1)], 1);
};

var __vue_staticRenderFns__$m = [];
/* style */

const __vue_inject_styles__$o = function (inject) {
  if (!inject) return;
  inject("data-v-e8b5952a_0", {
    source: ".account-container[data-v-e8b5952a]{min-width:264px;padding:var(--size-value5) var(--size-value3);overflow:hidden}.account-name[data-v-e8b5952a]{font-size:var(--font-size-small2);font-weight:var(--font-weight-large);line-height:var(--size-value5);max-width:264px;text-align:center;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2}.account-email[data-v-e8b5952a]{font-size:var(--font-size-xx-small);font-weight:var(--font-weight-medium)}.account-items[data-v-e8b5952a]{padding:var(--size-value2) 0}.account-item[data-v-e8b5952a]{width:100%}.account-item[data-v-e8b5952a]:hover{cursor:pointer}.logout-item[data-v-e8b5952a]{min-height:50px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$o = "data-v-e8b5952a";
/* module identifier */

const __vue_module_identifier__$o = undefined;
/* functional template */

const __vue_is_functional_template__$o = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, createInjector, undefined, undefined);

var VcAccountMenu = __vue_component__$y;

var script$n = {
  name: 'VcSearchLayout',
  components: {
    VcAvatar,
    VcIcon,
    VcLayout,
    VcLoader,
    VcEmptyState,
    VcGroupedItems,
    VcDropdown,
    VcSearchBar,
    VDivider: VDivider
  },
  props: {
    /**
      Sets if the drops down is closed or opened
     */
    value: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    emptyStateTitle: {
      type: String
    },

    /**
     * When this is turned on, the search expression will be marked bold in the search results
     */
    emptyStateSubtitle: {
      type: String
    },
    emptyStateImage: {
      type: [String, Object]
    },
    dataQa: {
      type: String,
      default: 'VcSearchLayout'
    }
  },
  data: () => ({
    searchValue: ''
  }),
  computed: {
    selectedEmptyStateTitle() {
      return this.emptyStateTitle || this.$dst('ds.search_layout.empty_state.title', {
        search_expression: this.searchValue
      });
    },

    selectedEmptyStateSubtitle() {
      return this.emptyStateSubtitle || this.$dst('ds.search_layout.empty_state.subtitle');
    },

    viewAllText() {
      return this.$dst('ds.search_layout.view_all', {
        search_expression: `<em class="dsSearchHighlight">${this.searchValue}</em>`
      });
    },

    itemGroupsBolded() {
      return this.$attrs.itemGroups;
    }

  },
  methods: {
    onSearch(value) {
      this.$emit('onSearch', value);
      this.searchValue = value;
    },

    onItemSelected(id) {
      this.$emit('onItemClicked', this.getSelectedItem(id));
    },

    getSelectedItem(id) {
      for (const group of this.$attrs.itemGroups) {
        for (const item of group.items) {
          if (item.id === id) return item;
        }
      }
    }

  }
};

/* script */
const __vue_script__$n = script$n;
/* template */

var __vue_render__$l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcDropdown', {
    attrs: {
      "value": _vm.value,
      "max-height": "595px",
      "data-qa": _vm.dataQa
    },
    on: {
      "input": function (value) {
        return _vm.$emit('onDropdownChange', value);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function () {
        return [_c('VcSearchBar', _vm._b({
          attrs: {
            "size": "small",
            "data-qa": _vm.dataQa + "-searchBar"
          },
          on: {
            "search": _vm.onSearch
          }
        }, 'VcSearchBar', _vm.$attrs, false))];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_c('VcLayout', {
          attrs: {
            "column": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('onSeeAllClicked');
            }
          }
        }, [_c('v-divider'), _vm._v(" "), !_vm.isSearching && _vm.$attrs.itemGroups && _vm.$attrs.itemGroups.length > 0 ? _c('VcLayout', {
          staticClass: "viewAll",
          attrs: {
            "justify-center": "",
            "flex-wrap": "",
            "align-center": ""
          }
        }, [_c('VcIcon', {
          attrs: {
            "small": "",
            "color": "var(--blue)"
          }
        }, [_vm._v(" $magnify_glass ")]), _vm._v(" "), _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.viewAllText)
          }
        })], 1) : _vm._e()], 1)];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('VcLayout', {
    staticClass: "searchResults",
    class: {
      loadingState: _vm.isSearching,
      emptyState: !_vm.$attrs.itemGroups || _vm.$attrs.itemGroups.length === 0
    },
    attrs: {
      "flex-wrap": ""
    }
  }, [_vm.isSearching ? _c('VcLoader') : _vm.$attrs.itemGroups && _vm.$attrs.itemGroups.length > 0 ? _c('VcGroupedItems', {
    attrs: {
      "item-groups": _vm.itemGroupsBolded,
      "show-dividers": "",
      "group-class": "searchLayoutGroup",
      "item-class": "searchLayoutItem",
      "data-qa": _vm.dataQa + "-groupedItems",
      "no-focus-border": ""
    },
    on: {
      "change": _vm.onItemSelected
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (data) {
        return [_c('div', {
          staticClass: "groupHeader"
        }, [_vm._v("\n          " + _vm._s(data.group.label) + "\n        ")])];
      }
    }, {
      key: "item",
      fn: function (data) {
        return [_vm._t("searchItem", function () {
          return [!data.item.showMore ? _c('VcLayout', {
            staticClass: "searchItem"
          }, [data.item.imagePath ? _c('VcAvatar', _vm._b({
            attrs: {
              "size": "sm"
            }
          }, 'VcAvatar', data.item, false)) : _vm._e(), _vm._v(" "), _c('VcLayout', {
            attrs: {
              "column": ""
            }
          }, [_c('span', {
            staticClass: "searchItem--top",
            domProps: {
              "innerHTML": _vm._s(_vm.$options.filters.dsHighlight(data.item.name, _vm.searchValue))
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "searchItem--bottom",
            domProps: {
              "innerHTML": _vm._s(_vm.$options.filters.dsHighlight(data.item.details, _vm.searchValue))
            }
          })])], 1) : _c('VcLayout', {
            staticClass: "searchItem showMore"
          }, [_vm._v("\n            " + _vm._s(_vm.$dst('ds.search_layout.show_more')) + "\n          ")])];
        }, {
          "item": data.item
        })];
      }
    }], null, true)
  }) : _c('VcEmptyState', {
    attrs: {
      "size": "sm",
      "title": _vm.selectedEmptyStateTitle,
      "subtitle": _vm.selectedEmptyStateSubtitle,
      "image": _vm.emptyStateImage
    }
  })], 1)], 1);
};

var __vue_staticRenderFns__$l = [];
/* style */

const __vue_inject_styles__$n = function (inject) {
  if (!inject) return;
  inject("data-v-af9ac650_0", {
    source: ".searchResults[data-v-af9ac650]{letter-spacing:.02rem}.searchResults .groupHeader[data-v-af9ac650]{font-size:10px;font-weight:var(--font-weight-large);padding-inline-start:var(--size-value4);color:var(--gray-darken-3)}.searchResults[data-v-af9ac650]  .searchLayoutGroup{padding-top:var(--size-value2);padding-bottom:var(--size-value2)}.searchResults[data-v-af9ac650]  .searchLayoutItem{padding-top:var(--size-value7);padding-bottom:var(--size-value6)}.searchResults[data-v-af9ac650]  .searchLayoutItem:has(.showMore){padding:0;height:auto}.searchResults[data-v-af9ac650]  em.dsSearchHighlight--default{font-weight:var(--font-weight-large2);line-height:var(--size-value6);font-style:initial}.searchResults .searchItem[data-v-af9ac650]{font-size:12px;font-weight:var(--font-weight-medium);padding-inline-start:var(--size-value4);padding:6px var(--size-value5);gap:var(--size-value4)}.searchResults .searchItem--top[data-v-af9ac650]{font-size:13px;line-height:24px}.searchResults .searchItem--bottom[data-v-af9ac650]{line-height:24px;color:var(--gray-darken-4)}.searchResults .searchItem.showMore[data-v-af9ac650]{padding:var(--size-value2) var(--size-value5);color:var(--blue);font-weight:var(--font-weight-medium2)}.loadingState[data-v-af9ac650]{min-height:291px;align-content:center;justify-content:center}.emptyState[data-v-af9ac650],.loadingState[data-v-af9ac650]{padding:var(--size-value4) 0}.viewAll[data-v-af9ac650]{color:var(--blue);font-size:13px;font-weight:var(--font-weight-medium);padding:var(--size-value4) 0;gap:var(--size-value3);cursor:pointer}[data-v-af9ac650] .grouped-items__group__container__menu-item:focus,[data-v-af9ac650] .grouped-items__group__container__menu-item:focus-visible{outline:3px solid var(--v-secondary-lighten1);outline-offset:-3px;border-radius:6px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$n = "data-v-af9ac650";
/* module identifier */

const __vue_module_identifier__$n = undefined;
/* functional template */

const __vue_is_functional_template__$n = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);

var VcSearchLayout = __vue_component__$x;

var script$m = {
  name: 'VcWideTopMenuBar',
  components: {
    VcSkeleton,
    VcList,
    VcDropdown,
    VcSearchLayout,
    VcIcon,
    VcLayout,
    VcAvatar,
    VcAccountMenu,
    VcButton,
    VcBadge
  },
  props: {
    name: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    colorId: {
      type: Number,
      required: true
    },
    imagePath: {
      type: [String, Object]
    },
    accountMenuItems: {
      type: Array,
      validator: items => items.length === 0 || items.every(item => item.label && item.icon && item.event)
    },
    upgradeButtonLabel: {
      type: String
    },
    helpButtonLabel: {
      type: String,
      required: true
    },
    backButtonLabel: {
      type: String
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    helpMenuItems: {
      type: Array,
      default: () => [],
      validator: items => items.every(item => item.label && item.event)
    },
    notificationBadge: {
      type: Number,
      default: undefined
    },
    logoutLabel: {
      type: String
    },
    logoutIcon: {
      type: String
    },
    showLogout: {
      type: Boolean,
      default: true
    },
    isNotificationsDialogOpen: {
      type: Boolean,
      default: false
    },

    /**
     * Indicates if the component is in loading state, which will display skeleton loaders
     */
    isLoading: {
      type: Boolean,
      default: false
    },

    /**
     * This prop is passed down to VcSearchLayout
     */
    isSearching: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcWideTopMenuBar'
    }
  },
  data: () => ({
    isAccountMenuOpen: false,
    width: undefined,
    resizeObserver: null
  }),

  mounted() {
    this.resizeObserver = new ResizeObserver(this.setComponentWidth);
    this.resizeObserver.observe(this.$refs.compRoot.$el);
  },

  methods: {
    onAccountButtonClicked() {
      this.$emit('onAccountButtonClicked');
      this.isAccountMenuOpen = !this.isAccountMenuOpen;
    },

    setComponentWidth() {
      var _this$$refs$compRoot;

      this.width = (_this$$refs$compRoot = this.$refs.compRoot) === null || _this$$refs$compRoot === void 0 ? void 0 : _this$$refs$compRoot.$el.clientWidth;
    },

    onAccountMenuClick(value) {
      this.$emit('onAccountMenuClick', value);
      this.isAccountMenuOpen = !this.isAccountMenuOpen;
    }

  }
};

/* script */
const __vue_script__$m = script$m;
/* template */

var __vue_render__$k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    ref: "compRoot",
    staticClass: "VcWideTopMenuBar",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    staticClass: "topBarSection leftSection",
    attrs: {
      "justify-end": ""
    }
  }, [_vm.showBackButton ? _c('VcLayout', {
    staticClass: "backButtonSection"
  }, [!_vm.isLoading ? _c('div', {
    attrs: {
      "data-qa": _vm.dataQa + "-backButton"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onBackButtonClicked');
      }
    }
  }, [_c('VcIcon', {
    attrs: {
      "color": "var(--gray-darken-3)",
      "size": "var(--font-size-small2)"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.rtl ? '$chevron_right' : '$chevron_left') + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "backButtonLabel"
  }, [_vm._v(" " + _vm._s(_vm.backButtonLabel) + " ")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('VcLayout', {
    staticClass: "topBarSection searchSection"
  }, [_vm.isLoading ? _c('VcSkeleton', {
    attrs: {
      "type": "avatar"
    }
  }) : _vm._e(), _vm._v(" "), _vm.isLoading ? _c('VcSkeleton', {
    attrs: {
      "type": "list-item",
      "width": "100%"
    }
  }) : _c('VcSearchLayout', _vm._g(_vm._b({
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, 'VcSearchLayout', _vm.$attrs, false), _vm.$listeners))], 1)], 1), _vm._v(" "), _c('VcLayout', {
    staticClass: "topBarSection rightSection",
    attrs: {
      "flex-wrap": "",
      "justify-end": ""
    }
  }, [[_vm.isLoading && _vm.$slots.customMenuItems ? _c('VcSkeleton', {
    attrs: {
      "type": "avatar"
    }
  }) : _vm._t("customMenuItems")], _vm._v(" "), _vm.isLoading ? _c('VcSkeleton', {
    attrs: {
      "type": "avatar"
    }
  }) : _c('VcDropdown', {
    attrs: {
      "max-height": "700px",
      "data-qa": _vm.dataQa + "-notificationsPaneDropdown"
    },
    on: {
      "input": function (data) {
        return _vm.$emit('onNotificationsDropdownToggle', data);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        ref.on;
        ref.attrs;
        return [_c('VcBadge', {
          attrs: {
            "offset-x": 15,
            "offset-y": 15,
            "badge-text": _vm.notificationBadge,
            "data-qa": _vm.dataQa + "-notificationsBadge"
          }
        }, [_c('VcButton', {
          staticClass: "d-flex specialButtonHeight notifications-button",
          attrs: {
            "ghost": "",
            "flavor": "secondary",
            "data-qa": _vm.dataQa + "-notifications",
            "width": 32
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('onNotificationsBadgeClicked');
            }
          },
          scopedSlots: _vm._u([{
            key: "prepend",
            fn: function () {
              return [_c('VcIcon', {
                staticClass: "notifications-icon",
                attrs: {
                  "size": "20"
                }
              }, [_vm._v(" $notifications ")])];
            },
            proxy: true
          }], null, true)
        })], 1)];
      }
    }]),
    model: {
      value: _vm.isNotificationsDialogOpen,
      callback: function ($$v) {
        _vm.isNotificationsDialogOpen = $$v;
      },
      expression: "isNotificationsDialogOpen"
    }
  }, [_vm._v(" "), _vm._t("notificationsPane")], 2), _vm._v(" "), _vm.isLoading ? _c('VcSkeleton', {
    attrs: {
      "type": "avatar"
    }
  }) : _vm._e(), _vm._v(" "), _vm.isLoading && _vm.width > 1200 ? _c('VcSkeleton', {
    attrs: {
      "type": "list-item",
      "width": "32"
    }
  }) : !_vm.isLoading ? _c('VcDropdown', {
    attrs: {
      "data-qa": _vm.dataQa + "-helpMenu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        var attrs = ref.attrs;
        return [_c('VcButton', _vm._g(_vm._b({
          staticClass: "helpButton specialButtonHeight",
          attrs: {
            "flavor": "secondary",
            "ghost": "",
            "data-qa": _vm.dataQa + "-help",
            "width": _vm.width > 1200 ? '' : 32
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('onHelpButtonClicked');
            }
          },
          scopedSlots: _vm._u([{
            key: "prepend",
            fn: function () {
              return [_c('VcIcon', {
                attrs: {
                  "size": "20"
                }
              }, [_vm._v(" $help ")])];
            },
            proxy: true
          }, {
            key: "default",
            fn: function () {
              return [_vm.width > 1200 ? _c('div', {
                staticClass: "helpButton--label"
              }, [_vm._v("\n              " + _vm._s(_vm.helpButtonLabel) + "\n            ")]) : _vm._e()];
            },
            proxy: true
          }], null, true)
        }, 'VcButton', attrs, false), on))];
      }
    }])
  }, [_vm._v(" "), _vm.helpMenuItems && _vm.helpMenuItems.length > 0 ? _c('VcList', {
    attrs: {
      "items": _vm.helpMenuItems,
      "data-qa": _vm.dataQa + "-helpMenuList"
    },
    on: {
      "select": function (value) {
        return _vm.$emit('onHelpItemClicked', _vm.helpMenuItems.find(function (item) {
          return item.identifier === value;
        }));
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (item) {
        return [_c('span', {
          staticClass: "helpMenuItem"
        }, [_vm._v(_vm._s(item.label))])];
      }
    }], null, false, 1212531349)
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.isLoading ? _c('VcSkeleton', {
    attrs: {
      "type": "avatar"
    }
  }) : _vm._e(), _vm._v(" "), _vm.isLoading && _vm.width > 784 ? _c('VcSkeleton', {
    attrs: {
      "type": "list-item",
      "width": "59"
    }
  }) : !_vm.isLoading && _vm.upgradeButtonLabel ? _c('VcButton', {
    staticClass: "upgradeButton specialButtonHeight",
    attrs: {
      "outlined": "",
      "small": "",
      "data-qa": _vm.dataQa + "-upgrade"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onUpgradeButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "color": "var(--v-secondary-base)"
          }
        }, [_vm._v(" $upgrade ")])];
      },
      proxy: true
    }])
  }, [_vm._v("\n      " + _vm._s(_vm.width > 784 ? _vm.upgradeButtonLabel : '') + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.isLoading ? _c('VcSkeleton', {
    attrs: {
      "type": _vm.width > 1040 ? 'list-item' : 'avatar',
      "width": _vm.width > 1040 ? '' : 59
    }
  }) : _c('VcAccountMenu', {
    attrs: {
      "items": _vm.accountMenuItems,
      "color-id": _vm.colorId,
      "email": _vm.email,
      "name": _vm.name,
      "image-path": _vm.imagePath,
      "logout-label": _vm.logoutLabel,
      "logout-icon": _vm.logoutIcon,
      "show-logout": _vm.showLogout,
      "data-qa": _vm.dataQa + "-accountMenu"
    },
    on: {
      "input": function (value) {
        return _vm.$emit('onAccountMenuChange', value);
      },
      "click": _vm.onAccountMenuClick
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        ref.on;
        ref.attrs;
        return [_c('VcButton', {
          staticClass: "accountMenuButton specialButtonHeight",
          attrs: {
            "flavor": "secondary",
            "ghost": "",
            "data-qa": _vm.dataQa + "-account"
          },
          on: {
            "click": _vm.onAccountButtonClicked
          },
          scopedSlots: _vm._u([{
            key: "prepend",
            fn: function () {
              return [_c('VcAvatar', {
                attrs: {
                  "name": _vm.name,
                  "color-id": _vm.colorId,
                  "image-path": _vm.imagePath,
                  "size": "x-sm",
                  "data-qa": _vm.dataQa + "-accountAvatar"
                }
              })];
            },
            proxy: true
          }, {
            key: "default",
            fn: function () {
              return [_vm.width > 1040 ? _c('div', {
                staticClass: "accountName"
              }, [_vm._v("\n              " + _vm._s(_vm.name) + "\n            ")]) : _vm._e()];
            },
            proxy: true
          }, {
            key: "append",
            fn: function () {
              return [_c('VcIcon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v(" $chevron_down ")])];
            },
            proxy: true
          }], null, true)
        })];
      }
    }]),
    model: {
      value: _vm.isAccountMenuOpen,
      callback: function ($$v) {
        _vm.isAccountMenuOpen = $$v;
      },
      expression: "isAccountMenuOpen"
    }
  })], 2)], 1);
};

var __vue_staticRenderFns__$k = [];
/* style */

const __vue_inject_styles__$m = function (inject) {
  if (!inject) return;
  inject("data-v-99d3204a_0", {
    source: ".VcWideTopMenuBar[data-v-99d3204a]{width:100%;height:52px;box-shadow:var(--shadow-1);padding-top:var(--size-value2);padding-bottom:var(--size-value2);padding-inline-end:var(--size-value1);padding-inline-start:var(--size-value1);background-color:var(--white);column-gap:var(--size-value1)}.VcWideTopMenuBar .specialButtonHeight[data-v-99d3204a]{height:var(--size-value8)}.topBarSection[data-v-99d3204a]{align-items:center}.leftSection[data-v-99d3204a]{flex-basis:66%}.searchSection[data-v-99d3204a]{flex-basis:50%;flex-grow:0;gap:var(--size-value2)}.rightSection[data-v-99d3204a]{gap:var(--size-value2);flex-basis:33%;min-width:fit-content}[data-v-99d3204a] .v-badge__badge{font-weight:var(--font-weight-medium2)}.VcWideTopMenuBar .topBarSection.rightSection .helpButton[data-v-99d3204a]{font-weight:var(--font-weight-medium2);padding:0 var(--size-value3)}.VcWideTopMenuBar .topBarSection.rightSection .helpButton--label[data-v-99d3204a]{padding-inline-start:var(--size-value2)}.helpMenuItem[data-v-99d3204a]{font-size:13px;font-weight:var(--font-weight-medium)}.VcWideTopMenuBar .topBarSection.rightSection .accountMenuButton[data-v-99d3204a]{padding:0 var(--size-value2)}.VcWideTopMenuBar .topBarSection.rightSection .upgradeButton[data-v-99d3204a]{padding:0 var(--size-value1)}.accountName[data-v-99d3204a]{font-size:12px;font-weight:var(--font-weight-medium2);line-height:var(--size-value6);padding-inline-start:var(--size-value2);text-overflow:ellipsis;max-width:150px;white-space:nowrap;overflow:hidden}.backButtonSection[data-v-99d3204a]{margin-inline-start:var(--size-value3);align-items:center}.backButtonSection[data-v-99d3204a] :hover{cursor:pointer}.backButtonLabel[data-v-99d3204a]{font-size:13px;font-weight:var(--font-weight-medium2);margin-inline-start:var(--size-value1);color:var(--gray-darken-4);line-height:var(--size-value6)}.backButtonLabel[data-v-99d3204a]:hover{text-decoration:underline}.VcWideTopMenuBar .topBarSection.rightSection .notifications-button[data-v-99d3204a]{padding:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$m = "data-v-99d3204a";
/* module identifier */

const __vue_module_identifier__$m = undefined;
/* functional template */

const __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);

var __vue_component__$w = __vue_component__$v;

var script$l = {
  name: 'VcOverlay',
  render: function (createElement) {
    // `<v-overlay></v-overlay>`
    const props = { ...this.$props,
      ...this.$attrs
    };
    return createElement('v-overlay', {
      props,
      on: this.$listeners
    });
  }
};

/* script */
const __vue_script__$l = script$l;
/* template */

/* style */

const __vue_inject_styles__$l = undefined;
/* scoped */

const __vue_scope_id__$l = undefined;
/* module identifier */

const __vue_module_identifier__$l = undefined;
/* functional template */

const __vue_is_functional_template__$l = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);

var __vue_component__$u = __vue_component__$t;

var script$k = {
  name: 'VcHeaderSort',
  components: {
    VcIcon
  },
  props: {
    direction: {
      type: String,
      default: 'none',
      validator: value => ['none', 'asc', 'desc'].includes(value)
    },
    hover: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcHeaderSort'
    }
  },
  computed: {
    currentIcon() {
      switch (this.direction) {
        case 'none':
          return this.hover ? '$table_sort_asc_hover' : '$table_sort_default';

        case 'asc':
          return this.hover ? '$table_sort_asc_hover' : '$table_sort_asc';

        case 'desc':
          return this.hover ? '$table_sort_desc_hover' : '$table_sort_desc';

        default:
          console.warn('currentIcon could not be determined since direction has a different value than expected, possible values are: none, asc, desc, value passed is: ' + this.direction);
          return '';
      }
    },

    currentColor() {
      switch (this.direction) {
        case 'none':
          return 'var(--gray)';

        case 'asc':
        case 'desc':
          return 'var(--v-secondary-base)';

        default:
          console.warn('currentIcon could not be determined since direction has a different value than expected, possible values are: none, asc, desc, value passed is: ' + this.direction);
          return '';
      }
    }

  }
};

/* script */
const __vue_script__$k = script$k;
/* template */

var __vue_render__$j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcIcon', {
    attrs: {
      "small": "",
      "color": _vm.currentColor,
      "data-qa": _vm.dataQa
    }
  }, [_vm._v("\n  " + _vm._s(_vm.currentIcon) + "\n")]);
};

var __vue_staticRenderFns__$j = [];
/* style */

const __vue_inject_styles__$k = undefined;
/* scoped */

const __vue_scope_id__$k = "data-v-c357edc0";
/* module identifier */

const __vue_module_identifier__$k = undefined;
/* functional template */

const __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

var VcHeaderSort = __vue_component__$s;

var script$j = {
  name: 'VcColumnHeader',
  components: {
    VcHeaderSort,
    VcIcon,
    VcLayout,
    VcImage
  },
  model: {
    prop: 'direction'
  },
  props: {
    /**
     * The "behind the scenes" value of the represented data, used for logical decisions made on this data
     */
    value: {
      type: [String, Number],
      required: true
    },

    /**
     * Value to be displayed, localized
     */
    display: {
      type: [String, Boolean],
      required: true
    },

    /**
     * The type of display the should be used to express the value in "display"
     */
    type: {
      type: String,
      default: 'text',
      validator: value => ['text', 'icon', 'image', 'avatar', 'tag'].includes(value)
    },
    isSortable: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'none',
      validator: value => ['none', 'asc', 'desc'].includes(value)
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcColumnHeader'
    }
  },
  data: () => ({
    hover: false
  }),
  methods: {
    onClick() {
      if (this.isSortable) {
        this.$emit('input', this.getNextDirection());
      }
    },

    getNextDirection() {
      switch (this.direction) {
        case 'none':
          return 'asc';

        case 'asc':
          return 'desc';

        case 'desc':
          return 'asc';
      }
    }

  }
};

/* script */
const __vue_script__$j = script$j;
/* template */

var __vue_render__$i = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcColumnHeader",
    class: (_obj = {
      sortable: _vm.isSortable,
      loading: _vm.isLoading
    }, _obj['type-' + _vm.type] = true, _obj),
    attrs: {
      "align-center": "",
      "justify-center": ['avatar', 'icon', 'image'].includes(_vm.type),
      "data-qa": _vm.dataQa
    },
    on: {
      "click": _vm.onClick,
      "mouseenter": function ($event) {
        _vm.hover = true;
      },
      "mouseleave": function ($event) {
        _vm.hover = false;
      }
    }
  }, [_vm._t("default", function () {
    return [_vm.type === 'text' && !_vm.isLoading ? _c('div', {
      staticClass: "VcColumnHeader--text"
    }, [_vm._v("\n      " + _vm._s(_vm.display) + "\n    ")]) : _vm._e(), _vm._v(" "), !_vm.isLoading && (_vm.type === 'avatar' || _vm.type === 'icon') ? _c('VcLayout', {
      attrs: {
        "justify-center": ""
      }
    }, [_c('VcIcon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.display))])], 1) : _vm._e(), _vm._v(" "), !_vm.isLoading && _vm.type === 'image' ? _c('VcLayout', {
      attrs: {
        "justify-center": ""
      }
    }, [_c('VcImage', {
      attrs: {
        "small": "",
        "image": _vm.display
      }
    })], 1) : _vm._e()];
  }, {
    "data": _vm.$props
  }), _vm._v(" "), _vm.isSortable && !_vm.isLoading ? _c('VcLayout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('VcHeaderSort', {
    attrs: {
      "direction": _vm.direction,
      "hover": _vm.hover
    }
  })], 1) : _vm._e()], 2);
};

var __vue_staticRenderFns__$i = [];
/* style */

const __vue_inject_styles__$j = function (inject) {
  if (!inject) return;
  inject("data-v-20b7d760_0", {
    source: ".VcColumnHeader[data-v-20b7d760]{height:var(--size-value9);padding:0 var(--size-value4);color:var(--gray-darken-5);font-size:10px;font-weight:var(--font-weight-large);background-color:var(--gray-lighten-4);border-bottom:var(--gray-lighten-2) solid 1px}.VcColumnHeader--text[data-v-20b7d760]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.VcColumnHeader.sortable[data-v-20b7d760]:hover{cursor:pointer;background:rgba(0,0,0,.04)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$j = "data-v-20b7d760";
/* module identifier */

const __vue_module_identifier__$j = undefined;
/* functional template */

const __vue_is_functional_template__$j = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, createInjector, undefined, undefined);

var VcColumnHeader = __vue_component__$r;

var script$i = {
  name: 'VcTableFooter',
  components: {
    VcSelectField,
    VcIcon,
    VcButton,
    VcLayout,
    VSkeletonLoader: VSkeletonLoader
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Object,
      required: true
    },
    itemsPerPageOptions: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcTableFooter'
    }
  }
};

/* script */
const __vue_script__$i = script$i;
/* template */

var __vue_render__$h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcTableFooter",
    attrs: {
      "align-center": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    attrs: {
      "justify-end": "",
      "align-center": ""
    }
  }, [_vm.isLoading ? _c('VSkeletonLoader', {
    staticClass: "VcTableFooter--skeleton",
    attrs: {
      "type": "list-item",
      "data-qa": _vm.dataQa + "-skeleton"
    }
  }) : _c('div', [_vm._v("\n      " + _vm._s(_vm.$dst('ds.table.footer.rows_per_page')) + "\n    ")]), _vm._v(" "), !_vm.isLoading ? _c('VcSelectField', {
    staticClass: "VcTableFooter--itemsPerPage",
    attrs: {
      "items": _vm.itemsPerPageOptions,
      "pre-selection": _vm.itemsPerPage,
      "disabled": _vm.disabled,
      "size": "medium",
      "top": "",
      "data-qa": _vm.dataQa + "-itemsPerPage"
    },
    on: {
      "selection-changed": function (value) {
        return _vm.$emit('onSelectionChanged', value);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.isLoading ? _c('VSkeletonLoader', {
    staticClass: "VcTableFooter--buttonSkeleton",
    attrs: {
      "type": "image",
      "min-width": "20",
      "width": "20",
      "height": "20"
    }
  }) : _c('VcButton', {
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.disabled || _vm.currentPage <= 1,
      "show-disabled-background": false,
      "data-qa": _vm.dataQa + "-backBtn"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onBackButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "size": "16",
            "color": "var(--gray-darken-2)"
          }
        }, [_vm._v(" $chevron_left ")])];
      },
      proxy: true
    }])
  }), _vm._v(" "), _vm.isLoading ? _c('VSkeletonLoader', {
    staticClass: "VcTableFooter--skeleton",
    attrs: {
      "type": "list-item"
    }
  }) : _c('div', [_vm._v("\n      " + _vm._s(_vm.$dst('ds.table.footer.pages', {
    from_page: _vm.currentPage,
    total_pages: _vm.totalPages
  })) + "\n    ")]), _vm._v(" "), _vm.isLoading ? _c('VSkeletonLoader', {
    staticClass: "VcTableFooter--buttonSkeleton",
    attrs: {
      "type": "image",
      "min-width": "20",
      "width": "20",
      "height": "20"
    }
  }) : _c('VcButton', {
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.disabled || _vm.currentPage >= _vm.totalPages,
      "show-disabled-background": false,
      "data-qa": _vm.dataQa + "-nextBtn"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onNextButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "size": "16",
            "color": "var(--gray-darken-2)"
          }
        }, [_vm._v(" $chevron_right ")])];
      },
      proxy: true
    }])
  })], 1)], 1);
};

var __vue_staticRenderFns__$h = [];
/* style */

const __vue_inject_styles__$i = function (inject) {
  if (!inject) return;
  inject("data-v-a3ceb754_0", {
    source: ".VcTableFooter[data-v-a3ceb754]{font-size:13px;font-weight:var(--font-weight-medium);color:var(--gray-darken-5);height:var(--size-value12);background-color:#fff;padding:0 var(--size-value5);border-top:1px solid var(--gray-lighten-2)}.VcTableFooter--skeleton[data-v-a3ceb754]{min-width:137px}.VcTableFooter--skeleton[data-v-a3ceb754]  .v-skeleton-loader__text{height:20px}.VcTableFooter--buttonSkeleton[data-v-a3ceb754]{margin-inline-start:var(--size-value3)}.VcTableFooter--itemsPerPage[data-v-a3ceb754]{max-height:32px;max-width:80px;margin-inline-start:var(--size-value2);margin-inline-end:var(--size-value2)}.VcTableFooter--itemsPerPage[data-v-a3ceb754]  .v-select__selections{font-size:13px;max-height:var(--size-value13)!important}.VcTableFooter--itemsPerPage[data-v-a3ceb754]  .v-input__slot{padding-inline-end:2px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$i = "data-v-a3ceb754";
/* module identifier */

const __vue_module_identifier__$i = undefined;
/* functional template */

const __vue_is_functional_template__$i = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, createInjector, undefined, undefined);

var VcTableFooter = __vue_component__$q;

/**
 * @component VcCheckboxColumnHeader
 * @description Specialized column header with checkbox for selecting/deselecting all table items.
 *
 * States: checked (all selected), unchecked (none selected), indeterminate (some selected).
 * When indeterminate, clicking always clears selection for intuitive UX.
 */

var script$h = {
  name: 'VcCheckboxColumnHeader',
  components: {
    VcGroupedItems,
    VcDropdown,
    VcCheckbox,
    VcIcon,
    VcLayout,
    VcLoader
  },
  props: {
    /**
     * Whether checkbox is checked.
     * When indeterminate, set to true to ensure proper behavior when clicked.
     */
    isChecked: {
      type: Boolean,
      default: false
    },

    /**
     * Whether checkbox is indeterminate (some items selected).
     * When true, clicking will always emit false regardless of isChecked.
     */
    isIndeterminate: {
      type: Boolean,
      default: false
    },

    /**
     * Shows loader instead of checkbox when true.
     */
    isLoading: {
      type: Boolean,
      default: false
    },

    /**
     * Data-qa attribute for testing.
     */
    dataQa: {
      type: String,
      default: 'VcCheckboxColumnHeader'
    },

    /**
     * Dropdown options for the checkbox.
     * Format: [{ label, id, items: [{ id, label }] }]
     */
    checkboxOptions: {
      type: Array,
      default: () => []
    },

    /**
     * Whether checkbox is disabled.
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isCheckboxDropdownOpen: false
  }),
  methods: {
    /**
     * Handles checkbox change events.
     * Always emits false when indeterminate, otherwise emits the new value.
     */
    onCheckboxChange(value) {
      // When in indeterminate state, we want to always emit false
      if (this.isIndeterminate) {
        this.$emit('onSelectAllChanged', false);
      } else {
        this.$emit('onSelectAllChanged', value);
      }
    },

    /**
     * Handles dropdown option clicks.
     */
    onCheckboxOptionClicked(option) {
      this.isCheckboxDropdownOpen = false;
      this.$emit('onCheckboxOptionClicked', option);
    }

  }
};

/* script */
const __vue_script__$h = script$h;
/* template */

var __vue_render__$g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcCheckboxColumnHeader type-checkbox",
    class: {
      loading: _vm.isLoading
    },
    attrs: {
      "align-center": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    staticClass: "VcCheckboxColumnHeader__checkbox-wrapper align-center"
  }, [_vm.isLoading ? _c('VcLoader', {
    attrs: {
      "size": 16
    }
  }) : _c('VcCheckbox', {
    ref: "checkbox",
    staticClass: "mt-0 pt-0",
    attrs: {
      "checked": _vm.isChecked,
      "indeterminate": _vm.isIndeterminate,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.onCheckboxChange
    }
  }), _vm._v(" "), _vm.checkboxOptions && _vm.checkboxOptions.length ? _c('VcDropdown', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        return [_c('VcIcon', _vm._g({
          attrs: {
            "data-qa": "checkbox-dropdown-icon",
            "size": "10",
            "color": "var(--gray-darken-4)",
            "role": "button",
            "aria-label": "Show selection options",
            "aria-expanded": _vm.isCheckboxDropdownOpen,
            "tabindex": "0"
          }
        }, on), [_vm._v("\n          $caret_down\n        ")])];
      }
    }], null, false, 3906489500),
    model: {
      value: _vm.isCheckboxDropdownOpen,
      callback: function ($$v) {
        _vm.isCheckboxDropdownOpen = $$v;
      },
      expression: "isCheckboxDropdownOpen"
    }
  }, [_vm._v(" "), _c('VcGroupedItems', {
    attrs: {
      "item-groups": _vm.checkboxOptions
    },
    on: {
      "change": _vm.onCheckboxOptionClicked
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (ref) {
        var group = ref.group;
        return [_c('div', {
          staticClass: "checkbox-group-label"
        }, [_vm._v("\n            " + _vm._s(group.label) + "\n          ")])];
      }
    }], null, false, 395577037)
  })], 1) : _vm._e()], 1)], 1);
};

var __vue_staticRenderFns__$g = [];
/* style */

const __vue_inject_styles__$h = function (inject) {
  if (!inject) return;
  inject("data-v-7b824e76_0", {
    source: ".VcCheckboxColumnHeader[data-v-7b824e76]{height:var(--size-value9);padding:0 var(--size-value4);color:var(--gray-darken-5);font-size:10px;font-weight:var(--font-weight-large);background-color:var(--gray-lighten-4);border-bottom:var(--gray-lighten-2) solid 1px}.VcCheckboxColumnHeader__checkbox-wrapper[data-v-7b824e76]{width:100%}.checkbox-group-label[data-v-7b824e76]{color:var(--gray-darken-3);font-size:var(--font-size-xs-small);font-weight:var(--font-weight-large);padding:var(--size-value4) var(--size-value4) var(--size-value2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$h = "data-v-7b824e76";
/* module identifier */

const __vue_module_identifier__$h = undefined;
/* functional template */

const __vue_is_functional_template__$h = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, createInjector, undefined, undefined);

var VcCheckboxColumnHeader = __vue_component__$p;

var script$g = {
  name: 'VcTableActionBar',
  components: {
    VcSearchBar,
    VcLayout,
    VSkeletonLoader: VSkeletonLoader
  },
  props: {
    summaryText: {
      type: String,
      default: ''
    },
    searchBarSize: {
      type: String,
      default: 'small'
    },
    searchBarLabel: {
      type: String,
      default: ''
    },
    searchBarPlaceholder: {
      type: String,
      required: true
    },
    searchValue: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcTableActionBar'
    }
  }
};

/* script */
const __vue_script__$g = script$g;
/* template */

var __vue_render__$f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcTableActionBar",
    attrs: {
      "column": "",
      "data-qa": _vm.dataQa
    }
  }, [_vm.searchBarLabel ? _c('VcLayout', [_c('VcLayout', {
    staticClass: "VcTableActionBar--searchBar"
  }, [_vm.isLoading ? _c('VSkeletonLoader', {
    staticClass: "VcTableActionBar--summaryText--skeleton",
    attrs: {
      "type": "list-item"
    }
  }) : _c('VcSearchBar', {
    attrs: {
      "size": _vm.searchBarSize,
      "data-qa": _vm.dataQa + "-searchBar",
      "label": _vm.searchBarLabel,
      "placeholder": _vm.searchBarPlaceholder,
      "value": _vm.searchValue,
      "case-sensitive": true,
      "clearable": true
    },
    on: {
      "search": function (value) {
        return _vm.$emit('search', value);
      }
    }
  })], 1), _vm._v(" "), _vm._t("search-bar-append")], 2) : _vm._e(), _vm._v(" "), _vm._t("extra-line"), _vm._v(" "), _vm.summaryText ? _c('VcLayout', {
    staticClass: "VcTableActionBar--summaryText"
  }, [_vm.isLoading ? _c('VSkeletonLoader', {
    staticClass: "VcTableActionBar--summaryText--skeleton",
    attrs: {
      "type": "list-item"
    }
  }) : _vm._t("summary-text", function () {
    return [_c('span', {
      staticClass: "VcTableActionBar--summaryText--text"
    }, [_vm._v(_vm._s(_vm.summaryText))])];
  }), _vm._v(" "), _vm._t("summary-append")], 2) : _vm._e()], 2);
};

var __vue_staticRenderFns__$f = [];
/* style */

const __vue_inject_styles__$g = function (inject) {
  if (!inject) return;
  inject("data-v-61450569_0", {
    source: ".VcTableActionBar--summaryText[data-v-61450569]{font-size:11px;font-weight:var(--font-weight-medium2);color:var(--gray-darken-5);align-items:center}.VcTableActionBar--summaryText--skeleton[data-v-61450569]{min-width:137px;padding-bottom:var(--size-value4)}.VcTableActionBar--summaryText--text[data-v-61450569]{margin-inline-end:var(--size-value3)}.VcTableActionBar--searchBar[data-v-61450569]{max-width:400px;padding-bottom:var(--size-value4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$g = "data-v-61450569";
/* module identifier */

const __vue_module_identifier__$g = undefined;
/* functional template */

const __vue_is_functional_template__$g = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, createInjector, undefined, undefined);

var VcTableActionBar = __vue_component__$o;

var script$f = {
  name: 'VcTableItem',
  components: {
    VcButton,
    VcChipList,
    VcAvatar,
    VcIcon,
    VcCheckbox,
    VcLayout,
    VSkeletonLoader: VSkeletonLoader
  },
  props: {
    type: {
      type: String,
      default: 'text',
      validator: value => ['text', 'text-2-lines', 'checkbox', 'tag', 'icon', 'avatar'].includes(value)
    },
    column: {
      type: String,
      required: true
    },
    value: {
      type: [Boolean, String, Number, Object, Array]
    },
    widthType: {
      type: String,
      default: 'auto',
      validator: value => ['auto', 'fixed'].includes(value)
    },
    width: {
      type: Number
    },
    minWidth: {
      type: Number,
      default: 56
    },
    maxWidth: {
      type: Number,
      default: 500
    },
    showAddTagButton: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },

    /**
     * This will add a class on the item, which will be used by the table in setting the column as sticky
     */
    isSticky: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcTableItem'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    hiddenChips: undefined
  }),
  computed: {
    widthStyle() {
      const newStyle = {};

      switch (this.widthType) {
        case 'auto':
          newStyle.minWidth = `${this.minWidth}px`;
          newStyle.maxWidth = `${this.maxWidth}px`;
          break;

        case 'fixed':
          if (this.width) newStyle.width = `${this.width}px`;
      }

      return newStyle;
    }

  },

  mounted() {
    const parentItem = this.$refs.mainItem.$el.closest('td');

    if (this.isSticky) {
      parentItem && parentItem.classList.add('sticky');
    }
  }

};

/* script */
const __vue_script__$f = script$f;
/* template */

var __vue_render__$e = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    ref: "mainItem",
    staticClass: "VcTableItem",
    class: (_obj = {
      loading: _vm.isLoading
    }, _obj['type-' + _vm.type] = true, _obj.itemPadding = _vm.isLoading || !['avatar'].includes(_vm.type), _obj['width-type-' + _vm.widthType] = true, _obj['is-sticky'] = _vm.isSticky, _obj),
    style: _vm.widthStyle,
    attrs: {
      "align-center": "",
      "justify-center": ['avatar', 'icon', 'checkbox'].includes(_vm.type),
      "data-qa": _vm.dataQa
    }
  }, [_vm.isLoading && 'checkbox' !== _vm.type ? _c('VSkeletonLoader', {
    staticClass: "VcTableItem--skeleton",
    attrs: {
      "type": "list-item",
      "data-qa": _vm.dataQa + "-skeleton"
    }
  }) : _vm._t("default", function () {
    return [['text', 'text-2-lines'].includes(_vm.type) ? _c('div', {
      class: {
        'VcTableItem--text': _vm.type === 'text',
        'VcTableItem--text-2-lines': _vm.type === 'text-2-lines'
      },
      attrs: {
        "data-qa": _vm.dataQa + "-text"
      }
    }, [_vm._v("\n      " + _vm._s(_vm.value) + "\n    ")]) : _vm.type === 'checkbox' ? _c('VcCheckbox', {
      staticClass: "VcTableItem--selected mt-0 pt-0",
      attrs: {
        "checked": _vm.value,
        "disabled": _vm.isLoading || _vm.disabled,
        "data-qa": _vm.dataQa + "-checkbox"
      },
      on: {
        "change": function (selected) {
          return _vm.$emit('change', selected);
        }
      }
    }) : _vm.type === 'icon' ? _c('VcIcon', [_vm._v("\n      " + _vm._s(_vm.value) + "\n    ")]) : _vm.type === 'avatar' ? _c('VcAvatar', _vm._b({
      attrs: {
        "size": "sm",
        "data-qa": _vm.dataQa + "-avatar"
      }
    }, 'VcAvatar', _vm.value, false)) : _vm.type === 'tag' && _vm.value.length > 0 ? _c('VcChipList', {
      attrs: {
        "items": _vm.value,
        "more-text": "+" + _vm.hiddenChips,
        "lines": 1,
        "hidden-item-display": "chip",
        "data-qa": _vm.dataQa + "-tags",
        "min-chip-width": 20,
        "max-chip-width": 116
      },
      on: {
        "onHiddenChipsChange": function (newValue) {
          return _vm.hiddenChips = newValue;
        }
      }
    }) : _vm.type === 'tag' && _vm.showAddTagButton ? _c('VcButton', {
      attrs: {
        "ghost": "",
        "data-qa": _vm.dataQa + "-addTagsButton"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('onClickToAddTag', _vm.$props);
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function () {
          return [_c('div', {
            staticClass: "VcTableItem--addTag"
          }, [_vm._v("\n          " + _vm._s(_vm.$dst('ds.table.item.add_tag_button')) + "\n        ")])];
        },
        proxy: true
      }])
    }) : _vm._e()];
  }, {
    "data": _vm.$props
  })], 2);
};

var __vue_staticRenderFns__$e = [];
/* style */

const __vue_inject_styles__$f = function (inject) {
  if (!inject) return;
  inject("data-v-492078a6_0", {
    source: ".VcTableItem[data-v-492078a6]{position:relative;font-size:13px;font-weight:var(--font-weight-medium2);height:60px}.VcTableItem.itemPadding[data-v-492078a6]{padding:0 var(--size-value4)}.VcTableItem.loading:not(.type-checkbox) .VcTableItem--skeleton[data-v-492078a6]{width:100%}.VcTableItem--text[data-v-492078a6]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.VcTableItem--text-2-lines[data-v-492078a6]{display:-webkit-box;line-clamp:2;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.VcTableItem--selected[data-v-492078a6]  label{display:none}.VcTableItem.type-tag[data-v-492078a6]{overflow-x:hidden}.VcTableItem--addTag[data-v-492078a6]{color:var(--gray-darken-3)}.VcTableItem.width-type-auto[data-v-492078a6]:not(.loading){width:max-content}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$f = "data-v-492078a6";
/* module identifier */

const __vue_module_identifier__$f = undefined;
/* functional template */

const __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined);

var VcTableItem = __vue_component__$n;

var script$e = {
  name: 'VcDataTable',
  components: {
    VcInfiniteScroll: () => Promise.resolve().then(function () { return VcInfiniteScroll$1; }),
    VcEmptyState,
    VcTableItem,
    VcTableActionBar,
    VcColumnHeader,
    VcTableFooter,
    VcCheckboxColumnHeader,
    VcLoader,
    VDataTable: VDataTable
  },
  props: {
    /**
     * structure:
     {
     display: text or data to be displayed, localized
     type: text/checkbox/icon/image/avatar/tag,
     dataType: optional, in case the column header and the data are displayed using different methods, indicates how the data in the cell should be rendered, options: text/checkbox/tag/icon/avatar
     value: the value used for logical actions, will not be localized
     },
     *
     */
    headers: {
      type: Array,
      default: () => []
    },

    /**
     * Defines how many columns should be sticky
     */
    stickyColumnNum: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default: () => []
    },
    totalItems: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Object,
      default: () => ({
        text: '10',
        value: 10
      }),
      validator: selection => selection.text && selection.value
    },
    itemsPerPageOptions: {
      type: Array,
      default: () => []
    },
    searchBarSize: {
      type: String,
      default: 'small'
    },
    searchBarLabel: {
      type: String,
      default: ''
    },
    searchBarPlaceholder: {
      type: String,
      default: ''
    },
    searchValue: {
      type: String,
      default: ''
    },
    summaryText: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    },
    emptyStateProps: {
      type: Object,
      validator: value => value.title && value.subtitle && value.image
    },
    dataQa: {
      type: String,
      default: 'VcDataTable'
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    showMobileOnBreakpoint: {
      type: Boolean,
      default: false
    },
    clickableRow: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isScrolling: false,
    columnForScrollTracking: undefined,
    observer: undefined,
    tableIdentifierByTimeStamp: Date.now()
  }),
  computed: {
    isMobile() {
      return this.showMobileOnBreakpoint && this.$vuetify.breakpoint.smAndDown;
    },

    headersWithClasses() {
      const updatedHeaders = this.headers.map((headerItem, index) => ({ ...headerItem,
        class: index < this.stickyColumnNum ? 'sticky' : ''
      }));
      updatedHeaders.unshift({
        value: 'scroll',
        display: '',
        class: 'scroll-indicator ' + this.tableIdentifierByTimeStamp
      });
      updatedHeaders.push({
        value: 'filler',
        display: '',
        class: 'table-filler'
      });
      return updatedHeaders;
    },

    getDummyItemsForIsSearching() {
      return Array.from({
        length: this.itemsPerPage.value
      }, () => ({}));
    },

    getItems() {
      return this.isSearching && !this.isMobile ? this.getDummyItemsForIsSearching : this.items;
    },

    showActionBar() {
      return this.searchBarLabel || this.summaryText;
    },

    showFooter() {
      return !this.hideFooter && this.items.length > 0;
    }

  },

  mounted() {
    if (!this.isMobile) {
      this.columnForScrollTracking = document.getElementsByClassName(this.tableIdentifierByTimeStamp)[0];
      this.observer = new IntersectionObserver(this.onIntersectionChange);
      this.observer.observe(this.columnForScrollTracking);
    }
  },

  destroyed() {
    if (!this.isMobile) {
      this.observer.unobserve(this.columnForScrollTracking);
    }
  },

  methods: {
    getHeaderSlotName(headerName) {
      return 'header.' + headerName;
    },

    getItemSlotName(headerName) {
      return 'item.' + headerName;
    },

    onIntersectionChange(event) {
      this.isScrolling = !event[event.length - 1].isIntersecting;
    },

    itemClass(item) {
      return `data-table-row ${item.checkbox ? 'selected' : ''}`;
    }

  }
};

/* script */
const __vue_script__$e = script$e;
/* template */

var __vue_render__$d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "VcDataTable--wrapper",
    class: {
      empty: _vm.getItems.length === 0
    }
  }, [_c('v-data-table', {
    staticClass: "VcDataTable",
    class: {
      isScrolling: _vm.isScrolling,
      clickableRow: _vm.clickableRow
    },
    attrs: {
      "data-qa": _vm.dataQa,
      "headers": _vm.headersWithClasses,
      "items": _vm.getItems,
      "items-per-page": _vm.itemsPerPage.value,
      "server-items-length": _vm.totalItems,
      "item-class": _vm.itemClass,
      "mobile-breakpoint": _vm.isMobile ? _vm.$vuetify.breakpoint.thresholds.sm : 10,
      "disable-sort": "",
      "disable-filtering": "",
      "disable-pagination": "",
      "fixed-header": "",
      "hide-default-footer": ""
    },
    on: {
      "update:itemsPerPage": function ($event) {
        return _vm.$set(_vm.itemsPerPage, "value", $event);
      },
      "update:items-per-page": function ($event) {
        return _vm.$set(_vm.itemsPerPage, "value", $event);
      },
      "click:row": function (item, index) {
        return _vm.$emit('onRowClicked', {
          item: item,
          index: index
        });
      }
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function () {
        return [_c('div', {
          staticClass: "header-slot"
        }, [_vm._t("header", function () {
          return [_vm.showActionBar ? _c('VcTableActionBar', {
            class: _vm.isMobile ? 'VcDataTable--actionBarMobile' : 'VcDataTable--actionBar',
            attrs: {
              "summary-text": _vm.summaryText,
              "is-loading": _vm.isLoading,
              "search-bar-size": _vm.searchBarSize,
              "search-bar-label": _vm.searchBarLabel,
              "search-bar-placeholder": _vm.searchBarPlaceholder,
              "search-value": _vm.searchValue,
              "data-qa": _vm.dataQa + "-actionBar"
            },
            on: {
              "search": function (value) {
                return _vm.$emit('onSearch', value);
              }
            },
            scopedSlots: _vm._u([{
              key: "search-bar-append",
              fn: function () {
                return [_vm._t("search-bar-append")];
              },
              proxy: true
            }, {
              key: "extra-line",
              fn: function () {
                return [_vm._t("extra-line")];
              },
              proxy: true
            }, {
              key: "summary-append",
              fn: function () {
                return [_vm._t("summary-append")];
              },
              proxy: true
            }, {
              key: "summary-text",
              fn: function () {
                return [_vm._t("summary-text")];
              },
              proxy: true
            }], null, true)
          }) : _vm._e()];
        })], 2)];
      },
      proxy: true
    }, _vm.isMobile ? {
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        return [_vm._t("mobile-item", null, {
          "item": item
        })];
      }
    } : _vm._l(_vm.headers, function (headerData, index) {
      return {
        key: _vm.getHeaderSlotName(headerData.value),
        fn: function (ref) {
          var header = ref.header;
          return [header.type === 'checkbox' ? _c('VcCheckboxColumnHeader', {
            key: "checkbox-" + (headerData.value || "header-" + index),
            staticClass: "VcDataTable--header",
            class: header.class,
            attrs: {
              "is-checked": header.display === true || header.display === 'indeterminate',
              "is-indeterminate": header.display === 'indeterminate',
              "is-loading": _vm.isLoading,
              "disabled": header.disabled,
              "checkbox-options": header.checkboxOptions,
              "data-qa": _vm.dataQa + "-header-" + header.value
            },
            on: {
              "onSelectAllChanged": function ($event) {
                return _vm.$emit('onSelectAllChanged', $event);
              },
              "onCheckboxOptionClicked": function ($event) {
                return _vm.$emit('onCheckboxOptionClicked', $event);
              }
            }
          }) : _c('VcColumnHeader', _vm._b({
            key: headerData.value,
            staticClass: "VcDataTable--header",
            attrs: {
              "is-loading": _vm.isLoading,
              "data-qa": _vm.dataQa + "-header-" + header.value
            },
            on: {
              "input": function (direction) {
                return _vm.$emit('onSort', {
                  direction: direction,
                  header: header
                });
              },
              "onSelectAllChanged": function ($event) {
                return _vm.$emit('onSelectAllChanged', $event);
              },
              "onCheckboxOptionClicked": function ($event) {
                return _vm.$emit('onCheckboxOptionClicked', $event);
              }
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function (ref) {
                var data = ref.data;
                return [_vm._t("header-" + data.value, null, {
                  "data": data
                })];
              }
            }], null, true)
          }, 'VcColumnHeader', header, false))];
        }
      };
    }), !_vm.isMobile ? _vm._l(_vm.headers, function (headerData, index) {
      return {
        key: _vm.getItemSlotName(headerData.value),
        fn: function (ref) {
          var item = ref.item;
          var header = ref.header;
          return [_c('VcTableItem', {
            attrs: {
              "value": item[header.value],
              "type": header.dataType || header.type,
              "column": header.value,
              "show-add-tag-button": item.showAddTagButton,
              "width-type": header.widthType,
              "width": header.width,
              "min-width": header.minWidth,
              "max-width": header.maxWidth,
              "is-loading": _vm.isLoading || _vm.isSearching,
              "is-sticky": index < _vm.stickyColumnNum,
              "disabled": item.disabled || header.disabled,
              "data-qa": _vm.dataQa + "-item-" + header.value
            },
            on: {
              "change": function (value) {
                return _vm.$emit('onItemSelected', value, item);
              },
              "onClickToAddTag": function ($event) {
                return _vm.$emit('onClickToAddTag', item);
              }
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function (ref) {
                var data = ref.data;
                return [_vm._t("item-" + data.column, null, {
                  "data": data,
                  "item": item
                })];
              }
            }], null, true)
          })];
        }
      };
    }) : null, {
      key: "no-data",
      fn: function () {
        return [_vm.isMobile && _vm.isSearching ? _c('VcLoader') : _vm.emptyStateProps ? _c('VcEmptyState', _vm._b({
          staticClass: "VcDataTable--emptyState",
          class: {
            directionRight: _vm.$vuetify.rtl,
            directionLeft: !_vm.$vuetify.rtl
          },
          attrs: {
            "image": _vm.emptyStateProps.image
          }
        }, 'VcEmptyState', _vm.emptyStateProps, false)) : _vm._e()];
      },
      proxy: true
    }, _vm.isMobile && !_vm.isSearching && _vm.items.length < _vm.totalItems ? {
      key: "body.append",
      fn: function () {
        return [_c('VcInfiniteScroll', {
          attrs: {
            "is-empty": false,
            "no-result-text": ""
          },
          on: {
            "onScroll": function (state) {
              return _vm.$emit('onLoadNextPage', state);
            }
          }
        })];
      },
      proxy: true
    } : null, !_vm.isMobile ? {
      key: "footer",
      fn: function () {
        return [_c('div', {
          staticClass: "footer-slot"
        }, [_vm._t("footer", function () {
          return [_vm.showFooter ? _c('VcTableFooter', {
            staticClass: "VcDataTable--footer",
            attrs: {
              "items-per-page": _vm.itemsPerPage,
              "items-per-page-options": _vm.itemsPerPageOptions,
              "current-page": _vm.currentPage,
              "total-pages": _vm.totalPages,
              "is-loading": _vm.isLoading,
              "disabled": _vm.isSearching,
              "data-qa": _vm.dataQa + "-footer"
            },
            on: {
              "onSelectionChanged": function (value) {
                return _vm.$emit('onSelectionChanged', value);
              },
              "onBackButtonClicked": function ($event) {
                return _vm.$emit('onBackButtonClicked');
              },
              "onNextButtonClicked": function ($event) {
                return _vm.$emit('onNextButtonClicked');
              }
            }
          }) : _vm._e()];
        })], 2)];
      },
      proxy: true
    } : null], null, true)
  })], 1);
};

var __vue_staticRenderFns__$d = [];
/* style */

const __vue_inject_styles__$e = function (inject) {
  if (!inject) return;
  inject("data-v-0aaca7c2_0", {
    source: ".VcDataTable--wrapper[data-v-0aaca7c2]{display:flex;flex-direction:column;max-height:100%}.VcDataTable--wrapper.empty[data-v-0aaca7c2]  table{height:100%}.VcDataTable[data-v-0aaca7c2]{height:100%;display:flex;flex-direction:column;overflow:hidden}.VcDataTable.isScrolling[data-v-0aaca7c2]  table tbody td.sticky,.VcDataTable.isScrolling[data-v-0aaca7c2]  table thead th.sticky{box-shadow:var(--table-sticky-column-shadow)}.VcDataTable.clickableRow[data-v-0aaca7c2]  .data-table-row{cursor:pointer}.VcDataTable--actionBar[data-v-0aaca7c2]{padding:var(--size-value3) var(--size-value5);margin-bottom:var(--size-value3)}.VcDataTable--actionBarMobile[data-v-0aaca7c2]{padding:var(--size-value5);border-bottom:1px solid var(--gray-lighten-1)}.VcDataTable--header[data-v-0aaca7c2]{border-inline-end:var(--gray-lighten-2) solid 1px}.VcDataTable[data-v-0aaca7c2]  table{table-layout:auto}.VcDataTable[data-v-0aaca7c2]  thead{position:sticky;top:0;z-index:2}.VcDataTable[data-v-0aaca7c2]  table thead th.scroll-indicator{position:absolute;height:100vh!important}.VcDataTable[data-v-0aaca7c2]  table thead th.table-filler{min-width:0;background-color:var(--gray-lighten-4)}.VcDataTable[data-v-0aaca7c2]  table thead th.sticky{position:sticky;z-index:3}.VcDataTable[data-v-0aaca7c2]  table thead th:nth-child(2){left:0}.VcDataTable[data-v-0aaca7c2]  table tbody td.sticky:nth-child(3),.VcDataTable[data-v-0aaca7c2]  table thead th.sticky:nth-child(3){left:49px}.VcDataTable[data-v-0aaca7c2]  table tbody tr td{border-bottom:thin solid var(--gray-lighten-2)!important}.VcDataTable[data-v-0aaca7c2]  table tbody td.sticky,.VcDataTable[data-v-0aaca7c2]  table thead th.sticky{box-shadow:0 0 0 transparent;transition:box-shadow .1s ease-in-out}.VcDataTable[data-v-0aaca7c2]  table tbody td.sticky{position:sticky;background:#fff;z-index:1}.VcDataTable[data-v-0aaca7c2]  table tbody tr.selected:not(:hover) td.sticky:before{content:\"\";position:absolute;height:100%;width:100%;background-color:var(--v-secondary-base-opacity-8)}.VcDataTable[data-v-0aaca7c2]  table tbody tr.selected:not(:hover) td:not(.sticky){background-color:var(--v-secondary-base-opacity-8)}.VcDataTable[data-v-0aaca7c2]  table tbody tr:not(.v-data-table__empty-wrapper):hover td{background:var(--gray-lighten-3)}.VcDataTable[data-v-0aaca7c2]  table tbody td.sticky:nth-child(2){left:0}.VcDataTable[data-v-0aaca7c2]  table tbody td:first-child{width:0;max-width:0}.VcDataTable[data-v-0aaca7c2]  tfoot{position:sticky;bottom:0;z-index:2}.VcDataTable[data-v-0aaca7c2]  .v-data-table__wrapper>table>thead>tr>th{padding:0;height:auto}.VcDataTable[data-v-0aaca7c2]  .v-data-table__wrapper>table>tbody>tr>td{padding:0}.VcDataTable[data-v-0aaca7c2]  .v-data-table-header__icon{display:none}.VcDataTable[data-v-0aaca7c2]  .VcDataTable--footer{min-height:48px}.VcDataTable[data-v-0aaca7c2]  .v-data-table__wrapper{flex:1}.VcDataTable--emptyState[data-v-0aaca7c2]{position:sticky;width:160px;overflow-x:visible;white-space:nowrap;align-items:center}.VcDataTable--emptyState.directionLeft[data-v-0aaca7c2]{left:calc(-80px + min(50cqw,50%))}.VcDataTable--emptyState.directionRight[data-v-0aaca7c2]{right:calc(-80px + min(50cqw,50%))}.VcDataTable .footer-slot[data-v-0aaca7c2],.VcDataTable .header-slot[data-v-0aaca7c2]{flex:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$e = "data-v-0aaca7c2";
/* module identifier */

const __vue_module_identifier__$e = undefined;
/* functional template */

const __vue_is_functional_template__$e = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, createInjector, undefined, undefined);

var __vue_component__$m = __vue_component__$l;

/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/

var jszip_min = createCommonjsModule(function (module, exports) {
!function(e){module.exports=e();}(function(){return function s(a,o,h){function u(r,e){if(!o[r]){if(!a[r]){var t="function"==typeof commonjsRequire&&commonjsRequire;if(!e&&t)return t(r,!0);if(l)return l(r,!0);var n=new Error("Cannot find module '"+r+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[r]={exports:{}};a[r][0].call(i.exports,function(e){var t=a[r][1][e];return u(t||e)},i,i.exports,s,a,o,h);}return o[r].exports}for(var l="function"==typeof commonjsRequire&&commonjsRequire,e=0;e<h.length;e++)u(h[e]);return u}({1:[function(e,t,r){var d=e("./utils"),c=e("./support"),p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.encode=function(e){for(var t,r,n,i,s,a,o,h=[],u=0,l=e.length,f=l,c="string"!==d.getTypeOf(e);u<e.length;)f=l-u,n=c?(t=e[u++],r=u<l?e[u++]:0,u<l?e[u++]:0):(t=e.charCodeAt(u++),r=u<l?e.charCodeAt(u++):0,u<l?e.charCodeAt(u++):0),i=t>>2,s=(3&t)<<4|r>>4,a=1<f?(15&r)<<2|n>>6:64,o=2<f?63&n:64,h.push(p.charAt(i)+p.charAt(s)+p.charAt(a)+p.charAt(o));return h.join("")},r.decode=function(e){var t,r,n,i,s,a,o=0,h=0,u="data:";if(e.substr(0,u.length)===u)throw new Error("Invalid base64 input, it looks like a data url.");var l,f=3*(e=e.replace(/[^A-Za-z0-9+/=]/g,"")).length/4;if(e.charAt(e.length-1)===p.charAt(64)&&f--,e.charAt(e.length-2)===p.charAt(64)&&f--,f%1!=0)throw new Error("Invalid base64 input, bad content length.");for(l=c.uint8array?new Uint8Array(0|f):new Array(0|f);o<e.length;)t=p.indexOf(e.charAt(o++))<<2|(i=p.indexOf(e.charAt(o++)))>>4,r=(15&i)<<4|(s=p.indexOf(e.charAt(o++)))>>2,n=(3&s)<<6|(a=p.indexOf(e.charAt(o++))),l[h++]=t,64!==s&&(l[h++]=r),64!==a&&(l[h++]=n);return l};},{"./support":30,"./utils":32}],2:[function(e,t,r){var n=e("./external"),i=e("./stream/DataWorker"),s=e("./stream/Crc32Probe"),a=e("./stream/DataLengthProbe");function o(e,t,r,n,i){this.compressedSize=e,this.uncompressedSize=t,this.crc32=r,this.compression=n,this.compressedContent=i;}o.prototype={getContentWorker:function(){var e=new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),t=this;return e.on("end",function(){if(this.streamInfo.data_length!==t.uncompressedSize)throw new Error("Bug : uncompressed data size mismatch")}),e},getCompressedWorker:function(){return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize",this.compressedSize).withStreamInfo("uncompressedSize",this.uncompressedSize).withStreamInfo("crc32",this.crc32).withStreamInfo("compression",this.compression)}},o.createWorkerFrom=function(e,t,r){return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression",t)},t.exports=o;},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(e,t,r){var n=e("./stream/GenericWorker");r.STORE={magic:"\0\0",compressWorker:function(){return new n("STORE compression")},uncompressWorker:function(){return new n("STORE decompression")}},r.DEFLATE=e("./flate");},{"./flate":7,"./stream/GenericWorker":28}],4:[function(e,t,r){var n=e("./utils");var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e;}return t}();t.exports=function(e,t){return void 0!==e&&e.length?"string"!==n.getTypeOf(e)?function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return -1^e}(0|t,e,e.length,0):function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t.charCodeAt(a))];return -1^e}(0|t,e,e.length,0):0};},{"./utils":32}],5:[function(e,t,r){r.base64=!1,r.binary=!1,r.dir=!1,r.createFolders=!0,r.date=null,r.compression=null,r.compressionOptions=null,r.comment=null,r.unixPermissions=null,r.dosPermissions=null;},{}],6:[function(e,t,r){var n=null;n="undefined"!=typeof Promise?Promise:e("lie"),t.exports={Promise:n};},{lie:37}],7:[function(e,t,r){var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array,i=e("pako"),s=e("./utils"),a=e("./stream/GenericWorker"),o=n?"uint8array":"array";function h(e,t){a.call(this,"FlateWorker/"+e),this._pako=null,this._pakoAction=e,this._pakoOptions=t,this.meta={};}r.magic="\b\0",s.inherits(h,a),h.prototype.processChunk=function(e){this.meta=e.meta,null===this._pako&&this._createPako(),this._pako.push(s.transformTo(o,e.data),!1);},h.prototype.flush=function(){a.prototype.flush.call(this),null===this._pako&&this._createPako(),this._pako.push([],!0);},h.prototype.cleanUp=function(){a.prototype.cleanUp.call(this),this._pako=null;},h.prototype._createPako=function(){this._pako=new i[this._pakoAction]({raw:!0,level:this._pakoOptions.level||-1});var t=this;this._pako.onData=function(e){t.push({data:e,meta:t.meta});};},r.compressWorker=function(e){return new h("Deflate",e)},r.uncompressWorker=function(){return new h("Inflate",{})};},{"./stream/GenericWorker":28,"./utils":32,pako:38}],8:[function(e,t,r){function A(e,t){var r,n="";for(r=0;r<t;r++)n+=String.fromCharCode(255&e),e>>>=8;return n}function n(e,t,r,n,i,s){var a,o,h=e.file,u=e.compression,l=s!==O.utf8encode,f=I.transformTo("string",s(h.name)),c=I.transformTo("string",O.utf8encode(h.name)),d=h.comment,p=I.transformTo("string",s(d)),m=I.transformTo("string",O.utf8encode(d)),_=c.length!==h.name.length,g=m.length!==d.length,b="",v="",y="",w=h.dir,k=h.date,x={crc32:0,compressedSize:0,uncompressedSize:0};t&&!r||(x.crc32=e.crc32,x.compressedSize=e.compressedSize,x.uncompressedSize=e.uncompressedSize);var S=0;t&&(S|=8),l||!_&&!g||(S|=2048);var z=0,C=0;w&&(z|=16),"UNIX"===i?(C=798,z|=function(e,t){var r=e;return e||(r=t?16893:33204),(65535&r)<<16}(h.unixPermissions,w)):(C=20,z|=function(e){return 63&(e||0)}(h.dosPermissions)),a=k.getUTCHours(),a<<=6,a|=k.getUTCMinutes(),a<<=5,a|=k.getUTCSeconds()/2,o=k.getUTCFullYear()-1980,o<<=4,o|=k.getUTCMonth()+1,o<<=5,o|=k.getUTCDate(),_&&(v=A(1,1)+A(B(f),4)+c,b+="up"+A(v.length,2)+v),g&&(y=A(1,1)+A(B(p),4)+m,b+="uc"+A(y.length,2)+y);var E="";return E+="\n\0",E+=A(S,2),E+=u.magic,E+=A(a,2),E+=A(o,2),E+=A(x.crc32,4),E+=A(x.compressedSize,4),E+=A(x.uncompressedSize,4),E+=A(f.length,2),E+=A(b.length,2),{fileRecord:R.LOCAL_FILE_HEADER+E+f+b,dirRecord:R.CENTRAL_FILE_HEADER+A(C,2)+E+A(p.length,2)+"\0\0\0\0"+A(z,4)+A(n,4)+f+b+p}}var I=e("../utils"),i=e("../stream/GenericWorker"),O=e("../utf8"),B=e("../crc32"),R=e("../signature");function s(e,t,r,n){i.call(this,"ZipFileWorker"),this.bytesWritten=0,this.zipComment=t,this.zipPlatform=r,this.encodeFileName=n,this.streamFiles=e,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[];}I.inherits(s,i),s.prototype.push=function(e){var t=e.meta.percent||0,r=this.entriesCount,n=this._sources.length;this.accumulate?this.contentBuffer.push(e):(this.bytesWritten+=e.data.length,i.prototype.push.call(this,{data:e.data,meta:{currentFile:this.currentFile,percent:r?(t+100*(r-n-1))/r:100}}));},s.prototype.openedSource=function(e){this.currentSourceOffset=this.bytesWritten,this.currentFile=e.file.name;var t=this.streamFiles&&!e.file.dir;if(t){var r=n(e,t,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:r.fileRecord,meta:{percent:0}});}else this.accumulate=!0;},s.prototype.closedSource=function(e){this.accumulate=!1;var t=this.streamFiles&&!e.file.dir,r=n(e,t,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(r.dirRecord),t)this.push({data:function(e){return R.DATA_DESCRIPTOR+A(e.crc32,4)+A(e.compressedSize,4)+A(e.uncompressedSize,4)}(e),meta:{percent:100}});else for(this.push({data:r.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null;},s.prototype.flush=function(){for(var e=this.bytesWritten,t=0;t<this.dirRecords.length;t++)this.push({data:this.dirRecords[t],meta:{percent:100}});var r=this.bytesWritten-e,n=function(e,t,r,n,i){var s=I.transformTo("string",i(n));return R.CENTRAL_DIRECTORY_END+"\0\0\0\0"+A(e,2)+A(e,2)+A(t,4)+A(r,4)+A(s.length,2)+s}(this.dirRecords.length,r,e,this.zipComment,this.encodeFileName);this.push({data:n,meta:{percent:100}});},s.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume();},s.prototype.registerPrevious=function(e){this._sources.push(e);var t=this;return e.on("data",function(e){t.processChunk(e);}),e.on("end",function(){t.closedSource(t.previous.streamInfo),t._sources.length?t.prepareNextSource():t.end();}),e.on("error",function(e){t.error(e);}),this},s.prototype.resume=function(){return !!i.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},s.prototype.error=function(e){var t=this._sources;if(!i.prototype.error.call(this,e))return !1;for(var r=0;r<t.length;r++)try{t[r].error(e);}catch(e){}return !0},s.prototype.lock=function(){i.prototype.lock.call(this);for(var e=this._sources,t=0;t<e.length;t++)e[t].lock();},t.exports=s;},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(e,t,r){var u=e("../compressions"),n=e("./ZipFileWorker");r.generateWorker=function(e,a,t){var o=new n(a.streamFiles,t,a.platform,a.encodeFileName),h=0;try{e.forEach(function(e,t){h++;var r=function(e,t){var r=e||t,n=u[r];if(!n)throw new Error(r+" is not a valid compression method !");return n}(t.options.compression,a.compression),n=t.options.compressionOptions||a.compressionOptions||{},i=t.dir,s=t.date;t._compressWorker(r,n).withStreamInfo("file",{name:e,dir:i,date:s,comment:t.comment||"",unixPermissions:t.unixPermissions,dosPermissions:t.dosPermissions}).pipe(o);}),o.entriesCount=h;}catch(e){o.error(e);}return o};},{"../compressions":3,"./ZipFileWorker":8}],10:[function(e,t,r){function n(){if(!(this instanceof n))return new n;if(arguments.length)throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");this.files=Object.create(null),this.comment=null,this.root="",this.clone=function(){var e=new n;for(var t in this)"function"!=typeof this[t]&&(e[t]=this[t]);return e};}(n.prototype=e("./object")).loadAsync=e("./load"),n.support=e("./support"),n.defaults=e("./defaults"),n.version="3.10.1",n.loadAsync=function(e,t){return (new n).loadAsync(e,t)},n.external=e("./external"),t.exports=n;},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(e,t,r){var u=e("./utils"),i=e("./external"),n=e("./utf8"),s=e("./zipEntries"),a=e("./stream/Crc32Probe"),l=e("./nodejsUtils");function f(n){return new i.Promise(function(e,t){var r=n.decompressed.getContentWorker().pipe(new a);r.on("error",function(e){t(e);}).on("end",function(){r.streamInfo.crc32!==n.decompressed.crc32?t(new Error("Corrupted zip : CRC32 mismatch")):e();}).resume();})}t.exports=function(e,o){var h=this;return o=u.extend(o||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:n.utf8decode}),l.isNode&&l.isStream(e)?i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")):u.prepareContent("the loaded zip file",e,!0,o.optimizedBinaryString,o.base64).then(function(e){var t=new s(o);return t.load(e),t}).then(function(e){var t=[i.Promise.resolve(e)],r=e.files;if(o.checkCRC32)for(var n=0;n<r.length;n++)t.push(f(r[n]));return i.Promise.all(t)}).then(function(e){for(var t=e.shift(),r=t.files,n=0;n<r.length;n++){var i=r[n],s=i.fileNameStr,a=u.resolve(i.fileNameStr);h.file(a,i.decompressed,{binary:!0,optimizedBinaryString:!0,date:i.date,dir:i.dir,comment:i.fileCommentStr.length?i.fileCommentStr:null,unixPermissions:i.unixPermissions,dosPermissions:i.dosPermissions,createFolders:o.createFolders}),i.dir||(h.file(a).unsafeOriginalName=s);}return t.zipComment.length&&(h.comment=t.zipComment),h})};},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(e,t,r){var n=e("../utils"),i=e("../stream/GenericWorker");function s(e,t){i.call(this,"Nodejs stream input adapter for "+e),this._upstreamEnded=!1,this._bindStream(t);}n.inherits(s,i),s.prototype._bindStream=function(e){var t=this;(this._stream=e).pause(),e.on("data",function(e){t.push({data:e,meta:{percent:0}});}).on("error",function(e){t.isPaused?this.generatedError=e:t.error(e);}).on("end",function(){t.isPaused?t._upstreamEnded=!0:t.end();});},s.prototype.pause=function(){return !!i.prototype.pause.call(this)&&(this._stream.pause(),!0)},s.prototype.resume=function(){return !!i.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},t.exports=s;},{"../stream/GenericWorker":28,"../utils":32}],13:[function(e,t,r){var i=e("readable-stream").Readable;function n(e,t,r){i.call(this,t),this._helper=e;var n=this;e.on("data",function(e,t){n.push(e)||n._helper.pause(),r&&r(t);}).on("error",function(e){n.emit("error",e);}).on("end",function(){n.push(null);});}e("../utils").inherits(n,i),n.prototype._read=function(){this._helper.resume();},t.exports=n;},{"../utils":32,"readable-stream":16}],14:[function(e,t,r){t.exports={isNode:"undefined"!=typeof Buffer,newBufferFrom:function(e,t){if(Buffer.from&&Buffer.from!==Uint8Array.from)return Buffer.from(e,t);if("number"==typeof e)throw new Error('The "data" argument must not be a number');return new Buffer(e,t)},allocBuffer:function(e){if(Buffer.alloc)return Buffer.alloc(e);var t=new Buffer(e);return t.fill(0),t},isBuffer:function(e){return Buffer.isBuffer(e)},isStream:function(e){return e&&"function"==typeof e.on&&"function"==typeof e.pause&&"function"==typeof e.resume}};},{}],15:[function(e,t,r){function s(e,t,r){var n,i=u.getTypeOf(t),s=u.extend(r||{},f);s.date=s.date||new Date,null!==s.compression&&(s.compression=s.compression.toUpperCase()),"string"==typeof s.unixPermissions&&(s.unixPermissions=parseInt(s.unixPermissions,8)),s.unixPermissions&&16384&s.unixPermissions&&(s.dir=!0),s.dosPermissions&&16&s.dosPermissions&&(s.dir=!0),s.dir&&(e=g(e)),s.createFolders&&(n=_(e))&&b.call(this,n,!0);var a="string"===i&&!1===s.binary&&!1===s.base64;r&&void 0!==r.binary||(s.binary=!a),(t instanceof c&&0===t.uncompressedSize||s.dir||!t||0===t.length)&&(s.base64=!1,s.binary=!0,t="",s.compression="STORE",i="string");var o=null;o=t instanceof c||t instanceof l?t:p.isNode&&p.isStream(t)?new m(e,t):u.prepareContent(e,t,s.binary,s.optimizedBinaryString,s.base64);var h=new d(e,o,s);this.files[e]=h;}var i=e("./utf8"),u=e("./utils"),l=e("./stream/GenericWorker"),a=e("./stream/StreamHelper"),f=e("./defaults"),c=e("./compressedObject"),d=e("./zipObject"),o=e("./generate"),p=e("./nodejsUtils"),m=e("./nodejs/NodejsStreamInputAdapter"),_=function(e){"/"===e.slice(-1)&&(e=e.substring(0,e.length-1));var t=e.lastIndexOf("/");return 0<t?e.substring(0,t):""},g=function(e){return "/"!==e.slice(-1)&&(e+="/"),e},b=function(e,t){return t=void 0!==t?t:f.createFolders,e=g(e),this.files[e]||s.call(this,e,null,{dir:!0,createFolders:t}),this.files[e]};function h(e){return "[object RegExp]"===Object.prototype.toString.call(e)}var n={load:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},forEach:function(e){var t,r,n;for(t in this.files)n=this.files[t],(r=t.slice(this.root.length,t.length))&&t.slice(0,this.root.length)===this.root&&e(r,n);},filter:function(r){var n=[];return this.forEach(function(e,t){r(e,t)&&n.push(t);}),n},file:function(e,t,r){if(1!==arguments.length)return e=this.root+e,s.call(this,e,t,r),this;if(h(e)){var n=e;return this.filter(function(e,t){return !t.dir&&n.test(e)})}var i=this.files[this.root+e];return i&&!i.dir?i:null},folder:function(r){if(!r)return this;if(h(r))return this.filter(function(e,t){return t.dir&&r.test(e)});var e=this.root+r,t=b.call(this,e),n=this.clone();return n.root=t.name,n},remove:function(r){r=this.root+r;var e=this.files[r];if(e||("/"!==r.slice(-1)&&(r+="/"),e=this.files[r]),e&&!e.dir)delete this.files[r];else for(var t=this.filter(function(e,t){return t.name.slice(0,r.length)===r}),n=0;n<t.length;n++)delete this.files[t[n].name];return this},generate:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},generateInternalStream:function(e){var t,r={};try{if((r=u.extend(e||{},{streamFiles:!1,compression:"STORE",compressionOptions:null,type:"",platform:"DOS",comment:null,mimeType:"application/zip",encodeFileName:i.utf8encode})).type=r.type.toLowerCase(),r.compression=r.compression.toUpperCase(),"binarystring"===r.type&&(r.type="string"),!r.type)throw new Error("No output type specified.");u.checkSupport(r.type),"darwin"!==r.platform&&"freebsd"!==r.platform&&"linux"!==r.platform&&"sunos"!==r.platform||(r.platform="UNIX"),"win32"===r.platform&&(r.platform="DOS");var n=r.comment||this.comment||"";t=o.generateWorker(this,r,n);}catch(e){(t=new l("error")).error(e);}return new a(t,r.type||"string",r.mimeType)},generateAsync:function(e,t){return this.generateInternalStream(e).accumulate(t)},generateNodeStream:function(e,t){return (e=e||{}).type||(e.type="nodebuffer"),this.generateInternalStream(e).toNodejsStream(t)}};t.exports=n;},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(e,t,r){t.exports=e("stream");},{stream:void 0}],17:[function(e,t,r){var n=e("./DataReader");function i(e){n.call(this,e);for(var t=0;t<this.data.length;t++)e[t]=255&e[t];}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data[this.zero+e]},i.prototype.lastIndexOfSignature=function(e){for(var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.length-4;0<=s;--s)if(this.data[s]===t&&this.data[s+1]===r&&this.data[s+2]===n&&this.data[s+3]===i)return s-this.zero;return -1},i.prototype.readAndCheckSignature=function(e){var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.readData(4);return t===s[0]&&r===s[1]&&n===s[2]&&i===s[3]},i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return [];var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i;},{"../utils":32,"./DataReader":18}],18:[function(e,t,r){var n=e("../utils");function i(e){this.data=e,this.length=e.length,this.index=0,this.zero=0;}i.prototype={checkOffset:function(e){this.checkIndex(this.index+e);},checkIndex:function(e){if(this.length<this.zero+e||e<0)throw new Error("End of data reached (data length = "+this.length+", asked index = "+e+"). Corrupted zip ?")},setIndex:function(e){this.checkIndex(e),this.index=e;},skip:function(e){this.setIndex(this.index+e);},byteAt:function(){},readInt:function(e){var t,r=0;for(this.checkOffset(e),t=this.index+e-1;t>=this.index;t--)r=(r<<8)+this.byteAt(t);return this.index+=e,r},readString:function(e){return n.transformTo("string",this.readData(e))},readData:function(){},lastIndexOfSignature:function(){},readAndCheckSignature:function(){},readDate:function(){var e=this.readInt(4);return new Date(Date.UTC(1980+(e>>25&127),(e>>21&15)-1,e>>16&31,e>>11&31,e>>5&63,(31&e)<<1))}},t.exports=i;},{"../utils":32}],19:[function(e,t,r){var n=e("./Uint8ArrayReader");function i(e){n.call(this,e);}e("../utils").inherits(i,n),i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i;},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(e,t,r){var n=e("./DataReader");function i(e){n.call(this,e);}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data.charCodeAt(this.zero+e)},i.prototype.lastIndexOfSignature=function(e){return this.data.lastIndexOf(e)-this.zero},i.prototype.readAndCheckSignature=function(e){return e===this.readData(4)},i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i;},{"../utils":32,"./DataReader":18}],21:[function(e,t,r){var n=e("./ArrayReader");function i(e){n.call(this,e);}e("../utils").inherits(i,n),i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return new Uint8Array(0);var t=this.data.subarray(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i;},{"../utils":32,"./ArrayReader":17}],22:[function(e,t,r){var n=e("../utils"),i=e("../support"),s=e("./ArrayReader"),a=e("./StringReader"),o=e("./NodeBufferReader"),h=e("./Uint8ArrayReader");t.exports=function(e){var t=n.getTypeOf(e);return n.checkSupport(t),"string"!==t||i.uint8array?"nodebuffer"===t?new o(e):i.uint8array?new h(n.transformTo("uint8array",e)):new s(n.transformTo("array",e)):new a(e)};},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(e,t,r){r.LOCAL_FILE_HEADER="PK",r.CENTRAL_FILE_HEADER="PK",r.CENTRAL_DIRECTORY_END="PK",r.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK",r.ZIP64_CENTRAL_DIRECTORY_END="PK",r.DATA_DESCRIPTOR="PK\b";},{}],24:[function(e,t,r){var n=e("./GenericWorker"),i=e("../utils");function s(e){n.call(this,"ConvertWorker to "+e),this.destType=e;}i.inherits(s,n),s.prototype.processChunk=function(e){this.push({data:i.transformTo(this.destType,e.data),meta:e.meta});},t.exports=s;},{"../utils":32,"./GenericWorker":28}],25:[function(e,t,r){var n=e("./GenericWorker"),i=e("../crc32");function s(){n.call(this,"Crc32Probe"),this.withStreamInfo("crc32",0);}e("../utils").inherits(s,n),s.prototype.processChunk=function(e){this.streamInfo.crc32=i(e.data,this.streamInfo.crc32||0),this.push(e);},t.exports=s;},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(e,t,r){var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataLengthProbe for "+e),this.propName=e,this.withStreamInfo(e,0);}n.inherits(s,i),s.prototype.processChunk=function(e){if(e){var t=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=t+e.data.length;}i.prototype.processChunk.call(this,e);},t.exports=s;},{"../utils":32,"./GenericWorker":28}],27:[function(e,t,r){var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataWorker");var t=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type="",this._tickScheduled=!1,e.then(function(e){t.dataIsReady=!0,t.data=e,t.max=e&&e.length||0,t.type=n.getTypeOf(e),t.isPaused||t._tickAndRepeat();},function(e){t.error(e);});}n.inherits(s,i),s.prototype.cleanUp=function(){i.prototype.cleanUp.call(this),this.data=null;},s.prototype.resume=function(){return !!i.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,n.delay(this._tickAndRepeat,[],this)),!0)},s.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(n.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0));},s.prototype._tick=function(){if(this.isPaused||this.isFinished)return !1;var e=null,t=Math.min(this.max,this.index+16384);if(this.index>=this.max)return this.end();switch(this.type){case"string":e=this.data.substring(this.index,t);break;case"uint8array":e=this.data.subarray(this.index,t);break;case"array":case"nodebuffer":e=this.data.slice(this.index,t);}return this.index=t,this.push({data:e,meta:{percent:this.max?this.index/this.max*100:0}})},t.exports=s;},{"../utils":32,"./GenericWorker":28}],28:[function(e,t,r){function n(e){this.name=e||"default",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null;}n.prototype={push:function(e){this.emit("data",e);},end:function(){if(this.isFinished)return !1;this.flush();try{this.emit("end"),this.cleanUp(),this.isFinished=!0;}catch(e){this.emit("error",e);}return !0},error:function(e){return !this.isFinished&&(this.isPaused?this.generatedError=e:(this.isFinished=!0,this.emit("error",e),this.previous&&this.previous.error(e),this.cleanUp()),!0)},on:function(e,t){return this._listeners[e].push(t),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[];},emit:function(e,t){if(this._listeners[e])for(var r=0;r<this._listeners[e].length;r++)this._listeners[e][r].call(this,t);},pipe:function(e){return e.registerPrevious(this)},registerPrevious:function(e){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.streamInfo=e.streamInfo,this.mergeStreamInfo(),this.previous=e;var t=this;return e.on("data",function(e){t.processChunk(e);}),e.on("end",function(){t.end();}),e.on("error",function(e){t.error(e);}),this},pause:function(){return !this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return !1;var e=this.isPaused=!1;return this.generatedError&&(this.error(this.generatedError),e=!0),this.previous&&this.previous.resume(),!e},flush:function(){},processChunk:function(e){this.push(e);},withStreamInfo:function(e,t){return this.extraStreamInfo[e]=t,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo,e)&&(this.streamInfo[e]=this.extraStreamInfo[e]);},lock:function(){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.isLocked=!0,this.previous&&this.previous.lock();},toString:function(){var e="Worker "+this.name;return this.previous?this.previous+" -> "+e:e}},t.exports=n;},{}],29:[function(e,t,r){var h=e("../utils"),i=e("./ConvertWorker"),s=e("./GenericWorker"),u=e("../base64"),n=e("../support"),a=e("../external"),o=null;if(n.nodestream)try{o=e("../nodejs/NodejsStreamOutputAdapter");}catch(e){}function l(e,o){return new a.Promise(function(t,r){var n=[],i=e._internalType,s=e._outputType,a=e._mimeType;e.on("data",function(e,t){n.push(e),o&&o(t);}).on("error",function(e){n=[],r(e);}).on("end",function(){try{var e=function(e,t,r){switch(e){case"blob":return h.newBlob(h.transformTo("arraybuffer",t),r);case"base64":return u.encode(t);default:return h.transformTo(e,t)}}(s,function(e,t){var r,n=0,i=null,s=0;for(r=0;r<t.length;r++)s+=t[r].length;switch(e){case"string":return t.join("");case"array":return Array.prototype.concat.apply([],t);case"uint8array":for(i=new Uint8Array(s),r=0;r<t.length;r++)i.set(t[r],n),n+=t[r].length;return i;case"nodebuffer":return Buffer.concat(t);default:throw new Error("concat : unsupported type '"+e+"'")}}(i,n),a);t(e);}catch(e){r(e);}n=[];}).resume();})}function f(e,t,r){var n=t;switch(t){case"blob":case"arraybuffer":n="uint8array";break;case"base64":n="string";}try{this._internalType=n,this._outputType=t,this._mimeType=r,h.checkSupport(n),this._worker=e.pipe(new i(n)),e.lock();}catch(e){this._worker=new s("error"),this._worker.error(e);}}f.prototype={accumulate:function(e){return l(this,e)},on:function(e,t){var r=this;return "data"===e?this._worker.on(e,function(e){t.call(r,e.data,e.meta);}):this._worker.on(e,function(){h.delay(t,arguments,r);}),this},resume:function(){return h.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(e){if(h.checkSupport("nodestream"),"nodebuffer"!==this._outputType)throw new Error(this._outputType+" is not supported by this method");return new o(this,{objectMode:"nodebuffer"!==this._outputType},e)}},t.exports=f;},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(e,t,r){if(r.base64=!0,r.array=!0,r.string=!0,r.arraybuffer="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,r.nodebuffer="undefined"!=typeof Buffer,r.uint8array="undefined"!=typeof Uint8Array,"undefined"==typeof ArrayBuffer)r.blob=!1;else {var n=new ArrayBuffer(0);try{r.blob=0===new Blob([n],{type:"application/zip"}).size;}catch(e){try{var i=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);i.append(n),r.blob=0===i.getBlob("application/zip").size;}catch(e){r.blob=!1;}}}try{r.nodestream=!!e("readable-stream").Readable;}catch(e){r.nodestream=!1;}},{"readable-stream":16}],31:[function(e,t,s){for(var o=e("./utils"),h=e("./support"),r=e("./nodejsUtils"),n=e("./stream/GenericWorker"),u=new Array(256),i=0;i<256;i++)u[i]=252<=i?6:248<=i?5:240<=i?4:224<=i?3:192<=i?2:1;u[254]=u[254]=1;function a(){n.call(this,"utf-8 decode"),this.leftOver=null;}function l(){n.call(this,"utf-8 encode");}s.utf8encode=function(e){return h.nodebuffer?r.newBufferFrom(e,"utf-8"):function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=h.uint8array?new Uint8Array(o):new Array(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t}(e)},s.utf8decode=function(e){return h.nodebuffer?o.transformTo("nodebuffer",e).toString("utf-8"):function(e){var t,r,n,i,s=e.length,a=new Array(2*s);for(t=r=0;t<s;)if((n=e[t++])<128)a[r++]=n;else if(4<(i=u[n]))a[r++]=65533,t+=i-1;else {for(n&=2===i?31:3===i?15:7;1<i&&t<s;)n=n<<6|63&e[t++],i--;1<i?a[r++]=65533:n<65536?a[r++]=n:(n-=65536,a[r++]=55296|n>>10&1023,a[r++]=56320|1023&n);}return a.length!==r&&(a.subarray?a=a.subarray(0,r):a.length=r),o.applyFromCharCode(a)}(e=o.transformTo(h.uint8array?"uint8array":"array",e))},o.inherits(a,n),a.prototype.processChunk=function(e){var t=o.transformTo(h.uint8array?"uint8array":"array",e.data);if(this.leftOver&&this.leftOver.length){if(h.uint8array){var r=t;(t=new Uint8Array(r.length+this.leftOver.length)).set(this.leftOver,0),t.set(r,this.leftOver.length);}else t=this.leftOver.concat(t);this.leftOver=null;}var n=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}(t),i=t;n!==t.length&&(h.uint8array?(i=t.subarray(0,n),this.leftOver=t.subarray(n,t.length)):(i=t.slice(0,n),this.leftOver=t.slice(n,t.length))),this.push({data:s.utf8decode(i),meta:e.meta});},a.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:s.utf8decode(this.leftOver),meta:{}}),this.leftOver=null);},s.Utf8DecodeWorker=a,o.inherits(l,n),l.prototype.processChunk=function(e){this.push({data:s.utf8encode(e.data),meta:e.meta});},s.Utf8EncodeWorker=l;},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(e,t,a){var o=e("./support"),h=e("./base64"),r=e("./nodejsUtils"),u=e("./external");function n(e){return e}function l(e,t){for(var r=0;r<e.length;++r)t[r]=255&e.charCodeAt(r);return t}e("setimmediate"),a.newBlob=function(t,r){a.checkSupport("blob");try{return new Blob([t],{type:r})}catch(e){try{var n=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);return n.append(t),n.getBlob(r)}catch(e){throw new Error("Bug : can't construct the Blob.")}}};var i={stringifyByChunk:function(e,t,r){var n=[],i=0,s=e.length;if(s<=r)return String.fromCharCode.apply(null,e);for(;i<s;)"array"===t||"nodebuffer"===t?n.push(String.fromCharCode.apply(null,e.slice(i,Math.min(i+r,s)))):n.push(String.fromCharCode.apply(null,e.subarray(i,Math.min(i+r,s)))),i+=r;return n.join("")},stringifyByChar:function(e){for(var t="",r=0;r<e.length;r++)t+=String.fromCharCode(e[r]);return t},applyCanBeUsed:{uint8array:function(){try{return o.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(e){return !1}}(),nodebuffer:function(){try{return o.nodebuffer&&1===String.fromCharCode.apply(null,r.allocBuffer(1)).length}catch(e){return !1}}()}};function s(e){var t=65536,r=a.getTypeOf(e),n=!0;if("uint8array"===r?n=i.applyCanBeUsed.uint8array:"nodebuffer"===r&&(n=i.applyCanBeUsed.nodebuffer),n)for(;1<t;)try{return i.stringifyByChunk(e,r,t)}catch(e){t=Math.floor(t/2);}return i.stringifyByChar(e)}function f(e,t){for(var r=0;r<e.length;r++)t[r]=e[r];return t}a.applyFromCharCode=s;var c={};c.string={string:n,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return c.string.uint8array(e).buffer},uint8array:function(e){return l(e,new Uint8Array(e.length))},nodebuffer:function(e){return l(e,r.allocBuffer(e.length))}},c.array={string:s,array:n,arraybuffer:function(e){return new Uint8Array(e).buffer},uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(e)}},c.arraybuffer={string:function(e){return s(new Uint8Array(e))},array:function(e){return f(new Uint8Array(e),new Array(e.byteLength))},arraybuffer:n,uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(new Uint8Array(e))}},c.uint8array={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return e.buffer},uint8array:n,nodebuffer:function(e){return r.newBufferFrom(e)}},c.nodebuffer={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return c.nodebuffer.uint8array(e).buffer},uint8array:function(e){return f(e,new Uint8Array(e.length))},nodebuffer:n},a.transformTo=function(e,t){if(t=t||"",!e)return t;a.checkSupport(e);var r=a.getTypeOf(t);return c[r][e](t)},a.resolve=function(e){for(var t=e.split("/"),r=[],n=0;n<t.length;n++){var i=t[n];"."===i||""===i&&0!==n&&n!==t.length-1||(".."===i?r.pop():r.push(i));}return r.join("/")},a.getTypeOf=function(e){return "string"==typeof e?"string":"[object Array]"===Object.prototype.toString.call(e)?"array":o.nodebuffer&&r.isBuffer(e)?"nodebuffer":o.uint8array&&e instanceof Uint8Array?"uint8array":o.arraybuffer&&e instanceof ArrayBuffer?"arraybuffer":void 0},a.checkSupport=function(e){if(!o[e.toLowerCase()])throw new Error(e+" is not supported by this platform")},a.MAX_VALUE_16BITS=65535,a.MAX_VALUE_32BITS=-1,a.pretty=function(e){var t,r,n="";for(r=0;r<(e||"").length;r++)n+="\\x"+((t=e.charCodeAt(r))<16?"0":"")+t.toString(16).toUpperCase();return n},a.delay=function(e,t,r){setImmediate(function(){e.apply(r||null,t||[]);});},a.inherits=function(e,t){function r(){}r.prototype=t.prototype,e.prototype=new r;},a.extend=function(){var e,t,r={};for(e=0;e<arguments.length;e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e],t)&&void 0===r[t]&&(r[t]=arguments[e][t]);return r},a.prepareContent=function(r,e,n,i,s){return u.Promise.resolve(e).then(function(n){return o.blob&&(n instanceof Blob||-1!==["[object File]","[object Blob]"].indexOf(Object.prototype.toString.call(n)))&&"undefined"!=typeof FileReader?new u.Promise(function(t,r){var e=new FileReader;e.onload=function(e){t(e.target.result);},e.onerror=function(e){r(e.target.error);},e.readAsArrayBuffer(n);}):n}).then(function(e){var t=a.getTypeOf(e);return t?("arraybuffer"===t?e=a.transformTo("uint8array",e):"string"===t&&(s?e=h.decode(e):n&&!0!==i&&(e=function(e){return l(e,o.uint8array?new Uint8Array(e.length):new Array(e.length))}(e))),e):u.Promise.reject(new Error("Can't read the data of '"+r+"'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))})};},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,setimmediate:54}],33:[function(e,t,r){var n=e("./reader/readerFor"),i=e("./utils"),s=e("./signature"),a=e("./zipEntry"),o=e("./support");function h(e){this.files=[],this.loadOptions=e;}h.prototype={checkSignature:function(e){if(!this.reader.readAndCheckSignature(e)){this.reader.index-=4;var t=this.reader.readString(4);throw new Error("Corrupted zip or bug: unexpected signature ("+i.pretty(t)+", expected "+i.pretty(e)+")")}},isSignature:function(e,t){var r=this.reader.index;this.reader.setIndex(e);var n=this.reader.readString(4)===t;return this.reader.setIndex(r),n},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var e=this.reader.readData(this.zipCommentLength),t=o.uint8array?"uint8array":"array",r=i.transformTo(t,e);this.zipComment=this.loadOptions.decodeFileName(r);},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var e,t,r,n=this.zip64EndOfCentralSize-44;0<n;)e=this.reader.readInt(2),t=this.reader.readInt(4),r=this.reader.readData(t),this.zip64ExtensibleData[e]={id:e,length:t,value:r};},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),1<this.disksCount)throw new Error("Multi-volumes zip are not supported")},readLocalFiles:function(){var e,t;for(e=0;e<this.files.length;e++)t=this.files[e],this.reader.setIndex(t.localHeaderOffset),this.checkSignature(s.LOCAL_FILE_HEADER),t.readLocalPart(this.reader),t.handleUTF8(),t.processAttributes();},readCentralDir:function(){var e;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e=new a({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(e);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error("Corrupted zip or bug: expected "+this.centralDirRecords+" records in central dir, got "+this.files.length)},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);if(e<0)throw !this.isSignature(0,s.LOCAL_FILE_HEADER)?new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html"):new Error("Corrupted zip: can't find end of central directory");this.reader.setIndex(e);var t=e;if(this.checkSignature(s.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===i.MAX_VALUE_16BITS||this.diskWithCentralDirStart===i.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===i.MAX_VALUE_16BITS||this.centralDirRecords===i.MAX_VALUE_16BITS||this.centralDirSize===i.MAX_VALUE_32BITS||this.centralDirOffset===i.MAX_VALUE_32BITS){if(this.zip64=!0,(e=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");if(this.reader.setIndex(e),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,s.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral();}var r=this.centralDirOffset+this.centralDirSize;this.zip64&&(r+=20,r+=12+this.zip64EndOfCentralSize);var n=t-r;if(0<n)this.isSignature(t,s.CENTRAL_FILE_HEADER)||(this.reader.zero=n);else if(n<0)throw new Error("Corrupted zip: missing "+Math.abs(n)+" bytes.")},prepareReader:function(e){this.reader=n(e);},load:function(e){this.prepareReader(e),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles();}},t.exports=h;},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utils":32,"./zipEntry":34}],34:[function(e,t,r){var n=e("./reader/readerFor"),s=e("./utils"),i=e("./compressedObject"),a=e("./crc32"),o=e("./utf8"),h=e("./compressions"),u=e("./support");function l(e,t){this.options=e,this.loadOptions=t;}l.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(e){var t,r;if(e.skip(22),this.fileNameLength=e.readInt(2),r=e.readInt(2),this.fileName=e.readData(this.fileNameLength),e.skip(r),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");if(null===(t=function(e){for(var t in h)if(Object.prototype.hasOwnProperty.call(h,t)&&h[t].magic===e)return h[t];return null}(this.compressionMethod)))throw new Error("Corrupted zip : compression "+s.pretty(this.compressionMethod)+" unknown (inner file : "+s.transformTo("string",this.fileName)+")");this.decompressed=new i(this.compressedSize,this.uncompressedSize,this.crc32,t,e.readData(this.compressedSize));},readCentralPart:function(e){this.versionMadeBy=e.readInt(2),e.skip(2),this.bitFlag=e.readInt(2),this.compressionMethod=e.readString(2),this.date=e.readDate(),this.crc32=e.readInt(4),this.compressedSize=e.readInt(4),this.uncompressedSize=e.readInt(4);var t=e.readInt(2);if(this.extraFieldsLength=e.readInt(2),this.fileCommentLength=e.readInt(2),this.diskNumberStart=e.readInt(2),this.internalFileAttributes=e.readInt(2),this.externalFileAttributes=e.readInt(4),this.localHeaderOffset=e.readInt(4),this.isEncrypted())throw new Error("Encrypted zip are not supported");e.skip(t),this.readExtraFields(e),this.parseZIP64ExtraField(e),this.fileComment=e.readData(this.fileCommentLength);},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var e=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),0==e&&(this.dosPermissions=63&this.externalFileAttributes),3==e&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||"/"!==this.fileNameStr.slice(-1)||(this.dir=!0);},parseZIP64ExtraField:function(){if(this.extraFields[1]){var e=n(this.extraFields[1].value);this.uncompressedSize===s.MAX_VALUE_32BITS&&(this.uncompressedSize=e.readInt(8)),this.compressedSize===s.MAX_VALUE_32BITS&&(this.compressedSize=e.readInt(8)),this.localHeaderOffset===s.MAX_VALUE_32BITS&&(this.localHeaderOffset=e.readInt(8)),this.diskNumberStart===s.MAX_VALUE_32BITS&&(this.diskNumberStart=e.readInt(4));}},readExtraFields:function(e){var t,r,n,i=e.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});e.index+4<i;)t=e.readInt(2),r=e.readInt(2),n=e.readData(r),this.extraFields[t]={id:t,length:r,value:n};e.setIndex(i);},handleUTF8:function(){var e=u.uint8array?"uint8array":"array";if(this.useUTF8())this.fileNameStr=o.utf8decode(this.fileName),this.fileCommentStr=o.utf8decode(this.fileComment);else {var t=this.findExtraFieldUnicodePath();if(null!==t)this.fileNameStr=t;else {var r=s.transformTo(e,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(r);}var n=this.findExtraFieldUnicodeComment();if(null!==n)this.fileCommentStr=n;else {var i=s.transformTo(e,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(i);}}},findExtraFieldUnicodePath:function(){var e=this.extraFields[28789];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileName)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null},findExtraFieldUnicodeComment:function(){var e=this.extraFields[25461];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileComment)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null}},t.exports=l;},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(e,t,r){function n(e,t,r){this.name=e,this.dir=r.dir,this.date=r.date,this.comment=r.comment,this.unixPermissions=r.unixPermissions,this.dosPermissions=r.dosPermissions,this._data=t,this._dataBinary=r.binary,this.options={compression:r.compression,compressionOptions:r.compressionOptions};}var s=e("./stream/StreamHelper"),i=e("./stream/DataWorker"),a=e("./utf8"),o=e("./compressedObject"),h=e("./stream/GenericWorker");n.prototype={internalStream:function(e){var t=null,r="string";try{if(!e)throw new Error("No output type specified.");var n="string"===(r=e.toLowerCase())||"text"===r;"binarystring"!==r&&"text"!==r||(r="string"),t=this._decompressWorker();var i=!this._dataBinary;i&&!n&&(t=t.pipe(new a.Utf8EncodeWorker)),!i&&n&&(t=t.pipe(new a.Utf8DecodeWorker));}catch(e){(t=new h("error")).error(e);}return new s(t,r,"")},async:function(e,t){return this.internalStream(e).accumulate(t)},nodeStream:function(e,t){return this.internalStream(e||"nodebuffer").toNodejsStream(t)},_compressWorker:function(e,t){if(this._data instanceof o&&this._data.compression.magic===e.magic)return this._data.getCompressedWorker();var r=this._decompressWorker();return this._dataBinary||(r=r.pipe(new a.Utf8EncodeWorker)),o.createWorkerFrom(r,e,t)},_decompressWorker:function(){return this._data instanceof o?this._data.getContentWorker():this._data instanceof h?this._data:new i(this._data)}};for(var u=["asText","asBinary","asNodeBuffer","asUint8Array","asArrayBuffer"],l=function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},f=0;f<u.length;f++)n.prototype[u[f]]=l;t.exports=n;},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(e,l,t){(function(t){var r,n,e=t.MutationObserver||t.WebKitMutationObserver;if(e){var i=0,s=new e(u),a=t.document.createTextNode("");s.observe(a,{characterData:!0}),r=function(){a.data=i=++i%2;};}else if(t.setImmediate||void 0===t.MessageChannel)r="document"in t&&"onreadystatechange"in t.document.createElement("script")?function(){var e=t.document.createElement("script");e.onreadystatechange=function(){u(),e.onreadystatechange=null,e.parentNode.removeChild(e),e=null;},t.document.documentElement.appendChild(e);}:function(){setTimeout(u,0);};else {var o=new t.MessageChannel;o.port1.onmessage=u,r=function(){o.port2.postMessage(0);};}var h=[];function u(){var e,t;n=!0;for(var r=h.length;r;){for(t=h,h=[],e=-1;++e<r;)t[e]();r=h.length;}n=!1;}l.exports=function(e){1!==h.push(e)||n||r();};}).call(this,"undefined"!=typeof commonjsGlobal?commonjsGlobal:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{});},{}],37:[function(e,t,r){var i=e("immediate");function u(){}var l={},s=["REJECTED"],a=["FULFILLED"],n=["PENDING"];function o(e){if("function"!=typeof e)throw new TypeError("resolver must be a function");this.state=n,this.queue=[],this.outcome=void 0,e!==u&&d(this,e);}function h(e,t,r){this.promise=e,"function"==typeof t&&(this.onFulfilled=t,this.callFulfilled=this.otherCallFulfilled),"function"==typeof r&&(this.onRejected=r,this.callRejected=this.otherCallRejected);}function f(t,r,n){i(function(){var e;try{e=r(n);}catch(e){return l.reject(t,e)}e===t?l.reject(t,new TypeError("Cannot resolve promise with itself")):l.resolve(t,e);});}function c(e){var t=e&&e.then;if(e&&("object"==typeof e||"function"==typeof e)&&"function"==typeof t)return function(){t.apply(e,arguments);}}function d(t,e){var r=!1;function n(e){r||(r=!0,l.reject(t,e));}function i(e){r||(r=!0,l.resolve(t,e));}var s=p(function(){e(i,n);});"error"===s.status&&n(s.value);}function p(e,t){var r={};try{r.value=e(t),r.status="success";}catch(e){r.status="error",r.value=e;}return r}(t.exports=o).prototype.finally=function(t){if("function"!=typeof t)return this;var r=this.constructor;return this.then(function(e){return r.resolve(t()).then(function(){return e})},function(e){return r.resolve(t()).then(function(){throw e})})},o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){if("function"!=typeof e&&this.state===a||"function"!=typeof t&&this.state===s)return this;var r=new this.constructor(u);this.state!==n?f(r,this.state===a?e:t,this.outcome):this.queue.push(new h(r,e,t));return r},h.prototype.callFulfilled=function(e){l.resolve(this.promise,e);},h.prototype.otherCallFulfilled=function(e){f(this.promise,this.onFulfilled,e);},h.prototype.callRejected=function(e){l.reject(this.promise,e);},h.prototype.otherCallRejected=function(e){f(this.promise,this.onRejected,e);},l.resolve=function(e,t){var r=p(c,t);if("error"===r.status)return l.reject(e,r.value);var n=r.value;if(n)d(e,n);else {e.state=a,e.outcome=t;for(var i=-1,s=e.queue.length;++i<s;)e.queue[i].callFulfilled(t);}return e},l.reject=function(e,t){e.state=s,e.outcome=t;for(var r=-1,n=e.queue.length;++r<n;)e.queue[r].callRejected(t);return e},o.resolve=function(e){if(e instanceof this)return e;return l.resolve(new this(u),e)},o.reject=function(e){var t=new this(u);return l.reject(t,e)},o.all=function(e){var r=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var n=e.length,i=!1;if(!n)return this.resolve([]);var s=new Array(n),a=0,t=-1,o=new this(u);for(;++t<n;)h(e[t],t);return o;function h(e,t){r.resolve(e).then(function(e){s[t]=e,++a!==n||i||(i=!0,l.resolve(o,s));},function(e){i||(i=!0,l.reject(o,e));});}},o.race=function(e){var t=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var r=e.length,n=!1;if(!r)return this.resolve([]);var i=-1,s=new this(u);for(;++i<r;)a=e[i],t.resolve(a).then(function(e){n||(n=!0,l.resolve(s,e));},function(e){n||(n=!0,l.reject(s,e));});var a;return s};},{immediate:36}],38:[function(e,t,r){var n={};(0, e("./lib/utils/common").assign)(n,e("./lib/deflate"),e("./lib/inflate"),e("./lib/zlib/constants")),t.exports=n;},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(e,t,r){var a=e("./zlib/deflate"),o=e("./utils/common"),h=e("./utils/strings"),i=e("./zlib/messages"),s=e("./zlib/zstream"),u=Object.prototype.toString,l=0,f=-1,c=0,d=8;function p(e){if(!(this instanceof p))return new p(e);this.options=o.assign({level:f,method:d,chunkSize:16384,windowBits:15,memLevel:8,strategy:c,to:""},e||{});var t=this.options;t.raw&&0<t.windowBits?t.windowBits=-t.windowBits:t.gzip&&0<t.windowBits&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new s,this.strm.avail_out=0;var r=a.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(r!==l)throw new Error(i[r]);if(t.header&&a.deflateSetHeader(this.strm,t.header),t.dictionary){var n;if(n="string"==typeof t.dictionary?h.string2buf(t.dictionary):"[object ArrayBuffer]"===u.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(r=a.deflateSetDictionary(this.strm,n))!==l)throw new Error(i[r]);this._dict_set=!0;}}function n(e,t){var r=new p(t);if(r.push(e,!0),r.err)throw r.msg||i[r.err];return r.result}p.prototype.push=function(e,t){var r,n,i=this.strm,s=this.options.chunkSize;if(this.ended)return !1;n=t===~~t?t:!0===t?4:0,"string"==typeof e?i.input=h.string2buf(e):"[object ArrayBuffer]"===u.call(e)?i.input=new Uint8Array(e):i.input=e,i.next_in=0,i.avail_in=i.input.length;do{if(0===i.avail_out&&(i.output=new o.Buf8(s),i.next_out=0,i.avail_out=s),1!==(r=a.deflate(i,n))&&r!==l)return this.onEnd(r),!(this.ended=!0);0!==i.avail_out&&(0!==i.avail_in||4!==n&&2!==n)||("string"===this.options.to?this.onData(h.buf2binstring(o.shrinkBuf(i.output,i.next_out))):this.onData(o.shrinkBuf(i.output,i.next_out)));}while((0<i.avail_in||0===i.avail_out)&&1!==r);return 4===n?(r=a.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===l):2!==n||(this.onEnd(l),!(i.avail_out=0))},p.prototype.onData=function(e){this.chunks.push(e);},p.prototype.onEnd=function(e){e===l&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=o.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg;},r.Deflate=p,r.deflate=n,r.deflateRaw=function(e,t){return (t=t||{}).raw=!0,n(e,t)},r.gzip=function(e,t){return (t=t||{}).gzip=!0,n(e,t)};},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(e,t,r){var c=e("./zlib/inflate"),d=e("./utils/common"),p=e("./utils/strings"),m=e("./zlib/constants"),n=e("./zlib/messages"),i=e("./zlib/zstream"),s=e("./zlib/gzheader"),_=Object.prototype.toString;function a(e){if(!(this instanceof a))return new a(e);this.options=d.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&0<=t.windowBits&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(0<=t.windowBits&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),15<t.windowBits&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new i,this.strm.avail_out=0;var r=c.inflateInit2(this.strm,t.windowBits);if(r!==m.Z_OK)throw new Error(n[r]);this.header=new s,c.inflateGetHeader(this.strm,this.header);}function o(e,t){var r=new a(t);if(r.push(e,!0),r.err)throw r.msg||n[r.err];return r.result}a.prototype.push=function(e,t){var r,n,i,s,a,o,h=this.strm,u=this.options.chunkSize,l=this.options.dictionary,f=!1;if(this.ended)return !1;n=t===~~t?t:!0===t?m.Z_FINISH:m.Z_NO_FLUSH,"string"==typeof e?h.input=p.binstring2buf(e):"[object ArrayBuffer]"===_.call(e)?h.input=new Uint8Array(e):h.input=e,h.next_in=0,h.avail_in=h.input.length;do{if(0===h.avail_out&&(h.output=new d.Buf8(u),h.next_out=0,h.avail_out=u),(r=c.inflate(h,m.Z_NO_FLUSH))===m.Z_NEED_DICT&&l&&(o="string"==typeof l?p.string2buf(l):"[object ArrayBuffer]"===_.call(l)?new Uint8Array(l):l,r=c.inflateSetDictionary(this.strm,o)),r===m.Z_BUF_ERROR&&!0===f&&(r=m.Z_OK,f=!1),r!==m.Z_STREAM_END&&r!==m.Z_OK)return this.onEnd(r),!(this.ended=!0);h.next_out&&(0!==h.avail_out&&r!==m.Z_STREAM_END&&(0!==h.avail_in||n!==m.Z_FINISH&&n!==m.Z_SYNC_FLUSH)||("string"===this.options.to?(i=p.utf8border(h.output,h.next_out),s=h.next_out-i,a=p.buf2string(h.output,i),h.next_out=s,h.avail_out=u-s,s&&d.arraySet(h.output,h.output,i,s,0),this.onData(a)):this.onData(d.shrinkBuf(h.output,h.next_out)))),0===h.avail_in&&0===h.avail_out&&(f=!0);}while((0<h.avail_in||0===h.avail_out)&&r!==m.Z_STREAM_END);return r===m.Z_STREAM_END&&(n=m.Z_FINISH),n===m.Z_FINISH?(r=c.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===m.Z_OK):n!==m.Z_SYNC_FLUSH||(this.onEnd(m.Z_OK),!(h.avail_out=0))},a.prototype.onData=function(e){this.chunks.push(e);},a.prototype.onEnd=function(e){e===m.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=d.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg;},r.Inflate=a,r.inflate=o,r.inflateRaw=function(e,t){return (t=t||{}).raw=!0,o(e,t)},r.ungzip=o;},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(e,t,r){var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;r.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var r=t.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var n in r)r.hasOwnProperty(n)&&(e[n]=r[n]);}}return e},r.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var i={arraySet:function(e,t,r,n,i){if(t.subarray&&e.subarray)e.set(t.subarray(r,r+n),i);else for(var s=0;s<n;s++)e[i+s]=t[r+s];},flattenChunks:function(e){var t,r,n,i,s,a;for(t=n=0,r=e.length;t<r;t++)n+=e[t].length;for(a=new Uint8Array(n),t=i=0,r=e.length;t<r;t++)s=e[t],a.set(s,i),i+=s.length;return a}},s={arraySet:function(e,t,r,n,i){for(var s=0;s<n;s++)e[i+s]=t[r+s];},flattenChunks:function(e){return [].concat.apply([],e)}};r.setTyped=function(e){e?(r.Buf8=Uint8Array,r.Buf16=Uint16Array,r.Buf32=Int32Array,r.assign(r,i)):(r.Buf8=Array,r.Buf16=Array,r.Buf32=Array,r.assign(r,s));},r.setTyped(n);},{}],42:[function(e,t,r){var h=e("./common"),i=!0,s=!0;try{String.fromCharCode.apply(null,[0]);}catch(e){i=!1;}try{String.fromCharCode.apply(null,new Uint8Array(1));}catch(e){s=!1;}for(var u=new h.Buf8(256),n=0;n<256;n++)u[n]=252<=n?6:248<=n?5:240<=n?4:224<=n?3:192<=n?2:1;function l(e,t){if(t<65537&&(e.subarray&&s||!e.subarray&&i))return String.fromCharCode.apply(null,h.shrinkBuf(e,t));for(var r="",n=0;n<t;n++)r+=String.fromCharCode(e[n]);return r}u[254]=u[254]=1,r.string2buf=function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=new h.Buf8(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t},r.buf2binstring=function(e){return l(e,e.length)},r.binstring2buf=function(e){for(var t=new h.Buf8(e.length),r=0,n=t.length;r<n;r++)t[r]=e.charCodeAt(r);return t},r.buf2string=function(e,t){var r,n,i,s,a=t||e.length,o=new Array(2*a);for(r=n=0;r<a;)if((i=e[r++])<128)o[n++]=i;else if(4<(s=u[i]))o[n++]=65533,r+=s-1;else {for(i&=2===s?31:3===s?15:7;1<s&&r<a;)i=i<<6|63&e[r++],s--;1<s?o[n++]=65533:i<65536?o[n++]=i:(i-=65536,o[n++]=55296|i>>10&1023,o[n++]=56320|1023&i);}return l(o,n)},r.utf8border=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t};},{"./common":41}],43:[function(e,t,r){t.exports=function(e,t,r,n){for(var i=65535&e|0,s=e>>>16&65535|0,a=0;0!==r;){for(r-=a=2e3<r?2e3:r;s=s+(i=i+t[n++]|0)|0,--a;);i%=65521,s%=65521;}return i|s<<16|0};},{}],44:[function(e,t,r){t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};},{}],45:[function(e,t,r){var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e;}return t}();t.exports=function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return -1^e};},{}],46:[function(e,t,r){var h,c=e("../utils/common"),u=e("./trees"),d=e("./adler32"),p=e("./crc32"),n=e("./messages"),l=0,f=4,m=0,_=-2,g=-1,b=4,i=2,v=8,y=9,s=286,a=30,o=19,w=2*s+1,k=15,x=3,S=258,z=S+x+1,C=42,E=113,A=1,I=2,O=3,B=4;function R(e,t){return e.msg=n[t],t}function T(e){return (e<<1)-(4<e?9:0)}function D(e){for(var t=e.length;0<=--t;)e[t]=0;}function F(e){var t=e.state,r=t.pending;r>e.avail_out&&(r=e.avail_out),0!==r&&(c.arraySet(e.output,t.pending_buf,t.pending_out,r,e.next_out),e.next_out+=r,t.pending_out+=r,e.total_out+=r,e.avail_out-=r,t.pending-=r,0===t.pending&&(t.pending_out=0));}function N(e,t){u._tr_flush_block(e,0<=e.block_start?e.block_start:-1,e.strstart-e.block_start,t),e.block_start=e.strstart,F(e.strm);}function U(e,t){e.pending_buf[e.pending++]=t;}function P(e,t){e.pending_buf[e.pending++]=t>>>8&255,e.pending_buf[e.pending++]=255&t;}function L(e,t){var r,n,i=e.max_chain_length,s=e.strstart,a=e.prev_length,o=e.nice_match,h=e.strstart>e.w_size-z?e.strstart-(e.w_size-z):0,u=e.window,l=e.w_mask,f=e.prev,c=e.strstart+S,d=u[s+a-1],p=u[s+a];e.prev_length>=e.good_match&&(i>>=2),o>e.lookahead&&(o=e.lookahead);do{if(u[(r=t)+a]===p&&u[r+a-1]===d&&u[r]===u[s]&&u[++r]===u[s+1]){s+=2,r++;do{}while(u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&s<c);if(n=S-(c-s),s=c-S,a<n){if(e.match_start=t,o<=(a=n))break;d=u[s+a-1],p=u[s+a];}}}while((t=f[t&l])>h&&0!=--i);return a<=e.lookahead?a:e.lookahead}function j(e){var t,r,n,i,s,a,o,h,u,l,f=e.w_size;do{if(i=e.window_size-e.lookahead-e.strstart,e.strstart>=f+(f-z)){for(c.arraySet(e.window,e.window,f,f,0),e.match_start-=f,e.strstart-=f,e.block_start-=f,t=r=e.hash_size;n=e.head[--t],e.head[t]=f<=n?n-f:0,--r;);for(t=r=f;n=e.prev[--t],e.prev[t]=f<=n?n-f:0,--r;);i+=f;}if(0===e.strm.avail_in)break;if(a=e.strm,o=e.window,h=e.strstart+e.lookahead,u=i,l=void 0,l=a.avail_in,u<l&&(l=u),r=0===l?0:(a.avail_in-=l,c.arraySet(o,a.input,a.next_in,l,h),1===a.state.wrap?a.adler=d(a.adler,o,l,h):2===a.state.wrap&&(a.adler=p(a.adler,o,l,h)),a.next_in+=l,a.total_in+=l,l),e.lookahead+=r,e.lookahead+e.insert>=x)for(s=e.strstart-e.insert,e.ins_h=e.window[s],e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+1])&e.hash_mask;e.insert&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+x-1])&e.hash_mask,e.prev[s&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=s,s++,e.insert--,!(e.lookahead+e.insert<x)););}while(e.lookahead<z&&0!==e.strm.avail_in)}function Z(e,t){for(var r,n;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!==r&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r)),e.match_length>=x)if(n=u._tr_tally(e,e.strstart-e.match_start,e.match_length-x),e.lookahead-=e.match_length,e.match_length<=e.max_lazy_match&&e.lookahead>=x){for(e.match_length--;e.strstart++,e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart,0!=--e.match_length;);e.strstart++;}else e.strstart+=e.match_length,e.match_length=0,e.ins_h=e.window[e.strstart],e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask;else n=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++;if(n&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function W(e,t){for(var r,n,i;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),e.prev_length=e.match_length,e.prev_match=e.match_start,e.match_length=x-1,0!==r&&e.prev_length<e.max_lazy_match&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r),e.match_length<=5&&(1===e.strategy||e.match_length===x&&4096<e.strstart-e.match_start)&&(e.match_length=x-1)),e.prev_length>=x&&e.match_length<=e.prev_length){for(i=e.strstart+e.lookahead-x,n=u._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-x),e.lookahead-=e.prev_length-1,e.prev_length-=2;++e.strstart<=i&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!=--e.prev_length;);if(e.match_available=0,e.match_length=x-1,e.strstart++,n&&(N(e,!1),0===e.strm.avail_out))return A}else if(e.match_available){if((n=u._tr_tally(e,0,e.window[e.strstart-1]))&&N(e,!1),e.strstart++,e.lookahead--,0===e.strm.avail_out)return A}else e.match_available=1,e.strstart++,e.lookahead--;}return e.match_available&&(n=u._tr_tally(e,0,e.window[e.strstart-1]),e.match_available=0),e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function M(e,t,r,n,i){this.good_length=e,this.max_lazy=t,this.nice_length=r,this.max_chain=n,this.func=i;}function H(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=v,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new c.Buf16(2*w),this.dyn_dtree=new c.Buf16(2*(2*a+1)),this.bl_tree=new c.Buf16(2*(2*o+1)),D(this.dyn_ltree),D(this.dyn_dtree),D(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new c.Buf16(k+1),this.heap=new c.Buf16(2*s+1),D(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new c.Buf16(2*s+1),D(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0;}function G(e){var t;return e&&e.state?(e.total_in=e.total_out=0,e.data_type=i,(t=e.state).pending=0,t.pending_out=0,t.wrap<0&&(t.wrap=-t.wrap),t.status=t.wrap?C:E,e.adler=2===t.wrap?0:1,t.last_flush=l,u._tr_init(t),m):R(e,_)}function K(e){var t=G(e);return t===m&&function(e){e.window_size=2*e.w_size,D(e.head),e.max_lazy_match=h[e.level].max_lazy,e.good_match=h[e.level].good_length,e.nice_match=h[e.level].nice_length,e.max_chain_length=h[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=x-1,e.match_available=0,e.ins_h=0;}(e.state),t}function Y(e,t,r,n,i,s){if(!e)return _;var a=1;if(t===g&&(t=6),n<0?(a=0,n=-n):15<n&&(a=2,n-=16),i<1||y<i||r!==v||n<8||15<n||t<0||9<t||s<0||b<s)return R(e,_);8===n&&(n=9);var o=new H;return (e.state=o).strm=e,o.wrap=a,o.gzhead=null,o.w_bits=n,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=i+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+x-1)/x),o.window=new c.Buf8(2*o.w_size),o.head=new c.Buf16(o.hash_size),o.prev=new c.Buf16(o.w_size),o.lit_bufsize=1<<i+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new c.Buf8(o.pending_buf_size),o.d_buf=1*o.lit_bufsize,o.l_buf=3*o.lit_bufsize,o.level=t,o.strategy=s,o.method=r,K(e)}h=[new M(0,0,0,0,function(e,t){var r=65535;for(r>e.pending_buf_size-5&&(r=e.pending_buf_size-5);;){if(e.lookahead<=1){if(j(e),0===e.lookahead&&t===l)return A;if(0===e.lookahead)break}e.strstart+=e.lookahead,e.lookahead=0;var n=e.block_start+r;if((0===e.strstart||e.strstart>=n)&&(e.lookahead=e.strstart-n,e.strstart=n,N(e,!1),0===e.strm.avail_out))return A;if(e.strstart-e.block_start>=e.w_size-z&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):(e.strstart>e.block_start&&(N(e,!1),e.strm.avail_out),A)}),new M(4,4,8,4,Z),new M(4,5,16,8,Z),new M(4,6,32,32,Z),new M(4,4,16,16,W),new M(8,16,32,32,W),new M(8,16,128,128,W),new M(8,32,128,256,W),new M(32,128,258,1024,W),new M(32,258,258,4096,W)],r.deflateInit=function(e,t){return Y(e,t,v,15,8,0)},r.deflateInit2=Y,r.deflateReset=K,r.deflateResetKeep=G,r.deflateSetHeader=function(e,t){return e&&e.state?2!==e.state.wrap?_:(e.state.gzhead=t,m):_},r.deflate=function(e,t){var r,n,i,s;if(!e||!e.state||5<t||t<0)return e?R(e,_):_;if(n=e.state,!e.output||!e.input&&0!==e.avail_in||666===n.status&&t!==f)return R(e,0===e.avail_out?-5:_);if(n.strm=e,r=n.last_flush,n.last_flush=t,n.status===C)if(2===n.wrap)e.adler=0,U(n,31),U(n,139),U(n,8),n.gzhead?(U(n,(n.gzhead.text?1:0)+(n.gzhead.hcrc?2:0)+(n.gzhead.extra?4:0)+(n.gzhead.name?8:0)+(n.gzhead.comment?16:0)),U(n,255&n.gzhead.time),U(n,n.gzhead.time>>8&255),U(n,n.gzhead.time>>16&255),U(n,n.gzhead.time>>24&255),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,255&n.gzhead.os),n.gzhead.extra&&n.gzhead.extra.length&&(U(n,255&n.gzhead.extra.length),U(n,n.gzhead.extra.length>>8&255)),n.gzhead.hcrc&&(e.adler=p(e.adler,n.pending_buf,n.pending,0)),n.gzindex=0,n.status=69):(U(n,0),U(n,0),U(n,0),U(n,0),U(n,0),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,3),n.status=E);else {var a=v+(n.w_bits-8<<4)<<8;a|=(2<=n.strategy||n.level<2?0:n.level<6?1:6===n.level?2:3)<<6,0!==n.strstart&&(a|=32),a+=31-a%31,n.status=E,P(n,a),0!==n.strstart&&(P(n,e.adler>>>16),P(n,65535&e.adler)),e.adler=1;}if(69===n.status)if(n.gzhead.extra){for(i=n.pending;n.gzindex<(65535&n.gzhead.extra.length)&&(n.pending!==n.pending_buf_size||(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending!==n.pending_buf_size));)U(n,255&n.gzhead.extra[n.gzindex]),n.gzindex++;n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),n.gzindex===n.gzhead.extra.length&&(n.gzindex=0,n.status=73);}else n.status=73;if(73===n.status)if(n.gzhead.name){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.name.length?255&n.gzhead.name.charCodeAt(n.gzindex++):0,U(n,s);}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.gzindex=0,n.status=91);}else n.status=91;if(91===n.status)if(n.gzhead.comment){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.comment.length?255&n.gzhead.comment.charCodeAt(n.gzindex++):0,U(n,s);}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.status=103);}else n.status=103;if(103===n.status&&(n.gzhead.hcrc?(n.pending+2>n.pending_buf_size&&F(e),n.pending+2<=n.pending_buf_size&&(U(n,255&e.adler),U(n,e.adler>>8&255),e.adler=0,n.status=E)):n.status=E),0!==n.pending){if(F(e),0===e.avail_out)return n.last_flush=-1,m}else if(0===e.avail_in&&T(t)<=T(r)&&t!==f)return R(e,-5);if(666===n.status&&0!==e.avail_in)return R(e,-5);if(0!==e.avail_in||0!==n.lookahead||t!==l&&666!==n.status){var o=2===n.strategy?function(e,t){for(var r;;){if(0===e.lookahead&&(j(e),0===e.lookahead)){if(t===l)return A;break}if(e.match_length=0,r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++,r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):3===n.strategy?function(e,t){for(var r,n,i,s,a=e.window;;){if(e.lookahead<=S){if(j(e),e.lookahead<=S&&t===l)return A;if(0===e.lookahead)break}if(e.match_length=0,e.lookahead>=x&&0<e.strstart&&(n=a[i=e.strstart-1])===a[++i]&&n===a[++i]&&n===a[++i]){s=e.strstart+S;do{}while(n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&i<s);e.match_length=S-(s-i),e.match_length>e.lookahead&&(e.match_length=e.lookahead);}if(e.match_length>=x?(r=u._tr_tally(e,1,e.match_length-x),e.lookahead-=e.match_length,e.strstart+=e.match_length,e.match_length=0):(r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++),r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):h[n.level].func(n,t);if(o!==O&&o!==B||(n.status=666),o===A||o===O)return 0===e.avail_out&&(n.last_flush=-1),m;if(o===I&&(1===t?u._tr_align(n):5!==t&&(u._tr_stored_block(n,0,0,!1),3===t&&(D(n.head),0===n.lookahead&&(n.strstart=0,n.block_start=0,n.insert=0))),F(e),0===e.avail_out))return n.last_flush=-1,m}return t!==f?m:n.wrap<=0?1:(2===n.wrap?(U(n,255&e.adler),U(n,e.adler>>8&255),U(n,e.adler>>16&255),U(n,e.adler>>24&255),U(n,255&e.total_in),U(n,e.total_in>>8&255),U(n,e.total_in>>16&255),U(n,e.total_in>>24&255)):(P(n,e.adler>>>16),P(n,65535&e.adler)),F(e),0<n.wrap&&(n.wrap=-n.wrap),0!==n.pending?m:1)},r.deflateEnd=function(e){var t;return e&&e.state?(t=e.state.status)!==C&&69!==t&&73!==t&&91!==t&&103!==t&&t!==E&&666!==t?R(e,_):(e.state=null,t===E?R(e,-3):m):_},r.deflateSetDictionary=function(e,t){var r,n,i,s,a,o,h,u,l=t.length;if(!e||!e.state)return _;if(2===(s=(r=e.state).wrap)||1===s&&r.status!==C||r.lookahead)return _;for(1===s&&(e.adler=d(e.adler,t,l,0)),r.wrap=0,l>=r.w_size&&(0===s&&(D(r.head),r.strstart=0,r.block_start=0,r.insert=0),u=new c.Buf8(r.w_size),c.arraySet(u,t,l-r.w_size,r.w_size,0),t=u,l=r.w_size),a=e.avail_in,o=e.next_in,h=e.input,e.avail_in=l,e.next_in=0,e.input=t,j(r);r.lookahead>=x;){for(n=r.strstart,i=r.lookahead-(x-1);r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+x-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++,--i;);r.strstart=n,r.lookahead=x-1,j(r);}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=x-1,r.match_available=0,e.next_in=o,e.input=h,e.avail_in=a,r.wrap=s,m},r.deflateInfo="pako deflate (from Nodeca project)";},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(e,t,r){t.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1;};},{}],48:[function(e,t,r){t.exports=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C;r=e.state,n=e.next_in,z=e.input,i=n+(e.avail_in-5),s=e.next_out,C=e.output,a=s-(t-e.avail_out),o=s+(e.avail_out-257),h=r.dmax,u=r.wsize,l=r.whave,f=r.wnext,c=r.window,d=r.hold,p=r.bits,m=r.lencode,_=r.distcode,g=(1<<r.lenbits)-1,b=(1<<r.distbits)-1;e:do{p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=m[d&g];t:for(;;){if(d>>>=y=v>>>24,p-=y,0===(y=v>>>16&255))C[s++]=65535&v;else {if(!(16&y)){if(0==(64&y)){v=m[(65535&v)+(d&(1<<y)-1)];continue t}if(32&y){r.mode=12;break e}e.msg="invalid literal/length code",r.mode=30;break e}w=65535&v,(y&=15)&&(p<y&&(d+=z[n++]<<p,p+=8),w+=d&(1<<y)-1,d>>>=y,p-=y),p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=_[d&b];r:for(;;){if(d>>>=y=v>>>24,p-=y,!(16&(y=v>>>16&255))){if(0==(64&y)){v=_[(65535&v)+(d&(1<<y)-1)];continue r}e.msg="invalid distance code",r.mode=30;break e}if(k=65535&v,p<(y&=15)&&(d+=z[n++]<<p,(p+=8)<y&&(d+=z[n++]<<p,p+=8)),h<(k+=d&(1<<y)-1)){e.msg="invalid distance too far back",r.mode=30;break e}if(d>>>=y,p-=y,(y=s-a)<k){if(l<(y=k-y)&&r.sane){e.msg="invalid distance too far back",r.mode=30;break e}if(S=c,(x=0)===f){if(x+=u-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C;}}else if(f<y){if(x+=u+f-y,(y-=f)<w){for(w-=y;C[s++]=c[x++],--y;);if(x=0,f<w){for(w-=y=f;C[s++]=c[x++],--y;);x=s-k,S=C;}}}else if(x+=f-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C;}for(;2<w;)C[s++]=S[x++],C[s++]=S[x++],C[s++]=S[x++],w-=3;w&&(C[s++]=S[x++],1<w&&(C[s++]=S[x++]));}else {for(x=s-k;C[s++]=C[x++],C[s++]=C[x++],C[s++]=C[x++],2<(w-=3););w&&(C[s++]=C[x++],1<w&&(C[s++]=C[x++]));}break}}break}}while(n<i&&s<o);n-=w=p>>3,d&=(1<<(p-=w<<3))-1,e.next_in=n,e.next_out=s,e.avail_in=n<i?i-n+5:5-(n-i),e.avail_out=s<o?o-s+257:257-(s-o),r.hold=d,r.bits=p;};},{}],49:[function(e,t,r){var I=e("../utils/common"),O=e("./adler32"),B=e("./crc32"),R=e("./inffast"),T=e("./inftrees"),D=1,F=2,N=0,U=-2,P=1,n=852,i=592;function L(e){return (e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function s(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new I.Buf16(320),this.work=new I.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0;}function a(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=P,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new I.Buf32(n),t.distcode=t.distdyn=new I.Buf32(i),t.sane=1,t.back=-1,N):U}function o(e){var t;return e&&e.state?((t=e.state).wsize=0,t.whave=0,t.wnext=0,a(e)):U}function h(e,t){var r,n;return e&&e.state?(n=e.state,t<0?(r=0,t=-t):(r=1+(t>>4),t<48&&(t&=15)),t&&(t<8||15<t)?U:(null!==n.window&&n.wbits!==t&&(n.window=null),n.wrap=r,n.wbits=t,o(e))):U}function u(e,t){var r,n;return e?(n=new s,(e.state=n).window=null,(r=h(e,t))!==N&&(e.state=null),r):U}var l,f,c=!0;function j(e){if(c){var t;for(l=new I.Buf32(512),f=new I.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(T(D,e.lens,0,288,l,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;T(F,e.lens,0,32,f,0,e.work,{bits:5}),c=!1;}e.lencode=l,e.lenbits=9,e.distcode=f,e.distbits=5;}function Z(e,t,r,n){var i,s=e.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new I.Buf8(s.wsize)),n>=s.wsize?(I.arraySet(s.window,t,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):(n<(i=s.wsize-s.wnext)&&(i=n),I.arraySet(s.window,t,r-n,i,s.wnext),(n-=i)?(I.arraySet(s.window,t,r-n,n,0),s.wnext=n,s.whave=s.wsize):(s.wnext+=i,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=i))),0}r.inflateReset=o,r.inflateReset2=h,r.inflateResetKeep=a,r.inflateInit=function(e){return u(e,15)},r.inflateInit2=u,r.inflate=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C=0,E=new I.Buf8(4),A=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return U;12===(r=e.state).mode&&(r.mode=13),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,f=o,c=h,x=N;e:for(;;)switch(r.mode){case P:if(0===r.wrap){r.mode=13;break}for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}if(2&r.wrap&&35615===u){E[r.check=0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0),l=u=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&u)<<8)+(u>>8))%31){e.msg="incorrect header check",r.mode=30;break}if(8!=(15&u)){e.msg="unknown compression method",r.mode=30;break}if(l-=4,k=8+(15&(u>>>=4)),0===r.wbits)r.wbits=k;else if(k>r.wbits){e.msg="invalid window size",r.mode=30;break}r.dmax=1<<k,e.adler=r.check=1,r.mode=512&u?10:12,l=u=0;break;case 2:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}if(r.flags=u,8!=(255&r.flags)){e.msg="unknown compression method",r.mode=30;break}if(57344&r.flags){e.msg="unknown header flags set",r.mode=30;break}r.head&&(r.head.text=u>>8&1),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=3;case 3:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}r.head&&(r.head.time=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,E[2]=u>>>16&255,E[3]=u>>>24&255,r.check=B(r.check,E,4,0)),l=u=0,r.mode=4;case 4:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}r.head&&(r.head.xflags=255&u,r.head.os=u>>8),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=5;case 5:if(1024&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}r.length=u,r.head&&(r.head.extra_len=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0;}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&(o<(d=r.length)&&(d=o),d&&(r.head&&(k=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),I.arraySet(r.head.extra,n,s,d,k)),512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,r.length-=d),r.length))break e;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.name+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.comment+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}if(u!==(65535&r.check)){e.msg="header crc mismatch",r.mode=30;break}l=u=0;}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),e.adler=r.check=0,r.mode=12;break;case 10:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}e.adler=r.check=L(u),l=u=0,r.mode=11;case 11:if(0===r.havedict)return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,2;e.adler=r.check=1,r.mode=12;case 12:if(5===t||6===t)break e;case 13:if(r.last){u>>>=7&l,l-=7&l,r.mode=27;break}for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}switch(r.last=1&u,l-=1,3&(u>>>=1)){case 0:r.mode=14;break;case 1:if(j(r),r.mode=20,6!==t)break;u>>>=2,l-=2;break e;case 2:r.mode=17;break;case 3:e.msg="invalid block type",r.mode=30;}u>>>=2,l-=2;break;case 14:for(u>>>=7&l,l-=7&l;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}if((65535&u)!=(u>>>16^65535)){e.msg="invalid stored block lengths",r.mode=30;break}if(r.length=65535&u,l=u=0,r.mode=15,6===t)break e;case 15:r.mode=16;case 16:if(d=r.length){if(o<d&&(d=o),h<d&&(d=h),0===d)break e;I.arraySet(i,n,s,d,a),o-=d,s+=d,h-=d,a+=d,r.length-=d;break}r.mode=12;break;case 17:for(;l<14;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}if(r.nlen=257+(31&u),u>>>=5,l-=5,r.ndist=1+(31&u),u>>>=5,l-=5,r.ncode=4+(15&u),u>>>=4,l-=4,286<r.nlen||30<r.ndist){e.msg="too many length or distance symbols",r.mode=30;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}r.lens[A[r.have++]]=7&u,u>>>=3,l-=3;}for(;r.have<19;)r.lens[A[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,S={bits:r.lenbits},x=T(0,r.lens,0,19,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid code lengths set",r.mode=30;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}if(b<16)u>>>=_,l-=_,r.lens[r.have++]=b;else {if(16===b){for(z=_+2;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}if(u>>>=_,l-=_,0===r.have){e.msg="invalid bit length repeat",r.mode=30;break}k=r.lens[r.have-1],d=3+(3&u),u>>>=2,l-=2;}else if(17===b){for(z=_+3;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}l-=_,k=0,d=3+(7&(u>>>=_)),u>>>=3,l-=3;}else {for(z=_+7;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}l-=_,k=0,d=11+(127&(u>>>=_)),u>>>=7,l-=7;}if(r.have+d>r.nlen+r.ndist){e.msg="invalid bit length repeat",r.mode=30;break}for(;d--;)r.lens[r.have++]=k;}}if(30===r.mode)break;if(0===r.lens[256]){e.msg="invalid code -- missing end-of-block",r.mode=30;break}if(r.lenbits=9,S={bits:r.lenbits},x=T(D,r.lens,0,r.nlen,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid literal/lengths set",r.mode=30;break}if(r.distbits=6,r.distcode=r.distdyn,S={bits:r.distbits},x=T(F,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,S),r.distbits=S.bits,x){e.msg="invalid distances set",r.mode=30;break}if(r.mode=20,6===t)break e;case 20:r.mode=21;case 21:if(6<=o&&258<=h){e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,R(e,c),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,12===r.mode&&(r.back=-1);break}for(r.back=0;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}if(g&&0==(240&g)){for(v=_,y=g,w=b;g=(C=r.lencode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}u>>>=v,l-=v,r.back+=v;}if(u>>>=_,l-=_,r.back+=_,r.length=b,0===g){r.mode=26;break}if(32&g){r.back=-1,r.mode=12;break}if(64&g){e.msg="invalid literal/length code",r.mode=30;break}r.extra=15&g,r.mode=22;case 22:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}r.length+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra;}r.was=r.length,r.mode=23;case 23:for(;g=(C=r.distcode[u&(1<<r.distbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}if(0==(240&g)){for(v=_,y=g,w=b;g=(C=r.distcode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}u>>>=v,l-=v,r.back+=v;}if(u>>>=_,l-=_,r.back+=_,64&g){e.msg="invalid distance code",r.mode=30;break}r.offset=b,r.extra=15&g,r.mode=24;case 24:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}r.offset+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra;}if(r.offset>r.dmax){e.msg="invalid distance too far back",r.mode=30;break}r.mode=25;case 25:if(0===h)break e;if(d=c-h,r.offset>d){if((d=r.offset-d)>r.whave&&r.sane){e.msg="invalid distance too far back",r.mode=30;break}p=d>r.wnext?(d-=r.wnext,r.wsize-d):r.wnext-d,d>r.length&&(d=r.length),m=r.window;}else m=i,p=a-r.offset,d=r.length;for(h<d&&(d=h),h-=d,r.length-=d;i[a++]=m[p++],--d;);0===r.length&&(r.mode=21);break;case 26:if(0===h)break e;i[a++]=r.length,h--,r.mode=21;break;case 27:if(r.wrap){for(;l<32;){if(0===o)break e;o--,u|=n[s++]<<l,l+=8;}if(c-=h,e.total_out+=c,r.total+=c,c&&(e.adler=r.check=r.flags?B(r.check,i,c,a-c):O(r.check,i,c,a-c)),c=h,(r.flags?u:L(u))!==r.check){e.msg="incorrect data check",r.mode=30;break}l=u=0;}r.mode=28;case 28:if(r.wrap&&r.flags){for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8;}if(u!==(4294967295&r.total)){e.msg="incorrect length check",r.mode=30;break}l=u=0;}r.mode=29;case 29:x=1;break e;case 30:x=-3;break e;case 31:return -4;case 32:default:return U}return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,(r.wsize||c!==e.avail_out&&r.mode<30&&(r.mode<27||4!==t))&&Z(e,e.output,e.next_out,c-e.avail_out)?(r.mode=31,-4):(f-=e.avail_in,c-=e.avail_out,e.total_in+=f,e.total_out+=c,r.total+=c,r.wrap&&c&&(e.adler=r.check=r.flags?B(r.check,i,c,e.next_out-c):O(r.check,i,c,e.next_out-c)),e.data_type=r.bits+(r.last?64:0)+(12===r.mode?128:0)+(20===r.mode||15===r.mode?256:0),(0==f&&0===c||4===t)&&x===N&&(x=-5),x)},r.inflateEnd=function(e){if(!e||!e.state)return U;var t=e.state;return t.window&&(t.window=null),e.state=null,N},r.inflateGetHeader=function(e,t){var r;return e&&e.state?0==(2&(r=e.state).wrap)?U:((r.head=t).done=!1,N):U},r.inflateSetDictionary=function(e,t){var r,n=t.length;return e&&e.state?0!==(r=e.state).wrap&&11!==r.mode?U:11===r.mode&&O(1,t,n,0)!==r.check?-3:Z(e,t,n,n)?(r.mode=31,-4):(r.havedict=1,N):U},r.inflateInfo="pako inflate (from Nodeca project)";},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(e,t,r){var D=e("../utils/common"),F=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],N=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],U=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],P=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(e,t,r,n,i,s,a,o){var h,u,l,f,c,d,p,m,_,g=o.bits,b=0,v=0,y=0,w=0,k=0,x=0,S=0,z=0,C=0,E=0,A=null,I=0,O=new D.Buf16(16),B=new D.Buf16(16),R=null,T=0;for(b=0;b<=15;b++)O[b]=0;for(v=0;v<n;v++)O[t[r+v]]++;for(k=g,w=15;1<=w&&0===O[w];w--);if(w<k&&(k=w),0===w)return i[s++]=20971520,i[s++]=20971520,o.bits=1,0;for(y=1;y<w&&0===O[y];y++);for(k<y&&(k=y),b=z=1;b<=15;b++)if(z<<=1,(z-=O[b])<0)return -1;if(0<z&&(0===e||1!==w))return -1;for(B[1]=0,b=1;b<15;b++)B[b+1]=B[b]+O[b];for(v=0;v<n;v++)0!==t[r+v]&&(a[B[t[r+v]]++]=v);if(d=0===e?(A=R=a,19):1===e?(A=F,I-=257,R=N,T-=257,256):(A=U,R=P,-1),b=y,c=s,S=v=E=0,l=-1,f=(C=1<<(x=k))-1,1===e&&852<C||2===e&&592<C)return 1;for(;;){for(p=b-S,_=a[v]<d?(m=0,a[v]):a[v]>d?(m=R[T+a[v]],A[I+a[v]]):(m=96,0),h=1<<b-S,y=u=1<<x;i[c+(E>>S)+(u-=h)]=p<<24|m<<16|_|0,0!==u;);for(h=1<<b-1;E&h;)h>>=1;if(0!==h?(E&=h-1,E+=h):E=0,v++,0==--O[b]){if(b===w)break;b=t[r+a[v]];}if(k<b&&(E&f)!==l){for(0===S&&(S=k),c+=y,z=1<<(x=b-S);x+S<w&&!((z-=O[x+S])<=0);)x++,z<<=1;if(C+=1<<x,1===e&&852<C||2===e&&592<C)return 1;i[l=E&f]=k<<24|x<<16|c-s|0;}}return 0!==E&&(i[c+E]=b-S<<24|64<<16|0),o.bits=k,0};},{"../utils/common":41}],51:[function(e,t,r){t.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"};},{}],52:[function(e,t,r){var i=e("../utils/common"),o=0,h=1;function n(e){for(var t=e.length;0<=--t;)e[t]=0;}var s=0,a=29,u=256,l=u+1+a,f=30,c=19,_=2*l+1,g=15,d=16,p=7,m=256,b=16,v=17,y=18,w=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],k=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],x=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],z=new Array(2*(l+2));n(z);var C=new Array(2*f);n(C);var E=new Array(512);n(E);var A=new Array(256);n(A);var I=new Array(a);n(I);var O,B,R,T=new Array(f);function D(e,t,r,n,i){this.static_tree=e,this.extra_bits=t,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=e&&e.length;}function F(e,t){this.dyn_tree=e,this.max_code=0,this.stat_desc=t;}function N(e){return e<256?E[e]:E[256+(e>>>7)]}function U(e,t){e.pending_buf[e.pending++]=255&t,e.pending_buf[e.pending++]=t>>>8&255;}function P(e,t,r){e.bi_valid>d-r?(e.bi_buf|=t<<e.bi_valid&65535,U(e,e.bi_buf),e.bi_buf=t>>d-e.bi_valid,e.bi_valid+=r-d):(e.bi_buf|=t<<e.bi_valid&65535,e.bi_valid+=r);}function L(e,t,r){P(e,r[2*t],r[2*t+1]);}function j(e,t){for(var r=0;r|=1&e,e>>>=1,r<<=1,0<--t;);return r>>>1}function Z(e,t,r){var n,i,s=new Array(g+1),a=0;for(n=1;n<=g;n++)s[n]=a=a+r[n-1]<<1;for(i=0;i<=t;i++){var o=e[2*i+1];0!==o&&(e[2*i]=j(s[o]++,o));}}function W(e){var t;for(t=0;t<l;t++)e.dyn_ltree[2*t]=0;for(t=0;t<f;t++)e.dyn_dtree[2*t]=0;for(t=0;t<c;t++)e.bl_tree[2*t]=0;e.dyn_ltree[2*m]=1,e.opt_len=e.static_len=0,e.last_lit=e.matches=0;}function M(e){8<e.bi_valid?U(e,e.bi_buf):0<e.bi_valid&&(e.pending_buf[e.pending++]=e.bi_buf),e.bi_buf=0,e.bi_valid=0;}function H(e,t,r,n){var i=2*t,s=2*r;return e[i]<e[s]||e[i]===e[s]&&n[t]<=n[r]}function G(e,t,r){for(var n=e.heap[r],i=r<<1;i<=e.heap_len&&(i<e.heap_len&&H(t,e.heap[i+1],e.heap[i],e.depth)&&i++,!H(t,n,e.heap[i],e.depth));)e.heap[r]=e.heap[i],r=i,i<<=1;e.heap[r]=n;}function K(e,t,r){var n,i,s,a,o=0;if(0!==e.last_lit)for(;n=e.pending_buf[e.d_buf+2*o]<<8|e.pending_buf[e.d_buf+2*o+1],i=e.pending_buf[e.l_buf+o],o++,0===n?L(e,i,t):(L(e,(s=A[i])+u+1,t),0!==(a=w[s])&&P(e,i-=I[s],a),L(e,s=N(--n),r),0!==(a=k[s])&&P(e,n-=T[s],a)),o<e.last_lit;);L(e,m,t);}function Y(e,t){var r,n,i,s=t.dyn_tree,a=t.stat_desc.static_tree,o=t.stat_desc.has_stree,h=t.stat_desc.elems,u=-1;for(e.heap_len=0,e.heap_max=_,r=0;r<h;r++)0!==s[2*r]?(e.heap[++e.heap_len]=u=r,e.depth[r]=0):s[2*r+1]=0;for(;e.heap_len<2;)s[2*(i=e.heap[++e.heap_len]=u<2?++u:0)]=1,e.depth[i]=0,e.opt_len--,o&&(e.static_len-=a[2*i+1]);for(t.max_code=u,r=e.heap_len>>1;1<=r;r--)G(e,s,r);for(i=h;r=e.heap[1],e.heap[1]=e.heap[e.heap_len--],G(e,s,1),n=e.heap[1],e.heap[--e.heap_max]=r,e.heap[--e.heap_max]=n,s[2*i]=s[2*r]+s[2*n],e.depth[i]=(e.depth[r]>=e.depth[n]?e.depth[r]:e.depth[n])+1,s[2*r+1]=s[2*n+1]=i,e.heap[1]=i++,G(e,s,1),2<=e.heap_len;);e.heap[--e.heap_max]=e.heap[1],function(e,t){var r,n,i,s,a,o,h=t.dyn_tree,u=t.max_code,l=t.stat_desc.static_tree,f=t.stat_desc.has_stree,c=t.stat_desc.extra_bits,d=t.stat_desc.extra_base,p=t.stat_desc.max_length,m=0;for(s=0;s<=g;s++)e.bl_count[s]=0;for(h[2*e.heap[e.heap_max]+1]=0,r=e.heap_max+1;r<_;r++)p<(s=h[2*h[2*(n=e.heap[r])+1]+1]+1)&&(s=p,m++),h[2*n+1]=s,u<n||(e.bl_count[s]++,a=0,d<=n&&(a=c[n-d]),o=h[2*n],e.opt_len+=o*(s+a),f&&(e.static_len+=o*(l[2*n+1]+a)));if(0!==m){do{for(s=p-1;0===e.bl_count[s];)s--;e.bl_count[s]--,e.bl_count[s+1]+=2,e.bl_count[p]--,m-=2;}while(0<m);for(s=p;0!==s;s--)for(n=e.bl_count[s];0!==n;)u<(i=e.heap[--r])||(h[2*i+1]!==s&&(e.opt_len+=(s-h[2*i+1])*h[2*i],h[2*i+1]=s),n--);}}(e,t),Z(s,u,e.bl_count);}function X(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),t[2*(r+1)+1]=65535,n=0;n<=r;n++)i=a,a=t[2*(n+1)+1],++o<h&&i===a||(o<u?e.bl_tree[2*i]+=o:0!==i?(i!==s&&e.bl_tree[2*i]++,e.bl_tree[2*b]++):o<=10?e.bl_tree[2*v]++:e.bl_tree[2*y]++,s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4));}function V(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),n=0;n<=r;n++)if(i=a,a=t[2*(n+1)+1],!(++o<h&&i===a)){if(o<u)for(;L(e,i,e.bl_tree),0!=--o;);else 0!==i?(i!==s&&(L(e,i,e.bl_tree),o--),L(e,b,e.bl_tree),P(e,o-3,2)):o<=10?(L(e,v,e.bl_tree),P(e,o-3,3)):(L(e,y,e.bl_tree),P(e,o-11,7));s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4);}}n(T);var q=!1;function J(e,t,r,n){P(e,(s<<1)+(n?1:0),3),function(e,t,r,n){M(e),n&&(U(e,r),U(e,~r)),i.arraySet(e.pending_buf,e.window,t,r,e.pending),e.pending+=r;}(e,t,r,!0);}r._tr_init=function(e){q||(function(){var e,t,r,n,i,s=new Array(g+1);for(n=r=0;n<a-1;n++)for(I[n]=r,e=0;e<1<<w[n];e++)A[r++]=n;for(A[r-1]=n,n=i=0;n<16;n++)for(T[n]=i,e=0;e<1<<k[n];e++)E[i++]=n;for(i>>=7;n<f;n++)for(T[n]=i<<7,e=0;e<1<<k[n]-7;e++)E[256+i++]=n;for(t=0;t<=g;t++)s[t]=0;for(e=0;e<=143;)z[2*e+1]=8,e++,s[8]++;for(;e<=255;)z[2*e+1]=9,e++,s[9]++;for(;e<=279;)z[2*e+1]=7,e++,s[7]++;for(;e<=287;)z[2*e+1]=8,e++,s[8]++;for(Z(z,l+1,s),e=0;e<f;e++)C[2*e+1]=5,C[2*e]=j(e,5);O=new D(z,w,u+1,l,g),B=new D(C,k,0,f,g),R=new D(new Array(0),x,0,c,p);}(),q=!0),e.l_desc=new F(e.dyn_ltree,O),e.d_desc=new F(e.dyn_dtree,B),e.bl_desc=new F(e.bl_tree,R),e.bi_buf=0,e.bi_valid=0,W(e);},r._tr_stored_block=J,r._tr_flush_block=function(e,t,r,n){var i,s,a=0;0<e.level?(2===e.strm.data_type&&(e.strm.data_type=function(e){var t,r=4093624447;for(t=0;t<=31;t++,r>>>=1)if(1&r&&0!==e.dyn_ltree[2*t])return o;if(0!==e.dyn_ltree[18]||0!==e.dyn_ltree[20]||0!==e.dyn_ltree[26])return h;for(t=32;t<u;t++)if(0!==e.dyn_ltree[2*t])return h;return o}(e)),Y(e,e.l_desc),Y(e,e.d_desc),a=function(e){var t;for(X(e,e.dyn_ltree,e.l_desc.max_code),X(e,e.dyn_dtree,e.d_desc.max_code),Y(e,e.bl_desc),t=c-1;3<=t&&0===e.bl_tree[2*S[t]+1];t--);return e.opt_len+=3*(t+1)+5+5+4,t}(e),i=e.opt_len+3+7>>>3,(s=e.static_len+3+7>>>3)<=i&&(i=s)):i=s=r+5,r+4<=i&&-1!==t?J(e,t,r,n):4===e.strategy||s===i?(P(e,2+(n?1:0),3),K(e,z,C)):(P(e,4+(n?1:0),3),function(e,t,r,n){var i;for(P(e,t-257,5),P(e,r-1,5),P(e,n-4,4),i=0;i<n;i++)P(e,e.bl_tree[2*S[i]+1],3);V(e,e.dyn_ltree,t-1),V(e,e.dyn_dtree,r-1);}(e,e.l_desc.max_code+1,e.d_desc.max_code+1,a+1),K(e,e.dyn_ltree,e.dyn_dtree)),W(e),n&&M(e);},r._tr_tally=function(e,t,r){return e.pending_buf[e.d_buf+2*e.last_lit]=t>>>8&255,e.pending_buf[e.d_buf+2*e.last_lit+1]=255&t,e.pending_buf[e.l_buf+e.last_lit]=255&r,e.last_lit++,0===t?e.dyn_ltree[2*r]++:(e.matches++,t--,e.dyn_ltree[2*(A[r]+u+1)]++,e.dyn_dtree[2*N(t)]++),e.last_lit===e.lit_bufsize-1},r._tr_align=function(e){P(e,2,3),L(e,m,z),function(e){16===e.bi_valid?(U(e,e.bi_buf),e.bi_buf=0,e.bi_valid=0):8<=e.bi_valid&&(e.pending_buf[e.pending++]=255&e.bi_buf,e.bi_buf>>=8,e.bi_valid-=8);}(e);};},{"../utils/common":41}],53:[function(e,t,r){t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0;};},{}],54:[function(e,t,r){(function(e){!function(r,n){if(!r.setImmediate){var i,s,t,a,o=1,h={},u=!1,l=r.document,e=Object.getPrototypeOf&&Object.getPrototypeOf(r);e=e&&e.setTimeout?e:r,i="[object process]"==={}.toString.call(r.process)?function(e){process.nextTick(function(){c(e);});}:function(){if(r.postMessage&&!r.importScripts){var e=!0,t=r.onmessage;return r.onmessage=function(){e=!1;},r.postMessage("","*"),r.onmessage=t,e}}()?(a="setImmediate$"+Math.random()+"$",r.addEventListener?r.addEventListener("message",d,!1):r.attachEvent("onmessage",d),function(e){r.postMessage(a+e,"*");}):r.MessageChannel?((t=new MessageChannel).port1.onmessage=function(e){c(e.data);},function(e){t.port2.postMessage(e);}):l&&"onreadystatechange"in l.createElement("script")?(s=l.documentElement,function(e){var t=l.createElement("script");t.onreadystatechange=function(){c(e),t.onreadystatechange=null,s.removeChild(t),t=null;},s.appendChild(t);}):function(e){setTimeout(c,0,e);},e.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),r=0;r<t.length;r++)t[r]=arguments[r+1];var n={callback:e,args:t};return h[o]=n,i(o),o++},e.clearImmediate=f;}function f(e){delete h[e];}function c(e){if(u)setTimeout(c,0,e);else {var t=h[e];if(t){u=!0;try{!function(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r);}}(t);}finally{f(e),u=!1;}}}}function d(e){e.source===r&&"string"==typeof e.data&&0===e.data.indexOf(a)&&c(+e.data.slice(a.length));}}("undefined"==typeof self?void 0===e?this:e:self);}).call(this,"undefined"!=typeof commonjsGlobal?commonjsGlobal:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{});},{}]},{},[10])(10)});
});

var docxPreview_min = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t(jszip_min);}(globalThis,(e=>(()=>{var t={438:(e,t,r)=>{r.r(t),r.d(t,{default:()=>d});var a=r(537),s=r.n(a),n=r(645),l=r.n(n),o=r(806),i=r.n(o),c=new URL(r(583),r.b),u=l()(s()),p=i()(c);u.push([e.id,`@namespace "http://www.w3.org/1998/Math/MathML";math{display:inline-block;line-height:initial}mfrac{display:inline-block;vertical-align:-50%;text-align:center}mfrac>:first-child{border-bottom:solid thin currentColor}mfrac>*{display:block}msub>:nth-child(2){font-size:smaller;vertical-align:sub}msup>:nth-child(2){font-size:smaller;vertical-align:super}munder,mover,munderover{display:inline-flex;flex-flow:column nowrap;vertical-align:middle;text-align:center}munder>:not(:first-child),mover>:not(:first-child),munderover>:not(:first-child){font-size:smaller}munderover>:last-child{order:-1}mroot,msqrt{position:relative;display:inline-block;border-top:solid thin currentColor;margin-top:.5px;vertical-align:middle;margin-left:1ch}mroot:before,msqrt:before{content:"";display:inline-block;position:absolute;width:1ch;left:-1ch;top:-1px;bottom:0;background-image:url(${p})}`,"",{version:3,sources:["webpack://./src/mathml.scss"],names:[],mappings:"AAAA,+CAAA,CAEA,KACI,oBAAA,CACA,mBAAA,CAGJ,MACI,oBAAA,CACA,mBAAA,CACA,iBAAA,CAEA,mBACI,qCAAA,CAGJ,QACI,aAAA,CAKJ,mBACI,iBAAA,CACA,kBAAA,CAKJ,mBACI,iBAAA,CACA,oBAAA,CAIR,wBACI,mBAAA,CACA,uBAAA,CACA,qBAAA,CACA,iBAAA,CAEA,iFACI,iBAAA,CAKJ,uBAAA,QAAA,CAGJ,YACI,iBAAA,CACA,oBAAA,CACA,kCAAA,CACA,eAAA,CACA,qBAAA,CACA,eAAA,CAEA,0BACI,UAAA,CACA,oBAAA,CACA,iBAAA,CACA,SAAA,CACA,SAAA,CACA,QAAA,CACA,QAAA,CACA,wDAAA",sourcesContent:["@namespace \"http://www.w3.org/1998/Math/MathML\";\r\n\r\nmath {\r\n    display: inline-block;\r\n    line-height: initial;\r\n}\r\n\r\nmfrac {\r\n    display: inline-block;\r\n    vertical-align: -50%;\r\n    text-align: center;\r\n\r\n    &>:first-child {\r\n        border-bottom: solid thin currentColor;\r\n    }\r\n\r\n    &>* {\r\n        display: block;\r\n    }\r\n}\r\n\r\nmsub {\r\n    &>:nth-child(2) {\r\n        font-size: smaller;\r\n        vertical-align: sub;\r\n    }\r\n}\r\n\r\nmsup {\r\n    &>:nth-child(2) {\r\n        font-size: smaller;\r\n        vertical-align: super;\r\n    }\r\n}\r\n\r\nmunder, mover, munderover {\r\n    display: inline-flex;\r\n    flex-flow: column nowrap;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n\r\n    &>:not(:first-child) {\r\n        font-size: smaller;\r\n    }\r\n}\r\n\r\nmunderover {\r\n    &>:last-child { order: -1; }\r\n}\r\n\r\nmroot, msqrt {\r\n    position: relative;\r\n    display: inline-block;\r\n    border-top: solid thin currentColor;  \r\n    margin-top: 0.5px;\r\n    vertical-align: middle;  \r\n    margin-left: 1ch; \r\n\r\n    &:before {\r\n        content: \"\";\r\n        display: inline-block;\r\n        position: absolute;\r\n        width: 1ch;\r\n        left: -1ch;\r\n        top: -1px;\r\n        bottom: 0;\r\n        background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 100' preserveAspectRatio='none'%3E%3Cpath d='m0,75 l5,0 l5,25 l10,-100' stroke='black' fill='none' vector-effect='non-scaling-stroke'/%3E%3C/svg%3E\");\r\n    }\r\n}"],sourceRoot:""}]);const d=u.toString();},645:e=>{e.exports=function(e){var t=[];return t.toString=function(){return this.map((function(t){var r="",a=void 0!==t[5];return t[4]&&(r+="@supports (".concat(t[4],") {")),t[2]&&(r+="@media ".concat(t[2]," {")),a&&(r+="@layer".concat(t[5].length>0?" ".concat(t[5]):""," {")),r+=e(t),a&&(r+="}"),t[2]&&(r+="}"),t[4]&&(r+="}"),r})).join("")},t.i=function(e,r,a,s,n){"string"==typeof e&&(e=[[null,e,void 0]]);var l={};if(a)for(var o=0;o<this.length;o++){var i=this[o][0];null!=i&&(l[i]=!0);}for(var c=0;c<e.length;c++){var u=[].concat(e[c]);a&&l[u[0]]||(void 0!==n&&(void 0===u[5]||(u[1]="@layer".concat(u[5].length>0?" ".concat(u[5]):""," {").concat(u[1],"}")),u[5]=n),r&&(u[2]?(u[1]="@media ".concat(u[2]," {").concat(u[1],"}"),u[2]=r):u[2]=r),s&&(u[4]?(u[1]="@supports (".concat(u[4],") {").concat(u[1],"}"),u[4]=s):u[4]="".concat(s)),t.push(u));}},t};},806:e=>{e.exports=function(e,t){return t||(t={}),e?(e=String(e.__esModule?e.default:e),/^['"].*['"]$/.test(e)&&(e=e.slice(1,-1)),t.hash&&(e+=t.hash),/["'() \t\n]|(%20)/.test(e)||t.needQuotes?'"'.concat(e.replace(/"/g,'\\"').replace(/\n/g,"\\n"),'"'):e):e};},537:e=>{e.exports=function(e){var t=e[1],r=e[3];if(!r)return t;if("function"==typeof btoa){var a=btoa(unescape(encodeURIComponent(JSON.stringify(r)))),s="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a),n="/*# ".concat(s," */");return [t].concat([n]).join("\n")}return [t].join("\n")};},522:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.OpenXmlPackage=void 0;const a=r(626),s=r(472),n=r(593),l=r(461);class o{constructor(e,t){this._zip=e,this.options=t,this.xmlParser=new s.XmlParser;}get(e){return this._zip.files[function(e){return e.startsWith("/")?e.substr(1):e}(e)]}update(e,t){this._zip.file(e,t);}static async load(e,t){const r=await a.loadAsync(e);return new o(r,t)}save(e="blob"){return this._zip.generateAsync({type:e})}load(e,t="string"){var r,a;return null!==(a=null===(r=this.get(e))||void 0===r?void 0:r.async(t))&&void 0!==a?a:Promise.resolve(null)}async loadRelationships(e=null){let t="_rels/.rels";if(null!=e){const[r,a]=(0, n.splitPath)(e);t=`${r}_rels/${a}.rels`;}const r=await this.load(t);return r?(0, l.parseRelationships)(this.parseXmlDocument(r).firstElementChild,this.xmlParser):null}parseXmlDocument(e){return (0, s.parseXmlString)(e,this.options.trimXmlDeclaration)}}t.OpenXmlPackage=o;},530:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.Part=void 0;const a=r(472);t.Part=class{constructor(e,t){this._package=e,this.path=t;}async load(){this.rels=await this._package.loadRelationships(this.path);const e=await this._package.load(this.path),t=this._package.parseXmlDocument(e);this._package.options.keepOrigin&&(this._xmlDocument=t),this.parseXml(t.firstElementChild);}save(){this._package.update(this.path,(0, a.serializeXmlString)(this._xmlDocument));}parseXml(e){}};},461:(e,t)=>{var r;Object.defineProperty(t,"__esModule",{value:!0}),t.parseRelationships=t.RelationshipTypes=void 0,function(e){e.OfficeDocument="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",e.FontTable="http://schemas.openxmlformats.org/officeDocument/2006/relationships/fontTable",e.Image="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",e.Numbering="http://schemas.openxmlformats.org/officeDocument/2006/relationships/numbering",e.Styles="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",e.StylesWithEffects="http://schemas.microsoft.com/office/2007/relationships/stylesWithEffects",e.Theme="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",e.Settings="http://schemas.openxmlformats.org/officeDocument/2006/relationships/settings",e.WebSettings="http://schemas.openxmlformats.org/officeDocument/2006/relationships/webSettings",e.Hyperlink="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",e.Footnotes="http://schemas.openxmlformats.org/officeDocument/2006/relationships/footnotes",e.Endnotes="http://schemas.openxmlformats.org/officeDocument/2006/relationships/endnotes",e.Footer="http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer",e.Header="http://schemas.openxmlformats.org/officeDocument/2006/relationships/header",e.ExtendedProperties="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",e.CoreProperties="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",e.CustomProperties="http://schemas.openxmlformats.org/package/2006/relationships/metadata/custom-properties";}(r||(t.RelationshipTypes=r={})),t.parseRelationships=function(e,t){return t.elements(e).map((e=>({id:t.attr(e,"Id"),type:t.attr(e,"Type"),target:t.attr(e,"Target"),targetMode:t.attr(e,"TargetMode")})))};},168:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.DocumentParser=t.autos=void 0;const a=r(120),s=r(109),n=r(59),l=r(472),o=r(488),i=r(172),c=r(149),u=r(320);t.autos={shd:"inherit",color:"black",borderColor:"black",highlight:"transparent"};const p=[],d={oMath:a.DomType.MmlMath,oMathPara:a.DomType.MmlMathParagraph,f:a.DomType.MmlFraction,func:a.DomType.MmlFunction,fName:a.DomType.MmlFunctionName,num:a.DomType.MmlNumerator,den:a.DomType.MmlDenominator,rad:a.DomType.MmlRadical,deg:a.DomType.MmlDegree,e:a.DomType.MmlBase,sSup:a.DomType.MmlSuperscript,sSub:a.DomType.MmlSubscript,sPre:a.DomType.MmlPreSubSuper,sup:a.DomType.MmlSuperArgument,sub:a.DomType.MmlSubArgument,d:a.DomType.MmlDelimiter,nary:a.DomType.MmlNary,eqArr:a.DomType.MmlEquationArray,lim:a.DomType.MmlLimit,limLow:a.DomType.MmlLimitLower,m:a.DomType.MmlMatrix,mr:a.DomType.MmlMatrixRow,box:a.DomType.MmlBox,bar:a.DomType.MmlBar,groupChr:a.DomType.MmlGroupChar};t.DocumentParser=class{constructor(e){this.options=Object.assign({ignoreWidth:!1,debug:!1},e);}parseNotes(e,t,r){var a=[];for(let s of l.default.elements(e,t)){const e=new r;e.id=l.default.attr(s,"id"),e.noteType=l.default.attr(s,"type"),e.children=this.parseBodyElements(s),a.push(e);}return a}parseDocumentFile(e){var t=l.default.element(e,"body"),r=l.default.element(e,"background"),s=l.default.element(t,"sectPr");return {type:a.DomType.Document,children:this.parseBodyElements(t),props:s?(0, n.parseSectionProperties)(s,l.default):{},cssStyle:r?this.parseBackground(r):{}}}parseBackground(e){var t={},r=h.colorAttr(e,"color");return r&&(t["background-color"]=r),t}parseBodyElements(e){var t=[];for(let r of l.default.elements(e))switch(r.localName){case"p":t.push(this.parseParagraph(r));break;case"tbl":t.push(this.parseTable(r));break;case"sdt":t.push(...this.parseSdt(r,(e=>this.parseBodyElements(e))));}return t}parseStylesFile(e){var t=[];return h.foreach(e,(e=>{switch(e.localName){case"style":t.push(this.parseStyle(e));break;case"docDefaults":t.push(this.parseDefaultStyles(e));}})),t}parseDefaultStyles(e){var t={id:null,name:null,target:null,basedOn:null,styles:[]};return h.foreach(e,(e=>{switch(e.localName){case"rPrDefault":var r=l.default.element(e,"rPr");r&&t.styles.push({target:"span",values:this.parseDefaultProperties(r,{})});break;case"pPrDefault":var a=l.default.element(e,"pPr");a&&t.styles.push({target:"p",values:this.parseDefaultProperties(a,{})});}})),t}parseStyle(e){var t={id:l.default.attr(e,"styleId"),isDefault:l.default.boolAttr(e,"default"),name:null,target:null,basedOn:null,styles:[],linked:null};switch(l.default.attr(e,"type")){case"paragraph":t.target="p";break;case"table":t.target="table";break;case"character":t.target="span";}return h.foreach(e,(e=>{switch(e.localName){case"basedOn":t.basedOn=l.default.attr(e,"val");break;case"name":t.name=l.default.attr(e,"val");break;case"link":t.linked=l.default.attr(e,"val");break;case"next":t.next=l.default.attr(e,"val");break;case"aliases":t.aliases=l.default.attr(e,"val").split(",");break;case"pPr":t.styles.push({target:"p",values:this.parseDefaultProperties(e,{})}),t.paragraphProps=(0, s.parseParagraphProperties)(e,l.default);break;case"rPr":t.styles.push({target:"span",values:this.parseDefaultProperties(e,{})}),t.runProps=(0, o.parseRunProperties)(e,l.default);break;case"tblPr":case"tcPr":t.styles.push({target:"td",values:this.parseDefaultProperties(e,{})});break;case"tblStylePr":for(let r of this.parseTableStyle(e))t.styles.push(r);break;case"rsid":case"qFormat":case"hidden":case"semiHidden":case"unhideWhenUsed":case"autoRedefine":case"uiPriority":break;default:this.options.debug&&console.warn(`DOCX: Unknown style element: ${e.localName}`);}})),t}parseTableStyle(e){var t=[],r=l.default.attr(e,"type"),a="",s="";switch(r){case"firstRow":s=".first-row",a="tr.first-row td";break;case"lastRow":s=".last-row",a="tr.last-row td";break;case"firstCol":s=".first-col",a="td.first-col";break;case"lastCol":s=".last-col",a="td.last-col";break;case"band1Vert":s=":not(.no-vband)",a="td.odd-col";break;case"band2Vert":s=":not(.no-vband)",a="td.even-col";break;case"band1Horz":s=":not(.no-hband)",a="tr.odd-row";break;case"band2Horz":s=":not(.no-hband)",a="tr.even-row";break;default:return []}return h.foreach(e,(e=>{switch(e.localName){case"pPr":t.push({target:`${a} p`,mod:s,values:this.parseDefaultProperties(e,{})});break;case"rPr":t.push({target:`${a} span`,mod:s,values:this.parseDefaultProperties(e,{})});break;case"tblPr":case"tcPr":t.push({target:a,mod:s,values:this.parseDefaultProperties(e,{})});}})),t}parseNumberingFile(e){var t=[],r={},a=[];return h.foreach(e,(e=>{switch(e.localName){case"abstractNum":this.parseAbstractNumbering(e,a).forEach((e=>t.push(e)));break;case"numPicBullet":a.push(this.parseNumberingPicBullet(e));break;case"num":var s=l.default.attr(e,"numId"),n=l.default.elementAttr(e,"abstractNumId","val");r[n]=s;}})),t.forEach((e=>e.id=r[e.id])),t}parseNumberingPicBullet(e){var t=l.default.element(e,"pict"),r=t&&l.default.element(t,"shape"),a=r&&l.default.element(r,"imagedata");return a?{id:l.default.intAttr(e,"numPicBulletId"),src:l.default.attr(a,"id"),style:l.default.attr(r,"style")}:null}parseAbstractNumbering(e,t){var r=[],a=l.default.attr(e,"abstractNumId");return h.foreach(e,(e=>{"lvl"===e.localName&&r.push(this.parseNumberingLevel(a,e,t));})),r}parseNumberingLevel(e,t,r){var a={id:e,level:l.default.intAttr(t,"ilvl"),start:1,pStyleName:void 0,pStyle:{},rStyle:{},suff:"tab"};return h.foreach(t,(e=>{switch(e.localName){case"start":a.start=l.default.intAttr(e,"val");break;case"pPr":this.parseDefaultProperties(e,a.pStyle);break;case"rPr":this.parseDefaultProperties(e,a.rStyle);break;case"lvlPicBulletId":var t=l.default.intAttr(e,"val");a.bullet=r.find((e=>e.id==t));break;case"lvlText":a.levelText=l.default.attr(e,"val");break;case"pStyle":a.pStyleName=l.default.attr(e,"val");break;case"numFmt":a.format=l.default.attr(e,"val");break;case"suff":a.suff=l.default.attr(e,"val");}})),a}parseSdt(e,t){const r=l.default.element(e,"sdtContent");return r?t(r):[]}parseInserted(e,t){var r,s;return {type:a.DomType.Inserted,children:null!==(s=null===(r=t(e))||void 0===r?void 0:r.children)&&void 0!==s?s:[]}}parseDeleted(e,t){var r,s;return {type:a.DomType.Deleted,children:null!==(s=null===(r=t(e))||void 0===r?void 0:r.children)&&void 0!==s?s:[]}}parseParagraph(e){var t={type:a.DomType.Paragraph,children:[]};for(let r of l.default.elements(e))switch(r.localName){case"pPr":this.parseParagraphProperties(r,t);break;case"r":t.children.push(this.parseRun(r,t));break;case"hyperlink":t.children.push(this.parseHyperlink(r,t));break;case"bookmarkStart":t.children.push((0, i.parseBookmarkStart)(r,l.default));break;case"bookmarkEnd":t.children.push((0, i.parseBookmarkEnd)(r,l.default));break;case"oMath":case"oMathPara":t.children.push(this.parseMathElement(r));break;case"sdt":t.children.push(...this.parseSdt(r,(e=>this.parseParagraph(e).children)));break;case"ins":t.children.push(this.parseInserted(r,(e=>this.parseParagraph(e))));break;case"del":t.children.push(this.parseDeleted(r,(e=>this.parseParagraph(e))));}return t}parseParagraphProperties(e,t){this.parseDefaultProperties(e,t.cssStyle={},null,(e=>{if((0, s.parseParagraphProperty)(e,t,l.default))return !0;switch(e.localName){case"pStyle":t.styleName=l.default.attr(e,"val");break;case"cnfStyle":t.className=f.classNameOfCnfStyle(e);break;case"framePr":this.parseFrame(e,t);break;case"rPr":break;default:return !1}return !0}));}parseFrame(e,t){"drop"==l.default.attr(e,"dropCap")&&(t.cssStyle.float="left");}parseHyperlink(e,t){var r={type:a.DomType.Hyperlink,parent:t,children:[]},s=l.default.attr(e,"anchor"),n=l.default.attr(e,"id");return s&&(r.href="#"+s),n&&(r.id=n),h.foreach(e,(e=>{"r"===e.localName&&r.children.push(this.parseRun(e,r));})),r}parseRun(e,t){var r={type:a.DomType.Run,parent:t,children:[]};return h.foreach(e,(e=>{switch((e=this.checkAlternateContent(e)).localName){case"t":r.children.push({type:a.DomType.Text,text:e.textContent});break;case"delText":r.children.push({type:a.DomType.DeletedText,text:e.textContent});break;case"fldSimple":r.children.push({type:a.DomType.SimpleField,instruction:l.default.attr(e,"instr"),lock:l.default.boolAttr(e,"lock",!1),dirty:l.default.boolAttr(e,"dirty",!1)});break;case"instrText":r.fieldRun=!0,r.children.push({type:a.DomType.Instruction,text:e.textContent});break;case"fldChar":r.fieldRun=!0,r.children.push({type:a.DomType.ComplexField,charType:l.default.attr(e,"fldCharType"),lock:l.default.boolAttr(e,"lock",!1),dirty:l.default.boolAttr(e,"dirty",!1)});break;case"noBreakHyphen":r.children.push({type:a.DomType.NoBreakHyphen});break;case"br":r.children.push({type:a.DomType.Break,break:l.default.attr(e,"type")||"textWrapping"});break;case"lastRenderedPageBreak":r.children.push({type:a.DomType.Break,break:"lastRenderedPageBreak"});break;case"sym":r.children.push({type:a.DomType.Symbol,font:l.default.attr(e,"font"),char:l.default.attr(e,"char")});break;case"tab":r.children.push({type:a.DomType.Tab});break;case"footnoteReference":r.children.push({type:a.DomType.FootnoteReference,id:l.default.attr(e,"id")});break;case"endnoteReference":r.children.push({type:a.DomType.EndnoteReference,id:l.default.attr(e,"id")});break;case"drawing":let t=this.parseDrawing(e);t&&(r.children=[t]);break;case"pict":r.children.push(this.parseVmlPicture(e));break;case"rPr":this.parseRunProperties(e,r);}})),r}parseMathElement(e){const t=`${e.localName}Pr`,r={type:d[e.localName],children:[]};for(const n of l.default.elements(e))if(d[n.localName])r.children.push(this.parseMathElement(n));else if("r"==n.localName){var s=this.parseRun(n);s.type=a.DomType.MmlRun,r.children.push(s);}else n.localName==t&&(r.props=this.parseMathProperies(n));return r}parseMathProperies(e){const t={};for(const r of l.default.elements(e))switch(r.localName){case"chr":t.char=l.default.attr(r,"val");break;case"vertJc":t.verticalJustification=l.default.attr(r,"val");break;case"pos":t.position=l.default.attr(r,"val");break;case"degHide":t.hideDegree=l.default.boolAttr(r,"val");break;case"begChr":t.beginChar=l.default.attr(r,"val");break;case"endChr":t.endChar=l.default.attr(r,"val");}return t}parseRunProperties(e,t){this.parseDefaultProperties(e,t.cssStyle={},null,(e=>{switch(e.localName){case"rStyle":t.styleName=l.default.attr(e,"val");break;case"vertAlign":t.verticalAlign=f.valueOfVertAlign(e,!0);break;default:return !1}return !0}));}parseVmlPicture(e){const t={type:a.DomType.VmlPicture,children:[]};for(const r of l.default.elements(e)){const e=(0, u.parseVmlElement)(r,this);e&&t.children.push(e);}return t}checkAlternateContent(e){var t;if("AlternateContent"!=e.localName)return e;var r=l.default.element(e,"Choice");if(r){var a=l.default.attr(r,"Requires"),s=e.lookupNamespaceURI(a);if(p.includes(s))return r.firstElementChild}return null===(t=l.default.element(e,"Fallback"))||void 0===t?void 0:t.firstElementChild}parseDrawing(e){for(var t of l.default.elements(e))switch(t.localName){case"inline":case"anchor":return this.parseDrawingWrapper(t)}}parseDrawingWrapper(e){var t,r={type:a.DomType.Drawing,children:[],cssStyle:{}},s="anchor"==e.localName;let n=null,o=l.default.boolAttr(e,"simplePos"),i={relative:"page",align:"left",offset:"0"},u={relative:"page",align:"top",offset:"0"};for(var p of l.default.elements(e))switch(p.localName){case"simplePos":o&&(i.offset=l.default.lengthAttr(p,"x",c.LengthUsage.Emu),u.offset=l.default.lengthAttr(p,"y",c.LengthUsage.Emu));break;case"extent":r.cssStyle.width=l.default.lengthAttr(p,"cx",c.LengthUsage.Emu),r.cssStyle.height=l.default.lengthAttr(p,"cy",c.LengthUsage.Emu);break;case"positionH":case"positionV":if(!o){let e="positionH"==p.localName?i:u;var d=l.default.element(p,"align"),m=l.default.element(p,"posOffset");e.relative=null!==(t=l.default.attr(p,"relativeFrom"))&&void 0!==t?t:e.relative,d&&(e.align=d.textContent),m&&(e.offset=h.sizeValue(m,c.LengthUsage.Emu));}break;case"wrapTopAndBottom":n="wrapTopAndBottom";break;case"wrapNone":n="wrapNone";break;case"graphic":var f=this.parseGraphic(p);f&&r.children.push(f);}return "wrapTopAndBottom"==n?(r.cssStyle.display="block",i.align&&(r.cssStyle["text-align"]=i.align,r.cssStyle.width="100%")):"wrapNone"==n?(r.cssStyle.display="block",r.cssStyle.position="relative",r.cssStyle.width="0px",r.cssStyle.height="0px",i.offset&&(r.cssStyle.left=i.offset),u.offset&&(r.cssStyle.top=u.offset)):!s||"left"!=i.align&&"right"!=i.align||(r.cssStyle.float=i.align),r}parseGraphic(e){var t=l.default.element(e,"graphicData");for(let e of l.default.elements(t))if("pic"===e.localName)return this.parsePicture(e);return null}parsePicture(e){var t={type:a.DomType.Image,src:"",cssStyle:{}},r=l.default.element(e,"blipFill"),s=l.default.element(r,"blip");t.src=l.default.attr(s,"embed");var n=l.default.element(e,"spPr"),o=l.default.element(n,"xfrm");for(var i of(t.cssStyle.position="relative",l.default.elements(o)))switch(i.localName){case"ext":t.cssStyle.width=l.default.lengthAttr(i,"cx",c.LengthUsage.Emu),t.cssStyle.height=l.default.lengthAttr(i,"cy",c.LengthUsage.Emu);break;case"off":t.cssStyle.left=l.default.lengthAttr(i,"x",c.LengthUsage.Emu),t.cssStyle.top=l.default.lengthAttr(i,"y",c.LengthUsage.Emu);}return t}parseTable(e){var t={type:a.DomType.Table,children:[]};return h.foreach(e,(e=>{switch(e.localName){case"tr":t.children.push(this.parseTableRow(e));break;case"tblGrid":t.columns=this.parseTableColumns(e);break;case"tblPr":this.parseTableProperties(e,t);}})),t}parseTableColumns(e){var t=[];return h.foreach(e,(e=>{"gridCol"===e.localName&&t.push({width:l.default.lengthAttr(e,"w")});})),t}parseTableProperties(e,t){switch(t.cssStyle={},t.cellStyle={},this.parseDefaultProperties(e,t.cssStyle,t.cellStyle,(e=>{switch(e.localName){case"tblStyle":t.styleName=l.default.attr(e,"val");break;case"tblLook":t.className=f.classNameOftblLook(e);break;case"tblpPr":this.parseTablePosition(e,t);break;case"tblStyleColBandSize":t.colBandSize=l.default.intAttr(e,"val");break;case"tblStyleRowBandSize":t.rowBandSize=l.default.intAttr(e,"val");break;default:return !1}return !0})),t.cssStyle["text-align"]){case"center":delete t.cssStyle["text-align"],t.cssStyle["margin-left"]="auto",t.cssStyle["margin-right"]="auto";break;case"right":delete t.cssStyle["text-align"],t.cssStyle["margin-left"]="auto";}}parseTablePosition(e,t){var r=l.default.lengthAttr(e,"topFromText"),a=l.default.lengthAttr(e,"bottomFromText"),s=l.default.lengthAttr(e,"rightFromText"),n=l.default.lengthAttr(e,"leftFromText");t.cssStyle.float="left",t.cssStyle["margin-bottom"]=f.addSize(t.cssStyle["margin-bottom"],a),t.cssStyle["margin-left"]=f.addSize(t.cssStyle["margin-left"],n),t.cssStyle["margin-right"]=f.addSize(t.cssStyle["margin-right"],s),t.cssStyle["margin-top"]=f.addSize(t.cssStyle["margin-top"],r);}parseTableRow(e){var t={type:a.DomType.Row,children:[]};return h.foreach(e,(e=>{switch(e.localName){case"tc":t.children.push(this.parseTableCell(e));break;case"trPr":this.parseTableRowProperties(e,t);}})),t}parseTableRowProperties(e,t){t.cssStyle=this.parseDefaultProperties(e,{},null,(e=>{switch(e.localName){case"cnfStyle":t.className=f.classNameOfCnfStyle(e);break;case"tblHeader":t.isHeader=l.default.boolAttr(e,"val");break;default:return !1}return !0}));}parseTableCell(e){var t={type:a.DomType.Cell,children:[]};return h.foreach(e,(e=>{switch(e.localName){case"tbl":t.children.push(this.parseTable(e));break;case"p":t.children.push(this.parseParagraph(e));break;case"tcPr":this.parseTableCellProperties(e,t);}})),t}parseTableCellProperties(e,t){t.cssStyle=this.parseDefaultProperties(e,{},null,(e=>{var r;switch(e.localName){case"gridSpan":t.span=l.default.intAttr(e,"val",null);break;case"vMerge":t.verticalMerge=null!==(r=l.default.attr(e,"val"))&&void 0!==r?r:"continue";break;case"cnfStyle":t.className=f.classNameOfCnfStyle(e);break;default:return !1}return !0}));}parseDefaultProperties(e,r=null,a=null,s=null){return r=r||{},h.foreach(e,(n=>{if(!(null==s?void 0:s(n)))switch(n.localName){case"jc":r["text-align"]=f.valueOfJc(n);break;case"textAlignment":r["vertical-align"]=f.valueOfTextAlignment(n);break;case"color":r.color=h.colorAttr(n,"val",null,t.autos.color);break;case"sz":r["font-size"]=r["min-height"]=l.default.lengthAttr(n,"val",c.LengthUsage.FontSize);break;case"shd":r["background-color"]=h.colorAttr(n,"fill",null,t.autos.shd);break;case"highlight":r["background-color"]=h.colorAttr(n,"val",null,t.autos.highlight);break;case"vertAlign":break;case"position":r.verticalAlign=l.default.lengthAttr(n,"val",c.LengthUsage.FontSize);break;case"tcW":if(this.options.ignoreWidth)break;case"tblW":r.width=f.valueOfSize(n,"w");break;case"trHeight":this.parseTrHeight(n,r);break;case"strike":r["text-decoration"]=l.default.boolAttr(n,"val",!0)?"line-through":"none";break;case"b":r["font-weight"]=l.default.boolAttr(n,"val",!0)?"bold":"normal";break;case"i":r["font-style"]=l.default.boolAttr(n,"val",!0)?"italic":"normal";break;case"caps":r["text-transform"]=l.default.boolAttr(n,"val",!0)?"uppercase":"none";break;case"smallCaps":r["text-transform"]=l.default.boolAttr(n,"val",!0)?"lowercase":"none";break;case"u":this.parseUnderline(n,r);break;case"ind":case"tblInd":this.parseIndentation(n,r);break;case"rFonts":this.parseFont(n,r);break;case"tblBorders":this.parseBorderProperties(n,a||r);break;case"tblCellSpacing":r["border-spacing"]=f.valueOfMargin(n),r["border-collapse"]="separate";break;case"pBdr":this.parseBorderProperties(n,r);break;case"bdr":r.border=f.valueOfBorder(n);break;case"tcBorders":this.parseBorderProperties(n,r);break;case"vanish":l.default.boolAttr(n,"val",!0)&&(r.display="none");break;case"kern":case"noWrap":break;case"tblCellMar":case"tcMar":this.parseMarginProperties(n,a||r);break;case"tblLayout":r["table-layout"]=f.valueOfTblLayout(n);break;case"vAlign":r["vertical-align"]=f.valueOfTextAlignment(n);break;case"spacing":"pPr"==e.localName&&this.parseSpacing(n,r);break;case"wordWrap":l.default.boolAttr(n,"val")&&(r["overflow-wrap"]="break-word");break;case"suppressAutoHyphens":r.hyphens=l.default.boolAttr(n,"val",!0)?"none":"auto";break;case"lang":r.$lang=l.default.attr(n,"val");break;case"bCs":case"iCs":case"szCs":case"tabs":case"outlineLvl":case"contextualSpacing":case"tblStyleColBandSize":case"tblStyleRowBandSize":case"webHidden":case"pageBreakBefore":case"suppressLineNumbers":case"keepLines":case"keepNext":case"widowControl":case"bidi":case"rtl":case"noProof":break;default:this.options.debug&&console.warn(`DOCX: Unknown document element: ${e.localName}.${n.localName}`);}})),r}parseUnderline(e,t){var r=l.default.attr(e,"val");if(null!=r){switch(r){case"dash":case"dashDotDotHeavy":case"dashDotHeavy":case"dashedHeavy":case"dashLong":case"dashLongHeavy":case"dotDash":case"dotDotDash":t["text-decoration-style"]="dashed";break;case"dotted":case"dottedHeavy":t["text-decoration-style"]="dotted";break;case"double":t["text-decoration-style"]="double";break;case"single":case"thick":case"words":t["text-decoration"]="underline";break;case"wave":case"wavyDouble":case"wavyHeavy":t["text-decoration-style"]="wavy";break;case"none":t["text-decoration"]="none";}var a=h.colorAttr(e,"color");a&&(t["text-decoration-color"]=a);}}parseFont(e,t){var r=[l.default.attr(e,"ascii"),f.themeValue(e,"asciiTheme")].filter((e=>e)).join(", ");r.length>0&&(t["font-family"]=r);}parseIndentation(e,t){var r=l.default.lengthAttr(e,"firstLine"),a=l.default.lengthAttr(e,"hanging"),s=l.default.lengthAttr(e,"left"),n=l.default.lengthAttr(e,"start"),o=l.default.lengthAttr(e,"right"),i=l.default.lengthAttr(e,"end");r&&(t["text-indent"]=r),a&&(t["text-indent"]=`-${a}`),(s||n)&&(t["margin-left"]=s||n),(o||i)&&(t["margin-right"]=o||i);}parseSpacing(e,t){var r=l.default.lengthAttr(e,"before"),a=l.default.lengthAttr(e,"after"),s=l.default.intAttr(e,"line",null),n=l.default.attr(e,"lineRule");if(r&&(t["margin-top"]=r),a&&(t["margin-bottom"]=a),null!==s)switch(n){case"auto":t["line-height"]=`${(s/240).toFixed(2)}`;break;case"atLeast":t["line-height"]=`calc(100% + ${s/20}pt)`;break;default:t["line-height"]=t["min-height"]=s/20+"pt";}}parseMarginProperties(e,t){h.foreach(e,(e=>{switch(e.localName){case"left":t["padding-left"]=f.valueOfMargin(e);break;case"right":t["padding-right"]=f.valueOfMargin(e);break;case"top":t["padding-top"]=f.valueOfMargin(e);break;case"bottom":t["padding-bottom"]=f.valueOfMargin(e);}}));}parseTrHeight(e,t){l.default.attr(e,"hRule"),t.height=l.default.lengthAttr(e,"val");}parseBorderProperties(e,t){h.foreach(e,(e=>{switch(e.localName){case"start":case"left":t["border-left"]=f.valueOfBorder(e);break;case"end":case"right":t["border-right"]=f.valueOfBorder(e);break;case"top":t["border-top"]=f.valueOfBorder(e);break;case"bottom":t["border-bottom"]=f.valueOfBorder(e);}}));}};const m=["black","blue","cyan","darkBlue","darkCyan","darkGray","darkGreen","darkMagenta","darkRed","darkYellow","green","lightGray","magenta","none","red","white","yellow"];class h{static foreach(e,t){for(var r=0;r<e.childNodes.length;r++){let a=e.childNodes[r];a.nodeType==Node.ELEMENT_NODE&&t(a);}}static colorAttr(e,t,r=null,a="black"){var s=l.default.attr(e,t);if(s)return "auto"==s?a:m.includes(s)?s:`#${s}`;var n=l.default.attr(e,"themeColor");return n?`var(--docx-${n}-color)`:r}static sizeValue(e,t=c.LengthUsage.Dxa){return (0, c.convertLength)(e.textContent,t)}}class f{static themeValue(e,t){var r=l.default.attr(e,t);return r?`var(--docx-${r}-font)`:null}static valueOfSize(e,t){var r=c.LengthUsage.Dxa;switch(l.default.attr(e,"type")){case"dxa":break;case"pct":r=c.LengthUsage.Percent;break;case"auto":return "auto"}return l.default.lengthAttr(e,t,r)}static valueOfMargin(e){return l.default.lengthAttr(e,"w")}static valueOfBorder(e){if("nil"==l.default.attr(e,"val"))return "none";var r=h.colorAttr(e,"color");return `${l.default.lengthAttr(e,"sz",c.LengthUsage.Border)} solid ${"auto"==r?t.autos.borderColor:r}`}static valueOfTblLayout(e){return "fixed"==l.default.attr(e,"val")?"fixed":"auto"}static classNameOfCnfStyle(e){const t=l.default.attr(e,"val");return ["first-row","last-row","first-col","last-col","odd-col","even-col","odd-row","even-row","ne-cell","nw-cell","se-cell","sw-cell"].filter(((e,r)=>"1"==t[r])).join(" ")}static valueOfJc(e){var t=l.default.attr(e,"val");switch(t){case"start":case"left":return "left";case"center":return "center";case"end":case"right":return "right";case"both":return "justify"}return t}static valueOfVertAlign(e,t=!1){var r=l.default.attr(e,"val");switch(r){case"subscript":return "sub";case"superscript":return t?"sup":"super"}return t?null:r}static valueOfTextAlignment(e){var t=l.default.attr(e,"val");switch(t){case"auto":case"baseline":return "baseline";case"top":return "top";case"center":return "middle";case"bottom":return "bottom"}return t}static addSize(e,t){return null==e?t:null==t?e:`calc(${e} + ${t})`}static classNameOftblLook(e){const t=l.default.hexAttr(e,"val",0);let r="";return (l.default.boolAttr(e,"firstRow")||32&t)&&(r+=" first-row"),(l.default.boolAttr(e,"lastRow")||64&t)&&(r+=" last-row"),(l.default.boolAttr(e,"firstColumn")||128&t)&&(r+=" first-col"),(l.default.boolAttr(e,"lastColumn")||256&t)&&(r+=" last-col"),(l.default.boolAttr(e,"noHBand")||512&t)&&(r+=" no-hband"),(l.default.boolAttr(e,"noVBand")||1024&t)&&(r+=" no-vband"),r.trim()}}},162:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.CorePropsPart=void 0;const a=r(530),s=r(614);class n extends a.Part{parseXml(e){this.props=(0, s.parseCoreProps)(e,this._package.xmlParser);}}t.CorePropsPart=n;},614:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseCoreProps=void 0,t.parseCoreProps=function(e,t){const r={};for(let a of t.elements(e))switch(a.localName){case"title":r.title=a.textContent;break;case"description":r.description=a.textContent;break;case"subject":r.subject=a.textContent;break;case"creator":r.creator=a.textContent;break;case"keywords":r.keywords=a.textContent;break;case"language":r.language=a.textContent;break;case"lastModifiedBy":r.lastModifiedBy=a.textContent;break;case"revision":a.textContent&&(r.revision=parseInt(a.textContent));}return r};},177:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.CustomPropsPart=void 0;const a=r(530),s=r(821);class n extends a.Part{parseXml(e){this.props=(0, s.parseCustomProps)(e,this._package.xmlParser);}}t.CustomPropsPart=n;},821:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseCustomProps=void 0,t.parseCustomProps=function(e,t){return t.elements(e,"property").map((e=>{const r=e.firstChild;return {formatId:t.attr(e,"fmtid"),name:t.attr(e,"name"),type:r.nodeName,value:r.textContent}}))};},665:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.ExtendedPropsPart=void 0;const a=r(530),s=r(668);class n extends a.Part{parseXml(e){this.props=(0, s.parseExtendedProps)(e,this._package.xmlParser);}}t.ExtendedPropsPart=n;},668:(e,t)=>{function r(e){if(void 0!==e)return parseInt(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.parseExtendedProps=void 0,t.parseExtendedProps=function(e,t){const a={};for(let s of t.elements(e))switch(s.localName){case"Template":a.template=s.textContent;break;case"Pages":a.pages=r(s.textContent);break;case"Words":a.words=r(s.textContent);break;case"Characters":a.characters=r(s.textContent);break;case"Application":a.application=s.textContent;break;case"Lines":a.lines=r(s.textContent);break;case"Paragraphs":a.paragraphs=r(s.textContent);break;case"Company":a.company=s.textContent;break;case"AppVersion":a.appVersion=s.textContent;}return a};},172:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseBookmarkEnd=t.parseBookmarkStart=void 0;const a=r(120);t.parseBookmarkStart=function(e,t){return {type:a.DomType.BookmarkStart,id:t.attr(e,"id"),name:t.attr(e,"name"),colFirst:t.intAttr(e,"colFirst"),colLast:t.intAttr(e,"colLast")}},t.parseBookmarkEnd=function(e,t){return {type:a.DomType.BookmarkEnd,id:t.attr(e,"id")}};},191:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseBorders=t.parseBorder=void 0;const a=r(149);function s(e,t){return {type:t.attr(e,"val"),color:t.attr(e,"color"),size:t.lengthAttr(e,"sz",a.LengthUsage.Border),offset:t.lengthAttr(e,"space",a.LengthUsage.Point),frame:t.boolAttr(e,"frame"),shadow:t.boolAttr(e,"shadow")}}t.parseBorder=s,t.parseBorders=function(e,t){var r={};for(let a of t.elements(e))switch(a.localName){case"left":r.left=s(a,t);break;case"top":r.top=s(a,t);break;case"right":r.right=s(a,t);break;case"bottom":r.bottom=s(a,t);}return r};},149:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseCommonProperty=t.convertPercentage=t.convertBoolean=t.convertLength=t.LengthUsage=t.ns=void 0,t.ns={wordml:"http://schemas.openxmlformats.org/wordprocessingml/2006/main",drawingml:"http://schemas.openxmlformats.org/drawingml/2006/main",picture:"http://schemas.openxmlformats.org/drawingml/2006/picture",compatibility:"http://schemas.openxmlformats.org/markup-compatibility/2006",math:"http://schemas.openxmlformats.org/officeDocument/2006/math"},t.LengthUsage={Dxa:{mul:.05,unit:"pt"},Emu:{mul:1/12700,unit:"pt"},FontSize:{mul:.5,unit:"pt"},Border:{mul:.125,unit:"pt"},Point:{mul:1,unit:"pt"},Percent:{mul:.02,unit:"%"},LineHeight:{mul:1/240,unit:""},VmlEmu:{mul:1/12700,unit:""}},t.convertLength=function(e,r=t.LengthUsage.Dxa){return null==e||/.+(p[xt]|[%])$/.test(e)?e:`${(parseInt(e)*r.mul).toFixed(2)}${r.unit}`},t.convertBoolean=function(e,t=!1){switch(e){case"1":case"on":case"true":return !0;case"0":case"off":case"false":return !1;default:return t}},t.convertPercentage=function(e){return e?parseInt(e)/100:null},t.parseCommonProperty=function(e,r,a){if(e.namespaceURI!=t.ns.wordml)return !1;switch(e.localName){case"color":r.color=a.attr(e,"val");break;case"sz":r.fontSize=a.lengthAttr(e,"val",t.LengthUsage.FontSize);break;default:return !1}return !0};},448:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.DocumentPart=void 0;const a=r(530);class s extends a.Part{constructor(e,t,r){super(e,t),this._documentParser=r;}parseXml(e){this.body=this._documentParser.parseDocumentFile(e);}}t.DocumentPart=s;},120:(e,t)=>{var r;Object.defineProperty(t,"__esModule",{value:!0}),t.OpenXmlElementBase=t.DomType=void 0,function(e){e.Document="document",e.Paragraph="paragraph",e.Run="run",e.Break="break",e.NoBreakHyphen="noBreakHyphen",e.Table="table",e.Row="row",e.Cell="cell",e.Hyperlink="hyperlink",e.Drawing="drawing",e.Image="image",e.Text="text",e.Tab="tab",e.Symbol="symbol",e.BookmarkStart="bookmarkStart",e.BookmarkEnd="bookmarkEnd",e.Footer="footer",e.Header="header",e.FootnoteReference="footnoteReference",e.EndnoteReference="endnoteReference",e.Footnote="footnote",e.Endnote="endnote",e.SimpleField="simpleField",e.ComplexField="complexField",e.Instruction="instruction",e.VmlPicture="vmlPicture",e.MmlMath="mmlMath",e.MmlMathParagraph="mmlMathParagraph",e.MmlFraction="mmlFraction",e.MmlFunction="mmlFunction",e.MmlFunctionName="mmlFunctionName",e.MmlNumerator="mmlNumerator",e.MmlDenominator="mmlDenominator",e.MmlRadical="mmlRadical",e.MmlBase="mmlBase",e.MmlDegree="mmlDegree",e.MmlSuperscript="mmlSuperscript",e.MmlSubscript="mmlSubscript",e.MmlPreSubSuper="mmlPreSubSuper",e.MmlSubArgument="mmlSubArgument",e.MmlSuperArgument="mmlSuperArgument",e.MmlNary="mmlNary",e.MmlDelimiter="mmlDelimiter",e.MmlRun="mmlRun",e.MmlEquationArray="mmlEquationArray",e.MmlLimit="mmlLimit",e.MmlLimitLower="mmlLimitLower",e.MmlMatrix="mmlMatrix",e.MmlMatrixRow="mmlMatrixRow",e.MmlBox="mmlBox",e.MmlBar="mmlBar",e.MmlGroupChar="mmlGroupChar",e.VmlElement="vmlElement",e.Inserted="inserted",e.Deleted="deleted",e.DeletedText="deletedText";}(r||(t.DomType=r={})),t.OpenXmlElementBase=class{constructor(){this.children=[],this.cssStyle={};}};},931:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseLineSpacing=void 0,t.parseLineSpacing=function(e,t){return {before:t.lengthAttr(e,"before"),after:t.lengthAttr(e,"after"),line:t.intAttr(e,"line"),lineRule:t.attr(e,"lineRule")}};},109:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseNumbering=t.parseTabs=t.parseParagraphProperty=t.parseParagraphProperties=void 0;const a=r(149),s=r(59),n=r(931),l=r(488);function o(e,t,r){if(e.namespaceURI!=a.ns.wordml)return !1;if((0, a.parseCommonProperty)(e,t,r))return !0;switch(e.localName){case"tabs":t.tabs=i(e,r);break;case"sectPr":t.sectionProps=(0, s.parseSectionProperties)(e,r);break;case"numPr":t.numbering=c(e,r);break;case"spacing":return t.lineSpacing=(0, n.parseLineSpacing)(e,r),!1;case"textAlignment":return t.textAlignment=r.attr(e,"val"),!1;case"keepNext":t.keepLines=r.boolAttr(e,"val",!0);break;case"keepNext":t.keepNext=r.boolAttr(e,"val",!0);break;case"pageBreakBefore":t.pageBreakBefore=r.boolAttr(e,"val",!0);break;case"outlineLvl":t.outlineLevel=r.intAttr(e,"val");break;case"pStyle":t.styleName=r.attr(e,"val");break;case"rPr":t.runProps=(0, l.parseRunProperties)(e,r);break;default:return !1}return !0}function i(e,t){return t.elements(e,"tab").map((e=>({position:t.lengthAttr(e,"pos"),leader:t.attr(e,"leader"),style:t.attr(e,"val")})))}function c(e,t){var r={};for(let a of t.elements(e))switch(a.localName){case"numId":r.id=t.attr(a,"val");break;case"ilvl":r.level=t.intAttr(a,"val");}return r}t.parseParagraphProperties=function(e,t){let r={};for(let a of t.elements(e))o(a,r,t);return r},t.parseParagraphProperty=o,t.parseTabs=i,t.parseNumbering=c;},488:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseRunProperty=t.parseRunProperties=void 0;const a=r(149);function s(e,t,r){return !!(0, a.parseCommonProperty)(e,t,r)}t.parseRunProperties=function(e,t){let r={};for(let a of t.elements(e))s(a,r,t);return r},t.parseRunProperty=s;},59:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseSectionProperties=t.SectionType=void 0;const a=r(472),s=r(191);var n;function l(e,t){return {numberOfColumns:t.intAttr(e,"num"),space:t.lengthAttr(e,"space"),separator:t.boolAttr(e,"sep"),equalWidth:t.boolAttr(e,"equalWidth",!0),columns:t.elements(e,"col").map((e=>({width:t.lengthAttr(e,"w"),space:t.lengthAttr(e,"space")})))}}function o(e,t){return {chapSep:t.attr(e,"chapSep"),chapStyle:t.attr(e,"chapStyle"),format:t.attr(e,"fmt"),start:t.intAttr(e,"start")}}function i(e,t){return {id:t.attr(e,"id"),type:t.attr(e,"type")}}!function(e){e.Continuous="continuous",e.NextPage="nextPage",e.NextColumn="nextColumn",e.EvenPage="evenPage",e.OddPage="oddPage";}(n||(t.SectionType=n={})),t.parseSectionProperties=function(e,t=a.default){var r,n,c={};for(let a of t.elements(e))switch(a.localName){case"pgSz":c.pageSize={width:t.lengthAttr(a,"w"),height:t.lengthAttr(a,"h"),orientation:t.attr(a,"orient")};break;case"type":c.type=t.attr(a,"val");break;case"pgMar":c.pageMargins={left:t.lengthAttr(a,"left"),right:t.lengthAttr(a,"right"),top:t.lengthAttr(a,"top"),bottom:t.lengthAttr(a,"bottom"),header:t.lengthAttr(a,"header"),footer:t.lengthAttr(a,"footer"),gutter:t.lengthAttr(a,"gutter")};break;case"cols":c.columns=l(a,t);break;case"headerReference":(null!==(r=c.headerRefs)&&void 0!==r?r:c.headerRefs=[]).push(i(a,t));break;case"footerReference":(null!==(n=c.footerRefs)&&void 0!==n?n:c.footerRefs=[]).push(i(a,t));break;case"titlePg":c.titlePage=t.boolAttr(a,"val",!0);break;case"pgBorders":c.pageBorders=(0, s.parseBorders)(a,t);break;case"pgNumType":c.pageNumber=o(a,t);}return c};},667:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.renderAsync=t.praseAsync=t.defaultOptions=void 0;const a=r(213),s=r(168),n=r(932);t.defaultOptions={ignoreHeight:!1,ignoreWidth:!1,ignoreFonts:!1,breakPages:!0,debug:!1,experimental:!1,className:"docx",inWrapper:!0,trimXmlDeclaration:!0,ignoreLastRenderedPageBreak:!0,renderHeaders:!0,renderFooters:!0,renderFootnotes:!0,renderEndnotes:!0,useBase64URL:!1,useMathMLPolyfill:!1,renderChanges:!1},t.praseAsync=function(e,r=null){const n=Object.assign(Object.assign({},t.defaultOptions),r);return a.WordDocument.load(e,new s.DocumentParser(n),n)},t.renderAsync=async function(e,r,l=null,o=null){const i=Object.assign(Object.assign({},t.defaultOptions),o),c=new n.HtmlRenderer(window.document),u=await a.WordDocument.load(e,new s.DocumentParser(i),i);return c.render(u,r,l,i),u};},380:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.FontTablePart=void 0;const a=r(530),s=r(512);class n extends a.Part{parseXml(e){this.fonts=(0, s.parseFonts)(e,this._package.xmlParser);}}t.FontTablePart=n;},512:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseEmbedFontRef=t.parseFont=t.parseFonts=void 0;const r={embedRegular:"regular",embedBold:"bold",embedItalic:"italic",embedBoldItalic:"boldItalic"};function a(e,t){let r={name:t.attr(e,"name"),embedFontRefs:[]};for(let a of t.elements(e))switch(a.localName){case"family":r.family=t.attr(a,"val");break;case"altName":r.altName=t.attr(a,"val");break;case"embedRegular":case"embedBold":case"embedItalic":case"embedBoldItalic":r.embedFontRefs.push(s(a,t));}return r}function s(e,t){return {id:t.attr(e,"id"),key:t.attr(e,"fontKey"),type:r[e.localName]}}t.parseFonts=function(e,t){return t.elements(e).map((e=>a(e,t)))},t.parseFont=a,t.parseEmbedFontRef=s;},984:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.WmlFooter=t.WmlHeader=void 0;const a=r(120);class s extends a.OpenXmlElementBase{constructor(){super(...arguments),this.type=a.DomType.Header;}}t.WmlHeader=s;class n extends a.OpenXmlElementBase{constructor(){super(...arguments),this.type=a.DomType.Footer;}}t.WmlFooter=n;},985:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.FooterPart=t.HeaderPart=t.BaseHeaderFooterPart=void 0;const a=r(530),s=r(984);class n extends a.Part{constructor(e,t,r){super(e,t),this._documentParser=r;}parseXml(e){this.rootElement=this.createRootElement(),this.rootElement.children=this._documentParser.parseBodyElements(e);}}t.BaseHeaderFooterPart=n,t.HeaderPart=class extends n{createRootElement(){return new s.WmlHeader}},t.FooterPart=class extends n{createRootElement(){return new s.WmlFooter}};},932:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.HtmlRenderer=void 0;const a=r(120),s=r(593),n=r(630),l=r(438),o="http://www.w3.org/1998/Math/MathML";function i(e,t,r){return u(void 0,e,t,r)}function c(e,t,r){return u("http://www.w3.org/2000/svg",e,t,r)}function u(e,t,r,a){var s=e?document.createElementNS(e,t):document.createElement(t);return Object.assign(s,r),a&&d(s,a),s}function p(e){e.innerHTML="";}function d(e,t){t.forEach((t=>e.appendChild((0, s.isString)(t)?document.createTextNode(t):t)));}function m(e){return i("style",{innerHTML:e})}function h(e,t){e.appendChild(document.createComment(t));}t.HtmlRenderer=class{constructor(e){this.htmlDocument=e,this.className="docx",this.styleMap={},this.currentPart=null,this.tableVerticalMerges=[],this.currentVerticalMerge=null,this.tableCellPositions=[],this.currentCellPosition=null,this.footnoteMap={},this.endnoteMap={},this.currentEndnoteIds=[],this.usedHederFooterParts=[],this.currentTabs=[],this.tabsTimeout=0,this.createElement=i;}render(e,t,r=null,a){var n;this.document=e,this.options=a,this.className=a.className,this.rootSelector=a.inWrapper?`.${this.className}-wrapper`:":root",this.styleMap=null,p(r=r||t),p(t),h(r,"docxjs library predefined styles"),r.appendChild(this.renderDefaultStyle()),!window.MathMLElement&&a.useMathMLPolyfill&&(h(r,"docxjs mathml polyfill styles"),r.appendChild(m(l.default))),e.themePart&&(h(r,"docxjs document theme values"),this.renderTheme(e.themePart,r)),null!=e.stylesPart&&(this.styleMap=this.processStyles(e.stylesPart.styles),h(r,"docxjs document styles"),r.appendChild(this.renderStyles(e.stylesPart.styles))),e.numberingPart&&(this.prodessNumberings(e.numberingPart.domNumberings),h(r,"docxjs document numbering styles"),r.appendChild(this.renderNumbering(e.numberingPart.domNumberings,r))),e.footnotesPart&&(this.footnoteMap=(0, s.keyBy)(e.footnotesPart.notes,(e=>e.id))),e.endnotesPart&&(this.endnoteMap=(0, s.keyBy)(e.endnotesPart.notes,(e=>e.id))),e.settingsPart&&(this.defaultTabSize=null===(n=e.settingsPart.settings)||void 0===n?void 0:n.defaultTabStop),!a.ignoreFonts&&e.fontTablePart&&this.renderFontTable(e.fontTablePart,r);var o=this.renderSections(e.documentPart.body);this.options.inWrapper?t.appendChild(this.renderWrapper(o)):d(t,o),this.refreshTabStops();}renderTheme(e,t){var r,a;const s={},n=null===(r=e.theme)||void 0===r?void 0:r.fontScheme;n&&(n.majorFont&&(s["--docx-majorHAnsi-font"]=n.majorFont.latinTypeface),n.minorFont&&(s["--docx-minorHAnsi-font"]=n.minorFont.latinTypeface));const l=null===(a=e.theme)||void 0===a?void 0:a.colorScheme;if(l)for(let[e,t]of Object.entries(l.colors))s[`--docx-${e}-color`]=`#${t}`;const o=this.styleToString(`.${this.className}`,s);t.appendChild(m(o));}renderFontTable(e,t){for(let r of e.fonts)for(let e of r.embedFontRefs)this.document.loadFont(e.id,e.key).then((a=>{const s={"font-family":r.name,src:`url(${a})`};"bold"!=e.type&&"boldItalic"!=e.type||(s["font-weight"]="bold"),"italic"!=e.type&&"boldItalic"!=e.type||(s["font-style"]="italic"),h(t,`docxjs ${r.name} font`);const n=this.styleToString("@font-face",s);t.appendChild(m(n)),this.refreshTabStops();}));}processStyleName(e){return e?`${this.className}_${(0, s.escapeClassName)(e)}`:this.className}processStyles(e){const t=(0, s.keyBy)(e.filter((e=>null!=e.id)),(e=>e.id));for(const a of e.filter((e=>e.basedOn))){var r=t[a.basedOn];if(r){a.paragraphProps=(0, s.mergeDeep)(a.paragraphProps,r.paragraphProps),a.runProps=(0, s.mergeDeep)(a.runProps,r.runProps);for(const e of r.styles){const t=a.styles.find((t=>t.target==e.target));t?this.copyStyleProperties(e.values,t.values):a.styles.push(Object.assign(Object.assign({},e),{values:Object.assign({},e.values)}));}}else this.options.debug&&console.warn(`Can't find base style ${a.basedOn}`);}for(let t of e)t.cssName=this.processStyleName(t.id);return t}prodessNumberings(e){var t;for(let r of e.filter((e=>e.pStyleName))){const e=this.findStyle(r.pStyleName);(null===(t=null==e?void 0:e.paragraphProps)||void 0===t?void 0:t.numbering)&&(e.paragraphProps.numbering.level=r.level);}}processElement(e){if(e.children)for(var t of e.children)t.parent=e,t.type==a.DomType.Table?this.processTable(t):this.processElement(t);}processTable(e){for(var t of e.children)for(var r of t.children)r.cssStyle=this.copyStyleProperties(e.cellStyle,r.cssStyle,["border-left","border-right","border-top","border-bottom","padding-left","padding-right","padding-top","padding-bottom"]),this.processElement(r);}copyStyleProperties(e,t,r=null){if(!e)return t;for(var a of(null==t&&(t={}),null==r&&(r=Object.getOwnPropertyNames(e)),r))e.hasOwnProperty(a)&&!t.hasOwnProperty(a)&&(t[a]=e[a]);return t}createSection(e,t){var r=this.createElement("section",{className:e});return t&&(t.pageMargins&&(r.style.paddingLeft=t.pageMargins.left,r.style.paddingRight=t.pageMargins.right,r.style.paddingTop=t.pageMargins.top,r.style.paddingBottom=t.pageMargins.bottom),t.pageSize&&(this.options.ignoreWidth||(r.style.width=t.pageSize.width),this.options.ignoreHeight||(r.style.minHeight=t.pageSize.height)),t.columns&&t.columns.numberOfColumns&&(r.style.columnCount=`${t.columns.numberOfColumns}`,r.style.columnGap=t.columns.space,t.columns.separator&&(r.style.columnRule="1px solid black"))),r}renderSections(e){const t=[];this.processElement(e);const r=this.splitBySection(e.children);let a=null;for(let n=0,l=r.length;n<l;n++){this.currentFootnoteIds=[];const o=r[n],i=o.sectProps||e.props,c=this.createSection(this.className,i);this.renderStyleValues(e.cssStyle,c),this.options.renderHeaders&&this.renderHeaderFooter(i.headerRefs,i,t.length,a!=i,c);var s=this.createElement("article");this.renderElements(o.elements,s),c.appendChild(s),this.options.renderFootnotes&&this.renderNotes(this.currentFootnoteIds,this.footnoteMap,c),this.options.renderEndnotes&&n==l-1&&this.renderNotes(this.currentEndnoteIds,this.endnoteMap,c),this.options.renderFooters&&this.renderHeaderFooter(i.footerRefs,i,t.length,a!=i,c),t.push(c),a=i;}return t}renderHeaderFooter(e,t,r,a,s){var n,l;if(e){var o=null!==(l=null!==(n=t.titlePage&&a?e.find((e=>"first"==e.type)):null)&&void 0!==n?n:r%2==1?e.find((e=>"even"==e.type)):null)&&void 0!==l?l:e.find((e=>"default"==e.type)),i=o&&this.document.findPartByRelId(o.id,this.document.documentPart);i&&(this.currentPart=i,this.usedHederFooterParts.includes(i.path)||(this.processElement(i.rootElement),this.usedHederFooterParts.push(i.path)),this.renderElements([i.rootElement],s),this.currentPart=null);}}isPageBreakElement(e){return e.type==a.DomType.Break&&("lastRenderedPageBreak"==e.break?!this.options.ignoreLastRenderedPageBreak:"page"==e.break)}splitBySection(e){var t,r={sectProps:null,elements:[]},s=[r];for(let u of e){if(u.type==a.DomType.Paragraph){const e=this.findStyle(u.styleName);(null===(t=null==e?void 0:e.paragraphProps)||void 0===t?void 0:t.pageBreakBefore)&&(r.sectProps=n,r={sectProps:null,elements:[]},s.push(r));}if(r.elements.push(u),u.type==a.DomType.Paragraph){const e=u;var n=e.sectionProps,l=-1,o=-1;if(this.options.breakPages&&e.children&&(l=e.children.findIndex((e=>{var t,r;return -1!=(o=null!==(r=null===(t=e.children)||void 0===t?void 0:t.findIndex(this.isPageBreakElement.bind(this)))&&void 0!==r?r:-1)}))),(n||-1!=l)&&(r.sectProps=n,r={sectProps:null,elements:[]},s.push(r)),-1!=l){let t=e.children[l],a=o<t.children.length-1;if(l<e.children.length-1||a){var i=u.children,c=Object.assign(Object.assign({},u),{children:i.slice(l)});if(u.children=i.slice(0,l),r.elements.push(c),a){let e=t.children,r=Object.assign(Object.assign({},t),{children:e.slice(0,o)});u.children.push(r),t.children=e.slice(o);}}}}}let u=null;for(let e=s.length-1;e>=0;e--)null==s[e].sectProps?s[e].sectProps=u:u=s[e].sectProps;return s}renderWrapper(e){return this.createElement("div",{className:`${this.className}-wrapper`},e)}renderDefaultStyle(){var e=this.className;return m(`\n.${e}-wrapper { background: gray; padding: 30px; padding-bottom: 0px; display: flex; flex-flow: column; align-items: center; } \n.${e}-wrapper>section.${e} { background: white; box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); margin-bottom: 30px; }\n.${e} { color: black; hyphens: auto; }\nsection.${e} { box-sizing: border-box; display: flex; flex-flow: column nowrap; position: relative; overflow: hidden; }\nsection.${e}>article { margin-bottom: auto; z-index: 1; }\nsection.${e}>footer { z-index: 1; }\n.${e} table { border-collapse: collapse; }\n.${e} table td, .${e} table th { vertical-align: top; }\n.${e} p { margin: 0pt; min-height: 1em; }\n.${e} span { white-space: pre-wrap; overflow-wrap: break-word; }\n.${e} a { color: inherit; text-decoration: inherit; }\n`)}renderNumbering(e,t){var r="",a=[];for(var s of e){var n=`p.${this.numberingClass(s.id,s.level)}`,l="none";if(s.bullet){let e=`--${this.className}-${s.bullet.src}`.toLowerCase();r+=this.styleToString(`${n}:before`,{content:"' '",display:"inline-block",background:`var(${e})`},s.bullet.style),this.document.loadNumberingImage(s.bullet.src).then((r=>{var a=`${this.rootSelector} { ${e}: url(${r}) }`;t.appendChild(m(a));}));}else if(s.levelText){let e=this.numberingCounter(s.id,s.level);const t=e+" "+(s.start-1);s.level>0&&(r+=this.styleToString(`p.${this.numberingClass(s.id,s.level-1)}`,{"counter-reset":t})),a.push(t),r+=this.styleToString(`${n}:before`,Object.assign({content:this.levelTextToContent(s.levelText,s.suff,s.id,this.numFormatToCssValue(s.format)),"counter-increment":e},s.rStyle));}else l=this.numFormatToCssValue(s.format);r+=this.styleToString(n,Object.assign({display:"list-item","list-style-position":"inside","list-style-type":l},s.pStyle));}return a.length>0&&(r+=this.styleToString(this.rootSelector,{"counter-reset":a.join(" ")})),m(r)}renderStyles(e){var t,r="";const a=this.styleMap,n=(0, s.keyBy)(e.filter((e=>e.isDefault)),(e=>e.target));for(const s of e){var l=s.styles;if(s.linked){var o=s.linked&&a[s.linked];o?l=l.concat(o.styles):this.options.debug&&console.warn(`Can't find linked style ${s.linked}`);}for(const e of l){var i=`${null!==(t=s.target)&&void 0!==t?t:""}.${s.cssName}`;s.target!=e.target&&(i+=` ${e.target}`),n[s.target]==s&&(i=`.${this.className} ${s.target}, `+i),r+=this.styleToString(i,e.values);}}return m(r)}renderNotes(e,t,r){var a=e.map((e=>t[e])).filter((e=>e));if(a.length>0){var s=this.createElement("ol",null,this.renderElements(a));r.appendChild(s);}}renderElement(e){switch(e.type){case a.DomType.Paragraph:return this.renderParagraph(e);case a.DomType.BookmarkStart:return this.renderBookmarkStart(e);case a.DomType.BookmarkEnd:return null;case a.DomType.Run:return this.renderRun(e);case a.DomType.Table:return this.renderTable(e);case a.DomType.Row:return this.renderTableRow(e);case a.DomType.Cell:return this.renderTableCell(e);case a.DomType.Hyperlink:return this.renderHyperlink(e);case a.DomType.Drawing:return this.renderDrawing(e);case a.DomType.Image:return this.renderImage(e);case a.DomType.Text:case a.DomType.Text:return this.renderText(e);case a.DomType.DeletedText:return this.renderDeletedText(e);case a.DomType.Tab:return this.renderTab(e);case a.DomType.Symbol:return this.renderSymbol(e);case a.DomType.Break:return this.renderBreak(e);case a.DomType.Footer:return this.renderContainer(e,"footer");case a.DomType.Header:return this.renderContainer(e,"header");case a.DomType.Footnote:case a.DomType.Endnote:return this.renderContainer(e,"li");case a.DomType.FootnoteReference:return this.renderFootnoteReference(e);case a.DomType.EndnoteReference:return this.renderEndnoteReference(e);case a.DomType.NoBreakHyphen:return this.createElement("wbr");case a.DomType.VmlPicture:return this.renderVmlPicture(e);case a.DomType.VmlElement:return this.renderVmlElement(e);case a.DomType.MmlMath:return this.renderContainerNS(e,o,"math",{xmlns:o});case a.DomType.MmlMathParagraph:return this.renderContainer(e,"span");case a.DomType.MmlFraction:return this.renderContainerNS(e,o,"mfrac");case a.DomType.MmlBase:return this.renderContainerNS(e,o,e.parent.type==a.DomType.MmlMatrixRow?"mtd":"mrow");case a.DomType.MmlNumerator:case a.DomType.MmlDenominator:case a.DomType.MmlFunction:case a.DomType.MmlLimit:case a.DomType.MmlBox:return this.renderContainerNS(e,o,"mrow");case a.DomType.MmlGroupChar:return this.renderMmlGroupChar(e);case a.DomType.MmlLimitLower:return this.renderContainerNS(e,o,"munder");case a.DomType.MmlMatrix:return this.renderContainerNS(e,o,"mtable");case a.DomType.MmlMatrixRow:return this.renderContainerNS(e,o,"mtr");case a.DomType.MmlRadical:return this.renderMmlRadical(e);case a.DomType.MmlSuperscript:return this.renderContainerNS(e,o,"msup");case a.DomType.MmlSubscript:return this.renderContainerNS(e,o,"msub");case a.DomType.MmlDegree:case a.DomType.MmlSuperArgument:case a.DomType.MmlSubArgument:return this.renderContainerNS(e,o,"mn");case a.DomType.MmlFunctionName:return this.renderContainerNS(e,o,"ms");case a.DomType.MmlDelimiter:return this.renderMmlDelimiter(e);case a.DomType.MmlRun:return this.renderMmlRun(e);case a.DomType.MmlNary:return this.renderMmlNary(e);case a.DomType.MmlPreSubSuper:return this.renderMmlPreSubSuper(e);case a.DomType.MmlBar:return this.renderMmlBar(e);case a.DomType.MmlEquationArray:return this.renderMllList(e);case a.DomType.Inserted:return this.renderInserted(e);case a.DomType.Deleted:return this.renderDeleted(e)}return null}renderChildren(e,t){return this.renderElements(e.children,t)}renderElements(e,t){if(null==e)return null;var r=e.flatMap((e=>this.renderElement(e))).filter((e=>null!=e));return t&&d(t,r),r}renderContainer(e,t,r){return this.createElement(t,r,this.renderChildren(e))}renderContainerNS(e,t,r,a){return u(t,r,a,this.renderChildren(e))}renderParagraph(e){var t,r,a,s,n=this.createElement("p");const l=this.findStyle(e.styleName);null!==(t=e.tabs)&&void 0!==t||(e.tabs=null===(r=null==l?void 0:l.paragraphProps)||void 0===r?void 0:r.tabs),this.renderClass(e,n),this.renderChildren(e,n),this.renderStyleValues(e.cssStyle,n),this.renderCommonProperties(n.style,e);const o=null!==(a=e.numbering)&&void 0!==a?a:null===(s=null==l?void 0:l.paragraphProps)||void 0===s?void 0:s.numbering;return o&&n.classList.add(this.numberingClass(o.id,o.level)),n}renderRunProperties(e,t){this.renderCommonProperties(e,t);}renderCommonProperties(e,t){null!=t&&(t.color&&(e.color=t.color),t.fontSize&&(e["font-size"]=t.fontSize));}renderHyperlink(e){var t=this.createElement("a");if(this.renderChildren(e,t),this.renderStyleValues(e.cssStyle,t),e.href)t.href=e.href;else if(e.id){const r=this.document.documentPart.rels.find((t=>t.id==e.id&&"External"===t.targetMode));t.href=null==r?void 0:r.target;}return t}renderDrawing(e){var t=this.createElement("div");return t.style.display="inline-block",t.style.position="relative",t.style.textIndent="0px",this.renderChildren(e,t),this.renderStyleValues(e.cssStyle,t),t}renderImage(e){let t=this.createElement("img");return this.renderStyleValues(e.cssStyle,t),this.document&&this.document.loadDocumentImage(e.src,this.currentPart).then((e=>{t.src=e;})),t}renderText(e){return this.htmlDocument.createTextNode(e.text)}renderDeletedText(e){return this.options.renderEndnotes?this.htmlDocument.createTextNode(e.text):null}renderBreak(e){return "textWrapping"==e.break?this.createElement("br"):null}renderInserted(e){return this.options.renderChanges?this.renderContainer(e,"ins"):this.renderChildren(e)}renderDeleted(e){return this.options.renderChanges?this.renderContainer(e,"del"):null}renderSymbol(e){var t=this.createElement("span");return t.style.fontFamily=e.font,t.innerHTML=`&#x${e.char};`,t}renderFootnoteReference(e){var t=this.createElement("sup");return this.currentFootnoteIds.push(e.id),t.textContent=`${this.currentFootnoteIds.length}`,t}renderEndnoteReference(e){var t=this.createElement("sup");return this.currentEndnoteIds.push(e.id),t.textContent=`${this.currentEndnoteIds.length}`,t}renderTab(e){var t,r=this.createElement("span");if(r.innerHTML="&emsp;",this.options.experimental){r.className=this.tabStopClass();var s=null===(t=function(e,t){for(var r=e.parent;null!=r&&r.type!=t;)r=r.parent;return r}(e,a.DomType.Paragraph))||void 0===t?void 0:t.tabs;this.currentTabs.push({stops:s,span:r});}return r}renderBookmarkStart(e){var t=this.createElement("span");return t.id=e.name,t}renderRun(e){if(e.fieldRun)return null;const t=this.createElement("span");if(e.id&&(t.id=e.id),this.renderClass(e,t),this.renderStyleValues(e.cssStyle,t),e.verticalAlign){const r=this.createElement(e.verticalAlign);this.renderChildren(e,r),t.appendChild(r);}else this.renderChildren(e,t);return t}renderTable(e){let t=this.createElement("table");return this.tableCellPositions.push(this.currentCellPosition),this.tableVerticalMerges.push(this.currentVerticalMerge),this.currentVerticalMerge={},this.currentCellPosition={col:0,row:0},e.columns&&t.appendChild(this.renderTableColumns(e.columns)),this.renderClass(e,t),this.renderChildren(e,t),this.renderStyleValues(e.cssStyle,t),this.currentVerticalMerge=this.tableVerticalMerges.pop(),this.currentCellPosition=this.tableCellPositions.pop(),t}renderTableColumns(e){let t=this.createElement("colgroup");for(let r of e){let e=this.createElement("col");r.width&&(e.style.width=r.width),t.appendChild(e);}return t}renderTableRow(e){let t=this.createElement("tr");return this.currentCellPosition.col=0,this.renderClass(e,t),this.renderChildren(e,t),this.renderStyleValues(e.cssStyle,t),this.currentCellPosition.row++,t}renderTableCell(e){let t=this.createElement("td");const r=this.currentCellPosition.col;return e.verticalMerge?"restart"==e.verticalMerge?(this.currentVerticalMerge[r]=t,t.rowSpan=1):this.currentVerticalMerge[r]&&(this.currentVerticalMerge[r].rowSpan+=1,t.style.display="none"):this.currentVerticalMerge[r]=null,this.renderClass(e,t),this.renderChildren(e,t),this.renderStyleValues(e.cssStyle,t),e.span&&(t.colSpan=e.span),this.currentCellPosition.col+=t.colSpan,t}renderVmlPicture(e){var t=i("div");return this.renderChildren(e,t),t}renderVmlElement(e){var t,r,a=c("svg");a.setAttribute("style",e.cssStyleText);const s=this.renderVmlChildElement(e);return (null===(t=e.imageHref)||void 0===t?void 0:t.id)&&(null===(r=this.document)||void 0===r||r.loadDocumentImage(e.imageHref.id,this.currentPart).then((e=>s.setAttribute("href",e)))),a.appendChild(s),requestAnimationFrame((()=>{const e=a.firstElementChild.getBBox();a.setAttribute("width",`${Math.ceil(e.x+e.width)}`),a.setAttribute("height",`${Math.ceil(e.y+e.height)}`);})),a}renderVmlChildElement(e){const t=c(e.tagName);Object.entries(e.attrs).forEach((([e,r])=>t.setAttribute(e,r)));for(let r of e.children)r.type==a.DomType.VmlElement?t.appendChild(this.renderVmlChildElement(r)):t.appendChild(...(0, s.asArray)(this.renderElement(r)));return t}renderMmlRadical(e){var t;const r=e.children.find((e=>e.type==a.DomType.MmlBase));if(null===(t=e.props)||void 0===t?void 0:t.hideDegree)return u(o,"msqrt",null,this.renderElements([r]));const s=e.children.find((e=>e.type==a.DomType.MmlDegree));return u(o,"mroot",null,this.renderElements([r,s]))}renderMmlDelimiter(e){var t,r;const a=[];return a.push(u(o,"mo",null,[null!==(t=e.props.beginChar)&&void 0!==t?t:"("])),a.push(...this.renderElements(e.children)),a.push(u(o,"mo",null,[null!==(r=e.props.endChar)&&void 0!==r?r:")"])),u(o,"mrow",null,a)}renderMmlNary(e){var t,r;const n=[],l=(0, s.keyBy)(e.children,(e=>e.type)),i=l[a.DomType.MmlSuperArgument],c=l[a.DomType.MmlSubArgument],p=i?u(o,"mo",null,(0, s.asArray)(this.renderElement(i))):null,d=c?u(o,"mo",null,(0, s.asArray)(this.renderElement(c))):null,m=u(o,"mo",null,[null!==(r=null===(t=e.props)||void 0===t?void 0:t.char)&&void 0!==r?r:"∫"]);return p||d?n.push(u(o,"munderover",null,[m,d,p])):p?n.push(u(o,"mover",null,[m,p])):d?n.push(u(o,"munder",null,[m,d])):n.push(m),n.push(...this.renderElements(l[a.DomType.MmlBase].children)),u(o,"mrow",null,n)}renderMmlPreSubSuper(e){const t=[],r=(0, s.keyBy)(e.children,(e=>e.type)),n=r[a.DomType.MmlSuperArgument],l=r[a.DomType.MmlSubArgument],i=n?u(o,"mo",null,(0, s.asArray)(this.renderElement(n))):null,c=l?u(o,"mo",null,(0, s.asArray)(this.renderElement(l))):null,p=u(o,"mo",null);return t.push(u(o,"msubsup",null,[p,c,i])),t.push(...this.renderElements(r[a.DomType.MmlBase].children)),u(o,"mrow",null,t)}renderMmlGroupChar(e){const t="bot"===e.props.verticalJustification?"mover":"munder",r=this.renderContainerNS(e,o,t);return e.props.char&&r.appendChild(u(o,"mo",null,[e.props.char])),r}renderMmlBar(e){const t=this.renderContainerNS(e,o,"mrow");switch(e.props.position){case"top":t.style.textDecoration="overline";break;case"bottom":t.style.textDecoration="underline";}return t}renderMmlRun(e){const t=u(o,"ms");return this.renderClass(e,t),this.renderStyleValues(e.cssStyle,t),this.renderChildren(e,t),t}renderMllList(e){const t=u(o,"mtable");this.renderClass(e,t),this.renderStyleValues(e.cssStyle,t),this.renderChildren(e);for(let r of this.renderChildren(e))t.appendChild(u(o,"mtr",null,[u(o,"mtd",null,[r])]));return t}renderStyleValues(e,t){for(let r in e)r.startsWith("$")?t.setAttribute(r.slice(1),e[r]):t.style[r]=e[r];}renderClass(e,t){e.className&&(t.className=e.className),e.styleName&&t.classList.add(this.processStyleName(e.styleName));}findStyle(e){var t;return e&&(null===(t=this.styleMap)||void 0===t?void 0:t[e])}numberingClass(e,t){return `${this.className}-num-${e}-${t}`}tabStopClass(){return `${this.className}-tab-stop`}styleToString(e,t,r=null){let a=`${e} {\r\n`;for(const e in t)e.startsWith("$")||(a+=`  ${e}: ${t[e]};\r\n`);return r&&(a+=r),a+"}\r\n"}numberingCounter(e,t){return `${this.className}-num-${e}-${t}`}levelTextToContent(e,t,r,a){var s;return `"${e.replace(/%\d*/g,(e=>{let t=parseInt(e.substring(1),10)-1;return `"counter(${this.numberingCounter(r,t)}, ${a})"`}))}${null!==(s={tab:"\\9",space:"\\a0"}[t])&&void 0!==s?s:""}"`}numFormatToCssValue(e){var t;return null!==(t={none:"none",bullet:"disc",decimal:"decimal",lowerLetter:"lower-alpha",upperLetter:"upper-alpha",lowerRoman:"lower-roman",upperRoman:"upper-roman",decimalZero:"decimal-leading-zero",aiueo:"katakana",aiueoFullWidth:"katakana",chineseCounting:"simp-chinese-informal",chineseCountingThousand:"simp-chinese-informal",chineseLegalSimplified:"simp-chinese-formal",chosung:"hangul-consonant",ideographDigital:"cjk-ideographic",ideographTraditional:"cjk-heavenly-stem",ideographLegalTraditional:"trad-chinese-formal",ideographZodiac:"cjk-earthly-branch",iroha:"katakana-iroha",irohaFullWidth:"katakana-iroha",japaneseCounting:"japanese-informal",japaneseDigitalTenThousand:"cjk-decimal",japaneseLegal:"japanese-formal",thaiNumbers:"thai",koreanCounting:"korean-hangul-formal",koreanDigital:"korean-hangul-formal",koreanDigital2:"korean-hanja-informal",hebrew1:"hebrew",hebrew2:"hebrew",hindiNumbers:"devanagari",ganada:"hangul",taiwaneseCounting:"cjk-ideographic",taiwaneseCountingThousand:"cjk-ideographic",taiwaneseDigital:"cjk-decimal"}[e])&&void 0!==t?t:e}refreshTabStops(){this.options.experimental&&(clearTimeout(this.tabsTimeout),this.tabsTimeout=setTimeout((()=>{const e=(0, n.computePixelToPoint)();for(let t of this.currentTabs)(0, n.updateTabStop)(t.span,t.stops,this.defaultTabSize,e);}),500));}};},630:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.updateTabStop=t.computePixelToPoint=void 0;const r={pos:0,leader:"none",style:"left"};function a(e){return parseFloat(e)}t.computePixelToPoint=function(e=document.body){const t=document.createElement("div");t.style.width="100pt",e.appendChild(t);const r=100/t.offsetWidth;return e.removeChild(t),r},t.updateTabStop=function(e,t,s,n=.75){const l=e.closest("p"),o=e.getBoundingClientRect(),i=l.getBoundingClientRect(),c=getComputedStyle(l),u=(null==t?void 0:t.length)>0?t.map((e=>({pos:a(e.position),leader:e.leader,style:e.style}))).sort(((e,t)=>e.pos-t.pos)):[r],p=u[u.length-1],d=i.width*n,m=a(s);let h=p.pos+m;if(h<d)for(;h<d&&u.length<50;h+=m)u.push(Object.assign(Object.assign({},r),{pos:h}));const f=parseFloat(c.marginLeft),g=i.left+f,b=(o.left-g)*n,y=u.find((e=>"clear"!=e.style&&e.pos>b));if(null==y)return;let v=1;if("right"==y.style||"center"==y.style){const t=Array.from(l.querySelectorAll(`.${e.className}`)),r=t.indexOf(e)+1,a=document.createRange();a.setStart(e,1),r<t.length?a.setEndBefore(t[r]):a.setEndAfter(l);const s="center"==y.style?.5:1,o=a.getBoundingClientRect(),c=o.left+s*o.width-(i.left-f);v=y.pos-c*n;}else v=y.pos-b;switch(e.innerHTML="&nbsp;",e.style.textDecoration="inherit",e.style.wordSpacing=`${v.toFixed(0)}pt`,y.leader){case"dot":case"middleDot":e.style.textDecoration="underline",e.style.textDecorationStyle="dotted";break;case"hyphen":case"heavy":case"underscore":e.style.textDecoration="underline";}};},881:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.WmlEndnote=t.WmlFootnote=t.WmlBaseNote=void 0;const a=r(120);class s{}t.WmlBaseNote=s,t.WmlFootnote=class extends s{constructor(){super(...arguments),this.type=a.DomType.Footnote;}},t.WmlEndnote=class extends s{constructor(){super(...arguments),this.type=a.DomType.Endnote;}};},735:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.EndnotesPart=t.FootnotesPart=t.BaseNotePart=void 0;const a=r(530),s=r(881);class n extends a.Part{constructor(e,t,r){super(e,t),this._documentParser=r;}}t.BaseNotePart=n,t.FootnotesPart=class extends n{constructor(e,t,r){super(e,t,r);}parseXml(e){this.notes=this._documentParser.parseNotes(e,"footnote",s.WmlFootnote);}},t.EndnotesPart=class extends n{constructor(e,t,r){super(e,t,r);}parseXml(e){this.notes=this._documentParser.parseNotes(e,"endnote",s.WmlEndnote);}};},527:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.NumberingPart=void 0;const a=r(530),s=r(682);class n extends a.Part{constructor(e,t,r){super(e,t),this._documentParser=r;}parseXml(e){Object.assign(this,(0, s.parseNumberingPart)(e,this._package.xmlParser)),this.domNumberings=this._documentParser.parseNumberingFile(e);}}t.NumberingPart=n;},682:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseNumberingBulletPicture=t.parseNumberingLevelOverrride=t.parseNumberingLevel=t.parseAbstractNumbering=t.parseNumbering=t.parseNumberingPart=void 0;const a=r(109),s=r(488);function n(e,t){let r={id:t.attr(e,"numId"),overrides:[]};for(let a of t.elements(e))switch(a.localName){case"abstractNumId":r.abstractId=t.attr(a,"val");break;case"lvlOverride":r.overrides.push(i(a,t));}return r}function l(e,t){let r={id:t.attr(e,"abstractNumId"),levels:[]};for(let a of t.elements(e))switch(a.localName){case"name":r.name=t.attr(a,"val");break;case"multiLevelType":r.multiLevelType=t.attr(a,"val");break;case"numStyleLink":r.numberingStyleLink=t.attr(a,"val");break;case"styleLink":r.styleLink=t.attr(a,"val");break;case"lvl":r.levels.push(o(a,t));}return r}function o(e,t){let r={level:t.intAttr(e,"ilvl")};for(let n of t.elements(e))switch(n.localName){case"start":r.start=t.attr(n,"val");break;case"lvlRestart":r.restart=t.intAttr(n,"val");break;case"numFmt":r.format=t.attr(n,"val");break;case"lvlText":r.text=t.attr(n,"val");break;case"lvlJc":r.justification=t.attr(n,"val");break;case"lvlPicBulletId":r.bulletPictureId=t.attr(n,"val");break;case"pStyle":r.paragraphStyle=t.attr(n,"val");break;case"pPr":r.paragraphProps=(0, a.parseParagraphProperties)(n,t);break;case"rPr":r.runProps=(0, s.parseRunProperties)(n,t);}return r}function i(e,t){let r={level:t.intAttr(e,"ilvl")};for(let a of t.elements(e))switch(a.localName){case"startOverride":r.start=t.intAttr(a,"val");break;case"lvl":r.numberingLevel=o(a,t);}return r}function c(e,t){var r=t.element(e,"pict"),a=r&&t.element(r,"shape"),s=a&&t.element(a,"imagedata");return s?{id:t.attr(e,"numPicBulletId"),referenceId:t.attr(s,"id"),style:t.attr(a,"style")}:null}t.parseNumberingPart=function(e,t){let r={numberings:[],abstractNumberings:[],bulletPictures:[]};for(let a of t.elements(e))switch(a.localName){case"num":r.numberings.push(n(a,t));break;case"abstractNum":r.abstractNumberings.push(l(a,t));break;case"numPicBullet":r.bulletPictures.push(c(a,t));}return r},t.parseNumbering=n,t.parseAbstractNumbering=l,t.parseNumberingLevel=o,t.parseNumberingLevelOverrride=i,t.parseNumberingBulletPicture=c;},472:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.XmlParser=t.serializeXmlString=t.parseXmlString=void 0;const a=r(149);t.parseXmlString=function(e,t=!1){var r;t&&(e=e.replace(/<[?].*[?]>/,"")),e=65279===(r=e).charCodeAt(0)?r.substring(1):r;const a=(new DOMParser).parseFromString(e,"application/xml"),s=null===(n=a.getElementsByTagName("parsererror")[0])||void 0===n?void 0:n.textContent;var n;if(s)throw new Error(s);return a},t.serializeXmlString=function(e){return (new XMLSerializer).serializeToString(e)};class s{elements(e,t=null){const r=[];for(let a=0,s=e.childNodes.length;a<s;a++){let s=e.childNodes.item(a);1!=s.nodeType||null!=t&&s.localName!=t||r.push(s);}return r}element(e,t){for(let r=0,a=e.childNodes.length;r<a;r++){let a=e.childNodes.item(r);if(1==a.nodeType&&a.localName==t)return a}return null}elementAttr(e,t,r){var a=this.element(e,t);return a?this.attr(a,r):void 0}attrs(e){return Array.from(e.attributes)}attr(e,t){for(let r=0,a=e.attributes.length;r<a;r++){let a=e.attributes.item(r);if(a.localName==t)return a.value}return null}intAttr(e,t,r=null){var a=this.attr(e,t);return a?parseInt(a):r}hexAttr(e,t,r=null){var a=this.attr(e,t);return a?parseInt(a,16):r}floatAttr(e,t,r=null){var a=this.attr(e,t);return a?parseFloat(a):r}boolAttr(e,t,r=null){return (0, a.convertBoolean)(this.attr(e,t),r)}lengthAttr(e,t,r=a.LengthUsage.Dxa){return (0, a.convertLength)(this.attr(e,t),r)}}t.XmlParser=s;const n=new s;t.default=n;},287:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.SettingsPart=void 0;const a=r(530),s=r(846);class n extends a.Part{constructor(e,t){super(e,t);}parseXml(e){this.settings=(0, s.parseSettings)(e,this._package.xmlParser);}}t.SettingsPart=n;},846:(e,t)=>{function r(e,t){var r={defaultNoteIds:[]};for(let a of t.elements(e))switch(a.localName){case"numFmt":r.nummeringFormat=t.attr(a,"val");break;case"footnote":case"endnote":r.defaultNoteIds.push(t.attr(a,"id"));}return r}Object.defineProperty(t,"__esModule",{value:!0}),t.parseNoteProperties=t.parseSettings=void 0,t.parseSettings=function(e,t){var a={};for(let s of t.elements(e))switch(s.localName){case"defaultTabStop":a.defaultTabStop=t.lengthAttr(s,"val");break;case"footnotePr":a.footnoteProps=r(s,t);break;case"endnotePr":a.endnoteProps=r(s,t);break;case"autoHyphenation":a.autoHyphenation=t.boolAttr(s,"val");}return a},t.parseNoteProperties=r;},240:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.StylesPart=void 0;const a=r(530);class s extends a.Part{constructor(e,t,r){super(e,t),this._documentParser=r;}parseXml(e){this.styles=this._documentParser.parseStylesFile(e);}}t.StylesPart=s;},893:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.ThemePart=void 0;const a=r(530),s=r(55);class n extends a.Part{constructor(e,t){super(e,t);}parseXml(e){this.theme=(0, s.parseTheme)(e,this._package.xmlParser);}}t.ThemePart=n;},55:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseFontInfo=t.parseFontScheme=t.parseColorScheme=t.parseTheme=t.DmlTheme=void 0;class r{}function a(e,t){var r={name:t.attr(e,"name"),colors:{}};for(let n of t.elements(e)){var a=t.element(n,"srgbClr"),s=t.element(n,"sysClr");a?r.colors[n.localName]=t.attr(a,"val"):s&&(r.colors[n.localName]=t.attr(s,"lastClr"));}return r}function s(e,t){var r={name:t.attr(e,"name")};for(let a of t.elements(e))switch(a.localName){case"majorFont":r.majorFont=n(a,t);break;case"minorFont":r.minorFont=n(a,t);}return r}function n(e,t){return {latinTypeface:t.elementAttr(e,"latin","typeface"),eaTypeface:t.elementAttr(e,"ea","typeface"),csTypeface:t.elementAttr(e,"cs","typeface")}}t.DmlTheme=r,t.parseTheme=function(e,t){var n=new r,l=t.element(e,"themeElements");for(let e of t.elements(l))switch(e.localName){case"clrScheme":n.colorScheme=a(e,t);break;case"fontScheme":n.fontScheme=s(e,t);}return n},t.parseColorScheme=a,t.parseFontScheme=s,t.parseFontInfo=n;},593:(e,t)=>{function r(e){return e&&"object"==typeof e&&!Array.isArray(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.asArray=t.formatCssRules=t.parseCssRules=t.mergeDeep=t.isString=t.isObject=t.blobToBase64=t.keyBy=t.resolvePath=t.splitPath=t.escapeClassName=void 0,t.escapeClassName=function(e){return null==e?void 0:e.replace(/[ .]+/g,"-").replace(/[&]+/g,"and").toLowerCase()},t.splitPath=function(e){let t=e.lastIndexOf("/")+1;return [0==t?"":e.substring(0,t),0==t?e:e.substring(t)]},t.resolvePath=function(e,t){try{const r="http://docx/";return new URL(e,r+t).toString().substring(r.length)}catch(r){return `${t}${e}`}},t.keyBy=function(e,t){return e.reduce(((e,r)=>(e[t(r)]=r,e)),{})},t.blobToBase64=function(e){return new Promise(((t,r)=>{const a=new FileReader;a.onloadend=()=>t(a.result),a.onerror=()=>r(),a.readAsDataURL(e);}))},t.isObject=r,t.isString=function(e){return "string"==typeof e||e instanceof String},t.mergeDeep=function e(t,...a){var s;if(!a.length)return t;const n=a.shift();if(r(t)&&r(n))for(const a in n)r(n[a])?e(null!==(s=t[a])&&void 0!==s?s:t[a]={},n[a]):t[a]=n[a];return e(t,...a)},t.parseCssRules=function(e){const t={};for(const r of e.split(";")){const[e,a]=r.split(":");t[e]=a;}return t},t.formatCssRules=function(e){return Object.entries(e).map(((e,t)=>`${e}: ${t}`)).join(";")},t.asArray=function(e){return Array.isArray(e)?e:[e]};},320:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseVmlElement=t.VmlElement=void 0;const a=r(149),s=r(120),n=r(472);class l extends s.OpenXmlElementBase{constructor(){super(...arguments),this.type=s.DomType.VmlElement,this.attrs={};}}function o(e){var t;return {stroke:n.default.attr(e,"color"),"stroke-width":null!==(t=n.default.lengthAttr(e,"weight",a.LengthUsage.Emu))&&void 0!==t?t:"1px"}}function i(e){return e.split(",")}t.VmlElement=l,t.parseVmlElement=function e(t,r){var a=new l;switch(t.localName){case"rect":a.tagName="rect",Object.assign(a.attrs,{width:"100%",height:"100%"});break;case"oval":a.tagName="ellipse",Object.assign(a.attrs,{cx:"50%",cy:"50%",rx:"50%",ry:"50%"});break;case"line":a.tagName="line";break;case"shape":a.tagName="g";break;case"textbox":a.tagName="foreignObject",Object.assign(a.attrs,{width:"100%",height:"100%"});break;default:return null}for(const e of n.default.attrs(t))switch(e.localName){case"style":a.cssStyleText=e.value;break;case"fillcolor":a.attrs.fill=e.value;break;case"from":const[t,r]=i(e.value);Object.assign(a.attrs,{x1:t,y1:r});break;case"to":const[s,n]=i(e.value);Object.assign(a.attrs,{x2:s,y2:n});}for(const s of n.default.elements(t))switch(s.localName){case"stroke":Object.assign(a.attrs,o(s));break;case"fill":Object.assign(a.attrs,{});break;case"imagedata":a.tagName="image",Object.assign(a.attrs,{width:"100%",height:"100%"}),a.imageHref={id:n.default.attr(s,"id"),title:n.default.attr(s,"title")};break;case"txbxContent":a.children.push(...r.parseBodyElements(s));break;default:const t=e(s,r);t&&a.children.push(t);}return a};},213:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.deobfuscate=t.WordDocument=void 0;const a=r(461),s=r(380),n=r(522),l=r(448),o=r(593),i=r(527),c=r(240),u=r(985),p=r(665),d=r(162),m=r(893),h=r(735),f=r(287),g=r(177),b=[{type:a.RelationshipTypes.OfficeDocument,target:"word/document.xml"},{type:a.RelationshipTypes.ExtendedProperties,target:"docProps/app.xml"},{type:a.RelationshipTypes.CoreProperties,target:"docProps/core.xml"},{type:a.RelationshipTypes.CustomProperties,target:"docProps/custom.xml"}];class y{constructor(){this.parts=[],this.partsMap={};}static async load(e,t,r){var a=new y;return a._options=r,a._parser=t,a._package=await n.OpenXmlPackage.load(e,r),a.rels=await a._package.loadRelationships(),await Promise.all(b.map((e=>{var t;const r=null!==(t=a.rels.find((t=>t.type===e.type)))&&void 0!==t?t:e;return a.loadRelationshipPart(r.target,r.type)}))),a}save(e="blob"){return this._package.save(e)}async loadRelationshipPart(e,t){var r;if(this.partsMap[e])return this.partsMap[e];if(!this._package.get(e))return null;let n=null;switch(t){case a.RelationshipTypes.OfficeDocument:this.documentPart=n=new l.DocumentPart(this._package,e,this._parser);break;case a.RelationshipTypes.FontTable:this.fontTablePart=n=new s.FontTablePart(this._package,e);break;case a.RelationshipTypes.Numbering:this.numberingPart=n=new i.NumberingPart(this._package,e,this._parser);break;case a.RelationshipTypes.Styles:this.stylesPart=n=new c.StylesPart(this._package,e,this._parser);break;case a.RelationshipTypes.Theme:this.themePart=n=new m.ThemePart(this._package,e);break;case a.RelationshipTypes.Footnotes:this.footnotesPart=n=new h.FootnotesPart(this._package,e,this._parser);break;case a.RelationshipTypes.Endnotes:this.endnotesPart=n=new h.EndnotesPart(this._package,e,this._parser);break;case a.RelationshipTypes.Footer:n=new u.FooterPart(this._package,e,this._parser);break;case a.RelationshipTypes.Header:n=new u.HeaderPart(this._package,e,this._parser);break;case a.RelationshipTypes.CoreProperties:this.corePropsPart=n=new d.CorePropsPart(this._package,e);break;case a.RelationshipTypes.ExtendedProperties:this.extendedPropsPart=n=new p.ExtendedPropsPart(this._package,e);break;case a.RelationshipTypes.CustomProperties:n=new g.CustomPropsPart(this._package,e);break;case a.RelationshipTypes.Settings:this.settingsPart=n=new f.SettingsPart(this._package,e);}if(null==n)return Promise.resolve(null);if(this.partsMap[e]=n,this.parts.push(n),await n.load(),(null===(r=n.rels)||void 0===r?void 0:r.length)>0){const[e]=(0, o.splitPath)(n.path);await Promise.all(n.rels.map((t=>this.loadRelationshipPart((0, o.resolvePath)(t.target,e),t.type))));}return n}async loadDocumentImage(e,t){const r=await this.loadResource(null!=t?t:this.documentPart,e,"blob");return this.blobToURL(r)}async loadNumberingImage(e){const t=await this.loadResource(this.numberingPart,e,"blob");return this.blobToURL(t)}async loadFont(e,t){const r=await this.loadResource(this.fontTablePart,e,"uint8array");return r?this.blobToURL(new Blob([v(r,t)])):r}blobToURL(e){return e?this._options.useBase64URL?(0, o.blobToBase64)(e):URL.createObjectURL(e):null}findPartByRelId(e,t=null){var r,a=(null!==(r=t.rels)&&void 0!==r?r:this.rels).find((t=>t.id==e));const s=t?(0, o.splitPath)(t.path)[0]:"";return a?this.partsMap[(0, o.resolvePath)(a.target,s)]:null}getPathById(e,t){const r=e.rels.find((e=>e.id==t)),[a]=(0, o.splitPath)(e.path);return r?(0, o.resolvePath)(r.target,a):null}loadResource(e,t,r){const a=this.getPathById(e,t);return a?this._package.load(a,r):Promise.resolve(null)}}function v(e,t){const r=t.replace(/{|}|-/g,""),a=new Array(16);for(let e=0;e<16;e++)a[16-e-1]=parseInt(r.substr(2*e,2),16);for(let t=0;t<32;t++)e[t]=e[t]^a[t%16];return e}t.WordDocument=y,t.deobfuscate=v;},583:e=>{e.exports="data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 100%27 preserveAspectRatio=%27none%27%3E%3Cpath d=%27m0,75 l5,0 l5,25 l10,-100%27 stroke=%27black%27 fill=%27none%27 vector-effect=%27non-scaling-stroke%27/%3E%3C/svg%3E";},626:t=>{t.exports=e;}},r={};function a(e){var s=r[e];if(void 0!==s)return s.exports;var n=r[e]={id:e,exports:{}};return t[e](n,n.exports,a),n.exports}return a.m=t,a.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return a.d(t,{a:t}),t},a.d=(e,t)=>{for(var r in t)a.o(t,r)&&!a.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]});},a.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),a.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},a.b=document.baseURI||self.location.href,a(667)})()));

});

var script$d = {
  name: 'DocPreview',
  props: {
    docPath: {
      type: String,
      required: true
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Number,
      default: 1,
      validate: num => num > 0 && num < 2
    },
    dataQa: {
      type: String,
      default: 'DocPreview'
    }
  },
  watch: {
    docPath: {
      immediate: true,

      handler() {
        /* istanbul ignore next */
        fetch(this.docPath).then(res => res.blob()).then(blob => {
          docxPreview_min.renderAsync(blob, this.$refs.preview);
          this.$emit('loaded');
        }).catch(err => {
          console.error(err);
          this.$emit('error', err);
        });
      }

    }
  }
};

/* script */
const __vue_script__$d = script$d;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "preview",
    staticClass: "doc-preview",
    class: {
      'doc-preview--width': _vm.fullWidth
    },
    style: "transform: scale(" + _vm.zoom + ");",
    attrs: {
      "data-qa": "DocPreview"
    }
  });
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$d = function (inject) {
  if (!inject) return;
  inject("data-v-3bf93203_0", {
    source: ".doc-preview[data-v-3bf93203]{height:100%;width:100%;transform-origin:top center}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$d = "data-v-3bf93203";
/* module identifier */

const __vue_module_identifier__$d = undefined;
/* functional template */

const __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);

var DocPreview = __vue_component__$k;

var script$c = {
  name: 'UnsupportedFile',
  components: {
    VcSvg,
    VcButton
  },
  props: {
    title: {
      type: String,
      default: 'Can’t preview this file'
    },
    ctaText: {
      type: String,
      default: 'Download'
    },
    dataQa: {
      type: String,
      default: 'unsupported-file'
    }
  }
};

/* script */
const __vue_script__$c = script$c;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "unsupported-file",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('div', {
    staticClass: "unsupported-file__content"
  }, [_c('VcSvg', {
    staticClass: "unsupported-file__image",
    attrs: {
      "svg": _vm.$svgImages.previewFiles
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "unsupported-file__title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', [_c('VcButton', {
    staticClass: "unsupported-file__button",
    attrs: {
      "prepend-default-icon": "",
      "ghost": "",
      "prepend-icon": "in_coming",
      "color": "white",
      "elevation": 5,
      "data-qa": _vm.dataQa + "-button",
      "label": _vm.ctaText
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('download');
      }
    }
  })], 1)], 1)]);
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$c = function (inject) {
  if (!inject) return;
  inject("data-v-33501fbe_0", {
    source: ".unsupported-file[data-v-33501fbe]{position:absolute;width:100%;max-width:100%;height:100%;max-height:100%;left:0;top:0;overflow:hidden;display:flex;justify-content:center;align-items:center}.unsupported-file__content[data-v-33501fbe]{background-color:var(--gray-lighten-1);width:450px;max-width:90%;height:auto;text-align:center;border-radius:var(--size-value6);padding:var(--size-value8) var(--size-value12);display:flex;flex-direction:column}.unsupported-file__image[data-v-33501fbe]{user-select:none}.unsupported-file__title[data-v-33501fbe]{user-select:none;margin-bottom:var(--size-value6);font-size:var(--font-size-small3);font-weight:var(--font-weight-large);color:var(--gray-darken-5)}.unsupported-file__button[data-v-33501fbe]{margin-bottom:var(--size-value4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$c = "data-v-33501fbe";
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, createInjector, undefined, undefined);

var UnsupportedFile = __vue_component__$j;

var script$b = {
  name: 'ErrorWithServer',
  components: {
    VcSvg
  },
  props: {
    title: {
      type: String,
      default: 'Something went wrong'
    },
    subTitle: {
      type: String,
      default: 'Try refreshing the page'
    },
    dataQa: {
      type: String,
      default: 'error-with-server'
    }
  }
};

/* script */
const __vue_script__$b = script$b;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "error-server",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('div', {
    staticClass: "error-server__content"
  }, [_c('VcSvg', {
    staticClass: "error-server__image",
    attrs: {
      "svg": _vm.$svgImages.errorFile
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "error-server__title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('h5', {
    staticClass: "error-server__subtitle"
  }, [_vm._v("\n      " + _vm._s(_vm.subTitle) + "\n    ")])], 1)]);
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$b = function (inject) {
  if (!inject) return;
  inject("data-v-6ba3be75_0", {
    source: ".error-server[data-v-6ba3be75]{position:absolute;width:100%;max-width:100%;height:100%;max-height:100%;left:0;top:0;overflow:hidden;display:flex;justify-content:center;align-items:center}.error-server__content[data-v-6ba3be75]{background-color:var(--gray-lighten-1);width:450px;max-width:90%;height:auto;text-align:center;border-radius:var(--size-value6);padding:var(--size-value8) var(--size-value12);display:flex;flex-direction:column}.error-server__image[data-v-6ba3be75]{user-select:none}.error-server__title[data-v-6ba3be75]{user-select:none;font-size:var(--font-size-small3);font-weight:var(--font-weight-large);color:var(--gray-darken-5)}.error-server__subtitle[data-v-6ba3be75]{user-select:none;margin-bottom:var(--size-value6);font-size:var(--font-size-small2);font-weight:var(--font-weight-medium);color:var(--gray-darken-5)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$b = "data-v-6ba3be75";
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, createInjector, undefined, undefined);

var ErrorWithServer = __vue_component__$i;

var script$a = {
  name: 'VcPreview',
  components: {
    ErrorWithServer,
    VcLoader,
    VuePdfEmbed: () => import('./vue2-pdf-embed-3f57f25f.js').then(function (n) { return n.v; }),
    DocPreview,
    UnsupportedFile,
    VcIcon
  },
  props: {
    fileLocation: {
      type: String,
      required: true
    },
    fileType: {
      type: String,
      required: true,
      validate: value => ['errorWithServer', 'pdf', 'document', 'image', 'nativePdf', 'unsupported', 'tooBig'].includes(value)
    },
    icon: {
      type: String
    },
    narrow: {
      type: Boolean,
      default: false
    },
    unsupportedFilesTexts: {
      type: Object
    },
    errorWithServerTexts: {
      type: Object
    },
    pdfWidth: {
      type: Number,
      default: 700
    },
    zoom: {
      type: Number,
      default: 1,
      validate: num => num > 0 && num < 2
    },
    rotate: {
      type: Number,
      default: 0
    },
    disableLoader: {
      type: Boolean,
      default: false
    },
    focusMode: {
      type: Boolean,
      default: false
    },
    inFocus: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcPreview'
    }
  },
  data: () => ({
    loading: true,
    displayError: false
  }),
  computed: {
    errorWithServer() {
      return 'errorWithServer' === this.fileType;
    },

    transformOrigin() {
      const start = this.$vuetify.rtl ? 'right' : 'left';
      const origin = this.zoom > 1 ? start : 'center';
      return `${origin} top`;
    }

  },
  watch: {
    fileLocation() {
      if (['nativePdf', 'unsupported', 'tooBig', 'errorWithServer'].includes(this.fileType)) {
        this.loading = false;
        this.displayError = false;
      } else {
        this.loading = true;
        this.displayError = false;
      }
    }

  },
  methods: {
    onload() {
      this.loading = false;
      this.displayError = false;
    },

    onerror(error) {
      console.error('Error loading:', error);
      this.loading = false;
      this.displayError = true;
      this.$emit('errorLoading', error);
    }

  }
};

/* script */
const __vue_script__$a = script$a;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['preview', {
      'focus-mode': _vm.focusMode
    }, {
      inFocus: _vm.inFocus
    }],
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm.loading && !_vm.disableLoader && !_vm.errorWithServer ? _c('VcLoader', {
    attrs: {
      "mode": "linear",
      "data-qa": _vm.dataQa + "--loader"
    }
  }) : _vm._e(), _vm._v(" "), _vm.errorWithServer ? _c('ErrorWithServer', _vm._b({}, 'ErrorWithServer', _vm.errorWithServerTexts, false)) : ['unsupported', 'tooBig'].includes(_vm.fileType) || _vm.displayError ? _c('UnsupportedFile', _vm._b({
    on: {
      "download": function ($event) {
        return _vm.$emit('download');
      }
    }
  }, 'UnsupportedFile', _vm.unsupportedFilesTexts, false)) : _vm.fileType === 'nativePdf' ? [_c('iframe', {
    staticClass: "iframe-desktop",
    attrs: {
      "src": _vm.fileLocation,
      "data-qa": _vm.dataQa + "--iframe"
    }
  })] : _vm.fileType === 'pdf' && !_vm.displayError ? [_c('vue-pdf-embed', {
    attrs: {
      "data-qa": _vm.dataQa + "--pdf",
      "rotation": _vm.rotate,
      "width": _vm.pdfWidth * _vm.zoom,
      "source": _vm.fileLocation
    },
    on: {
      "loading-failed": _vm.onerror,
      "rendering-failed": _vm.onerror,
      "password-requested": _vm.onerror,
      "loaded": _vm.onload
    }
  })] : _vm.fileType === 'document' ? _c('DocPreview', {
    attrs: {
      "doc-path": _vm.fileLocation,
      "full-width": _vm.narrow,
      "zoom": _vm.zoom,
      "rotate": _vm.rotate
    },
    on: {
      "loaded": _vm.onload,
      "error": _vm.onerror
    }
  }) : _vm.fileType === 'image' ? _c('div', {
    staticClass: "image-display__wrapper",
    style: "transform: scale(" + _vm.zoom + ");transformOrigin:" + _vm.transformOrigin + ";",
    attrs: {
      "data-qa": _vm.dataQa + "--image"
    }
  }, [_c('img', {
    staticClass: "image-display__image",
    style: "transform: rotate(" + _vm.rotate + "deg);",
    attrs: {
      "src": _vm.fileLocation
    },
    on: {
      "error": _vm.onerror,
      "load": _vm.onload
    }
  })]) : _vm.fileType === 'icon' ? _c('div', {
    staticClass: "icon-display"
  }, [_c('VcIcon', {
    attrs: {
      "size": "52"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.icon) + "\n    ")])], 1) : _vm._e()], 2);
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$a = function (inject) {
  if (!inject) return;
  inject("data-v-34c1c169_0", {
    source: "[data-v-34c1c169]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-34c1c169]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-34c1c169]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-34c1c169]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-34c1c169]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-34c1c169]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-34c1c169]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-34c1c169]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-34c1c169]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-34c1c169]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-34c1c169]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-34c1c169]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-34c1c169]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-34c1c169]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-34c1c169]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-34c1c169]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-34c1c169]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-34c1c169]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-34c1c169]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-34c1c169]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-34c1c169]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-34c1c169]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-34c1c169]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-34c1c169]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-34c1c169]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-34c1c169]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-34c1c169]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-34c1c169]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-34c1c169]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-34c1c169]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-34c1c169]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-34c1c169]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-34c1c169]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-34c1c169]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-34c1c169]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-34c1c169]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-34c1c169]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-34c1c169]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-34c1c169]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-34c1c169]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-34c1c169]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-34c1c169]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-34c1c169]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-34c1c169]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-34c1c169]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-34c1c169]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-34c1c169]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-34c1c169]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-34c1c169]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-34c1c169]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-34c1c169]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-34c1c169]{--color-dark:#63757e;--color-light:#c8d2d7}.preview[data-v-34c1c169]{height:100%;width:fit-content;min-width:100%}.pdf-display[data-v-34c1c169]{overflow:scroll}.focus-mode[data-v-34c1c169]{opacity:.5;transition:.1s}.focus-mode[data-v-34c1c169]:hover{opacity:.7;transition:.3s}.inFocus[data-v-34c1c169]{opacity:1;border-radius:4px;border:3px solid var(--v-secondary-base)}.inFocus[data-v-34c1c169]:hover{opacity:1}.iframe-desktop[data-v-34c1c169]{height:100%;width:100%;border:none}[data-v-34c1c169] .vue-pdf-embed__page{display:flex;justify-content:center}[data-v-34c1c169] .vue-pdf-embed div:not(:last-child) canvas{margin-bottom:var(--size-value3)}.image-display__wrapper[data-v-34c1c169]{position:relative;width:100%;height:100%;display:flex;justify-content:center;align-items:flex-start;transition:.2s ease-in-out}.focus-mode .image-display__wrapper[data-v-34c1c169]{align-items:center}.image-display__image[data-v-34c1c169]{height:auto;max-width:100%;transition:.2s ease-in-out}.icon-display[data-v-34c1c169]{display:flex;justify-content:center;align-items:center;height:100%;background-color:var(--gray-lighten-3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$a = "data-v-34c1c169";
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, createInjector, undefined, undefined);

var VcPreview = __vue_component__$h;

var script$9 = {
  name: 'VcGalleyHeader',
  components: {
    VcIcon,
    VcMenu,
    VcMenuItem,
    VcButton
  },
  props: {
    fileName: {
      type: String,
      required: true
    },
    actions: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: 'l',
      validator: value => ['s', 'l'].includes(value)
    },
    dataQa: {
      type: String,
      default: 'VcGallery__header'
    }
  }
};

/* script */
const __vue_script__$9 = script$9;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "gallery-header",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('VcButton', {
    attrs: {
      "data-qa": _vm.dataQa + "--back-button",
      "prepend-default-icon": "",
      "ghost": "",
      "white": "",
      "prepend-icon": "$chevron_left",
      "flavor": "secondary",
      "label": _vm.fileName
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('back');
      }
    }
  }), _vm._v(" "), _vm.actions.length ? _c('div', {
    staticClass: "gallery-header__actions"
  }, [_vm._t("actions", function () {
    return [_vm.size === 'l' ? _c('div', {
      staticClass: "gallery-header__actions__item"
    }, _vm._l(_vm.actions, function (action) {
      return _c('VcButton', {
        key: action.name,
        attrs: {
          "prepend-default-icon": "",
          "icon": "",
          "white": "",
          "prepend-icon": action.icon,
          "data-qa": _vm.dataQa + "--" + action.name + "-button",
          "disabled": action.disabled,
          "loading": action.loading
        },
        on: {
          "click": function ($event) {
            return _vm.$emit('action', action.name);
          }
        },
        scopedSlots: _vm._u([{
          key: "prepend",
          fn: function () {
            return [_c('VcIcon', {
              attrs: {
                "small": "",
                "color": "var(--gray-lighten-4)"
              }
            }, [_vm._v("\n              " + _vm._s(action.icon) + "\n            ")])];
          },
          proxy: true
        }], null, true)
      });
    }), 1) : _c('VcMenu', {
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (ref) {
          var on = ref.on;
          return [_c('VcButton', _vm._g({
            attrs: {
              "prepend-default-icon": "",
              "icon": "",
              "white": "",
              "prepend-icon": "$three_dots",
              "data-qa": _vm.dataQa + "--actions-menu"
            }
          }, on))];
        }
      }], null, false, 1918686934)
    }, [_vm._v(" "), _c('div', {
      staticClass: "gallery-header__actions--mobile"
    }, _vm._l(_vm.actions, function (action) {
      return _c('VcMenuItem', _vm._b({
        key: action.name,
        attrs: {
          "data-qa": _vm.dataQa + "--" + action.name + "-button"
        },
        on: {
          "click": function ($event) {
            return _vm.$emit('action', action.name);
          }
        }
      }, 'VcMenuItem', action, false));
    }), 1)])];
  })], 2) : _vm._e()], 1);
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$9 = function (inject) {
  if (!inject) return;
  inject("data-v-b90cb71e_0", {
    source: "[data-v-b90cb71e]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xs-small:11px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium0:20px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-radius-circle:50%;--border-frame:1px solid var(--gray-lighten-1);--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--centered-layout-min-width:708px;--centered-layout-max-width:1316px;--left-panel-width:265px;--vc-top-bar-height:58px;--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:0;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--scroll-shadow-size:var(--size-value2);--scroll-shadow-offset:-3px;--scroll-shadow-color:rgba(23, 23, 23, 0.13);--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--select-field-height-md:32px;--bottom-nav-shadow:0px -3px 8px rgba(23, 23, 23, 0.13);--entity-status-info-background-color:var(--neutral-lighten-2);--entity-status-info-header-color:var(--neutral);--entity-status-alert-background-color:#fff9e4;--entity-status-alert-header-color:#c68600;--entity-status-warning-background-color:#fff0e8;--entity-status-warning-header-color:#b74302;--entity-status-error-background-color:#fdeaee;--entity-status-error-header-color:#a82433;--entity-status-success-background-color:#e8f8f4;--entity-status-success-header-color:#2c7d67;--entity-status-default-background-color:#e6f6ff;--entity-status-default-header-color:#004970;--table-sticky-column-shadow:10px 0 12px 0 rgba(0, 0, 0, 0.08);--v-secondary-base-opacity-4:color-mix(in srgb, var(--v-secondary-base), transparent 96%);--v-secondary-base-opacity-8:color-mix(in srgb, var(--v-secondary-base), transparent 92%);--v-secondary-base-opacity-14:color-mix(in srgb, var(--v-secondary-base), transparent 86%);--v-secondary-base-opacity-20:color-mix(in srgb, var(--v-secondary-base), transparent 80%);--black:#000000;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--gray-light-opacity-1:#e1e1e129;--gray-light-opacity-2:#e1e1e11f;--gray-light-opacity-3:#e1e1e112;--neutral:#586e8c;--neutral-lighten-1:#d6dbe6;--neutral-lighten-2:#eaedf2;--neutral-lighten-3:#f8f9fb;--red:#f2514a;--red-lighten-1:#f79792;--red-lighten-2:#fbcbc9;--red-lighten-3:#fde8e7;--yellow:#ffc511;--yellow-lighten-1:#ffdc70;--yellow-lighten-2:#ffedb8;--yellow-lighten-3:#fff7e0;--green:#54d28c;--green-lighten-1:#98e4ba;--green-lighten-2:#cff8e1;--green-lighten-3:#eafcf2;--blue:#478fff;--blue-lighten-1:#91bcff;--blue-lighten-2:#c8ddff;--blue-lighten-3:#e7f0ff;--orange:#ff8f00;--orange-lighten-1:#fcb965;--orange-lighten-2:#fad9b0;--orange-lighten-3:#f9ebda;--purple:#bd98f7;--purple-lighten-1:#caadf9;--purple-lighten-2:#d7c1fa;--purple-lighten-3:#f7f1ff;--white:#fff;--ai-main:#6039FC;--ai-surface-top:#E7EFFB;--ai-surface-bottom:#F4EDFF;--ai-background:linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%);--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc;--link-color:#1155cc}.color-0[data-v-b90cb71e]{--color-dark:#fed62f;--color-light:#fff1b6}.color-1[data-v-b90cb71e]{--color-dark:#fec22e;--color-light:#ffeab6}.color-2[data-v-b90cb71e]{--color-dark:#feac2a;--color-light:#ffe2b5}.color-3[data-v-b90cb71e]{--color-dark:#fe9a28;--color-light:#ffdcb4}.color-4[data-v-b90cb71e]{--color-dark:#fd7024;--color-light:#fecdb3}.color-5[data-v-b90cb71e]{--color-dark:#fd5b32;--color-light:#fec6b7}.color-6[data-v-b90cb71e]{--color-dark:#f2483f;--color-light:#fabfbc}.color-7[data-v-b90cb71e]{--color-dark:#dc331b;--color-light:#f3b8af}.color-8[data-v-b90cb71e]{--color-dark:#d41419;--color-light:#f0adaf}.color-9[data-v-b90cb71e]{--color-dark:#e72866;--color-light:#f7b4ca}.color-10[data-v-b90cb71e]{--color-dark:#c41c63;--color-light:#eab0c9}.color-11[data-v-b90cb71e]{--color-dark:#9b2bae;--color-light:#dcb5e3}.color-12[data-v-b90cb71e]{--color-dark:#673bb5;--color-light:#cabbe5}.color-13[data-v-b90cb71e]{--color-dark:#7c4efc;--color-light:#d1c1fe}.color-14[data-v-b90cb71e]{--color-dark:#4051b3;--color-light:#bcc2e4}.color-15[data-v-b90cb71e]{--color-dark:#311b92;--color-light:#c0b2ff}.color-16[data-v-b90cb71e]{--color-dark:#2d62fb;--color-light:#b6c8fe}.color-17[data-v-b90cb71e]{--color-dark:#5c6bc0;--color-light:#9aa2d2}.color-18[data-v-b90cb71e]{--color-dark:#17a8f1;--color-light:#aee1fa}.color-19[data-v-b90cb71e]{--color-dark:#17bbd2;--color-light:#aee7ef}.color-20[data-v-b90cb71e]{--color-dark:#14abbf;--color-light:#ade2e9}.color-21[data-v-b90cb71e]{--color-dark:#0f9587;--color-light:#abdad5}.color-22[data-v-b90cb71e]{--color-dark:#16bea5;--color-light:#aee8e0}.color-23[data-v-b90cb71e]{--color-dark:#4eae53;--color-light:#c1e3c3}.color-24[data-v-b90cb71e]{--color-dark:#3a8d3f;--color-light:#bad7bc}.color-25[data-v-b90cb71e]{--color-dark:#8cc250;--color-light:#d7eac2}.color-26[data-v-b90cb71e]{--color-dark:#66bb6a;--color-light:#9fd3a1}.color-27[data-v-b90cb71e]{--color-dark:#880e4f;--color-light:#ab8198}.color-28[data-v-b90cb71e]{--color-dark:#1565c0;--color-light:#83a4ca}.color-29[data-v-b90cb71e]{--color-dark:#1e88e5;--color-light:#79b1ff}.color-9999[data-v-b90cb71e]{--color-dark:#4675d9;--color-light:#becff2}.color-101[data-v-b90cb71e]{--color-dark:#ee5787;--color-light:#ffc6cc}.color-102[data-v-b90cb71e]{--color-dark:#ee5787;--color-light:#f7b3ca}.color-103[data-v-b90cb71e]{--color-dark:#ab51bd;--color-light:#ddb6e3}.color-104[data-v-b90cb71e]{--color-dark:#8564c4;--color-light:#cbbce6}.color-105[data-v-b90cb71e]{--color-dark:#6371bf;--color-light:#bdc3e6}.color-106[data-v-b90cb71e]{--color-dark:#1779ce;--color-light:#b3d9fa}.color-107[data-v-b90cb71e]{--color-dark:#1e92cc;--color-light:#aae1fc}.color-108[data-v-b90cb71e]{--color-dark:#1e8694;--color-light:#a9e8f0}.color-109[data-v-b90cb71e]{--color-dark:#328179;--color-light:#a9dad6}.color-110[data-v-b90cb71e]{--color-dark:#3d853f;--color-light:#c1e2c2}.color-111[data-v-b90cb71e]{--color-dark:#5b8131;--color-light:#d7eac1}.color-112[data-v-b90cb71e]{--color-dark:#757b23;--color-light:#eef2bb}.color-113[data-v-b90cb71e]{--color-dark:#8a731e;--color-light:#fff8bc}.color-114[data-v-b90cb71e]{--color-dark:#c88704;--color-light:#ffe9aa}.color-115[data-v-b90cb71e]{--color-dark:#b85f00;--color-light:#ffdba9}.color-116[data-v-b90cb71e]{--color-dark:#ea0a00;--color-light:#ffc5b4}.color-117[data-v-b90cb71e]{--color-dark:#ff4d1f;--color-light:#ffa186}.color-118[data-v-b90cb71e]{--color-dark:#6e4b3f;--color-light:#d1c5c1}.color-119[data-v-b90cb71e]{--color-dark:#6e4b3f;--color-light:#b4a09a}.color-120[data-v-b90cb71e]{--color-dark:#63757e;--color-light:#c8d2d7}.gallery-header[data-v-b90cb71e]{background-color:var(--gray-darken-4);display:flex;justify-content:space-between}.gallery-header__actions[data-v-b90cb71e]{padding-inline-end:var(--size-value2)}.gallery-header__actions--mobile[data-v-b90cb71e]{display:flex;flex-direction:column;align-items:flex-start;padding:0 var(--size-value4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$9 = "data-v-b90cb71e";
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);

var VcGalleyHeader = __vue_component__$g;

var script$8 = {
  name: 'VcGalleryActions',
  components: {
    VcButton
  },
  props: {
    zoomSize: {
      type: Number,
      default: 100
    },
    rotate: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Boolean,
      default: false
    },
    resetSizeText: {
      type: String,
      default: 'Fit to screen'
    },
    dataQa: {
      type: String,
      default: 'VcGalleryActions'
    }
  }
};

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "gallery-actions",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm.zoom ? _c('div', {
    staticClass: "gallery-actions__status--section"
  }, [_c('VcButton', {
    staticClass: "gallery-actions--zoomout",
    attrs: {
      "data-qa": _vm.dataQa + "__zoomout-button",
      "icon": "",
      "prepend-default-icon": "",
      "white": "",
      "x-small": "",
      "prepend-icon": "$minus",
      "flavor": "secondary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('zoomout');
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "gallery-actions__status"
  }, [_vm._v(_vm._s(_vm.zoomSize) + "%")]), _vm._v(" "), _c('VcButton', {
    staticClass: "gallery-actions--zoomin",
    attrs: {
      "data-qa": _vm.dataQa + "__zoomin-button",
      "icon": "",
      "prepend-default-icon": "",
      "white": "",
      "x-small": "",
      "prepend-icon": "$plus",
      "flavor": "secondary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('zoomin');
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.reset ? _c('span', {
    staticClass: "gallery-actions--separator"
  }) : _vm._e(), _vm._v(" "), _vm.reset ? _c('div', {
    staticClass: "gallery-actions__reset",
    attrs: {
      "data-qa": _vm.dataQa + "__reset",
      "ghost": "",
      "flavor": "secondary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('resetStyle');
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.resetSizeText) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.rotate ? _c('span', {
    staticClass: "gallery-actions--separator"
  }) : _vm._e(), _vm._v(" "), _vm.rotate ? _c('VcButton', {
    staticClass: "gallery-actions--rotate",
    attrs: {
      "data-qa": _vm.dataQa + "__rotate-button",
      "icon": "",
      "prepend-default-icon": "",
      "white": "",
      "x-small": "",
      "prepend-icon": "$rotate",
      "flavor": "secondary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('rotate');
      }
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$8 = function (inject) {
  if (!inject) return;
  inject("data-v-195684d0_0", {
    source: ".gallery-actions[data-v-195684d0]{background-color:var(--gray-darken-4);display:flex;align-items:center;justify-content:center;width:fit-content;border-radius:var(--border-radius);padding:var(--size-value1) var(--size-value3);gap:var(--size-value2)}.gallery-actions__status[data-v-195684d0]{color:var(--gray-lighten-4);font-size:var(--font-size-x-small);font-weight:var(--font-weight-large);padding-inline:var(--size-value2);background-color:var(--gray-darken-5);cursor:default}.gallery-actions__status--section[data-v-195684d0]{width:99px}.gallery-actions__reset[data-v-195684d0]{color:var(--gray-lighten-4)!important;text-wrap:nowrap;cursor:pointer}.gallery-actions--separator[data-v-195684d0]:not(:first-child){display:inline-block;height:var(--size-value5);border-inline-start:1px solid var(--gray-lighten-4);border-radius:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$8 = "data-v-195684d0";
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);

var VcGalleryActions = __vue_component__$f;

var script$7 = {
  name: 'VcGallery',
  components: {
    VcGalleryActions,
    VcGalleyHeader,
    VcButton,
    VcPreview
  },
  model: {
    prop: 'startIndex'
  },
  props: {
    /*
     * @param [{
     *            type: ['errorWithServer', 'pdf', 'document', 'image', 'nativePdf', 'unsupported', 'tooBig']
     *            name: File name,
     *            icon: Icon string for VcIcon component,
     *            thumbnails: URL to the image
     *            location: URL to the file
     * }] files
     */
    files: {
      type: Array,
      required: true,
      validator: files => !!files.length && !files.some(file => !file.type)
    },

    /*
     * @param [{name: "", icon: ""}] action
     */
    headerActions: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: 'l',
      validator: value => ['s', 'l'].includes(value)
    },
    galleryActions: {
      type: Object,
      default: () => ({
        rotate: true,
        zoom: true,
        reset: true
      })
    },
    unsupportedFileTitle: {
      type: String,
      default: 'No preview available'
    },
    fileTooBigTitle: {
      type: String,
      default: 'File is too large to preview'
    },
    serverErrorTexts: {
      type: Object,
      validator: texts => !!texts.title && !!texts.subTitle
    },
    downloadCtaText: {
      type: String,
      default: 'Download'
    },
    startIndex: {
      type: Number,
      default: 0
    },
    pdfWidth: {
      type: Number,
      default: 700
    },
    dataQa: {
      type: String,
      default: 'VcGallery'
    }
  },
  data: () => ({
    zoomSize: 100,
    rotateDeg: 0,
    isErrorLoading: false
  }),
  computed: {
    galleryActionsAllowed() {
      const filteredActions = { ...this.galleryActions
      };
      Object.keys(filteredActions).forEach(action => {
        if (action === 'zoom' && !this.supportZoom || action === 'rotate' && !this.supportRotate || action === 'reset' && !this.supportZoom && !this.supportRotate) {
          delete filteredActions[action];
        }
      });
      return filteredActions;
    },

    currentFile() {
      return this.files[this.startIndex] || {};
    },

    supportZoom() {
      return this.galleryActions.zoom && ['image', 'pdf', 'document'].includes(this.currentFile.type);
    },

    supportRotate() {
      return this.galleryActions.rotate && ['image', 'pdf'].includes(this.currentFile.type);
    },

    showActionsBar() {
      return !['tooBig', 'unsupported'].includes(this.currentFile.type) && (this.supportZoom || this.supportRotate) && !this.isErrorLoading;
    },

    unsupportedFilesTexts() {
      const title = this.currentFile.type === 'tooBig' ? this.fileTooBigTitle : this.unsupportedFileTitle;
      return {
        title,
        ctaText: this.downloadCtaText
      };
    },

    thumbnailPosition() {
      const thumbnailWidth = this.startIndex * 100;
      const thumbnailPaddings = this.startIndex * 24;
      const halfElementWithPaddings = 74;
      return thumbnailWidth + thumbnailPaddings + halfElementWithPaddings;
    },

    showThumbnails() {
      return this.files.some(file => file.thumbnails || file.icon) && this.files.length > 1;
    }

  },
  watch: {
    startIndex() {
      this.resetControllers();
    }

  },
  methods: {
    updateStyleStatus() {
      const isRotated = this.rotateDeg / 360 !== Math.floor(this.rotateDeg / 360);
      const isZoomed = this.zoomSize !== 100;
      this.$emit('updateStyleStatus', {
        isRotated,
        isZoomed
      });
    },

    zoomout() {
      if (this.zoomSize > 10) {
        this.zoomSize = this.zoomSize - 10;
      }

      this.updateStyleStatus();
    },

    zoomin() {
      if (this.zoomSize < 190) {
        this.zoomSize = this.zoomSize + 10;
      }

      this.updateStyleStatus();
    },

    rotating() {
      this.rotateDeg = this.rotateDeg - 90;
      this.updateStyleStatus();
    },

    reset() {
      this.zoomSize = 100;
      const rotateTimes = this.rotateDeg / 360 + '';

      switch (rotateTimes.split('.')[1]) {
        case '25':
          this.rotateDeg = this.rotateDeg + 90;
          break;

        case '5':
          this.rotateDeg = this.rotateDeg - 180;
          break;

        case '75':
          this.rotateDeg = this.rotateDeg - 90;
          break;
      }

      this.updateStyleStatus();
    },

    headerAction(action) {
      this.$emit('headerAction', {
        action,
        fileIndex: this.startIndex
      });
    },

    navigateFiles(navDirection) {
      this.resetControllers();

      if (navDirection === 'back') {
        // eslint-disable-next-line vue/no-mutating-props
        this.startIndex = this.startIndex - 1;
      } else {
        // eslint-disable-next-line vue/no-mutating-props
        this.startIndex = this.startIndex + 1;
      }

      if (this.startIndex === this.files.length) {
        // eslint-disable-next-line vue/no-mutating-props
        this.startIndex = 0;
      } else if (this.startIndex === -1) {
        // eslint-disable-next-line vue/no-mutating-props
        this.startIndex = this.files.length - 1;
      }

      this.$emit('navigateFiles', navDirection);
    },

    resetControllers() {
      this.isErrorLoading = false;
      this.zoomSize = 100;
      this.rotateDeg = 0;
    },

    updateFileIndex(fileClicked) {
      this.resetControllers(); // eslint-disable-next-line vue/no-mutating-props

      this.startIndex = this.files.findIndex(file => file.name === fileClicked.name);
      this.$emit('thumbnailsClicked', fileClicked);
    },

    errorLoadingPreview() {
      this.isErrorLoading = true;
      this.$emit('errorLoadingPreview', this.startIndex);
    },

    errorLoadingThumbnails(file) {
      this.$emit('errorLoadingThumbnails', file);
    }

  }
};

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['gallery', {
      'thumbnails-on': _vm.showThumbnails
    }],
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm._t("header", function () {
    return [_c('VcGalleyHeader', {
      attrs: {
        "file-name": _vm.currentFile.name,
        "size": _vm.size,
        "actions": _vm.headerActions
      },
      on: {
        "action": _vm.headerAction,
        "back": function ($event) {
          return _vm.$emit('back');
        }
      }
    })];
  }), _vm._v(" "), _vm._t("navigation", function () {
    return [_vm.files.length > 1 ? _c('div', {
      staticClass: "gallery__navigation"
    }, [_c('VcButton', {
      staticClass: "gallery__navigation--back",
      attrs: {
        "data-qa": _vm.dataQa + "__navigate-back-button",
        "icon": "",
        "prepend-default-icon": "",
        "pill": "",
        "prepend-icon": "$chevron_left",
        "flavor": "secondary"
      },
      on: {
        "click": function ($event) {
          return _vm.navigateFiles('back');
        }
      }
    }), _vm._v(" "), _c('VcButton', {
      staticClass: "gallery__navigation--forward",
      attrs: {
        "data-qa": _vm.dataQa + "__navigate-forward-button",
        "icon": "",
        "prepend-default-icon": "",
        "pill": "",
        "prepend-icon": "$chevron_right",
        "flavor": "secondary"
      },
      on: {
        "click": function ($event) {
          return _vm.navigateFiles('forward');
        }
      }
    })], 1) : _vm._e()];
  }), _vm._v(" "), _vm.showActionsBar ? _c('div', {
    staticClass: "gallery__controls"
  }, [_c('VcGalleryActions', _vm._b({
    attrs: {
      "zoom-size": _vm.zoomSize
    },
    on: {
      "resetStyle": _vm.reset,
      "zoomout": _vm.zoomout,
      "zoomin": _vm.zoomin,
      "rotate": _vm.rotating
    }
  }, 'VcGalleryActions', _vm.galleryActionsAllowed, false))], 1) : _vm._e(), _vm._v(" "), _vm._t("fileViewer", function () {
    return [_c('div', {
      staticClass: "gallery__viewer"
    }, [_c('VcPreview', {
      attrs: {
        "file-location": _vm.currentFile.location,
        "file-type": _vm.currentFile.type,
        "narrow": _vm.size === 's',
        "unsupported-files-texts": _vm.unsupportedFilesTexts,
        "error-with-server-texts": _vm.serverErrorTexts,
        "rotate": _vm.rotateDeg,
        "zoom": _vm.zoomSize / 100,
        "pdf-width": _vm.pdfWidth
      },
      on: {
        "download": function ($event) {
          return _vm.$emit('download');
        },
        "errorLoading": _vm.errorLoadingPreview
      }
    })], 1)];
  }), _vm._v(" "), _vm._t("thumbnails", function () {
    return [_vm.showThumbnails ? _c('div', {
      staticClass: "gallery__thumbnails"
    }, [_c('div', {
      staticClass: "gallery__thumbnails--scroll",
      style: "transform: translateX(-" + _vm.thumbnailPosition + "px);"
    }, _vm._l(_vm.files, function (file) {
      return _c('div', {
        key: file.location,
        staticClass: "gallery__thumbnails--item",
        attrs: {
          "data-qa": _vm.dataQa + "__thumbnail--" + file.name
        },
        on: {
          "click": function ($event) {
            return _vm.updateFileIndex(file);
          }
        }
      }, [_c('VcPreview', {
        attrs: {
          "disable-loader": "",
          "focus-mode": "",
          "file-type": file.thumbnails ? 'image' : 'icon',
          "in-focus": _vm.currentFile.name === file.name,
          "icon": file.icon,
          "file-location": file.thumbnails || file.icon
        },
        on: {
          "errorLoading": function ($event) {
            return _vm.errorLoadingThumbnails(file);
          }
        }
      })], 1);
    }), 0)]) : _vm._e()];
  })], 2);
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$7 = function (inject) {
  if (!inject) return;
  inject("data-v-2b038f6d_0", {
    source: ".gallery[data-v-2b038f6d]{height:100%;width:100%;display:flex;flex-direction:column;background-color:rgba(0,0,0,.8);position:relative;overflow:hidden}.gallery[data-v-2b038f6d]  ::-webkit-scrollbar{width:var(--size-value1);height:var(--size-value1);background-color:transparent}.gallery[data-v-2b038f6d]  ::-webkit-scrollbar-thumb{background:var(--gray-darken-3)}.gallery__navigation[data-v-2b038f6d]{width:100%;position:fixed;z-index:1;left:0;height:0;top:50%;transform:translateY(-50%);display:flex;justify-content:space-between;padding-inline:var(--size-value7)}.gallery__navigation[data-v-2b038f6d]  .v-btn{background-color:#fff}.gallery__viewer[data-v-2b038f6d]{position:relative;overflow:auto;flex:1}.gallery__controls[data-v-2b038f6d]{position:absolute;z-index:1;transform:translateX(-50%);left:50%;bottom:var(--size-value4)}.thumbnails-on .gallery__controls[data-v-2b038f6d]{bottom:128px}.gallery__thumbnails[data-v-2b038f6d]{display:flex;position:relative;height:116px;background-color:var(--gray-darken-5)}.gallery__thumbnails--scroll[data-v-2b038f6d]{display:flex;flex-wrap:nowrap;transition:.25s ease-in-out;position:absolute;left:50%;padding-block:var(--size-value2)}.gallery__thumbnails--item[data-v-2b038f6d]{flex-basis:100px;width:100px;height:100px;margin-inline:var(--size-value3);border-radius:var(--size-value1);overflow:hidden;cursor:pointer}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$7 = "data-v-2b038f6d";
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);

var __vue_component__$e = __vue_component__$d;

var script$6 = {
  name: 'VcCounter',
  components: {
    VcLayout,
    VcButton,
    VcIcon,
    VcTextField
  },
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    type: {
      type: String,
      default: 'number',
      validator: value => value === 'number'
    },
    step: {
      type: Number,
      default: 1,
      validator: value => value !== 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcCounter'
    }
  },

  data() {
    return {
      counterValue: this.value
    };
  },

  watch: {
    value(newValue) {
      this.counterValue = newValue;
    }

  },
  methods: {
    updateValue(positive = true) {
      const stepSize = this.step * (positive ? 1 : -1);
      this.counterValue = (parseFloat(this.counterValue) || 0) + stepSize;
      this.$emit('input', this.counterValue.toString());
    },

    inputChanged(inputValue) {
      this.counterValue = inputValue;
      this.$emit('input', inputValue);
    }

  }
};

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcTextField', _vm._b({
    attrs: {
      "value": _vm.counterValue,
      "disabled": _vm.disabled,
      "type": _vm.type,
      "data-qa": _vm.dataQa
    },
    on: {
      "input": _vm.inputChanged,
      "click": function ($event) {
        return _vm.$emit('click');
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [!_vm.disabled ? _c('VcLayout', {
          staticClass: "number-counter",
          attrs: {
            "column": ""
          }
        }, [_c('VcButton', {
          staticClass: "number-counter__button",
          attrs: {
            "icon": "",
            "data-qa": _vm.dataQa + "-counter-up"
          },
          on: {
            "click": _vm.updateValue
          }
        }, [_c('VcIcon', {
          staticClass: "number-counter__button__caret-up",
          attrs: {
            "color": "var(--gray-darken-1)",
            "size": "10"
          }
        }, [_vm._v("\n          $caret_down\n        ")])], 1), _vm._v(" "), _c('VcButton', {
          staticClass: "number-counter__button",
          attrs: {
            "icon": "",
            "data-qa": _vm.dataQa + "-counter-down"
          },
          on: {
            "click": function ($event) {
              return _vm.updateValue(false);
            }
          }
        }, [_c('VcIcon', {
          staticClass: "number-counter__button__caret-down",
          attrs: {
            "color": "var(--gray-darken-1)",
            "size": "10"
          }
        }, [_vm._v("\n          $caret_down\n        ")])], 1)], 1) : _vm._e()];
      },
      proxy: true
    }])
  }, 'VcTextField', _vm.$attrs, false));
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-1c0b82b4_0", {
    source: ".VcTextInput.v-text-field[data-v-1c0b82b4] input::-webkit-inner-spin-button,.VcTextInput.v-text-field[data-v-1c0b82b4] input::-webkit-outer-spin-button{-webkit-appearance:none}.VcTextInput.v-text-field[data-v-1c0b82b4] input[type=number]{-moz-appearance:textfield}.VcTextInput.v-text-field[data-v-1c0b82b4] .v-input__control .v-input__slot{padding-inline:var(--size-value3) 0}.number-counter[data-v-1c0b82b4]{border-inline-start:1px solid var(--gray-lighten-1)}.number-counter__button[data-v-1c0b82b4]{width:var(--size-value8);max-height:calc((var(--size-value13)/ 2) - 1px);border-radius:0}.number-counter__button__caret-up[data-v-1c0b82b4]{transform:rotate(180deg);translate:-1px 4px}.number-counter__button__caret-down[data-v-1c0b82b4]{translate:0 -4px}.error--text .v-input__slot[data-v-1c0b82b4]{border-color:var(--red);color:unset;box-shadow:unset;line-height:var(--size-value4)}.error--text .v-input__slot .number-counter[data-v-1c0b82b4]{border-inline-start:1px solid var(--red)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$6 = "data-v-1c0b82b4";
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

var __vue_component__$c = __vue_component__$b;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$5 = {
  name: 'VcScrollShadow',
  props: {
    hideTopShadow: {
      type: Boolean,
      default: false
    },
    hideRightShadow: {
      type: Boolean,
      default: false
    },
    hideBottomShadow: {
      type: Boolean,
      default: false
    },
    hideLeftShadow: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcScrollShadow'
    }
  },

  data() {
    return {
      shadow: {
        top: false,
        right: false,
        bottom: false,
        left: false
      }
    };
  },

  mounted() {
    // Check if shadows are necessary after the element is resized.
    this.scrollContainerObserver = new ResizeObserver(this.toggleShadow);
    this.scrollContainerObserver.observe(this.$refs.scrollContainer);
  },

  destroyed() {
    this.scrollContainerObserver.disconnect();
  },

  methods: {
    // Check if shadows are needed.
    toggleShadow() {
      const hasHorizontalScrollbar = this.$refs.scrollContainer.clientWidth < this.$refs.scrollContainer.scrollWidth;
      const hasVerticalScrollbar = this.$refs.scrollContainer.clientHeight < this.$refs.scrollContainer.scrollHeight;
      const scrolledToTop = this.$refs.scrollContainer.scrollTop === 0;
      const scrolledToBottom = this.getScrolledToEnd('vertical');
      const scrolledToLeft = this.$refs.scrollContainer.scrollLeft === 0;
      const scrolledToRight = this.getScrolledToEnd('horizontal');
      this.shadow.top = hasVerticalScrollbar && !scrolledToTop;
      this.shadow.right = hasHorizontalScrollbar && !scrolledToRight;
      this.shadow.bottom = hasVerticalScrollbar && !scrolledToBottom;
      this.shadow.left = hasHorizontalScrollbar && !scrolledToLeft;
    },

    getScrolledToEnd(direction) {
      const container = this.$refs.scrollContainer;
      const offset = direction === 'horizontal' ? container.offsetWidth : container.offsetHeight;
      const scroll = direction === 'horizontal' ? container.scrollLeft : container.scrollTop;
      const size = direction === 'horizontal' ? container.scrollWidth : container.scrollHeight;
      return Math.abs(offset + Math.abs(scroll) - size) < 1;
    }

  }
};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    ref: "scrollContainer",
    staticClass: "scroll-container",
    attrs: {
      "data-qa": _vm.dataQa
    },
    on: {
      "&scroll": function ($event) {
        return _vm.toggleShadow.apply(null, arguments);
      }
    }
  }, [_vm._t("default"), _vm._v(" "), !_vm.hideTopShadow ? _c('span', {
    class: ['shadow-top', {
      'is-active': _vm.shadow.top
    }],
    attrs: {
      "data-qa": _vm.dataQa + "_topShadow"
    }
  }) : _vm._e(), _vm._v(" "), !_vm.hideRightShadow ? _c('span', {
    class: ['shadow-right', {
      'is-active': _vm.shadow.right
    }],
    attrs: {
      "data-qa": _vm.dataQa + "_rightShadow"
    }
  }) : _vm._e(), _vm._v(" "), !_vm.hideBottomShadow ? _c('span', {
    class: ['shadow-bottom', {
      'is-active': _vm.shadow.bottom
    }],
    attrs: {
      "data-qa": _vm.dataQa + "_bottomShadow"
    }
  }) : _vm._e(), _vm._v(" "), !_vm.hideLeftShadow ? _c('span', {
    class: ['shadow-left', {
      'is-active': _vm.shadow.left
    }],
    attrs: {
      "data-qa": _vm.dataQa + "_leftShadow"
    }
  }) : _vm._e()], 2)]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-16d1cc3e_0", {
    source: ".wrap[data-v-16d1cc3e]{overflow:hidden;position:relative}.scroll-container[data-v-16d1cc3e]{overflow:auto;max-width:100%;max-height:100%}.shadow-bottom[data-v-16d1cc3e],.shadow-left[data-v-16d1cc3e],.shadow-right[data-v-16d1cc3e],.shadow-top[data-v-16d1cc3e]{position:absolute;border-radius:var(--border-radius);opacity:0;transition:opacity .2s;pointer-events:none}.shadow-bottom[data-v-16d1cc3e],.shadow-top[data-v-16d1cc3e]{right:0;left:0;height:var(--scroll-shadow-size);border-top-right-radius:0;border-top-left-radius:0;background-image:linear-gradient(var(--scroll-shadow-color) 0,transparent 100%)}.shadow-top[data-v-16d1cc3e]{top:var(--scroll-shadow-offset)}.shadow-bottom[data-v-16d1cc3e]{bottom:var(--scroll-shadow-offset);transform:rotate(180deg)}.shadow-left[data-v-16d1cc3e],.shadow-right[data-v-16d1cc3e]{top:0;bottom:0;width:var(--scroll-shadow-size);border-top-left-radius:0;border-bottom-left-radius:0;background-image:linear-gradient(90deg,var(--scroll-shadow-color) 0,transparent 100%)}.shadow-right[data-v-16d1cc3e]{inset-inline-end:var(--scroll-shadow-offset);transform:rotate(180deg)}#app[dir=rtl] .shadow-right[data-v-16d1cc3e]{transform:initial}.shadow-left[data-v-16d1cc3e]{inset-inline-start:var(--scroll-shadow-offset);transform:initial}#app[dir=rtl] .shadow-left[data-v-16d1cc3e]{transform:rotate(180deg)}.is-active[data-v-16d1cc3e]{opacity:1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$5 = "data-v-16d1cc3e";
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

var __vue_component__$a = __vue_component__$9;

const FLAG_FOLDER = './flags/4x3/';
var script$4 = {
  name: 'VcFlag',
  components: {
    VcImage
  },
  props: {
    countryInitials: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 21
    },
    width: {
      type: Number,
      default: 28
    },
    rounded: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-flag'
    }
  },

  data() {
    return {
      icon: ''
    };
  },

  computed: {
    style() {
      return {
        'max-height': `${this.height}px`,
        'max-width': `${this.width}px`
      };
    }

  },
  watch: {
    countryInitials: {
      async handler(initials) {
        this.icon = await this.getCountryFlag(initials);
      },

      immediate: true
    }
  },
  methods: {
    async getCountryFlag(initials)
    /* istanbul ignore next */
    {
      let svg;

      try {
        svg = await import(`${FLAG_FOLDER}${initials.toLowerCase()}.svg`);
      } catch {
        svg = await import(`${FLAG_FOLDER}us.svg`);
      }

      return svg.default;
    }

  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcImage', {
    staticClass: "vc-flag",
    class: {
      'rounded-flag': _vm.rounded
    },
    style: _vm.style,
    attrs: {
      "data-qa": _vm.dataQa,
      "image": _vm.icon
    }
  });
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-3478b15d_0", {
    source: ".vc-flag[data-v-3478b15d]{border:solid 1px var(--gray-lighten-3)}.rounded-flag[data-v-3478b15d]{overflow:hidden;border-radius:var(--size-value1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = "data-v-3478b15d";
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

var VcFlag = __vue_component__$8;

const allCountries = [['Afghanistan', 'af', '93'], ['Albania', 'al', '355'], ['Algeria', 'dz', '213'], ['American Samoa', 'as', '1684'], ['Andorra', 'ad', '376'], ['Angola', 'ao', '244'], ['Anguilla', 'ai', '1264'], ['Antigua and Barbuda', 'ag', '1268'], ['Argentina', 'ar', '54'], ['Armenia', 'am', '374'], ['Aruba', 'aw', '297'], ['Australia', 'au', '61'], ['Austria', 'at', '43'], ['Azerbaijan', 'az', '994'], ['Bahamas', 'bs', '1242'], ['Bahrain', 'bh', '973'], ['Bangladesh', 'bd', '880'], ['Barbados', 'bb', '1246'], ['Belarus', 'by', '375'], ['Belgium', 'be', '32'], ['Belize', 'bz', '501'], ['Benin', 'bj', '229'], ['Bermuda', 'bm', '1441'], ['Bhutan', 'bt', '975'], ['Bolivia', 'bo', '591'], ['Bosnia and Herzegovina', 'ba', '387'], ['Botswana', 'bw', '267'], ['Brazil', 'br', '55'], ['British Indian Ocean Territory', 'io', '246'], ['British Virgin Islands', 'vg', '1284'], ['Brunei', 'bn', '673'], ['Bulgaria', 'bg', '359'], ['Burkina Faso', 'bf', '226'], ['Burundi', 'bi', '257'], ['Cambodia', 'kh', '855'], ['Cameroon', 'cm', '237'], ['Canada', 'ca', '1'], ['Cape Verde', 'cv', '238'], ['Caribbean Netherlands', 'bq', '599'], ['Cayman Islands', 'ky', '1345'], ['Central African Republic', 'cf', '236'], ['Chad', 'td', '235'], ['Chile', 'cl', '56'], ['China', 'cn', '86'], ['Christmas Island', 'cx', '61'], ['Cocos (Keeling) Islands', 'cc', '61'], ['Colombia', 'co', '57'], ['Comoros', 'km', '269'], ['Congo (DRC)', 'cd', '243'], ['Congo (Republic)', 'cg', '242'], ['Cook Islands', 'ck', '682'], ['Costa Rica', 'cr', '506'], ['Côte d’Ivoire', 'ci', '225'], ['Croatia', 'hr', '385'], ['Cuba', 'cu', '53'], ['Curaçao', 'cw', '599'], ['Cyprus', 'cy', '357'], ['Czech Republic', 'cz', '420'], ['Denmark', 'dk', '45'], ['Djibouti', 'dj', '253'], ['Dominica', 'dm', '1767'], ['Dominican Republic', 'do', '1'], ['Ecuador', 'ec', '593'], ['Egypt', 'eg', '20'], ['El Salvador', 'sv', '503'], ['Equatorial Guinea', 'gq', '240'], ['Eritrea', 'er', '291'], ['Estonia', 'ee', '372'], ['Ethiopia', 'et', '251'], ['Falkland Islands', 'fk', '500'], ['Faroe Islands', 'fo', '298'], ['Fiji', 'fj', '679'], ['Finland', 'fi', '358'], ['France', 'fr', '33'], ['French Guiana', 'gf', '594'], ['French Polynesia', 'pf', '689'], ['Gabon', 'ga', '241'], ['Gambia', 'gm', '220'], ['Georgia', 'ge', '995'], ['Germany', 'de', '49'], ['Ghana', 'gh', '233'], ['Gibraltar', 'gi', '350'], ['Greece', 'gr', '30'], ['Greenland', 'gl', '299'], ['Grenada', 'gd', '1473'], ['Guadeloupe', 'gp', '590'], ['Guam', 'gu', '1671'], ['Guatemala', 'gt', '502'], ['Guernsey', 'gg', '44'], ['Guinea', 'gn', '224'], ['Guinea-Bissau', 'gw', '245'], ['Guyana', 'gy', '592'], ['Haiti', 'ht', '509'], ['Honduras', 'hn', '504'], ['Hong Kong', 'hk', '852'], ['Hungary', 'hu', '36'], ['Iceland', 'is', '354'], ['India', 'in', '91'], ['Indonesia', 'id', '62'], ['Iran', 'ir', '98'], ['Iraq', 'iq', '964'], ['Ireland', 'ie', '353'], ['Isle of Man', 'im', '44'], ['Israel', 'il', '972'], ['Italy', 'it', '39'], ['Jamaica', 'jm', '1876'], ['Japan', 'jp', '81'], ['Jersey', 'je', '44'], ['Jordan', 'jo', '962'], ['Kazakhstan', 'kz', '7'], ['Kenya', 'ke', '254'], ['Kiribati', 'ki', '686'], ['Kosovo', 'xk', '383'], ['Kuwait', 'kw', '965'], ['Kyrgyzstan', 'kg', '996'], ['Laos', 'la', '856'], ['Latvia', 'lv', '371'], ['Lebanon', 'lb', '961'], ['Lesotho', 'ls', '266'], ['Liberia', 'lr', '231'], ['Libya', 'ly', '218'], ['Liechtenstein', 'li', '423'], ['Lithuania', 'lt', '370'], ['Luxembourg', 'lu', '352'], ['Macau (澳門)', 'mo', '853'], ['Macedonia', 'mk', '389'], ['Madagascar', 'mg', '261'], ['Malawi', 'mw', '265'], ['Malaysia', 'my', '60'], ['Maldives', 'mv', '960'], ['Mali', 'ml', '223'], ['Malta', 'mt', '356'], ['Marshall Islands', 'mh', '692'], ['Martinique', 'mq', '596'], ['Mauritania', 'mr', '222'], ['Mauritius', 'mu', '230'], ['Mayotte', 'yt', '262'], ['Mexico', 'mx', '52'], ['Micronesia', 'fm', '691'], ['Moldova', 'md', '373'], ['Monaco', 'mc', '377'], ['Mongolia', 'mn', '976'], ['Montenegro', 'me', '382'], ['Montserrat', 'ms', '1664'], ['Morocco', 'ma', '212'], ['Mozambique', 'mz', '258'], ['Myanmar', 'mm', '95'], ['Namibia', 'na', '264'], ['Nauru', 'nr', '674'], ['Nepal', 'np', '977'], ['Netherlands', 'nl', '31'], ['New Caledonia', 'nc', '687'], ['New Zealand', 'nz', '64'], ['Nicaragua', 'ni', '505'], ['Niger', 'ne', '227'], ['Nigeria', 'ng', '234'], ['Niue', 'nu', '683'], ['Norfolk Island', 'nf', '672'], ['North Korea', 'kp', '850'], ['Northern Mariana Islands', 'mp', '1670'], ['Norway', 'no', '47'], ['Oman', 'om', '968'], ['Pakistan', 'pk', '92'], ['Palau', 'pw', '680'], ['Panama', 'pa', '507'], ['Papua New Guinea', 'pg', '675'], ['Paraguay', 'py', '595'], ['Peru', 'pe', '51'], ['Philippines', 'ph', '63'], ['Poland', 'pl', '48'], ['Portugal', 'pt', '351'], ['Puerto Rico', 'pr', '1'], ['Qatar', 'qa', '974'], ['Réunion', 're', '262'], ['Romania', 'ro', '40'], ['Russia', 'ru', '7'], ['Rwanda', 'rw', '250'], ['Saint Barthélemy', 'bl', '590'], ['Saint Helena', 'sh', '290'], ['Saint Kitts and Nevis', 'kn', '1869'], ['Saint Lucia', 'lc', '1758'], ['Saint Martin', 'mf', '590'], ['Saint Pierre and Miquelon', 'pm', '508'], ['Saint Vincent and the Grenadines', 'vc', '1784'], ['Samoa', 'ws', '685'], ['San Marino', 'sm', '378'], ['São Tomé and Príncipe', 'st', '239'], ['Saudi Arabia', 'sa', '966'], ['Senegal', 'sn', '221'], ['Serbia', 'rs', '381'], ['Seychelles', 'sc', '248'], ['Sierra Leone', 'sl', '232'], ['Singapore', 'sg', '65'], ['Sint Maarten', 'sx', '1721'], ['Slovakia', 'sk', '421'], ['Slovenia', 'si', '386'], ['Solomon Islands', 'sb', '677'], ['Somalia', 'so', '252'], ['South Africa', 'za', '27'], ['South Korea', 'kr', '82'], ['South Sudan', 'ss', '211'], ['Spain', 'es', '34'], ['Sri Lanka', 'lk', '94'], ['Sudan', 'sd', '249'], ['Suriname', 'sr', '597'], ['Svalbard and Jan Mayen', 'sj', '47'], ['Swaziland', 'sz', '268'], ['Sweden', 'se', '46'], ['Switzerland', 'ch', '41'], ['Syria', 'sy', '963'], ['Taiwan', 'tw', '886'], ['Tajikistan', 'tj', '992'], ['Tanzania', 'tz', '255'], ['Thailand', 'th', '66'], ['Timor-Leste', 'tl', '670'], ['Togo', 'tg', '228'], ['Tokelau', 'tk', '690'], ['Tonga', 'to', '676'], ['Trinidad and Tobago', 'tt', '1868'], ['Tunisia', 'tn', '216'], ['Turkey', 'tr', '90'], ['Turkmenistan', 'tm', '993'], ['Turks and Caicos Islands', 'tc', '1649'], ['Tuvalu', 'tv', '688'], ['U.S. Virgin Islands', 'vi', '1340'], ['Uganda', 'ug', '256'], ['Ukraine', 'ua', '380'], ['United Arab Emirates', 'ae', '971'], ['United Kingdom', 'gb', '44'], ['United States', 'us', '1'], ['Uruguay', 'uy', '598'], ['Uzbekistan', 'uz', '998'], ['Vanuatu', 'vu', '678'], ['Vatican City', 'va', '39'], ['Venezuela', 've', '58'], ['Vietnam', 'vn', '84'], ['Wallis and Futuna', 'wf', '681'], ['Western Sahara', 'eh', '212'], ['Yemen', 'ye', '967'], ['Zambia', 'zm', '260'], ['Zimbabwe', 'zw', '263'], ['Aland Islands', 'ax', '358']]; // iso2 refers to the countries 2-letter code iso2 code as described here: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
const countries = allCountries.map(country => ({
  name: country[0],
  iso2: country[1].toUpperCase(),
  dialCode: country[2],
  identifier: country[1].toUpperCase()
})).sort((a, b) => a.name.localeCompare(b.name));

var countries$1 = countries;

const ALLOWED_KEY_CODES = [8, 9, 13, 27, 37, 39, 46]; // backspace, tab, enter, escape, left arrow, right arrow, delete

var script$3 = {
  name: 'VcPhoneField',
  components: {
    VcList,
    VcDropdown,
    VcIcon,
    VcFlag,
    VcTextField,
    VcLayout
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-phone-field'
    },
    initialCountryCode: {
      type: String,
      default: 'us'
    },
    includeCountryCode: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    label: {
      type: String
    },
    initialPhoneNumber: {
      type: String,
      default: ''
    },
    resultType: {
      type: String,
      default: 'fullNumber',
      validator: value => ['fullNumber', 'structured'].includes(value)
    }
  },

  data() {
    return {
      countries: countries$1,
      selectedCountry: countries$1[0],
      showError: false,
      phoneNumber: '',
      showPicker: false
    };
  },

  computed: {
    selectedCountryDialCode() {
      return this.selectedCountry.dialCode;
    },

    selectedCountryDialCodeText() {
      return this.countryDialCodeText(this.selectedCountry);
    },

    fullNumber() {
      return this.includeCountryCode ? this.selectedCountryDialCode + this.phoneNumber : this.phoneNumber;
    },

    emissionData() {
      if (this.resultType === 'structured') {
        var _this$selectedCountry, _this$selectedCountry2;

        return {
          countryName: (_this$selectedCountry = this.selectedCountry) === null || _this$selectedCountry === void 0 ? void 0 : _this$selectedCountry.name,
          countryCode: (_this$selectedCountry2 = this.selectedCountry) === null || _this$selectedCountry2 === void 0 ? void 0 : _this$selectedCountry2.iso2,
          dialCode: this.selectedCountryDialCode,
          phoneNumber: this.phoneNumber,
          fullNumber: this.fullNumber
        };
      }

      return this.fullNumber;
    }

  },
  watch: {
    initialPhoneNumber: {
      handler() {
        this.init();
      }

    },
    initialCountryCode: {
      handler() {
        this.init();
      }

    }
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      if (this.includeCountryCode) {
        this.selectedCountry = this.countries.find(country => {
          var _this$initialCountryC;

          return country.iso2 === ((_this$initialCountryC = this.initialCountryCode) === null || _this$initialCountryC === void 0 ? void 0 : _this$initialCountryC.toUpperCase());
        }) || this.countries.find(country => country.iso2 === 'US');
      }

      this.phoneNumber = this.initialPhoneNumber;
    },

    countryDialCodeText(country) {
      return this.includeCountryCode ? `${this.$dst('ds.phone_field.country_code', {
        country_code: country.dialCode
      })}` : '';
    },

    selectionChanged(val) {
      this.selectedCountry = countries$1.find(c => c.identifier === val);
      this.$emit('number-changed', this.emissionData);
      this.$emit('country-changed', this.emissionData);
      this.toggleShowPicker();
    },

    toggleShowPicker() {
      this.showPicker = !this.showPicker;
    },

    onKeyDown(event) {
      const {
        keyCode
      } = event;
      const isDigit = keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105;
      const isAllowedKey = ALLOWED_KEY_CODES.includes(keyCode);

      if (isDigit || isAllowedKey) {
        this.$emit('keydown', event);
      } else {
        event.preventDefault();
      }
    },

    validatePhoneField() {
      this.showError = !!this.getError();
      this.$emit('validate-phone-field', this.showError);
    },

    resetFieldValidation() {
      this.showError = false;
    },

    getError() {
      let errorMessages = this.rules.map(rule => {
        const resolve = rule.call(this, this.phoneNumber);
        if (typeof resolve === 'string') return resolve;
      }).filter(item => !!item);
      return errorMessages[0];
    }

  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "vc-phone-field",
    class: {
      'required-error': _vm.showError,
      disabled: _vm.disabled
    },
    attrs: {
      "column": "",
      "data-qa": _vm.dataQa
    },
    on: {
      "focusout": _vm.validatePhoneField,
      "focusin": _vm.resetFieldValidation
    }
  }, [_c('VcLayout', [_c('VcDropdown', {
    staticClass: "vc-phone-field__number-prefix",
    attrs: {
      "value": _vm.showPicker,
      "data-qa": _vm.dataQa + "_number-prefix"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function () {
        return [_c('VcLayout', {
          staticClass: "vc-phone-field__number-prefix_flag",
          attrs: {
            "data-qa": _vm.dataQa + "_number-prefix",
            "align-center": "",
            "justify-space-around": "",
            "data-country-name": _vm.selectedCountry.name
          },
          on: {
            "click": _vm.toggleShowPicker
          }
        }, [_c('VcFlag', {
          attrs: {
            "country-initials": _vm.selectedCountry.iso2.toLowerCase(),
            "rounded": ""
          }
        }), _vm._v(" "), _c('VcIcon', {
          staticClass: "dropdown-arrow",
          class: {
            'menu-active': _vm.showPicker
          },
          attrs: {
            "size": "9",
            "color": "var(--gray-darken-2)"
          }
        }, [_vm._v("\n            $caret_down\n          ")])], 1)];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        return [_c('VcList', {
          attrs: {
            "items": _vm.countries
          },
          on: {
            "select": _vm.selectionChanged
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (country) {
              return [_c('VcLayout', {
                attrs: {
                  "justify-space-between": ""
                }
              }, [_c('VcLayout', [_c('VcFlag', {
                staticClass: "vc-phone-field__number-prefix__list-item_flag",
                attrs: {
                  "country-initials": country.iso2.toLowerCase(),
                  "rounded": ""
                }
              }), _vm._v(" "), _c('span', [_vm._v(_vm._s(country.name))])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.countryDialCodeText(country)))])], 1)];
            }
          }])
        })];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('VcTextField', {
    staticClass: "vc-phone-field__number-text",
    class: {
      'required-error': _vm.showError
    },
    attrs: {
      "data-qa": _vm.dataQa + "_number-text",
      "label": _vm.label,
      "type": "text",
      "prefix": _vm.selectedCountryDialCodeText
    },
    on: {
      "keydown": _vm.onKeyDown,
      "onKeydownEnter": function ($event) {
        return _vm.$emit('onKeydownEnter', _vm.emissionData);
      },
      "input": function ($event) {
        return _vm.$emit('number-changed', _vm.emissionData);
      },
      "blur": function ($event) {
        return _vm.$emit('blur', _vm.emissionData);
      }
    },
    model: {
      value: _vm.phoneNumber,
      callback: function ($$v) {
        _vm.phoneNumber = $$v;
      },
      expression: "phoneNumber"
    }
  })], 1), _vm._v(" "), _vm.showError ? _c('VcLayout', {
    staticClass: "v-messages error--text v-messages__wrapper",
    attrs: {
      "data-qa": _vm.dataQa + "_error-message"
    }
  }, [_c('span', {
    staticClass: "v-messages__message"
  }, [_vm._v(_vm._s(_vm.getError()))])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-69cef131_0", {
    source: ".vc-phone-field-select-menu[data-v-69cef131]{min-width:100%}.vc-phone-field[data-v-69cef131]{max-height:54px}.vc-phone-field .menu-active[data-v-69cef131]{transform:rotate(180deg)}.vc-phone-field.disabled[data-v-69cef131]{pointer-events:none;opacity:62%}.vc-phone-field__number-prefix[data-v-69cef131]{flex:1;margin:var(--size-value2);padding:0}.vc-phone-field__number-prefix__list-item[data-v-69cef131]{min-width:100%}.vc-phone-field__number-prefix__list-item_country-name[data-v-69cef131]{margin-inline-start:var(--size-value2)}.vc-phone-field__number-prefix__list-item_flag[data-v-69cef131]{margin-inline-end:var(--size-value2)}.vc-phone-field__number-text[data-v-69cef131]{max-height:52px;flex:10;margin-block-start:0}.vc-phone-field[data-v-69cef131]{border:var(--border-frame);border-radius:var(--border-radius)}.vc-phone-field[data-v-69cef131]:hover{border-color:var(--gray-darken-2)}.vc-phone-field[data-v-69cef131]:active,.vc-phone-field[data-v-69cef131]:focus,.vc-phone-field[data-v-69cef131]:focus-within{border-color:var(--v-secondary-base);box-shadow:var(--shadow-focused-frame)}.vc-phone-field[data-v-69cef131].required-error{border-color:var(--red);box-shadow:unset}.vc-phone-field[data-v-69cef131] .vc-phone-field__number-text{border-inline-start:var(--border-frame)}.vc-phone-field[data-v-69cef131] .vc-phone-field__number-text.required-error{border-color:var(--red)}.vc-phone-field[data-v-69cef131] .vc-phone-field__number-text .v-input__slot{border:unset}.vc-phone-field[data-v-69cef131] .vc-phone-field__number-text .v-input__slot:active,.vc-phone-field[data-v-69cef131] .vc-phone-field__number-text .v-input__slot:focus,.vc-phone-field[data-v-69cef131] .vc-phone-field__number-text .v-input__slot:focus-within{border:unset;box-shadow:unset}.vc-phone-field[data-v-69cef131] .v-input__slot{margin-block-end:0}.vc-phone-field[data-v-69cef131] .v-input__slot::before{border:unset}.vc-phone-field[data-v-69cef131] .v-input__slot::after{border:unset}.vc-phone-field .v-messages__wrapper[data-v-69cef131]{margin-block-start:var(--size-value1);margin-inline-start:var(--size-value1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$3 = "data-v-69cef131";
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

var __vue_component__$7 = __vue_component__$6;

var script$2 = {
  name: 'VcInputGroup',
  components: {
    VcLayout
  },
  props: {
    /**
     * Errors object for start and end fields.
     * The object should have two arrays: start and end
     */
    rules: {
      type: Object,
      default: () => ({
        start: [],
        end: []
      }),
      validator: prop => Array.isArray(prop.start) && Array.isArray(prop.end)
    },

    /**
     * Error messages object for start and end fields.
     * The object should have two arrays: start and end
     */
    errorMessages: {
      type: String,
      default: ''
    },

    /**
     * How to split the input group
     */
    split: {
      type: String,
      default: 'even',
      validator: prop => ['even', 'start', 'end'].includes(prop)
    },

    /**
     * If true, the input group will be treated as one item in relation to validation
     */
    unify: {
      type: Boolean,
      default: false
    },
    directionOverride: {
      type: String,
      validator: prop => ['rtl', 'ltr'].includes(prop)
    },
    dataQa: {
      type: String,
      default: 'VcInputGroup'
    }
  },
  data: () => ({
    resizeObserver: null,
    width: 0,
    currentError: ''
  }),
  computed: {
    classes() {
      return {
        [`split-${this.split}`]: true,
        unify: this.unify
      };
    }

  },

  mounted() {
    this.resizeObserver = new ResizeObserver(this.measureSize);
    this.resizeObserver.observe(this.$refs.root.$el);
  },

  destroyed() {
    this.resizeObserver.disconnect();
  },

  methods: {
    measureSize(value) {
      this.width = value[0].contentRect.width;
    },

    onValidation(item) {
      return (data => {
        this.$emit('onValidation', {
          item,
          rules: this.rules[item],
          data
        });
        const rule = this.rules[item][0];

        if (typeof rule === 'function') {
          this.currentError = rule(data);
        }

        if (typeof rule === 'string') {
          this.currentError = rule;
        }
      }).bind(this);
    }

  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    attrs: {
      "column": "",
      "dir": _vm.directionOverride || (_vm.$vuetify.rtl ? 'rtl' : 'ltr'),
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    ref: "root",
    staticClass: "VcInputGroup",
    class: _vm.classes,
    attrs: {
      "align-top": "",
      "align-stretch": "",
      "direction": "",
      "tabindex": "0",
      "data-qa": _vm.dataQa + "-inputs"
    }
  }, [_vm._t("start", null, {
    "rules": _vm.rules.start.length > 0 ? [function () {
      return false;
    }] : [],
    "props": {
      tabindex: -1
    },
    "buttonProps": {
      xLarge: true
    },
    "dropdownProps": {
      minWidth: _vm.width
    },
    "onValidation": _vm.onValidation('start')
  }), _vm._v(" "), _vm._t("end", null, {
    "rules": _vm.rules.end.length > 0 ? [function () {
      return false;
    }] : [],
    "props": {
      tabindex: -1
    },
    "buttonProps": {
      xLarge: true
    },
    "dropdownProps": {
      minWidth: _vm.width
    },
    "onValidation": _vm.onValidation('end')
  })], 2), _vm._v(" "), _vm.currentError || _vm.errorMessages ? _c('span', {
    staticClass: "errorDisplay",
    attrs: {
      "data-qa": "error-display"
    }
  }, [_vm._v(_vm._s(_vm.currentError || _vm.errorMessages))]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-6db3637c_0", {
    source: ".VcInputGroup[data-v-6db3637c]  :first-child,.VcInputGroup[data-v-6db3637c] >div:first-child{border-start-start-radius:var(--border-radius);border-end-start-radius:var(--border-radius)}.VcInputGroup[data-v-6db3637c]  :last-child,.VcInputGroup[data-v-6db3637c] >div:last-child{border-start-end-radius:var(--border-radius);border-end-end-radius:var(--border-radius)}.VcInputGroup[data-v-6db3637c]{border-radius:var(--border-radius);height:var(--size-value13)}.VcInputGroup.unify[data-v-6db3637c]:hover{border-color:var(--gray-darken-3)}.VcInputGroup.unify[data-v-6db3637c]:active,.VcInputGroup.unify[data-v-6db3637c]:focus,.VcInputGroup.unify[data-v-6db3637c]:focus-within{box-shadow:0 0 0 3px var(--v-secondary-lighten1)}.VcInputGroup.unify[data-v-6db3637c]  .VcTextInput.v-text-field .v-input__slot:active,.VcInputGroup.unify[data-v-6db3637c]  .VcTextInput.v-text-field .v-input__slot:focus,.VcInputGroup.unify[data-v-6db3637c]  .VcTextInput.v-text-field .v-input__slot:focus-within,.VcInputGroup.unify[data-v-6db3637c]  .VcTextInput.v-text-field .v-input__slot:hover{box-shadow:none}.VcInputGroup.split-even[data-v-6db3637c] >*{flex-basis:50%}.VcInputGroup.split-start[data-v-6db3637c] >:first-child{flex-basis:68px;flex-grow:0}.VcInputGroup.split-end[data-v-6db3637c] >:last-child{flex-basis:100px;flex-grow:0}.VcInputGroup[data-v-6db3637c] >*{margin:0;flex-grow:1;flex-shrink:0}.VcInputGroup[data-v-6db3637c]  .VcButton{border-radius:unset}.VcInputGroup[data-v-6db3637c]  .VcButton:first-child{border-start-start-radius:var(--border-radius);border-end-start-radius:var(--border-radius)}.VcInputGroup[data-v-6db3637c]  .VcButton:last-child{border-start-end-radius:var(--border-radius);border-end-end-radius:var(--border-radius)}.VcInputGroup[data-v-6db3637c]  .VcTextInput.v-text-field .v-input__slot{border-radius:unset}.VcInputGroup[data-v-6db3637c]  .VcTextInput:first-child.v-text-field .v-input__slot{border-start-start-radius:var(--border-radius);border-end-start-radius:var(--border-radius)}.VcInputGroup[data-v-6db3637c]  .VcTextInput:last-child.v-text-field .v-input__slot{border-start-end-radius:var(--border-radius);border-end-end-radius:var(--border-radius)}.VcInputGroup[data-v-6db3637c]  .VcTextInput:has(.v-input__slot):active,.VcInputGroup[data-v-6db3637c]  .VcTextInput:has(.v-input__slot):focus,.VcInputGroup[data-v-6db3637c]  .VcTextInput:has(.v-input__slot):focus-within,.VcInputGroup[data-v-6db3637c]  .VcTextInput:has(.v-input__slot):hover{z-index:1}.errorDisplay[data-v-6db3637c]{color:var(--v-error-base)!important;caret-color:var(--v-error-base)!important;text-align:start;font-size:12px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$2 = "data-v-6db3637c";
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

var __vue_component__$5 = __vue_component__$4;

var script$1 = {
  name: 'VcDatePicker',
  props: {
    dataQa: {
      type: String,
      default: 'VcDatePicker'
    }
  },
  render: function (createElement) {
    // `<v-date-picker><slot></slot></v-date-picker>`
    const props = {
      attrs: { ...this.$attrs,
        'data-qa': this.dataQa
      },
      on: { ...this.$listeners
      },
      ref: this.$vnode.data.ref,
      style: this.$vnode.data.style
    };
    return createElement('v-date-picker', props, this.$slots.default);
  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = "data-v-095692e4";
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var __vue_component__$3 = __vue_component__$2;

const formatSecondsToTime = seconds => {
  const HOUR_IN_SECONDS = 3600;
  const MINUTE_IN_SECONDS = 60;
  const hours = Math.floor(seconds / HOUR_IN_SECONDS);
  const minutes = Math.floor(seconds % HOUR_IN_SECONDS / MINUTE_IN_SECONDS);
  const secs = Math.floor(seconds % MINUTE_IN_SECONDS);
  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = secs.toString().padStart(2, '0');

  if (seconds < HOUR_IN_SECONDS) {
    return `${formattedMinutes}:${formattedSeconds}`; // MM:SS
  }

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`; // HH:MM:SS
};

var script = {
  name: 'VcAudioPlayer',
  components: {
    VcLayout,
    VcIcon,
    VcButton,
    VcDropdown,
    VcList
  },
  props: {
    dataQa: {
      type: String,
      default: 'vc-audio-player'
    },
    src: {
      type: String,
      required: true
    },
    speed: {
      type: Object,
      default: () => {
        return {
          identifier: 1,
          label: '1x'
        };
      }
    },
    speedOptions: {
      type: Array,
      default: () => [{
        identifier: 0.5,
        label: '0.5x'
      }, {
        identifier: 1,
        label: '1x'
      }, {
        identifier: 1.5,
        label: '1.5x'
      }, {
        identifier: 2,
        label: '2x'
      }]
    },
    bordered: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentTime: 0,
      duration: 0,
      isPlaying: false,
      selectedSpeed: this.speed
    };
  },

  computed: {
    speedOptionsItems() {
      return this.speedOptions.map(item => {
        return item.identifier === this.selectedSpeed.identifier ? { ...item,
          selected: true
        } : item;
      });
    },

    formattedDuration() {
      return formatSecondsToTime(this.duration);
    },

    formattedCurrentTime() {
      return formatSecondsToTime(this.currentTime);
    },

    progressPercentage() {
      return this.duration ? this.currentTime / this.duration * 100 : 0;
    },

    rangeSliderStyle() {
      return `background-size:${this.progressPercentage}% 100%`;
    }

  },
  methods: {
    togglePlayPause() {
      const audio = this.$refs.audio;

      if (this.isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }

      this.isPlaying = !this.isPlaying;
      this.$emit('playPause', {
        isPlaying: this.isPlaying
      });
    },

    updateStyleProperty() {
      this.$refs.audioContainer.style.setProperty('--progress-percentage', this.progressPercentage + '%');
    },

    updateProgress(e) {
      this.currentTime = e.target.value * this.duration / 100;
      this.$refs.audio.currentTime = this.currentTime;
      this.updateStyleProperty();
    },

    updateTime() {
      this.currentTime = this.$refs.audio.currentTime;
      this.updateStyleProperty();
    },

    onSpeedChange(speed) {
      this.selectedSpeed = this.speedOptions.find(item => item.identifier === speed);
      this.$refs.audio.playbackRate = this.selectedSpeed.identifier;
      this.$emit('speedChange', this.selectedSpeed.identifier);
    },

    updateDuration() {
      this.duration = this.$refs.audio.duration;
    }

  }
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "audioContainer",
    staticClass: "audio-player",
    class: {
      bordered: _vm.bordered
    },
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.src,
      "data-qa": _vm.dataQa + "_audio"
    },
    on: {
      "timeupdate": _vm.updateTime,
      "loadedmetadata": _vm.updateDuration,
      "ended": function ($event) {
        _vm.isPlaying = false;
      }
    }
  }), _vm._v(" "), _c('VcLayout', {
    attrs: {
      "align-center": "",
      "reverse": _vm.$vuetify.rtl
    }
  }, [_c('VcButton', {
    staticClass: "play-btn mr-2",
    attrs: {
      "icon": "",
      "x-small": "",
      "data-qa": _vm.dataQa + "_play-btn"
    },
    on: {
      "click": _vm.togglePlayPause
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "color": "black",
            "size": "14px"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.isPlaying ? '$pause' : '$play') + "\n        ")])];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('VcLayout', {
    attrs: {
      "align-center": "",
      "reverse": _vm.$vuetify.rtl
    }
  }, [_c('input', {
    class: ['progress-bar', {
      'play-ended': _vm.progressPercentage === 100
    }],
    style: _vm.rangeSliderStyle,
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100",
      "data-qa": _vm.dataQa + "_progress-bar"
    },
    domProps: {
      "value": _vm.progressPercentage
    },
    on: {
      "change": _vm.updateProgress
    }
  }), _vm._v(" "), _c('VcLayout', {
    staticClass: "d-flex time-container",
    attrs: {
      "data-qa": _vm.dataQa + "_formatted-time",
      "reverse": _vm.$vuetify.rtl
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formattedCurrentTime))]), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formattedDuration))])])], 1), _vm._v(" "), _c('VcDropdown', {
    staticClass: "speed-dropdown",
    attrs: {
      "close-on-content-click": "",
      "data-qa": _vm.dataQa + "_speed-dropdown",
      "content-area-style": "minWidth: 0"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        var attrs = ref.attrs;
        return [_c('span', _vm._g(_vm._b({
          staticClass: "speed-text",
          attrs: {
            "data-qa": _vm.dataQa + "_speed-label"
          }
        }, 'span', attrs, false), on), [_vm._v("\n          " + _vm._s(_vm.selectedSpeed.label) + "\n        ")])];
      }
    }])
  }, [_vm._v(" "), _c('VcList', {
    staticClass: "speed-list",
    attrs: {
      "items": _vm.speedOptionsItems,
      "data-qa": _vm.dataQa + "_speed-dropdown-list"
    },
    on: {
      "select": _vm.onSpeedChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (item) {
        return [_c('div', {
          staticClass: "speed-option-item"
        }, [_vm._v("\n            " + _vm._s(item.label) + "\n          ")])];
      }
    }])
  })], 1)], 1)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-394f0e6a_0", {
    source: "audio[data-v-394f0e6a]{display:none}.audio-player[data-v-394f0e6a]{width:100%;margin:0 auto;position:relative;--progress-percentage:0}.audio-player.bordered[data-v-394f0e6a]{display:flex;padding:11px 12px;border:1px solid var(--gray);border-radius:var(--size-value2)}.progress-bar[data-v-394f0e6a]{-webkit-appearance:none;appearance:none;cursor:pointer;border-radius:var(--size-value4);margin-right:var(--size-value3);background-color:var(--gray);background-size:0 100%;background-image:linear-gradient(var(--gray-darken-3),var(--gray-darken-3));position:relative;direction:ltr;width:100%}.progress-bar[data-v-394f0e6a]::-webkit-slider-thumb{opacity:0}.progress-bar[data-v-394f0e6a]::-webkit-slider-runnable-track{height:8px}.progress-bar[data-v-394f0e6a]:before{content:\"\";position:absolute;background:var(--gray-darken-5);border-radius:50%;width:9px;height:9px;left:var(--progress-percentage);margin-left:-2px;box-shadow:var(--shadow-3)}.progress-bar.play-ended[data-v-394f0e6a]:before{margin-left:-5px}.time-container[data-v-394f0e6a]{width:80px;flex:0 0 auto;color:var(--gray-darken-3);font-size:var(--font-size-xx-small)}.speed-text[data-v-394f0e6a]{min-width:var(--size-value7);max-width:var(--size-value7);font-size:var(--font-size-xx-small);text-align:right}.speed-option-item[data-v-394f0e6a]{padding:0 var(--size-value3);text-align:center;font-size:var(--font-size-x-small)}.speed-list[data-v-394f0e6a] .vc-base-list-item{padding:var(--size-value2) 0}.speed-list[data-v-394f0e6a] .vc-base-list-item:not(.disabled).active:not(.disabled){background:var(--gray-lighten-1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-394f0e6a";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

var __vue_component__$1 = __vue_component__;

// install function executed by Vue.use()
const install = function installdesignSystem(Vue, options) {
  const loadFunc = loadComponent(Vue);

  if (options !== null && options !== void 0 && options.components) {
    Object.entries(options.components).forEach(([componentName, component]) => {
      loadFunc(componentName, component);
    });
  } else {
    import('./index-3fa2da31.js').then(module => {
      Object.entries(module).forEach(async ([componentName, component]) => {
        if (typeof component === 'function') {
          // eslint-disable-next-line no-undef
          await Promise.all(component()).then(res => {
            for (const lazyComponent of res) {
              loadFunc(lazyComponent.name, lazyComponent);
            }
          });
        } else {
          loadFunc(componentName, component);
        }
      });
    });
  }
};

const loadedComponents = {};

const loadComponent = Vue => (componentName, component) => {
  if (!loadedComponents[componentName]) {
    Vue.component(componentName, component);
    loadedComponents[componentName] = true;

    if (component.components) {
      Object.entries(component.components).forEach(([componentName, component]) => {
        loadComponent(Vue)(componentName, component);
      });
    }
  }
}; // Create module definition for Vue.use()

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': install,
  VcLayout: VcLayout,
  VcLoader: VcLoader,
  VcConfirmModal: __vue_component__$2N,
  VcInputModal: __vue_component__$2K,
  VcNoticeModal: __vue_component__$2H,
  VcModalFooter: VcModalFooter,
  VcModalHeader: VcModalHeader,
  VcAlert: VcAlert,
  VcTooltip: VcTooltip,
  VcIconWithTooltip: VcIconWithTooltip,
  VcTruncatedText: __vue_component__$2C,
  VcBottomActions: VcBottomActions,
  VcActionList: VcActionList,
  VcActions: VcActions,
  VcStepsBar: VcStepsBar,
  VcMobileWizardProgress: VcMobileWizardProgress,
  VcProgressCircular: VcProgressCircular,
  VcChecklistItem: VcChecklistItem,
  VcListbox: __vue_component__$2p,
  VcBottomSheet: VcBottomSheet,
  VcInputBottomSheet: __vue_component__$2l,
  VcPopover: VcPopover,
  VcInputPopover: __vue_component__$2i,
  VcChip: VcChip,
  VcChipList: VcChipList,
  VcSearchBar: VcSearchBar,
  VcBaseListItem: VcBaseListItem,
  VcList: VcList,
  VcButton: VcButton,
  VcAiButton: __vue_component__$2a,
  VcButtonGroup: __vue_component__$28,
  VcForm: VcForm,
  VcIcon: VcIcon,
  VcSwitch: VcSwitch,
  VcListEntity: __vue_component__$26,
  VcExpansionCard: __vue_component__$24,
  VcTextField: VcTextField,
  VcAvatar: VcAvatar,
  VcTextArea: __vue_component__$22,
  VcSelectField: VcSelectField,
  VcToast: __vue_component__$1$,
  VcCard: __vue_component__$1Z,
  VcCheckbox: VcCheckbox,
  VcFilterPanel: __vue_component__$1X,
  VcFocusArea: VcFocusArea,
  VcLink: VcLink,
  VcListItem: VcListItem,
  VcGroupHeader: VcGroupHeader,
  VcEmptyState: VcEmptyState,
  VcSvg: VcSvg,
  VcBanner: __vue_component__$1R,
  VcWizardCtaContainer: VcWizardCtaContainer,
  VcWizard: __vue_component__$1N,
  VcImage: VcImage,
  VcBadge: VcBadge,
  VcUpsellBlock: __vue_component__$1K,
  VcModalContainer: VcModalContainer,
  VcDropzone: __vue_component__$1I,
  VcRadioGroup: __vue_component__$1F,
  VcRadio: VcRadio,
  VcSegmentedControl: __vue_component__$1D,
  VcDocItem: __vue_component__$1B,
  VcTimeSince: __vue_component__$1z,
  VcSearchPicker: __vue_component__$1x,
  VcDraggableList: __vue_component__$1v,
  VcTabs: __vue_component__$1r,
  VcSideNav: __vue_component__$1o,
  VcMiniBanner: __vue_component__$1m,
  VcGalleryItem: VcGalleryItem,
  VcGalleryList: __vue_component__$1j,
  VcBreadcrumbs: VcBreadcrumbs,
  VcPageHeader: __vue_component__$1g,
  VcMenu: VcMenu,
  VcDropdown: VcDropdown,
  VcGroupedItems: VcGroupedItems,
  VcColorPicker: __vue_component__$1e,
  VcAccordion: __vue_component__$1c,
  VcActionBar: __vue_component__$1a,
  VcEntityList: __vue_component__$17,
  VcInfiniteScroll: VcInfiniteScroll,
  VcMenuItem: VcMenuItem,
  VcBottomNav: __vue_component__$14,
  VcTopMenuBar: __vue_component__$12,
  VcMenuItemsGroup: __vue_component__$10,
  VcProfileIndication: __vue_component__$_,
  VcPoweredBy: __vue_component__$Y,
  VcClientItem: __vue_component__$W,
  VcDetailItem: __vue_component__$U,
  VcTimeline: __vue_component__$S,
  VcTimelineRecord: __vue_component__$Q,
  VcEntityStatus: __vue_component__$O,
  VcServiceItem: __vue_component__$M,
  VcSidepaneHeader: __vue_component__$K,
  VcSummary: __vue_component__$I,
  VcSystemAlert: __vue_component__$G,
  VcQuickActions: __vue_component__$B,
  VcWideTopMenuBar: __vue_component__$w,
  VcAccountMenu: VcAccountMenu,
  VcSearchLayout: VcSearchLayout,
  VcOverlay: __vue_component__$u,
  VcColumnHeader: VcColumnHeader,
  VcDataTable: __vue_component__$m,
  VcTableActionBar: VcTableActionBar,
  VcTableFooter: VcTableFooter,
  VcTableItem: VcTableItem,
  VcPreview: VcPreview,
  VcGallery: __vue_component__$e,
  VcDivider: VcDivider,
  VcSkeleton: VcSkeleton,
  VcCounter: __vue_component__$c,
  VcScrollShadow: __vue_component__$a,
  VcFlag: VcFlag,
  VcPhoneField: __vue_component__$7,
  VcInputGroup: __vue_component__$5,
  VcDatePicker: __vue_component__$3,
  VcAudioPlayer: __vue_component__$1
});

// iife/cjs usage extends esm default export - so import it all
// only expose one global var, with component exports exposed as properties of
// that global var (eg. plugin.component)

Object.entries(components).forEach(([componentName, component]) => {
  if (componentName !== 'default') {
    install[componentName] = component;
  }
});

export { VcImage as $, VcButton as A, __vue_component__$2a as B, __vue_component__$28 as C, VcForm as D, VcIcon as E, VcSwitch as F, __vue_component__$26 as G, __vue_component__$24 as H, VcTextField as I, VcAvatar as J, __vue_component__$22 as K, VcSelectField as L, __vue_component__$1$ as M, __vue_component__$1Z as N, VcCheckbox as O, __vue_component__$1X as P, VcFocusArea as Q, VcLink as R, VcListItem as S, VcGroupHeader as T, VcEmptyState as U, VcLayout as V, VcSvg as W, __vue_component__$1R as X, VcWizardCtaContainer as Y, __vue_component__$1N as Z, __vue_component__$2N as _, VcLoader as a, createCommonjsModule as a$, VcBadge as a0, __vue_component__$1K as a1, VcModalContainer as a2, __vue_component__$1I as a3, __vue_component__$1F as a4, VcRadio as a5, __vue_component__$1D as a6, __vue_component__$1B as a7, __vue_component__$1z as a8, __vue_component__$1x as a9, __vue_component__$O as aA, __vue_component__$M as aB, __vue_component__$K as aC, __vue_component__$I as aD, __vue_component__$G as aE, __vue_component__$B as aF, __vue_component__$w as aG, VcAccountMenu as aH, VcSearchLayout as aI, __vue_component__$u as aJ, VcColumnHeader as aK, __vue_component__$m as aL, VcTableActionBar as aM, VcTableFooter as aN, VcTableItem as aO, VcPreview as aP, __vue_component__$e as aQ, VcDivider as aR, VcSkeleton as aS, __vue_component__$c as aT, __vue_component__$a as aU, VcFlag as aV, __vue_component__$7 as aW, __vue_component__$5 as aX, __vue_component__$3 as aY, __vue_component__$1 as aZ, getDefaultExportFromCjs as a_, __vue_component__$1v as aa, __vue_component__$1r as ab, __vue_component__$1o as ac, __vue_component__$1m as ad, VcGalleryItem as ae, __vue_component__$1j as af, VcBreadcrumbs as ag, __vue_component__$1g as ah, VcMenu as ai, VcDropdown as aj, VcGroupedItems as ak, __vue_component__$1e as al, __vue_component__$1c as am, __vue_component__$1a as an, __vue_component__$17 as ao, VcInfiniteScroll as ap, VcMenuItem as aq, __vue_component__$14 as ar, __vue_component__$12 as as, __vue_component__$10 as at, __vue_component__$_ as au, __vue_component__$Y as av, __vue_component__$W as aw, __vue_component__$U as ax, __vue_component__$S as ay, __vue_component__$Q as az, __vue_component__$2K as b, install as b0, __vue_component__$2H as c, VcModalFooter as d, VcModalHeader as e, VcAlert as f, VcTooltip as g, VcIconWithTooltip as h, __vue_component__$2C as i, VcBottomActions as j, VcActionList as k, VcActions as l, VcStepsBar as m, VcMobileWizardProgress as n, VcProgressCircular as o, VcChecklistItem as p, __vue_component__$2p as q, VcBottomSheet as r, __vue_component__$2l as s, VcPopover as t, __vue_component__$2i as u, VcChip as v, VcChipList as w, VcSearchBar as x, VcBaseListItem as y, VcList as z };
